
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9350"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9350"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cTIdu", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $963ceb9011541442$export$ffb0004e005737fa; }, function (v) { return $963ceb9011541442$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $963ceb9011541442$export$34b9dba7ce09269b; }, function (v) { return $963ceb9011541442$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $963ceb9011541442$export$25062201e9e25d76; }, function (v) { return $963ceb9011541442$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $963ceb9011541442$export$ffb0004e005737fa;
var $963ceb9011541442$export$34b9dba7ce09269b;
var $963ceb9011541442$export$25062201e9e25d76;
'use strict';

var $dBNnn = parcelRequire("dBNnn");
var $963ceb9011541442$var$k = Symbol.for("react.element"), $963ceb9011541442$var$l = Symbol.for("react.fragment"), $963ceb9011541442$var$m = Object.prototype.hasOwnProperty, $963ceb9011541442$var$n = $dBNnn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $963ceb9011541442$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $963ceb9011541442$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$963ceb9011541442$var$m.call(a, b) && !$963ceb9011541442$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $963ceb9011541442$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $963ceb9011541442$var$n.current
    };
}
$963ceb9011541442$export$ffb0004e005737fa = $963ceb9011541442$var$l;
$963ceb9011541442$export$34b9dba7ce09269b = $963ceb9011541442$var$q;
$963ceb9011541442$export$25062201e9e25d76 = $963ceb9011541442$var$q;

});
parcelRegister("dBNnn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5gcUq"));

});
parcelRegister("5gcUq", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3d4875db56205f7f$export$dca3b0875bd9a954; }, function (v) { return $3d4875db56205f7f$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3d4875db56205f7f$export$16fa2f45be04daa8; }, function (v) { return $3d4875db56205f7f$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3d4875db56205f7f$export$ffb0004e005737fa; }, function (v) { return $3d4875db56205f7f$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3d4875db56205f7f$export$e2c29f18771995cb; }, function (v) { return $3d4875db56205f7f$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3d4875db56205f7f$export$221d75b3f55bb0bd; }, function (v) { return $3d4875db56205f7f$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3d4875db56205f7f$export$5f8d39834fd61797; }, function (v) { return $3d4875db56205f7f$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3d4875db56205f7f$export$74bf444e3cd11ea5; }, function (v) { return $3d4875db56205f7f$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3d4875db56205f7f$export$ae55be85d98224ed; }, function (v) { return $3d4875db56205f7f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $3d4875db56205f7f$export$3ba232387fd5d6dd; }, function (v) { return $3d4875db56205f7f$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3d4875db56205f7f$export$e530037191fcd5d7; }, function (v) { return $3d4875db56205f7f$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3d4875db56205f7f$export$fd42f52fd3ae1109; }, function (v) { return $3d4875db56205f7f$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3d4875db56205f7f$export$c8a8987d4410bf2d; }, function (v) { return $3d4875db56205f7f$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $3d4875db56205f7f$export$d38cd72104c1f0e9; }, function (v) { return $3d4875db56205f7f$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $3d4875db56205f7f$export$7d1e3a5e95ceca43; }, function (v) { return $3d4875db56205f7f$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3d4875db56205f7f$export$257a8862b851cb5b; }, function (v) { return $3d4875db56205f7f$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3d4875db56205f7f$export$a8257692ac88316c; }, function (v) { return $3d4875db56205f7f$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3d4875db56205f7f$export$488013bae63b21da; }, function (v) { return $3d4875db56205f7f$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3d4875db56205f7f$export$7c73462e0d25e514; }, function (v) { return $3d4875db56205f7f$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3d4875db56205f7f$export$7568632d0d33d16d; }, function (v) { return $3d4875db56205f7f$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $3d4875db56205f7f$export$88948ce120ea2619; }, function (v) { return $3d4875db56205f7f$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3d4875db56205f7f$export$35808ee640e87ca7; }, function (v) { return $3d4875db56205f7f$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3d4875db56205f7f$export$fae74005e78b1a27; }, function (v) { return $3d4875db56205f7f$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3d4875db56205f7f$export$dc8fbce3eb94dc1e; }, function (v) { return $3d4875db56205f7f$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3d4875db56205f7f$export$6a7bc4e911dc01cf; }, function (v) { return $3d4875db56205f7f$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3d4875db56205f7f$export$6d9c69b0de29b591; }, function (v) { return $3d4875db56205f7f$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3d4875db56205f7f$export$f680877a34711e37; }, function (v) { return $3d4875db56205f7f$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3d4875db56205f7f$export$d5a552a76deda3c2; }, function (v) { return $3d4875db56205f7f$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3d4875db56205f7f$export$aaabe4eda9ed9969; }, function (v) { return $3d4875db56205f7f$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3d4875db56205f7f$export$e5c5a5f917a5871c; }, function (v) { return $3d4875db56205f7f$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3d4875db56205f7f$export$1538c33de8887b59; }, function (v) { return $3d4875db56205f7f$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $3d4875db56205f7f$export$13e3392192263954; }, function (v) { return $3d4875db56205f7f$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3d4875db56205f7f$export$b8f5890fc79d6aca; }, function (v) { return $3d4875db56205f7f$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3d4875db56205f7f$export$60241385465d0a34; }, function (v) { return $3d4875db56205f7f$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3d4875db56205f7f$export$306c0aa65ff9ec16; }, function (v) { return $3d4875db56205f7f$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3d4875db56205f7f$export$7b286972b8d8ccbf; }, function (v) { return $3d4875db56205f7f$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3d4875db56205f7f$export$83d89fbfd8236492; }, function (v) { return $3d4875db56205f7f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d4875db56205f7f$export$dca3b0875bd9a954;
var $3d4875db56205f7f$export$16fa2f45be04daa8;
var $3d4875db56205f7f$export$ffb0004e005737fa;
var $3d4875db56205f7f$export$e2c29f18771995cb;
var $3d4875db56205f7f$export$221d75b3f55bb0bd;
var $3d4875db56205f7f$export$5f8d39834fd61797;
var $3d4875db56205f7f$export$74bf444e3cd11ea5;
var $3d4875db56205f7f$export$ae55be85d98224ed;
var $3d4875db56205f7f$export$3ba232387fd5d6dd;
var $3d4875db56205f7f$export$e530037191fcd5d7;
var $3d4875db56205f7f$export$fd42f52fd3ae1109;
var $3d4875db56205f7f$export$c8a8987d4410bf2d;
var $3d4875db56205f7f$export$d38cd72104c1f0e9;
var $3d4875db56205f7f$export$7d1e3a5e95ceca43;
var $3d4875db56205f7f$export$257a8862b851cb5b;
var $3d4875db56205f7f$export$a8257692ac88316c;
var $3d4875db56205f7f$export$488013bae63b21da;
var $3d4875db56205f7f$export$7c73462e0d25e514;
var $3d4875db56205f7f$export$7568632d0d33d16d;
var $3d4875db56205f7f$export$88948ce120ea2619;
var $3d4875db56205f7f$export$35808ee640e87ca7;
var $3d4875db56205f7f$export$fae74005e78b1a27;
var $3d4875db56205f7f$export$dc8fbce3eb94dc1e;
var $3d4875db56205f7f$export$6a7bc4e911dc01cf;
var $3d4875db56205f7f$export$6d9c69b0de29b591;
var $3d4875db56205f7f$export$f680877a34711e37;
var $3d4875db56205f7f$export$d5a552a76deda3c2;
var $3d4875db56205f7f$export$aaabe4eda9ed9969;
var $3d4875db56205f7f$export$e5c5a5f917a5871c;
var $3d4875db56205f7f$export$1538c33de8887b59;
var $3d4875db56205f7f$export$13e3392192263954;
var $3d4875db56205f7f$export$b8f5890fc79d6aca;
var $3d4875db56205f7f$export$60241385465d0a34;
var $3d4875db56205f7f$export$306c0aa65ff9ec16;
var $3d4875db56205f7f$export$7b286972b8d8ccbf;
var $3d4875db56205f7f$export$83d89fbfd8236492;
'use strict';
var $3d4875db56205f7f$var$l = Symbol.for("react.element"), $3d4875db56205f7f$var$n = Symbol.for("react.portal"), $3d4875db56205f7f$var$p = Symbol.for("react.fragment"), $3d4875db56205f7f$var$q = Symbol.for("react.strict_mode"), $3d4875db56205f7f$var$r = Symbol.for("react.profiler"), $3d4875db56205f7f$var$t = Symbol.for("react.provider"), $3d4875db56205f7f$var$u = Symbol.for("react.context"), $3d4875db56205f7f$var$v = Symbol.for("react.forward_ref"), $3d4875db56205f7f$var$w = Symbol.for("react.suspense"), $3d4875db56205f7f$var$x = Symbol.for("react.memo"), $3d4875db56205f7f$var$y = Symbol.for("react.lazy"), $3d4875db56205f7f$var$z = Symbol.iterator;
function $3d4875db56205f7f$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $3d4875db56205f7f$var$z && a[$3d4875db56205f7f$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3d4875db56205f7f$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $3d4875db56205f7f$var$C = Object.assign, $3d4875db56205f7f$var$D = {};
function $3d4875db56205f7f$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3d4875db56205f7f$var$D;
    this.updater = e || $3d4875db56205f7f$var$B;
}
$3d4875db56205f7f$var$E.prototype.isReactComponent = {};
$3d4875db56205f7f$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3d4875db56205f7f$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3d4875db56205f7f$var$F() {}
$3d4875db56205f7f$var$F.prototype = $3d4875db56205f7f$var$E.prototype;
function $3d4875db56205f7f$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3d4875db56205f7f$var$D;
    this.updater = e || $3d4875db56205f7f$var$B;
}
var $3d4875db56205f7f$var$H = $3d4875db56205f7f$var$G.prototype = new $3d4875db56205f7f$var$F;
$3d4875db56205f7f$var$H.constructor = $3d4875db56205f7f$var$G;
$3d4875db56205f7f$var$C($3d4875db56205f7f$var$H, $3d4875db56205f7f$var$E.prototype);
$3d4875db56205f7f$var$H.isPureReactComponent = !0;
var $3d4875db56205f7f$var$I = Array.isArray, $3d4875db56205f7f$var$J = Object.prototype.hasOwnProperty, $3d4875db56205f7f$var$K = {
    current: null
}, $3d4875db56205f7f$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3d4875db56205f7f$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3d4875db56205f7f$var$J.call(b, d) && !$3d4875db56205f7f$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3d4875db56205f7f$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3d4875db56205f7f$var$K.current
    };
}
function $3d4875db56205f7f$var$N(a, b) {
    return {
        $$typeof: $3d4875db56205f7f$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3d4875db56205f7f$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3d4875db56205f7f$var$l;
}
function $3d4875db56205f7f$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3d4875db56205f7f$var$P = /\/+/g;
function $3d4875db56205f7f$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $3d4875db56205f7f$var$escape("" + a.key) : b.toString(36);
}
function $3d4875db56205f7f$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3d4875db56205f7f$var$l:
                case $3d4875db56205f7f$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3d4875db56205f7f$var$Q(h, 0) : d, $3d4875db56205f7f$var$I(c) ? (e = "", null != a && (e = a.replace($3d4875db56205f7f$var$P, "$&/") + "/"), $3d4875db56205f7f$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3d4875db56205f7f$var$O(c) && (c = $3d4875db56205f7f$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3d4875db56205f7f$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3d4875db56205f7f$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3d4875db56205f7f$var$Q(k, g);
        h += $3d4875db56205f7f$var$R(k, b, e, f, c);
    }
    else if (f = $3d4875db56205f7f$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3d4875db56205f7f$var$Q(k, g++), h += $3d4875db56205f7f$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3d4875db56205f7f$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3d4875db56205f7f$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3d4875db56205f7f$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3d4875db56205f7f$var$U = {
    current: null
}, $3d4875db56205f7f$var$V = {
    transition: null
}, $3d4875db56205f7f$var$W = {
    ReactCurrentDispatcher: $3d4875db56205f7f$var$U,
    ReactCurrentBatchConfig: $3d4875db56205f7f$var$V,
    ReactCurrentOwner: $3d4875db56205f7f$var$K
};
function $3d4875db56205f7f$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$3d4875db56205f7f$export$dca3b0875bd9a954 = {
    map: $3d4875db56205f7f$var$S,
    forEach: function(a, b, e) {
        $3d4875db56205f7f$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $3d4875db56205f7f$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $3d4875db56205f7f$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$3d4875db56205f7f$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3d4875db56205f7f$export$16fa2f45be04daa8 = $3d4875db56205f7f$var$E;
$3d4875db56205f7f$export$ffb0004e005737fa = $3d4875db56205f7f$var$p;
$3d4875db56205f7f$export$e2c29f18771995cb = $3d4875db56205f7f$var$r;
$3d4875db56205f7f$export$221d75b3f55bb0bd = $3d4875db56205f7f$var$G;
$3d4875db56205f7f$export$5f8d39834fd61797 = $3d4875db56205f7f$var$q;
$3d4875db56205f7f$export$74bf444e3cd11ea5 = $3d4875db56205f7f$var$w;
$3d4875db56205f7f$export$ae55be85d98224ed = $3d4875db56205f7f$var$W;
$3d4875db56205f7f$export$3ba232387fd5d6dd = $3d4875db56205f7f$var$X;
$3d4875db56205f7f$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3d4875db56205f7f$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3d4875db56205f7f$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3d4875db56205f7f$var$J.call(b, f) && !$3d4875db56205f7f$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3d4875db56205f7f$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3d4875db56205f7f$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3d4875db56205f7f$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3d4875db56205f7f$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3d4875db56205f7f$export$c8a8987d4410bf2d = $3d4875db56205f7f$var$M;
$3d4875db56205f7f$export$d38cd72104c1f0e9 = function(a) {
    var b = $3d4875db56205f7f$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3d4875db56205f7f$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3d4875db56205f7f$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3d4875db56205f7f$var$v,
        render: a
    };
};
$3d4875db56205f7f$export$a8257692ac88316c = $3d4875db56205f7f$var$O;
$3d4875db56205f7f$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3d4875db56205f7f$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3d4875db56205f7f$var$T
    };
};
$3d4875db56205f7f$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3d4875db56205f7f$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3d4875db56205f7f$export$7568632d0d33d16d = function(a) {
    var b = $3d4875db56205f7f$var$V.transition;
    $3d4875db56205f7f$var$V.transition = {};
    try {
        a();
    } finally{
        $3d4875db56205f7f$var$V.transition = b;
    }
};
$3d4875db56205f7f$export$88948ce120ea2619 = $3d4875db56205f7f$var$X;
$3d4875db56205f7f$export$35808ee640e87ca7 = function(a, b) {
    return $3d4875db56205f7f$var$U.current.useCallback(a, b);
};
$3d4875db56205f7f$export$fae74005e78b1a27 = function(a) {
    return $3d4875db56205f7f$var$U.current.useContext(a);
};
$3d4875db56205f7f$export$dc8fbce3eb94dc1e = function() {};
$3d4875db56205f7f$export$6a7bc4e911dc01cf = function(a) {
    return $3d4875db56205f7f$var$U.current.useDeferredValue(a);
};
$3d4875db56205f7f$export$6d9c69b0de29b591 = function(a, b) {
    return $3d4875db56205f7f$var$U.current.useEffect(a, b);
};
$3d4875db56205f7f$export$f680877a34711e37 = function() {
    return $3d4875db56205f7f$var$U.current.useId();
};
$3d4875db56205f7f$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3d4875db56205f7f$var$U.current.useImperativeHandle(a, b, e);
};
$3d4875db56205f7f$export$aaabe4eda9ed9969 = function(a, b) {
    return $3d4875db56205f7f$var$U.current.useInsertionEffect(a, b);
};
$3d4875db56205f7f$export$e5c5a5f917a5871c = function(a, b) {
    return $3d4875db56205f7f$var$U.current.useLayoutEffect(a, b);
};
$3d4875db56205f7f$export$1538c33de8887b59 = function(a, b) {
    return $3d4875db56205f7f$var$U.current.useMemo(a, b);
};
$3d4875db56205f7f$export$13e3392192263954 = function(a, b, e) {
    return $3d4875db56205f7f$var$U.current.useReducer(a, b, e);
};
$3d4875db56205f7f$export$b8f5890fc79d6aca = function(a) {
    return $3d4875db56205f7f$var$U.current.useRef(a);
};
$3d4875db56205f7f$export$60241385465d0a34 = function(a) {
    return $3d4875db56205f7f$var$U.current.useState(a);
};
$3d4875db56205f7f$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3d4875db56205f7f$var$U.current.useSyncExternalStore(a, b, e);
};
$3d4875db56205f7f$export$7b286972b8d8ccbf = function() {
    return $3d4875db56205f7f$var$U.current.useTransition();
};
$3d4875db56205f7f$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("2NwrC", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $20995330db7af0aa$export$882461b6382ed46c; }, function (v) { return $20995330db7af0aa$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $20995330db7af0aa$export$757ceba2d55c277e; }, function (v) { return $20995330db7af0aa$export$757ceba2d55c277e = v; });
var $20995330db7af0aa$export$882461b6382ed46c;
var $20995330db7af0aa$export$757ceba2d55c277e;
'use strict';

var $a6afE = parcelRequire("a6afE");
var $20995330db7af0aa$var$i;
$20995330db7af0aa$export$882461b6382ed46c = $a6afE.createRoot;
$20995330db7af0aa$export$757ceba2d55c277e = $a6afE.hydrateRoot;

});
parcelRegister("a6afE", function(module, exports) {
'use strict';
function $75a26aa934d0c3c7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($75a26aa934d0c3c7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$75a26aa934d0c3c7$var$checkDCE();

module.exports = (parcelRequire("e0ZbD"));

});
parcelRegister("e0ZbD", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a340872f7a7f928e$export$ae55be85d98224ed; }, function (v) { return $a340872f7a7f928e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a340872f7a7f928e$export$d39a5bbd09211389; }, function (v) { return $a340872f7a7f928e$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a340872f7a7f928e$export$882461b6382ed46c; }, function (v) { return $a340872f7a7f928e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a340872f7a7f928e$export$466bfc07425424d5; }, function (v) { return $a340872f7a7f928e$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a340872f7a7f928e$export$cd75ccfd720a3cd4; }, function (v) { return $a340872f7a7f928e$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a340872f7a7f928e$export$fa8d919ba61d84db; }, function (v) { return $a340872f7a7f928e$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a340872f7a7f928e$export$757ceba2d55c277e; }, function (v) { return $a340872f7a7f928e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a340872f7a7f928e$export$b3890eb0ae9dca99; }, function (v) { return $a340872f7a7f928e$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a340872f7a7f928e$export$502457920280e6be; }, function (v) { return $a340872f7a7f928e$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a340872f7a7f928e$export$c78a37762a8d58e1; }, function (v) { return $a340872f7a7f928e$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a340872f7a7f928e$export$dc54d992c10e8a18; }, function (v) { return $a340872f7a7f928e$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a340872f7a7f928e$export$83d89fbfd8236492; }, function (v) { return $a340872f7a7f928e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a340872f7a7f928e$export$ae55be85d98224ed;
var $a340872f7a7f928e$export$d39a5bbd09211389;
var $a340872f7a7f928e$export$882461b6382ed46c;
var $a340872f7a7f928e$export$466bfc07425424d5;
var $a340872f7a7f928e$export$cd75ccfd720a3cd4;
var $a340872f7a7f928e$export$fa8d919ba61d84db;
var $a340872f7a7f928e$export$757ceba2d55c277e;
var $a340872f7a7f928e$export$b3890eb0ae9dca99;
var $a340872f7a7f928e$export$502457920280e6be;
var $a340872f7a7f928e$export$c78a37762a8d58e1;
var $a340872f7a7f928e$export$dc54d992c10e8a18;
var $a340872f7a7f928e$export$83d89fbfd8236492;
'use strict';

var $dBNnn = parcelRequire("dBNnn");

var $eYRpC = parcelRequire("eYRpC");
function $a340872f7a7f928e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a340872f7a7f928e$var$da = new Set, $a340872f7a7f928e$var$ea = {};
function $a340872f7a7f928e$var$fa(a, b) {
    $a340872f7a7f928e$var$ha(a, b);
    $a340872f7a7f928e$var$ha(a + "Capture", b);
}
function $a340872f7a7f928e$var$ha(a, b) {
    $a340872f7a7f928e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a340872f7a7f928e$var$da.add(b[a]);
}
var $a340872f7a7f928e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a340872f7a7f928e$var$ja = Object.prototype.hasOwnProperty, $a340872f7a7f928e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a340872f7a7f928e$var$la = {}, $a340872f7a7f928e$var$ma = {};
function $a340872f7a7f928e$var$oa(a) {
    if ($a340872f7a7f928e$var$ja.call($a340872f7a7f928e$var$ma, a)) return !0;
    if ($a340872f7a7f928e$var$ja.call($a340872f7a7f928e$var$la, a)) return !1;
    if ($a340872f7a7f928e$var$ka.test(a)) return $a340872f7a7f928e$var$ma[a] = !0;
    $a340872f7a7f928e$var$la[a] = !0;
    return !1;
}
function $a340872f7a7f928e$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a340872f7a7f928e$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a340872f7a7f928e$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a340872f7a7f928e$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a340872f7a7f928e$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a340872f7a7f928e$var$z[b] = new $a340872f7a7f928e$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a340872f7a7f928e$var$ra = /[\-:]([a-z])/g;
function $a340872f7a7f928e$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a340872f7a7f928e$var$ra, $a340872f7a7f928e$var$sa);
    $a340872f7a7f928e$var$z[b] = new $a340872f7a7f928e$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a340872f7a7f928e$var$ra, $a340872f7a7f928e$var$sa);
    $a340872f7a7f928e$var$z[b] = new $a340872f7a7f928e$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a340872f7a7f928e$var$ra, $a340872f7a7f928e$var$sa);
    $a340872f7a7f928e$var$z[b] = new $a340872f7a7f928e$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a340872f7a7f928e$var$z.xlinkHref = new $a340872f7a7f928e$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a340872f7a7f928e$var$z[a] = new $a340872f7a7f928e$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a340872f7a7f928e$var$ta(a, b, c, d) {
    var e = $a340872f7a7f928e$var$z.hasOwnProperty(b) ? $a340872f7a7f928e$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a340872f7a7f928e$var$qa(b, c, e, d) && (c = null), d || null === e ? $a340872f7a7f928e$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a340872f7a7f928e$var$ua = $dBNnn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a340872f7a7f928e$var$va = Symbol.for("react.element"), $a340872f7a7f928e$var$wa = Symbol.for("react.portal"), $a340872f7a7f928e$var$ya = Symbol.for("react.fragment"), $a340872f7a7f928e$var$za = Symbol.for("react.strict_mode"), $a340872f7a7f928e$var$Aa = Symbol.for("react.profiler"), $a340872f7a7f928e$var$Ba = Symbol.for("react.provider"), $a340872f7a7f928e$var$Ca = Symbol.for("react.context"), $a340872f7a7f928e$var$Da = Symbol.for("react.forward_ref"), $a340872f7a7f928e$var$Ea = Symbol.for("react.suspense"), $a340872f7a7f928e$var$Fa = Symbol.for("react.suspense_list"), $a340872f7a7f928e$var$Ga = Symbol.for("react.memo"), $a340872f7a7f928e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a340872f7a7f928e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a340872f7a7f928e$var$Ja = Symbol.iterator;
function $a340872f7a7f928e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a340872f7a7f928e$var$Ja && a[$a340872f7a7f928e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a340872f7a7f928e$var$A = Object.assign, $a340872f7a7f928e$var$La;
function $a340872f7a7f928e$var$Ma(a) {
    if (void 0 === $a340872f7a7f928e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a340872f7a7f928e$var$La = b && b[1] || "";
    }
    return "\n" + $a340872f7a7f928e$var$La + a;
}
var $a340872f7a7f928e$var$Na = !1;
function $a340872f7a7f928e$var$Oa(a, b) {
    if (!a || $a340872f7a7f928e$var$Na) return "";
    $a340872f7a7f928e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a340872f7a7f928e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a340872f7a7f928e$var$Ma(a) : "";
}
function $a340872f7a7f928e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a340872f7a7f928e$var$Ma(a.type);
        case 16:
            return $a340872f7a7f928e$var$Ma("Lazy");
        case 13:
            return $a340872f7a7f928e$var$Ma("Suspense");
        case 19:
            return $a340872f7a7f928e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a340872f7a7f928e$var$Oa(a.type, !1), a;
        case 11:
            return a = $a340872f7a7f928e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a340872f7a7f928e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a340872f7a7f928e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a340872f7a7f928e$var$ya:
            return "Fragment";
        case $a340872f7a7f928e$var$wa:
            return "Portal";
        case $a340872f7a7f928e$var$Aa:
            return "Profiler";
        case $a340872f7a7f928e$var$za:
            return "StrictMode";
        case $a340872f7a7f928e$var$Ea:
            return "Suspense";
        case $a340872f7a7f928e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a340872f7a7f928e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a340872f7a7f928e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a340872f7a7f928e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a340872f7a7f928e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a340872f7a7f928e$var$Qa(a.type) || "Memo";
        case $a340872f7a7f928e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a340872f7a7f928e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a340872f7a7f928e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a340872f7a7f928e$var$Qa(b);
        case 8:
            return b === $a340872f7a7f928e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a340872f7a7f928e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a340872f7a7f928e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a340872f7a7f928e$var$Ua(a) {
    var b = $a340872f7a7f928e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a340872f7a7f928e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a340872f7a7f928e$var$Ua(a));
}
function $a340872f7a7f928e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a340872f7a7f928e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a340872f7a7f928e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a340872f7a7f928e$var$Ya(a, b) {
    var c = b.checked;
    return $a340872f7a7f928e$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a340872f7a7f928e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a340872f7a7f928e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a340872f7a7f928e$var$ab(a, b) {
    b = b.checked;
    null != b && $a340872f7a7f928e$var$ta(a, "checked", b, !1);
}
function $a340872f7a7f928e$var$bb(a, b) {
    $a340872f7a7f928e$var$ab(a, b);
    var c = $a340872f7a7f928e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a340872f7a7f928e$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a340872f7a7f928e$var$cb(a, b.type, $a340872f7a7f928e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a340872f7a7f928e$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a340872f7a7f928e$var$cb(a, b, c) {
    if ("number" !== b || $a340872f7a7f928e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a340872f7a7f928e$var$eb = Array.isArray;
function $a340872f7a7f928e$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a340872f7a7f928e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a340872f7a7f928e$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a340872f7a7f928e$var$p(91));
    return $a340872f7a7f928e$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a340872f7a7f928e$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a340872f7a7f928e$var$p(92));
            if ($a340872f7a7f928e$var$eb(c)) {
                if (1 < c.length) throw Error($a340872f7a7f928e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a340872f7a7f928e$var$Sa(c)
    };
}
function $a340872f7a7f928e$var$ib(a, b) {
    var c = $a340872f7a7f928e$var$Sa(b.value), d = $a340872f7a7f928e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a340872f7a7f928e$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a340872f7a7f928e$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a340872f7a7f928e$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a340872f7a7f928e$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a340872f7a7f928e$var$mb, $a340872f7a7f928e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a340872f7a7f928e$var$mb = $a340872f7a7f928e$var$mb || document.createElement("div");
        $a340872f7a7f928e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a340872f7a7f928e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a340872f7a7f928e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a340872f7a7f928e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a340872f7a7f928e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a340872f7a7f928e$var$pb).forEach(function(a) {
    $a340872f7a7f928e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a340872f7a7f928e$var$pb[b] = $a340872f7a7f928e$var$pb[a];
    });
});
function $a340872f7a7f928e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a340872f7a7f928e$var$pb.hasOwnProperty(a) && $a340872f7a7f928e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a340872f7a7f928e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a340872f7a7f928e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a340872f7a7f928e$var$tb = $a340872f7a7f928e$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a340872f7a7f928e$var$ub(a, b) {
    if (b) {
        if ($a340872f7a7f928e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a340872f7a7f928e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a340872f7a7f928e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a340872f7a7f928e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a340872f7a7f928e$var$p(62));
    }
}
function $a340872f7a7f928e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a340872f7a7f928e$var$wb = null;
function $a340872f7a7f928e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a340872f7a7f928e$var$yb = null, $a340872f7a7f928e$var$zb = null, $a340872f7a7f928e$var$Ab = null;
function $a340872f7a7f928e$var$Bb(a) {
    if (a = $a340872f7a7f928e$var$Cb(a)) {
        if ("function" !== typeof $a340872f7a7f928e$var$yb) throw Error($a340872f7a7f928e$var$p(280));
        var b = a.stateNode;
        b && (b = $a340872f7a7f928e$var$Db(b), $a340872f7a7f928e$var$yb(a.stateNode, a.type, b));
    }
}
function $a340872f7a7f928e$var$Eb(a) {
    $a340872f7a7f928e$var$zb ? $a340872f7a7f928e$var$Ab ? $a340872f7a7f928e$var$Ab.push(a) : $a340872f7a7f928e$var$Ab = [
        a
    ] : $a340872f7a7f928e$var$zb = a;
}
function $a340872f7a7f928e$var$Fb() {
    if ($a340872f7a7f928e$var$zb) {
        var a = $a340872f7a7f928e$var$zb, b = $a340872f7a7f928e$var$Ab;
        $a340872f7a7f928e$var$Ab = $a340872f7a7f928e$var$zb = null;
        $a340872f7a7f928e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a340872f7a7f928e$var$Bb(b[a]);
    }
}
function $a340872f7a7f928e$var$Gb(a, b) {
    return a(b);
}
function $a340872f7a7f928e$var$Hb() {}
var $a340872f7a7f928e$var$Ib = !1;
function $a340872f7a7f928e$var$Jb(a, b, c) {
    if ($a340872f7a7f928e$var$Ib) return a(b, c);
    $a340872f7a7f928e$var$Ib = !0;
    try {
        return $a340872f7a7f928e$var$Gb(a, b, c);
    } finally{
        if ($a340872f7a7f928e$var$Ib = !1, null !== $a340872f7a7f928e$var$zb || null !== $a340872f7a7f928e$var$Ab) $a340872f7a7f928e$var$Hb(), $a340872f7a7f928e$var$Fb();
    }
}
function $a340872f7a7f928e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a340872f7a7f928e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a340872f7a7f928e$var$p(231, b, typeof c));
    return c;
}
var $a340872f7a7f928e$var$Lb = !1;
if ($a340872f7a7f928e$var$ia) try {
    var $a340872f7a7f928e$var$Mb = {};
    Object.defineProperty($a340872f7a7f928e$var$Mb, "passive", {
        get: function() {
            $a340872f7a7f928e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a340872f7a7f928e$var$Mb, $a340872f7a7f928e$var$Mb);
    window.removeEventListener("test", $a340872f7a7f928e$var$Mb, $a340872f7a7f928e$var$Mb);
} catch (a) {
    $a340872f7a7f928e$var$Lb = !1;
}
function $a340872f7a7f928e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a340872f7a7f928e$var$Ob = !1, $a340872f7a7f928e$var$Pb = null, $a340872f7a7f928e$var$Qb = !1, $a340872f7a7f928e$var$Rb = null, $a340872f7a7f928e$var$Sb = {
    onError: function(a) {
        $a340872f7a7f928e$var$Ob = !0;
        $a340872f7a7f928e$var$Pb = a;
    }
};
function $a340872f7a7f928e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a340872f7a7f928e$var$Ob = !1;
    $a340872f7a7f928e$var$Pb = null;
    $a340872f7a7f928e$var$Nb.apply($a340872f7a7f928e$var$Sb, arguments);
}
function $a340872f7a7f928e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a340872f7a7f928e$var$Tb.apply(this, arguments);
    if ($a340872f7a7f928e$var$Ob) {
        if ($a340872f7a7f928e$var$Ob) {
            var l = $a340872f7a7f928e$var$Pb;
            $a340872f7a7f928e$var$Ob = !1;
            $a340872f7a7f928e$var$Pb = null;
        } else throw Error($a340872f7a7f928e$var$p(198));
        $a340872f7a7f928e$var$Qb || ($a340872f7a7f928e$var$Qb = !0, $a340872f7a7f928e$var$Rb = l);
    }
}
function $a340872f7a7f928e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a340872f7a7f928e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a340872f7a7f928e$var$Xb(a) {
    if ($a340872f7a7f928e$var$Vb(a) !== a) throw Error($a340872f7a7f928e$var$p(188));
}
function $a340872f7a7f928e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a340872f7a7f928e$var$Vb(a);
        if (null === b) throw Error($a340872f7a7f928e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a340872f7a7f928e$var$Xb(e), a;
                if (f === d) return $a340872f7a7f928e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a340872f7a7f928e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a340872f7a7f928e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a340872f7a7f928e$var$p(190));
    }
    if (3 !== c.tag) throw Error($a340872f7a7f928e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a340872f7a7f928e$var$Zb(a) {
    a = $a340872f7a7f928e$var$Yb(a);
    return null !== a ? $a340872f7a7f928e$var$$b(a) : null;
}
function $a340872f7a7f928e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a340872f7a7f928e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a340872f7a7f928e$var$ac = $eYRpC.unstable_scheduleCallback, $a340872f7a7f928e$var$bc = $eYRpC.unstable_cancelCallback, $a340872f7a7f928e$var$cc = $eYRpC.unstable_shouldYield, $a340872f7a7f928e$var$dc = $eYRpC.unstable_requestPaint, $a340872f7a7f928e$var$B = $eYRpC.unstable_now, $a340872f7a7f928e$var$ec = $eYRpC.unstable_getCurrentPriorityLevel, $a340872f7a7f928e$var$fc = $eYRpC.unstable_ImmediatePriority, $a340872f7a7f928e$var$gc = $eYRpC.unstable_UserBlockingPriority, $a340872f7a7f928e$var$hc = $eYRpC.unstable_NormalPriority, $a340872f7a7f928e$var$ic = $eYRpC.unstable_LowPriority, $a340872f7a7f928e$var$jc = $eYRpC.unstable_IdlePriority, $a340872f7a7f928e$var$kc = null, $a340872f7a7f928e$var$lc = null;
function $a340872f7a7f928e$var$mc(a) {
    if ($a340872f7a7f928e$var$lc && "function" === typeof $a340872f7a7f928e$var$lc.onCommitFiberRoot) try {
        $a340872f7a7f928e$var$lc.onCommitFiberRoot($a340872f7a7f928e$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a340872f7a7f928e$var$oc = Math.clz32 ? Math.clz32 : $a340872f7a7f928e$var$nc, $a340872f7a7f928e$var$pc = Math.log, $a340872f7a7f928e$var$qc = Math.LN2;
function $a340872f7a7f928e$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a340872f7a7f928e$var$pc(a) / $a340872f7a7f928e$var$qc | 0) | 0;
}
var $a340872f7a7f928e$var$rc = 64, $a340872f7a7f928e$var$sc = 4194304;
function $a340872f7a7f928e$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a340872f7a7f928e$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a340872f7a7f928e$var$tc(h) : (f &= g, 0 !== f && (d = $a340872f7a7f928e$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a340872f7a7f928e$var$tc(g) : 0 !== f && (d = $a340872f7a7f928e$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a340872f7a7f928e$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a340872f7a7f928e$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a340872f7a7f928e$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a340872f7a7f928e$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a340872f7a7f928e$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a340872f7a7f928e$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a340872f7a7f928e$var$yc() {
    var a = $a340872f7a7f928e$var$rc;
    $a340872f7a7f928e$var$rc <<= 1;
    0 === ($a340872f7a7f928e$var$rc & 4194240) && ($a340872f7a7f928e$var$rc = 64);
    return a;
}
function $a340872f7a7f928e$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a340872f7a7f928e$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a340872f7a7f928e$var$oc(b);
    a[b] = c;
}
function $a340872f7a7f928e$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a340872f7a7f928e$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a340872f7a7f928e$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a340872f7a7f928e$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a340872f7a7f928e$var$C = 0;
function $a340872f7a7f928e$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a340872f7a7f928e$var$Ec, $a340872f7a7f928e$var$Fc, $a340872f7a7f928e$var$Gc, $a340872f7a7f928e$var$Hc, $a340872f7a7f928e$var$Ic, $a340872f7a7f928e$var$Jc = !1, $a340872f7a7f928e$var$Kc = [], $a340872f7a7f928e$var$Lc = null, $a340872f7a7f928e$var$Mc = null, $a340872f7a7f928e$var$Nc = null, $a340872f7a7f928e$var$Oc = new Map, $a340872f7a7f928e$var$Pc = new Map, $a340872f7a7f928e$var$Qc = [], $a340872f7a7f928e$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a340872f7a7f928e$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a340872f7a7f928e$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a340872f7a7f928e$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a340872f7a7f928e$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a340872f7a7f928e$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a340872f7a7f928e$var$Pc.delete(b.pointerId);
    }
}
function $a340872f7a7f928e$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a340872f7a7f928e$var$Cb(b), null !== b && $a340872f7a7f928e$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a340872f7a7f928e$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a340872f7a7f928e$var$Lc = $a340872f7a7f928e$var$Tc($a340872f7a7f928e$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a340872f7a7f928e$var$Mc = $a340872f7a7f928e$var$Tc($a340872f7a7f928e$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a340872f7a7f928e$var$Nc = $a340872f7a7f928e$var$Tc($a340872f7a7f928e$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a340872f7a7f928e$var$Oc.set(f, $a340872f7a7f928e$var$Tc($a340872f7a7f928e$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a340872f7a7f928e$var$Pc.set(f, $a340872f7a7f928e$var$Tc($a340872f7a7f928e$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a340872f7a7f928e$var$Vc(a) {
    var b = $a340872f7a7f928e$var$Wc(a.target);
    if (null !== b) {
        var c = $a340872f7a7f928e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a340872f7a7f928e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a340872f7a7f928e$var$Ic(a.priority, function() {
                        $a340872f7a7f928e$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a340872f7a7f928e$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a340872f7a7f928e$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a340872f7a7f928e$var$wb = d;
            c.target.dispatchEvent(d);
            $a340872f7a7f928e$var$wb = null;
        } else return b = $a340872f7a7f928e$var$Cb(c), null !== b && $a340872f7a7f928e$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a340872f7a7f928e$var$Zc(a, b, c) {
    $a340872f7a7f928e$var$Xc(a) && c.delete(b);
}
function $a340872f7a7f928e$var$$c() {
    $a340872f7a7f928e$var$Jc = !1;
    null !== $a340872f7a7f928e$var$Lc && $a340872f7a7f928e$var$Xc($a340872f7a7f928e$var$Lc) && ($a340872f7a7f928e$var$Lc = null);
    null !== $a340872f7a7f928e$var$Mc && $a340872f7a7f928e$var$Xc($a340872f7a7f928e$var$Mc) && ($a340872f7a7f928e$var$Mc = null);
    null !== $a340872f7a7f928e$var$Nc && $a340872f7a7f928e$var$Xc($a340872f7a7f928e$var$Nc) && ($a340872f7a7f928e$var$Nc = null);
    $a340872f7a7f928e$var$Oc.forEach($a340872f7a7f928e$var$Zc);
    $a340872f7a7f928e$var$Pc.forEach($a340872f7a7f928e$var$Zc);
}
function $a340872f7a7f928e$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a340872f7a7f928e$var$Jc || ($a340872f7a7f928e$var$Jc = !0, $eYRpC.unstable_scheduleCallback($eYRpC.unstable_NormalPriority, $a340872f7a7f928e$var$$c)));
}
function $a340872f7a7f928e$var$bd(a) {
    function b(b) {
        return $a340872f7a7f928e$var$ad(b, a);
    }
    if (0 < $a340872f7a7f928e$var$Kc.length) {
        $a340872f7a7f928e$var$ad($a340872f7a7f928e$var$Kc[0], a);
        for(var c = 1; c < $a340872f7a7f928e$var$Kc.length; c++){
            var d = $a340872f7a7f928e$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a340872f7a7f928e$var$Lc && $a340872f7a7f928e$var$ad($a340872f7a7f928e$var$Lc, a);
    null !== $a340872f7a7f928e$var$Mc && $a340872f7a7f928e$var$ad($a340872f7a7f928e$var$Mc, a);
    null !== $a340872f7a7f928e$var$Nc && $a340872f7a7f928e$var$ad($a340872f7a7f928e$var$Nc, a);
    $a340872f7a7f928e$var$Oc.forEach(b);
    $a340872f7a7f928e$var$Pc.forEach(b);
    for(c = 0; c < $a340872f7a7f928e$var$Qc.length; c++)d = $a340872f7a7f928e$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a340872f7a7f928e$var$Qc.length && (c = $a340872f7a7f928e$var$Qc[0], null === c.blockedOn);)$a340872f7a7f928e$var$Vc(c), null === c.blockedOn && $a340872f7a7f928e$var$Qc.shift();
}
var $a340872f7a7f928e$var$cd = $a340872f7a7f928e$var$ua.ReactCurrentBatchConfig, $a340872f7a7f928e$var$dd = !0;
function $a340872f7a7f928e$var$ed(a, b, c, d) {
    var e = $a340872f7a7f928e$var$C, f = $a340872f7a7f928e$var$cd.transition;
    $a340872f7a7f928e$var$cd.transition = null;
    try {
        $a340872f7a7f928e$var$C = 1, $a340872f7a7f928e$var$fd(a, b, c, d);
    } finally{
        $a340872f7a7f928e$var$C = e, $a340872f7a7f928e$var$cd.transition = f;
    }
}
function $a340872f7a7f928e$var$gd(a, b, c, d) {
    var e = $a340872f7a7f928e$var$C, f = $a340872f7a7f928e$var$cd.transition;
    $a340872f7a7f928e$var$cd.transition = null;
    try {
        $a340872f7a7f928e$var$C = 4, $a340872f7a7f928e$var$fd(a, b, c, d);
    } finally{
        $a340872f7a7f928e$var$C = e, $a340872f7a7f928e$var$cd.transition = f;
    }
}
function $a340872f7a7f928e$var$fd(a, b, c, d) {
    if ($a340872f7a7f928e$var$dd) {
        var e = $a340872f7a7f928e$var$Yc(a, b, c, d);
        if (null === e) $a340872f7a7f928e$var$hd(a, b, d, $a340872f7a7f928e$var$id, c), $a340872f7a7f928e$var$Sc(a, d);
        else if ($a340872f7a7f928e$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a340872f7a7f928e$var$Sc(a, d), b & 4 && -1 < $a340872f7a7f928e$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a340872f7a7f928e$var$Cb(e);
                null !== f && $a340872f7a7f928e$var$Ec(f);
                f = $a340872f7a7f928e$var$Yc(a, b, c, d);
                null === f && $a340872f7a7f928e$var$hd(a, b, d, $a340872f7a7f928e$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a340872f7a7f928e$var$hd(a, b, d, null, c);
    }
}
var $a340872f7a7f928e$var$id = null;
function $a340872f7a7f928e$var$Yc(a, b, c, d) {
    $a340872f7a7f928e$var$id = null;
    a = $a340872f7a7f928e$var$xb(d);
    a = $a340872f7a7f928e$var$Wc(a);
    if (null !== a) {
        if (b = $a340872f7a7f928e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a340872f7a7f928e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a340872f7a7f928e$var$id = a;
    return null;
}
function $a340872f7a7f928e$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a340872f7a7f928e$var$ec()){
                case $a340872f7a7f928e$var$fc:
                    return 1;
                case $a340872f7a7f928e$var$gc:
                    return 4;
                case $a340872f7a7f928e$var$hc:
                case $a340872f7a7f928e$var$ic:
                    return 16;
                case $a340872f7a7f928e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a340872f7a7f928e$var$kd = null, $a340872f7a7f928e$var$ld = null, $a340872f7a7f928e$var$md = null;
function $a340872f7a7f928e$var$nd() {
    if ($a340872f7a7f928e$var$md) return $a340872f7a7f928e$var$md;
    var a, b = $a340872f7a7f928e$var$ld, c = b.length, d, e = "value" in $a340872f7a7f928e$var$kd ? $a340872f7a7f928e$var$kd.value : $a340872f7a7f928e$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a340872f7a7f928e$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a340872f7a7f928e$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a340872f7a7f928e$var$pd() {
    return !0;
}
function $a340872f7a7f928e$var$qd() {
    return !1;
}
function $a340872f7a7f928e$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a340872f7a7f928e$var$pd : $a340872f7a7f928e$var$qd;
        this.isPropagationStopped = $a340872f7a7f928e$var$qd;
        return this;
    }
    $a340872f7a7f928e$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a340872f7a7f928e$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a340872f7a7f928e$var$pd);
        },
        persist: function() {},
        isPersistent: $a340872f7a7f928e$var$pd
    });
    return b;
}
var $a340872f7a7f928e$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a340872f7a7f928e$var$td = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$sd), $a340872f7a7f928e$var$ud = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$sd, {
    view: 0,
    detail: 0
}), $a340872f7a7f928e$var$vd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$ud), $a340872f7a7f928e$var$wd, $a340872f7a7f928e$var$xd, $a340872f7a7f928e$var$yd, $a340872f7a7f928e$var$Ad = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a340872f7a7f928e$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a340872f7a7f928e$var$yd && ($a340872f7a7f928e$var$yd && "mousemove" === a.type ? ($a340872f7a7f928e$var$wd = a.screenX - $a340872f7a7f928e$var$yd.screenX, $a340872f7a7f928e$var$xd = a.screenY - $a340872f7a7f928e$var$yd.screenY) : $a340872f7a7f928e$var$xd = $a340872f7a7f928e$var$wd = 0, $a340872f7a7f928e$var$yd = a);
        return $a340872f7a7f928e$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a340872f7a7f928e$var$xd;
    }
}), $a340872f7a7f928e$var$Bd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Ad), $a340872f7a7f928e$var$Cd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$Ad, {
    dataTransfer: 0
}), $a340872f7a7f928e$var$Dd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Cd), $a340872f7a7f928e$var$Ed = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$ud, {
    relatedTarget: 0
}), $a340872f7a7f928e$var$Fd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Ed), $a340872f7a7f928e$var$Gd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a340872f7a7f928e$var$Hd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Gd), $a340872f7a7f928e$var$Id = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a340872f7a7f928e$var$Jd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Id), $a340872f7a7f928e$var$Kd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$sd, {
    data: 0
}), $a340872f7a7f928e$var$Ld = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Kd), $a340872f7a7f928e$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a340872f7a7f928e$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a340872f7a7f928e$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a340872f7a7f928e$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a340872f7a7f928e$var$Od[a]) ? !!b[a] : !1;
}
function $a340872f7a7f928e$var$zd() {
    return $a340872f7a7f928e$var$Pd;
}
var $a340872f7a7f928e$var$Qd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a340872f7a7f928e$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a340872f7a7f928e$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a340872f7a7f928e$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a340872f7a7f928e$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a340872f7a7f928e$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a340872f7a7f928e$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a340872f7a7f928e$var$Rd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Qd), $a340872f7a7f928e$var$Sd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a340872f7a7f928e$var$Td = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Sd), $a340872f7a7f928e$var$Ud = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a340872f7a7f928e$var$zd
}), $a340872f7a7f928e$var$Vd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Ud), $a340872f7a7f928e$var$Wd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a340872f7a7f928e$var$Xd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Wd), $a340872f7a7f928e$var$Yd = $a340872f7a7f928e$var$A({}, $a340872f7a7f928e$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a340872f7a7f928e$var$Zd = $a340872f7a7f928e$var$rd($a340872f7a7f928e$var$Yd), $a340872f7a7f928e$var$$d = [
    9,
    13,
    27,
    32
], $a340872f7a7f928e$var$ae = $a340872f7a7f928e$var$ia && "CompositionEvent" in window, $a340872f7a7f928e$var$be = null;
$a340872f7a7f928e$var$ia && "documentMode" in document && ($a340872f7a7f928e$var$be = document.documentMode);
var $a340872f7a7f928e$var$ce = $a340872f7a7f928e$var$ia && "TextEvent" in window && !$a340872f7a7f928e$var$be, $a340872f7a7f928e$var$de = $a340872f7a7f928e$var$ia && (!$a340872f7a7f928e$var$ae || $a340872f7a7f928e$var$be && 8 < $a340872f7a7f928e$var$be && 11 >= $a340872f7a7f928e$var$be), $a340872f7a7f928e$var$ee = String.fromCharCode(32), $a340872f7a7f928e$var$fe = !1;
function $a340872f7a7f928e$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a340872f7a7f928e$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a340872f7a7f928e$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a340872f7a7f928e$var$ie = !1;
function $a340872f7a7f928e$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a340872f7a7f928e$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a340872f7a7f928e$var$fe = !0;
            return $a340872f7a7f928e$var$ee;
        case "textInput":
            return a = b.data, a === $a340872f7a7f928e$var$ee && $a340872f7a7f928e$var$fe ? null : a;
        default:
            return null;
    }
}
function $a340872f7a7f928e$var$ke(a, b) {
    if ($a340872f7a7f928e$var$ie) return "compositionend" === a || !$a340872f7a7f928e$var$ae && $a340872f7a7f928e$var$ge(a, b) ? (a = $a340872f7a7f928e$var$nd(), $a340872f7a7f928e$var$md = $a340872f7a7f928e$var$ld = $a340872f7a7f928e$var$kd = null, $a340872f7a7f928e$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a340872f7a7f928e$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a340872f7a7f928e$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a340872f7a7f928e$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a340872f7a7f928e$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a340872f7a7f928e$var$ne(a, b, c, d) {
    $a340872f7a7f928e$var$Eb(d);
    b = $a340872f7a7f928e$var$oe(b, "onChange");
    0 < b.length && (c = new $a340872f7a7f928e$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a340872f7a7f928e$var$pe = null, $a340872f7a7f928e$var$qe = null;
function $a340872f7a7f928e$var$re(a) {
    $a340872f7a7f928e$var$se(a, 0);
}
function $a340872f7a7f928e$var$te(a) {
    var b = $a340872f7a7f928e$var$ue(a);
    if ($a340872f7a7f928e$var$Wa(b)) return a;
}
function $a340872f7a7f928e$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a340872f7a7f928e$var$we = !1;
if ($a340872f7a7f928e$var$ia) {
    var $a340872f7a7f928e$var$xe;
    if ($a340872f7a7f928e$var$ia) {
        var $a340872f7a7f928e$var$ye = "oninput" in document;
        if (!$a340872f7a7f928e$var$ye) {
            var $a340872f7a7f928e$var$ze = document.createElement("div");
            $a340872f7a7f928e$var$ze.setAttribute("oninput", "return;");
            $a340872f7a7f928e$var$ye = "function" === typeof $a340872f7a7f928e$var$ze.oninput;
        }
        $a340872f7a7f928e$var$xe = $a340872f7a7f928e$var$ye;
    } else $a340872f7a7f928e$var$xe = !1;
    $a340872f7a7f928e$var$we = $a340872f7a7f928e$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a340872f7a7f928e$var$Ae() {
    $a340872f7a7f928e$var$pe && ($a340872f7a7f928e$var$pe.detachEvent("onpropertychange", $a340872f7a7f928e$var$Be), $a340872f7a7f928e$var$qe = $a340872f7a7f928e$var$pe = null);
}
function $a340872f7a7f928e$var$Be(a) {
    if ("value" === a.propertyName && $a340872f7a7f928e$var$te($a340872f7a7f928e$var$qe)) {
        var b = [];
        $a340872f7a7f928e$var$ne(b, $a340872f7a7f928e$var$qe, a, $a340872f7a7f928e$var$xb(a));
        $a340872f7a7f928e$var$Jb($a340872f7a7f928e$var$re, b);
    }
}
function $a340872f7a7f928e$var$Ce(a, b, c) {
    "focusin" === a ? ($a340872f7a7f928e$var$Ae(), $a340872f7a7f928e$var$pe = b, $a340872f7a7f928e$var$qe = c, $a340872f7a7f928e$var$pe.attachEvent("onpropertychange", $a340872f7a7f928e$var$Be)) : "focusout" === a && $a340872f7a7f928e$var$Ae();
}
function $a340872f7a7f928e$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a340872f7a7f928e$var$te($a340872f7a7f928e$var$qe);
}
function $a340872f7a7f928e$var$Ee(a, b) {
    if ("click" === a) return $a340872f7a7f928e$var$te(b);
}
function $a340872f7a7f928e$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a340872f7a7f928e$var$te(b);
}
function $a340872f7a7f928e$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a340872f7a7f928e$var$He = "function" === typeof Object.is ? Object.is : $a340872f7a7f928e$var$Ge;
function $a340872f7a7f928e$var$Ie(a, b) {
    if ($a340872f7a7f928e$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a340872f7a7f928e$var$ja.call(b, e) || !$a340872f7a7f928e$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a340872f7a7f928e$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a340872f7a7f928e$var$Ke(a, b) {
    var c = $a340872f7a7f928e$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a340872f7a7f928e$var$Je(c);
    }
}
function $a340872f7a7f928e$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a340872f7a7f928e$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a340872f7a7f928e$var$Me() {
    for(var a = window, b = $a340872f7a7f928e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a340872f7a7f928e$var$Xa(a.document);
    }
    return b;
}
function $a340872f7a7f928e$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a340872f7a7f928e$var$Oe(a) {
    var b = $a340872f7a7f928e$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a340872f7a7f928e$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a340872f7a7f928e$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a340872f7a7f928e$var$Ke(c, f);
                var g = $a340872f7a7f928e$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a340872f7a7f928e$var$Pe = $a340872f7a7f928e$var$ia && "documentMode" in document && 11 >= document.documentMode, $a340872f7a7f928e$var$Qe = null, $a340872f7a7f928e$var$Re = null, $a340872f7a7f928e$var$Se = null, $a340872f7a7f928e$var$Te = !1;
function $a340872f7a7f928e$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a340872f7a7f928e$var$Te || null == $a340872f7a7f928e$var$Qe || $a340872f7a7f928e$var$Qe !== $a340872f7a7f928e$var$Xa(d) || (d = $a340872f7a7f928e$var$Qe, "selectionStart" in d && $a340872f7a7f928e$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a340872f7a7f928e$var$Se && $a340872f7a7f928e$var$Ie($a340872f7a7f928e$var$Se, d) || ($a340872f7a7f928e$var$Se = d, d = $a340872f7a7f928e$var$oe($a340872f7a7f928e$var$Re, "onSelect"), 0 < d.length && (b = new $a340872f7a7f928e$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a340872f7a7f928e$var$Qe)));
}
function $a340872f7a7f928e$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a340872f7a7f928e$var$We = {
    animationend: $a340872f7a7f928e$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a340872f7a7f928e$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a340872f7a7f928e$var$Ve("Animation", "AnimationStart"),
    transitionend: $a340872f7a7f928e$var$Ve("Transition", "TransitionEnd")
}, $a340872f7a7f928e$var$Xe = {}, $a340872f7a7f928e$var$Ye = {};
$a340872f7a7f928e$var$ia && ($a340872f7a7f928e$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a340872f7a7f928e$var$We.animationend.animation, delete $a340872f7a7f928e$var$We.animationiteration.animation, delete $a340872f7a7f928e$var$We.animationstart.animation), "TransitionEvent" in window || delete $a340872f7a7f928e$var$We.transitionend.transition);
function $a340872f7a7f928e$var$Ze(a) {
    if ($a340872f7a7f928e$var$Xe[a]) return $a340872f7a7f928e$var$Xe[a];
    if (!$a340872f7a7f928e$var$We[a]) return a;
    var b = $a340872f7a7f928e$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a340872f7a7f928e$var$Ye) return $a340872f7a7f928e$var$Xe[a] = b[c];
    return a;
}
var $a340872f7a7f928e$var$$e = $a340872f7a7f928e$var$Ze("animationend"), $a340872f7a7f928e$var$af = $a340872f7a7f928e$var$Ze("animationiteration"), $a340872f7a7f928e$var$bf = $a340872f7a7f928e$var$Ze("animationstart"), $a340872f7a7f928e$var$cf = $a340872f7a7f928e$var$Ze("transitionend"), $a340872f7a7f928e$var$df = new Map, $a340872f7a7f928e$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a340872f7a7f928e$var$ff(a, b) {
    $a340872f7a7f928e$var$df.set(a, b);
    $a340872f7a7f928e$var$fa(b, [
        a
    ]);
}
for(var $a340872f7a7f928e$var$gf = 0; $a340872f7a7f928e$var$gf < $a340872f7a7f928e$var$ef.length; $a340872f7a7f928e$var$gf++){
    var $a340872f7a7f928e$var$hf = $a340872f7a7f928e$var$ef[$a340872f7a7f928e$var$gf], $a340872f7a7f928e$var$jf = $a340872f7a7f928e$var$hf.toLowerCase(), $a340872f7a7f928e$var$kf = $a340872f7a7f928e$var$hf[0].toUpperCase() + $a340872f7a7f928e$var$hf.slice(1);
    $a340872f7a7f928e$var$ff($a340872f7a7f928e$var$jf, "on" + $a340872f7a7f928e$var$kf);
}
$a340872f7a7f928e$var$ff($a340872f7a7f928e$var$$e, "onAnimationEnd");
$a340872f7a7f928e$var$ff($a340872f7a7f928e$var$af, "onAnimationIteration");
$a340872f7a7f928e$var$ff($a340872f7a7f928e$var$bf, "onAnimationStart");
$a340872f7a7f928e$var$ff("dblclick", "onDoubleClick");
$a340872f7a7f928e$var$ff("focusin", "onFocus");
$a340872f7a7f928e$var$ff("focusout", "onBlur");
$a340872f7a7f928e$var$ff($a340872f7a7f928e$var$cf, "onTransitionEnd");
$a340872f7a7f928e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a340872f7a7f928e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a340872f7a7f928e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a340872f7a7f928e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a340872f7a7f928e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a340872f7a7f928e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a340872f7a7f928e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a340872f7a7f928e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a340872f7a7f928e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a340872f7a7f928e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a340872f7a7f928e$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a340872f7a7f928e$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a340872f7a7f928e$var$lf));
function $a340872f7a7f928e$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a340872f7a7f928e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a340872f7a7f928e$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a340872f7a7f928e$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a340872f7a7f928e$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a340872f7a7f928e$var$Qb) throw a = $a340872f7a7f928e$var$Rb, $a340872f7a7f928e$var$Qb = !1, $a340872f7a7f928e$var$Rb = null, a;
}
function $a340872f7a7f928e$var$D(a, b) {
    var c = b[$a340872f7a7f928e$var$of];
    void 0 === c && (c = b[$a340872f7a7f928e$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a340872f7a7f928e$var$pf(b, a, 2, !1), c.add(d));
}
function $a340872f7a7f928e$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a340872f7a7f928e$var$pf(c, a, d, b);
}
var $a340872f7a7f928e$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a340872f7a7f928e$var$sf(a) {
    if (!a[$a340872f7a7f928e$var$rf]) {
        a[$a340872f7a7f928e$var$rf] = !0;
        $a340872f7a7f928e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a340872f7a7f928e$var$mf.has(b) || $a340872f7a7f928e$var$qf(b, !1, a), $a340872f7a7f928e$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a340872f7a7f928e$var$rf] || (b[$a340872f7a7f928e$var$rf] = !0, $a340872f7a7f928e$var$qf("selectionchange", !1, b));
    }
}
function $a340872f7a7f928e$var$pf(a, b, c, d) {
    switch($a340872f7a7f928e$var$jd(b)){
        case 1:
            var e = $a340872f7a7f928e$var$ed;
            break;
        case 4:
            e = $a340872f7a7f928e$var$gd;
            break;
        default:
            e = $a340872f7a7f928e$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a340872f7a7f928e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a340872f7a7f928e$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a340872f7a7f928e$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a340872f7a7f928e$var$Jb(function() {
        var d = f, e = $a340872f7a7f928e$var$xb(c), g = [];
        a: {
            var h = $a340872f7a7f928e$var$df.get(a);
            if (void 0 !== h) {
                var k = $a340872f7a7f928e$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a340872f7a7f928e$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a340872f7a7f928e$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a340872f7a7f928e$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a340872f7a7f928e$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a340872f7a7f928e$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a340872f7a7f928e$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a340872f7a7f928e$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a340872f7a7f928e$var$Vd;
                        break;
                    case $a340872f7a7f928e$var$$e:
                    case $a340872f7a7f928e$var$af:
                    case $a340872f7a7f928e$var$bf:
                        k = $a340872f7a7f928e$var$Hd;
                        break;
                    case $a340872f7a7f928e$var$cf:
                        k = $a340872f7a7f928e$var$Xd;
                        break;
                    case "scroll":
                        k = $a340872f7a7f928e$var$vd;
                        break;
                    case "wheel":
                        k = $a340872f7a7f928e$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a340872f7a7f928e$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a340872f7a7f928e$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a340872f7a7f928e$var$Kb(w, x), null != F && t.push($a340872f7a7f928e$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a340872f7a7f928e$var$wb && (n = c.relatedTarget || c.fromElement) && ($a340872f7a7f928e$var$Wc(n) || n[$a340872f7a7f928e$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a340872f7a7f928e$var$Wc(n) : null, null !== n && (J = $a340872f7a7f928e$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a340872f7a7f928e$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a340872f7a7f928e$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a340872f7a7f928e$var$ue(k);
                        u = null == n ? h : $a340872f7a7f928e$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a340872f7a7f928e$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a340872f7a7f928e$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a340872f7a7f928e$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a340872f7a7f928e$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a340872f7a7f928e$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a340872f7a7f928e$var$vf(t);
                                x = $a340872f7a7f928e$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a340872f7a7f928e$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a340872f7a7f928e$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a340872f7a7f928e$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a340872f7a7f928e$var$ve;
                else if ($a340872f7a7f928e$var$me(h)) {
                    if ($a340872f7a7f928e$var$we) na = $a340872f7a7f928e$var$Fe;
                    else {
                        na = $a340872f7a7f928e$var$De;
                        var xa = $a340872f7a7f928e$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a340872f7a7f928e$var$Ee);
                if (na && (na = na(a, d))) {
                    $a340872f7a7f928e$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a340872f7a7f928e$var$cb(h, "number", h.value);
            }
            xa = d ? $a340872f7a7f928e$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a340872f7a7f928e$var$me(xa) || "true" === xa.contentEditable) $a340872f7a7f928e$var$Qe = xa, $a340872f7a7f928e$var$Re = d, $a340872f7a7f928e$var$Se = null;
                    break;
                case "focusout":
                    $a340872f7a7f928e$var$Se = $a340872f7a7f928e$var$Re = $a340872f7a7f928e$var$Qe = null;
                    break;
                case "mousedown":
                    $a340872f7a7f928e$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a340872f7a7f928e$var$Te = !1;
                    $a340872f7a7f928e$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a340872f7a7f928e$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a340872f7a7f928e$var$Ue(g, c, e);
            }
            var $a;
            if ($a340872f7a7f928e$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a340872f7a7f928e$var$ie ? $a340872f7a7f928e$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a340872f7a7f928e$var$de && "ko" !== c.locale && ($a340872f7a7f928e$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a340872f7a7f928e$var$ie && ($a = $a340872f7a7f928e$var$nd()) : ($a340872f7a7f928e$var$kd = e, $a340872f7a7f928e$var$ld = "value" in $a340872f7a7f928e$var$kd ? $a340872f7a7f928e$var$kd.value : $a340872f7a7f928e$var$kd.textContent, $a340872f7a7f928e$var$ie = !0)), xa = $a340872f7a7f928e$var$oe(d, ba), 0 < xa.length && (ba = new $a340872f7a7f928e$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a340872f7a7f928e$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a340872f7a7f928e$var$ce ? $a340872f7a7f928e$var$je(a, c) : $a340872f7a7f928e$var$ke(a, c)) d = $a340872f7a7f928e$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a340872f7a7f928e$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a340872f7a7f928e$var$se(g, b);
    });
}
function $a340872f7a7f928e$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a340872f7a7f928e$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a340872f7a7f928e$var$Kb(a, c), null != f && d.unshift($a340872f7a7f928e$var$tf(a, f, e)), f = $a340872f7a7f928e$var$Kb(a, b), null != f && d.push($a340872f7a7f928e$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a340872f7a7f928e$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a340872f7a7f928e$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a340872f7a7f928e$var$Kb(c, f), null != k && g.unshift($a340872f7a7f928e$var$tf(c, k, h))) : e || (k = $a340872f7a7f928e$var$Kb(c, f), null != k && g.push($a340872f7a7f928e$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a340872f7a7f928e$var$xf = /\r\n?/g, $a340872f7a7f928e$var$yf = /\u0000|\uFFFD/g;
function $a340872f7a7f928e$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a340872f7a7f928e$var$xf, "\n").replace($a340872f7a7f928e$var$yf, "");
}
function $a340872f7a7f928e$var$Af(a, b, c) {
    b = $a340872f7a7f928e$var$zf(b);
    if ($a340872f7a7f928e$var$zf(a) !== b && c) throw Error($a340872f7a7f928e$var$p(425));
}
function $a340872f7a7f928e$var$Bf() {}
var $a340872f7a7f928e$var$Cf = null, $a340872f7a7f928e$var$Df = null;
function $a340872f7a7f928e$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a340872f7a7f928e$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a340872f7a7f928e$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a340872f7a7f928e$var$Hf = "function" === typeof Promise ? Promise : void 0, $a340872f7a7f928e$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a340872f7a7f928e$var$Hf ? function(a) {
    return $a340872f7a7f928e$var$Hf.resolve(null).then(a).catch($a340872f7a7f928e$var$If);
} : $a340872f7a7f928e$var$Ff;
function $a340872f7a7f928e$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a340872f7a7f928e$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a340872f7a7f928e$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a340872f7a7f928e$var$bd(b);
}
function $a340872f7a7f928e$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a340872f7a7f928e$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a340872f7a7f928e$var$Nf = Math.random().toString(36).slice(2), $a340872f7a7f928e$var$Of = "__reactFiber$" + $a340872f7a7f928e$var$Nf, $a340872f7a7f928e$var$Pf = "__reactProps$" + $a340872f7a7f928e$var$Nf, $a340872f7a7f928e$var$uf = "__reactContainer$" + $a340872f7a7f928e$var$Nf, $a340872f7a7f928e$var$of = "__reactEvents$" + $a340872f7a7f928e$var$Nf, $a340872f7a7f928e$var$Qf = "__reactListeners$" + $a340872f7a7f928e$var$Nf, $a340872f7a7f928e$var$Rf = "__reactHandles$" + $a340872f7a7f928e$var$Nf;
function $a340872f7a7f928e$var$Wc(a) {
    var b = a[$a340872f7a7f928e$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a340872f7a7f928e$var$uf] || c[$a340872f7a7f928e$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a340872f7a7f928e$var$Mf(a); null !== a;){
                if (c = a[$a340872f7a7f928e$var$Of]) return c;
                a = $a340872f7a7f928e$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a340872f7a7f928e$var$Cb(a) {
    a = a[$a340872f7a7f928e$var$Of] || a[$a340872f7a7f928e$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a340872f7a7f928e$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a340872f7a7f928e$var$p(33));
}
function $a340872f7a7f928e$var$Db(a) {
    return a[$a340872f7a7f928e$var$Pf] || null;
}
var $a340872f7a7f928e$var$Sf = [], $a340872f7a7f928e$var$Tf = -1;
function $a340872f7a7f928e$var$Uf(a) {
    return {
        current: a
    };
}
function $a340872f7a7f928e$var$E(a) {
    0 > $a340872f7a7f928e$var$Tf || (a.current = $a340872f7a7f928e$var$Sf[$a340872f7a7f928e$var$Tf], $a340872f7a7f928e$var$Sf[$a340872f7a7f928e$var$Tf] = null, $a340872f7a7f928e$var$Tf--);
}
function $a340872f7a7f928e$var$G(a, b) {
    $a340872f7a7f928e$var$Tf++;
    $a340872f7a7f928e$var$Sf[$a340872f7a7f928e$var$Tf] = a.current;
    a.current = b;
}
var $a340872f7a7f928e$var$Vf = {}, $a340872f7a7f928e$var$H = $a340872f7a7f928e$var$Uf($a340872f7a7f928e$var$Vf), $a340872f7a7f928e$var$Wf = $a340872f7a7f928e$var$Uf(!1), $a340872f7a7f928e$var$Xf = $a340872f7a7f928e$var$Vf;
function $a340872f7a7f928e$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a340872f7a7f928e$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a340872f7a7f928e$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a340872f7a7f928e$var$$f() {
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf);
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$H);
}
function $a340872f7a7f928e$var$ag(a, b, c) {
    if ($a340872f7a7f928e$var$H.current !== $a340872f7a7f928e$var$Vf) throw Error($a340872f7a7f928e$var$p(168));
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$H, b);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$Wf, c);
}
function $a340872f7a7f928e$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a340872f7a7f928e$var$p(108, $a340872f7a7f928e$var$Ra(a) || "Unknown", e));
    return $a340872f7a7f928e$var$A({}, c, d);
}
function $a340872f7a7f928e$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a340872f7a7f928e$var$Vf;
    $a340872f7a7f928e$var$Xf = $a340872f7a7f928e$var$H.current;
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$H, a);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$Wf, $a340872f7a7f928e$var$Wf.current);
    return !0;
}
function $a340872f7a7f928e$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a340872f7a7f928e$var$p(169));
    c ? (a = $a340872f7a7f928e$var$bg(a, b, $a340872f7a7f928e$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf), $a340872f7a7f928e$var$E($a340872f7a7f928e$var$H), $a340872f7a7f928e$var$G($a340872f7a7f928e$var$H, a)) : $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$Wf, c);
}
var $a340872f7a7f928e$var$eg = null, $a340872f7a7f928e$var$fg = !1, $a340872f7a7f928e$var$gg = !1;
function $a340872f7a7f928e$var$hg(a) {
    null === $a340872f7a7f928e$var$eg ? $a340872f7a7f928e$var$eg = [
        a
    ] : $a340872f7a7f928e$var$eg.push(a);
}
function $a340872f7a7f928e$var$ig(a) {
    $a340872f7a7f928e$var$fg = !0;
    $a340872f7a7f928e$var$hg(a);
}
function $a340872f7a7f928e$var$jg() {
    if (!$a340872f7a7f928e$var$gg && null !== $a340872f7a7f928e$var$eg) {
        $a340872f7a7f928e$var$gg = !0;
        var a = 0, b = $a340872f7a7f928e$var$C;
        try {
            var c = $a340872f7a7f928e$var$eg;
            for($a340872f7a7f928e$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a340872f7a7f928e$var$eg = null;
            $a340872f7a7f928e$var$fg = !1;
        } catch (e) {
            throw null !== $a340872f7a7f928e$var$eg && ($a340872f7a7f928e$var$eg = $a340872f7a7f928e$var$eg.slice(a + 1)), $a340872f7a7f928e$var$ac($a340872f7a7f928e$var$fc, $a340872f7a7f928e$var$jg), e;
        } finally{
            $a340872f7a7f928e$var$C = b, $a340872f7a7f928e$var$gg = !1;
        }
    }
    return null;
}
var $a340872f7a7f928e$var$kg = [], $a340872f7a7f928e$var$lg = 0, $a340872f7a7f928e$var$mg = null, $a340872f7a7f928e$var$ng = 0, $a340872f7a7f928e$var$og = [], $a340872f7a7f928e$var$pg = 0, $a340872f7a7f928e$var$qg = null, $a340872f7a7f928e$var$rg = 1, $a340872f7a7f928e$var$sg = "";
function $a340872f7a7f928e$var$tg(a, b) {
    $a340872f7a7f928e$var$kg[$a340872f7a7f928e$var$lg++] = $a340872f7a7f928e$var$ng;
    $a340872f7a7f928e$var$kg[$a340872f7a7f928e$var$lg++] = $a340872f7a7f928e$var$mg;
    $a340872f7a7f928e$var$mg = a;
    $a340872f7a7f928e$var$ng = b;
}
function $a340872f7a7f928e$var$ug(a, b, c) {
    $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$rg;
    $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$sg;
    $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$qg;
    $a340872f7a7f928e$var$qg = a;
    var d = $a340872f7a7f928e$var$rg;
    a = $a340872f7a7f928e$var$sg;
    var e = 32 - $a340872f7a7f928e$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a340872f7a7f928e$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a340872f7a7f928e$var$rg = 1 << 32 - $a340872f7a7f928e$var$oc(b) + e | c << e | d;
        $a340872f7a7f928e$var$sg = f + a;
    } else $a340872f7a7f928e$var$rg = 1 << f | c << e | d, $a340872f7a7f928e$var$sg = a;
}
function $a340872f7a7f928e$var$vg(a) {
    null !== a.return && ($a340872f7a7f928e$var$tg(a, 1), $a340872f7a7f928e$var$ug(a, 1, 0));
}
function $a340872f7a7f928e$var$wg(a) {
    for(; a === $a340872f7a7f928e$var$mg;)$a340872f7a7f928e$var$mg = $a340872f7a7f928e$var$kg[--$a340872f7a7f928e$var$lg], $a340872f7a7f928e$var$kg[$a340872f7a7f928e$var$lg] = null, $a340872f7a7f928e$var$ng = $a340872f7a7f928e$var$kg[--$a340872f7a7f928e$var$lg], $a340872f7a7f928e$var$kg[$a340872f7a7f928e$var$lg] = null;
    for(; a === $a340872f7a7f928e$var$qg;)$a340872f7a7f928e$var$qg = $a340872f7a7f928e$var$og[--$a340872f7a7f928e$var$pg], $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg] = null, $a340872f7a7f928e$var$sg = $a340872f7a7f928e$var$og[--$a340872f7a7f928e$var$pg], $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg] = null, $a340872f7a7f928e$var$rg = $a340872f7a7f928e$var$og[--$a340872f7a7f928e$var$pg], $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg] = null;
}
var $a340872f7a7f928e$var$xg = null, $a340872f7a7f928e$var$yg = null, $a340872f7a7f928e$var$I = !1, $a340872f7a7f928e$var$zg = null;
function $a340872f7a7f928e$var$Ag(a, b) {
    var c = $a340872f7a7f928e$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a340872f7a7f928e$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a340872f7a7f928e$var$xg = a, $a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a340872f7a7f928e$var$xg = a, $a340872f7a7f928e$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a340872f7a7f928e$var$qg ? {
                id: $a340872f7a7f928e$var$rg,
                overflow: $a340872f7a7f928e$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a340872f7a7f928e$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a340872f7a7f928e$var$xg = a, $a340872f7a7f928e$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a340872f7a7f928e$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a340872f7a7f928e$var$Eg(a) {
    if ($a340872f7a7f928e$var$I) {
        var b = $a340872f7a7f928e$var$yg;
        if (b) {
            var c = b;
            if (!$a340872f7a7f928e$var$Cg(a, b)) {
                if ($a340872f7a7f928e$var$Dg(a)) throw Error($a340872f7a7f928e$var$p(418));
                b = $a340872f7a7f928e$var$Lf(c.nextSibling);
                var d = $a340872f7a7f928e$var$xg;
                b && $a340872f7a7f928e$var$Cg(a, b) ? $a340872f7a7f928e$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a340872f7a7f928e$var$I = !1, $a340872f7a7f928e$var$xg = a);
            }
        } else {
            if ($a340872f7a7f928e$var$Dg(a)) throw Error($a340872f7a7f928e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a340872f7a7f928e$var$I = !1;
            $a340872f7a7f928e$var$xg = a;
        }
    }
}
function $a340872f7a7f928e$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a340872f7a7f928e$var$xg = a;
}
function $a340872f7a7f928e$var$Gg(a) {
    if (a !== $a340872f7a7f928e$var$xg) return !1;
    if (!$a340872f7a7f928e$var$I) return $a340872f7a7f928e$var$Fg(a), $a340872f7a7f928e$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a340872f7a7f928e$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a340872f7a7f928e$var$yg)) {
        if ($a340872f7a7f928e$var$Dg(a)) throw $a340872f7a7f928e$var$Hg(), Error($a340872f7a7f928e$var$p(418));
        for(; b;)$a340872f7a7f928e$var$Ag(a, b), b = $a340872f7a7f928e$var$Lf(b.nextSibling);
    }
    $a340872f7a7f928e$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a340872f7a7f928e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a340872f7a7f928e$var$yg = null;
        }
    } else $a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$xg ? $a340872f7a7f928e$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a340872f7a7f928e$var$Hg() {
    for(var a = $a340872f7a7f928e$var$yg; a;)a = $a340872f7a7f928e$var$Lf(a.nextSibling);
}
function $a340872f7a7f928e$var$Ig() {
    $a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$xg = null;
    $a340872f7a7f928e$var$I = !1;
}
function $a340872f7a7f928e$var$Jg(a) {
    null === $a340872f7a7f928e$var$zg ? $a340872f7a7f928e$var$zg = [
        a
    ] : $a340872f7a7f928e$var$zg.push(a);
}
var $a340872f7a7f928e$var$Kg = $a340872f7a7f928e$var$ua.ReactCurrentBatchConfig;
function $a340872f7a7f928e$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a340872f7a7f928e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a340872f7a7f928e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a340872f7a7f928e$var$p(284));
        if (!c._owner) throw Error($a340872f7a7f928e$var$p(290, a));
    }
    return a;
}
function $a340872f7a7f928e$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a340872f7a7f928e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a340872f7a7f928e$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $a340872f7a7f928e$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a340872f7a7f928e$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a340872f7a7f928e$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a340872f7a7f928e$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a340872f7a7f928e$var$Ha && $a340872f7a7f928e$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $a340872f7a7f928e$var$Lg(a, b, c), d.return = a, d;
        d = $a340872f7a7f928e$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a340872f7a7f928e$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a340872f7a7f928e$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a340872f7a7f928e$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a340872f7a7f928e$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a340872f7a7f928e$var$va:
                    return c = $a340872f7a7f928e$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $a340872f7a7f928e$var$Lg(a, null, b), c.return = a, c;
                case $a340872f7a7f928e$var$wa:
                    return b = $a340872f7a7f928e$var$Sg(b, a.mode, c), b.return = a, b;
                case $a340872f7a7f928e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a340872f7a7f928e$var$eb(b) || $a340872f7a7f928e$var$Ka(b)) return b = $a340872f7a7f928e$var$Tg(b, a.mode, c, null), b.return = a, b;
            $a340872f7a7f928e$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a340872f7a7f928e$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a340872f7a7f928e$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a340872f7a7f928e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a340872f7a7f928e$var$eb(c) || $a340872f7a7f928e$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a340872f7a7f928e$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a340872f7a7f928e$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a340872f7a7f928e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a340872f7a7f928e$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a340872f7a7f928e$var$eb(d) || $a340872f7a7f928e$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a340872f7a7f928e$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a340872f7a7f928e$var$Ka(h);
        if ("function" !== typeof l) throw Error($a340872f7a7f928e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a340872f7a7f928e$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a340872f7a7f928e$var$I && $a340872f7a7f928e$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a340872f7a7f928e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a340872f7a7f928e$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a340872f7a7f928e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a340872f7a7f928e$var$Ha && $a340872f7a7f928e$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a340872f7a7f928e$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a340872f7a7f928e$var$ya ? (d = $a340872f7a7f928e$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a340872f7a7f928e$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $a340872f7a7f928e$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a340872f7a7f928e$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a340872f7a7f928e$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a340872f7a7f928e$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a340872f7a7f928e$var$eb(f)) return n(a, d, f, h);
            if ($a340872f7a7f928e$var$Ka(f)) return t(a, d, f, h);
            $a340872f7a7f928e$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a340872f7a7f928e$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a340872f7a7f928e$var$Ug = $a340872f7a7f928e$var$Og(!0), $a340872f7a7f928e$var$Vg = $a340872f7a7f928e$var$Og(!1), $a340872f7a7f928e$var$Wg = $a340872f7a7f928e$var$Uf(null), $a340872f7a7f928e$var$Xg = null, $a340872f7a7f928e$var$Yg = null, $a340872f7a7f928e$var$Zg = null;
function $a340872f7a7f928e$var$$g() {
    $a340872f7a7f928e$var$Zg = $a340872f7a7f928e$var$Yg = $a340872f7a7f928e$var$Xg = null;
}
function $a340872f7a7f928e$var$ah(a) {
    var b = $a340872f7a7f928e$var$Wg.current;
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wg);
    a._currentValue = b;
}
function $a340872f7a7f928e$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a340872f7a7f928e$var$ch(a, b) {
    $a340872f7a7f928e$var$Xg = a;
    $a340872f7a7f928e$var$Zg = $a340872f7a7f928e$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a340872f7a7f928e$var$dh = !0), a.firstContext = null);
}
function $a340872f7a7f928e$var$eh(a) {
    var b = a._currentValue;
    if ($a340872f7a7f928e$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a340872f7a7f928e$var$Yg) {
            if (null === $a340872f7a7f928e$var$Xg) throw Error($a340872f7a7f928e$var$p(308));
            $a340872f7a7f928e$var$Yg = a;
            $a340872f7a7f928e$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a340872f7a7f928e$var$Yg = $a340872f7a7f928e$var$Yg.next = a;
    }
    return b;
}
var $a340872f7a7f928e$var$fh = null;
function $a340872f7a7f928e$var$gh(a) {
    null === $a340872f7a7f928e$var$fh ? $a340872f7a7f928e$var$fh = [
        a
    ] : $a340872f7a7f928e$var$fh.push(a);
}
function $a340872f7a7f928e$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a340872f7a7f928e$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a340872f7a7f928e$var$ih(a, d);
}
function $a340872f7a7f928e$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a340872f7a7f928e$var$jh = !1;
function $a340872f7a7f928e$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a340872f7a7f928e$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a340872f7a7f928e$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a340872f7a7f928e$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a340872f7a7f928e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a340872f7a7f928e$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a340872f7a7f928e$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a340872f7a7f928e$var$ih(a, c);
}
function $a340872f7a7f928e$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a340872f7a7f928e$var$Cc(a, c);
    }
}
function $a340872f7a7f928e$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a340872f7a7f928e$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $a340872f7a7f928e$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a340872f7a7f928e$var$A({}, q, r);
                            break a;
                        case 2:
                            $a340872f7a7f928e$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a340872f7a7f928e$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a340872f7a7f928e$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a340872f7a7f928e$var$p(191, e));
            e.call(d);
        }
    }
}
var $a340872f7a7f928e$var$th = {}, $a340872f7a7f928e$var$uh = $a340872f7a7f928e$var$Uf($a340872f7a7f928e$var$th), $a340872f7a7f928e$var$vh = $a340872f7a7f928e$var$Uf($a340872f7a7f928e$var$th), $a340872f7a7f928e$var$wh = $a340872f7a7f928e$var$Uf($a340872f7a7f928e$var$th);
function $a340872f7a7f928e$var$xh(a) {
    if (a === $a340872f7a7f928e$var$th) throw Error($a340872f7a7f928e$var$p(174));
    return a;
}
function $a340872f7a7f928e$var$yh(a, b) {
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$wh, b);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$vh, a);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$uh, $a340872f7a7f928e$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a340872f7a7f928e$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a340872f7a7f928e$var$lb(b, a);
    }
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$uh);
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$uh, b);
}
function $a340872f7a7f928e$var$zh() {
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$uh);
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$vh);
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$wh);
}
function $a340872f7a7f928e$var$Ah(a) {
    $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$wh.current);
    var b = $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$uh.current);
    var c = $a340872f7a7f928e$var$lb(b, a.type);
    b !== c && ($a340872f7a7f928e$var$G($a340872f7a7f928e$var$vh, a), $a340872f7a7f928e$var$G($a340872f7a7f928e$var$uh, c));
}
function $a340872f7a7f928e$var$Bh(a) {
    $a340872f7a7f928e$var$vh.current === a && ($a340872f7a7f928e$var$E($a340872f7a7f928e$var$uh), $a340872f7a7f928e$var$E($a340872f7a7f928e$var$vh));
}
var $a340872f7a7f928e$var$L = $a340872f7a7f928e$var$Uf(0);
function $a340872f7a7f928e$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a340872f7a7f928e$var$Dh = [];
function $a340872f7a7f928e$var$Eh() {
    for(var a = 0; a < $a340872f7a7f928e$var$Dh.length; a++)$a340872f7a7f928e$var$Dh[a]._workInProgressVersionPrimary = null;
    $a340872f7a7f928e$var$Dh.length = 0;
}
var $a340872f7a7f928e$var$Fh = $a340872f7a7f928e$var$ua.ReactCurrentDispatcher, $a340872f7a7f928e$var$Gh = $a340872f7a7f928e$var$ua.ReactCurrentBatchConfig, $a340872f7a7f928e$var$Hh = 0, $a340872f7a7f928e$var$M = null, $a340872f7a7f928e$var$N = null, $a340872f7a7f928e$var$O = null, $a340872f7a7f928e$var$Ih = !1, $a340872f7a7f928e$var$Jh = !1, $a340872f7a7f928e$var$Kh = 0, $a340872f7a7f928e$var$Lh = 0;
function $a340872f7a7f928e$var$P() {
    throw Error($a340872f7a7f928e$var$p(321));
}
function $a340872f7a7f928e$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a340872f7a7f928e$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a340872f7a7f928e$var$Nh(a, b, c, d, e, f) {
    $a340872f7a7f928e$var$Hh = f;
    $a340872f7a7f928e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a340872f7a7f928e$var$Fh.current = null === a || null === a.memoizedState ? $a340872f7a7f928e$var$Oh : $a340872f7a7f928e$var$Ph;
    a = c(d, e);
    if ($a340872f7a7f928e$var$Jh) {
        f = 0;
        do {
            $a340872f7a7f928e$var$Jh = !1;
            $a340872f7a7f928e$var$Kh = 0;
            if (25 <= f) throw Error($a340872f7a7f928e$var$p(301));
            f += 1;
            $a340872f7a7f928e$var$O = $a340872f7a7f928e$var$N = null;
            b.updateQueue = null;
            $a340872f7a7f928e$var$Fh.current = $a340872f7a7f928e$var$Qh;
            a = c(d, e);
        }while ($a340872f7a7f928e$var$Jh);
    }
    $a340872f7a7f928e$var$Fh.current = $a340872f7a7f928e$var$Rh;
    b = null !== $a340872f7a7f928e$var$N && null !== $a340872f7a7f928e$var$N.next;
    $a340872f7a7f928e$var$Hh = 0;
    $a340872f7a7f928e$var$O = $a340872f7a7f928e$var$N = $a340872f7a7f928e$var$M = null;
    $a340872f7a7f928e$var$Ih = !1;
    if (b) throw Error($a340872f7a7f928e$var$p(300));
    return a;
}
function $a340872f7a7f928e$var$Sh() {
    var a = 0 !== $a340872f7a7f928e$var$Kh;
    $a340872f7a7f928e$var$Kh = 0;
    return a;
}
function $a340872f7a7f928e$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a340872f7a7f928e$var$O ? $a340872f7a7f928e$var$M.memoizedState = $a340872f7a7f928e$var$O = a : $a340872f7a7f928e$var$O = $a340872f7a7f928e$var$O.next = a;
    return $a340872f7a7f928e$var$O;
}
function $a340872f7a7f928e$var$Uh() {
    if (null === $a340872f7a7f928e$var$N) {
        var a = $a340872f7a7f928e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a340872f7a7f928e$var$N.next;
    var b = null === $a340872f7a7f928e$var$O ? $a340872f7a7f928e$var$M.memoizedState : $a340872f7a7f928e$var$O.next;
    if (null !== b) $a340872f7a7f928e$var$O = b, $a340872f7a7f928e$var$N = a;
    else {
        if (null === a) throw Error($a340872f7a7f928e$var$p(310));
        $a340872f7a7f928e$var$N = a;
        a = {
            memoizedState: $a340872f7a7f928e$var$N.memoizedState,
            baseState: $a340872f7a7f928e$var$N.baseState,
            baseQueue: $a340872f7a7f928e$var$N.baseQueue,
            queue: $a340872f7a7f928e$var$N.queue,
            next: null
        };
        null === $a340872f7a7f928e$var$O ? $a340872f7a7f928e$var$M.memoizedState = $a340872f7a7f928e$var$O = a : $a340872f7a7f928e$var$O = $a340872f7a7f928e$var$O.next = a;
    }
    return $a340872f7a7f928e$var$O;
}
function $a340872f7a7f928e$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a340872f7a7f928e$var$Wh(a) {
    var b = $a340872f7a7f928e$var$Uh(), c = b.queue;
    if (null === c) throw Error($a340872f7a7f928e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a340872f7a7f928e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a340872f7a7f928e$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a340872f7a7f928e$var$M.lanes |= m;
                $a340872f7a7f928e$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a340872f7a7f928e$var$He(d, b.memoizedState) || ($a340872f7a7f928e$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a340872f7a7f928e$var$M.lanes |= f, $a340872f7a7f928e$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a340872f7a7f928e$var$Xh(a) {
    var b = $a340872f7a7f928e$var$Uh(), c = b.queue;
    if (null === c) throw Error($a340872f7a7f928e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a340872f7a7f928e$var$He(f, b.memoizedState) || ($a340872f7a7f928e$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a340872f7a7f928e$var$Yh() {}
function $a340872f7a7f928e$var$Zh(a, b) {
    var c = $a340872f7a7f928e$var$M, d = $a340872f7a7f928e$var$Uh(), e = b(), f = !$a340872f7a7f928e$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a340872f7a7f928e$var$dh = !0);
    d = d.queue;
    $a340872f7a7f928e$var$$h($a340872f7a7f928e$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a340872f7a7f928e$var$O && $a340872f7a7f928e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a340872f7a7f928e$var$bi(9, $a340872f7a7f928e$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $a340872f7a7f928e$var$Q) throw Error($a340872f7a7f928e$var$p(349));
        0 !== ($a340872f7a7f928e$var$Hh & 30) || $a340872f7a7f928e$var$di(c, b, e);
    }
    return e;
}
function $a340872f7a7f928e$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a340872f7a7f928e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a340872f7a7f928e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a340872f7a7f928e$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a340872f7a7f928e$var$ei(b) && $a340872f7a7f928e$var$fi(a);
}
function $a340872f7a7f928e$var$ai(a, b, c) {
    return c(function() {
        $a340872f7a7f928e$var$ei(b) && $a340872f7a7f928e$var$fi(a);
    });
}
function $a340872f7a7f928e$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a340872f7a7f928e$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a340872f7a7f928e$var$fi(a) {
    var b = $a340872f7a7f928e$var$ih(a, 1);
    null !== b && $a340872f7a7f928e$var$gi(b, a, 1, -1);
}
function $a340872f7a7f928e$var$hi(a) {
    var b = $a340872f7a7f928e$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a340872f7a7f928e$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a340872f7a7f928e$var$ii.bind(null, $a340872f7a7f928e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a340872f7a7f928e$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a340872f7a7f928e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a340872f7a7f928e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a340872f7a7f928e$var$ji() {
    return $a340872f7a7f928e$var$Uh().memoizedState;
}
function $a340872f7a7f928e$var$ki(a, b, c, d) {
    var e = $a340872f7a7f928e$var$Th();
    $a340872f7a7f928e$var$M.flags |= a;
    e.memoizedState = $a340872f7a7f928e$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a340872f7a7f928e$var$li(a, b, c, d) {
    var e = $a340872f7a7f928e$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a340872f7a7f928e$var$N) {
        var g = $a340872f7a7f928e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $a340872f7a7f928e$var$Mh(d, g.deps)) {
            e.memoizedState = $a340872f7a7f928e$var$bi(b, c, f, d);
            return;
        }
    }
    $a340872f7a7f928e$var$M.flags |= a;
    e.memoizedState = $a340872f7a7f928e$var$bi(1 | b, c, f, d);
}
function $a340872f7a7f928e$var$mi(a, b) {
    return $a340872f7a7f928e$var$ki(8390656, 8, a, b);
}
function $a340872f7a7f928e$var$$h(a, b) {
    return $a340872f7a7f928e$var$li(2048, 8, a, b);
}
function $a340872f7a7f928e$var$ni(a, b) {
    return $a340872f7a7f928e$var$li(4, 2, a, b);
}
function $a340872f7a7f928e$var$oi(a, b) {
    return $a340872f7a7f928e$var$li(4, 4, a, b);
}
function $a340872f7a7f928e$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a340872f7a7f928e$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a340872f7a7f928e$var$li(4, 4, $a340872f7a7f928e$var$pi.bind(null, b, a), c);
}
function $a340872f7a7f928e$var$ri() {}
function $a340872f7a7f928e$var$si(a, b) {
    var c = $a340872f7a7f928e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a340872f7a7f928e$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a340872f7a7f928e$var$ti(a, b) {
    var c = $a340872f7a7f928e$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a340872f7a7f928e$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a340872f7a7f928e$var$ui(a, b, c) {
    if (0 === ($a340872f7a7f928e$var$Hh & 21)) return a.baseState && (a.baseState = !1, $a340872f7a7f928e$var$dh = !0), a.memoizedState = c;
    $a340872f7a7f928e$var$He(c, b) || (c = $a340872f7a7f928e$var$yc(), $a340872f7a7f928e$var$M.lanes |= c, $a340872f7a7f928e$var$rh |= c, a.baseState = !0);
    return b;
}
function $a340872f7a7f928e$var$vi(a, b) {
    var c = $a340872f7a7f928e$var$C;
    $a340872f7a7f928e$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a340872f7a7f928e$var$Gh.transition;
    $a340872f7a7f928e$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a340872f7a7f928e$var$C = c, $a340872f7a7f928e$var$Gh.transition = d;
    }
}
function $a340872f7a7f928e$var$wi() {
    return $a340872f7a7f928e$var$Uh().memoizedState;
}
function $a340872f7a7f928e$var$xi(a, b, c) {
    var d = $a340872f7a7f928e$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a340872f7a7f928e$var$zi(a)) $a340872f7a7f928e$var$Ai(b, c);
    else if (c = $a340872f7a7f928e$var$hh(a, b, c, d), null !== c) {
        var e = $a340872f7a7f928e$var$R();
        $a340872f7a7f928e$var$gi(c, a, d, e);
        $a340872f7a7f928e$var$Bi(c, b, d);
    }
}
function $a340872f7a7f928e$var$ii(a, b, c) {
    var d = $a340872f7a7f928e$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a340872f7a7f928e$var$zi(a)) $a340872f7a7f928e$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a340872f7a7f928e$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a340872f7a7f928e$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a340872f7a7f928e$var$hh(a, b, e, d);
        null !== c && (e = $a340872f7a7f928e$var$R(), $a340872f7a7f928e$var$gi(c, a, d, e), $a340872f7a7f928e$var$Bi(c, b, d));
    }
}
function $a340872f7a7f928e$var$zi(a) {
    var b = a.alternate;
    return a === $a340872f7a7f928e$var$M || null !== b && b === $a340872f7a7f928e$var$M;
}
function $a340872f7a7f928e$var$Ai(a, b) {
    $a340872f7a7f928e$var$Jh = $a340872f7a7f928e$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a340872f7a7f928e$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a340872f7a7f928e$var$Cc(a, c);
    }
}
var $a340872f7a7f928e$var$Rh = {
    readContext: $a340872f7a7f928e$var$eh,
    useCallback: $a340872f7a7f928e$var$P,
    useContext: $a340872f7a7f928e$var$P,
    useEffect: $a340872f7a7f928e$var$P,
    useImperativeHandle: $a340872f7a7f928e$var$P,
    useInsertionEffect: $a340872f7a7f928e$var$P,
    useLayoutEffect: $a340872f7a7f928e$var$P,
    useMemo: $a340872f7a7f928e$var$P,
    useReducer: $a340872f7a7f928e$var$P,
    useRef: $a340872f7a7f928e$var$P,
    useState: $a340872f7a7f928e$var$P,
    useDebugValue: $a340872f7a7f928e$var$P,
    useDeferredValue: $a340872f7a7f928e$var$P,
    useTransition: $a340872f7a7f928e$var$P,
    useMutableSource: $a340872f7a7f928e$var$P,
    useSyncExternalStore: $a340872f7a7f928e$var$P,
    useId: $a340872f7a7f928e$var$P,
    unstable_isNewReconciler: !1
}, $a340872f7a7f928e$var$Oh = {
    readContext: $a340872f7a7f928e$var$eh,
    useCallback: function(a, b) {
        $a340872f7a7f928e$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a340872f7a7f928e$var$eh,
    useEffect: $a340872f7a7f928e$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a340872f7a7f928e$var$ki(4194308, 4, $a340872f7a7f928e$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a340872f7a7f928e$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a340872f7a7f928e$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a340872f7a7f928e$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a340872f7a7f928e$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a340872f7a7f928e$var$xi.bind(null, $a340872f7a7f928e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a340872f7a7f928e$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a340872f7a7f928e$var$hi,
    useDebugValue: $a340872f7a7f928e$var$ri,
    useDeferredValue: function(a) {
        return $a340872f7a7f928e$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $a340872f7a7f928e$var$hi(!1), b = a[0];
        a = $a340872f7a7f928e$var$vi.bind(null, a[1]);
        $a340872f7a7f928e$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a340872f7a7f928e$var$M, e = $a340872f7a7f928e$var$Th();
        if ($a340872f7a7f928e$var$I) {
            if (void 0 === c) throw Error($a340872f7a7f928e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a340872f7a7f928e$var$Q) throw Error($a340872f7a7f928e$var$p(349));
            0 !== ($a340872f7a7f928e$var$Hh & 30) || $a340872f7a7f928e$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a340872f7a7f928e$var$mi($a340872f7a7f928e$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a340872f7a7f928e$var$bi(9, $a340872f7a7f928e$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a340872f7a7f928e$var$Th(), b = $a340872f7a7f928e$var$Q.identifierPrefix;
        if ($a340872f7a7f928e$var$I) {
            var c = $a340872f7a7f928e$var$sg;
            var d = $a340872f7a7f928e$var$rg;
            c = (d & ~(1 << 32 - $a340872f7a7f928e$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a340872f7a7f928e$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a340872f7a7f928e$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a340872f7a7f928e$var$Ph = {
    readContext: $a340872f7a7f928e$var$eh,
    useCallback: $a340872f7a7f928e$var$si,
    useContext: $a340872f7a7f928e$var$eh,
    useEffect: $a340872f7a7f928e$var$$h,
    useImperativeHandle: $a340872f7a7f928e$var$qi,
    useInsertionEffect: $a340872f7a7f928e$var$ni,
    useLayoutEffect: $a340872f7a7f928e$var$oi,
    useMemo: $a340872f7a7f928e$var$ti,
    useReducer: $a340872f7a7f928e$var$Wh,
    useRef: $a340872f7a7f928e$var$ji,
    useState: function() {
        return $a340872f7a7f928e$var$Wh($a340872f7a7f928e$var$Vh);
    },
    useDebugValue: $a340872f7a7f928e$var$ri,
    useDeferredValue: function(a) {
        var b = $a340872f7a7f928e$var$Uh();
        return $a340872f7a7f928e$var$ui(b, $a340872f7a7f928e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a340872f7a7f928e$var$Wh($a340872f7a7f928e$var$Vh)[0], b = $a340872f7a7f928e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a340872f7a7f928e$var$Yh,
    useSyncExternalStore: $a340872f7a7f928e$var$Zh,
    useId: $a340872f7a7f928e$var$wi,
    unstable_isNewReconciler: !1
}, $a340872f7a7f928e$var$Qh = {
    readContext: $a340872f7a7f928e$var$eh,
    useCallback: $a340872f7a7f928e$var$si,
    useContext: $a340872f7a7f928e$var$eh,
    useEffect: $a340872f7a7f928e$var$$h,
    useImperativeHandle: $a340872f7a7f928e$var$qi,
    useInsertionEffect: $a340872f7a7f928e$var$ni,
    useLayoutEffect: $a340872f7a7f928e$var$oi,
    useMemo: $a340872f7a7f928e$var$ti,
    useReducer: $a340872f7a7f928e$var$Xh,
    useRef: $a340872f7a7f928e$var$ji,
    useState: function() {
        return $a340872f7a7f928e$var$Xh($a340872f7a7f928e$var$Vh);
    },
    useDebugValue: $a340872f7a7f928e$var$ri,
    useDeferredValue: function(a) {
        var b = $a340872f7a7f928e$var$Uh();
        return null === $a340872f7a7f928e$var$N ? b.memoizedState = a : $a340872f7a7f928e$var$ui(b, $a340872f7a7f928e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $a340872f7a7f928e$var$Xh($a340872f7a7f928e$var$Vh)[0], b = $a340872f7a7f928e$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a340872f7a7f928e$var$Yh,
    useSyncExternalStore: $a340872f7a7f928e$var$Zh,
    useId: $a340872f7a7f928e$var$wi,
    unstable_isNewReconciler: !1
};
function $a340872f7a7f928e$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $a340872f7a7f928e$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $a340872f7a7f928e$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a340872f7a7f928e$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a340872f7a7f928e$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a340872f7a7f928e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a340872f7a7f928e$var$R(), e = $a340872f7a7f928e$var$yi(a), f = $a340872f7a7f928e$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a340872f7a7f928e$var$nh(a, f, e);
        null !== b && ($a340872f7a7f928e$var$gi(b, a, e, d), $a340872f7a7f928e$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a340872f7a7f928e$var$R(), e = $a340872f7a7f928e$var$yi(a), f = $a340872f7a7f928e$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a340872f7a7f928e$var$nh(a, f, e);
        null !== b && ($a340872f7a7f928e$var$gi(b, a, e, d), $a340872f7a7f928e$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a340872f7a7f928e$var$R(), d = $a340872f7a7f928e$var$yi(a), e = $a340872f7a7f928e$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a340872f7a7f928e$var$nh(a, e, d);
        null !== b && ($a340872f7a7f928e$var$gi(b, a, d, c), $a340872f7a7f928e$var$oh(b, a, d));
    }
};
function $a340872f7a7f928e$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a340872f7a7f928e$var$Ie(c, d) || !$a340872f7a7f928e$var$Ie(e, f) : !0;
}
function $a340872f7a7f928e$var$Gi(a, b, c) {
    var d = !1, e = $a340872f7a7f928e$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a340872f7a7f928e$var$eh(f) : (e = $a340872f7a7f928e$var$Zf(b) ? $a340872f7a7f928e$var$Xf : $a340872f7a7f928e$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a340872f7a7f928e$var$Yf(a, e) : $a340872f7a7f928e$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a340872f7a7f928e$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a340872f7a7f928e$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a340872f7a7f928e$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $a340872f7a7f928e$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $a340872f7a7f928e$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a340872f7a7f928e$var$eh(f) : (f = $a340872f7a7f928e$var$Zf(b) ? $a340872f7a7f928e$var$Xf : $a340872f7a7f928e$var$H.current, e.context = $a340872f7a7f928e$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a340872f7a7f928e$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a340872f7a7f928e$var$Ei.enqueueReplaceState(e, e.state, null), $a340872f7a7f928e$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a340872f7a7f928e$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $a340872f7a7f928e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a340872f7a7f928e$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a340872f7a7f928e$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a340872f7a7f928e$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $a340872f7a7f928e$var$Ni(a, b, c) {
    c = $a340872f7a7f928e$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a340872f7a7f928e$var$Oi || ($a340872f7a7f928e$var$Oi = !0, $a340872f7a7f928e$var$Pi = d);
        $a340872f7a7f928e$var$Li(a, b);
    };
    return c;
}
function $a340872f7a7f928e$var$Qi(a, b, c) {
    c = $a340872f7a7f928e$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a340872f7a7f928e$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a340872f7a7f928e$var$Li(a, b);
        "function" !== typeof d && (null === $a340872f7a7f928e$var$Ri ? $a340872f7a7f928e$var$Ri = new Set([
            this
        ]) : $a340872f7a7f928e$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a340872f7a7f928e$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a340872f7a7f928e$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a340872f7a7f928e$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $a340872f7a7f928e$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a340872f7a7f928e$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a340872f7a7f928e$var$mh(-1, 1), b.tag = 2, $a340872f7a7f928e$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a340872f7a7f928e$var$Wi = $a340872f7a7f928e$var$ua.ReactCurrentOwner, $a340872f7a7f928e$var$dh = !1;
function $a340872f7a7f928e$var$Xi(a, b, c, d) {
    b.child = null === a ? $a340872f7a7f928e$var$Vg(b, null, c, d) : $a340872f7a7f928e$var$Ug(b, a.child, c, d);
}
function $a340872f7a7f928e$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a340872f7a7f928e$var$ch(b, e);
    d = $a340872f7a7f928e$var$Nh(a, b, c, d, f, e);
    c = $a340872f7a7f928e$var$Sh();
    if (null !== a && !$a340872f7a7f928e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a340872f7a7f928e$var$Zi(a, b, e);
    $a340872f7a7f928e$var$I && c && $a340872f7a7f928e$var$vg(b);
    b.flags |= 1;
    $a340872f7a7f928e$var$Xi(a, b, d, e);
    return b.child;
}
function $a340872f7a7f928e$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a340872f7a7f928e$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a340872f7a7f928e$var$bj(a, b, f, d, e);
        a = $a340872f7a7f928e$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a340872f7a7f928e$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a340872f7a7f928e$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $a340872f7a7f928e$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a340872f7a7f928e$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a340872f7a7f928e$var$Ie(f, d) && a.ref === b.ref) {
            if ($a340872f7a7f928e$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a340872f7a7f928e$var$dh = !0);
            else return b.lanes = a.lanes, $a340872f7a7f928e$var$Zi(a, b, e);
        }
    }
    return $a340872f7a7f928e$var$cj(a, b, c, d, e);
}
function $a340872f7a7f928e$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a340872f7a7f928e$var$G($a340872f7a7f928e$var$ej, $a340872f7a7f928e$var$fj), $a340872f7a7f928e$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a340872f7a7f928e$var$G($a340872f7a7f928e$var$ej, $a340872f7a7f928e$var$fj), $a340872f7a7f928e$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a340872f7a7f928e$var$G($a340872f7a7f928e$var$ej, $a340872f7a7f928e$var$fj);
            $a340872f7a7f928e$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a340872f7a7f928e$var$G($a340872f7a7f928e$var$ej, $a340872f7a7f928e$var$fj), $a340872f7a7f928e$var$fj |= d;
    $a340872f7a7f928e$var$Xi(a, b, e, c);
    return b.child;
}
function $a340872f7a7f928e$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a340872f7a7f928e$var$cj(a, b, c, d, e) {
    var f = $a340872f7a7f928e$var$Zf(c) ? $a340872f7a7f928e$var$Xf : $a340872f7a7f928e$var$H.current;
    f = $a340872f7a7f928e$var$Yf(b, f);
    $a340872f7a7f928e$var$ch(b, e);
    c = $a340872f7a7f928e$var$Nh(a, b, c, d, f, e);
    d = $a340872f7a7f928e$var$Sh();
    if (null !== a && !$a340872f7a7f928e$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a340872f7a7f928e$var$Zi(a, b, e);
    $a340872f7a7f928e$var$I && d && $a340872f7a7f928e$var$vg(b);
    b.flags |= 1;
    $a340872f7a7f928e$var$Xi(a, b, c, e);
    return b.child;
}
function $a340872f7a7f928e$var$hj(a, b, c, d, e) {
    if ($a340872f7a7f928e$var$Zf(c)) {
        var f = !0;
        $a340872f7a7f928e$var$cg(b);
    } else f = !1;
    $a340872f7a7f928e$var$ch(b, e);
    if (null === b.stateNode) $a340872f7a7f928e$var$ij(a, b), $a340872f7a7f928e$var$Gi(b, c, d), $a340872f7a7f928e$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a340872f7a7f928e$var$eh(l) : (l = $a340872f7a7f928e$var$Zf(c) ? $a340872f7a7f928e$var$Xf : $a340872f7a7f928e$var$H.current, l = $a340872f7a7f928e$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a340872f7a7f928e$var$Hi(b, g, d, l);
        $a340872f7a7f928e$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $a340872f7a7f928e$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a340872f7a7f928e$var$Wf.current || $a340872f7a7f928e$var$jh ? ("function" === typeof m && ($a340872f7a7f928e$var$Di(b, c, m, d), k = b.memoizedState), (h = $a340872f7a7f928e$var$jh || $a340872f7a7f928e$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a340872f7a7f928e$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a340872f7a7f928e$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a340872f7a7f928e$var$eh(k) : (k = $a340872f7a7f928e$var$Zf(c) ? $a340872f7a7f928e$var$Xf : $a340872f7a7f928e$var$H.current, k = $a340872f7a7f928e$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a340872f7a7f928e$var$Hi(b, g, d, k);
        $a340872f7a7f928e$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $a340872f7a7f928e$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a340872f7a7f928e$var$Wf.current || $a340872f7a7f928e$var$jh ? ("function" === typeof y && ($a340872f7a7f928e$var$Di(b, c, y, d), n = b.memoizedState), (l = $a340872f7a7f928e$var$jh || $a340872f7a7f928e$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a340872f7a7f928e$var$jj(a, b, c, d, f, e);
}
function $a340872f7a7f928e$var$jj(a, b, c, d, e, f) {
    $a340872f7a7f928e$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a340872f7a7f928e$var$dg(b, c, !1), $a340872f7a7f928e$var$Zi(a, b, f);
    d = b.stateNode;
    $a340872f7a7f928e$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a340872f7a7f928e$var$Ug(b, a.child, null, f), b.child = $a340872f7a7f928e$var$Ug(b, null, h, f)) : $a340872f7a7f928e$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a340872f7a7f928e$var$dg(b, c, !0);
    return b.child;
}
function $a340872f7a7f928e$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a340872f7a7f928e$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a340872f7a7f928e$var$ag(a, b.context, !1);
    $a340872f7a7f928e$var$yh(a, b.containerInfo);
}
function $a340872f7a7f928e$var$lj(a, b, c, d, e) {
    $a340872f7a7f928e$var$Ig();
    $a340872f7a7f928e$var$Jg(e);
    b.flags |= 256;
    $a340872f7a7f928e$var$Xi(a, b, c, d);
    return b.child;
}
var $a340872f7a7f928e$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a340872f7a7f928e$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a340872f7a7f928e$var$oj(a, b, c) {
    var d = b.pendingProps, e = $a340872f7a7f928e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, e & 1);
    if (null === a) {
        $a340872f7a7f928e$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a340872f7a7f928e$var$pj(g, d, 0, null), a = $a340872f7a7f928e$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a340872f7a7f928e$var$nj(c), b.memoizedState = $a340872f7a7f928e$var$mj, a) : $a340872f7a7f928e$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a340872f7a7f928e$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a340872f7a7f928e$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a340872f7a7f928e$var$Pg(h, f) : (f = $a340872f7a7f928e$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a340872f7a7f928e$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a340872f7a7f928e$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a340872f7a7f928e$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a340872f7a7f928e$var$qj(a, b) {
    b = $a340872f7a7f928e$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a340872f7a7f928e$var$sj(a, b, c, d) {
    null !== d && $a340872f7a7f928e$var$Jg(d);
    $a340872f7a7f928e$var$Ug(b, a.child, null, c);
    a = $a340872f7a7f928e$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a340872f7a7f928e$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a340872f7a7f928e$var$Ki(Error($a340872f7a7f928e$var$p(422))), $a340872f7a7f928e$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a340872f7a7f928e$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a340872f7a7f928e$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a340872f7a7f928e$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $a340872f7a7f928e$var$nj(g);
        b.memoizedState = $a340872f7a7f928e$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a340872f7a7f928e$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a340872f7a7f928e$var$p(419));
        d = $a340872f7a7f928e$var$Ki(f, d, void 0);
        return $a340872f7a7f928e$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a340872f7a7f928e$var$dh || h) {
        d = $a340872f7a7f928e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a340872f7a7f928e$var$ih(a, e), $a340872f7a7f928e$var$gi(d, a, e, -1));
        }
        $a340872f7a7f928e$var$tj();
        d = $a340872f7a7f928e$var$Ki(Error($a340872f7a7f928e$var$p(421)));
        return $a340872f7a7f928e$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a340872f7a7f928e$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$Lf(e.nextSibling);
    $a340872f7a7f928e$var$xg = b;
    $a340872f7a7f928e$var$I = !0;
    $a340872f7a7f928e$var$zg = null;
    null !== a && ($a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$rg, $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$sg, $a340872f7a7f928e$var$og[$a340872f7a7f928e$var$pg++] = $a340872f7a7f928e$var$qg, $a340872f7a7f928e$var$rg = a.id, $a340872f7a7f928e$var$sg = a.overflow, $a340872f7a7f928e$var$qg = b);
    b = $a340872f7a7f928e$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a340872f7a7f928e$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a340872f7a7f928e$var$bh(a.return, b, c);
}
function $a340872f7a7f928e$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a340872f7a7f928e$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a340872f7a7f928e$var$Xi(a, b, d.children, c);
    d = $a340872f7a7f928e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a340872f7a7f928e$var$vj(a, c, b);
            else if (19 === a.tag) $a340872f7a7f928e$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a340872f7a7f928e$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a340872f7a7f928e$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a340872f7a7f928e$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a340872f7a7f928e$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $a340872f7a7f928e$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a340872f7a7f928e$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a340872f7a7f928e$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a340872f7a7f928e$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a340872f7a7f928e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a340872f7a7f928e$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a340872f7a7f928e$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a340872f7a7f928e$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $a340872f7a7f928e$var$kj(b);
            $a340872f7a7f928e$var$Ig();
            break;
        case 5:
            $a340872f7a7f928e$var$Ah(b);
            break;
        case 1:
            $a340872f7a7f928e$var$Zf(b.type) && $a340872f7a7f928e$var$cg(b);
            break;
        case 4:
            $a340872f7a7f928e$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a340872f7a7f928e$var$G($a340872f7a7f928e$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, $a340872f7a7f928e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a340872f7a7f928e$var$oj(a, b, c);
                $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, $a340872f7a7f928e$var$L.current & 1);
                a = $a340872f7a7f928e$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, $a340872f7a7f928e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a340872f7a7f928e$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, $a340872f7a7f928e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a340872f7a7f928e$var$dj(a, b, c);
    }
    return $a340872f7a7f928e$var$Zi(a, b, c);
}
var $a340872f7a7f928e$var$zj, $a340872f7a7f928e$var$Aj, $a340872f7a7f928e$var$Bj, $a340872f7a7f928e$var$Cj;
$a340872f7a7f928e$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a340872f7a7f928e$var$Aj = function() {};
$a340872f7a7f928e$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a340872f7a7f928e$var$Ya(a, e);
                d = $a340872f7a7f928e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a340872f7a7f928e$var$A({}, e, {
                    value: void 0
                });
                d = $a340872f7a7f928e$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a340872f7a7f928e$var$gb(a, e);
                d = $a340872f7a7f928e$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a340872f7a7f928e$var$Bf);
        }
        $a340872f7a7f928e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a340872f7a7f928e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a340872f7a7f928e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a340872f7a7f928e$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a340872f7a7f928e$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a340872f7a7f928e$var$Dj(a, b) {
    if (!$a340872f7a7f928e$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a340872f7a7f928e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a340872f7a7f928e$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $a340872f7a7f928e$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a340872f7a7f928e$var$S(b), null;
        case 1:
            return $a340872f7a7f928e$var$Zf(b.type) && $a340872f7a7f928e$var$$f(), $a340872f7a7f928e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a340872f7a7f928e$var$zh();
            $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf);
            $a340872f7a7f928e$var$E($a340872f7a7f928e$var$H);
            $a340872f7a7f928e$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a340872f7a7f928e$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a340872f7a7f928e$var$zg && ($a340872f7a7f928e$var$Fj($a340872f7a7f928e$var$zg), $a340872f7a7f928e$var$zg = null));
            $a340872f7a7f928e$var$Aj(a, b);
            $a340872f7a7f928e$var$S(b);
            return null;
        case 5:
            $a340872f7a7f928e$var$Bh(b);
            var e = $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a340872f7a7f928e$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a340872f7a7f928e$var$p(166));
                    $a340872f7a7f928e$var$S(b);
                    return null;
                }
                a = $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$uh.current);
                if ($a340872f7a7f928e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a340872f7a7f928e$var$Of] = b;
                    d[$a340872f7a7f928e$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a340872f7a7f928e$var$D("cancel", d);
                            $a340872f7a7f928e$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a340872f7a7f928e$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a340872f7a7f928e$var$lf.length; e++)$a340872f7a7f928e$var$D($a340872f7a7f928e$var$lf[e], d);
                            break;
                        case "source":
                            $a340872f7a7f928e$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a340872f7a7f928e$var$D("error", d);
                            $a340872f7a7f928e$var$D("load", d);
                            break;
                        case "details":
                            $a340872f7a7f928e$var$D("toggle", d);
                            break;
                        case "input":
                            $a340872f7a7f928e$var$Za(d, f);
                            $a340872f7a7f928e$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a340872f7a7f928e$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a340872f7a7f928e$var$hb(d, f), $a340872f7a7f928e$var$D("invalid", d);
                    }
                    $a340872f7a7f928e$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a340872f7a7f928e$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a340872f7a7f928e$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a340872f7a7f928e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a340872f7a7f928e$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a340872f7a7f928e$var$Va(d);
                            $a340872f7a7f928e$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a340872f7a7f928e$var$Va(d);
                            $a340872f7a7f928e$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a340872f7a7f928e$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a340872f7a7f928e$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a340872f7a7f928e$var$Of] = b;
                    a[$a340872f7a7f928e$var$Pf] = d;
                    $a340872f7a7f928e$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a340872f7a7f928e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a340872f7a7f928e$var$D("cancel", a);
                                $a340872f7a7f928e$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a340872f7a7f928e$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a340872f7a7f928e$var$lf.length; e++)$a340872f7a7f928e$var$D($a340872f7a7f928e$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a340872f7a7f928e$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a340872f7a7f928e$var$D("error", a);
                                $a340872f7a7f928e$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a340872f7a7f928e$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a340872f7a7f928e$var$Za(a, d);
                                e = $a340872f7a7f928e$var$Ya(a, d);
                                $a340872f7a7f928e$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a340872f7a7f928e$var$A({}, d, {
                                    value: void 0
                                });
                                $a340872f7a7f928e$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a340872f7a7f928e$var$hb(a, d);
                                e = $a340872f7a7f928e$var$gb(a, d);
                                $a340872f7a7f928e$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a340872f7a7f928e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a340872f7a7f928e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a340872f7a7f928e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a340872f7a7f928e$var$ob(a, k) : "number" === typeof k && $a340872f7a7f928e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a340872f7a7f928e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a340872f7a7f928e$var$D("scroll", a) : null != k && $a340872f7a7f928e$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a340872f7a7f928e$var$Va(a);
                                $a340872f7a7f928e$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a340872f7a7f928e$var$Va(a);
                                $a340872f7a7f928e$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a340872f7a7f928e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a340872f7a7f928e$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a340872f7a7f928e$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a340872f7a7f928e$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a340872f7a7f928e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a340872f7a7f928e$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a340872f7a7f928e$var$p(166));
                c = $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$wh.current);
                $a340872f7a7f928e$var$xh($a340872f7a7f928e$var$uh.current);
                if ($a340872f7a7f928e$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a340872f7a7f928e$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a340872f7a7f928e$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a340872f7a7f928e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a340872f7a7f928e$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a340872f7a7f928e$var$Of] = b, b.stateNode = d;
            }
            $a340872f7a7f928e$var$S(b);
            return null;
        case 13:
            $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a340872f7a7f928e$var$I && null !== $a340872f7a7f928e$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a340872f7a7f928e$var$Hg(), $a340872f7a7f928e$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a340872f7a7f928e$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a340872f7a7f928e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a340872f7a7f928e$var$p(317));
                        f[$a340872f7a7f928e$var$Of] = b;
                    } else $a340872f7a7f928e$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a340872f7a7f928e$var$S(b);
                    f = !1;
                } else null !== $a340872f7a7f928e$var$zg && ($a340872f7a7f928e$var$Fj($a340872f7a7f928e$var$zg), $a340872f7a7f928e$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a340872f7a7f928e$var$L.current & 1) ? 0 === $a340872f7a7f928e$var$T && ($a340872f7a7f928e$var$T = 3) : $a340872f7a7f928e$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a340872f7a7f928e$var$S(b);
            return null;
        case 4:
            return $a340872f7a7f928e$var$zh(), $a340872f7a7f928e$var$Aj(a, b), null === a && $a340872f7a7f928e$var$sf(b.stateNode.containerInfo), $a340872f7a7f928e$var$S(b), null;
        case 10:
            return $a340872f7a7f928e$var$ah(b.type._context), $a340872f7a7f928e$var$S(b), null;
        case 17:
            return $a340872f7a7f928e$var$Zf(b.type) && $a340872f7a7f928e$var$$f(), $a340872f7a7f928e$var$S(b), null;
        case 19:
            $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L);
            f = b.memoizedState;
            if (null === f) return $a340872f7a7f928e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a340872f7a7f928e$var$Dj(f, !1);
                else {
                    if (0 !== $a340872f7a7f928e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a340872f7a7f928e$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a340872f7a7f928e$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, $a340872f7a7f928e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a340872f7a7f928e$var$B() > $a340872f7a7f928e$var$Gj && (b.flags |= 128, d = !0, $a340872f7a7f928e$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a340872f7a7f928e$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a340872f7a7f928e$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a340872f7a7f928e$var$I) return $a340872f7a7f928e$var$S(b), null;
                    } else 2 * $a340872f7a7f928e$var$B() - f.renderingStartTime > $a340872f7a7f928e$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $a340872f7a7f928e$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a340872f7a7f928e$var$B(), b.sibling = null, c = $a340872f7a7f928e$var$L.current, $a340872f7a7f928e$var$G($a340872f7a7f928e$var$L, d ? c & 1 | 2 : c & 1), b;
            $a340872f7a7f928e$var$S(b);
            return null;
        case 22:
        case 23:
            return $a340872f7a7f928e$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a340872f7a7f928e$var$fj & 1073741824) && ($a340872f7a7f928e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a340872f7a7f928e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a340872f7a7f928e$var$p(156, b.tag));
}
function $a340872f7a7f928e$var$Ij(a, b) {
    $a340872f7a7f928e$var$wg(b);
    switch(b.tag){
        case 1:
            return $a340872f7a7f928e$var$Zf(b.type) && $a340872f7a7f928e$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a340872f7a7f928e$var$zh(), $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf), $a340872f7a7f928e$var$E($a340872f7a7f928e$var$H), $a340872f7a7f928e$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a340872f7a7f928e$var$Bh(b), null;
        case 13:
            $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a340872f7a7f928e$var$p(340));
                $a340872f7a7f928e$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L), null;
        case 4:
            return $a340872f7a7f928e$var$zh(), null;
        case 10:
            return $a340872f7a7f928e$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $a340872f7a7f928e$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a340872f7a7f928e$var$Jj = !1, $a340872f7a7f928e$var$U = !1, $a340872f7a7f928e$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $a340872f7a7f928e$var$V = null;
function $a340872f7a7f928e$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a340872f7a7f928e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a340872f7a7f928e$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a340872f7a7f928e$var$W(a, b, d);
    }
}
var $a340872f7a7f928e$var$Nj = !1;
function $a340872f7a7f928e$var$Oj(a, b) {
    $a340872f7a7f928e$var$Cf = $a340872f7a7f928e$var$dd;
    a = $a340872f7a7f928e$var$Me();
    if ($a340872f7a7f928e$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a340872f7a7f928e$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a340872f7a7f928e$var$dd = !1;
    for($a340872f7a7f928e$var$V = b; null !== $a340872f7a7f928e$var$V;)if (b = $a340872f7a7f928e$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a340872f7a7f928e$var$V = a;
    else for(; null !== $a340872f7a7f928e$var$V;){
        b = $a340872f7a7f928e$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a340872f7a7f928e$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a340872f7a7f928e$var$p(163));
            }
        } catch (F) {
            $a340872f7a7f928e$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a340872f7a7f928e$var$V = a;
            break;
        }
        $a340872f7a7f928e$var$V = b.return;
    }
    n = $a340872f7a7f928e$var$Nj;
    $a340872f7a7f928e$var$Nj = !1;
    return n;
}
function $a340872f7a7f928e$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a340872f7a7f928e$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a340872f7a7f928e$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a340872f7a7f928e$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a340872f7a7f928e$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a340872f7a7f928e$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a340872f7a7f928e$var$Of], delete b[$a340872f7a7f928e$var$Pf], delete b[$a340872f7a7f928e$var$of], delete b[$a340872f7a7f928e$var$Qf], delete b[$a340872f7a7f928e$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a340872f7a7f928e$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a340872f7a7f928e$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a340872f7a7f928e$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a340872f7a7f928e$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a340872f7a7f928e$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a340872f7a7f928e$var$Vj(a, b, c), a = a.sibling; null !== a;)$a340872f7a7f928e$var$Vj(a, b, c), a = a.sibling;
}
function $a340872f7a7f928e$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a340872f7a7f928e$var$Wj(a, b, c), a = a.sibling; null !== a;)$a340872f7a7f928e$var$Wj(a, b, c), a = a.sibling;
}
var $a340872f7a7f928e$var$X = null, $a340872f7a7f928e$var$Xj = !1;
function $a340872f7a7f928e$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$a340872f7a7f928e$var$Zj(a, b, c), c = c.sibling;
}
function $a340872f7a7f928e$var$Zj(a, b, c) {
    if ($a340872f7a7f928e$var$lc && "function" === typeof $a340872f7a7f928e$var$lc.onCommitFiberUnmount) try {
        $a340872f7a7f928e$var$lc.onCommitFiberUnmount($a340872f7a7f928e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a340872f7a7f928e$var$U || $a340872f7a7f928e$var$Lj(c, b);
        case 6:
            var d = $a340872f7a7f928e$var$X, e = $a340872f7a7f928e$var$Xj;
            $a340872f7a7f928e$var$X = null;
            $a340872f7a7f928e$var$Yj(a, b, c);
            $a340872f7a7f928e$var$X = d;
            $a340872f7a7f928e$var$Xj = e;
            null !== $a340872f7a7f928e$var$X && ($a340872f7a7f928e$var$Xj ? (a = $a340872f7a7f928e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a340872f7a7f928e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a340872f7a7f928e$var$X && ($a340872f7a7f928e$var$Xj ? (a = $a340872f7a7f928e$var$X, c = c.stateNode, 8 === a.nodeType ? $a340872f7a7f928e$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a340872f7a7f928e$var$Kf(a, c), $a340872f7a7f928e$var$bd(a)) : $a340872f7a7f928e$var$Kf($a340872f7a7f928e$var$X, c.stateNode));
            break;
        case 4:
            d = $a340872f7a7f928e$var$X;
            e = $a340872f7a7f928e$var$Xj;
            $a340872f7a7f928e$var$X = c.stateNode.containerInfo;
            $a340872f7a7f928e$var$Xj = !0;
            $a340872f7a7f928e$var$Yj(a, b, c);
            $a340872f7a7f928e$var$X = d;
            $a340872f7a7f928e$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a340872f7a7f928e$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a340872f7a7f928e$var$Mj(c, b, g) : 0 !== (f & 4) && $a340872f7a7f928e$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a340872f7a7f928e$var$Yj(a, b, c);
            break;
        case 1:
            if (!$a340872f7a7f928e$var$U && ($a340872f7a7f928e$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a340872f7a7f928e$var$W(c, b, h);
            }
            $a340872f7a7f928e$var$Yj(a, b, c);
            break;
        case 21:
            $a340872f7a7f928e$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a340872f7a7f928e$var$U = (d = $a340872f7a7f928e$var$U) || null !== c.memoizedState, $a340872f7a7f928e$var$Yj(a, b, c), $a340872f7a7f928e$var$U = d) : $a340872f7a7f928e$var$Yj(a, b, c);
            break;
        default:
            $a340872f7a7f928e$var$Yj(a, b, c);
    }
}
function $a340872f7a7f928e$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a340872f7a7f928e$var$Kj);
        b.forEach(function(b) {
            var d = $a340872f7a7f928e$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a340872f7a7f928e$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a340872f7a7f928e$var$X = h.stateNode;
                        $a340872f7a7f928e$var$Xj = !1;
                        break a;
                    case 3:
                        $a340872f7a7f928e$var$X = h.stateNode.containerInfo;
                        $a340872f7a7f928e$var$Xj = !0;
                        break a;
                    case 4:
                        $a340872f7a7f928e$var$X = h.stateNode.containerInfo;
                        $a340872f7a7f928e$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a340872f7a7f928e$var$X) throw Error($a340872f7a7f928e$var$p(160));
            $a340872f7a7f928e$var$Zj(f, g, e);
            $a340872f7a7f928e$var$X = null;
            $a340872f7a7f928e$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a340872f7a7f928e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a340872f7a7f928e$var$dk(b, a), b = b.sibling;
}
function $a340872f7a7f928e$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            if (d & 4) {
                try {
                    $a340872f7a7f928e$var$Pj(3, a, a.return), $a340872f7a7f928e$var$Qj(3, a);
                } catch (t) {
                    $a340872f7a7f928e$var$W(a, a.return, t);
                }
                try {
                    $a340872f7a7f928e$var$Pj(5, a, a.return);
                } catch (t) {
                    $a340872f7a7f928e$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            d & 512 && null !== c && $a340872f7a7f928e$var$Lj(c, c.return);
            break;
        case 5:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            d & 512 && null !== c && $a340872f7a7f928e$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a340872f7a7f928e$var$ob(e, "");
                } catch (t) {
                    $a340872f7a7f928e$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a340872f7a7f928e$var$ab(e, f);
                    $a340872f7a7f928e$var$vb(h, g);
                    var l = $a340872f7a7f928e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a340872f7a7f928e$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a340872f7a7f928e$var$nb(e, q) : "children" === m ? $a340872f7a7f928e$var$ob(e, q) : $a340872f7a7f928e$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a340872f7a7f928e$var$bb(e, f);
                            break;
                        case "textarea":
                            $a340872f7a7f928e$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a340872f7a7f928e$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a340872f7a7f928e$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a340872f7a7f928e$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a340872f7a7f928e$var$Pf] = f;
                } catch (t) {
                    $a340872f7a7f928e$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a340872f7a7f928e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a340872f7a7f928e$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a340872f7a7f928e$var$bd(b.containerInfo);
            } catch (t) {
                $a340872f7a7f928e$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            break;
        case 13:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a340872f7a7f928e$var$fk = $a340872f7a7f928e$var$B()));
            d & 4 && $a340872f7a7f928e$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a340872f7a7f928e$var$U = (l = $a340872f7a7f928e$var$U) || m, $a340872f7a7f928e$var$ck(b, a), $a340872f7a7f928e$var$U = l) : $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a340872f7a7f928e$var$V = a, m = a.child; null !== m;){
                    for(q = $a340872f7a7f928e$var$V = m; null !== $a340872f7a7f928e$var$V;){
                        r = $a340872f7a7f928e$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a340872f7a7f928e$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $a340872f7a7f928e$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a340872f7a7f928e$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a340872f7a7f928e$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a340872f7a7f928e$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a340872f7a7f928e$var$V = y) : $a340872f7a7f928e$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a340872f7a7f928e$var$rb("display", g));
                            } catch (t) {
                                $a340872f7a7f928e$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a340872f7a7f928e$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a340872f7a7f928e$var$ck(b, a);
            $a340872f7a7f928e$var$ek(a);
            d & 4 && $a340872f7a7f928e$var$ak(a);
            break;
        case 21:
            break;
        default:
            $a340872f7a7f928e$var$ck(b, a), $a340872f7a7f928e$var$ek(a);
    }
}
function $a340872f7a7f928e$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a340872f7a7f928e$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a340872f7a7f928e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a340872f7a7f928e$var$ob(e, ""), d.flags &= -33);
                    var f = $a340872f7a7f928e$var$Uj(a);
                    $a340872f7a7f928e$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a340872f7a7f928e$var$Uj(a);
                    $a340872f7a7f928e$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($a340872f7a7f928e$var$p(161));
            }
        } catch (k) {
            $a340872f7a7f928e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a340872f7a7f928e$var$hk(a, b, c) {
    $a340872f7a7f928e$var$V = a;
    $a340872f7a7f928e$var$ik(a, b, c);
}
function $a340872f7a7f928e$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a340872f7a7f928e$var$V;){
        var e = $a340872f7a7f928e$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a340872f7a7f928e$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a340872f7a7f928e$var$U;
                h = $a340872f7a7f928e$var$Jj;
                var l = $a340872f7a7f928e$var$U;
                $a340872f7a7f928e$var$Jj = g;
                if (($a340872f7a7f928e$var$U = k) && !l) for($a340872f7a7f928e$var$V = e; null !== $a340872f7a7f928e$var$V;)g = $a340872f7a7f928e$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a340872f7a7f928e$var$jk(e) : null !== k ? (k.return = g, $a340872f7a7f928e$var$V = k) : $a340872f7a7f928e$var$jk(e);
                for(; null !== f;)$a340872f7a7f928e$var$V = f, $a340872f7a7f928e$var$ik(f, b, c), f = f.sibling;
                $a340872f7a7f928e$var$V = e;
                $a340872f7a7f928e$var$Jj = h;
                $a340872f7a7f928e$var$U = l;
            }
            $a340872f7a7f928e$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a340872f7a7f928e$var$V = f) : $a340872f7a7f928e$var$kk(a, b, c);
    }
}
function $a340872f7a7f928e$var$kk(a) {
    for(; null !== $a340872f7a7f928e$var$V;){
        var b = $a340872f7a7f928e$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a340872f7a7f928e$var$U || $a340872f7a7f928e$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a340872f7a7f928e$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a340872f7a7f928e$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a340872f7a7f928e$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a340872f7a7f928e$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a340872f7a7f928e$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a340872f7a7f928e$var$p(163));
                }
                $a340872f7a7f928e$var$U || b.flags & 512 && $a340872f7a7f928e$var$Rj(b);
            } catch (r) {
                $a340872f7a7f928e$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a340872f7a7f928e$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a340872f7a7f928e$var$V = c;
            break;
        }
        $a340872f7a7f928e$var$V = b.return;
    }
}
function $a340872f7a7f928e$var$gk(a) {
    for(; null !== $a340872f7a7f928e$var$V;){
        var b = $a340872f7a7f928e$var$V;
        if (b === a) {
            $a340872f7a7f928e$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a340872f7a7f928e$var$V = c;
            break;
        }
        $a340872f7a7f928e$var$V = b.return;
    }
}
function $a340872f7a7f928e$var$jk(a) {
    for(; null !== $a340872f7a7f928e$var$V;){
        var b = $a340872f7a7f928e$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a340872f7a7f928e$var$Qj(4, b);
                    } catch (k) {
                        $a340872f7a7f928e$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a340872f7a7f928e$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a340872f7a7f928e$var$Rj(b);
                    } catch (k) {
                        $a340872f7a7f928e$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a340872f7a7f928e$var$Rj(b);
                    } catch (k) {
                        $a340872f7a7f928e$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a340872f7a7f928e$var$W(b, b.return, k);
        }
        if (b === a) {
            $a340872f7a7f928e$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a340872f7a7f928e$var$V = h;
            break;
        }
        $a340872f7a7f928e$var$V = b.return;
    }
}
var $a340872f7a7f928e$var$lk = Math.ceil, $a340872f7a7f928e$var$mk = $a340872f7a7f928e$var$ua.ReactCurrentDispatcher, $a340872f7a7f928e$var$nk = $a340872f7a7f928e$var$ua.ReactCurrentOwner, $a340872f7a7f928e$var$ok = $a340872f7a7f928e$var$ua.ReactCurrentBatchConfig, $a340872f7a7f928e$var$K = 0, $a340872f7a7f928e$var$Q = null, $a340872f7a7f928e$var$Y = null, $a340872f7a7f928e$var$Z = 0, $a340872f7a7f928e$var$fj = 0, $a340872f7a7f928e$var$ej = $a340872f7a7f928e$var$Uf(0), $a340872f7a7f928e$var$T = 0, $a340872f7a7f928e$var$pk = null, $a340872f7a7f928e$var$rh = 0, $a340872f7a7f928e$var$qk = 0, $a340872f7a7f928e$var$rk = 0, $a340872f7a7f928e$var$sk = null, $a340872f7a7f928e$var$tk = null, $a340872f7a7f928e$var$fk = 0, $a340872f7a7f928e$var$Gj = Infinity, $a340872f7a7f928e$var$uk = null, $a340872f7a7f928e$var$Oi = !1, $a340872f7a7f928e$var$Pi = null, $a340872f7a7f928e$var$Ri = null, $a340872f7a7f928e$var$vk = !1, $a340872f7a7f928e$var$wk = null, $a340872f7a7f928e$var$xk = 0, $a340872f7a7f928e$var$yk = 0, $a340872f7a7f928e$var$zk = null, $a340872f7a7f928e$var$Ak = -1, $a340872f7a7f928e$var$Bk = 0;
function $a340872f7a7f928e$var$R() {
    return 0 !== ($a340872f7a7f928e$var$K & 6) ? $a340872f7a7f928e$var$B() : -1 !== $a340872f7a7f928e$var$Ak ? $a340872f7a7f928e$var$Ak : $a340872f7a7f928e$var$Ak = $a340872f7a7f928e$var$B();
}
function $a340872f7a7f928e$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a340872f7a7f928e$var$K & 2) && 0 !== $a340872f7a7f928e$var$Z) return $a340872f7a7f928e$var$Z & -$a340872f7a7f928e$var$Z;
    if (null !== $a340872f7a7f928e$var$Kg.transition) return 0 === $a340872f7a7f928e$var$Bk && ($a340872f7a7f928e$var$Bk = $a340872f7a7f928e$var$yc()), $a340872f7a7f928e$var$Bk;
    a = $a340872f7a7f928e$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a340872f7a7f928e$var$jd(a.type);
    return a;
}
function $a340872f7a7f928e$var$gi(a, b, c, d) {
    if (50 < $a340872f7a7f928e$var$yk) throw $a340872f7a7f928e$var$yk = 0, $a340872f7a7f928e$var$zk = null, Error($a340872f7a7f928e$var$p(185));
    $a340872f7a7f928e$var$Ac(a, c, d);
    if (0 === ($a340872f7a7f928e$var$K & 2) || a !== $a340872f7a7f928e$var$Q) a === $a340872f7a7f928e$var$Q && (0 === ($a340872f7a7f928e$var$K & 2) && ($a340872f7a7f928e$var$qk |= c), 4 === $a340872f7a7f928e$var$T && $a340872f7a7f928e$var$Ck(a, $a340872f7a7f928e$var$Z)), $a340872f7a7f928e$var$Dk(a, d), 1 === c && 0 === $a340872f7a7f928e$var$K && 0 === (b.mode & 1) && ($a340872f7a7f928e$var$Gj = $a340872f7a7f928e$var$B() + 500, $a340872f7a7f928e$var$fg && $a340872f7a7f928e$var$jg());
}
function $a340872f7a7f928e$var$Dk(a, b) {
    var c = a.callbackNode;
    $a340872f7a7f928e$var$wc(a, b);
    var d = $a340872f7a7f928e$var$uc(a, a === $a340872f7a7f928e$var$Q ? $a340872f7a7f928e$var$Z : 0);
    if (0 === d) null !== c && $a340872f7a7f928e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a340872f7a7f928e$var$bc(c);
        if (1 === b) 0 === a.tag ? $a340872f7a7f928e$var$ig($a340872f7a7f928e$var$Ek.bind(null, a)) : $a340872f7a7f928e$var$hg($a340872f7a7f928e$var$Ek.bind(null, a)), $a340872f7a7f928e$var$Jf(function() {
            0 === ($a340872f7a7f928e$var$K & 6) && $a340872f7a7f928e$var$jg();
        }), c = null;
        else {
            switch($a340872f7a7f928e$var$Dc(d)){
                case 1:
                    c = $a340872f7a7f928e$var$fc;
                    break;
                case 4:
                    c = $a340872f7a7f928e$var$gc;
                    break;
                case 16:
                    c = $a340872f7a7f928e$var$hc;
                    break;
                case 536870912:
                    c = $a340872f7a7f928e$var$jc;
                    break;
                default:
                    c = $a340872f7a7f928e$var$hc;
            }
            c = $a340872f7a7f928e$var$Fk(c, $a340872f7a7f928e$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a340872f7a7f928e$var$Gk(a, b) {
    $a340872f7a7f928e$var$Ak = -1;
    $a340872f7a7f928e$var$Bk = 0;
    if (0 !== ($a340872f7a7f928e$var$K & 6)) throw Error($a340872f7a7f928e$var$p(327));
    var c = a.callbackNode;
    if ($a340872f7a7f928e$var$Hk() && a.callbackNode !== c) return null;
    var d = $a340872f7a7f928e$var$uc(a, a === $a340872f7a7f928e$var$Q ? $a340872f7a7f928e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a340872f7a7f928e$var$Ik(a, d);
    else {
        b = d;
        var e = $a340872f7a7f928e$var$K;
        $a340872f7a7f928e$var$K |= 2;
        var f = $a340872f7a7f928e$var$Jk();
        if ($a340872f7a7f928e$var$Q !== a || $a340872f7a7f928e$var$Z !== b) $a340872f7a7f928e$var$uk = null, $a340872f7a7f928e$var$Gj = $a340872f7a7f928e$var$B() + 500, $a340872f7a7f928e$var$Kk(a, b);
        for(;;)try {
            $a340872f7a7f928e$var$Lk();
            break;
        } catch (h) {
            $a340872f7a7f928e$var$Mk(a, h);
        }
        $a340872f7a7f928e$var$$g();
        $a340872f7a7f928e$var$mk.current = f;
        $a340872f7a7f928e$var$K = e;
        null !== $a340872f7a7f928e$var$Y ? b = 0 : ($a340872f7a7f928e$var$Q = null, $a340872f7a7f928e$var$Z = 0, b = $a340872f7a7f928e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a340872f7a7f928e$var$xc(a), 0 !== e && (d = e, b = $a340872f7a7f928e$var$Nk(a, e)));
        if (1 === b) throw c = $a340872f7a7f928e$var$pk, $a340872f7a7f928e$var$Kk(a, 0), $a340872f7a7f928e$var$Ck(a, d), $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B()), c;
        if (6 === b) $a340872f7a7f928e$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a340872f7a7f928e$var$Ok(e) && (b = $a340872f7a7f928e$var$Ik(a, d), 2 === b && (f = $a340872f7a7f928e$var$xc(a), 0 !== f && (d = f, b = $a340872f7a7f928e$var$Nk(a, f))), 1 === b)) throw c = $a340872f7a7f928e$var$pk, $a340872f7a7f928e$var$Kk(a, 0), $a340872f7a7f928e$var$Ck(a, d), $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a340872f7a7f928e$var$p(345));
                case 2:
                    $a340872f7a7f928e$var$Pk(a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk);
                    break;
                case 3:
                    $a340872f7a7f928e$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $a340872f7a7f928e$var$fk + 500 - $a340872f7a7f928e$var$B(), 10 < b)) {
                        if (0 !== $a340872f7a7f928e$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a340872f7a7f928e$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a340872f7a7f928e$var$Ff($a340872f7a7f928e$var$Pk.bind(null, a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk), b);
                        break;
                    }
                    $a340872f7a7f928e$var$Pk(a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk);
                    break;
                case 4:
                    $a340872f7a7f928e$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a340872f7a7f928e$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a340872f7a7f928e$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a340872f7a7f928e$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a340872f7a7f928e$var$Ff($a340872f7a7f928e$var$Pk.bind(null, a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk), d);
                        break;
                    }
                    $a340872f7a7f928e$var$Pk(a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk);
                    break;
                case 5:
                    $a340872f7a7f928e$var$Pk(a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk);
                    break;
                default:
                    throw Error($a340872f7a7f928e$var$p(329));
            }
        }
    }
    $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B());
    return a.callbackNode === c ? $a340872f7a7f928e$var$Gk.bind(null, a) : null;
}
function $a340872f7a7f928e$var$Nk(a, b) {
    var c = $a340872f7a7f928e$var$sk;
    a.current.memoizedState.isDehydrated && ($a340872f7a7f928e$var$Kk(a, b).flags |= 256);
    a = $a340872f7a7f928e$var$Ik(a, b);
    2 !== a && (b = $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$tk = c, null !== b && $a340872f7a7f928e$var$Fj(b));
    return a;
}
function $a340872f7a7f928e$var$Fj(a) {
    null === $a340872f7a7f928e$var$tk ? $a340872f7a7f928e$var$tk = a : $a340872f7a7f928e$var$tk.push.apply($a340872f7a7f928e$var$tk, a);
}
function $a340872f7a7f928e$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a340872f7a7f928e$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a340872f7a7f928e$var$Ck(a, b) {
    b &= ~$a340872f7a7f928e$var$rk;
    b &= ~$a340872f7a7f928e$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a340872f7a7f928e$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a340872f7a7f928e$var$Ek(a) {
    if (0 !== ($a340872f7a7f928e$var$K & 6)) throw Error($a340872f7a7f928e$var$p(327));
    $a340872f7a7f928e$var$Hk();
    var b = $a340872f7a7f928e$var$uc(a, 0);
    if (0 === (b & 1)) return $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B()), null;
    var c = $a340872f7a7f928e$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a340872f7a7f928e$var$xc(a);
        0 !== d && (b = d, c = $a340872f7a7f928e$var$Nk(a, d));
    }
    if (1 === c) throw c = $a340872f7a7f928e$var$pk, $a340872f7a7f928e$var$Kk(a, 0), $a340872f7a7f928e$var$Ck(a, b), $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B()), c;
    if (6 === c) throw Error($a340872f7a7f928e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a340872f7a7f928e$var$Pk(a, $a340872f7a7f928e$var$tk, $a340872f7a7f928e$var$uk);
    $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B());
    return null;
}
function $a340872f7a7f928e$var$Qk(a, b) {
    var c = $a340872f7a7f928e$var$K;
    $a340872f7a7f928e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a340872f7a7f928e$var$K = c, 0 === $a340872f7a7f928e$var$K && ($a340872f7a7f928e$var$Gj = $a340872f7a7f928e$var$B() + 500, $a340872f7a7f928e$var$fg && $a340872f7a7f928e$var$jg());
    }
}
function $a340872f7a7f928e$var$Rk(a) {
    null !== $a340872f7a7f928e$var$wk && 0 === $a340872f7a7f928e$var$wk.tag && 0 === ($a340872f7a7f928e$var$K & 6) && $a340872f7a7f928e$var$Hk();
    var b = $a340872f7a7f928e$var$K;
    $a340872f7a7f928e$var$K |= 1;
    var c = $a340872f7a7f928e$var$ok.transition, d = $a340872f7a7f928e$var$C;
    try {
        if ($a340872f7a7f928e$var$ok.transition = null, $a340872f7a7f928e$var$C = 1, a) return a();
    } finally{
        $a340872f7a7f928e$var$C = d, $a340872f7a7f928e$var$ok.transition = c, $a340872f7a7f928e$var$K = b, 0 === ($a340872f7a7f928e$var$K & 6) && $a340872f7a7f928e$var$jg();
    }
}
function $a340872f7a7f928e$var$Hj() {
    $a340872f7a7f928e$var$fj = $a340872f7a7f928e$var$ej.current;
    $a340872f7a7f928e$var$E($a340872f7a7f928e$var$ej);
}
function $a340872f7a7f928e$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a340872f7a7f928e$var$Gf(c));
    if (null !== $a340872f7a7f928e$var$Y) for(c = $a340872f7a7f928e$var$Y.return; null !== c;){
        var d = c;
        $a340872f7a7f928e$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a340872f7a7f928e$var$$f();
                break;
            case 3:
                $a340872f7a7f928e$var$zh();
                $a340872f7a7f928e$var$E($a340872f7a7f928e$var$Wf);
                $a340872f7a7f928e$var$E($a340872f7a7f928e$var$H);
                $a340872f7a7f928e$var$Eh();
                break;
            case 5:
                $a340872f7a7f928e$var$Bh(d);
                break;
            case 4:
                $a340872f7a7f928e$var$zh();
                break;
            case 13:
                $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L);
                break;
            case 19:
                $a340872f7a7f928e$var$E($a340872f7a7f928e$var$L);
                break;
            case 10:
                $a340872f7a7f928e$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $a340872f7a7f928e$var$Hj();
        }
        c = c.return;
    }
    $a340872f7a7f928e$var$Q = a;
    $a340872f7a7f928e$var$Y = a = $a340872f7a7f928e$var$Pg(a.current, null);
    $a340872f7a7f928e$var$Z = $a340872f7a7f928e$var$fj = b;
    $a340872f7a7f928e$var$T = 0;
    $a340872f7a7f928e$var$pk = null;
    $a340872f7a7f928e$var$rk = $a340872f7a7f928e$var$qk = $a340872f7a7f928e$var$rh = 0;
    $a340872f7a7f928e$var$tk = $a340872f7a7f928e$var$sk = null;
    if (null !== $a340872f7a7f928e$var$fh) {
        for(b = 0; b < $a340872f7a7f928e$var$fh.length; b++)if (c = $a340872f7a7f928e$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a340872f7a7f928e$var$fh = null;
    }
    return a;
}
function $a340872f7a7f928e$var$Mk(a, b) {
    do {
        var c = $a340872f7a7f928e$var$Y;
        try {
            $a340872f7a7f928e$var$$g();
            $a340872f7a7f928e$var$Fh.current = $a340872f7a7f928e$var$Rh;
            if ($a340872f7a7f928e$var$Ih) {
                for(var d = $a340872f7a7f928e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a340872f7a7f928e$var$Ih = !1;
            }
            $a340872f7a7f928e$var$Hh = 0;
            $a340872f7a7f928e$var$O = $a340872f7a7f928e$var$N = $a340872f7a7f928e$var$M = null;
            $a340872f7a7f928e$var$Jh = !1;
            $a340872f7a7f928e$var$Kh = 0;
            $a340872f7a7f928e$var$nk.current = null;
            if (null === c || null === c.return) {
                $a340872f7a7f928e$var$T = 1;
                $a340872f7a7f928e$var$pk = b;
                $a340872f7a7f928e$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a340872f7a7f928e$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a340872f7a7f928e$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a340872f7a7f928e$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $a340872f7a7f928e$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a340872f7a7f928e$var$Si(f, l, b);
                            $a340872f7a7f928e$var$tj();
                            break a;
                        }
                        k = Error($a340872f7a7f928e$var$p(426));
                    }
                } else if ($a340872f7a7f928e$var$I && h.mode & 1) {
                    var J = $a340872f7a7f928e$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a340872f7a7f928e$var$Vi(J, g, h, f, b);
                        $a340872f7a7f928e$var$Jg($a340872f7a7f928e$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $a340872f7a7f928e$var$Ji(k, h);
                4 !== $a340872f7a7f928e$var$T && ($a340872f7a7f928e$var$T = 2);
                null === $a340872f7a7f928e$var$sk ? $a340872f7a7f928e$var$sk = [
                    f
                ] : $a340872f7a7f928e$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a340872f7a7f928e$var$Ni(f, k, b);
                            $a340872f7a7f928e$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a340872f7a7f928e$var$Ri || !$a340872f7a7f928e$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a340872f7a7f928e$var$Qi(f, h, b);
                                $a340872f7a7f928e$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a340872f7a7f928e$var$Sk(c);
        } catch (na) {
            b = na;
            $a340872f7a7f928e$var$Y === c && null !== c && ($a340872f7a7f928e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a340872f7a7f928e$var$Jk() {
    var a = $a340872f7a7f928e$var$mk.current;
    $a340872f7a7f928e$var$mk.current = $a340872f7a7f928e$var$Rh;
    return null === a ? $a340872f7a7f928e$var$Rh : a;
}
function $a340872f7a7f928e$var$tj() {
    if (0 === $a340872f7a7f928e$var$T || 3 === $a340872f7a7f928e$var$T || 2 === $a340872f7a7f928e$var$T) $a340872f7a7f928e$var$T = 4;
    null === $a340872f7a7f928e$var$Q || 0 === ($a340872f7a7f928e$var$rh & 268435455) && 0 === ($a340872f7a7f928e$var$qk & 268435455) || $a340872f7a7f928e$var$Ck($a340872f7a7f928e$var$Q, $a340872f7a7f928e$var$Z);
}
function $a340872f7a7f928e$var$Ik(a, b) {
    var c = $a340872f7a7f928e$var$K;
    $a340872f7a7f928e$var$K |= 2;
    var d = $a340872f7a7f928e$var$Jk();
    if ($a340872f7a7f928e$var$Q !== a || $a340872f7a7f928e$var$Z !== b) $a340872f7a7f928e$var$uk = null, $a340872f7a7f928e$var$Kk(a, b);
    for(;;)try {
        $a340872f7a7f928e$var$Tk();
        break;
    } catch (e) {
        $a340872f7a7f928e$var$Mk(a, e);
    }
    $a340872f7a7f928e$var$$g();
    $a340872f7a7f928e$var$K = c;
    $a340872f7a7f928e$var$mk.current = d;
    if (null !== $a340872f7a7f928e$var$Y) throw Error($a340872f7a7f928e$var$p(261));
    $a340872f7a7f928e$var$Q = null;
    $a340872f7a7f928e$var$Z = 0;
    return $a340872f7a7f928e$var$T;
}
function $a340872f7a7f928e$var$Tk() {
    for(; null !== $a340872f7a7f928e$var$Y;)$a340872f7a7f928e$var$Uk($a340872f7a7f928e$var$Y);
}
function $a340872f7a7f928e$var$Lk() {
    for(; null !== $a340872f7a7f928e$var$Y && !$a340872f7a7f928e$var$cc();)$a340872f7a7f928e$var$Uk($a340872f7a7f928e$var$Y);
}
function $a340872f7a7f928e$var$Uk(a) {
    var b = $a340872f7a7f928e$var$Vk(a.alternate, a, $a340872f7a7f928e$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a340872f7a7f928e$var$Sk(a) : $a340872f7a7f928e$var$Y = b;
    $a340872f7a7f928e$var$nk.current = null;
}
function $a340872f7a7f928e$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a340872f7a7f928e$var$Ej(c, b, $a340872f7a7f928e$var$fj), null !== c) {
                $a340872f7a7f928e$var$Y = c;
                return;
            }
        } else {
            c = $a340872f7a7f928e$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a340872f7a7f928e$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a340872f7a7f928e$var$T = 6;
                $a340872f7a7f928e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a340872f7a7f928e$var$Y = b;
            return;
        }
        $a340872f7a7f928e$var$Y = b = a;
    }while (null !== b);
    0 === $a340872f7a7f928e$var$T && ($a340872f7a7f928e$var$T = 5);
}
function $a340872f7a7f928e$var$Pk(a, b, c) {
    var d = $a340872f7a7f928e$var$C, e = $a340872f7a7f928e$var$ok.transition;
    try {
        $a340872f7a7f928e$var$ok.transition = null, $a340872f7a7f928e$var$C = 1, $a340872f7a7f928e$var$Wk(a, b, c, d);
    } finally{
        $a340872f7a7f928e$var$ok.transition = e, $a340872f7a7f928e$var$C = d;
    }
    return null;
}
function $a340872f7a7f928e$var$Wk(a, b, c, d) {
    do $a340872f7a7f928e$var$Hk();
    while (null !== $a340872f7a7f928e$var$wk);
    if (0 !== ($a340872f7a7f928e$var$K & 6)) throw Error($a340872f7a7f928e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a340872f7a7f928e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a340872f7a7f928e$var$Bc(a, f);
    a === $a340872f7a7f928e$var$Q && ($a340872f7a7f928e$var$Y = $a340872f7a7f928e$var$Q = null, $a340872f7a7f928e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a340872f7a7f928e$var$vk || ($a340872f7a7f928e$var$vk = !0, $a340872f7a7f928e$var$Fk($a340872f7a7f928e$var$hc, function() {
        $a340872f7a7f928e$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a340872f7a7f928e$var$ok.transition;
        $a340872f7a7f928e$var$ok.transition = null;
        var g = $a340872f7a7f928e$var$C;
        $a340872f7a7f928e$var$C = 1;
        var h = $a340872f7a7f928e$var$K;
        $a340872f7a7f928e$var$K |= 4;
        $a340872f7a7f928e$var$nk.current = null;
        $a340872f7a7f928e$var$Oj(a, c);
        $a340872f7a7f928e$var$dk(c, a);
        $a340872f7a7f928e$var$Oe($a340872f7a7f928e$var$Df);
        $a340872f7a7f928e$var$dd = !!$a340872f7a7f928e$var$Cf;
        $a340872f7a7f928e$var$Df = $a340872f7a7f928e$var$Cf = null;
        a.current = c;
        $a340872f7a7f928e$var$hk(c, a, e);
        $a340872f7a7f928e$var$dc();
        $a340872f7a7f928e$var$K = h;
        $a340872f7a7f928e$var$C = g;
        $a340872f7a7f928e$var$ok.transition = f;
    } else a.current = c;
    $a340872f7a7f928e$var$vk && ($a340872f7a7f928e$var$vk = !1, $a340872f7a7f928e$var$wk = a, $a340872f7a7f928e$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($a340872f7a7f928e$var$Ri = null);
    $a340872f7a7f928e$var$mc(c.stateNode, d);
    $a340872f7a7f928e$var$Dk(a, $a340872f7a7f928e$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a340872f7a7f928e$var$Oi) throw $a340872f7a7f928e$var$Oi = !1, a = $a340872f7a7f928e$var$Pi, $a340872f7a7f928e$var$Pi = null, a;
    0 !== ($a340872f7a7f928e$var$xk & 1) && 0 !== a.tag && $a340872f7a7f928e$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a340872f7a7f928e$var$zk ? $a340872f7a7f928e$var$yk++ : ($a340872f7a7f928e$var$yk = 0, $a340872f7a7f928e$var$zk = a) : $a340872f7a7f928e$var$yk = 0;
    $a340872f7a7f928e$var$jg();
    return null;
}
function $a340872f7a7f928e$var$Hk() {
    if (null !== $a340872f7a7f928e$var$wk) {
        var a = $a340872f7a7f928e$var$Dc($a340872f7a7f928e$var$xk), b = $a340872f7a7f928e$var$ok.transition, c = $a340872f7a7f928e$var$C;
        try {
            $a340872f7a7f928e$var$ok.transition = null;
            $a340872f7a7f928e$var$C = 16 > a ? 16 : a;
            if (null === $a340872f7a7f928e$var$wk) var d = !1;
            else {
                a = $a340872f7a7f928e$var$wk;
                $a340872f7a7f928e$var$wk = null;
                $a340872f7a7f928e$var$xk = 0;
                if (0 !== ($a340872f7a7f928e$var$K & 6)) throw Error($a340872f7a7f928e$var$p(331));
                var e = $a340872f7a7f928e$var$K;
                $a340872f7a7f928e$var$K |= 4;
                for($a340872f7a7f928e$var$V = a.current; null !== $a340872f7a7f928e$var$V;){
                    var f = $a340872f7a7f928e$var$V, g = f.child;
                    if (0 !== ($a340872f7a7f928e$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a340872f7a7f928e$var$V = l; null !== $a340872f7a7f928e$var$V;){
                                    var m = $a340872f7a7f928e$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a340872f7a7f928e$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a340872f7a7f928e$var$V = q;
                                    else for(; null !== $a340872f7a7f928e$var$V;){
                                        m = $a340872f7a7f928e$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a340872f7a7f928e$var$Sj(m);
                                        if (m === l) {
                                            $a340872f7a7f928e$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a340872f7a7f928e$var$V = r;
                                            break;
                                        }
                                        $a340872f7a7f928e$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a340872f7a7f928e$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a340872f7a7f928e$var$V = g;
                    else b: for(; null !== $a340872f7a7f928e$var$V;){
                        f = $a340872f7a7f928e$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a340872f7a7f928e$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a340872f7a7f928e$var$V = x;
                            break b;
                        }
                        $a340872f7a7f928e$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a340872f7a7f928e$var$V = w; null !== $a340872f7a7f928e$var$V;){
                    g = $a340872f7a7f928e$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a340872f7a7f928e$var$V = u;
                    else b: for(g = w; null !== $a340872f7a7f928e$var$V;){
                        h = $a340872f7a7f928e$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a340872f7a7f928e$var$Qj(9, h);
                            }
                        } catch (na) {
                            $a340872f7a7f928e$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a340872f7a7f928e$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a340872f7a7f928e$var$V = F;
                            break b;
                        }
                        $a340872f7a7f928e$var$V = h.return;
                    }
                }
                $a340872f7a7f928e$var$K = e;
                $a340872f7a7f928e$var$jg();
                if ($a340872f7a7f928e$var$lc && "function" === typeof $a340872f7a7f928e$var$lc.onPostCommitFiberRoot) try {
                    $a340872f7a7f928e$var$lc.onPostCommitFiberRoot($a340872f7a7f928e$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a340872f7a7f928e$var$C = c, $a340872f7a7f928e$var$ok.transition = b;
        }
    }
    return !1;
}
function $a340872f7a7f928e$var$Xk(a, b, c) {
    b = $a340872f7a7f928e$var$Ji(c, b);
    b = $a340872f7a7f928e$var$Ni(a, b, 1);
    a = $a340872f7a7f928e$var$nh(a, b, 1);
    b = $a340872f7a7f928e$var$R();
    null !== a && ($a340872f7a7f928e$var$Ac(a, 1, b), $a340872f7a7f928e$var$Dk(a, b));
}
function $a340872f7a7f928e$var$W(a, b, c) {
    if (3 === a.tag) $a340872f7a7f928e$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a340872f7a7f928e$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a340872f7a7f928e$var$Ri || !$a340872f7a7f928e$var$Ri.has(d))) {
                a = $a340872f7a7f928e$var$Ji(c, a);
                a = $a340872f7a7f928e$var$Qi(b, a, 1);
                b = $a340872f7a7f928e$var$nh(b, a, 1);
                a = $a340872f7a7f928e$var$R();
                null !== b && ($a340872f7a7f928e$var$Ac(b, 1, a), $a340872f7a7f928e$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a340872f7a7f928e$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a340872f7a7f928e$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $a340872f7a7f928e$var$Q === a && ($a340872f7a7f928e$var$Z & c) === c && (4 === $a340872f7a7f928e$var$T || 3 === $a340872f7a7f928e$var$T && ($a340872f7a7f928e$var$Z & 130023424) === $a340872f7a7f928e$var$Z && 500 > $a340872f7a7f928e$var$B() - $a340872f7a7f928e$var$fk ? $a340872f7a7f928e$var$Kk(a, 0) : $a340872f7a7f928e$var$rk |= c);
    $a340872f7a7f928e$var$Dk(a, b);
}
function $a340872f7a7f928e$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a340872f7a7f928e$var$sc, $a340872f7a7f928e$var$sc <<= 1, 0 === ($a340872f7a7f928e$var$sc & 130023424) && ($a340872f7a7f928e$var$sc = 4194304)));
    var c = $a340872f7a7f928e$var$R();
    a = $a340872f7a7f928e$var$ih(a, b);
    null !== a && ($a340872f7a7f928e$var$Ac(a, b, c), $a340872f7a7f928e$var$Dk(a, c));
}
function $a340872f7a7f928e$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a340872f7a7f928e$var$Yk(a, c);
}
function $a340872f7a7f928e$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a340872f7a7f928e$var$p(314));
    }
    null !== d && d.delete(b);
    $a340872f7a7f928e$var$Yk(a, c);
}
var $a340872f7a7f928e$var$Vk;
$a340872f7a7f928e$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a340872f7a7f928e$var$Wf.current) $a340872f7a7f928e$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a340872f7a7f928e$var$dh = !1, $a340872f7a7f928e$var$yj(a, b, c);
            $a340872f7a7f928e$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a340872f7a7f928e$var$dh = !1, $a340872f7a7f928e$var$I && 0 !== (b.flags & 1048576) && $a340872f7a7f928e$var$ug(b, $a340872f7a7f928e$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a340872f7a7f928e$var$ij(a, b);
            a = b.pendingProps;
            var e = $a340872f7a7f928e$var$Yf(b, $a340872f7a7f928e$var$H.current);
            $a340872f7a7f928e$var$ch(b, c);
            e = $a340872f7a7f928e$var$Nh(null, b, d, a, e, c);
            var f = $a340872f7a7f928e$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a340872f7a7f928e$var$Zf(d) ? (f = !0, $a340872f7a7f928e$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a340872f7a7f928e$var$kh(b), e.updater = $a340872f7a7f928e$var$Ei, b.stateNode = e, e._reactInternals = b, $a340872f7a7f928e$var$Ii(b, d, a, c), b = $a340872f7a7f928e$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $a340872f7a7f928e$var$I && f && $a340872f7a7f928e$var$vg(b), $a340872f7a7f928e$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a340872f7a7f928e$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a340872f7a7f928e$var$Zk(d);
                a = $a340872f7a7f928e$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $a340872f7a7f928e$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a340872f7a7f928e$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a340872f7a7f928e$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a340872f7a7f928e$var$$i(null, b, d, $a340872f7a7f928e$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($a340872f7a7f928e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a340872f7a7f928e$var$Ci(d, e), $a340872f7a7f928e$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a340872f7a7f928e$var$Ci(d, e), $a340872f7a7f928e$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $a340872f7a7f928e$var$kj(b);
                if (null === a) throw Error($a340872f7a7f928e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a340872f7a7f928e$var$lh(a, b);
                $a340872f7a7f928e$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a340872f7a7f928e$var$Ji(Error($a340872f7a7f928e$var$p(423)), b);
                        b = $a340872f7a7f928e$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a340872f7a7f928e$var$Ji(Error($a340872f7a7f928e$var$p(424)), b);
                        b = $a340872f7a7f928e$var$lj(a, b, d, c, e);
                        break a;
                    } else for($a340872f7a7f928e$var$yg = $a340872f7a7f928e$var$Lf(b.stateNode.containerInfo.firstChild), $a340872f7a7f928e$var$xg = b, $a340872f7a7f928e$var$I = !0, $a340872f7a7f928e$var$zg = null, c = $a340872f7a7f928e$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a340872f7a7f928e$var$Ig();
                    if (d === e) {
                        b = $a340872f7a7f928e$var$Zi(a, b, c);
                        break a;
                    }
                    $a340872f7a7f928e$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a340872f7a7f928e$var$Ah(b), null === a && $a340872f7a7f928e$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a340872f7a7f928e$var$Ef(d, e) ? g = null : null !== f && $a340872f7a7f928e$var$Ef(d, f) && (b.flags |= 32), $a340872f7a7f928e$var$gj(a, b), $a340872f7a7f928e$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $a340872f7a7f928e$var$Eg(b), null;
        case 13:
            return $a340872f7a7f928e$var$oj(a, b, c);
        case 4:
            return $a340872f7a7f928e$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a340872f7a7f928e$var$Ug(b, null, d, c) : $a340872f7a7f928e$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a340872f7a7f928e$var$Ci(d, e), $a340872f7a7f928e$var$Yi(a, b, d, e, c);
        case 7:
            return $a340872f7a7f928e$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a340872f7a7f928e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a340872f7a7f928e$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a340872f7a7f928e$var$G($a340872f7a7f928e$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a340872f7a7f928e$var$He(f.value, g)) {
                        if (f.children === e.children && !$a340872f7a7f928e$var$Wf.current) {
                            b = $a340872f7a7f928e$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a340872f7a7f928e$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a340872f7a7f928e$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a340872f7a7f928e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a340872f7a7f928e$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a340872f7a7f928e$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a340872f7a7f928e$var$ch(b, c), e = $a340872f7a7f928e$var$eh(e), d = d(e), b.flags |= 1, $a340872f7a7f928e$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a340872f7a7f928e$var$Ci(d, b.pendingProps), e = $a340872f7a7f928e$var$Ci(d.type, e), $a340872f7a7f928e$var$$i(a, b, d, e, c);
        case 15:
            return $a340872f7a7f928e$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a340872f7a7f928e$var$Ci(d, e), $a340872f7a7f928e$var$ij(a, b), b.tag = 1, $a340872f7a7f928e$var$Zf(d) ? (a = !0, $a340872f7a7f928e$var$cg(b)) : a = !1, $a340872f7a7f928e$var$ch(b, c), $a340872f7a7f928e$var$Gi(b, d, e), $a340872f7a7f928e$var$Ii(b, d, e, c), $a340872f7a7f928e$var$jj(null, b, d, !0, a, c);
        case 19:
            return $a340872f7a7f928e$var$xj(a, b, c);
        case 22:
            return $a340872f7a7f928e$var$dj(a, b, c);
    }
    throw Error($a340872f7a7f928e$var$p(156, b.tag));
};
function $a340872f7a7f928e$var$Fk(a, b) {
    return $a340872f7a7f928e$var$ac(a, b);
}
function $a340872f7a7f928e$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a340872f7a7f928e$var$Bg(a, b, c, d) {
    return new $a340872f7a7f928e$var$$k(a, b, c, d);
}
function $a340872f7a7f928e$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a340872f7a7f928e$var$Zk(a) {
    if ("function" === typeof a) return $a340872f7a7f928e$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a340872f7a7f928e$var$Da) return 11;
        if (a === $a340872f7a7f928e$var$Ga) return 14;
    }
    return 2;
}
function $a340872f7a7f928e$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $a340872f7a7f928e$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a340872f7a7f928e$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a340872f7a7f928e$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a340872f7a7f928e$var$ya:
            return $a340872f7a7f928e$var$Tg(c.children, e, f, b);
        case $a340872f7a7f928e$var$za:
            g = 8;
            e |= 8;
            break;
        case $a340872f7a7f928e$var$Aa:
            return a = $a340872f7a7f928e$var$Bg(12, c, b, e | 2), a.elementType = $a340872f7a7f928e$var$Aa, a.lanes = f, a;
        case $a340872f7a7f928e$var$Ea:
            return a = $a340872f7a7f928e$var$Bg(13, c, b, e), a.elementType = $a340872f7a7f928e$var$Ea, a.lanes = f, a;
        case $a340872f7a7f928e$var$Fa:
            return a = $a340872f7a7f928e$var$Bg(19, c, b, e), a.elementType = $a340872f7a7f928e$var$Fa, a.lanes = f, a;
        case $a340872f7a7f928e$var$Ia:
            return $a340872f7a7f928e$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a340872f7a7f928e$var$Ba:
                    g = 10;
                    break a;
                case $a340872f7a7f928e$var$Ca:
                    g = 9;
                    break a;
                case $a340872f7a7f928e$var$Da:
                    g = 11;
                    break a;
                case $a340872f7a7f928e$var$Ga:
                    g = 14;
                    break a;
                case $a340872f7a7f928e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a340872f7a7f928e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a340872f7a7f928e$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a340872f7a7f928e$var$Tg(a, b, c, d) {
    a = $a340872f7a7f928e$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a340872f7a7f928e$var$pj(a, b, c, d) {
    a = $a340872f7a7f928e$var$Bg(22, a, d, b);
    a.elementType = $a340872f7a7f928e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a340872f7a7f928e$var$Qg(a, b, c) {
    a = $a340872f7a7f928e$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a340872f7a7f928e$var$Sg(a, b, c) {
    b = $a340872f7a7f928e$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a340872f7a7f928e$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a340872f7a7f928e$var$zc(0);
    this.expirationTimes = $a340872f7a7f928e$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a340872f7a7f928e$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a340872f7a7f928e$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $a340872f7a7f928e$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a340872f7a7f928e$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a340872f7a7f928e$var$kh(f);
    return a;
}
function $a340872f7a7f928e$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a340872f7a7f928e$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a340872f7a7f928e$var$dl(a) {
    if (!a) return $a340872f7a7f928e$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a340872f7a7f928e$var$Vb(a) !== a || 1 !== a.tag) throw Error($a340872f7a7f928e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a340872f7a7f928e$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a340872f7a7f928e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a340872f7a7f928e$var$Zf(c)) return $a340872f7a7f928e$var$bg(a, c, b);
    }
    return b;
}
function $a340872f7a7f928e$var$el(a, b, c, d, e, f, g, h, k) {
    a = $a340872f7a7f928e$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $a340872f7a7f928e$var$dl(null);
    c = a.current;
    d = $a340872f7a7f928e$var$R();
    e = $a340872f7a7f928e$var$yi(c);
    f = $a340872f7a7f928e$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a340872f7a7f928e$var$nh(c, f, e);
    a.current.lanes = e;
    $a340872f7a7f928e$var$Ac(a, e, d);
    $a340872f7a7f928e$var$Dk(a, d);
    return a;
}
function $a340872f7a7f928e$var$fl(a, b, c, d) {
    var e = b.current, f = $a340872f7a7f928e$var$R(), g = $a340872f7a7f928e$var$yi(e);
    c = $a340872f7a7f928e$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a340872f7a7f928e$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a340872f7a7f928e$var$nh(e, b, g);
    null !== a && ($a340872f7a7f928e$var$gi(a, e, g, f), $a340872f7a7f928e$var$oh(a, e, g));
    return g;
}
function $a340872f7a7f928e$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a340872f7a7f928e$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a340872f7a7f928e$var$il(a, b) {
    $a340872f7a7f928e$var$hl(a, b);
    (a = a.alternate) && $a340872f7a7f928e$var$hl(a, b);
}
function $a340872f7a7f928e$var$jl() {
    return null;
}
var $a340872f7a7f928e$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a340872f7a7f928e$var$ll(a) {
    this._internalRoot = a;
}
$a340872f7a7f928e$var$ml.prototype.render = $a340872f7a7f928e$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a340872f7a7f928e$var$p(409));
    $a340872f7a7f928e$var$fl(a, b, null, null);
};
$a340872f7a7f928e$var$ml.prototype.unmount = $a340872f7a7f928e$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a340872f7a7f928e$var$Rk(function() {
            $a340872f7a7f928e$var$fl(null, a, null, null);
        });
        b[$a340872f7a7f928e$var$uf] = null;
    }
};
function $a340872f7a7f928e$var$ml(a) {
    this._internalRoot = a;
}
$a340872f7a7f928e$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a340872f7a7f928e$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a340872f7a7f928e$var$Qc.length && 0 !== b && b < $a340872f7a7f928e$var$Qc[c].priority; c++);
        $a340872f7a7f928e$var$Qc.splice(c, 0, a);
        0 === c && $a340872f7a7f928e$var$Vc(a);
    }
};
function $a340872f7a7f928e$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a340872f7a7f928e$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a340872f7a7f928e$var$pl() {}
function $a340872f7a7f928e$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a340872f7a7f928e$var$gl(g);
                f.call(a);
            };
        }
        var g = $a340872f7a7f928e$var$el(b, d, a, 0, null, !1, !1, "", $a340872f7a7f928e$var$pl);
        a._reactRootContainer = g;
        a[$a340872f7a7f928e$var$uf] = g.current;
        $a340872f7a7f928e$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a340872f7a7f928e$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a340872f7a7f928e$var$gl(k);
            h.call(a);
        };
    }
    var k = $a340872f7a7f928e$var$bl(a, 0, !1, null, null, !1, !1, "", $a340872f7a7f928e$var$pl);
    a._reactRootContainer = k;
    a[$a340872f7a7f928e$var$uf] = k.current;
    $a340872f7a7f928e$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a340872f7a7f928e$var$Rk(function() {
        $a340872f7a7f928e$var$fl(b, k, c, d);
    });
    return k;
}
function $a340872f7a7f928e$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a340872f7a7f928e$var$gl(g);
                h.call(a);
            };
        }
        $a340872f7a7f928e$var$fl(b, g, a, e);
    } else g = $a340872f7a7f928e$var$ql(c, b, a, e, d);
    return $a340872f7a7f928e$var$gl(g);
}
$a340872f7a7f928e$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a340872f7a7f928e$var$tc(b.pendingLanes);
                0 !== c && ($a340872f7a7f928e$var$Cc(b, c | 1), $a340872f7a7f928e$var$Dk(b, $a340872f7a7f928e$var$B()), 0 === ($a340872f7a7f928e$var$K & 6) && ($a340872f7a7f928e$var$Gj = $a340872f7a7f928e$var$B() + 500, $a340872f7a7f928e$var$jg()));
            }
            break;
        case 13:
            $a340872f7a7f928e$var$Rk(function() {
                var b = $a340872f7a7f928e$var$ih(a, 1);
                if (null !== b) {
                    var c = $a340872f7a7f928e$var$R();
                    $a340872f7a7f928e$var$gi(b, a, 1, c);
                }
            }), $a340872f7a7f928e$var$il(a, 1);
    }
};
$a340872f7a7f928e$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a340872f7a7f928e$var$ih(a, 134217728);
        if (null !== b) {
            var c = $a340872f7a7f928e$var$R();
            $a340872f7a7f928e$var$gi(b, a, 134217728, c);
        }
        $a340872f7a7f928e$var$il(a, 134217728);
    }
};
$a340872f7a7f928e$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a340872f7a7f928e$var$yi(a), c = $a340872f7a7f928e$var$ih(a, b);
        if (null !== c) {
            var d = $a340872f7a7f928e$var$R();
            $a340872f7a7f928e$var$gi(c, a, b, d);
        }
        $a340872f7a7f928e$var$il(a, b);
    }
};
$a340872f7a7f928e$var$Hc = function() {
    return $a340872f7a7f928e$var$C;
};
$a340872f7a7f928e$var$Ic = function(a, b) {
    var c = $a340872f7a7f928e$var$C;
    try {
        return $a340872f7a7f928e$var$C = a, b();
    } finally{
        $a340872f7a7f928e$var$C = c;
    }
};
$a340872f7a7f928e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a340872f7a7f928e$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a340872f7a7f928e$var$Db(d);
                        if (!e) throw Error($a340872f7a7f928e$var$p(90));
                        $a340872f7a7f928e$var$Wa(d);
                        $a340872f7a7f928e$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a340872f7a7f928e$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a340872f7a7f928e$var$fb(a, !!c.multiple, b, !1);
    }
};
$a340872f7a7f928e$var$Gb = $a340872f7a7f928e$var$Qk;
$a340872f7a7f928e$var$Hb = $a340872f7a7f928e$var$Rk;
var $a340872f7a7f928e$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $a340872f7a7f928e$var$Cb,
        $a340872f7a7f928e$var$ue,
        $a340872f7a7f928e$var$Db,
        $a340872f7a7f928e$var$Eb,
        $a340872f7a7f928e$var$Fb,
        $a340872f7a7f928e$var$Qk
    ]
}, $a340872f7a7f928e$var$tl = {
    findFiberByHostInstance: $a340872f7a7f928e$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $a340872f7a7f928e$var$ul = {
    bundleType: $a340872f7a7f928e$var$tl.bundleType,
    version: $a340872f7a7f928e$var$tl.version,
    rendererPackageName: $a340872f7a7f928e$var$tl.rendererPackageName,
    rendererConfig: $a340872f7a7f928e$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a340872f7a7f928e$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a340872f7a7f928e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a340872f7a7f928e$var$tl.findFiberByHostInstance || $a340872f7a7f928e$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a340872f7a7f928e$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a340872f7a7f928e$var$vl.isDisabled && $a340872f7a7f928e$var$vl.supportsFiber) try {
        $a340872f7a7f928e$var$kc = $a340872f7a7f928e$var$vl.inject($a340872f7a7f928e$var$ul), $a340872f7a7f928e$var$lc = $a340872f7a7f928e$var$vl;
    } catch (a) {}
}
$a340872f7a7f928e$export$ae55be85d98224ed = $a340872f7a7f928e$var$sl;
$a340872f7a7f928e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a340872f7a7f928e$var$nl(b)) throw Error($a340872f7a7f928e$var$p(200));
    return $a340872f7a7f928e$var$cl(a, b, null, c);
};
$a340872f7a7f928e$export$882461b6382ed46c = function(a, b) {
    if (!$a340872f7a7f928e$var$nl(a)) throw Error($a340872f7a7f928e$var$p(299));
    var c = !1, d = "", e = $a340872f7a7f928e$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a340872f7a7f928e$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$a340872f7a7f928e$var$uf] = b.current;
    $a340872f7a7f928e$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a340872f7a7f928e$var$ll(b);
};
$a340872f7a7f928e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a340872f7a7f928e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a340872f7a7f928e$var$p(268, a));
    }
    a = $a340872f7a7f928e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a340872f7a7f928e$export$cd75ccfd720a3cd4 = function(a) {
    return $a340872f7a7f928e$var$Rk(a);
};
$a340872f7a7f928e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a340872f7a7f928e$var$ol(b)) throw Error($a340872f7a7f928e$var$p(200));
    return $a340872f7a7f928e$var$rl(null, a, b, !0, c);
};
$a340872f7a7f928e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a340872f7a7f928e$var$nl(a)) throw Error($a340872f7a7f928e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a340872f7a7f928e$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a340872f7a7f928e$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a340872f7a7f928e$var$uf] = b.current;
    $a340872f7a7f928e$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a340872f7a7f928e$var$ml(b);
};
$a340872f7a7f928e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a340872f7a7f928e$var$ol(b)) throw Error($a340872f7a7f928e$var$p(200));
    return $a340872f7a7f928e$var$rl(null, a, b, !1, c);
};
$a340872f7a7f928e$export$502457920280e6be = function(a) {
    if (!$a340872f7a7f928e$var$ol(a)) throw Error($a340872f7a7f928e$var$p(40));
    return a._reactRootContainer ? ($a340872f7a7f928e$var$Rk(function() {
        $a340872f7a7f928e$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a340872f7a7f928e$var$uf] = null;
        });
    }), !0) : !1;
};
$a340872f7a7f928e$export$c78a37762a8d58e1 = $a340872f7a7f928e$var$Qk;
$a340872f7a7f928e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a340872f7a7f928e$var$ol(c)) throw Error($a340872f7a7f928e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a340872f7a7f928e$var$p(38));
    return $a340872f7a7f928e$var$rl(a, b, c, !1, d);
};
$a340872f7a7f928e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("eYRpC", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jF1tk"));

});
parcelRegister("jF1tk", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e502fcfa8aed41eb$export$c4744153514ff05d; }, function (v) { return $e502fcfa8aed41eb$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e502fcfa8aed41eb$export$3e506c1ccc9cc1a7; }, function (v) { return $e502fcfa8aed41eb$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e502fcfa8aed41eb$export$e26fe2ed2fa76875; }, function (v) { return $e502fcfa8aed41eb$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e502fcfa8aed41eb$export$502329bbf4b505b1; }, function (v) { return $e502fcfa8aed41eb$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e502fcfa8aed41eb$export$6e3807111c4874c4; }, function (v) { return $e502fcfa8aed41eb$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e502fcfa8aed41eb$export$c27134553091fb3a; }, function (v) { return $e502fcfa8aed41eb$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e502fcfa8aed41eb$export$33ee1acdc04fd2a2; }, function (v) { return $e502fcfa8aed41eb$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e502fcfa8aed41eb$export$b00a404bbd5edef2; }, function (v) { return $e502fcfa8aed41eb$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e502fcfa8aed41eb$export$8352ce38b91d0c62; }, function (v) { return $e502fcfa8aed41eb$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e502fcfa8aed41eb$export$d66a1c1c77bd778b; }, function (v) { return $e502fcfa8aed41eb$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e502fcfa8aed41eb$export$d3dfb8e4810cb555; }, function (v) { return $e502fcfa8aed41eb$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e502fcfa8aed41eb$export$839f9183b0465a69; }, function (v) { return $e502fcfa8aed41eb$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e502fcfa8aed41eb$export$72fdf0e06517287b; }, function (v) { return $e502fcfa8aed41eb$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e502fcfa8aed41eb$export$4b844e58a3e414b4; }, function (v) { return $e502fcfa8aed41eb$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e502fcfa8aed41eb$export$816d2913ae6b83b1; }, function (v) { return $e502fcfa8aed41eb$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e502fcfa8aed41eb$export$61bcfe829111a1d0; }, function (v) { return $e502fcfa8aed41eb$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e502fcfa8aed41eb$export$7ee8c9beb337bc3f; }, function (v) { return $e502fcfa8aed41eb$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e502fcfa8aed41eb$export$b5836b71941fa3ed; }, function (v) { return $e502fcfa8aed41eb$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e502fcfa8aed41eb$export$cf845f2c119da08a; }, function (v) { return $e502fcfa8aed41eb$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e502fcfa8aed41eb$export$c4744153514ff05d;
var $e502fcfa8aed41eb$export$3e506c1ccc9cc1a7;
var $e502fcfa8aed41eb$export$e26fe2ed2fa76875;
var $e502fcfa8aed41eb$export$502329bbf4b505b1;
var $e502fcfa8aed41eb$export$6e3807111c4874c4;
var $e502fcfa8aed41eb$export$c27134553091fb3a;
var $e502fcfa8aed41eb$export$33ee1acdc04fd2a2;
var $e502fcfa8aed41eb$export$b00a404bbd5edef2;
var $e502fcfa8aed41eb$export$8352ce38b91d0c62;
var $e502fcfa8aed41eb$export$d66a1c1c77bd778b;
var $e502fcfa8aed41eb$export$d3dfb8e4810cb555;
var $e502fcfa8aed41eb$export$839f9183b0465a69;
var $e502fcfa8aed41eb$export$72fdf0e06517287b;
var $e502fcfa8aed41eb$export$4b844e58a3e414b4;
var $e502fcfa8aed41eb$export$816d2913ae6b83b1;
var $e502fcfa8aed41eb$export$61bcfe829111a1d0;
var $e502fcfa8aed41eb$export$7ee8c9beb337bc3f;
var $e502fcfa8aed41eb$export$b5836b71941fa3ed;
var $e502fcfa8aed41eb$export$cf845f2c119da08a;
'use strict';
function $e502fcfa8aed41eb$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e502fcfa8aed41eb$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e502fcfa8aed41eb$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e502fcfa8aed41eb$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e502fcfa8aed41eb$var$g(C, c)) n < e && 0 > $e502fcfa8aed41eb$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e502fcfa8aed41eb$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e502fcfa8aed41eb$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e502fcfa8aed41eb$var$l = performance;
    $e502fcfa8aed41eb$export$c4744153514ff05d = function() {
        return $e502fcfa8aed41eb$var$l.now();
    };
} else {
    var $e502fcfa8aed41eb$var$p = Date, $e502fcfa8aed41eb$var$q = $e502fcfa8aed41eb$var$p.now();
    $e502fcfa8aed41eb$export$c4744153514ff05d = function() {
        return $e502fcfa8aed41eb$var$p.now() - $e502fcfa8aed41eb$var$q;
    };
}
var $e502fcfa8aed41eb$var$r = [], $e502fcfa8aed41eb$var$t = [], $e502fcfa8aed41eb$var$u = 1, $e502fcfa8aed41eb$var$v = null, $e502fcfa8aed41eb$var$y = 3, $e502fcfa8aed41eb$var$z = !1, $e502fcfa8aed41eb$var$A = !1, $e502fcfa8aed41eb$var$B = !1, $e502fcfa8aed41eb$var$D = "function" === typeof setTimeout ? setTimeout : null, $e502fcfa8aed41eb$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e502fcfa8aed41eb$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e502fcfa8aed41eb$var$G(a) {
    for(var b = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$t); null !== b;){
        if (null === b.callback) $e502fcfa8aed41eb$var$k($e502fcfa8aed41eb$var$t);
        else if (b.startTime <= a) $e502fcfa8aed41eb$var$k($e502fcfa8aed41eb$var$t), b.sortIndex = b.expirationTime, $e502fcfa8aed41eb$var$f($e502fcfa8aed41eb$var$r, b);
        else break;
        b = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$t);
    }
}
function $e502fcfa8aed41eb$var$H(a) {
    $e502fcfa8aed41eb$var$B = !1;
    $e502fcfa8aed41eb$var$G(a);
    if (!$e502fcfa8aed41eb$var$A) {
        if (null !== $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r)) $e502fcfa8aed41eb$var$A = !0, $e502fcfa8aed41eb$var$I($e502fcfa8aed41eb$var$J);
        else {
            var b = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$t);
            null !== b && $e502fcfa8aed41eb$var$K($e502fcfa8aed41eb$var$H, b.startTime - a);
        }
    }
}
function $e502fcfa8aed41eb$var$J(a, b) {
    $e502fcfa8aed41eb$var$A = !1;
    $e502fcfa8aed41eb$var$B && ($e502fcfa8aed41eb$var$B = !1, $e502fcfa8aed41eb$var$E($e502fcfa8aed41eb$var$L), $e502fcfa8aed41eb$var$L = -1);
    $e502fcfa8aed41eb$var$z = !0;
    var c = $e502fcfa8aed41eb$var$y;
    try {
        $e502fcfa8aed41eb$var$G(b);
        for($e502fcfa8aed41eb$var$v = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r); null !== $e502fcfa8aed41eb$var$v && (!($e502fcfa8aed41eb$var$v.expirationTime > b) || a && !$e502fcfa8aed41eb$var$M());){
            var d = $e502fcfa8aed41eb$var$v.callback;
            if ("function" === typeof d) {
                $e502fcfa8aed41eb$var$v.callback = null;
                $e502fcfa8aed41eb$var$y = $e502fcfa8aed41eb$var$v.priorityLevel;
                var e = d($e502fcfa8aed41eb$var$v.expirationTime <= b);
                b = $e502fcfa8aed41eb$export$c4744153514ff05d();
                "function" === typeof e ? $e502fcfa8aed41eb$var$v.callback = e : $e502fcfa8aed41eb$var$v === $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r) && $e502fcfa8aed41eb$var$k($e502fcfa8aed41eb$var$r);
                $e502fcfa8aed41eb$var$G(b);
            } else $e502fcfa8aed41eb$var$k($e502fcfa8aed41eb$var$r);
            $e502fcfa8aed41eb$var$v = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r);
        }
        if (null !== $e502fcfa8aed41eb$var$v) var w = !0;
        else {
            var m = $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$t);
            null !== m && $e502fcfa8aed41eb$var$K($e502fcfa8aed41eb$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e502fcfa8aed41eb$var$v = null, $e502fcfa8aed41eb$var$y = c, $e502fcfa8aed41eb$var$z = !1;
    }
}
var $e502fcfa8aed41eb$var$N = !1, $e502fcfa8aed41eb$var$O = null, $e502fcfa8aed41eb$var$L = -1, $e502fcfa8aed41eb$var$P = 5, $e502fcfa8aed41eb$var$Q = -1;
function $e502fcfa8aed41eb$var$M() {
    return $e502fcfa8aed41eb$export$c4744153514ff05d() - $e502fcfa8aed41eb$var$Q < $e502fcfa8aed41eb$var$P ? !1 : !0;
}
function $e502fcfa8aed41eb$var$R() {
    if (null !== $e502fcfa8aed41eb$var$O) {
        var a = $e502fcfa8aed41eb$export$c4744153514ff05d();
        $e502fcfa8aed41eb$var$Q = a;
        var b = !0;
        try {
            b = $e502fcfa8aed41eb$var$O(!0, a);
        } finally{
            b ? $e502fcfa8aed41eb$var$S() : ($e502fcfa8aed41eb$var$N = !1, $e502fcfa8aed41eb$var$O = null);
        }
    } else $e502fcfa8aed41eb$var$N = !1;
}
var $e502fcfa8aed41eb$var$S;
if ("function" === typeof $e502fcfa8aed41eb$var$F) $e502fcfa8aed41eb$var$S = function() {
    $e502fcfa8aed41eb$var$F($e502fcfa8aed41eb$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e502fcfa8aed41eb$var$T = new MessageChannel, $e502fcfa8aed41eb$var$U = $e502fcfa8aed41eb$var$T.port2;
    $e502fcfa8aed41eb$var$T.port1.onmessage = $e502fcfa8aed41eb$var$R;
    $e502fcfa8aed41eb$var$S = function() {
        $e502fcfa8aed41eb$var$U.postMessage(null);
    };
} else $e502fcfa8aed41eb$var$S = function() {
    $e502fcfa8aed41eb$var$D($e502fcfa8aed41eb$var$R, 0);
};
function $e502fcfa8aed41eb$var$I(a) {
    $e502fcfa8aed41eb$var$O = a;
    $e502fcfa8aed41eb$var$N || ($e502fcfa8aed41eb$var$N = !0, $e502fcfa8aed41eb$var$S());
}
function $e502fcfa8aed41eb$var$K(a, b) {
    $e502fcfa8aed41eb$var$L = $e502fcfa8aed41eb$var$D(function() {
        a($e502fcfa8aed41eb$export$c4744153514ff05d());
    }, b);
}
$e502fcfa8aed41eb$export$3e506c1ccc9cc1a7 = 5;
$e502fcfa8aed41eb$export$e26fe2ed2fa76875 = 1;
$e502fcfa8aed41eb$export$502329bbf4b505b1 = 4;
$e502fcfa8aed41eb$export$6e3807111c4874c4 = 3;
$e502fcfa8aed41eb$export$c27134553091fb3a = null;
$e502fcfa8aed41eb$export$33ee1acdc04fd2a2 = 2;
$e502fcfa8aed41eb$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e502fcfa8aed41eb$export$8352ce38b91d0c62 = function() {
    $e502fcfa8aed41eb$var$A || $e502fcfa8aed41eb$var$z || ($e502fcfa8aed41eb$var$A = !0, $e502fcfa8aed41eb$var$I($e502fcfa8aed41eb$var$J));
};
$e502fcfa8aed41eb$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e502fcfa8aed41eb$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e502fcfa8aed41eb$export$d3dfb8e4810cb555 = function() {
    return $e502fcfa8aed41eb$var$y;
};
$e502fcfa8aed41eb$export$839f9183b0465a69 = function() {
    return $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r);
};
$e502fcfa8aed41eb$export$72fdf0e06517287b = function(a) {
    switch($e502fcfa8aed41eb$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e502fcfa8aed41eb$var$y;
    }
    var c = $e502fcfa8aed41eb$var$y;
    $e502fcfa8aed41eb$var$y = b;
    try {
        return a();
    } finally{
        $e502fcfa8aed41eb$var$y = c;
    }
};
$e502fcfa8aed41eb$export$4b844e58a3e414b4 = function() {};
$e502fcfa8aed41eb$export$816d2913ae6b83b1 = function() {};
$e502fcfa8aed41eb$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e502fcfa8aed41eb$var$y;
    $e502fcfa8aed41eb$var$y = a;
    try {
        return b();
    } finally{
        $e502fcfa8aed41eb$var$y = c;
    }
};
$e502fcfa8aed41eb$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e502fcfa8aed41eb$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e502fcfa8aed41eb$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e502fcfa8aed41eb$var$f($e502fcfa8aed41eb$var$t, a), null === $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$r) && a === $e502fcfa8aed41eb$var$h($e502fcfa8aed41eb$var$t) && ($e502fcfa8aed41eb$var$B ? ($e502fcfa8aed41eb$var$E($e502fcfa8aed41eb$var$L), $e502fcfa8aed41eb$var$L = -1) : $e502fcfa8aed41eb$var$B = !0, $e502fcfa8aed41eb$var$K($e502fcfa8aed41eb$var$H, c - d))) : (a.sortIndex = e, $e502fcfa8aed41eb$var$f($e502fcfa8aed41eb$var$r, a), $e502fcfa8aed41eb$var$A || $e502fcfa8aed41eb$var$z || ($e502fcfa8aed41eb$var$A = !0, $e502fcfa8aed41eb$var$I($e502fcfa8aed41eb$var$J)));
    return a;
};
$e502fcfa8aed41eb$export$b5836b71941fa3ed = $e502fcfa8aed41eb$var$M;
$e502fcfa8aed41eb$export$cf845f2c119da08a = function(a) {
    var b = $e502fcfa8aed41eb$var$y;
    return function() {
        var c = $e502fcfa8aed41eb$var$y;
        $e502fcfa8aed41eb$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e502fcfa8aed41eb$var$y = c;
        }
    };
};

});





parcelRegister("iQwFe", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $db866bb59f2c0d16$export$306c0aa65ff9ec16; }, function (v) { return $db866bb59f2c0d16$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $db866bb59f2c0d16$export$306c0aa65ff9ec16;
"use strict";

var $dBNnn = parcelRequire("dBNnn");
function $db866bb59f2c0d16$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $db866bb59f2c0d16$var$objectIs = "function" === typeof Object.is ? Object.is : $db866bb59f2c0d16$var$is, $db866bb59f2c0d16$var$useState = $dBNnn.useState, $db866bb59f2c0d16$var$useEffect = $dBNnn.useEffect, $db866bb59f2c0d16$var$useLayoutEffect = $dBNnn.useLayoutEffect, $db866bb59f2c0d16$var$useDebugValue = $dBNnn.useDebugValue;
function $db866bb59f2c0d16$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $db866bb59f2c0d16$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $db866bb59f2c0d16$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $db866bb59f2c0d16$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $db866bb59f2c0d16$var$useEffect(function() {
        $db866bb59f2c0d16$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $db866bb59f2c0d16$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $db866bb59f2c0d16$var$useDebugValue(value);
    return value;
}
function $db866bb59f2c0d16$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$db866bb59f2c0d16$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $db866bb59f2c0d16$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $db866bb59f2c0d16$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $db866bb59f2c0d16$var$useSyncExternalStore$1 : $db866bb59f2c0d16$var$useSyncExternalStore$2;
$db866bb59f2c0d16$export$306c0aa65ff9ec16 = void 0 !== $dBNnn.useSyncExternalStore ? $dBNnn.useSyncExternalStore : $db866bb59f2c0d16$var$shim;

});

parcelRegister("dWZmh", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $a280499f2f230ae2$export$bf730a2d8bf68b42; }, function (v) { return $a280499f2f230ae2$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a280499f2f230ae2$export$bf730a2d8bf68b42;
"use strict";

var $dBNnn = parcelRequire("dBNnn");

var $24Gq2 = parcelRequire("24Gq2");
function $a280499f2f230ae2$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a280499f2f230ae2$var$objectIs = "function" === typeof Object.is ? Object.is : $a280499f2f230ae2$var$is, $a280499f2f230ae2$var$useSyncExternalStore = $24Gq2.useSyncExternalStore, $a280499f2f230ae2$var$useRef = $dBNnn.useRef, $a280499f2f230ae2$var$useEffect = $dBNnn.useEffect, $a280499f2f230ae2$var$useMemo = $dBNnn.useMemo, $a280499f2f230ae2$var$useDebugValue = $dBNnn.useDebugValue;
$a280499f2f230ae2$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $a280499f2f230ae2$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $a280499f2f230ae2$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($a280499f2f230ae2$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $a280499f2f230ae2$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $a280499f2f230ae2$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $a280499f2f230ae2$var$useDebugValue(value);
    return value;
};

});
parcelRegister("24Gq2", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iQwFe"));

});


parcelRegister("3YTlc", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2e61e743162d942c$export$2b8d127b894957b9; }, function (v) { return $2e61e743162d942c$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2e61e743162d942c$export$cea3a54a6425200c; }, function (v) { return $2e61e743162d942c$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2e61e743162d942c$export$a7c73072b1a182ae; }, function (v) { return $2e61e743162d942c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2e61e743162d942c$export$9f27bc3417b4524d; }, function (v) { return $2e61e743162d942c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2e61e743162d942c$export$db77ccec0bb4ccac; }, function (v) { return $2e61e743162d942c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2e61e743162d942c$export$8392c0c9d3dcbd35; }, function (v) { return $2e61e743162d942c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2e61e743162d942c$export$ffb0004e005737fa; }, function (v) { return $2e61e743162d942c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2e61e743162d942c$export$b624eff549462981; }, function (v) { return $2e61e743162d942c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2e61e743162d942c$export$7897aa7841a5380c; }, function (v) { return $2e61e743162d942c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2e61e743162d942c$export$602eac185826482c; }, function (v) { return $2e61e743162d942c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2e61e743162d942c$export$e2c29f18771995cb; }, function (v) { return $2e61e743162d942c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2e61e743162d942c$export$5f8d39834fd61797; }, function (v) { return $2e61e743162d942c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2e61e743162d942c$export$74bf444e3cd11ea5; }, function (v) { return $2e61e743162d942c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2e61e743162d942c$export$92387174baf9b227; }, function (v) { return $2e61e743162d942c$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2e61e743162d942c$export$ec112efeb987d9c6; }, function (v) { return $2e61e743162d942c$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2e61e743162d942c$export$b706b080d889d2c9; }, function (v) { return $2e61e743162d942c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2e61e743162d942c$export$5be5a87408f70ddc; }, function (v) { return $2e61e743162d942c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2e61e743162d942c$export$45a5e7f76e0caa8d; }, function (v) { return $2e61e743162d942c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2e61e743162d942c$export$455c2e768291efa6; }, function (v) { return $2e61e743162d942c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2e61e743162d942c$export$9522e17588c12572; }, function (v) { return $2e61e743162d942c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2e61e743162d942c$export$2110ac352bb060b9; }, function (v) { return $2e61e743162d942c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2e61e743162d942c$export$56885ab8b9c456ab; }, function (v) { return $2e61e743162d942c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2e61e743162d942c$export$d927fcb6adf8f9de; }, function (v) { return $2e61e743162d942c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2e61e743162d942c$export$b82d16f27459e05a; }, function (v) { return $2e61e743162d942c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2e61e743162d942c$export$522c17b4f5e123e8; }, function (v) { return $2e61e743162d942c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2e61e743162d942c$export$1aabd8a0274ecfd6; }, function (v) { return $2e61e743162d942c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2e61e743162d942c$export$9b621391a187a31a; }, function (v) { return $2e61e743162d942c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2e61e743162d942c$export$f5bbd400c2f4426f; }, function (v) { return $2e61e743162d942c$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2e61e743162d942c$export$2b8d127b894957b9;
var $2e61e743162d942c$export$cea3a54a6425200c;
var $2e61e743162d942c$export$a7c73072b1a182ae;
var $2e61e743162d942c$export$9f27bc3417b4524d;
var $2e61e743162d942c$export$db77ccec0bb4ccac;
var $2e61e743162d942c$export$8392c0c9d3dcbd35;
var $2e61e743162d942c$export$ffb0004e005737fa;
var $2e61e743162d942c$export$b624eff549462981;
var $2e61e743162d942c$export$7897aa7841a5380c;
var $2e61e743162d942c$export$602eac185826482c;
var $2e61e743162d942c$export$e2c29f18771995cb;
var $2e61e743162d942c$export$5f8d39834fd61797;
var $2e61e743162d942c$export$74bf444e3cd11ea5;
var $2e61e743162d942c$export$92387174baf9b227;
var $2e61e743162d942c$export$ec112efeb987d9c6;
var $2e61e743162d942c$export$b706b080d889d2c9;
var $2e61e743162d942c$export$5be5a87408f70ddc;
var $2e61e743162d942c$export$45a5e7f76e0caa8d;
var $2e61e743162d942c$export$455c2e768291efa6;
var $2e61e743162d942c$export$9522e17588c12572;
var $2e61e743162d942c$export$2110ac352bb060b9;
var $2e61e743162d942c$export$56885ab8b9c456ab;
var $2e61e743162d942c$export$d927fcb6adf8f9de;
var $2e61e743162d942c$export$b82d16f27459e05a;
var $2e61e743162d942c$export$522c17b4f5e123e8;
var $2e61e743162d942c$export$1aabd8a0274ecfd6;
var $2e61e743162d942c$export$9b621391a187a31a;
var $2e61e743162d942c$export$f5bbd400c2f4426f;
'use strict';
var $2e61e743162d942c$var$b = "function" === typeof Symbol && Symbol.for, $2e61e743162d942c$var$c = $2e61e743162d942c$var$b ? Symbol.for("react.element") : 60103, $2e61e743162d942c$var$d = $2e61e743162d942c$var$b ? Symbol.for("react.portal") : 60106, $2e61e743162d942c$var$e = $2e61e743162d942c$var$b ? Symbol.for("react.fragment") : 60107, $2e61e743162d942c$var$f = $2e61e743162d942c$var$b ? Symbol.for("react.strict_mode") : 60108, $2e61e743162d942c$var$g = $2e61e743162d942c$var$b ? Symbol.for("react.profiler") : 60114, $2e61e743162d942c$var$h = $2e61e743162d942c$var$b ? Symbol.for("react.provider") : 60109, $2e61e743162d942c$var$k = $2e61e743162d942c$var$b ? Symbol.for("react.context") : 60110, $2e61e743162d942c$var$l = $2e61e743162d942c$var$b ? Symbol.for("react.async_mode") : 60111, $2e61e743162d942c$var$m = $2e61e743162d942c$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2e61e743162d942c$var$n = $2e61e743162d942c$var$b ? Symbol.for("react.forward_ref") : 60112, $2e61e743162d942c$var$p = $2e61e743162d942c$var$b ? Symbol.for("react.suspense") : 60113, $2e61e743162d942c$var$q = $2e61e743162d942c$var$b ? Symbol.for("react.suspense_list") : 60120, $2e61e743162d942c$var$r = $2e61e743162d942c$var$b ? Symbol.for("react.memo") : 60115, $2e61e743162d942c$var$t = $2e61e743162d942c$var$b ? Symbol.for("react.lazy") : 60116, $2e61e743162d942c$var$v = $2e61e743162d942c$var$b ? Symbol.for("react.block") : 60121, $2e61e743162d942c$var$w = $2e61e743162d942c$var$b ? Symbol.for("react.fundamental") : 60117, $2e61e743162d942c$var$x = $2e61e743162d942c$var$b ? Symbol.for("react.responder") : 60118, $2e61e743162d942c$var$y = $2e61e743162d942c$var$b ? Symbol.for("react.scope") : 60119;
function $2e61e743162d942c$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2e61e743162d942c$var$c:
                switch(a = a.type, a){
                    case $2e61e743162d942c$var$l:
                    case $2e61e743162d942c$var$m:
                    case $2e61e743162d942c$var$e:
                    case $2e61e743162d942c$var$g:
                    case $2e61e743162d942c$var$f:
                    case $2e61e743162d942c$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2e61e743162d942c$var$k:
                            case $2e61e743162d942c$var$n:
                            case $2e61e743162d942c$var$t:
                            case $2e61e743162d942c$var$r:
                            case $2e61e743162d942c$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2e61e743162d942c$var$d:
                return u;
        }
    }
}
function $2e61e743162d942c$var$A(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$m;
}
$2e61e743162d942c$export$2b8d127b894957b9 = $2e61e743162d942c$var$l;
$2e61e743162d942c$export$cea3a54a6425200c = $2e61e743162d942c$var$m;
$2e61e743162d942c$export$a7c73072b1a182ae = $2e61e743162d942c$var$k;
$2e61e743162d942c$export$9f27bc3417b4524d = $2e61e743162d942c$var$h;
$2e61e743162d942c$export$db77ccec0bb4ccac = $2e61e743162d942c$var$c;
$2e61e743162d942c$export$8392c0c9d3dcbd35 = $2e61e743162d942c$var$n;
$2e61e743162d942c$export$ffb0004e005737fa = $2e61e743162d942c$var$e;
$2e61e743162d942c$export$b624eff549462981 = $2e61e743162d942c$var$t;
$2e61e743162d942c$export$7897aa7841a5380c = $2e61e743162d942c$var$r;
$2e61e743162d942c$export$602eac185826482c = $2e61e743162d942c$var$d;
$2e61e743162d942c$export$e2c29f18771995cb = $2e61e743162d942c$var$g;
$2e61e743162d942c$export$5f8d39834fd61797 = $2e61e743162d942c$var$f;
$2e61e743162d942c$export$74bf444e3cd11ea5 = $2e61e743162d942c$var$p;
$2e61e743162d942c$export$92387174baf9b227 = function(a) {
    return $2e61e743162d942c$var$A(a) || $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$l;
};
$2e61e743162d942c$export$ec112efeb987d9c6 = $2e61e743162d942c$var$A;
$2e61e743162d942c$export$b706b080d889d2c9 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$k;
};
$2e61e743162d942c$export$5be5a87408f70ddc = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$h;
};
$2e61e743162d942c$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2e61e743162d942c$var$c;
};
$2e61e743162d942c$export$455c2e768291efa6 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$n;
};
$2e61e743162d942c$export$9522e17588c12572 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$e;
};
$2e61e743162d942c$export$2110ac352bb060b9 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$t;
};
$2e61e743162d942c$export$56885ab8b9c456ab = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$r;
};
$2e61e743162d942c$export$d927fcb6adf8f9de = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$d;
};
$2e61e743162d942c$export$b82d16f27459e05a = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$g;
};
$2e61e743162d942c$export$522c17b4f5e123e8 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$f;
};
$2e61e743162d942c$export$1aabd8a0274ecfd6 = function(a) {
    return $2e61e743162d942c$var$z(a) === $2e61e743162d942c$var$p;
};
$2e61e743162d942c$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2e61e743162d942c$var$e || a === $2e61e743162d942c$var$m || a === $2e61e743162d942c$var$g || a === $2e61e743162d942c$var$f || a === $2e61e743162d942c$var$p || a === $2e61e743162d942c$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2e61e743162d942c$var$t || a.$$typeof === $2e61e743162d942c$var$r || a.$$typeof === $2e61e743162d942c$var$h || a.$$typeof === $2e61e743162d942c$var$k || a.$$typeof === $2e61e743162d942c$var$n || a.$$typeof === $2e61e743162d942c$var$w || a.$$typeof === $2e61e743162d942c$var$x || a.$$typeof === $2e61e743162d942c$var$y || a.$$typeof === $2e61e743162d942c$var$v);
};
$2e61e743162d942c$export$f5bbd400c2f4426f = $2e61e743162d942c$var$z;

});

parcelRegister("4592M", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2f8ea4fbb75efe57$export$a7c73072b1a182ae; }, function (v) { return $2f8ea4fbb75efe57$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2f8ea4fbb75efe57$export$9f27bc3417b4524d; }, function (v) { return $2f8ea4fbb75efe57$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2f8ea4fbb75efe57$export$db77ccec0bb4ccac; }, function (v) { return $2f8ea4fbb75efe57$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2f8ea4fbb75efe57$export$8392c0c9d3dcbd35; }, function (v) { return $2f8ea4fbb75efe57$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2f8ea4fbb75efe57$export$ffb0004e005737fa; }, function (v) { return $2f8ea4fbb75efe57$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2f8ea4fbb75efe57$export$b624eff549462981; }, function (v) { return $2f8ea4fbb75efe57$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2f8ea4fbb75efe57$export$7897aa7841a5380c; }, function (v) { return $2f8ea4fbb75efe57$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2f8ea4fbb75efe57$export$602eac185826482c; }, function (v) { return $2f8ea4fbb75efe57$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2f8ea4fbb75efe57$export$e2c29f18771995cb; }, function (v) { return $2f8ea4fbb75efe57$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2f8ea4fbb75efe57$export$5f8d39834fd61797; }, function (v) { return $2f8ea4fbb75efe57$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2f8ea4fbb75efe57$export$74bf444e3cd11ea5; }, function (v) { return $2f8ea4fbb75efe57$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $2f8ea4fbb75efe57$export$998bcd577473dd93; }, function (v) { return $2f8ea4fbb75efe57$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2f8ea4fbb75efe57$export$92387174baf9b227; }, function (v) { return $2f8ea4fbb75efe57$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2f8ea4fbb75efe57$export$ec112efeb987d9c6; }, function (v) { return $2f8ea4fbb75efe57$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2f8ea4fbb75efe57$export$b706b080d889d2c9; }, function (v) { return $2f8ea4fbb75efe57$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2f8ea4fbb75efe57$export$5be5a87408f70ddc; }, function (v) { return $2f8ea4fbb75efe57$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2f8ea4fbb75efe57$export$45a5e7f76e0caa8d; }, function (v) { return $2f8ea4fbb75efe57$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2f8ea4fbb75efe57$export$455c2e768291efa6; }, function (v) { return $2f8ea4fbb75efe57$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2f8ea4fbb75efe57$export$9522e17588c12572; }, function (v) { return $2f8ea4fbb75efe57$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2f8ea4fbb75efe57$export$2110ac352bb060b9; }, function (v) { return $2f8ea4fbb75efe57$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2f8ea4fbb75efe57$export$56885ab8b9c456ab; }, function (v) { return $2f8ea4fbb75efe57$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2f8ea4fbb75efe57$export$d927fcb6adf8f9de; }, function (v) { return $2f8ea4fbb75efe57$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2f8ea4fbb75efe57$export$b82d16f27459e05a; }, function (v) { return $2f8ea4fbb75efe57$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2f8ea4fbb75efe57$export$522c17b4f5e123e8; }, function (v) { return $2f8ea4fbb75efe57$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2f8ea4fbb75efe57$export$1aabd8a0274ecfd6; }, function (v) { return $2f8ea4fbb75efe57$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $2f8ea4fbb75efe57$export$3d6c20d97e46b957; }, function (v) { return $2f8ea4fbb75efe57$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2f8ea4fbb75efe57$export$9b621391a187a31a; }, function (v) { return $2f8ea4fbb75efe57$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2f8ea4fbb75efe57$export$f5bbd400c2f4426f; }, function (v) { return $2f8ea4fbb75efe57$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2f8ea4fbb75efe57$export$a7c73072b1a182ae;
var $2f8ea4fbb75efe57$export$9f27bc3417b4524d;
var $2f8ea4fbb75efe57$export$db77ccec0bb4ccac;
var $2f8ea4fbb75efe57$export$8392c0c9d3dcbd35;
var $2f8ea4fbb75efe57$export$ffb0004e005737fa;
var $2f8ea4fbb75efe57$export$b624eff549462981;
var $2f8ea4fbb75efe57$export$7897aa7841a5380c;
var $2f8ea4fbb75efe57$export$602eac185826482c;
var $2f8ea4fbb75efe57$export$e2c29f18771995cb;
var $2f8ea4fbb75efe57$export$5f8d39834fd61797;
var $2f8ea4fbb75efe57$export$74bf444e3cd11ea5;
var $2f8ea4fbb75efe57$export$998bcd577473dd93;
var $2f8ea4fbb75efe57$export$92387174baf9b227;
var $2f8ea4fbb75efe57$export$ec112efeb987d9c6;
var $2f8ea4fbb75efe57$export$b706b080d889d2c9;
var $2f8ea4fbb75efe57$export$5be5a87408f70ddc;
var $2f8ea4fbb75efe57$export$45a5e7f76e0caa8d;
var $2f8ea4fbb75efe57$export$455c2e768291efa6;
var $2f8ea4fbb75efe57$export$9522e17588c12572;
var $2f8ea4fbb75efe57$export$2110ac352bb060b9;
var $2f8ea4fbb75efe57$export$56885ab8b9c456ab;
var $2f8ea4fbb75efe57$export$d927fcb6adf8f9de;
var $2f8ea4fbb75efe57$export$b82d16f27459e05a;
var $2f8ea4fbb75efe57$export$522c17b4f5e123e8;
var $2f8ea4fbb75efe57$export$1aabd8a0274ecfd6;
var $2f8ea4fbb75efe57$export$3d6c20d97e46b957;
var $2f8ea4fbb75efe57$export$9b621391a187a31a;
var $2f8ea4fbb75efe57$export$f5bbd400c2f4426f;
'use strict';
var $2f8ea4fbb75efe57$var$b = Symbol.for("react.element"), $2f8ea4fbb75efe57$var$c = Symbol.for("react.portal"), $2f8ea4fbb75efe57$var$d = Symbol.for("react.fragment"), $2f8ea4fbb75efe57$var$e = Symbol.for("react.strict_mode"), $2f8ea4fbb75efe57$var$f = Symbol.for("react.profiler"), $2f8ea4fbb75efe57$var$g = Symbol.for("react.provider"), $2f8ea4fbb75efe57$var$h = Symbol.for("react.context"), $2f8ea4fbb75efe57$var$k = Symbol.for("react.server_context"), $2f8ea4fbb75efe57$var$l = Symbol.for("react.forward_ref"), $2f8ea4fbb75efe57$var$m = Symbol.for("react.suspense"), $2f8ea4fbb75efe57$var$n = Symbol.for("react.suspense_list"), $2f8ea4fbb75efe57$var$p = Symbol.for("react.memo"), $2f8ea4fbb75efe57$var$q = Symbol.for("react.lazy"), $2f8ea4fbb75efe57$var$t = Symbol.for("react.offscreen"), $2f8ea4fbb75efe57$var$u;
$2f8ea4fbb75efe57$var$u = Symbol.for("react.module.reference");
function $2f8ea4fbb75efe57$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $2f8ea4fbb75efe57$var$b:
                switch(a = a.type, a){
                    case $2f8ea4fbb75efe57$var$d:
                    case $2f8ea4fbb75efe57$var$f:
                    case $2f8ea4fbb75efe57$var$e:
                    case $2f8ea4fbb75efe57$var$m:
                    case $2f8ea4fbb75efe57$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2f8ea4fbb75efe57$var$k:
                            case $2f8ea4fbb75efe57$var$h:
                            case $2f8ea4fbb75efe57$var$l:
                            case $2f8ea4fbb75efe57$var$q:
                            case $2f8ea4fbb75efe57$var$p:
                            case $2f8ea4fbb75efe57$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $2f8ea4fbb75efe57$var$c:
                return r;
        }
    }
}
$2f8ea4fbb75efe57$export$a7c73072b1a182ae = $2f8ea4fbb75efe57$var$h;
$2f8ea4fbb75efe57$export$9f27bc3417b4524d = $2f8ea4fbb75efe57$var$g;
$2f8ea4fbb75efe57$export$db77ccec0bb4ccac = $2f8ea4fbb75efe57$var$b;
$2f8ea4fbb75efe57$export$8392c0c9d3dcbd35 = $2f8ea4fbb75efe57$var$l;
$2f8ea4fbb75efe57$export$ffb0004e005737fa = $2f8ea4fbb75efe57$var$d;
$2f8ea4fbb75efe57$export$b624eff549462981 = $2f8ea4fbb75efe57$var$q;
$2f8ea4fbb75efe57$export$7897aa7841a5380c = $2f8ea4fbb75efe57$var$p;
$2f8ea4fbb75efe57$export$602eac185826482c = $2f8ea4fbb75efe57$var$c;
$2f8ea4fbb75efe57$export$e2c29f18771995cb = $2f8ea4fbb75efe57$var$f;
$2f8ea4fbb75efe57$export$5f8d39834fd61797 = $2f8ea4fbb75efe57$var$e;
$2f8ea4fbb75efe57$export$74bf444e3cd11ea5 = $2f8ea4fbb75efe57$var$m;
$2f8ea4fbb75efe57$export$998bcd577473dd93 = $2f8ea4fbb75efe57$var$n;
$2f8ea4fbb75efe57$export$92387174baf9b227 = function() {
    return !1;
};
$2f8ea4fbb75efe57$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2f8ea4fbb75efe57$export$b706b080d889d2c9 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$h;
};
$2f8ea4fbb75efe57$export$5be5a87408f70ddc = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$g;
};
$2f8ea4fbb75efe57$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2f8ea4fbb75efe57$var$b;
};
$2f8ea4fbb75efe57$export$455c2e768291efa6 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$l;
};
$2f8ea4fbb75efe57$export$9522e17588c12572 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$d;
};
$2f8ea4fbb75efe57$export$2110ac352bb060b9 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$q;
};
$2f8ea4fbb75efe57$export$56885ab8b9c456ab = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$p;
};
$2f8ea4fbb75efe57$export$d927fcb6adf8f9de = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$c;
};
$2f8ea4fbb75efe57$export$b82d16f27459e05a = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$f;
};
$2f8ea4fbb75efe57$export$522c17b4f5e123e8 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$e;
};
$2f8ea4fbb75efe57$export$1aabd8a0274ecfd6 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$m;
};
$2f8ea4fbb75efe57$export$3d6c20d97e46b957 = function(a) {
    return $2f8ea4fbb75efe57$var$v(a) === $2f8ea4fbb75efe57$var$n;
};
$2f8ea4fbb75efe57$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2f8ea4fbb75efe57$var$d || a === $2f8ea4fbb75efe57$var$f || a === $2f8ea4fbb75efe57$var$e || a === $2f8ea4fbb75efe57$var$m || a === $2f8ea4fbb75efe57$var$n || a === $2f8ea4fbb75efe57$var$t || "object" === typeof a && null !== a && (a.$$typeof === $2f8ea4fbb75efe57$var$q || a.$$typeof === $2f8ea4fbb75efe57$var$p || a.$$typeof === $2f8ea4fbb75efe57$var$g || a.$$typeof === $2f8ea4fbb75efe57$var$h || a.$$typeof === $2f8ea4fbb75efe57$var$l || a.$$typeof === $2f8ea4fbb75efe57$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$2f8ea4fbb75efe57$export$f5bbd400c2f4426f = $2f8ea4fbb75efe57$var$v;

});

parcelRegister("atqVQ", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

parcelRegister("56SzX", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $eY5vZ = parcelRequire("eY5vZ");
function $3b87d988559d2897$var$emptyFunction() {}
function $3b87d988559d2897$var$emptyFunctionWithReset() {}
$3b87d988559d2897$var$emptyFunctionWithReset.resetWarningCache = $3b87d988559d2897$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $eY5vZ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $3b87d988559d2897$var$emptyFunctionWithReset,
        resetWarningCache: $3b87d988559d2897$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("eY5vZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $ae5af2773ce29f76$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $ae5af2773ce29f76$var$ReactPropTypesSecret;

});


var $9584ffb48191d639$exports = {};
$parcel$extendImportMap({
    "3TXTY": "identifiers_logo.9d30579d.png",
    "fXFC6": "elixir_kitemark-60px.d5d618fa.png",
    "ePaEF": "individual_warnings.dcc95232.png",
    "dX9Cm": "warning_details.35e32745.png"
});

var $8e95fc83e6ec5c3c$exports = {};
'use strict';

$8e95fc83e6ec5c3c$exports = (parcelRequire("cTIdu"));



var $dBNnn = parcelRequire("dBNnn");

var $2NwrC = parcelRequire("2NwrC");
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $24Gq2 = parcelRequire("24Gq2");
var $452b980a53fc94dc$exports = {};
'use strict';

$452b980a53fc94dc$exports = (parcelRequire("dWZmh"));



var $a6afE = parcelRequire("a6afE");


var $a6afE = parcelRequire("a6afE");
// Default to a dummy "batch" implementation that just runs the callback
function $b10bc760ff4cf69c$var$defaultNoopBatch(callback) {
    callback();
}
let $b10bc760ff4cf69c$var$batch = $b10bc760ff4cf69c$var$defaultNoopBatch; // Allow injecting another batching function later
const $b10bc760ff4cf69c$export$4b9874722d0da7bc = (newBatch)=>$b10bc760ff4cf69c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $b10bc760ff4cf69c$export$fc47d4c0ba3bd2c6 = ()=>$b10bc760ff4cf69c$var$batch;



var $dBNnn = parcelRequire("dBNnn");

var $dBNnn = parcelRequire("dBNnn");

var $dBNnn = parcelRequire("dBNnn");
const $23b57d30696e087e$var$ContextKey = Symbol.for(`react-redux-context`);
const $23b57d30696e087e$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $23b57d30696e087e$var$getContext() {
    var _gT$ContextKey;
    if (!$dBNnn.createContext) return {};
    const contextMap = (_gT$ContextKey = $23b57d30696e087e$var$gT[$23b57d30696e087e$var$ContextKey]) != null ? _gT$ContextKey : $23b57d30696e087e$var$gT[$23b57d30696e087e$var$ContextKey] = new Map();
    let realContext = contextMap.get($dBNnn.createContext);
    if (!realContext) {
        realContext = $dBNnn.createContext(null);
        contextMap.set($dBNnn.createContext, realContext);
    }
    return realContext;
}
const $23b57d30696e087e$export$cc80c08dc91f1c00 = /*#__PURE__*/ $23b57d30696e087e$var$getContext();
var $23b57d30696e087e$export$2e2bcd8739ae039 = $23b57d30696e087e$export$cc80c08dc91f1c00;


function $5bc1767ead7bbd47$export$d4d6226d5fc61558(context = (0, $23b57d30696e087e$export$cc80c08dc91f1c00)) {
    return function useReduxContext() {
        const contextValue = (0, $dBNnn.useContext)(context);
        return contextValue;
    };
}
const $5bc1767ead7bbd47$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $5bc1767ead7bbd47$export$d4d6226d5fc61558();



const $8b5db137926ef54d$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};


let $c9816f21a8964acc$var$useSyncExternalStoreWithSelector = (0, $8b5db137926ef54d$export$20656a4825650bd0);
const $c9816f21a8964acc$export$e2e6e3f3f3b782e3 = (fn)=>{
    $c9816f21a8964acc$var$useSyncExternalStoreWithSelector = fn;
};
const $c9816f21a8964acc$var$refEquality = (a, b)=>a === b;
function $c9816f21a8964acc$export$2b53f90d2bd1cbfb(context = (0, $23b57d30696e087e$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $23b57d30696e087e$export$cc80c08dc91f1c00) ? (0, $5bc1767ead7bbd47$export$c1275ca9a6fd3ec5) : (0, $5bc1767ead7bbd47$export$d4d6226d5fc61558)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $c9816f21a8964acc$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $dBNnn.useRef)(true);
        const wrappedSelector = (0, $dBNnn.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $c9816f21a8964acc$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $dBNnn.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $c9816f21a8964acc$export$2105062e25df4afe = /*#__PURE__*/ $c9816f21a8964acc$export$2b53f90d2bd1cbfb();


function $6d83b9c16c5b75ae$export$2e2bcd8739ae039() {
    return $6d83b9c16c5b75ae$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $6d83b9c16c5b75ae$export$2e2bcd8739ae039.apply(null, arguments);
}


function $684ce3ba1bb7e6e5$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


var $2e2662c624c8c977$exports = {};
'use strict';
var $d57a99d581592c36$exports = {};
'use strict';

$d57a99d581592c36$exports = (parcelRequire("3YTlc"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $2e2662c624c8c977$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $2e2662c624c8c977$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $2e2662c624c8c977$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $2e2662c624c8c977$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $2e2662c624c8c977$var$TYPE_STATICS = {};
$2e2662c624c8c977$var$TYPE_STATICS[$d57a99d581592c36$exports.ForwardRef] = $2e2662c624c8c977$var$FORWARD_REF_STATICS;
$2e2662c624c8c977$var$TYPE_STATICS[$d57a99d581592c36$exports.Memo] = $2e2662c624c8c977$var$MEMO_STATICS;
function $2e2662c624c8c977$var$getStatics(component) {
    // React v16.11 and below
    if ($d57a99d581592c36$exports.isMemo(component)) return $2e2662c624c8c977$var$MEMO_STATICS;
     // React v16.12 and above
    return $2e2662c624c8c977$var$TYPE_STATICS[component['$$typeof']] || $2e2662c624c8c977$var$REACT_STATICS;
}
var $2e2662c624c8c977$var$defineProperty = Object.defineProperty;
var $2e2662c624c8c977$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $2e2662c624c8c977$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $2e2662c624c8c977$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $2e2662c624c8c977$var$getPrototypeOf = Object.getPrototypeOf;
var $2e2662c624c8c977$var$objectPrototype = Object.prototype;
function $2e2662c624c8c977$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($2e2662c624c8c977$var$objectPrototype) {
            var inheritedComponent = $2e2662c624c8c977$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $2e2662c624c8c977$var$objectPrototype) $2e2662c624c8c977$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $2e2662c624c8c977$var$getOwnPropertyNames(sourceComponent);
        if ($2e2662c624c8c977$var$getOwnPropertySymbols) keys = keys.concat($2e2662c624c8c977$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $2e2662c624c8c977$var$getStatics(targetComponent);
        var sourceStatics = $2e2662c624c8c977$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$2e2662c624c8c977$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $2e2662c624c8c977$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $2e2662c624c8c977$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$2e2662c624c8c977$exports = $2e2662c624c8c977$var$hoistNonReactStatics;



var $dBNnn = parcelRequire("dBNnn");
var $c98ed44d2d4feff5$exports = {};
'use strict';

$c98ed44d2d4feff5$exports = (parcelRequire("4592M"));



/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $a54f77c65244d363$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }


function $05be34b7472cfd70$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $a54f77c65244d363$export$2e2bcd8739ae039)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $05be34b7472cfd70$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $05be34b7472cfd70$var$verify(mapStateToProps, 'mapStateToProps');
    $05be34b7472cfd70$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $05be34b7472cfd70$var$verify(mergeProps, 'mergeProps');
}


const $0d436f7a74ca0651$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $0d436f7a74ca0651$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $0d436f7a74ca0651$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $684ce3ba1bb7e6e5$export$2e2bcd8739ae039)(_ref, $0d436f7a74ca0651$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $0d436f7a74ca0651$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}


function $f6bfe50ce8dddc1b$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}


/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d3ba52dddd968107$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}



function $9b0ceee554957a6b$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $d3ba52dddd968107$export$2e2bcd8739ae039)(value)) (0, $a54f77c65244d363$export$2e2bcd8739ae039)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}


function $78150e4b7718e80d$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $78150e4b7718e80d$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $78150e4b7718e80d$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $78150e4b7718e80d$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $78150e4b7718e80d$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}


function $32258be5c7b9c02d$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}


function $a40277bc51ce2aec$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $78150e4b7718e80d$export$710f7c60f68acd3e)((dispatch)=>(0, $f6bfe50ce8dddc1b$export$2e2bcd8739ae039)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $78150e4b7718e80d$export$710f7c60f68acd3e)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $78150e4b7718e80d$export$8d46c7f53c8c602f)(mapDispatchToProps, 'mapDispatchToProps') : (0, $32258be5c7b9c02d$export$19ef7b929f7e2559)(mapDispatchToProps, 'mapDispatchToProps');
}




function $c56dfcf50b6af26d$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $78150e4b7718e80d$export$710f7c60f68acd3e)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $78150e4b7718e80d$export$8d46c7f53c8c602f)(mapStateToProps, 'mapStateToProps') : (0, $32258be5c7b9c02d$export$19ef7b929f7e2559)(mapStateToProps, 'mapStateToProps');
}





function $56b7403dfe25ddc2$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6d83b9c16c5b75ae$export$2e2bcd8739ae039)({}, ownProps, stateProps, dispatchProps);
}
function $56b7403dfe25ddc2$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $56b7403dfe25ddc2$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$56b7403dfe25ddc2$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $56b7403dfe25ddc2$export$5b105939c84b5234(mergeProps) : (0, $32258be5c7b9c02d$export$19ef7b929f7e2559)(mergeProps, 'mergeProps');
}



// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $d1890946e050a52a$var$createListenerCollection() {
    const batch = (0, $b10bc760ff4cf69c$export$fc47d4c0ba3bd2c6)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $d1890946e050a52a$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $d1890946e050a52a$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $d1890946e050a52a$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $d1890946e050a52a$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $d1890946e050a52a$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}



var $dBNnn = parcelRequire("dBNnn");
const $1a31a91df424a204$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $1a31a91df424a204$export$700979bc83e7db82 = $1a31a91df424a204$export$71594e8a50f746f4 ? $dBNnn.useLayoutEffect : $dBNnn.useEffect;


function $ad810c5a6e144f90$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $ad810c5a6e144f90$export$2e2bcd8739ae039(objA, objB) {
    if ($ad810c5a6e144f90$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$ad810c5a6e144f90$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}





const $edfd7b4d382be2ae$var$_excluded = [
    "reactReduxForwardedRef"
];
let $edfd7b4d382be2ae$var$useSyncExternalStore = (0, $8b5db137926ef54d$export$20656a4825650bd0);
const $edfd7b4d382be2ae$export$36d45daa6a4925b8 = (fn)=>{
    $edfd7b4d382be2ae$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $edfd7b4d382be2ae$var$EMPTY_ARRAY = [
    null,
    0
];
const $edfd7b4d382be2ae$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $edfd7b4d382be2ae$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $edfd7b4d382be2ae$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $1a31a91df424a204$export$700979bc83e7db82)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $edfd7b4d382be2ae$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $edfd7b4d382be2ae$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $edfd7b4d382be2ae$var$initStateUpdates = ()=>$edfd7b4d382be2ae$var$EMPTY_ARRAY;
function $edfd7b4d382be2ae$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $edfd7b4d382be2ae$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $edfd7b4d382be2ae$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $edfd7b4d382be2ae$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $ad810c5a6e144f90$export$2e2bcd8739ae039), areStatePropsEqual: areStatePropsEqual = (0, $ad810c5a6e144f90$export$2e2bcd8739ae039), areMergedPropsEqual: areMergedPropsEqual = (0, $ad810c5a6e144f90$export$2e2bcd8739ae039), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $23b57d30696e087e$export$cc80c08dc91f1c00) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $c56dfcf50b6af26d$export$e00e93951827eda7)(mapStateToProps);
    const initMapDispatchToProps = (0, $a40277bc51ce2aec$export$b69a785ceac019a6)(mapDispatchToProps);
    const initMergeProps = (0, $56b7403dfe25ddc2$export$17457cf6fa742f84)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $dBNnn.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $684ce3ba1bb7e6e5$export$2e2bcd8739ae039)(props, $edfd7b4d382be2ae$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $dBNnn.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $c98ed44d2d4feff5$exports.isContextConsumer)(/*#__PURE__*/ $dBNnn.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $dBNnn.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $dBNnn.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $0d436f7a74ca0651$export$2e2bcd8739ae039)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $dBNnn.useMemo(()=>{
                if (!shouldHandleStateChanges) return $edfd7b4d382be2ae$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $d1890946e050a52a$export$d567d2b9af322f8f)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $dBNnn.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6d83b9c16c5b75ae$export$2e2bcd8739ae039)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $dBNnn.useRef();
            const lastWrapperProps = $dBNnn.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $dBNnn.useRef();
            const renderIsScheduled = $dBNnn.useRef(false);
            const isProcessingDispatch = $dBNnn.useRef(false);
            const isMounted = $dBNnn.useRef(false);
            const latestSubscriptionCallbackError = $dBNnn.useRef();
            (0, $1a31a91df424a204$export$700979bc83e7db82)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $dBNnn.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $dBNnn.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $edfd7b4d382be2ae$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $edfd7b4d382be2ae$var$useIsomorphicLayoutEffectWithArgs($edfd7b4d382be2ae$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $edfd7b4d382be2ae$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $1a31a91df424a204$export$700979bc83e7db82)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $dBNnn.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $dBNnn.createElement(WrappedComponent, (0, $6d83b9c16c5b75ae$export$2e2bcd8739ae039)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $dBNnn.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $dBNnn.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $dBNnn.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $dBNnn.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $dBNnn.createElement(Connect, (0, $6d83b9c16c5b75ae$export$2e2bcd8739ae039)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($2e2662c624c8c977$exports)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($2e2662c624c8c977$exports)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $edfd7b4d382be2ae$export$2e2bcd8739ae039 = $edfd7b4d382be2ae$var$connect;



var $dBNnn = parcelRequire("dBNnn");



function $91c02eb1486780d6$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $dBNnn.useMemo(()=>{
        const subscription = (0, $d1890946e050a52a$export$d567d2b9af322f8f)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $dBNnn.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $1a31a91df424a204$export$700979bc83e7db82)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $23b57d30696e087e$export$cc80c08dc91f1c00); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $dBNnn.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $91c02eb1486780d6$export$2e2bcd8739ae039 = $91c02eb1486780d6$var$Provider;







function $26422081f4967f53$export$671dba69185d0304(context = (0, $23b57d30696e087e$export$cc80c08dc91f1c00)) {
    const useReduxContext = context === (0, $23b57d30696e087e$export$cc80c08dc91f1c00) ? (0, $5bc1767ead7bbd47$export$c1275ca9a6fd3ec5) : (0, $5bc1767ead7bbd47$export$d4d6226d5fc61558)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $26422081f4967f53$export$6ccbb43953eebf8 = /*#__PURE__*/ $26422081f4967f53$export$671dba69185d0304();


function $12f5a04711fdbb0b$export$bc9b55530897c558(context = (0, $23b57d30696e087e$export$cc80c08dc91f1c00)) {
    const useStore = context === (0, $23b57d30696e087e$export$cc80c08dc91f1c00) ? (0, $26422081f4967f53$export$6ccbb43953eebf8) : (0, $26422081f4967f53$export$671dba69185d0304)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $12f5a04711fdbb0b$export$8ad76b76a4c905f8 = /*#__PURE__*/ $12f5a04711fdbb0b$export$bc9b55530897c558();









(0, $c9816f21a8964acc$export$e2e6e3f3f3b782e3)((0, $452b980a53fc94dc$exports.useSyncExternalStoreWithSelector));
(0, $edfd7b4d382be2ae$export$36d45daa6a4925b8)((0, $24Gq2.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $b10bc760ff4cf69c$export$4b9874722d0da7bc)((0, $a6afE.unstable_batchedUpdates));



var $atqVQ = parcelRequire("atqVQ");
function $de87e354bfed880f$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $de87e354bfed880f$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $de87e354bfed880f$export$2e2bcd8739ae039(o);
}



function $0c9f9ec4c6d02d77$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $de87e354bfed880f$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $de87e354bfed880f$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $d626872890ea3800$export$2e2bcd8739ae039(t) {
    var i = (0, $0c9f9ec4c6d02d77$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $de87e354bfed880f$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $d1642800038ca25d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $d626872890ea3800$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $e6834c4c8af113ac$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6834c4c8af113ac$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6834c4c8af113ac$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $d1642800038ca25d$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6834c4c8af113ac$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $d06d39bd9e9b7dd2$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $d06d39bd9e9b7dd2$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $d06d39bd9e9b7dd2$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $d06d39bd9e9b7dd2$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $d06d39bd9e9b7dd2$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $d06d39bd9e9b7dd2$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $d06d39bd9e9b7dd2$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $d06d39bd9e9b7dd2$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $d06d39bd9e9b7dd2$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($d06d39bd9e9b7dd2$var$isDate(val)) return 'date';
    if ($d06d39bd9e9b7dd2$var$isError(val)) return 'error';
    var constructorName = $d06d39bd9e9b7dd2$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $d06d39bd9e9b7dd2$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $d06d39bd9e9b7dd2$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $d06d39bd9e9b7dd2$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $d06d39bd9e9b7dd2$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $d06d39bd9e9b7dd2$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(1));
        return enhancer($d06d39bd9e9b7dd2$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$d06d39bd9e9b7dd2$var$isPlainObject(action)) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $d06d39bd9e9b7dd2$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$d06d39bd9e9b7dd2$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $d06d39bd9e9b7dd2$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$d06d39bd9e9b7dd2$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $d06d39bd9e9b7dd2$export$8928921ea2d3b126 = $d06d39bd9e9b7dd2$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $d06d39bd9e9b7dd2$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $d06d39bd9e9b7dd2$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $d06d39bd9e9b7dd2$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$d06d39bd9e9b7dd2$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $d06d39bd9e9b7dd2$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $d06d39bd9e9b7dd2$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $d06d39bd9e9b7dd2$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $d06d39bd9e9b7dd2$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $d06d39bd9e9b7dd2$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $d06d39bd9e9b7dd2$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $d06d39bd9e9b7dd2$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $d06d39bd9e9b7dd2$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $d06d39bd9e9b7dd2$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $d06d39bd9e9b7dd2$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $d06d39bd9e9b7dd2$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $d06d39bd9e9b7dd2$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $d06d39bd9e9b7dd2$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($d06d39bd9e9b7dd2$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $d06d39bd9e9b7dd2$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $e6834c4c8af113ac$export$2e2bcd8739ae039)((0, $e6834c4c8af113ac$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}


/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $cda3b149c8af48da$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === 'function') // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $cda3b149c8af48da$var$thunk = $cda3b149c8af48da$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$cda3b149c8af48da$var$thunk.withExtraArgument = $cda3b149c8af48da$var$createThunkMiddleware;
var $cda3b149c8af48da$export$2e2bcd8739ae039 = $cda3b149c8af48da$var$thunk;


// Keycloak.
/*
 * Copyright 2016 Red Hat, Inc. and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $0557b67206af4d36$var$Keycloak(config) {
    if (!(this instanceof $0557b67206af4d36$var$Keycloak)) throw new Error("The 'Keycloak' constructor must be invoked with 'new'.");
    if (typeof config !== 'string' && !$0557b67206af4d36$var$isObject(config)) throw new Error("The 'Keycloak' constructor must be provided with a configuration object, or a URL to a JSON configuration file.");
    if ($0557b67206af4d36$var$isObject(config)) {
        const requiredProperties = 'oidcProvider' in config ? [
            'clientId'
        ] : [
            'url',
            'realm',
            'clientId'
        ];
        for (const property of requiredProperties){
            if (!config[property]) throw new Error(`The configuration object is missing the required '${property}' property.`);
        }
    }
    var kc = this;
    var adapter;
    var refreshQueue = [];
    var callbackStorage;
    var loginIframe = {
        enable: true,
        callbackList: [],
        interval: 5
    };
    kc.didInitialize = false;
    var useNonce = true;
    var logInfo = createLogger(console.info);
    var logWarn = createLogger(console.warn);
    if (!globalThis.isSecureContext) logWarn("[KEYCLOAK] Keycloak JS must be used in a 'secure context' to function properly as it relies on browser APIs that are otherwise not available.\nContinuing to run your application insecurely will lead to unexpected behavior and breakage.\n\nFor more information see: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts");
    kc.init = function(initOptions = {}) {
        if (kc.didInitialize) throw new Error("A 'Keycloak' instance can only be initialized once.");
        kc.didInitialize = true;
        kc.authenticated = false;
        callbackStorage = createCallbackStorage();
        var adapters = [
            'default',
            'cordova',
            'cordova-native'
        ];
        if (adapters.indexOf(initOptions.adapter) > -1) adapter = loadAdapter(initOptions.adapter);
        else if (typeof initOptions.adapter === "object") adapter = initOptions.adapter;
        else if (window.Cordova || window.cordova) adapter = loadAdapter('cordova');
        else adapter = loadAdapter();
        if (typeof initOptions.useNonce !== 'undefined') useNonce = initOptions.useNonce;
        if (typeof initOptions.checkLoginIframe !== 'undefined') loginIframe.enable = initOptions.checkLoginIframe;
        if (initOptions.checkLoginIframeInterval) loginIframe.interval = initOptions.checkLoginIframeInterval;
        if (initOptions.onLoad === 'login-required') kc.loginRequired = true;
        if (initOptions.responseMode) {
            if (initOptions.responseMode === 'query' || initOptions.responseMode === 'fragment') kc.responseMode = initOptions.responseMode;
            else throw 'Invalid value for responseMode';
        }
        if (initOptions.flow) {
            switch(initOptions.flow){
                case 'standard':
                    kc.responseType = 'code';
                    break;
                case 'implicit':
                    kc.responseType = 'id_token token';
                    break;
                case 'hybrid':
                    kc.responseType = 'code id_token token';
                    break;
                default:
                    throw 'Invalid value for flow';
            }
            kc.flow = initOptions.flow;
        }
        if (initOptions.timeSkew != null) kc.timeSkew = initOptions.timeSkew;
        if (initOptions.redirectUri) kc.redirectUri = initOptions.redirectUri;
        if (initOptions.silentCheckSsoRedirectUri) kc.silentCheckSsoRedirectUri = initOptions.silentCheckSsoRedirectUri;
        if (typeof initOptions.silentCheckSsoFallback === 'boolean') kc.silentCheckSsoFallback = initOptions.silentCheckSsoFallback;
        else kc.silentCheckSsoFallback = true;
        if (typeof initOptions.pkceMethod !== "undefined") {
            if (initOptions.pkceMethod !== "S256" && initOptions.pkceMethod !== false) throw new TypeError(`Invalid value for pkceMethod', expected 'S256' or false but got ${initOptions.pkceMethod}.`);
            kc.pkceMethod = initOptions.pkceMethod;
        } else kc.pkceMethod = "S256";
        if (typeof initOptions.enableLogging === 'boolean') kc.enableLogging = initOptions.enableLogging;
        else kc.enableLogging = false;
        if (initOptions.logoutMethod === 'POST') kc.logoutMethod = 'POST';
        else kc.logoutMethod = 'GET';
        if (typeof initOptions.scope === 'string') kc.scope = initOptions.scope;
        if (typeof initOptions.acrValues === 'string') kc.acrValues = initOptions.acrValues;
        if (typeof initOptions.messageReceiveTimeout === 'number' && initOptions.messageReceiveTimeout > 0) kc.messageReceiveTimeout = initOptions.messageReceiveTimeout;
        else kc.messageReceiveTimeout = 10000;
        if (!kc.responseMode) kc.responseMode = 'fragment';
        if (!kc.responseType) {
            kc.responseType = 'code';
            kc.flow = 'standard';
        }
        var promise = createPromise();
        var initPromise = createPromise();
        initPromise.promise.then(function() {
            kc.onReady && kc.onReady(kc.authenticated);
            promise.setSuccess(kc.authenticated);
        }).catch(function(error) {
            promise.setError(error);
        });
        var configPromise = loadConfig();
        function onLoad() {
            var doLogin = function(prompt) {
                if (!prompt) options.prompt = 'none';
                if (initOptions.locale) options.locale = initOptions.locale;
                kc.login(options).then(function() {
                    initPromise.setSuccess();
                }).catch(function(error) {
                    initPromise.setError(error);
                });
            };
            var checkSsoSilently = async function() {
                var ifrm = document.createElement("iframe");
                var src = await kc.createLoginUrl({
                    prompt: 'none',
                    redirectUri: kc.silentCheckSsoRedirectUri
                });
                ifrm.setAttribute("src", src);
                ifrm.setAttribute("sandbox", "allow-storage-access-by-user-activation allow-scripts allow-same-origin");
                ifrm.setAttribute("title", "keycloak-silent-check-sso");
                ifrm.style.display = "none";
                document.body.appendChild(ifrm);
                var messageCallback = function(event) {
                    if (event.origin !== window.location.origin || ifrm.contentWindow !== event.source) return;
                    var oauth = parseCallback(event.data);
                    processCallback(oauth, initPromise);
                    document.body.removeChild(ifrm);
                    window.removeEventListener("message", messageCallback);
                };
                window.addEventListener("message", messageCallback);
            };
            var options = {};
            switch(initOptions.onLoad){
                case 'check-sso':
                    if (loginIframe.enable) setupCheckLoginIframe().then(function() {
                        checkLoginIframe().then(function(unchanged) {
                            if (!unchanged) kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                            else initPromise.setSuccess();
                        }).catch(function(error) {
                            initPromise.setError(error);
                        });
                    });
                    else kc.silentCheckSsoRedirectUri ? checkSsoSilently() : doLogin(false);
                    break;
                case 'login-required':
                    doLogin(true);
                    break;
                default:
                    throw 'Invalid value for onLoad';
            }
        }
        function processInit() {
            var callback = parseCallback(window.location.href);
            if (callback) window.history.replaceState(window.history.state, null, callback.newUrl);
            if (callback && callback.valid) return setupCheckLoginIframe().then(function() {
                processCallback(callback, initPromise);
            }).catch(function(error) {
                initPromise.setError(error);
            });
            if (initOptions.token && initOptions.refreshToken) {
                setToken(initOptions.token, initOptions.refreshToken, initOptions.idToken);
                if (loginIframe.enable) setupCheckLoginIframe().then(function() {
                    checkLoginIframe().then(function(unchanged) {
                        if (unchanged) {
                            kc.onAuthSuccess && kc.onAuthSuccess();
                            initPromise.setSuccess();
                            scheduleCheckIframe();
                        } else initPromise.setSuccess();
                    }).catch(function(error) {
                        initPromise.setError(error);
                    });
                });
                else kc.updateToken(-1).then(function() {
                    kc.onAuthSuccess && kc.onAuthSuccess();
                    initPromise.setSuccess();
                }).catch(function(error) {
                    kc.onAuthError && kc.onAuthError();
                    if (initOptions.onLoad) onLoad();
                    else initPromise.setError(error);
                });
            } else if (initOptions.onLoad) onLoad();
            else initPromise.setSuccess();
        }
        configPromise.then(function() {
            check3pCookiesSupported().then(processInit).catch(function(error) {
                promise.setError(error);
            });
        });
        configPromise.catch(function(error) {
            promise.setError(error);
        });
        return promise.promise;
    };
    kc.login = function(options) {
        return adapter.login(options);
    };
    function generateRandomData(len) {
        if (typeof crypto === "undefined" || typeof crypto.getRandomValues === "undefined") throw new Error("Web Crypto API is not available.");
        return crypto.getRandomValues(new Uint8Array(len));
    }
    function generateCodeVerifier(len) {
        return generateRandomString(len, 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789');
    }
    function generateRandomString(len, alphabet) {
        var randomData = generateRandomData(len);
        var chars = new Array(len);
        for(var i = 0; i < len; i++)chars[i] = alphabet.charCodeAt(randomData[i] % alphabet.length);
        return String.fromCharCode.apply(null, chars);
    }
    async function generatePkceChallenge(pkceMethod, codeVerifier) {
        if (pkceMethod !== "S256") throw new TypeError(`Invalid value for 'pkceMethod', expected 'S256' but got '${pkceMethod}'.`);
        // hash codeVerifier, then encode as url-safe base64 without padding
        const hashBytes = new Uint8Array(await $0557b67206af4d36$var$sha256Digest(codeVerifier));
        const encodedHash = $0557b67206af4d36$var$bytesToBase64(hashBytes).replace(/\+/g, '-').replace(/\//g, '_').replace(/\=/g, '');
        return encodedHash;
    }
    function buildClaimsParameter(requestedAcr) {
        var claims = {
            id_token: {
                acr: requestedAcr
            }
        };
        return JSON.stringify(claims);
    }
    kc.createLoginUrl = async function(options) {
        var state = createUUID();
        var nonce = createUUID();
        var redirectUri = adapter.redirectUri(options);
        var callbackState = {
            state: state,
            nonce: nonce,
            redirectUri: encodeURIComponent(redirectUri),
            loginOptions: options
        };
        if (options && options.prompt) callbackState.prompt = options.prompt;
        var baseUrl;
        if (options && options.action == 'register') baseUrl = kc.endpoints.register();
        else baseUrl = kc.endpoints.authorize();
        var scope = options && options.scope || kc.scope;
        if (!scope) // if scope is not set, default to "openid"
        scope = "openid";
        else if (scope.indexOf("openid") === -1) // if openid scope is missing, prefix the given scopes with it
        scope = "openid " + scope;
        var url = baseUrl + '?client_id=' + encodeURIComponent(kc.clientId) + '&redirect_uri=' + encodeURIComponent(redirectUri) + '&state=' + encodeURIComponent(state) + '&response_mode=' + encodeURIComponent(kc.responseMode) + '&response_type=' + encodeURIComponent(kc.responseType) + '&scope=' + encodeURIComponent(scope);
        if (useNonce) url = url + '&nonce=' + encodeURIComponent(nonce);
        if (options && options.prompt) url += '&prompt=' + encodeURIComponent(options.prompt);
        if (options && typeof options.maxAge === 'number') url += '&max_age=' + encodeURIComponent(options.maxAge);
        if (options && options.loginHint) url += '&login_hint=' + encodeURIComponent(options.loginHint);
        if (options && options.idpHint) url += '&kc_idp_hint=' + encodeURIComponent(options.idpHint);
        if (options && options.action && options.action != 'register') url += '&kc_action=' + encodeURIComponent(options.action);
        if (options && options.locale) url += '&ui_locales=' + encodeURIComponent(options.locale);
        if (options && options.acr) {
            var claimsParameter = buildClaimsParameter(options.acr);
            url += '&claims=' + encodeURIComponent(claimsParameter);
        }
        if (options && options.acrValues || kc.acrValues) url += '&acr_values=' + encodeURIComponent(options.acrValues || kc.acrValues);
        if (kc.pkceMethod) try {
            const codeVerifier = generateCodeVerifier(96);
            const pkceChallenge = await generatePkceChallenge(kc.pkceMethod, codeVerifier);
            callbackState.pkceCodeVerifier = codeVerifier;
            url += '&code_challenge=' + pkceChallenge;
            url += '&code_challenge_method=' + kc.pkceMethod;
        } catch (error) {
            throw new Error("Failed to generate PKCE challenge.", {
                cause: error
            });
        }
        callbackStorage.add(callbackState);
        return url;
    };
    kc.logout = function(options) {
        return adapter.logout(options);
    };
    kc.createLogoutUrl = function(options) {
        const logoutMethod = options?.logoutMethod ?? kc.logoutMethod;
        if (logoutMethod === 'POST') return kc.endpoints.logout();
        var url = kc.endpoints.logout() + '?client_id=' + encodeURIComponent(kc.clientId) + '&post_logout_redirect_uri=' + encodeURIComponent(adapter.redirectUri(options, false));
        if (kc.idToken) url += '&id_token_hint=' + encodeURIComponent(kc.idToken);
        return url;
    };
    kc.register = function(options) {
        return adapter.register(options);
    };
    kc.createRegisterUrl = async function(options) {
        if (!options) options = {};
        options.action = 'register';
        return await kc.createLoginUrl(options);
    };
    kc.createAccountUrl = function(options) {
        var realm = getRealmUrl();
        var url = undefined;
        if (typeof realm !== 'undefined') url = realm + '/account' + '?referrer=' + encodeURIComponent(kc.clientId) + '&referrer_uri=' + encodeURIComponent(adapter.redirectUri(options));
        return url;
    };
    kc.accountManagement = function() {
        return adapter.accountManagement();
    };
    kc.hasRealmRole = function(role) {
        var access = kc.realmAccess;
        return !!access && access.roles.indexOf(role) >= 0;
    };
    kc.hasResourceRole = function(role, resource) {
        if (!kc.resourceAccess) return false;
        var access = kc.resourceAccess[resource || kc.clientId];
        return !!access && access.roles.indexOf(role) >= 0;
    };
    kc.loadUserProfile = function() {
        var url = getRealmUrl() + '/account';
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);
        var promise = createPromise();
        req.onreadystatechange = function() {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.profile = JSON.parse(req.responseText);
                    promise.setSuccess(kc.profile);
                } else promise.setError();
            }
        };
        req.send();
        return promise.promise;
    };
    kc.loadUserInfo = function() {
        var url = kc.endpoints.userinfo();
        var req = new XMLHttpRequest();
        req.open('GET', url, true);
        req.setRequestHeader('Accept', 'application/json');
        req.setRequestHeader('Authorization', 'bearer ' + kc.token);
        var promise = createPromise();
        req.onreadystatechange = function() {
            if (req.readyState == 4) {
                if (req.status == 200) {
                    kc.userInfo = JSON.parse(req.responseText);
                    promise.setSuccess(kc.userInfo);
                } else promise.setError();
            }
        };
        req.send();
        return promise.promise;
    };
    kc.isTokenExpired = function(minValidity) {
        if (!kc.tokenParsed || !kc.refreshToken && kc.flow != 'implicit') throw 'Not authenticated';
        if (kc.timeSkew == null) {
            logInfo('[KEYCLOAK] Unable to determine if token is expired as timeskew is not set');
            return true;
        }
        var expiresIn = kc.tokenParsed['exp'] - Math.ceil(new Date().getTime() / 1000) + kc.timeSkew;
        if (minValidity) {
            if (isNaN(minValidity)) throw 'Invalid minValidity';
            expiresIn -= minValidity;
        }
        return expiresIn < 0;
    };
    kc.updateToken = function(minValidity) {
        var promise = createPromise();
        if (!kc.refreshToken) {
            promise.setError();
            return promise.promise;
        }
        minValidity = minValidity || 5;
        var exec = function() {
            var refreshToken = false;
            if (minValidity == -1) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: forced refresh');
            } else if (!kc.tokenParsed || kc.isTokenExpired(minValidity)) {
                refreshToken = true;
                logInfo('[KEYCLOAK] Refreshing token: token expired');
            }
            if (!refreshToken) promise.setSuccess(false);
            else {
                var params = "grant_type=refresh_token&refresh_token=" + kc.refreshToken;
                var url = kc.endpoints.token();
                refreshQueue.push(promise);
                if (refreshQueue.length == 1) {
                    var req = new XMLHttpRequest();
                    req.open('POST', url, true);
                    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                    req.withCredentials = true;
                    params += '&client_id=' + encodeURIComponent(kc.clientId);
                    var timeLocal = new Date().getTime();
                    req.onreadystatechange = function() {
                        if (req.readyState == 4) {
                            if (req.status == 200) {
                                logInfo('[KEYCLOAK] Token refreshed');
                                timeLocal = (timeLocal + new Date().getTime()) / 2;
                                var tokenResponse = JSON.parse(req.responseText);
                                setToken(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], timeLocal);
                                kc.onAuthRefreshSuccess && kc.onAuthRefreshSuccess();
                                for(var p = refreshQueue.pop(); p != null; p = refreshQueue.pop())p.setSuccess(true);
                            } else {
                                logWarn('[KEYCLOAK] Failed to refresh token');
                                if (req.status == 400) kc.clearToken();
                                kc.onAuthRefreshError && kc.onAuthRefreshError();
                                for(var p = refreshQueue.pop(); p != null; p = refreshQueue.pop())p.setError("Failed to refresh token: An unexpected HTTP error occurred while attempting to refresh the token.");
                            }
                        }
                    };
                    req.send(params);
                }
            }
        };
        if (loginIframe.enable) {
            var iframePromise = checkLoginIframe();
            iframePromise.then(function() {
                exec();
            }).catch(function(error) {
                promise.setError(error);
            });
        } else exec();
        return promise.promise;
    };
    kc.clearToken = function() {
        if (kc.token) {
            setToken(null, null, null);
            kc.onAuthLogout && kc.onAuthLogout();
            if (kc.loginRequired) kc.login();
        }
    };
    function getRealmUrl() {
        if (typeof kc.authServerUrl !== 'undefined') {
            if (kc.authServerUrl.charAt(kc.authServerUrl.length - 1) == '/') return kc.authServerUrl + 'realms/' + encodeURIComponent(kc.realm);
            else return kc.authServerUrl + '/realms/' + encodeURIComponent(kc.realm);
        } else return undefined;
    }
    function getOrigin() {
        if (!window.location.origin) return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        else return window.location.origin;
    }
    function processCallback(oauth, promise) {
        var code = oauth.code;
        var error = oauth.error;
        var prompt = oauth.prompt;
        var timeLocal = new Date().getTime();
        if (oauth['kc_action_status']) kc.onActionUpdate && kc.onActionUpdate(oauth['kc_action_status'], oauth['kc_action']);
        if (error) {
            if (prompt != 'none') {
                if (oauth.error_description && oauth.error_description === "authentication_expired") kc.login(oauth.loginOptions);
                else {
                    var errorData = {
                        error: error,
                        error_description: oauth.error_description
                    };
                    kc.onAuthError && kc.onAuthError(errorData);
                    promise && promise.setError(errorData);
                }
            } else promise && promise.setSuccess();
            return;
        } else if (kc.flow != 'standard' && (oauth.access_token || oauth.id_token)) authSuccess(oauth.access_token, null, oauth.id_token, true);
        if (kc.flow != 'implicit' && code) {
            var params = 'code=' + code + '&grant_type=authorization_code';
            var url = kc.endpoints.token();
            var req = new XMLHttpRequest();
            req.open('POST', url, true);
            req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            params += '&client_id=' + encodeURIComponent(kc.clientId);
            params += '&redirect_uri=' + oauth.redirectUri;
            if (oauth.pkceCodeVerifier) params += '&code_verifier=' + oauth.pkceCodeVerifier;
            req.withCredentials = true;
            req.onreadystatechange = function() {
                if (req.readyState == 4) {
                    if (req.status == 200) {
                        var tokenResponse = JSON.parse(req.responseText);
                        authSuccess(tokenResponse['access_token'], tokenResponse['refresh_token'], tokenResponse['id_token'], kc.flow === 'standard');
                        scheduleCheckIframe();
                    } else {
                        kc.onAuthError && kc.onAuthError();
                        promise && promise.setError();
                    }
                }
            };
            req.send(params);
        }
        function authSuccess(accessToken, refreshToken, idToken, fulfillPromise) {
            timeLocal = (timeLocal + new Date().getTime()) / 2;
            setToken(accessToken, refreshToken, idToken, timeLocal);
            if (useNonce && kc.idTokenParsed && kc.idTokenParsed.nonce != oauth.storedNonce) {
                logInfo('[KEYCLOAK] Invalid nonce, clearing token');
                kc.clearToken();
                promise && promise.setError();
            } else if (fulfillPromise) {
                kc.onAuthSuccess && kc.onAuthSuccess();
                promise && promise.setSuccess();
            }
        }
    }
    function loadConfig() {
        var promise = createPromise();
        var configUrl;
        if (typeof config === 'string') configUrl = config;
        function setupOidcEndoints(oidcConfiguration) {
            if (!oidcConfiguration) kc.endpoints = {
                authorize: function() {
                    return getRealmUrl() + '/protocol/openid-connect/auth';
                },
                token: function() {
                    return getRealmUrl() + '/protocol/openid-connect/token';
                },
                logout: function() {
                    return getRealmUrl() + '/protocol/openid-connect/logout';
                },
                checkSessionIframe: function() {
                    return getRealmUrl() + '/protocol/openid-connect/login-status-iframe.html';
                },
                thirdPartyCookiesIframe: function() {
                    return getRealmUrl() + '/protocol/openid-connect/3p-cookies/step1.html';
                },
                register: function() {
                    return getRealmUrl() + '/protocol/openid-connect/registrations';
                },
                userinfo: function() {
                    return getRealmUrl() + '/protocol/openid-connect/userinfo';
                }
            };
            else kc.endpoints = {
                authorize: function() {
                    return oidcConfiguration.authorization_endpoint;
                },
                token: function() {
                    return oidcConfiguration.token_endpoint;
                },
                logout: function() {
                    if (!oidcConfiguration.end_session_endpoint) throw "Not supported by the OIDC server";
                    return oidcConfiguration.end_session_endpoint;
                },
                checkSessionIframe: function() {
                    if (!oidcConfiguration.check_session_iframe) throw "Not supported by the OIDC server";
                    return oidcConfiguration.check_session_iframe;
                },
                register: function() {
                    throw 'Redirection to "Register user" page not supported in standard OIDC mode';
                },
                userinfo: function() {
                    if (!oidcConfiguration.userinfo_endpoint) throw "Not supported by the OIDC server";
                    return oidcConfiguration.userinfo_endpoint;
                }
            };
        }
        if (configUrl) {
            var req = new XMLHttpRequest();
            req.open('GET', configUrl, true);
            req.setRequestHeader('Accept', 'application/json');
            req.onreadystatechange = function() {
                if (req.readyState == 4) {
                    if (req.status == 200 || fileLoaded(req)) {
                        var config = JSON.parse(req.responseText);
                        kc.authServerUrl = config['auth-server-url'];
                        kc.realm = config['realm'];
                        kc.clientId = config['resource'];
                        setupOidcEndoints(null);
                        promise.setSuccess();
                    } else promise.setError();
                }
            };
            req.send();
        } else {
            kc.clientId = config.clientId;
            var oidcProvider = config['oidcProvider'];
            if (!oidcProvider) {
                kc.authServerUrl = config.url;
                kc.realm = config.realm;
                setupOidcEndoints(null);
                promise.setSuccess();
            } else if (typeof oidcProvider === 'string') {
                var oidcProviderConfigUrl;
                if (oidcProvider.charAt(oidcProvider.length - 1) == '/') oidcProviderConfigUrl = oidcProvider + '.well-known/openid-configuration';
                else oidcProviderConfigUrl = oidcProvider + '/.well-known/openid-configuration';
                var req = new XMLHttpRequest();
                req.open('GET', oidcProviderConfigUrl, true);
                req.setRequestHeader('Accept', 'application/json');
                req.onreadystatechange = function() {
                    if (req.readyState == 4) {
                        if (req.status == 200 || fileLoaded(req)) {
                            var oidcProviderConfig = JSON.parse(req.responseText);
                            setupOidcEndoints(oidcProviderConfig);
                            promise.setSuccess();
                        } else promise.setError();
                    }
                };
                req.send();
            } else {
                setupOidcEndoints(oidcProvider);
                promise.setSuccess();
            }
        }
        return promise.promise;
    }
    function fileLoaded(xhr) {
        return xhr.status == 0 && xhr.responseText && xhr.responseURL.startsWith('file:');
    }
    function setToken(token, refreshToken, idToken, timeLocal) {
        if (kc.tokenTimeoutHandle) {
            clearTimeout(kc.tokenTimeoutHandle);
            kc.tokenTimeoutHandle = null;
        }
        if (refreshToken) {
            kc.refreshToken = refreshToken;
            kc.refreshTokenParsed = $0557b67206af4d36$var$decodeToken(refreshToken);
        } else {
            delete kc.refreshToken;
            delete kc.refreshTokenParsed;
        }
        if (idToken) {
            kc.idToken = idToken;
            kc.idTokenParsed = $0557b67206af4d36$var$decodeToken(idToken);
        } else {
            delete kc.idToken;
            delete kc.idTokenParsed;
        }
        if (token) {
            kc.token = token;
            kc.tokenParsed = $0557b67206af4d36$var$decodeToken(token);
            kc.sessionId = kc.tokenParsed.sid;
            kc.authenticated = true;
            kc.subject = kc.tokenParsed.sub;
            kc.realmAccess = kc.tokenParsed.realm_access;
            kc.resourceAccess = kc.tokenParsed.resource_access;
            if (timeLocal) kc.timeSkew = Math.floor(timeLocal / 1000) - kc.tokenParsed.iat;
            if (kc.timeSkew != null) {
                logInfo('[KEYCLOAK] Estimated time difference between browser and server is ' + kc.timeSkew + ' seconds');
                if (kc.onTokenExpired) {
                    var expiresIn = (kc.tokenParsed['exp'] - new Date().getTime() / 1000 + kc.timeSkew) * 1000;
                    logInfo('[KEYCLOAK] Token expires in ' + Math.round(expiresIn / 1000) + ' s');
                    if (expiresIn <= 0) kc.onTokenExpired();
                    else kc.tokenTimeoutHandle = setTimeout(kc.onTokenExpired, expiresIn);
                }
            }
        } else {
            delete kc.token;
            delete kc.tokenParsed;
            delete kc.subject;
            delete kc.realmAccess;
            delete kc.resourceAccess;
            kc.authenticated = false;
        }
    }
    function createUUID() {
        if (typeof crypto === "undefined" || typeof crypto.randomUUID === "undefined") throw new Error("Web Crypto API is not available.");
        return crypto.randomUUID();
    }
    function parseCallback(url) {
        var oauth = parseCallbackUrl(url);
        if (!oauth) return;
        var oauthState = callbackStorage.get(oauth.state);
        if (oauthState) {
            oauth.valid = true;
            oauth.redirectUri = oauthState.redirectUri;
            oauth.storedNonce = oauthState.nonce;
            oauth.prompt = oauthState.prompt;
            oauth.pkceCodeVerifier = oauthState.pkceCodeVerifier;
            oauth.loginOptions = oauthState.loginOptions;
        }
        return oauth;
    }
    function parseCallbackUrl(url) {
        var supportedParams;
        switch(kc.flow){
            case 'standard':
                supportedParams = [
                    'code',
                    'state',
                    'session_state',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
            case 'implicit':
                supportedParams = [
                    'access_token',
                    'token_type',
                    'id_token',
                    'state',
                    'session_state',
                    'expires_in',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
            case 'hybrid':
                supportedParams = [
                    'access_token',
                    'token_type',
                    'id_token',
                    'code',
                    'state',
                    'session_state',
                    'expires_in',
                    'kc_action_status',
                    'kc_action',
                    'iss'
                ];
                break;
        }
        supportedParams.push('error');
        supportedParams.push('error_description');
        supportedParams.push('error_uri');
        var queryIndex = url.indexOf('?');
        var fragmentIndex = url.indexOf('#');
        var newUrl;
        var parsed;
        if (kc.responseMode === 'query' && queryIndex !== -1) {
            newUrl = url.substring(0, queryIndex);
            parsed = parseCallbackParams(url.substring(queryIndex + 1, fragmentIndex !== -1 ? fragmentIndex : url.length), supportedParams);
            if (parsed.paramsString !== '') newUrl += '?' + parsed.paramsString;
            if (fragmentIndex !== -1) newUrl += url.substring(fragmentIndex);
        } else if (kc.responseMode === 'fragment' && fragmentIndex !== -1) {
            newUrl = url.substring(0, fragmentIndex);
            parsed = parseCallbackParams(url.substring(fragmentIndex + 1), supportedParams);
            if (parsed.paramsString !== '') newUrl += '#' + parsed.paramsString;
        }
        if (parsed && parsed.oauthParams) {
            if (kc.flow === 'standard' || kc.flow === 'hybrid') {
                if ((parsed.oauthParams.code || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            } else if (kc.flow === 'implicit') {
                if ((parsed.oauthParams.access_token || parsed.oauthParams.error) && parsed.oauthParams.state) {
                    parsed.oauthParams.newUrl = newUrl;
                    return parsed.oauthParams;
                }
            }
        }
    }
    function parseCallbackParams(paramsString, supportedParams) {
        var p = paramsString.split('&');
        var result = {
            paramsString: '',
            oauthParams: {}
        };
        for(var i = 0; i < p.length; i++){
            var split = p[i].indexOf("=");
            var key = p[i].slice(0, split);
            if (supportedParams.indexOf(key) !== -1) result.oauthParams[key] = p[i].slice(split + 1);
            else {
                if (result.paramsString !== '') result.paramsString += '&';
                result.paramsString += p[i];
            }
        }
        return result;
    }
    function createPromise() {
        // Need to create a native Promise which also preserves the
        // interface of the custom promise type previously used by the API
        var p = {
            setSuccess: function(result) {
                p.resolve(result);
            },
            setError: function(result) {
                p.reject(result);
            }
        };
        p.promise = new Promise(function(resolve, reject) {
            p.resolve = resolve;
            p.reject = reject;
        });
        return p;
    }
    // Function to extend existing native Promise with timeout
    function applyTimeoutToPromise(promise, timeout, errorMessage) {
        var timeoutHandle = null;
        var timeoutPromise = new Promise(function(resolve, reject) {
            timeoutHandle = setTimeout(function() {
                reject({
                    "error": errorMessage || "Promise is not settled within timeout of " + timeout + "ms"
                });
            }, timeout);
        });
        return Promise.race([
            promise,
            timeoutPromise
        ]).finally(function() {
            clearTimeout(timeoutHandle);
        });
    }
    function setupCheckLoginIframe() {
        var promise = createPromise();
        if (!loginIframe.enable) {
            promise.setSuccess();
            return promise.promise;
        }
        if (loginIframe.iframe) {
            promise.setSuccess();
            return promise.promise;
        }
        var iframe = document.createElement('iframe');
        loginIframe.iframe = iframe;
        iframe.onload = function() {
            var authUrl = kc.endpoints.authorize();
            if (authUrl.charAt(0) === '/') loginIframe.iframeOrigin = getOrigin();
            else loginIframe.iframeOrigin = authUrl.substring(0, authUrl.indexOf('/', 8));
            promise.setSuccess();
        };
        var src = kc.endpoints.checkSessionIframe();
        iframe.setAttribute('src', src);
        iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
        iframe.setAttribute('title', 'keycloak-session-iframe');
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
        var messageCallback = function(event) {
            if (event.origin !== loginIframe.iframeOrigin || loginIframe.iframe.contentWindow !== event.source) return;
            if (!(event.data == 'unchanged' || event.data == 'changed' || event.data == 'error')) return;
            if (event.data != 'unchanged') kc.clearToken();
            var callbacks = loginIframe.callbackList.splice(0, loginIframe.callbackList.length);
            for(var i = callbacks.length - 1; i >= 0; --i){
                var promise = callbacks[i];
                if (event.data == 'error') promise.setError();
                else promise.setSuccess(event.data == 'unchanged');
            }
        };
        window.addEventListener('message', messageCallback, false);
        return promise.promise;
    }
    function scheduleCheckIframe() {
        if (loginIframe.enable) {
            if (kc.token) setTimeout(function() {
                checkLoginIframe().then(function(unchanged) {
                    if (unchanged) scheduleCheckIframe();
                });
            }, loginIframe.interval * 1000);
        }
    }
    function checkLoginIframe() {
        var promise = createPromise();
        if (loginIframe.iframe && loginIframe.iframeOrigin) {
            var msg = kc.clientId + ' ' + (kc.sessionId ? kc.sessionId : '');
            loginIframe.callbackList.push(promise);
            var origin = loginIframe.iframeOrigin;
            if (loginIframe.callbackList.length == 1) loginIframe.iframe.contentWindow.postMessage(msg, origin);
        } else promise.setSuccess();
        return promise.promise;
    }
    function check3pCookiesSupported() {
        var promise = createPromise();
        if ((loginIframe.enable || kc.silentCheckSsoRedirectUri) && typeof kc.endpoints.thirdPartyCookiesIframe === 'function') {
            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', kc.endpoints.thirdPartyCookiesIframe());
            iframe.setAttribute('sandbox', 'allow-storage-access-by-user-activation allow-scripts allow-same-origin');
            iframe.setAttribute('title', 'keycloak-3p-check-iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
            var messageCallback = function(event) {
                if (iframe.contentWindow !== event.source) return;
                if (event.data !== "supported" && event.data !== "unsupported") return;
                else if (event.data === "unsupported") {
                    logWarn("[KEYCLOAK] Your browser is blocking access to 3rd-party cookies, this means:\n\n - It is not possible to retrieve tokens without redirecting to the Keycloak server (a.k.a. no support for silent authentication).\n - It is not possible to automatically detect changes to the session status (such as the user logging out in another tab).\n\nFor more information see: https://www.keycloak.org/securing-apps/javascript-adapter#_modern_browsers");
                    loginIframe.enable = false;
                    if (kc.silentCheckSsoFallback) kc.silentCheckSsoRedirectUri = false;
                }
                document.body.removeChild(iframe);
                window.removeEventListener("message", messageCallback);
                promise.setSuccess();
            };
            window.addEventListener('message', messageCallback, false);
        } else promise.setSuccess();
        return applyTimeoutToPromise(promise.promise, kc.messageReceiveTimeout, "Timeout when waiting for 3rd party check iframe message.");
    }
    function loadAdapter(type) {
        if (!type || type == 'default') return {
            login: async function(options) {
                window.location.assign(await kc.createLoginUrl(options));
                return createPromise().promise;
            },
            logout: async function(options) {
                const logoutMethod = options?.logoutMethod ?? kc.logoutMethod;
                if (logoutMethod === "GET") {
                    window.location.replace(kc.createLogoutUrl(options));
                    return;
                }
                // Create form to send POST request.
                const form = document.createElement("form");
                form.setAttribute("method", "POST");
                form.setAttribute("action", kc.createLogoutUrl(options));
                form.style.display = "none";
                // Add data to form as hidden input fields.
                const data = {
                    id_token_hint: kc.idToken,
                    client_id: kc.clientId,
                    post_logout_redirect_uri: adapter.redirectUri(options, false)
                };
                for (const [name, value] of Object.entries(data)){
                    const input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", name);
                    input.setAttribute("value", value);
                    form.appendChild(input);
                }
                // Append form to page and submit it to perform logout and redirect.
                document.body.appendChild(form);
                form.submit();
            },
            register: async function(options) {
                window.location.assign(await kc.createRegisterUrl(options));
                return createPromise().promise;
            },
            accountManagement: function() {
                var accountUrl = kc.createAccountUrl();
                if (typeof accountUrl !== 'undefined') window.location.href = accountUrl;
                else throw "Not supported by the OIDC server";
                return createPromise().promise;
            },
            redirectUri: function(options, encodeHash) {
                if (arguments.length == 1) encodeHash = true;
                if (options && options.redirectUri) return options.redirectUri;
                else if (kc.redirectUri) return kc.redirectUri;
                else return location.href;
            }
        };
        if (type == 'cordova') {
            loginIframe.enable = false;
            var cordovaOpenWindowWrapper = function(loginUrl, target, options) {
                if (window.cordova && window.cordova.InAppBrowser) // Use inappbrowser for IOS and Android if available
                return window.cordova.InAppBrowser.open(loginUrl, target, options);
                else return window.open(loginUrl, target, options);
            };
            var shallowCloneCordovaOptions = function(userOptions) {
                if (userOptions && userOptions.cordovaOptions) return Object.keys(userOptions.cordovaOptions).reduce(function(options, optionName) {
                    options[optionName] = userOptions.cordovaOptions[optionName];
                    return options;
                }, {});
                else return {};
            };
            var formatCordovaOptions = function(cordovaOptions) {
                return Object.keys(cordovaOptions).reduce(function(options, optionName) {
                    options.push(optionName + "=" + cordovaOptions[optionName]);
                    return options;
                }, []).join(",");
            };
            var createCordovaOptions = function(userOptions) {
                var cordovaOptions = shallowCloneCordovaOptions(userOptions);
                cordovaOptions.location = 'no';
                if (userOptions && userOptions.prompt == 'none') cordovaOptions.hidden = 'yes';
                return formatCordovaOptions(cordovaOptions);
            };
            var getCordovaRedirectUri = function() {
                return kc.redirectUri || 'http://localhost';
            };
            return {
                login: async function(options) {
                    var promise = createPromise();
                    var cordovaOptions = createCordovaOptions(options);
                    var loginUrl = await kc.createLoginUrl(options);
                    var ref = cordovaOpenWindowWrapper(loginUrl, '_blank', cordovaOptions);
                    var completed = false;
                    var closed = false;
                    var closeBrowser = function() {
                        closed = true;
                        ref.close();
                    };
                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                            var callback = parseCallback(event.url);
                            processCallback(callback, promise);
                            closeBrowser();
                            completed = true;
                        }
                    });
                    ref.addEventListener('loaderror', function(event) {
                        if (!completed) {
                            if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                                var callback = parseCallback(event.url);
                                processCallback(callback, promise);
                                closeBrowser();
                                completed = true;
                            } else {
                                promise.setError();
                                closeBrowser();
                            }
                        }
                    });
                    ref.addEventListener('exit', function(event) {
                        if (!closed) promise.setError({
                            reason: "closed_by_user"
                        });
                    });
                    return promise.promise;
                },
                logout: function(options) {
                    var promise = createPromise();
                    var logoutUrl = kc.createLogoutUrl(options);
                    var ref = cordovaOpenWindowWrapper(logoutUrl, '_blank', 'location=no,hidden=yes,clearcache=yes');
                    var error;
                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) ref.close();
                    });
                    ref.addEventListener('loaderror', function(event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) ref.close();
                        else {
                            error = true;
                            ref.close();
                        }
                    });
                    ref.addEventListener('exit', function(event) {
                        if (error) promise.setError();
                        else {
                            kc.clearToken();
                            promise.setSuccess();
                        }
                    });
                    return promise.promise;
                },
                register: async function(options) {
                    var promise = createPromise();
                    var registerUrl = await kc.createRegisterUrl();
                    var cordovaOptions = createCordovaOptions(options);
                    var ref = cordovaOpenWindowWrapper(registerUrl, '_blank', cordovaOptions);
                    ref.addEventListener('loadstart', function(event) {
                        if (event.url.indexOf(getCordovaRedirectUri()) == 0) {
                            ref.close();
                            var oauth = parseCallback(event.url);
                            processCallback(oauth, promise);
                        }
                    });
                    return promise.promise;
                },
                accountManagement: function() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') {
                        var ref = cordovaOpenWindowWrapper(accountUrl, '_blank', 'location=no');
                        ref.addEventListener('loadstart', function(event) {
                            if (event.url.indexOf(getCordovaRedirectUri()) == 0) ref.close();
                        });
                    } else throw "Not supported by the OIDC server";
                },
                redirectUri: function(options) {
                    return getCordovaRedirectUri();
                }
            };
        }
        if (type == 'cordova-native') {
            loginIframe.enable = false;
            return {
                login: async function(options) {
                    var promise = createPromise();
                    var loginUrl = await kc.createLoginUrl(options);
                    universalLinks.subscribe('keycloak', function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        var oauth = parseCallback(event.url);
                        processCallback(oauth, promise);
                    });
                    window.cordova.plugins.browsertab.openUrl(loginUrl);
                    return promise.promise;
                },
                logout: function(options) {
                    var promise = createPromise();
                    var logoutUrl = kc.createLogoutUrl(options);
                    universalLinks.subscribe('keycloak', function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        kc.clearToken();
                        promise.setSuccess();
                    });
                    window.cordova.plugins.browsertab.openUrl(logoutUrl);
                    return promise.promise;
                },
                register: async function(options) {
                    var promise = createPromise();
                    var registerUrl = await kc.createRegisterUrl(options);
                    universalLinks.subscribe('keycloak', function(event) {
                        universalLinks.unsubscribe('keycloak');
                        window.cordova.plugins.browsertab.close();
                        var oauth = parseCallback(event.url);
                        processCallback(oauth, promise);
                    });
                    window.cordova.plugins.browsertab.openUrl(registerUrl);
                    return promise.promise;
                },
                accountManagement: function() {
                    var accountUrl = kc.createAccountUrl();
                    if (typeof accountUrl !== 'undefined') window.cordova.plugins.browsertab.openUrl(accountUrl);
                    else throw "Not supported by the OIDC server";
                },
                redirectUri: function(options) {
                    if (options && options.redirectUri) return options.redirectUri;
                    else if (kc.redirectUri) return kc.redirectUri;
                    else return "http://localhost";
                }
            };
        }
        throw 'invalid adapter type: ' + type;
    }
    const STORAGE_KEY_PREFIX = 'kc-callback-';
    var LocalStorage = function() {
        if (!(this instanceof LocalStorage)) return new LocalStorage();
        localStorage.setItem('kc-test', 'test');
        localStorage.removeItem('kc-test');
        var cs = this;
        /**
         * Clears all values from local storage that are no longer valid.
         */ function clearInvalidValues() {
            const currentTime = Date.now();
            for (const [key, value] of getStoredEntries()){
                // Attempt to parse the expiry time from the value.
                const expiry = parseExpiry(value);
                // Discard the value if it is malformed or expired.
                if (expiry === null || expiry < currentTime) localStorage.removeItem(key);
            }
        }
        /**
         * Clears all known values from local storage.
         */ function clearAllValues() {
            for (const [key] of getStoredEntries())localStorage.removeItem(key);
        }
        /**
         * Gets all entries stored in local storage that are known to be managed by this class.
         * @returns {Array<[string, unknown]>} An array of key-value pairs.
         */ function getStoredEntries() {
            return Object.entries(localStorage).filter(([key])=>key.startsWith(STORAGE_KEY_PREFIX));
        }
        /**
         * Parses the expiry time from a value stored in local storage.
         * @param {unknown} value
         * @returns {number | null} The expiry time in milliseconds, or `null` if the value is malformed.
         */ function parseExpiry(value) {
            let parsedValue;
            // Attempt to parse the value as JSON.
            try {
                parsedValue = JSON.parse(value);
            } catch (error) {
                return null;
            }
            // Attempt to extract the 'expires' property.
            if ($0557b67206af4d36$var$isObject(parsedValue) && 'expires' in parsedValue && typeof parsedValue.expires === 'number') return parsedValue.expires;
            return null;
        }
        cs.get = function(state) {
            if (!state) return;
            var key = STORAGE_KEY_PREFIX + state;
            var value = localStorage.getItem(key);
            if (value) {
                localStorage.removeItem(key);
                value = JSON.parse(value);
            }
            clearInvalidValues();
            return value;
        };
        cs.add = function(state) {
            clearInvalidValues();
            const key = STORAGE_KEY_PREFIX + state.state;
            const value = JSON.stringify({
                ...state,
                // Set the expiry time to 1 hour from now.
                expires: Date.now() + 3600000
            });
            try {
                localStorage.setItem(key, value);
            } catch (error) {
                // If the storage is full, clear all known values and try again.
                clearAllValues();
                localStorage.setItem(key, value);
            }
        };
    };
    var CookieStorage = function() {
        if (!(this instanceof CookieStorage)) return new CookieStorage();
        var cs = this;
        cs.get = function(state) {
            if (!state) return;
            var value = getCookie(STORAGE_KEY_PREFIX + state);
            setCookie(STORAGE_KEY_PREFIX + state, '', cookieExpiration(-100));
            if (value) return JSON.parse(value);
        };
        cs.add = function(state) {
            setCookie(STORAGE_KEY_PREFIX + state.state, JSON.stringify(state), cookieExpiration(60));
        };
        cs.removeItem = function(key) {
            setCookie(key, '', cookieExpiration(-100));
        };
        var cookieExpiration = function(minutes) {
            var exp = new Date();
            exp.setTime(exp.getTime() + minutes * 60000);
            return exp;
        };
        var getCookie = function(key) {
            var name = key + '=';
            var ca = document.cookie.split(';');
            for(var i = 0; i < ca.length; i++){
                var c = ca[i];
                while(c.charAt(0) == ' ')c = c.substring(1);
                if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
            }
            return '';
        };
        var setCookie = function(key, value, expirationDate) {
            var cookie = key + '=' + value + '; ' + 'expires=' + expirationDate.toUTCString() + '; ';
            document.cookie = cookie;
        };
    };
    function createCallbackStorage() {
        try {
            return new LocalStorage();
        } catch (err) {}
        return new CookieStorage();
    }
    function createLogger(fn) {
        return function() {
            if (kc.enableLogging) fn.apply(console, Array.prototype.slice.call(arguments));
        };
    }
}
var $0557b67206af4d36$export$2e2bcd8739ae039 = $0557b67206af4d36$var$Keycloak;
/**
 * @param {ArrayBuffer} bytes
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ function $0557b67206af4d36$var$bytesToBase64(bytes) {
    const binString = String.fromCodePoint(...bytes);
    return btoa(binString);
}
/**
 * @param {string} message
 * @see https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest#basic_example
 */ async function $0557b67206af4d36$var$sha256Digest(message) {
    const encoder = new TextEncoder();
    const data = encoder.encode(message);
    if (typeof crypto === "undefined" || typeof crypto.subtle === "undefined") throw new Error("Web Crypto API is not available.");
    return await crypto.subtle.digest("SHA-256", data);
}
/**
 * @param {string} token
 */ function $0557b67206af4d36$var$decodeToken(token) {
    const [header, payload] = token.split(".");
    if (typeof payload !== "string") throw new Error("Unable to decode token, payload not found.");
    let decoded;
    try {
        decoded = $0557b67206af4d36$var$base64UrlDecode(payload);
    } catch (error) {
        throw new Error("Unable to decode token, payload is not a valid Base64URL value.", {
            cause: error
        });
    }
    try {
        return JSON.parse(decoded);
    } catch (error) {
        throw new Error("Unable to decode token, payload is not a valid JSON value.", {
            cause: error
        });
    }
}
/**
 * @param {string} input
 */ function $0557b67206af4d36$var$base64UrlDecode(input) {
    let output = input.replaceAll("-", "+").replaceAll("_", "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("Input is not of the correct length.");
    }
    try {
        return $0557b67206af4d36$var$b64DecodeUnicode(output);
    } catch (error) {
        return atob(output);
    }
}
/**
 * @param {string} input
 */ function $0557b67206af4d36$var$b64DecodeUnicode(input) {
    return decodeURIComponent(atob(input).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
/**
 * Check if the input is an object that can be operated on.
 * @param {unknown} input
 */ function $0557b67206af4d36$var$isObject(input) {
    return typeof input === 'object' && input !== null;
}


// Config.
const $f5375947831a300f$export$e506a1d27d1eaa20 = {
    registryApi: typeof configApiRegistryUrl !== 'undefined' ? configApiRegistryUrl : 'http://localhost:8180',
    authApi: typeof configAuthUrl !== 'undefined' ? `${configAuthUrl}/auth` : 'http://localkeycloak:8080/auth',
    authRedirectUri: typeof configAuthRedirectUri !== 'undefined' ? configAuthRedirectUri : 'http://127.0.0.1:8182/',
    prefixRegistrationRequestValidationEndpoint: 'prefixRegistrationApi',
    resourceRegistrationRequestValidationEndpoint: 'resourceManagementApi',
    prefixRegistrationEndpoint: 'prefixRegistrationApi',
    resourceRegistrationEndpoint: 'resourceManagementApi',
    prefixRequestEndpoint: 'prefixRegistrationApi/registerPrefix',
    resourceRequestEndpoint: 'resourceManagementApi/registerResource',
    rorIdEndpoint: 'rorIdApi',
    institutionManagementEndpoint: 'institutionManagementApi',
    namespaceManagementEndpoint: 'namespaceManagementApi',
    resourceManagementEndpoint: 'resourceManagementApi',
    // Schema.org metadata endpoints.
    schemaOrgPlatformEndpoint: 'schemaOrgApi/getMetadataForPlatform',
    schemaOrgNamespaceEndpoint: 'schemaOrgApi/getMetadataForNamespace',
    schemaOrgNamespacePrefixEndpoint: 'schemaOrgApi/getMetadataForNamespacePrefix',
    satelliteUrl: 'https://identifiers.org',
    feedbackUrl: 'https://github.com/identifiers-org/identifiers-org.github.io/issues/new',
    documentationUrl: 'https://docs.identifiers.org',
    oldIdentifiersUrl: 'https://ebi.identifiers.org',
    showBetaBanner: false,
    suggestionQuerySize: 10,
    baseUrl: `${window.location.protocol}//${window.location.hostname}${location.port ? ':' + location.port : ''}/`,
    apiVersion: '1.0',
    VALIDATION_DELAY: 1000,
    DEBOUNCE_DELAY: 500,
    // Enable ROR ID selection in registration request institution fields.
    enableRegistrationRequestRORIDinstitutionSelection: true,
    // Enable institution dropdown selection in registration request.
    enableRegistrationRequestInstitutionDropdownSelection: false,
    enableAuthFeatures: true,
    ebiSearchDomainEndpoint: 'https://www.ebi.ac.uk/ebisearch/ws/rest/identifiers_registry',
    ebiSearchResponseSize: 100
};


const $8919d65bd69b21cd$export$e0df4b3af4781041 = {
    'realm': 'idorg',
    'url': (0, $f5375947831a300f$export$e506a1d27d1eaa20).authApi,
    'ssl-required': 'external',
    'resource': 'hq-web-frontend',
    'public-client': true,
    'confidential-port': 0,
    'clientId': 'hq-web-frontend',
    'redirectUri': (0, $f5375947831a300f$export$e506a1d27d1eaa20).authRedirectUri
};


// Auth reducer
const $ee9a3d729429833a$var$defaultState = {
    authenticated: undefined,
    authRenewalIntervalHandler: undefined,
    keycloak: new (0, $0557b67206af4d36$export$2e2bcd8739ae039)((0, $8919d65bd69b21cd$export$e0df4b3af4781041))
};
const $ee9a3d729429833a$var$authReducer = (state = $ee9a3d729429833a$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_AUTHENTICATED':
            return {
                authenticated: action.keycloak.authenticated,
                keycloak: action.keycloak
            };
        case 'SET_AUTHRENEWALINTERVALHANDLER':
            return {
                ...state,
                authRenewalIntervalHandler: setInterval(action.authRenewalIntervalHandler, action.timeout)
            };
        default:
            return state;
    }
};
var $ee9a3d729429833a$export$2e2bcd8739ae039 = $ee9a3d729429833a$var$authReducer;



// Config reducer
const $16690323086d3d46$var$defaultState = (0, $f5375947831a300f$export$e506a1d27d1eaa20);
const $16690323086d3d46$var$configReducer = (state = $16690323086d3d46$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_CONFIG':
            return {
                ...state,
                ...action.config
            };
        default:
            return state;
    }
};
var $16690323086d3d46$export$2e2bcd8739ae039 = $16690323086d3d46$var$configReducer;


// Namespaces List reducer
const $39a7425a54037db6$var$defaultState = [];
const $39a7425a54037db6$var$curationInstitutionListReducer = (state = $39a7425a54037db6$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_CURATIONINSTITUTIONLIST':
            return action.curationInstitutionList;
        default:
            return state;
    }
};
var $39a7425a54037db6$export$2e2bcd8739ae039 = $39a7425a54037db6$var$curationInstitutionListReducer;


// Namespaces List reducer
const $af89bafee01d16a9$var$defaultState = {
    nameContent: '',
    number: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0
};
const $af89bafee01d16a9$var$curationInstitutionListParamsReducer = (state = $af89bafee01d16a9$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_CURATIONINSTITUTIONLISTPARAMS':
            return {
                ...state,
                ...action.params
            };
        default:
            return state;
    }
};
var $af89bafee01d16a9$export$2e2bcd8739ae039 = $af89bafee01d16a9$var$curationInstitutionListParamsReducer;


// Institution List reducer
const $97912a2f420348f9$var$defaultState = [];
const $97912a2f420348f9$var$institutionListReducer = (state = $97912a2f420348f9$var$defaultState, action)=>{
    switch(action.type){
        // Set store institution list to the supplied one.
        case 'SET_INSTITUTIONLIST':
            return action.institutionList.sort((a, b)=>a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        case 'SET_INSTITUTION':
            return [
                ...state.filter((institution)=>institution.id !== action.institution.id),
                action.institution
            ].sort((a, b)=>a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        default:
            return state;
    }
};
var $97912a2f420348f9$export$2e2bcd8739ae039 = $97912a2f420348f9$var$institutionListReducer;


// institution patch reducer
const $dedbae5442965aeb$var$defaultState = {
    id: undefined,
    institution: {
        name: undefined,
        description: undefined,
        location: undefined,
        homeUrl: undefined
    }
};
const $dedbae5442965aeb$var$institutionPatchReducer = (state = $dedbae5442965aeb$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_INSTITUTIONPATCHREDUCERFIELD':
            return {
                ...state,
                namespace: {
                    ...state.namespace,
                    [action.field]: action.value
                }
            };
        case 'SET_INSTITUTIONPATCHREDUCER':
            return {
                id: action.id,
                namespace: {
                    name: action.institution.name,
                    description: action.institution.description,
                    location: action.institution.location,
                    homeUrl: action.institution.homeUrl
                }
            };
        default:
            return state;
    }
};
var $dedbae5442965aeb$export$2e2bcd8739ae039 = $dedbae5442965aeb$var$institutionPatchReducer;


// Location List reducer
const $0f97fdf94ac6f8c1$var$defaultState = [];
const $0f97fdf94ac6f8c1$var$locationListReducer = (state = $0f97fdf94ac6f8c1$var$defaultState, action)=>{
    switch(action.type){
        // Set store location list to the supplied one.
        case 'SET_LOCATIONLIST':
            return action.locationList;
        default:
            return state;
    }
};
var $0f97fdf94ac6f8c1$export$2e2bcd8739ae039 = $0f97fdf94ac6f8c1$var$locationListReducer;


// Namespaces List reducer
const $92e614f1bc359b3d$var$defaultState = [];
const $92e614f1bc359b3d$var$namespaceListReducer = (state = $92e614f1bc359b3d$var$defaultState, action)=>{
    switch(action.type){
        // Set store namespace list to the supplied one.
        case 'SET_STATISTICS':
            return state.map((ns)=>{
                if (ns.prefix == action.prefix) ns['stats'] = action.stats;
                return ns;
            });
        case 'SET_NAMESPACELIST':
            return action.namespaceList;
        case 'SET_RESOURCES':
            {
                // Adds resources to namespace specified by action.prefix.
                let newNamespaceList = state.map((ns)=>{
                    if (ns.prefix === action.prefix) ns['resources'] = action.resources;
                    return ns;
                });
                return newNamespaceList;
            }
        default:
            return state;
    }
};
var $92e614f1bc359b3d$export$2e2bcd8739ae039 = $92e614f1bc359b3d$var$namespaceListReducer;


// Namespaces List reducer
const $a21822eb5e00a2d8$var$defaultState = {
    content: '',
    number: 0,
    prefixStart: '',
    size: 20,
    sort: 'name,asc',
    totalElements: 0,
    totalPages: 0
};
const $a21822eb5e00a2d8$var$namespaceListParamsReducer = (state = $a21822eb5e00a2d8$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_NAMESPACELISTPARAMS':
            return {
                ...state,
                ...action.namespaceListParams
            };
        default:
            return state;
    }
};
var $a21822eb5e00a2d8$export$2e2bcd8739ae039 = $a21822eb5e00a2d8$var$namespaceListParamsReducer;


// namespace patch reducer
const $7a22e8604fee5a26$var$defaultState = {
    id: undefined,
    namespace: {
        deprecated: undefined,
        deprecationDate: undefined,
        description: undefined,
        mirId: undefined,
        modified: undefined,
        name: undefined,
        namespaceEmbeddedInLui: undefined,
        pattern: undefined,
        prefix: undefined,
        sampleId: undefined
    }
};
const $7a22e8604fee5a26$var$namespacePatchReducer = (state = $7a22e8604fee5a26$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_NAMESPACEPATCHREDUCERFIELD':
            return {
                ...state,
                namespace: {
                    ...state.namespace,
                    [action.field]: action.value
                }
            };
        case 'SET_NAMESPACEPATCHREDUCER':
            return {
                id: action.id,
                namespace: {
                    deprecated: action.namespace.deprecated,
                    deprecationDate: action.namespace.deprecationDate,
                    description: action.namespace.description,
                    mirId: action.namespace.mirId,
                    modified: action.namespace.modified,
                    name: action.namespace.name,
                    namespaceEmbeddedInLui: action.namespace.namespaceEmbeddedInLui,
                    pattern: action.namespace.pattern,
                    prefix: action.namespace.prefix,
                    sampleId: action.namespace.sampleId
                }
            };
        default:
            return state;
    }
};
var $7a22e8604fee5a26$export$2e2bcd8739ae039 = $7a22e8604fee5a26$var$namespacePatchReducer;


// PrefixRegistrationRequest reducer.
/* TODO: This has to be used by the prefix registration request form,
 * for validation and UI state purposes. A refactor of the whole form
 * is needed. Will do when we have spare time (TM).
 */ const $8f828c3b9f53b3e7$var$defaultState = {
    errorMessage: undefined,
    label: '',
    shouldValidate: true,
    requestedValidate: false,
    value: '',
    valid: undefined
};
const $8f828c3b9f53b3e7$var$prefixRegistrationRequestFieldReducer = (prefixRegistrationRequestField)=>(state = $8f828c3b9f53b3e7$var$defaultState, action)=>{
        switch(action.type){
            case `${prefixRegistrationRequestField}/SET_PREFIXREGISTRATIONREQUESTFIELDFIELD`:
                return {
                    ...state,
                    [action.field]: action.value
                };
            case `${prefixRegistrationRequestField}/SET_PREFIXREGISTRATIONREQUESTFIELDVALIDATION`:
                return {
                    ...state,
                    shouldValidate: action.validation,
                    valid: undefined
                };
            case `${prefixRegistrationRequestField}/RESET_PREFIXREGISTRATIONREQUESTFIELDVALIDITYSTATUS`:
                return {
                    ...state,
                    valid: undefined,
                    errorMessage: undefined
                };
            case `${prefixRegistrationRequestField}/PREFIXREGISTRATIONREQUESTFIELDRESET`:
                return {
                    ...state,
                    value: '',
                    valid: undefined,
                    requestValidate: false,
                    shouldValidate: true
                };
            default:
                return state;
        }
    };
var $8f828c3b9f53b3e7$export$2e2bcd8739ae039 = $8f828c3b9f53b3e7$var$prefixRegistrationRequestFieldReducer;


// Prefix Registration Session List reducer
const $2bc350c6a85eaa66$var$defaultState = [];
const $2bc350c6a85eaa66$var$prefixRegistrationSessionListReducer = (state = $2bc350c6a85eaa66$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONLIST':
            return action.registrationSessionList;
        default:
            return state;
    }
};
var $2bc350c6a85eaa66$export$2e2bcd8739ae039 = $2bc350c6a85eaa66$var$prefixRegistrationSessionListReducer;


// Prefix Registration List Params reducer
const $4c59a9d85cf86e0b$var$defaultState = {
    number: 0,
    size: 5,
    totalElements: 0,
    totalPages: 0
};
const $4c59a9d85cf86e0b$var$prefixRegistrationSessionListParamsReducer = (state = $4c59a9d85cf86e0b$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONLISTPARAMS':
            return {
                ...state,
                ...action.page
            };
        default:
            return state;
    }
};
var $4c59a9d85cf86e0b$export$2e2bcd8739ae039 = $4c59a9d85cf86e0b$var$prefixRegistrationSessionListParamsReducer;


// PrefixRegistratonSession reducer
const $38bc9a0f6d5df001$var$defaultState = {
    closed: false,
    created: undefined,
    id: undefined,
    prefixRegistrationRequest: undefined,
    prefixRegistrationSessionEvents: []
};
const $38bc9a0f6d5df001$var$prefixRegistrationSessionReducer = (state = $38bc9a0f6d5df001$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSION':
            return action.prefixRegistrationSession;
        default:
            return state;
    }
};
var $38bc9a0f6d5df001$export$2e2bcd8739ae039 = $38bc9a0f6d5df001$var$prefixRegistrationSessionReducer;


// PrefixRegistratonSessionAccept reducer
const $22ac88e45fc79826$var$defaultState = {
    acceptanceReason: undefined,
    additionalInformation: undefined
};
const $22ac88e45fc79826$var$prefixRegistrationSessionAcceptReducer = (state = $22ac88e45fc79826$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONACCEPT':
            return {
                ...state,
                acceptanceReason: action.acceptanceReason,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $22ac88e45fc79826$export$2e2bcd8739ae039 = $22ac88e45fc79826$var$prefixRegistrationSessionAcceptReducer;


// PrefixRegistratonSessionAmend reducer
const $7fc92da4968d69d5$var$defaultState = {
    name: undefined,
    description: undefined,
    requestedPrefix: undefined,
    sampleId: undefined,
    idRegexPattern: undefined,
    supportingReferences: undefined,
    additionalInformation: undefined,
    institutionRorId: undefined,
    institutionName: undefined,
    institutionDescription: undefined,
    institutionHomeUrl: undefined,
    institutionLocation: undefined,
    namespaceEmbeddedInLui: undefined,
    providerName: undefined,
    providerDescription: undefined,
    providerHomeUrl: undefined,
    providerCode: undefined,
    providerUrlPattern: undefined,
    providerLocation: undefined,
    requesterName: undefined,
    requesterEmail: undefined
};
const $7fc92da4968d69d5$var$prefixRegistrationSessionAmendReducer = (state = $7fc92da4968d69d5$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONAMENDFIELD':
            return {
                ...state,
                [action.field]: action.value
            };
        case 'SET_PREFIXREGISTRATIONSESSIONAMEND':
            return {
                ...state,
                name: action.registrationSessionAmend.name,
                description: action.registrationSessionAmend.description,
                requestedPrefix: action.registrationSessionAmend.requestedPrefix,
                sampleId: action.registrationSessionAmend.sampleId,
                idRegexPattern: action.registrationSessionAmend.idRegexPattern,
                supportingReferences: action.registrationSessionAmend.supportingReferences,
                additionalInformation: action.registrationSessionAmend.additionalInformation,
                institutionRorId: action.registrationSessionAmend.institutionRorId,
                institutionName: action.registrationSessionAmend.institutionName,
                institutionDescription: action.registrationSessionAmend.institutionDescription,
                institutionHomeUrl: action.registrationSessionAmend.institutionHomeUrl,
                institutionLocation: action.registrationSessionAmend.institutionLocation,
                namespaceEmbeddedInLui: action.registrationSessionAmend.namespaceEmbeddedInLui,
                providerName: action.registrationSessionAmend.providerName,
                providerDescription: action.registrationSessionAmend.providerDescription,
                providerHomeUrl: action.registrationSessionAmend.providerHomeUrl,
                providerCode: action.registrationSessionAmend.providerCode,
                providerUrlPattern: action.registrationSessionAmend.providerUrlPattern,
                providerLocation: action.registrationSessionAmend.providerLocation,
                requesterName: action.registrationSessionAmend.requesterName,
                requesterEmail: action.registrationSessionAmend.requesterEmail
            };
        default:
            return state;
    }
};
var $7fc92da4968d69d5$export$2e2bcd8739ae039 = $7fc92da4968d69d5$var$prefixRegistrationSessionAmendReducer;


// PrefixRegistratonSessionComment reducer
const $42ecefb828040400$var$defaultState = {
    comment: undefined,
    additionalInformation: undefined
};
const $42ecefb828040400$var$prefixRegistrationSessionCommentReducer = (state = $42ecefb828040400$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONCOMMENT':
            return {
                ...state,
                comment: action.comment,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $42ecefb828040400$export$2e2bcd8739ae039 = $42ecefb828040400$var$prefixRegistrationSessionCommentReducer;


// PrefixRegistratonSessionReject reducer
const $de0ae49c0c99573b$var$defaultState = {
    rejectionReason: undefined,
    additionalInformation: undefined
};
const $de0ae49c0c99573b$var$prefixRegistrationSessionRejectReducer = (state = $de0ae49c0c99573b$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONREJECT':
            return {
                ...state,
                rejectionReason: action.rejectionReason,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $de0ae49c0c99573b$export$2e2bcd8739ae039 = $de0ae49c0c99573b$var$prefixRegistrationSessionRejectReducer;


// Resource patch reducer
const $2a44cc53c0c877a9$var$defaultState = {
    id: undefined,
    resource: {
        providerCode: undefined,
        description: undefined,
        urlPattern: undefined,
        institution: undefined,
        resourceHomeUrl: undefined,
        location: undefined,
        sampleId: undefined,
        official: undefined
    }
};
const $2a44cc53c0c877a9$var$resourcePatchReducer = (state = $2a44cc53c0c877a9$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEPATCHREDUCERFIELD':
            return {
                ...state,
                resource: {
                    ...state.resource,
                    [action.field]: action.value
                }
            };
        case 'SET_RESOURCEPATCHREDUCER':
            return {
                id: action.id,
                resource: {
                    providerCode: action.resource.providerCode,
                    description: action.resource.description,
                    urlPattern: action.resource.urlPattern,
                    institution: action.resource.institution,
                    resourceHomeUrl: action.resource.resourceHomeUrl,
                    location: action.resource.location,
                    sampleId: action.resource.sampleId,
                    official: action.resource.official
                }
            };
        default:
            return state;
    }
};
var $2a44cc53c0c877a9$export$2e2bcd8739ae039 = $2a44cc53c0c877a9$var$resourcePatchReducer;


// ResourceRegistrationRequest reducer.
/* TODO: This has to be used by the resource registration request form,
 * for validation and UI state purposes. A refactor of the whole form
 * is needed. Will do when we have spare time (TM).
 */ const $2dd954336fbf1cd6$var$defaultState = {
    errorMessage: undefined,
    label: '',
    shouldValidate: true,
    requestedValidate: false,
    value: '',
    valid: undefined
};
const $2dd954336fbf1cd6$var$resourceRegistrationRequestFieldReducer = (resourceRegistrationRequestField)=>(state = $2dd954336fbf1cd6$var$defaultState, action)=>{
        switch(action.type){
            case `${resourceRegistrationRequestField}/SET_RESOURCEREGISTRATIONREQUESTFIELDFIELD`:
                return {
                    ...state,
                    [action.field]: action.value
                };
            case `${resourceRegistrationRequestField}/SET_RESOURCEREGISTRATIONREQUESTFIELDVALIDATION`:
                return {
                    ...state,
                    shouldValidate: action.validation,
                    valid: undefined
                };
            case `${resourceRegistrationRequestField}/RESOURCEREGISTRATIONREQUESTFIELDRESET`:
                return {
                    ...state,
                    value: '',
                    valid: undefined,
                    requestValidate: false,
                    shouldValidate: true
                };
            default:
                return state;
        }
    };
var $2dd954336fbf1cd6$export$2e2bcd8739ae039 = $2dd954336fbf1cd6$var$resourceRegistrationRequestFieldReducer;


// Resource Registration Session List reducer
const $7baeae42d52514ea$var$defaultState = [];
const $7baeae42d52514ea$var$resourceRegistrationSessionListReducer = (state = $7baeae42d52514ea$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSIONLIST':
            return action.registrationSessionList;
        default:
            return state;
    }
};
var $7baeae42d52514ea$export$2e2bcd8739ae039 = $7baeae42d52514ea$var$resourceRegistrationSessionListReducer;


// Resource Registration List Params reducer
const $8e2300fe135202ef$var$defaultState = {
    number: 0,
    size: 5,
    totalElements: 0,
    totalPages: 0
};
const $8e2300fe135202ef$var$resourceRegistrationSessionListParamsReducer = (state = $8e2300fe135202ef$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSIONLISTPARAMS':
            return {
                ...state,
                ...action.page
            };
        default:
            return state;
    }
};
var $8e2300fe135202ef$export$2e2bcd8739ae039 = $8e2300fe135202ef$var$resourceRegistrationSessionListParamsReducer;


// ResourceRegistratonSession reducer
const $6e15758bb0489dc5$var$defaultState = {
    closed: false,
    created: undefined,
    id: undefined,
    resourceRegistrationRequest: undefined,
    resourceRegistrationSessionEvents: []
};
const $6e15758bb0489dc5$var$resourceRegistrationSessionReducer = (state = $6e15758bb0489dc5$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSION':
            return action.resourceRegistrationSession;
        default:
            return state;
    }
};
var $6e15758bb0489dc5$export$2e2bcd8739ae039 = $6e15758bb0489dc5$var$resourceRegistrationSessionReducer;


// ResourceRegistratonSessionAccept reducer
const $cae9524ace354948$var$defaultState = {
    acceptanceReason: undefined,
    additionalInformation: undefined
};
const $cae9524ace354948$var$resourceRegistrationSessionAcceptReducer = (state = $cae9524ace354948$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSIONACCEPT':
            return {
                ...state,
                acceptanceReason: action.acceptanceReason,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $cae9524ace354948$export$2e2bcd8739ae039 = $cae9524ace354948$var$resourceRegistrationSessionAcceptReducer;


// ResourceRegistratonSessionAmend reducer
const $14524882842a2735$var$defaultState = {
    namespacePrefix: undefined,
    institutionRorId: undefined,
    institutionName: undefined,
    institutionDescription: undefined,
    institutionHomeUrl: undefined,
    institutionLocation: undefined,
    providerName: undefined,
    providerDescription: undefined,
    providerHomeUrl: undefined,
    providerCode: undefined,
    providerUrlPattern: undefined,
    sampleId: undefined,
    providerLocation: undefined,
    requesterName: undefined,
    requesterEmail: undefined
};
const $14524882842a2735$var$resourceRegistrationSessionAmendReducer = (state = $14524882842a2735$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSIONAMENDFIELD':
            return {
                ...state,
                [action.field]: action.value
            };
        case 'SET_RESOURCEREGISTRATIONSESSIONAMEND':
            return {
                ...state,
                namespacePrefix: action.registrationSessionAmend.namespacePrefix,
                institutionRorId: action.registrationSessionAmend.institutionRorId,
                institutionName: action.registrationSessionAmend.institutionName,
                institutionDescription: action.registrationSessionAmend.institutionDescription,
                institutionHomeUrl: action.registrationSessionAmend.institutionHomeUrl,
                institutionLocation: action.registrationSessionAmend.institutionLocation,
                providerName: action.registrationSessionAmend.providerName,
                providerDescription: action.registrationSessionAmend.providerDescription,
                providerHomeUrl: action.registrationSessionAmend.providerHomeUrl,
                providerCode: action.registrationSessionAmend.providerCode,
                providerUrlPattern: action.registrationSessionAmend.providerUrlPattern,
                sampleId: action.registrationSessionAmend.sampleId,
                providerLocation: action.registrationSessionAmend.providerLocation,
                requesterName: action.registrationSessionAmend.requesterName,
                requesterEmail: action.registrationSessionAmend.requesterEmail
            };
        default:
            return state;
    }
};
var $14524882842a2735$export$2e2bcd8739ae039 = $14524882842a2735$var$resourceRegistrationSessionAmendReducer;


// ResourceRegistratonSessionComment reducer
const $d4dfe74dd6698475$var$defaultState = {
    comment: undefined,
    additionalInformation: undefined
};
const $d4dfe74dd6698475$var$resourceRegistrationSessionCommentReducer = (state = $d4dfe74dd6698475$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_RESOURCEREGISTRATIONSESSIONCOMMENT':
            return {
                ...state,
                comment: action.comment,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $d4dfe74dd6698475$export$2e2bcd8739ae039 = $d4dfe74dd6698475$var$resourceRegistrationSessionCommentReducer;


// PrefixRegistratonSessionReject reducer
const $b147a105484169c1$var$defaultState = {
    rejectionReason: undefined,
    additionalInformation: undefined
};
const $b147a105484169c1$var$prefixRegistrationSessionRejectReducer = (state = $b147a105484169c1$var$defaultState, action)=>{
    switch(action.type){
        case 'SET_PREFIXREGISTRATIONSESSIONREJECT':
            return {
                ...state,
                rejectionReason: action.rejectionReason,
                additionalInformation: action.additionalInformation
            };
        default:
            return state;
    }
};
var $b147a105484169c1$export$2e2bcd8739ae039 = $b147a105484169c1$var$prefixRegistrationSessionRejectReducer;


const $ba9a7949bfed683b$var$defaultState = {};
const $ba9a7949bfed683b$var$schemaOrgMetadataReducer = (state = $ba9a7949bfed683b$var$defaultState, action)=>{
    switch(action.type){
        // Set Schema.org metadata to the supplied one.
        case 'SET_SCHEMAORGMETADATA':
            return {
                ...action.schemaOrgMetadata
            };
        default:
            return state;
    }
};
var $ba9a7949bfed683b$export$2e2bcd8739ae039 = $ba9a7949bfed683b$var$schemaOrgMetadataReducer;


// Middlewares.
// TODO: Convert validator to middleware.
// import fieldValidationMiddleware from '../middleware/fieldValidationMiddleware';
const $764c5d8c73d64a30$var$composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || (0, $d06d39bd9e9b7dd2$export$f672e0b6f7222cd7);
//
// Store management.
//
// Store creation.
const $764c5d8c73d64a30$var$store = (0, $d06d39bd9e9b7dd2$export$f51a9068ac82ea43)((0, $d06d39bd9e9b7dd2$export$66e4520cdb265d18)({
    auth: (0, $ee9a3d729429833a$export$2e2bcd8739ae039),
    config: (0, $16690323086d3d46$export$2e2bcd8739ae039),
    curationDashboard: (0, $d06d39bd9e9b7dd2$export$66e4520cdb265d18)({
        curationInstitutionList: (0, $39a7425a54037db6$export$2e2bcd8739ae039),
        curationInstitutionListParams: (0, $af89bafee01d16a9$export$2e2bcd8739ae039),
        curationEditInstitution: (0, $dedbae5442965aeb$export$2e2bcd8739ae039),
        prefixRegistrationSessionList: (0, $2bc350c6a85eaa66$export$2e2bcd8739ae039),
        prefixRegistrationSessionListParams: (0, $4c59a9d85cf86e0b$export$2e2bcd8739ae039),
        prefixRegistrationSession: (0, $38bc9a0f6d5df001$export$2e2bcd8739ae039),
        prefixRegistrationSessionAccept: (0, $22ac88e45fc79826$export$2e2bcd8739ae039),
        prefixRegistrationSessionAmend: (0, $7fc92da4968d69d5$export$2e2bcd8739ae039),
        prefixRegistrationSessionComment: (0, $42ecefb828040400$export$2e2bcd8739ae039),
        prefixRegistrationSessionReject: (0, $de0ae49c0c99573b$export$2e2bcd8739ae039),
        resourceRegistrationSessionList: (0, $7baeae42d52514ea$export$2e2bcd8739ae039),
        resourceRegistrationSessionListParams: (0, $8e2300fe135202ef$export$2e2bcd8739ae039),
        resourceRegistrationSession: (0, $6e15758bb0489dc5$export$2e2bcd8739ae039),
        resourceRegistrationSessionAccept: (0, $cae9524ace354948$export$2e2bcd8739ae039),
        resourceRegistrationSessionAmend: (0, $14524882842a2735$export$2e2bcd8739ae039),
        resourceRegistrationSessionComment: (0, $d4dfe74dd6698475$export$2e2bcd8739ae039),
        resourceRegistrationSessionReject: (0, $b147a105484169c1$export$2e2bcd8739ae039)
    }),
    curationEditNamespace: (0, $7a22e8604fee5a26$export$2e2bcd8739ae039),
    curationEditResource: (0, $2a44cc53c0c877a9$export$2e2bcd8739ae039),
    locationList: (0, $0f97fdf94ac6f8c1$export$2e2bcd8739ae039),
    institutionList: (0, $97912a2f420348f9$export$2e2bcd8739ae039),
    prefixRegistrationRequestForm: (0, $d06d39bd9e9b7dd2$export$66e4520cdb265d18)({
        name: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('name'),
        description: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('description'),
        requestedPrefix: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('requestedPrefix'),
        sampleId: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('sampleId'),
        idRegexPattern: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('idRegexPattern'),
        supportingReferences: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('supportingReferences'),
        additionalInformation: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('additionalInformation'),
        institutionName: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('institutionName'),
        institutionDescription: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('institutionDescription'),
        institutionHomeUrl: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('institutionHomeUrl'),
        institutionLocation: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('institutionLocation'),
        institutionIsProvider: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('institutionIsProvider'),
        providerName: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerName'),
        providerDescription: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerDescription'),
        providerCode: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerCode'),
        providerHomeUrl: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerHomeUrl'),
        providerUrlPattern: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerUrlPattern'),
        providerLocation: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('providerLocation'),
        requesterName: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('requesterName'),
        requesterEmail: (0, $8f828c3b9f53b3e7$export$2e2bcd8739ae039)('requesterEmail')
    }),
    resourceRegistrationRequestForm: (0, $d06d39bd9e9b7dd2$export$66e4520cdb265d18)({
        namespacePrefix: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('namespacePrefix'),
        institutionName: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('institutionName'),
        institutionDescription: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('institutionDescription'),
        institutionHomeUrl: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('institutionHomeUrl'),
        institutionLocation: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('institutionLocation'),
        institutionIsProvider: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('institutionIsProvider'),
        providerName: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerName'),
        providerDescription: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerDescription'),
        providerCode: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerCode'),
        providerHomeUrl: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerHomeUrl'),
        providerUrlPattern: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerUrlPattern'),
        sampleId: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('sampleId'),
        providerLocation: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('providerLocation'),
        requesterName: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('requesterName'),
        requesterEmail: (0, $2dd954336fbf1cd6$export$2e2bcd8739ae039)('requesterEmail')
    }),
    registryBrowser: (0, $d06d39bd9e9b7dd2$export$66e4520cdb265d18)({
        namespaceList: (0, $92e614f1bc359b3d$export$2e2bcd8739ae039),
        namespaceListParams: (0, $a21822eb5e00a2d8$export$2e2bcd8739ae039)
    }),
    schemaOrgMetadata: (0, $ba9a7949bfed683b$export$2e2bcd8739ae039)
}), $764c5d8c73d64a30$var$composeEnhancers((0, $d06d39bd9e9b7dd2$export$9ff26e0402cc7b7)((0, $cda3b149c8af48da$export$2e2bcd8739ae039))));
var $764c5d8c73d64a30$export$2e2bcd8739ae039 = $764c5d8c73d64a30$var$store;


// Init Keycloak object. Will dispatch setAuthenticated.
const $0b883306a510c740$export$c03d5f201539f0d9 = ()=>{
    return async (dispatch, getState)=>{
        const { keycloak: keycloak } = getState().auth;
        try {
            await keycloak.init({
                onLoad: 'check-sso'
            });
        } catch  {
            console.error('Unable to authenticate.');
        }
        dispatch($0b883306a510c740$export$fa196dbb7e28994(keycloak));
    };
};
const $0b883306a510c740$export$7abc584011c1e113 = ()=>{
    return async (dispatch, getState)=>{
        const { keycloak: keycloak } = getState().auth;
        await keycloak.login();
        dispatch($0b883306a510c740$export$fa196dbb7e28994(keycloak));
    };
};
const $0b883306a510c740$export$3ebfd0406116c6c7 = ()=>{
    return async (dispatch, getState)=>{
        const { keycloak: keycloak } = getState().auth;
        await keycloak.logout({
            redirectUri: window.location.origin
        });
        dispatch($0b883306a510c740$export$fa196dbb7e28994(keycloak));
    };
};
const $0b883306a510c740$export$fa196dbb7e28994 = (keycloak)=>{
    return {
        type: 'SET_AUTHENTICATED',
        keycloak: keycloak
    };
};
const $0b883306a510c740$export$95c42985d2be0368 = (authRenewalIntervalHandler, timeout)=>{
    return {
        type: 'SET_AUTHRENEWALINTERVALHANDLER',
        authRenewalIntervalHandler: authRenewalIntervalHandler,
        timeout: timeout
    };
};


// Config.

// Helper function for HATEOAS requests: fetches subobjects.
const $df9764f9470d541a$export$adb5405149b9ba8a = async function(parent, links, init, addId = false) {
    const resources = await Promise.all(links.map((link)=>fetch(link.url, init)));
    const jsonResources = await Promise.all(resources.map((res)=>res.ok ? res.json() : undefined));
    jsonResources.forEach((resource, index)=>{
        parent[links[index].name] = resource;
        if (addId) parent[links[index].name]['id'] = resource._links.self.href;
    });
    return parent;
};


const $c3dc2e9b5981d644$export$53bd7c9cf2087a2d = ()=>{
    return async (dispatch)=>{
        let requestUrl = (0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + '/restApi/institutions?size=1000';
        let institutions = [];
        try {
            const response = await fetch(requestUrl);
            const json = await response.json();
            institutions = json._embedded.institutions.map((institution)=>({
                    id: institution._links.self.href,
                    shortId: institution._links.self.href.split('/').pop(),
                    name: institution.name,
                    homeUrl: institution.homeUrl,
                    description: institution.description
                }));
        } catch (error) {
            console.error(`Failed to fetch ${requestUrl}`, error);
        }
        dispatch($c3dc2e9b5981d644$export$3b76971e5c117dab(institutions));
    };
};
const $c3dc2e9b5981d644$export$e78039615e6b2be0 = (id)=>{
    return async (dispatch)=>{
        let requestUrl = (0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + `/restApi/institutions/${id}`;
        const response = await fetch(requestUrl);
        const institution = await response.json();
        let newInstitution = {
            id: institution._links.self.href,
            shortId: institution._links.self.href.split('/').pop(),
            rorId: institution.rorId,
            name: institution.name,
            homeUrl: institution.homeUrl,
            description: institution.description
        };
        newInstitution = await (0, $df9764f9470d541a$export$adb5405149b9ba8a)(newInstitution, [
            {
                name: 'location',
                url: institution._links.location.href
            }
        ], undefined, true);
        newInstitution.location.shortId = newInstitution.location.id.split('/').pop();
        dispatch($c3dc2e9b5981d644$export$eff3f275a0931dbb(newInstitution));
        return newInstitution;
    };
};
const $c3dc2e9b5981d644$export$68f0fa7e9d97698f = (rorId)=>async ()=>{
        let requestURL = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).rorIdEndpoint}/getInstitutionForRorId`);
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({
                apiVersion: '1.0',
                payload: {
                    rorId: rorId
                }
            })
        };
        const response = await fetch(requestURL, init);
        return response.status === 200 ? await response.json() : null;
    };
const $c3dc2e9b5981d644$export$3b76971e5c117dab = (institutionList)=>{
    return {
        type: 'SET_INSTITUTIONLIST',
        institutionList: institutionList
    };
};
const $c3dc2e9b5981d644$export$eff3f275a0931dbb = (institution)=>{
    return {
        type: 'SET_INSTITUTION',
        institution: institution
    };
};



const $8720e80f7302d904$export$579aa4ccb2704142 = ()=>{
    return async (dispatch)=>{
        let requestUrl = (0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + '/restApi/locations?size=1000';
        let locations = [];
        try {
            const response = await fetch(requestUrl);
            const json = await response.json();
            locations = json._embedded.locations.map((location)=>({
                    id: location._links.self.href,
                    shortId: location._links.self.href.split('/').pop(),
                    // This is for uneven api contents. Should be fixed in backend.
                    label: location.countryName
                })).sort((a, b)=>a.name > b.name ? -1 : a.name < b.name ? 1 : 0);
        } catch (err) {
            console.error(`Failed to fetch ${requestUrl}`, err);
        }
        dispatch($8720e80f7302d904$export$8b2c343d2739dd40(locations));
    };
};
const $8720e80f7302d904$export$8b2c343d2739dd40 = (locationList)=>{
    return {
        type: 'SET_LOCATIONLIST',
        locationList: locationList
    };
};


// Config.

function $fd5d9941f8cbe9ee$export$eea578708101341f(contents) {
    const script = document.getElementById('schemaorg-metadata') || document.createElement('script');
    script.id = 'schemaorg-metadata';
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(contents, null, 2);
    document.head.appendChild(script);
}


const $8a5c3ddb423770e6$export$78572dfc0a558ba6 = (namespaceId)=>{
    return async (dispatch)=>{
        let requestUrl = !namespaceId ? `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).schemaOrgPlatformEndpoint}` : `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).schemaOrgNamespaceEndpoint}/${namespaceId}`;
        let json = {};
        try {
            const response = await fetch(requestUrl);
            json = await response.json();
        } catch (err) {
            console.error(`Failed to fetch ${requestUrl}`, err);
        }
        dispatch($8a5c3ddb423770e6$export$102255af3b72336(json));
    };
};
const $8a5c3ddb423770e6$export$358ac8bb95c77f0c = (prefix)=>{
    return async (dispatch)=>{
        let requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).schemaOrgNamespacePrefixEndpoint}/${prefix}`;
        let json = {};
        try {
            const response = await fetch(requestUrl);
            if (response.ok) json = await response.json();
        } catch (err) {
            console.error(err);
        }
        dispatch($8a5c3ddb423770e6$export$102255af3b72336(json));
    };
};
const $8a5c3ddb423770e6$export$102255af3b72336 = (schemaOrgMetadata)=>{
    // Inject metadata in DOM.
    (0, $fd5d9941f8cbe9ee$export$eea578708101341f)(schemaOrgMetadata);
    return {
        type: 'SET_SCHEMAORGMETADATA',
        schemaOrgMetadata: schemaOrgMetadata
    };
};



parcelRequire("dBNnn");
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dBNnn = parcelRequire("dBNnn");

var $a6afE = parcelRequire("a6afE");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $07ec9c019360714d$var$_extends() {
    $07ec9c019360714d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $07ec9c019360714d$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $07ec9c019360714d$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($07ec9c019360714d$export$e19cd5f9376f8cee || ($07ec9c019360714d$export$e19cd5f9376f8cee = {}));
const $07ec9c019360714d$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $07ec9c019360714d$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $07ec9c019360714d$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $07ec9c019360714d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $07ec9c019360714d$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $07ec9c019360714d$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $07ec9c019360714d$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $07ec9c019360714d$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $07ec9c019360714d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $07ec9c019360714d$export$fe53371bee54353d(to);
    }
    return $07ec9c019360714d$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $07ec9c019360714d$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $07ec9c019360714d$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $07ec9c019360714d$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $07ec9c019360714d$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $07ec9c019360714d$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $07ec9c019360714d$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $07ec9c019360714d$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $07ec9c019360714d$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $07ec9c019360714d$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $07ec9c019360714d$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $07ec9c019360714d$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $07ec9c019360714d$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $07ec9c019360714d$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $07ec9c019360714d$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $07ec9c019360714d$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $07ec9c019360714d$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($07ec9c019360714d$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $07ec9c019360714d$export$e19cd5f9376f8cee.Push;
        let location = $07ec9c019360714d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $07ec9c019360714d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $07ec9c019360714d$export$e19cd5f9376f8cee.Replace;
        let location = $07ec9c019360714d$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $07ec9c019360714d$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $07ec9c019360714d$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $07ec9c019360714d$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($07ec9c019360714d$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($07ec9c019360714d$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $07ec9c019360714d$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($07ec9c019360714d$var$ResultType || ($07ec9c019360714d$var$ResultType = {}));
const $07ec9c019360714d$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $07ec9c019360714d$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $07ec9c019360714d$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $07ec9c019360714d$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $07ec9c019360714d$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($07ec9c019360714d$var$isIndexRoute(route)) {
            let indexRoute = $07ec9c019360714d$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $07ec9c019360714d$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $07ec9c019360714d$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $07ec9c019360714d$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $07ec9c019360714d$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $07ec9c019360714d$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $07ec9c019360714d$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $07ec9c019360714d$var$flattenRoutes(routes);
    $07ec9c019360714d$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $07ec9c019360714d$export$30d21fd6d7295f52(pathname);
        matches = $07ec9c019360714d$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $07ec9c019360714d$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $07ec9c019360714d$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $07ec9c019360714d$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $07ec9c019360714d$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $07ec9c019360714d$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $07ec9c019360714d$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $07ec9c019360714d$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $07ec9c019360714d$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $07ec9c019360714d$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $07ec9c019360714d$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $07ec9c019360714d$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $07ec9c019360714d$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $07ec9c019360714d$var$paramRe = /^:[\w-]+$/;
const $07ec9c019360714d$var$dynamicSegmentValue = 3;
const $07ec9c019360714d$var$indexRouteValue = 2;
const $07ec9c019360714d$var$emptySegmentValue = 1;
const $07ec9c019360714d$var$staticSegmentValue = 10;
const $07ec9c019360714d$var$splatPenalty = -2;
const $07ec9c019360714d$var$isSplat = (s)=>s === "*";
function $07ec9c019360714d$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($07ec9c019360714d$var$isSplat)) initialScore += $07ec9c019360714d$var$splatPenalty;
    if (index) initialScore += $07ec9c019360714d$var$indexRouteValue;
    return segments.filter((s)=>!$07ec9c019360714d$var$isSplat(s)).reduce((score, segment)=>score + ($07ec9c019360714d$var$paramRe.test(segment) ? $07ec9c019360714d$var$dynamicSegmentValue : segment === "" ? $07ec9c019360714d$var$emptySegmentValue : $07ec9c019360714d$var$staticSegmentValue), initialScore);
}
function $07ec9c019360714d$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $07ec9c019360714d$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $07ec9c019360714d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $07ec9c019360714d$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $07ec9c019360714d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $07ec9c019360714d$export$a5c6d149b50c1d86($07ec9c019360714d$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $07ec9c019360714d$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $07ec9c019360714d$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $07ec9c019360714d$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $07ec9c019360714d$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $07ec9c019360714d$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $07ec9c019360714d$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $07ec9c019360714d$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $07ec9c019360714d$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $07ec9c019360714d$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $07ec9c019360714d$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $07ec9c019360714d$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $07ec9c019360714d$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $07ec9c019360714d$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $07ec9c019360714d$var$normalizeSearch(search),
        hash: $07ec9c019360714d$var$normalizeHash(hash)
    };
}
function $07ec9c019360714d$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $07ec9c019360714d$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $07ec9c019360714d$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $07ec9c019360714d$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $07ec9c019360714d$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $07ec9c019360714d$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $07ec9c019360714d$export$8ccf933b0513f8d0(toArg);
    else {
        to = $07ec9c019360714d$var$_extends({}, toArg);
        $07ec9c019360714d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $07ec9c019360714d$var$getInvalidPathError("?", "pathname", "search", to));
        $07ec9c019360714d$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $07ec9c019360714d$var$getInvalidPathError("#", "pathname", "hash", to));
        $07ec9c019360714d$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $07ec9c019360714d$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $07ec9c019360714d$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $07ec9c019360714d$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $07ec9c019360714d$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $07ec9c019360714d$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $07ec9c019360714d$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $07ec9c019360714d$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $07ec9c019360714d$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $07ec9c019360714d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $07ec9c019360714d$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $07ec9c019360714d$export$4051a07651545597(data, init) {
    return new $07ec9c019360714d$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $07ec9c019360714d$export$42a99a7a4bc0e76a extends Error {
}
class $07ec9c019360714d$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $07ec9c019360714d$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $07ec9c019360714d$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $07ec9c019360714d$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $07ec9c019360714d$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $07ec9c019360714d$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $07ec9c019360714d$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $07ec9c019360714d$var$unwrapTrackedPromise(value) {
    if (!$07ec9c019360714d$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $07ec9c019360714d$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $07ec9c019360714d$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $07ec9c019360714d$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $07ec9c019360714d$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $07ec9c019360714d$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $07ec9c019360714d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $07ec9c019360714d$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $07ec9c019360714d$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $07ec9c019360714d$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $07ec9c019360714d$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $07ec9c019360714d$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $07ec9c019360714d$var$validMutationMethods = new Set($07ec9c019360714d$var$validMutationMethodsArr);
const $07ec9c019360714d$var$validRequestMethodsArr = [
    "get",
    ...$07ec9c019360714d$var$validMutationMethodsArr
];
const $07ec9c019360714d$var$validRequestMethods = new Set($07ec9c019360714d$var$validRequestMethodsArr);
const $07ec9c019360714d$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $07ec9c019360714d$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $07ec9c019360714d$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $07ec9c019360714d$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $07ec9c019360714d$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $07ec9c019360714d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $07ec9c019360714d$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $07ec9c019360714d$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $07ec9c019360714d$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $07ec9c019360714d$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $07ec9c019360714d$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $07ec9c019360714d$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $07ec9c019360714d$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $07ec9c019360714d$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $07ec9c019360714d$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $07ec9c019360714d$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $07ec9c019360714d$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$07ec9c019360714d$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$07ec9c019360714d$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $07ec9c019360714d$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $07ec9c019360714d$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $07ec9c019360714d$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $07ec9c019360714d$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$07ec9c019360714d$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($07ec9c019360714d$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $07ec9c019360714d$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $07ec9c019360714d$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $07ec9c019360714d$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $07ec9c019360714d$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $07ec9c019360714d$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $07ec9c019360714d$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $07ec9c019360714d$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $07ec9c019360714d$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $07ec9c019360714d$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($07ec9c019360714d$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $07ec9c019360714d$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $07ec9c019360714d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $07ec9c019360714d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $07ec9c019360714d$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $07ec9c019360714d$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $07ec9c019360714d$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $07ec9c019360714d$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $07ec9c019360714d$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $07ec9c019360714d$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $07ec9c019360714d$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $07ec9c019360714d$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $07ec9c019360714d$var$findNearestBoundary(matches).route.id,
            {
                type: $07ec9c019360714d$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $07ec9c019360714d$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($07ec9c019360714d$var$isErrorResult(result) && $07ec9c019360714d$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $07ec9c019360714d$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $07ec9c019360714d$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $07ec9c019360714d$var$_extends({
            matches: updatedMatches || matches
        }, $07ec9c019360714d$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $07ec9c019360714d$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $07ec9c019360714d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $07ec9c019360714d$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $07ec9c019360714d$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $07ec9c019360714d$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $07ec9c019360714d$var$ResultType.error,
            error: $07ec9c019360714d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($07ec9c019360714d$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $07ec9c019360714d$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($07ec9c019360714d$var$isDeferredResult(result)) throw $07ec9c019360714d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($07ec9c019360714d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $07ec9c019360714d$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $07ec9c019360714d$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $07ec9c019360714d$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $07ec9c019360714d$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($07ec9c019360714d$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $07ec9c019360714d$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $07ec9c019360714d$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $07ec9c019360714d$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $07ec9c019360714d$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $07ec9c019360714d$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $07ec9c019360714d$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $07ec9c019360714d$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $07ec9c019360714d$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $07ec9c019360714d$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$07ec9c019360714d$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $07ec9c019360714d$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $07ec9c019360714d$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $07ec9c019360714d$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $07ec9c019360714d$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $07ec9c019360714d$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $07ec9c019360714d$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $07ec9c019360714d$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $07ec9c019360714d$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $07ec9c019360714d$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $07ec9c019360714d$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $07ec9c019360714d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $07ec9c019360714d$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($07ec9c019360714d$var$isRedirectResult(actionResult) || $07ec9c019360714d$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $07ec9c019360714d$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($07ec9c019360714d$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $07ec9c019360714d$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $07ec9c019360714d$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($07ec9c019360714d$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($07ec9c019360714d$var$isDeferredResult(actionResult)) throw $07ec9c019360714d$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $07ec9c019360714d$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $07ec9c019360714d$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $07ec9c019360714d$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $07ec9c019360714d$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $07ec9c019360714d$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $07ec9c019360714d$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $07ec9c019360714d$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $07ec9c019360714d$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $07ec9c019360714d$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $07ec9c019360714d$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $07ec9c019360714d$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $07ec9c019360714d$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $07ec9c019360714d$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $07ec9c019360714d$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $07ec9c019360714d$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $07ec9c019360714d$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($07ec9c019360714d$var$isDeferredResult(result)) result = await $07ec9c019360714d$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $07ec9c019360714d$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($07ec9c019360714d$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $07ec9c019360714d$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($07ec9c019360714d$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $07ec9c019360714d$export$3e9cee6b33872309(!$07ec9c019360714d$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $07ec9c019360714d$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $07ec9c019360714d$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $07ec9c019360714d$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $07ec9c019360714d$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($07ec9c019360714d$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $07ec9c019360714d$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $07ec9c019360714d$export$e19cd5f9376f8cee.Replace : $07ec9c019360714d$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $07ec9c019360714d$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($07ec9c019360714d$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $07ec9c019360714d$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $07ec9c019360714d$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $07ec9c019360714d$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $07ec9c019360714d$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $07ec9c019360714d$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($07ec9c019360714d$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $07ec9c019360714d$var$ResultType.redirect,
                response: $07ec9c019360714d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $07ec9c019360714d$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $07ec9c019360714d$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $07ec9c019360714d$var$ResultType.error,
                    error: $07ec9c019360714d$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $07ec9c019360714d$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $07ec9c019360714d$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $07ec9c019360714d$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $07ec9c019360714d$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $07ec9c019360714d$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $07ec9c019360714d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $07ec9c019360714d$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $07ec9c019360714d$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $07ec9c019360714d$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $07ec9c019360714d$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $07ec9c019360714d$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $07ec9c019360714d$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $07ec9c019360714d$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $07ec9c019360714d$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$07ec9c019360714d$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $07ec9c019360714d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $07ec9c019360714d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $07ec9c019360714d$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $07ec9c019360714d$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $07ec9c019360714d$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $07ec9c019360714d$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $07ec9c019360714d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $07ec9c019360714d$export$4d0306f8f6a4585b = Symbol("deferred");
function $07ec9c019360714d$export$3336b097a6fbc59a(routes, opts) {
    $07ec9c019360714d$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $07ec9c019360714d$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $07ec9c019360714d$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $07ec9c019360714d$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $07ec9c019360714d$var$createLocation("", $07ec9c019360714d$export$fe53371bee54353d(url), null, "default");
        let matches = $07ec9c019360714d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$07ec9c019360714d$var$isValidMethod(method) && method !== "HEAD") {
            let error = $07ec9c019360714d$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $07ec9c019360714d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $07ec9c019360714d$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $07ec9c019360714d$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($07ec9c019360714d$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $07ec9c019360714d$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $07ec9c019360714d$var$createLocation("", $07ec9c019360714d$export$fe53371bee54353d(url), null, "default");
        let matches = $07ec9c019360714d$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$07ec9c019360714d$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $07ec9c019360714d$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $07ec9c019360714d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $07ec9c019360714d$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $07ec9c019360714d$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $07ec9c019360714d$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($07ec9c019360714d$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$07ec9c019360714d$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $07ec9c019360714d$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($07ec9c019360714d$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $07ec9c019360714d$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $07ec9c019360714d$var$isResponse(result) ? result : $07ec9c019360714d$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($07ec9c019360714d$var$isDataStrategyResult(e) && $07ec9c019360714d$var$isResponse(e.result)) {
                if (e.type === $07ec9c019360714d$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($07ec9c019360714d$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $07ec9c019360714d$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $07ec9c019360714d$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $07ec9c019360714d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($07ec9c019360714d$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($07ec9c019360714d$var$isDeferredResult(result)) {
            let error = $07ec9c019360714d$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $07ec9c019360714d$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($07ec9c019360714d$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($07ec9c019360714d$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $07ec9c019360714d$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $07ec9c019360714d$var$_extends({}, context, {
                statusCode: $07ec9c019360714d$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $07ec9c019360714d$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $07ec9c019360714d$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $07ec9c019360714d$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? $07ec9c019360714d$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $07ec9c019360714d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $07ec9c019360714d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $07ec9c019360714d$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $07ec9c019360714d$var$callDataStrategyImpl(dataStrategy || $07ec9c019360714d$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($07ec9c019360714d$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $07ec9c019360714d$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($07ec9c019360714d$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $07ec9c019360714d$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $07ec9c019360714d$export$fec11da027c70692(routes, context, error) {
    let newContext = $07ec9c019360714d$var$_extends({}, context, {
        statusCode: $07ec9c019360714d$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $07ec9c019360714d$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $07ec9c019360714d$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $07ec9c019360714d$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $07ec9c019360714d$export$cae722b0cc860f13(to ? to : ".", $07ec9c019360714d$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $07ec9c019360714d$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $07ec9c019360714d$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $07ec9c019360714d$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $07ec9c019360714d$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $07ec9c019360714d$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$07ec9c019360714d$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$07ec9c019360714d$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $07ec9c019360714d$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $07ec9c019360714d$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $07ec9c019360714d$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$07ec9c019360714d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$07ec9c019360714d$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $07ec9c019360714d$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $07ec9c019360714d$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $07ec9c019360714d$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $07ec9c019360714d$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $07ec9c019360714d$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($07ec9c019360714d$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $07ec9c019360714d$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $07ec9c019360714d$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $07ec9c019360714d$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $07ec9c019360714d$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $07ec9c019360714d$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $07ec9c019360714d$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $07ec9c019360714d$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $07ec9c019360714d$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $07ec9c019360714d$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($07ec9c019360714d$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $07ec9c019360714d$var$shouldRevalidateLoader(match, $07ec9c019360714d$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $07ec9c019360714d$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $07ec9c019360714d$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $07ec9c019360714d$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $07ec9c019360714d$var$shouldRevalidateLoader(fetcherMatch, $07ec9c019360714d$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $07ec9c019360714d$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $07ec9c019360714d$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $07ec9c019360714d$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $07ec9c019360714d$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $07ec9c019360714d$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $07ec9c019360714d$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$07ec9c019360714d$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $07ec9c019360714d$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $07ec9c019360714d$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$07ec9c019360714d$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $07ec9c019360714d$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $07ec9c019360714d$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $07ec9c019360714d$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$07ec9c019360714d$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $07ec9c019360714d$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $07ec9c019360714d$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $07ec9c019360714d$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $07ec9c019360714d$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $07ec9c019360714d$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $07ec9c019360714d$var$ResultType.data,
                result: undefined
            });
        };
        return $07ec9c019360714d$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $07ec9c019360714d$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $07ec9c019360714d$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $07ec9c019360714d$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $07ec9c019360714d$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $07ec9c019360714d$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $07ec9c019360714d$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $07ec9c019360714d$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($07ec9c019360714d$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $07ec9c019360714d$var$ResultType.error,
                error: e
            };
        }
        if (type === $07ec9c019360714d$var$ResultType.error) return {
            type: $07ec9c019360714d$var$ResultType.error,
            error: new $07ec9c019360714d$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $07ec9c019360714d$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $07ec9c019360714d$var$ResultType.error) {
        if ($07ec9c019360714d$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $07ec9c019360714d$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $07ec9c019360714d$var$ResultType.error,
                error: new $07ec9c019360714d$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $07ec9c019360714d$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $07ec9c019360714d$var$ResultType.error,
            error: result,
            statusCode: $07ec9c019360714d$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($07ec9c019360714d$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $07ec9c019360714d$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($07ec9c019360714d$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $07ec9c019360714d$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $07ec9c019360714d$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $07ec9c019360714d$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $07ec9c019360714d$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$07ec9c019360714d$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $07ec9c019360714d$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $07ec9c019360714d$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($07ec9c019360714d$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $07ec9c019360714d$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $07ec9c019360714d$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($07ec9c019360714d$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $07ec9c019360714d$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $07ec9c019360714d$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $07ec9c019360714d$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $07ec9c019360714d$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $07ec9c019360714d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $07ec9c019360714d$export$3e9cee6b33872309(!$07ec9c019360714d$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($07ec9c019360714d$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $07ec9c019360714d$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $07ec9c019360714d$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($07ec9c019360714d$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $07ec9c019360714d$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $07ec9c019360714d$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $07ec9c019360714d$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($07ec9c019360714d$var$isErrorResult(result)) {
            let boundaryMatch = $07ec9c019360714d$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $07ec9c019360714d$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($07ec9c019360714d$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $07ec9c019360714d$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($07ec9c019360714d$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $07ec9c019360714d$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $07ec9c019360714d$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $07ec9c019360714d$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $07ec9c019360714d$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $07ec9c019360714d$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $07ec9c019360714d$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $07ec9c019360714d$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $07ec9c019360714d$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $07ec9c019360714d$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $07ec9c019360714d$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $07ec9c019360714d$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($07ec9c019360714d$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $07ec9c019360714d$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(path) : path;
    return $07ec9c019360714d$export$fe53371bee54353d($07ec9c019360714d$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $07ec9c019360714d$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $07ec9c019360714d$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $07ec9c019360714d$var$ResultType.data || result.type === $07ec9c019360714d$var$ResultType.error);
}
function $07ec9c019360714d$var$isRedirectDataStrategyResultResult(result) {
    return $07ec9c019360714d$var$isResponse(result.result) && $07ec9c019360714d$var$redirectStatusCodes.has(result.result.status);
}
function $07ec9c019360714d$var$isDeferredResult(result) {
    return result.type === $07ec9c019360714d$var$ResultType.deferred;
}
function $07ec9c019360714d$var$isErrorResult(result) {
    return result.type === $07ec9c019360714d$var$ResultType.error;
}
function $07ec9c019360714d$var$isRedirectResult(result) {
    return (result && result.type) === $07ec9c019360714d$var$ResultType.redirect;
}
function $07ec9c019360714d$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $07ec9c019360714d$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $07ec9c019360714d$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $07ec9c019360714d$var$isRedirectResponse(result) {
    if (!$07ec9c019360714d$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $07ec9c019360714d$var$isValidMethod(method) {
    return $07ec9c019360714d$var$validRequestMethods.has(method.toLowerCase());
}
function $07ec9c019360714d$var$isMutationMethod(method) {
    return $07ec9c019360714d$var$validMutationMethods.has(method.toLowerCase());
}
async function $07ec9c019360714d$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$07ec9c019360714d$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($07ec9c019360714d$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $07ec9c019360714d$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $07ec9c019360714d$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($07ec9c019360714d$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $07ec9c019360714d$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $07ec9c019360714d$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $07ec9c019360714d$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $07ec9c019360714d$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $07ec9c019360714d$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $07ec9c019360714d$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $07ec9c019360714d$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $07ec9c019360714d$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $07ec9c019360714d$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $07ec9c019360714d$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $07ec9c019360714d$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $07ec9c019360714d$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $07ec9c019360714d$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $07ec9c019360714d$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $07ec9c019360714d$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $07ec9c019360714d$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $07ec9c019360714d$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $07ec9c019360714d$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($07ec9c019360714d$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $07ec9c019360714d$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($07ec9c019360714d$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $07ec9c019360714d$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $dBNnn = parcelRequire("dBNnn");

function $bfdf1f7a109a1ee5$var$_extends() {
    $bfdf1f7a109a1ee5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bfdf1f7a109a1ee5$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $bfdf1f7a109a1ee5$export$3add0d5dce533e2e = /*#__PURE__*/ $dBNnn.createContext(null);
const $bfdf1f7a109a1ee5$export$145dfa71566a64dc = /*#__PURE__*/ $dBNnn.createContext(null);
const $bfdf1f7a109a1ee5$var$AwaitContext = /*#__PURE__*/ $dBNnn.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $bfdf1f7a109a1ee5$export$26749e8557646306 = /*#__PURE__*/ $dBNnn.createContext(null);
const $bfdf1f7a109a1ee5$export$c7914228fb69b0f5 = /*#__PURE__*/ $dBNnn.createContext(null);
const $bfdf1f7a109a1ee5$export$9072aa6dd1f93057 = /*#__PURE__*/ $dBNnn.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $bfdf1f7a109a1ee5$var$RouteErrorContext = /*#__PURE__*/ $dBNnn.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $bfdf1f7a109a1ee5$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $07ec9c019360714d$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() {
    return $dBNnn.useContext($bfdf1f7a109a1ee5$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $bfdf1f7a109a1ee5$export$45d76561a5302f2b() {
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return $dBNnn.useContext($bfdf1f7a109a1ee5$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $bfdf1f7a109a1ee5$export$1b3f31771c5d07c() {
    return $dBNnn.useContext($bfdf1f7a109a1ee5$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $bfdf1f7a109a1ee5$export$6c330e8992e8a295(pattern) {
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $bfdf1f7a109a1ee5$export$45d76561a5302f2b();
    return $dBNnn.useMemo(()=>(0, $07ec9c019360714d$export$81336c211d5ff295)(pattern, (0, $07ec9c019360714d$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $bfdf1f7a109a1ee5$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $bfdf1f7a109a1ee5$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $dBNnn.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $bfdf1f7a109a1ee5$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $bfdf1f7a109a1ee5$var$useNavigateStable() : $bfdf1f7a109a1ee5$var$useNavigateUnstable();
}
function $bfdf1f7a109a1ee5$var$useNavigateUnstable() {
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let dataRouterContext = $dBNnn.useContext($bfdf1f7a109a1ee5$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306);
    let { matches: matches } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bfdf1f7a109a1ee5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $07ec9c019360714d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $dBNnn.useRef(false);
    $bfdf1f7a109a1ee5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dBNnn.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $07ec9c019360714d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $07ec9c019360714d$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $bfdf1f7a109a1ee5$var$OutletContext = /*#__PURE__*/ $dBNnn.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $bfdf1f7a109a1ee5$export$4138103a3ae699cc() {
    return $dBNnn.useContext($bfdf1f7a109a1ee5$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $bfdf1f7a109a1ee5$export$a3be3530d8e40d0b(context) {
    let outlet = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $bfdf1f7a109a1ee5$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306);
    let { matches: matches } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bfdf1f7a109a1ee5$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $07ec9c019360714d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $dBNnn.useMemo(()=>(0, $07ec9c019360714d$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $bfdf1f7a109a1ee5$export$5d3fca4a98652595(routes, locationArg) {
    return $bfdf1f7a109a1ee5$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $bfdf1f7a109a1ee5$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let { navigator: navigator, static: isStatic } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306);
    let { matches: parentMatches } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $bfdf1f7a109a1ee5$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $07ec9c019360714d$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, $07ec9c019360714d$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $bfdf1f7a109a1ee5$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $07ec9c019360714d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $07ec9c019360714d$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $bfdf1f7a109a1ee5$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $07ec9c019360714d$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $bfdf1f7a109a1ee5$var$DefaultErrorComponent() {
    let error = $bfdf1f7a109a1ee5$export$ed527bf60f6e05f2();
    let message = (0, $07ec9c019360714d$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $dBNnn.createElement($dBNnn.Fragment, null, /*#__PURE__*/ $dBNnn.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $dBNnn.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $dBNnn.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $bfdf1f7a109a1ee5$var$defaultErrorElement = /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$DefaultErrorComponent, null);
class $bfdf1f7a109a1ee5$var$RenderErrorBoundary extends $dBNnn.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $bfdf1f7a109a1ee5$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $dBNnn.useContext($bfdf1f7a109a1ee5$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $bfdf1f7a109a1ee5$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $bfdf1f7a109a1ee5$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $bfdf1f7a109a1ee5$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $dBNnn.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $bfdf1f7a109a1ee5$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($bfdf1f7a109a1ee5$var$DataRouterHook || {});
var $bfdf1f7a109a1ee5$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($bfdf1f7a109a1ee5$var$DataRouterStateHook || {});
function $bfdf1f7a109a1ee5$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $bfdf1f7a109a1ee5$var$useDataRouterContext(hookName) {
    let ctx = $dBNnn.useContext($bfdf1f7a109a1ee5$export$3add0d5dce533e2e);
    !ctx && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $bfdf1f7a109a1ee5$var$useDataRouterState(hookName) {
    let state = $dBNnn.useContext($bfdf1f7a109a1ee5$export$145dfa71566a64dc);
    !state && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return state;
}
function $bfdf1f7a109a1ee5$var$useRouteContext(hookName) {
    let route = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    !route && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $bfdf1f7a109a1ee5$var$useCurrentRouteId(hookName) {
    let route = $bfdf1f7a109a1ee5$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $bfdf1f7a109a1ee5$export$5fc8298006ad9e58() {
    return $bfdf1f7a109a1ee5$var$useCurrentRouteId($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $bfdf1f7a109a1ee5$export$d0fd4b7106de2769() {
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $bfdf1f7a109a1ee5$export$600dc272ed516c15() {
    let dataRouterContext = $bfdf1f7a109a1ee5$var$useDataRouterContext($bfdf1f7a109a1ee5$var$DataRouterHook.UseRevalidator);
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseRevalidator);
    return $dBNnn.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $bfdf1f7a109a1ee5$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseMatches);
    return $dBNnn.useMemo(()=>matches.map((m)=>(0, $07ec9c019360714d$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $bfdf1f7a109a1ee5$export$1448a5050d252c4d() {
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseLoaderData);
    let routeId = $bfdf1f7a109a1ee5$var$useCurrentRouteId($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $bfdf1f7a109a1ee5$export$fd5d37484eab868d(routeId) {
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $bfdf1f7a109a1ee5$export$fdc00f3f26066d5e() {
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseActionData);
    let routeId = $bfdf1f7a109a1ee5$var$useCurrentRouteId($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $bfdf1f7a109a1ee5$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $dBNnn.useContext($bfdf1f7a109a1ee5$var$RouteErrorContext);
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseRouteError);
    let routeId = $bfdf1f7a109a1ee5$var$useCurrentRouteId($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $bfdf1f7a109a1ee5$export$78a72ddb39bdd145() {
    let value = $dBNnn.useContext($bfdf1f7a109a1ee5$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $bfdf1f7a109a1ee5$export$17f53340677d5831() {
    let value = $dBNnn.useContext($bfdf1f7a109a1ee5$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $bfdf1f7a109a1ee5$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $bfdf1f7a109a1ee5$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $bfdf1f7a109a1ee5$var$useDataRouterContext($bfdf1f7a109a1ee5$var$DataRouterHook.UseBlocker);
    let state = $bfdf1f7a109a1ee5$var$useDataRouterState($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $dBNnn.useState("");
    let blockerFunction = $dBNnn.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $bfdf1f7a109a1ee5$var$_extends({}, currentLocation, {
                pathname: (0, $07ec9c019360714d$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $bfdf1f7a109a1ee5$var$_extends({}, nextLocation, {
                pathname: (0, $07ec9c019360714d$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $dBNnn.useEffect(()=>{
        let key = String(++$bfdf1f7a109a1ee5$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $dBNnn.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $07ec9c019360714d$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $bfdf1f7a109a1ee5$var$useNavigateStable() {
    let { router: router } = $bfdf1f7a109a1ee5$var$useDataRouterContext($bfdf1f7a109a1ee5$var$DataRouterHook.UseNavigateStable);
    let id = $bfdf1f7a109a1ee5$var$useCurrentRouteId($bfdf1f7a109a1ee5$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $dBNnn.useRef(false);
    $bfdf1f7a109a1ee5$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $dBNnn.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $bfdf1f7a109a1ee5$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $bfdf1f7a109a1ee5$var$alreadyWarned$1 = {};
function $bfdf1f7a109a1ee5$var$warningOnce(key, cond, message) {
    if (!cond && !$bfdf1f7a109a1ee5$var$alreadyWarned$1[key]) $bfdf1f7a109a1ee5$var$alreadyWarned$1[key] = true;
}
const $bfdf1f7a109a1ee5$var$alreadyWarned = {};
function $bfdf1f7a109a1ee5$var$warnOnce(key, message) {}
const $bfdf1f7a109a1ee5$var$logDeprecation = (flag, msg, link)=>$bfdf1f7a109a1ee5$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $bfdf1f7a109a1ee5$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $bfdf1f7a109a1ee5$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) $bfdf1f7a109a1ee5$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $bfdf1f7a109a1ee5$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $bfdf1f7a109a1ee5$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $bfdf1f7a109a1ee5$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $bfdf1f7a109a1ee5$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $bfdf1f7a109a1ee5$var$START_TRANSITION = "startTransition";
const $bfdf1f7a109a1ee5$var$startTransitionImpl = $dBNnn[$bfdf1f7a109a1ee5$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $bfdf1f7a109a1ee5$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dBNnn.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dBNnn.useCallback((newState)=>{
        if (v7_startTransition && $bfdf1f7a109a1ee5$var$startTransitionImpl) $bfdf1f7a109a1ee5$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dBNnn.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $dBNnn.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dBNnn.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dBNnn.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $dBNnn.useEffect(()=>$bfdf1f7a109a1ee5$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dBNnn.createElement($dBNnn.Fragment, null, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $bfdf1f7a109a1ee5$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $bfdf1f7a109a1ee5$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $bfdf1f7a109a1ee5$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $dBNnn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $07ec9c019360714d$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dBNnn.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dBNnn.useCallback((newState)=>{
        v7_startTransition && $bfdf1f7a109a1ee5$var$startTransitionImpl ? $bfdf1f7a109a1ee5$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dBNnn.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dBNnn.useEffect(()=>$bfdf1f7a109a1ee5$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $bfdf1f7a109a1ee5$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$26749e8557646306);
    let { matches: matches } = $dBNnn.useContext($bfdf1f7a109a1ee5$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $bfdf1f7a109a1ee5$export$45d76561a5302f2b();
    let navigate = $bfdf1f7a109a1ee5$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $07ec9c019360714d$export$cae722b0cc860f13)(to, (0, $07ec9c019360714d$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $dBNnn.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $bfdf1f7a109a1ee5$export$910ae8079b2c2852(props) {
    return $bfdf1f7a109a1ee5$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6(_props) {
    (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $bfdf1f7a109a1ee5$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $07ec9c019360714d$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$bfdf1f7a109a1ee5$export$9c954a9d03d32f4a() && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $dBNnn.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $bfdf1f7a109a1ee5$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $07ec9c019360714d$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $dBNnn.useMemo(()=>{
        let trailingPathname = (0, $07ec9c019360714d$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $bfdf1f7a109a1ee5$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $bfdf1f7a109a1ee5$export$5d3fca4a98652595($bfdf1f7a109a1ee5$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $bfdf1f7a109a1ee5$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$ResolveAwait, null, children));
}
var $bfdf1f7a109a1ee5$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($bfdf1f7a109a1ee5$var$AwaitRenderStatus || {});
const $bfdf1f7a109a1ee5$var$neverSettledPromise = new Promise(()=>{});
class $bfdf1f7a109a1ee5$var$AwaitErrorBoundary extends $dBNnn.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $bfdf1f7a109a1ee5$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $bfdf1f7a109a1ee5$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $bfdf1f7a109a1ee5$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $bfdf1f7a109a1ee5$var$AwaitRenderStatus.error : "_data" in promise ? $bfdf1f7a109a1ee5$var$AwaitRenderStatus.success : $bfdf1f7a109a1ee5$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $bfdf1f7a109a1ee5$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $bfdf1f7a109a1ee5$var$AwaitRenderStatus.error && promise._error instanceof (0, $07ec9c019360714d$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $bfdf1f7a109a1ee5$var$neverSettledPromise;
        if (status === $bfdf1f7a109a1ee5$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $bfdf1f7a109a1ee5$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $bfdf1f7a109a1ee5$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $dBNnn.createElement($bfdf1f7a109a1ee5$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $bfdf1f7a109a1ee5$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $bfdf1f7a109a1ee5$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $dBNnn.createElement($dBNnn.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $bfdf1f7a109a1ee5$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $dBNnn.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $dBNnn.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $dBNnn.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $bfdf1f7a109a1ee5$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $bfdf1f7a109a1ee5$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $bfdf1f7a109a1ee5$export$daf73786167a7f72(matches) {
    return $bfdf1f7a109a1ee5$var$_renderMatches(matches);
}
function $bfdf1f7a109a1ee5$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $dBNnn.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $dBNnn.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $dBNnn.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $bfdf1f7a109a1ee5$export$f30f7e456d254e83(routes, opts) {
    return (0, $07ec9c019360714d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $bfdf1f7a109a1ee5$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $07ec9c019360714d$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $bfdf1f7a109a1ee5$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $b08650187def67b8$var$_extends() {
    $b08650187def67b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b08650187def67b8$var$_extends.apply(this, arguments);
}
function $b08650187def67b8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b08650187def67b8$var$defaultMethod = "get";
const $b08650187def67b8$var$defaultEncType = "application/x-www-form-urlencoded";
function $b08650187def67b8$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b08650187def67b8$var$isButtonElement(object) {
    return $b08650187def67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b08650187def67b8$var$isFormElement(object) {
    return $b08650187def67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b08650187def67b8$var$isInputElement(object) {
    return $b08650187def67b8$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b08650187def67b8$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b08650187def67b8$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b08650187def67b8$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b08650187def67b8$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b08650187def67b8$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b08650187def67b8$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b08650187def67b8$var$_formDataSupportsSubmitter = null;
function $b08650187def67b8$var$isFormDataSubmitterSupported() {
    if ($b08650187def67b8$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b08650187def67b8$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b08650187def67b8$var$_formDataSupportsSubmitter = true;
    }
    return $b08650187def67b8$var$_formDataSupportsSubmitter;
}
const $b08650187def67b8$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b08650187def67b8$var$getFormEncType(encType) {
    if (encType != null && !$b08650187def67b8$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b08650187def67b8$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b08650187def67b8$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $07ec9c019360714d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $b08650187def67b8$var$defaultMethod;
        encType = $b08650187def67b8$var$getFormEncType(target.getAttribute("enctype")) || $b08650187def67b8$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b08650187def67b8$var$isButtonElement(target) || $b08650187def67b8$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $07ec9c019360714d$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b08650187def67b8$var$defaultMethod;
        encType = $b08650187def67b8$var$getFormEncType(target.getAttribute("formenctype")) || $b08650187def67b8$var$getFormEncType(form.getAttribute("enctype")) || $b08650187def67b8$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b08650187def67b8$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b08650187def67b8$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b08650187def67b8$var$defaultMethod;
        action = null;
        encType = $b08650187def67b8$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b08650187def67b8$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $b08650187def67b8$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $b08650187def67b8$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b08650187def67b8$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b08650187def67b8$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b08650187def67b8$export$1f3f55432a00e06d(routes, opts) {
    return (0, $07ec9c019360714d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b08650187def67b8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $07ec9c019360714d$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b08650187def67b8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bfdf1f7a109a1ee5$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b08650187def67b8$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $07ec9c019360714d$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b08650187def67b8$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $07ec9c019360714d$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b08650187def67b8$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $bfdf1f7a109a1ee5$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b08650187def67b8$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b08650187def67b8$var$_extends({}, state, {
        errors: $b08650187def67b8$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b08650187def67b8$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $07ec9c019360714d$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b08650187def67b8$export$7ad602f0e94e62d1 = /*#__PURE__*/ $dBNnn.createContext({
    isTransitioning: false
});
const $b08650187def67b8$export$148fd98d095596d4 = /*#__PURE__*/ $dBNnn.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b08650187def67b8$var$START_TRANSITION = "startTransition";
const $b08650187def67b8$var$startTransitionImpl = $dBNnn[$b08650187def67b8$var$START_TRANSITION];
const $b08650187def67b8$var$FLUSH_SYNC = "flushSync";
const $b08650187def67b8$var$flushSyncImpl = $a6afE[$b08650187def67b8$var$FLUSH_SYNC];
const $b08650187def67b8$var$USE_ID = "useId";
const $b08650187def67b8$var$useIdImpl = $dBNnn[$b08650187def67b8$var$USE_ID];
function $b08650187def67b8$var$startTransitionSafe(cb) {
    if ($b08650187def67b8$var$startTransitionImpl) $b08650187def67b8$var$startTransitionImpl(cb);
    else cb();
}
function $b08650187def67b8$var$flushSyncSafe(cb) {
    if ($b08650187def67b8$var$flushSyncImpl) $b08650187def67b8$var$flushSyncImpl(cb);
    else cb();
}
class $b08650187def67b8$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b08650187def67b8$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $dBNnn.useState(router.state);
    let [pendingState, setPendingState] = $dBNnn.useState();
    let [vtContext, setVtContext] = $dBNnn.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $dBNnn.useState();
    let [transition, setTransition] = $dBNnn.useState();
    let [interruption, setInterruption] = $dBNnn.useState();
    let fetcherData = $dBNnn.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $dBNnn.useCallback((cb)=>{
        if (v7_startTransition) $b08650187def67b8$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $dBNnn.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b08650187def67b8$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b08650187def67b8$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b08650187def67b8$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b08650187def67b8$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b08650187def67b8$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $dBNnn.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $dBNnn.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b08650187def67b8$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $dBNnn.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $dBNnn.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $dBNnn.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $dBNnn.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $dBNnn.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $dBNnn.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $dBNnn.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $dBNnn.useEffect(()=>(0, $bfdf1f7a109a1ee5$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $dBNnn.createElement($dBNnn.Fragment, null, /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $dBNnn.createElement($b08650187def67b8$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $dBNnn.createElement($b08650187def67b8$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $dBNnn.createElement($b08650187def67b8$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $b08650187def67b8$var$MemoizedDataRoutes = /*#__PURE__*/ $dBNnn.memo($b08650187def67b8$var$DataRoutes);
function $b08650187def67b8$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $bfdf1f7a109a1ee5$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b08650187def67b8$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $dBNnn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $07ec9c019360714d$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dBNnn.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dBNnn.useCallback((newState)=>{
        v7_startTransition && $b08650187def67b8$var$startTransitionImpl ? $b08650187def67b8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dBNnn.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dBNnn.useEffect(()=>(0, $bfdf1f7a109a1ee5$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b08650187def67b8$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $dBNnn.useRef();
    if (historyRef.current == null) historyRef.current = (0, $07ec9c019360714d$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $dBNnn.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dBNnn.useCallback((newState)=>{
        v7_startTransition && $b08650187def67b8$var$startTransitionImpl ? $b08650187def67b8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dBNnn.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dBNnn.useEffect(()=>(0, $bfdf1f7a109a1ee5$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b08650187def67b8$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $dBNnn.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $dBNnn.useCallback((newState)=>{
        v7_startTransition && $b08650187def67b8$var$startTransitionImpl ? $b08650187def67b8$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $dBNnn.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $dBNnn.useEffect(()=>(0, $bfdf1f7a109a1ee5$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $dBNnn.createElement((0, $bfdf1f7a109a1ee5$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $b08650187def67b8$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b08650187def67b8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b08650187def67b8$export$a6c7ac8248d6e38a = /*#__PURE__*/ $dBNnn.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $b08650187def67b8$var$_objectWithoutPropertiesLoose(_ref7, $b08650187def67b8$var$_excluded);
    let { basename: basename } = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b08650187def67b8$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b08650187def67b8$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $07ec9c019360714d$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $bfdf1f7a109a1ee5$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $b08650187def67b8$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $dBNnn.createElement("a", $b08650187def67b8$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b08650187def67b8$export$b0d92dbee9b5b60d = /*#__PURE__*/ $dBNnn.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $b08650187def67b8$var$_objectWithoutPropertiesLoose(_ref8, $b08650187def67b8$var$_excluded2);
    let path = (0, $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $bfdf1f7a109a1ee5$export$45d76561a5302f2b)();
    let routerState = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b08650187def67b8$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $07ec9c019360714d$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $dBNnn.createElement($b08650187def67b8$export$a6c7ac8248d6e38a, $b08650187def67b8$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b08650187def67b8$export$a7fed597f4b8afd8 = /*#__PURE__*/ $dBNnn.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b08650187def67b8$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $b08650187def67b8$var$_objectWithoutPropertiesLoose(_ref9, $b08650187def67b8$var$_excluded3);
    let submit = $b08650187def67b8$export$47c85c6e3a081d3();
    let formAction = $b08650187def67b8$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $dBNnn.createElement("form", $b08650187def67b8$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b08650187def67b8$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b08650187def67b8$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b08650187def67b8$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b08650187def67b8$var$DataRouterHook || ($b08650187def67b8$var$DataRouterHook = {}));
var $b08650187def67b8$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b08650187def67b8$var$DataRouterStateHook || ($b08650187def67b8$var$DataRouterStateHook = {}));
// Internal hooks
function $b08650187def67b8$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $b08650187def67b8$var$useDataRouterContext(hookName) {
    let ctx = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$3add0d5dce533e2e));
    !ctx && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return ctx;
}
function $b08650187def67b8$var$useDataRouterState(hookName) {
    let state = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$145dfa71566a64dc));
    !state && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b08650187def67b8$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    let location = (0, $bfdf1f7a109a1ee5$export$45d76561a5302f2b)();
    let path = (0, $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $dBNnn.useCallback((event)=>{
        if ($b08650187def67b8$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $07ec9c019360714d$export$fe53371bee54353d)(location) === (0, $07ec9c019360714d$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b08650187def67b8$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $dBNnn.useRef($b08650187def67b8$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $dBNnn.useRef(false);
    let location = (0, $bfdf1f7a109a1ee5$export$45d76561a5302f2b)();
    let searchParams = $dBNnn.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b08650187def67b8$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    let setSearchParams = $dBNnn.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b08650187def67b8$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b08650187def67b8$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b08650187def67b8$var$fetcherId = 0;
let $b08650187def67b8$var$getUniqueFetcherId = ()=>"__" + String(++$b08650187def67b8$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b08650187def67b8$export$47c85c6e3a081d3() {
    let { router: router } = $b08650187def67b8$var$useDataRouterContext($b08650187def67b8$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$26749e8557646306));
    let currentRouteId = (0, $bfdf1f7a109a1ee5$export$5fc8298006ad9e58)();
    return $dBNnn.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b08650187def67b8$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b08650187def67b8$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b08650187def67b8$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b08650187def67b8$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$26749e8557646306));
    let routeContext = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$9072aa6dd1f93057));
    !routeContext && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b08650187def67b8$var$_extends({}, (0, $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $bfdf1f7a109a1ee5$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $07ec9c019360714d$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $07ec9c019360714d$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b08650187def67b8$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b08650187def67b8$var$useDataRouterContext($b08650187def67b8$var$DataRouterHook.UseFetcher);
    let state = $b08650187def67b8$var$useDataRouterState($b08650187def67b8$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $dBNnn.useContext($b08650187def67b8$export$148fd98d095596d4);
    let route = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    !route && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b08650187def67b8$var$useIdImpl ? $b08650187def67b8$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $dBNnn.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b08650187def67b8$var$getUniqueFetcherId());
    // Registration/cleanup
    $dBNnn.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $dBNnn.useCallback((href, opts)=>{
        !routeId && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b08650187def67b8$export$47c85c6e3a081d3();
    let submit = $dBNnn.useCallback((target, opts)=>{
        submitImpl(target, $b08650187def67b8$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $dBNnn.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $dBNnn.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $dBNnn.createElement($b08650187def67b8$export$a7fed597f4b8afd8, $b08650187def67b8$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $07ec9c019360714d$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $dBNnn.useMemo(()=>$b08650187def67b8$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b08650187def67b8$export$fa996778a3a31087() {
    let state = $b08650187def67b8$var$useDataRouterState($b08650187def67b8$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b08650187def67b8$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b08650187def67b8$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b08650187def67b8$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b08650187def67b8$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b08650187def67b8$var$useDataRouterContext($b08650187def67b8$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b08650187def67b8$var$useDataRouterState($b08650187def67b8$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $dBNnn.useContext((0, $bfdf1f7a109a1ee5$export$26749e8557646306));
    let location = (0, $bfdf1f7a109a1ee5$export$45d76561a5302f2b)();
    let matches = (0, $bfdf1f7a109a1ee5$export$2378eb7f5ff86053)();
    let navigation = (0, $bfdf1f7a109a1ee5$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $dBNnn.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b08650187def67b8$var$usePageHide($dBNnn.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b08650187def67b8$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b08650187def67b8$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b08650187def67b8$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dBNnn.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b08650187def67b8$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b08650187def67b8$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dBNnn.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b08650187def67b8$var$_extends({}, location, {
                    pathname: (0, $07ec9c019360714d$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b08650187def67b8$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $dBNnn.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b08650187def67b8$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $dBNnn.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b08650187def67b8$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $dBNnn.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b08650187def67b8$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $bfdf1f7a109a1ee5$export$b273b3273281a049)(when);
    $dBNnn.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $dBNnn.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b08650187def67b8$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $dBNnn.useContext($b08650187def67b8$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $07ec9c019360714d$export$3e9cee6b33872309)(false);
    let { basename: basename } = $b08650187def67b8$var$useDataRouterContext($b08650187def67b8$var$DataRouterHook.useViewTransitionState);
    let path = (0, $bfdf1f7a109a1ee5$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $07ec9c019360714d$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $07ec9c019360714d$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $07ec9c019360714d$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $07ec9c019360714d$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}




var $ee16f7e54946bcf0$exports = {};
var $285605c28808fe7f$exports = {};
var $a1dea9026fe17b79$exports = {};
function $a1dea9026fe17b79$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a1dea9026fe17b79$exports = $a1dea9026fe17b79$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a1dea9026fe17b79$exports.__esModule = true, $a1dea9026fe17b79$exports["default"] = $a1dea9026fe17b79$exports, $a1dea9026fe17b79$var$_typeof(o);
}
$a1dea9026fe17b79$exports = $a1dea9026fe17b79$var$_typeof, $a1dea9026fe17b79$exports.__esModule = true, $a1dea9026fe17b79$exports["default"] = $a1dea9026fe17b79$exports;


var $285605c28808fe7f$var$_typeof = $a1dea9026fe17b79$exports.default;
var $942c091057179846$exports = {};

var $942c091057179846$var$_typeof = $a1dea9026fe17b79$exports.default;
function $942c091057179846$var$toPrimitive(t, r) {
    if ("object" != $942c091057179846$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $942c091057179846$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$942c091057179846$exports = $942c091057179846$var$toPrimitive, $942c091057179846$exports.__esModule = true, $942c091057179846$exports["default"] = $942c091057179846$exports;


function $285605c28808fe7f$var$toPropertyKey(t) {
    var i = $942c091057179846$exports(t, "string");
    return "symbol" == $285605c28808fe7f$var$_typeof(i) ? i : i + "";
}
$285605c28808fe7f$exports = $285605c28808fe7f$var$toPropertyKey, $285605c28808fe7f$exports.__esModule = true, $285605c28808fe7f$exports["default"] = $285605c28808fe7f$exports;


function $ee16f7e54946bcf0$var$_defineProperty(e, r, t) {
    return (r = $285605c28808fe7f$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$ee16f7e54946bcf0$exports = $ee16f7e54946bcf0$var$_defineProperty, $ee16f7e54946bcf0$exports.__esModule = true, $ee16f7e54946bcf0$exports["default"] = $ee16f7e54946bcf0$exports;



var $dBNnn = parcelRequire("dBNnn");





var $dBNnn = parcelRequire("dBNnn");



var $dBNnn = parcelRequire("dBNnn");

parcelRequire("dBNnn");
const $78f4ebdc4943af05$var$EBINavItem = (props)=>{
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
        className: props.className,
        onClick: props.handleClickChildFunction,
        children: props.children
    });
};
var $78f4ebdc4943af05$export$2e2bcd8739ae039 = $78f4ebdc4943af05$var$EBINavItem;


class $c0aa2f3b45abd23c$var$EBINavDropDown extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickChild", ()=>{
            this.setState({
                expanded: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickExpandLink", ()=>{
            this.setState({
                expanded: !this.state.expanded
            });
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { handleClickChild: handleClickChild, handleClickExpandLink: handleClickExpandLink, props: { handleClickChildFunction: handleClickChildFunction, children: children, caption: caption }, state: { expanded: expanded } } = this;
        const childrenList = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).cloneElement(child, {
                handleClickChildFunction: ()=>{
                    handleClickChild();
                    handleClickChildFunction && handleClickChildFunction();
                }
            }));
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                    href: "#!",
                    onClick: handleClickExpandLink,
                    children: [
                        caption,
                        " ",
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                            className: "icon icon-common icon-angle-down"
                        })
                    ]
                }),
                expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("ul", {
                        className: "EBINav-dropdown",
                        children: childrenList
                    })
                })
            ]
        });
    }
}
var $c0aa2f3b45abd23c$export$2e2bcd8739ae039 = $c0aa2f3b45abd23c$var$EBINavDropDown;


class $7afe89e02b13004d$var$EBINavBar extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        this.state = {
            width: window.innerWidth
        };
    }
    componentDidMount() {
        window.addEventListener('resize', ()=>this.setState({
                width: window.innerWidth
            }));
    }
    render() {
        const { props: { children: children, modifiers: modifiers } } = this;
        const modifierClasses = modifiers.length ? modifiers.reduce((result, modifier)=>{
            result = `${result} ${$7afe89e02b13004d$var$EBINavBar.baseClass}--${modifier}`;
            return result;
        }, '') : '';
        const visibleElements = Math.floor(window.innerWidth / 170) - 1;
        const childrenList = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Children.map(children, (child)=>child);
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            className: `${$7afe89e02b13004d$var$EBINavBar.baseClass} ${modifierClasses}`,
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("nav", {
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("ul", {
                    id: "local-nav",
                    className: "dropdown menu float-start",
                    "data-description": "navigational",
                    children: [
                        childrenList.slice(0, visibleElements),
                        childrenList.length > visibleElements && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $c0aa2f3b45abd23c$export$2e2bcd8739ae039), {
                            caption: "Also in this section",
                            children: childrenList.slice(visibleElements)
                        })
                    ]
                })
            })
        });
    }
}
$7afe89e02b13004d$var$EBINavBar.baseClass = 'EBINavBar';
var $7afe89e02b13004d$export$2e2bcd8739ae039 = $7afe89e02b13004d$var$EBINavBar;






var $dBNnn = parcelRequire("dBNnn");
// Adapted from https://medium.com/trendkite-dev/building-a-sticky-header-component-in-react-f2117099a9a2
class $6e1bdcbc0d8fe278$var$Sticky extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "state", {
            height: 0,
            width: 0,
            stuckTop: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "frameId", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "stickyDiv", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef());
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleScroll", ()=>{
            const { sides: sides } = this.props;
            const stickyDiv = this.stickyDiv.current || null;
            const scrollTarget = this.props.scrollTarget || window;
            this.frameId = 0;
            if (!stickyDiv) return;
            const scrollRect = scrollTarget.getBoundingClientRect ? scrollTarget.getBoundingClientRect() : {
                height: scrollTarget.innerHeight,
                width: scrollTarget.innerWidth,
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                x: scrollTarget.scrollX,
                y: scrollTarget.scrollY
            };
            let stickyRect = stickyDiv.getBoundingClientRect();
            if (!this.state.height || !this.state.width) this.setState({
                height: stickyRect.height,
                width: stickyRect.height
            });
            stickyRect = {
                height: this.state.height || stickyRect.height,
                width: this.state.width || stickyRect.width,
                x: stickyRect.x,
                y: stickyRect.y
            };
            if (typeof sides.bottom === 'number') {
                const stuckBottom = stickyRect.y + stickyRect.height > scrollRect.height + scrollRect.top - sides.bottom;
                this.setState({
                    stuckBottom: stuckBottom
                });
            }
            if (typeof sides.top === 'number') {
                const stuckTop = stickyRect.y < scrollRect.top + sides.top;
                this.setState({
                    stuckTop: stuckTop
                });
            }
            if (typeof sides.left === 'number') {
                const stuckLeft = stickyRect.x < scrollRect.left + sides.left;
                this.setState({
                    stuckLeft: stuckLeft
                });
            }
            if (typeof sides.right === 'number') {
                const stuckRight = stickyRect.x + stickyRect.width > scrollRect.width + scrollRect.left - sides.right;
                this.setState({
                    stuckRight: stuckRight
                });
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "debouncedScroll", ()=>{
            if (!this.frameId) {
                const frameId = requestAnimationFrame(this.handleScroll);
                this.frameId = frameId;
            }
        });
    }
    componentDidMount() {
        this.addEvents();
        this.handleScroll();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.scrollTarget !== this.props.scrollTarget) {
            this.removeEvents();
            this.addEvents();
        }
    }
    componentWillUnmount() {
        this.removeEvents();
    }
    addEvents() {
        const scrollTarget = this.props.scrollTarget || window;
        if (scrollTarget && this.stickyDiv.current) scrollTarget.addEventListener('scroll', this.debouncedScroll);
    }
    removeEvents() {
        const scrollTarget = this.props.scrollTarget || window;
        if (scrollTarget) scrollTarget.removeEventListener('scroll', this.debouncedScroll);
        if (this.frameId) cancelAnimationFrame(this.frameId);
    }
    render() {
        const { children: children } = this.props;
        const { stuckBottom: stuckBottom, stuckLeft: stuckLeft, stuckRight: stuckRight, stuckTop: stuckTop } = this.state;
        const stickyModifiers = [];
        if (stuckBottom) stickyModifiers.push('stuck-bottom');
        if (stuckLeft) stickyModifiers.push('stuck-left');
        if (stuckRight) stickyModifiers.push('stuck-right');
        if (stuckTop) stickyModifiers.push('stuck-top');
        const childrenWithStuckProps = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Children.map(children, (child)=>{
            const childModifiers = child.props && child.props.modifiers || [];
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).cloneElement(child, {
                modifiers: [
                    ...childModifiers,
                    ...stickyModifiers
                ]
            });
        });
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            className: $6e1bdcbc0d8fe278$var$Sticky.baseClass,
            ref: this.stickyDiv,
            children: childrenWithStuckProps
        });
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))($6e1bdcbc0d8fe278$var$Sticky, "baseClass", 'Sticky-base');
$6e1bdcbc0d8fe278$var$Sticky.defaultProps = {
    scrollTarget: null,
    sides: {
        top: 0
    }
};
var $6e1bdcbc0d8fe278$export$2e2bcd8739ae039 = $6e1bdcbc0d8fe278$var$Sticky;



var $ebfb0f2464c2ca63$exports = {};
$ebfb0f2464c2ca63$exports = $parcel$resolve("3TXTY");


// Assets.
const $6fdc6fa6a39680d8$var$identifiersLogo = new URL($ebfb0f2464c2ca63$exports);
// This code was written for v5 and code adjusts v6 to have the same behavious as v5
// https://reactrouter.com/en/main/components/nav-link
const $6fdc6fa6a39680d8$var$NavLink = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).forwardRef(({ activeClassName: activeClassName, activeStyle: activeStyle, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b08650187def67b8$export$b0d92dbee9b5b60d), {
        ref: ref,
        ...props,
        className: ({ isActive: isActive })=>[
                props.className,
                isActive ? activeClassName : null
            ].filter(Boolean).join(" "),
        style: ({ isActive: isActive })=>({
                ...props.style,
                ...isActive ? activeStyle : null
            })
    });
});
class $6fdc6fa6a39680d8$var$Header extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickSignIn", ()=>{
            const { auth: auth, doSignIn: doSignIn } = this.props;
            if (typeof auth.authenticated !== 'undefined' && !auth.authenticated) doSignIn();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickSignOut", ()=>{
            const { auth: auth, doSignOut: doSignOut } = this.props;
            if (typeof auth.authenticated !== 'undefined' && auth.authenticated) doSignOut();
        });
    }
    componentDidMount() {
        ebiFrameworkPopulateBlackBar();
        ebiFrameworkActivateBlackBar();
        ebiFrameworkExternalLinks();
        ebiFrameworkManageGlobalSearch();
        ebiFrameworkSearchNullError();
        ebiFrameworkHideGlobalNav();
        ebiFrameworkAssignImageByMetaTags();
        ebiFrameworkInsertEMBLdropdown();
    }
    render() {
        const { handleClickSignIn: handleClickSignIn, handleClickSignOut: handleClickSignOut, props: { auth: auth, config: config } } = this;
        return(// This is EMBL-EBI Enforced boilerplate header.
        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("header", {
                    id: "masthead-black-bar",
                    className: "clearfix masthead-black-bar expanded",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("nav", {
                        className: "position-relative",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("ul", {
                            id: "global-nav",
                            className: "menu",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "home-mobile",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "home",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk",
                                        children: "EMBL-EBI"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "services",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk/services",
                                        children: "Services"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "research",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk/research",
                                        children: "Research"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "training",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk/training",
                                        children: "Training"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "about",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "//www.ebi.ac.uk/about",
                                        children: "About us"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("li", {
                                    className: "search",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                            href: "#",
                                            "data-bs-toggle": "search-global-dropdown",
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "show-for-small-only",
                                                children: "Search"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                            id: "search-global-dropdown",
                                            className: "dropdown-pane",
                                            "data-bs-dropdown": true,
                                            "data-options": "closeOnClick:true;"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: "float-end show-for-medium embl-selector",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                        className: "button float-end",
                                        type: "button",
                                        "data-bs-toggle": "embl-dropdown",
                                        children: "Hinxton"
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    id: "content",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        "data-sticky-container": true,
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            id: "masthead",
                            className: "masthead",
                            "data-sticky": true,
                            "data-sticky-on": "large",
                            "data-top-anchor": "main-content-area:top",
                            "data-btm-anchor": "main-content-area:bottom",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                className: "masthead-inner row expanded",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                        className: "columns medium-12",
                                        id: "local-title",
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "d-flex ms-3 mb-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("img", {
                                                    src: $6fdc6fa6a39680d8$var$identifiersLogo
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "logo-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("h1", {
                                                            children: "Identifiers.org"
                                                        }),
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                            className: "logo-subtitle",
                                                            children: "Central registry"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                        className: "sticky-placeholder px-0",
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $6e1bdcbc0d8fe278$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $7afe89e02b13004d$export$2e2bcd8739ae039), {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: config.satelliteUrl,
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-external-link-alt me-1"
                                                                }),
                                                                "Resolution"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)($6fdc6fa6a39680d8$var$NavLink, {
                                                            to: "/",
                                                            className: "nav-link",
                                                            activeClassName: "active",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-list me-1"
                                                                }),
                                                                "Registry"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)($6fdc6fa6a39680d8$var$NavLink, {
                                                            to: "/registry",
                                                            className: "nav-link",
                                                            activeClassName: "active",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-search me-1"
                                                                }),
                                                                "Browse the registry"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $c0aa2f3b45abd23c$export$2e2bcd8739ae039), {
                                                        caption: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-hand-point-up me-1"
                                                                }),
                                                                "Make a request"
                                                            ]
                                                        }),
                                                        children: [
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                                className: "nav-item",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)($6fdc6fa6a39680d8$var$NavLink, {
                                                                    to: "/prefixregistrationrequest",
                                                                    className: "nav-link",
                                                                    activeClassName: "active",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                            className: "icon icon-common icon-leaf me-1"
                                                                        }),
                                                                        "Request prefix"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                                className: "nav-item",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)($6fdc6fa6a39680d8$var$NavLink, {
                                                                    to: "/resourceregistrationrequest",
                                                                    className: "nav-link",
                                                                    activeClassName: "active",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                            className: "icon icon-common icon-cube me-1"
                                                                        }),
                                                                        "Request resource"
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: config.documentationUrl,
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-documentation me-1"
                                                                }),
                                                                "Documentation"
                                                            ]
                                                        })
                                                    }),
                                                    // If not logged in.
                                                    config.enableAuthFeatures && !auth.authenticated && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: "#!",
                                                            onClick: handleClickSignIn,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-sign-in-alt me-1"
                                                                }),
                                                                "Sign in"
                                                            ]
                                                        })
                                                    }),
                                                    config.enableAuthFeatures && auth.authenticated && // If logged in.
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)($6fdc6fa6a39680d8$var$NavLink, {
                                                            to: "/curation",
                                                            className: "nav-link",
                                                            activeClassName: "active",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-tachometer-alt me-1"
                                                                }),
                                                                "Curation dashboard"
                                                            ]
                                                        })
                                                    }),
                                                    config.enableAuthFeatures && auth.authenticated && // If logged in.
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: `${config.authApi}/realms/idorg/account`,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-user me-1"
                                                                }),
                                                                "Account"
                                                            ]
                                                        })
                                                    }),
                                                    config.enableAuthFeatures && auth.authenticated && // If logged in.
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: "#!",
                                                            onClick: handleClickSignOut,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-sign-out-alt me-1"
                                                                }),
                                                                "Sign out"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $78f4ebdc4943af05$export$2e2bcd8739ae039), {
                                                        className: "nav-item float-end",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                            href: config.feedbackUrl,
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            className: "nav-link nav-link-dark",
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-comments me-1"
                                                                }),
                                                                "Feedback"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        }));
    }
}
// Redux mappings.
const $6fdc6fa6a39680d8$var$mapStateToProps = (state)=>({
        auth: state.auth,
        config: state.config
    });
const $6fdc6fa6a39680d8$var$mapDispatchToProps = (dispatch)=>({
        doSignIn: ()=>dispatch((0, $0b883306a510c740$export$7abc584011c1e113)()),
        doSignOut: ()=>dispatch((0, $0b883306a510c740$export$3ebfd0406116c6c7)())
    });
var $6fdc6fa6a39680d8$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($6fdc6fa6a39680d8$var$mapStateToProps, $6fdc6fa6a39680d8$var$mapDispatchToProps, null)($6fdc6fa6a39680d8$var$Header);




var $dBNnn = parcelRequire("dBNnn");
var $d7144e3474d99a94$exports = {};
$d7144e3474d99a94$exports = $parcel$resolve("fXFC6");


const $174bb9519d39d5ba$var$elixirKiteMark = new URL($d7144e3474d99a94$exports);
class $174bb9519d39d5ba$var$Footer extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
    }
    componentDidMount() {
        ebiFrameworkUpdateFoot();
        ebiFrameworkUpdateFooterMeta();
        ebiFrameworkIncludeAnnouncements();
        ebiFrameworkRunDataProtectionBanner('1.4');
    }
    render() {
        return(// This is EMBL-EBI Enforced boilerplate footer.
        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row footer-section align-items-center mx-5 mb-2 bg-light py-2",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-xl-1",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("img", {
                                src: $174bb9519d39d5ba$var$elixirKiteMark
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "col col-xl-11",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    children: "This service"
                                }),
                                " is part of the ELIXIR infrastructure",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                    className: "mb-0",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                children: "Identifiers.org is an ELIXIR Interoperability Platform resource "
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                href: "https://elixir-europe.org/platforms/interoperability",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "text-primary",
                                                children: "Learn more"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("footer", {
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        id: "global-footer",
                        className: "global-footer",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("nav", {
                                id: "global-nav-expanded",
                                className: "global-nav-expanded row"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("section", {
                                id: "ebi-footer-meta",
                                className: "ebi-footer-meta row"
                            })
                        ]
                    })
                })
            ]
        }));
    }
}
var $174bb9519d39d5ba$export$2e2bcd8739ae039 = $174bb9519d39d5ba$var$Footer;






var $dBNnn = parcelRequire("dBNnn");





var $dBNnn = parcelRequire("dBNnn");
var $c28448d2a51cfc72$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c28448d2a51cfc72$var$ReactIs, $c28448d2a51cfc72$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$c28448d2a51cfc72$exports = (parcelRequire("56SzX"))();




var $dBNnn = parcelRequire("dBNnn");



//
// querySplit: splits a query according to the identifiers.org algorithm.
// For the future: Implement FDA
//
const $bb0f081e87a16695$export$c067719c5fdda563 = function(query) {
    const [prefixSide, ...idSide] = query.split(':');
    const prefixParts = prefixSide.split('/');
    let resource = '';
    if (prefixParts.length > 1) resource = prefixParts.shift();
    const prefix = prefixParts.join('/');
    const prefixEffectiveValue = prefix.toLowerCase();
    const id = idSide ? idSide.join(':') : '';
    const idWithEmbeddedPrefix = `${prefix}:${id}`;
    return {
        prefix: prefix,
        prefixEffectiveValue: prefixEffectiveValue,
        id: id,
        idWithEmbeddedPrefix: idWithEmbeddedPrefix,
        resource: resource
    };
};



const $d649e5ae846bb32a$export$bb4811fea1acfcc7 = (query)=>{
    if (query === '*:*') // Match all query should just go through
    return query;
    // Escape lucene problem chars
    const luceneProblemChars = [
        '\\',
        '+',
        '-',
        '&',
        '!',
        '(',
        ')',
        '{',
        '}',
        '[',
        ']',
        '^',
        '~',
        '*',
        '?',
        ':',
        '/',
        '|'
    ];
    for (const char of luceneProblemChars)query = query.replaceAll(char, "\\" + char);
    return query;
};
var $d649e5ae846bb32a$export$2e2bcd8739ae039 = Object.freeze({
    async queryEbiSearchForRelevantNamespacesWithHitCount (query, opts = {}) {
        const { ebiSearchDomainEndpoint: ebiSearchDomainEndpoint, ebiSearchResponseSize: ebiSearchResponseSize } = (0, $f5375947831a300f$export$e506a1d27d1eaa20);
        const preppedQuery = $d649e5ae846bb32a$export$bb4811fea1acfcc7(query);
        const params = new URLSearchParams({
            fields: 'prefix, name',
            size: ebiSearchResponseSize.toString(),
            query: preppedQuery,
            format: 'JSON',
            ...opts
        });
        return fetch(ebiSearchDomainEndpoint + '?' + params).then((r)=>r.json(), (err)=>{
            console.error(err);
            return {};
        }).then((json)=>[
                json.hitCount || 0,
                json.entries?.map((e)=>{
                    return e.fields;
                }) || []
            ]).then(([hitCount, namespaces])=>[
                hitCount,
                namespaces.map((namespace)=>{
                    // Convert ebi search fields from singleton arrays to simple values
                    const newEntries = Object.entries(namespace).map(([attr, val])=>[
                            attr,
                            Array.isArray(val) ? val[0] : val
                        ]);
                    return Object.fromEntries(newEntries);
                })
            ]);
    },
    async queryEbiSearchForRelevantNamespaces (query, opts = {}) {
        const { ebiSearchDomainEndpoint: ebiSearchDomainEndpoint, ebiSearchResponseSize: ebiSearchResponseSize } = (0, $f5375947831a300f$export$e506a1d27d1eaa20);
        const params = new URLSearchParams({
            fields: 'prefix, name',
            size: ebiSearchResponseSize.toString(),
            query: query,
            format: 'JSON',
            ...opts
        });
        return await fetch(ebiSearchDomainEndpoint + '?' + params).then((r)=>r.json()).then((json)=>json.entries?.map((e)=>{
                return e.fields;
            }) || []).then((namespaces)=>namespaces.map((namespace)=>{
                // Convert ebi search fields from singleton arrays to simple values
                const newEntries = Object.entries(namespace).map(([attr, val])=>[
                        attr,
                        Array.isArray(val) ? val[0] : val
                    ]);
                return Object.fromEntries(newEntries);
            }));
    }
});


const $b9b9c61f058e4374$var$SearchSuggestions = /*#__PURE__*/ (0, $dBNnn.forwardRef)((props, ref)=>{
    const { query: query } = props;
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    const [loading, setLoading] = (0, $dBNnn.useState)(true);
    const [namespaceList, setNamespaceList] = (0, $dBNnn.useState)([]);
    const [selectedNamespace, setSelectedNamespace] = (0, $dBNnn.useState)(-1);
    const [debounce, setDebounce] = (0, $dBNnn.useState)(0);
    const handleSuggestionInteraction = (0, $dBNnn.useCallback)((prefix)=>navigate(`/registry/${prefix}`), [
        navigate
    ]);
    const handleSelectedNamespace = (0, $dBNnn.useCallback)(async (index)=>{
        setSelectedNamespace(index);
    }, [
        setSelectedNamespace
    ]);
    const updateNamespaces = (0, $dBNnn.useCallback)(async ()=>{
        if (query) {
            const { prefix: prefix } = (0, $bb0f081e87a16695$export$c067719c5fdda563)(query);
            const namespaces = (await (0, $d649e5ae846bb32a$export$2e2bcd8739ae039).queryEbiSearchForRelevantNamespaces(query, {
                fields: 'name,prefix,lui_pattern,sample_id'
            }))?.slice(0, (0, $f5375947831a300f$export$e506a1d27d1eaa20).suggestionQuerySize) || [];
            setNamespaceList(namespaces);
            setSelectedNamespace(namespaces.findIndex((ns)=>ns.prefix === prefix));
        }
        setLoading(false);
    }, [
        query,
        setNamespaceList,
        setSelectedNamespace,
        setLoading
    ]);
    (0, $dBNnn.useImperativeHandle)(ref, ()=>({
            hasSelection () {
                return selectedNamespace !== -1;
            },
            async clearSelection () {
                setSelectedNamespace(-1);
            },
            async clickSelection () {
                if (selectedNamespace === -1) return;
                const prefix = namespaceList[selectedNamespace].prefix;
                document.getElementById(`suggestion-${prefix}`)?.click();
            },
            async upSelection (n = 1) {
                if (selectedNamespace === 0 || namespaceList.length === 0) return;
                let newPosition = -1;
                if (selectedNamespace === -1) {
                    if (namespaceList.length !== 0) newPosition = 0;
                } else newPosition = Math.max(0, selectedNamespace - n);
                setSelectedNamespace(newPosition);
            },
            async downSelection (n = 1) {
                if (selectedNamespace === namespaceList.length - 1 || namespaceList.length === 0) return;
                let newPosition = -1;
                if (selectedNamespace === -1) {
                    if (namespaceList.length !== 0) newPosition = 0;
                } else newPosition = Math.min(namespaceList.length - 1, selectedNamespace + n);
                setSelectedNamespace(newPosition);
            }
        }), [
        selectedNamespace,
        setSelectedNamespace,
        namespaceList
    ]);
    (0, $dBNnn.useEffect)(()=>{
        clearTimeout(debounce);
        setDebounce(setTimeout(updateNamespaces, 600));
        return ()=>clearTimeout(debounce);
    }, [
        query,
        updateNamespaces,
        setDebounce
    ]);
    const noResults = !namespaceList || namespaceList.length === 0;
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "inline-search-container",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "suggestions-box",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mx-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col align-self-end",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            className: "text-muted text-end my-0",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                                children: [
                                    loading && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: " Loading "
                                    }),
                                    !loading && noResults && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: " No "
                                    }),
                                    "Suggestions",
                                    loading && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: " \u2026 "
                                    }),
                                    !loading && noResults && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: ", try another query "
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("ul", {
                    className: "suggestion-list pb-2",
                    children: !loading && namespaceList.map((namespace, index)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                            className: `suggestion ${selectedNamespace === index ? 'suggestion__selected' : ''}`,
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "row g-0 py-1 mx-2",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        className: "clear-link d-flex align-items-center",
                                        id: `suggestion-${namespace.prefix}`,
                                        onMouseOver: ()=>{
                                            handleSelectedNamespace(index);
                                        },
                                        onFocus: ()=>{
                                            handleSelectedNamespace(index);
                                        },
                                        onClick: ()=>{
                                            handleSuggestionInteraction(namespace.prefix);
                                        },
                                        onKeyDown: (e)=>{
                                            if (e.key !== 'Enter') return;
                                            handleSuggestionInteraction(namespace.prefix);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: `badge ${selectedNamespace === index ? 'bg-secondary border border-dark' : 'bg-dark border border-secondary'} font-weight-normal`,
                                                children: namespace.prefix
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                className: `mb-0 ms-2 ${selectedNamespace === index ? 'text-white' : ''}`,
                                                children: namespace.name
                                            })
                                        ]
                                    })
                                })
                            })
                        }, `li-suggestion-${namespace.prefix}`))
                })
            ]
        })
    });
});
$b9b9c61f058e4374$var$SearchSuggestions.propTypes = {
    query: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).string.isRequired
};
var $b9b9c61f058e4374$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).memo($b9b9c61f058e4374$var$SearchSuggestions, (p1, p2)=>p1.query === p2.query);



class $9c4c30017c1a225d$var$Search extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChange", (e)=>{
            this.setState({
                query: e.target.value
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleKeyDown", (e)=>{
            switch(e.key){
                case 'Escape':
                    e.preventDefault();
                    this.suggestionListRef.current?.clearSelection();
                    break;
                case 'Enter':
                    e.preventDefault();
                    if (this.suggestionListRef.current?.hasSelection()) this.suggestionListRef.current?.clickSelection();
                    else this.handleSubmit(e);
                    break;
                case 'ArrowUp':
                    e.preventDefault();
                    this.suggestionListRef.current?.upSelection();
                    break;
                case 'ArrowDown':
                    e.preventDefault();
                    this.suggestionListRef.current?.downSelection();
                    break;
                case 'PageDown':
                    e.preventDefault();
                    this.suggestionListRef.current?.downSelection(5);
                    break;
                case 'PageUp':
                    e.preventDefault();
                    this.suggestionListRef.current?.upSelection(5);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSubmit", (e)=>{
            e.preventDefault();
            const { props: { navigate: navigate }, state: { query: query } } = this;
            navigate(`/registry?query=${query}`);
        });
        this.state = {
            query: ''
        };
        this.suggestionListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
    }
    render() {
        const { props: { buttonCaption: buttonCaption, placeholderCaption: placeholderCaption }, state: { query: query } } = this;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("form", {
            onSubmit: this.handleSubmit,
            role: "search",
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "search-form-group",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "input-group inline-search-input-group",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                role: "searchbox",
                                className: "form-control search-input",
                                onChange: this.handleChange,
                                onKeyDown: this.handleKeyDown,
                                placeholder: placeholderCaption,
                                ref: this.search,
                                spellCheck: false,
                                value: query
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                className: "btn btn-primary text-white",
                                children: buttonCaption
                            })
                        ]
                    }),
                    query && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b9b9c61f058e4374$export$2e2bcd8739ae039), {
                        query: query,
                        ref: this.suggestionListRef
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                        className: "text-muted text-sm text-decoration-none ms-1",
                        href: "https://www.ebi.ac.uk/ebisearch",
                        children: "powered by EBI Search"
                    })
                ]
            })
        });
    }
}
$9c4c30017c1a225d$var$Search.propTypes = {
    buttonCaption: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).element,
        (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).string
    ]).isRequired,
    placeholderCaption: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).string.isRequired,
    navigate: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).func.isRequired
};
var $9c4c30017c1a225d$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($9c4c30017c1a225d$var$Search, {
        ...props,
        navigate: (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)()
    });



var $dBNnn = parcelRequire("dBNnn");

var $dBNnn = parcelRequire("dBNnn");
const $35ad84941ce9372a$var$MatomoContext = (0, $dBNnn.createContext)(null);
var $35ad84941ce9372a$export$2e2bcd8739ae039 = $35ad84941ce9372a$var$MatomoContext;



var $dBNnn = parcelRequire("dBNnn");
const $a91e98e5b381888e$var$useOutboundClickListener = (matomoInstance)=>{
    const handleOutboundClick = (event)=>{
        // The target is not guaranteed to be a link, it could be a child element.
        // Look up the element's parent until the anchor element is found.
        const findLinkElement = (el)=>{
            if (el instanceof HTMLAnchorElement && el.href) return el;
            if (el instanceof HTMLElement && el.parentElement) return findLinkElement(el.parentElement);
            return null;
        };
        const target = findLinkElement(event.target);
        if (!(target instanceof HTMLAnchorElement)) return;
        const { href: href } = target;
        // Check if the click target differs from the current hostname, meaning it's external
        if (// eslint-disable-next-line @typescript-eslint/prefer-regexp-exec
        !href.match(new RegExp(`^(http://www.|https://www.|http://|https://)+(${window.location.hostname})`))) matomoInstance.trackLink({
            href: href
        });
    };
    (0, $dBNnn.useEffect)(()=>{
        window.document.addEventListener('click', handleOutboundClick, {
            capture: true
        });
        return ()=>window.document.removeEventListener('click', handleOutboundClick, {
                capture: true
            });
    }, []);
};
var $a91e98e5b381888e$export$2e2bcd8739ae039 = $a91e98e5b381888e$var$useOutboundClickListener;


function $26f6a2459c708f92$var$useMatomo() {
    const instance = (0, $dBNnn.useContext)((0, $35ad84941ce9372a$export$2e2bcd8739ae039));
    const trackPageView = (0, $dBNnn.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackPageView(params), [
        instance
    ]);
    const trackEvent = (0, $dBNnn.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackEvent(params), [
        instance
    ]);
    const trackEvents = (0, $dBNnn.useCallback)(()=>instance === null || instance === void 0 ? void 0 : instance.trackEvents(), [
        instance
    ]);
    const trackSiteSearch = (0, $dBNnn.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackSiteSearch(params), [
        instance
    ]);
    const trackLink = (0, $dBNnn.useCallback)((params)=>instance === null || instance === void 0 ? void 0 : instance.trackLink(params), [
        instance
    ]);
    const enableLinkTracking = (0, $dBNnn.useCallback)(()=>{
        if (instance) (0, $a91e98e5b381888e$export$2e2bcd8739ae039)(instance);
    }, [
        instance
    ]);
    const pushInstruction = (0, $dBNnn.useCallback)((name, ...args)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        instance === null || instance === void 0 || instance.pushInstruction(name, ...args);
    }, [
        instance
    ]);
    return {
        trackEvent: trackEvent,
        trackEvents: trackEvents,
        trackPageView: trackPageView,
        trackSiteSearch: trackSiteSearch,
        trackLink: trackLink,
        enableLinkTracking: enableLinkTracking,
        pushInstruction: pushInstruction
    };
}
var $26f6a2459c708f92$export$2e2bcd8739ae039 = $26f6a2459c708f92$var$useMatomo;


const $ef8690990f8fc9f7$export$cbc7c17b7602658a = ()=>window.matchMedia("(max-width: 768px)").matches;
const $ef8690990f8fc9f7$export$9265a4c0580e69f6 = ()=>window.matchMedia("(max-width: 1280px)").matches;


class $235bf69e728e9dd0$var$HomePage extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickPrefixRegistrationRequestForm", ()=>{
            this.props.navigate('/prefixregistrationrequest');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickRegistryBrowser", ()=>{
            this.props.navigate('/registry');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSuggestionAction", (query)=>{
            this.props.navigate(`/registry/${query}`);
        });
        // Takes user to search if there are no prefixes matching that exact query in the namespace list, otherwise
        // will redirect to the matching namespace page.
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSearchAction", (query)=>{
            const { namespaceList: namespaceList, navigate: navigate } = this.props;
            const exactMatch = namespaceList.find((namespace)=>namespace.prefix === query);
            const redirectUrl = exactMatch ? `/registry/${query}` : `/registry?query=${query}`;
            navigate(redirectUrl);
        });
        const params = new URLSearchParams(window.location.search);
        this.state = {
            query: params.get('query') || ''
        };
    }
    componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
    }
    render() {
        const { handleClickPrefixRegistrationRequestForm: handleClickPrefixRegistrationRequestForm, handleClickRegistryBrowser: handleClickRegistryBrowser, handleSearchAction: handleSearchAction, handleSuggestionAction: handleSuggestionAction, state: { query: query } } = this;
        const boxPadding = (0, $ef8690990f8fc9f7$export$cbc7c17b7602658a)() || (0, $ef8690990f8fc9f7$export$9265a4c0580e69f6)() ? 'p-3' : 'p-5';
        const searchBarPadding = (0, $ef8690990f8fc9f7$export$cbc7c17b7602658a)() ? 'p-1' : 'px-5';
        const topSpacer = (0, $ef8690990f8fc9f7$export$cbc7c17b7602658a)() ? '' : 'spacer-5';
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: `row border ${topSpacer}`,
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: `col col-12 col-xl-6 ${boxPadding}`,
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("h1", {
                            className: "text-primary mb-4",
                            children: "Identifiers.org Central Registry"
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "d-flex",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                className: "mb-0 text-justify text-muted",
                                children: [
                                    "The ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "text-dark",
                                        children: "Identifiers.org"
                                    }),
                                    " Central Registry service provides a centralized directory of Compact Identifiers. This website allows performing searches on the registry by using the search bar on the right side or the ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "#!",
                                        className: "text-primary text-decoration-none",
                                        onClick: handleClickRegistryBrowser,
                                        children: "Registry Browser"
                                    }),
                                    ". Resource maintainers can also find the ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        href: "#!",
                                        className: "text-primary text-decoration-none",
                                        onClick: handleClickPrefixRegistrationRequestForm,
                                        children: "Prefix Registration Request form"
                                    }),
                                    " to request a prefix in Identifiers.org for their databases or services."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "col col-12 col-xl-6 bg-light",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            className: `mt-3 ${boxPadding}`,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-search me-2"
                                }),
                                "Search the registry ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("br", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: `row justify-content-center mt-2 ${searchBarPadding}`,
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "col col-lg-7 col-xl-12",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $9c4c30017c1a225d$export$2e2bcd8739ae039), {
                                    buttonCaption: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-search me-1"
                                            }),
                                            " Search"
                                        ]
                                    }),
                                    placeholderCaption: "Enter a namespace to search the registry"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
// Redux mappings.
const $235bf69e728e9dd0$var$mapStateToProps = (state)=>({
        namespaceList: state.registryBrowser.namespaceList
    });
const $235bf69e728e9dd0$var$ConnectedHomepage = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($235bf69e728e9dd0$var$mapStateToProps)($235bf69e728e9dd0$var$HomePage);
function $235bf69e728e9dd0$export$2e2bcd8739ae039(props) {
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    const matomo = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($235bf69e728e9dd0$var$ConnectedHomepage, {
        ...props,
        matomo: matomo,
        navigate: navigate
    });
}




var $dBNnn = parcelRequire("dBNnn");



var $dBNnn = parcelRequire("dBNnn");

parcelRequire("dBNnn");


var $dBNnn = parcelRequire("dBNnn");

const $ad1e82774825a5c5$var$RoleConditional = ({ auth: auth, children: children, requiredRoles: requiredRoles, fallbackComponent: fallbackComponent })=>{
    if (auth.authenticated) {
        const rolesMet = requiredRoles.map((role)=>auth.keycloak.hasResourceRole(role));
        if (!rolesMet.includes(false)) {
            const child = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Children.only(children);
            return child;
        }
    }
    // Roles not met / unauthenticated.
    return fallbackComponent ? fallbackComponent : null;
};
//
// Mapping functions.
//
const $ad1e82774825a5c5$var$mapStateToProps = (state)=>({
        auth: state.auth
    });
var $ad1e82774825a5c5$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($ad1e82774825a5c5$var$mapStateToProps)($ad1e82774825a5c5$var$RoleConditional);


const $6ccca0d1af5c1d28$var$NamespaceItem = (namespace)=>{
    const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                        className: "narrow align-middle",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                            to: `/registry/${namespace.prefix}`,
                            className: "clear-link text-primary",
                            children: namespace.name
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                        className: "med align-middle text-center",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                            className: "text-warning fw-bold border border-secondary badge bg-dark",
                            children: namespace.prefix
                        })
                    }),
                    !isSmallScreen && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "d-flex justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                    className: "small m-0",
                                    children: namespace.description
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                    requiredRoles: [
                                        'editNamespace'
                                    ],
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                                        to: `/registry/${namespace.prefix}?editNamespace=true`,
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                            className: "btn btn-sm btn-success ms-3 edit-button",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                    className: "icon icon-common icon-edit me-1"
                                                }),
                                                "Edit namespace"
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            isSmallScreen && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tr", {}),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tr", {
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                            colSpan: "2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                className: "small text-justify mx-3",
                                children: namespace.description
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var $6ccca0d1af5c1d28$export$2e2bcd8739ae039 = $6ccca0d1af5c1d28$var$NamespaceItem;





var $dBNnn = parcelRequire("dBNnn");
class $54e37c13f6fd63e4$var$Paginator extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleNavigate", (pageLink)=>{
            this.setState({
                currentPage: pageLink
            });
            this.props.navigate(pageLink);
        });
        this.state = {
            pageWindow: 3
        };
    }
    render() {
        const entriesPerPage = [
            5,
            20,
            50,
            100
        ];
        const { pageWindow: pageWindow } = this.state;
        const { number: number = 0, totalPages: totalPages = 0, size: size = 0, totalElements: totalElements = 0, setSize: setSize } = this.props;
        const smallerThan = (size)=>window.matchMedia(`(max-width: ${size}px)`).matches;
        const smallOrder1 = smallerThan(991) ? 'order-1' : '';
        const smallOrder2 = smallerThan(991) ? 'order-2' : '';
        const smallOrder3 = smallerThan(991) ? 'order-3' : '';
        const smallCenter = smallerThan(767) ? 'justify-content-center align-self-center' : '';
        // First and last indexes of paginator.
        let firstIndex = Math.max(0, number - pageWindow);
        let lastIndex = Math.min(number + pageWindow + 1, Math.max(totalPages, number + pageWindow));
        // If current page < pageWindow, add difference to last index.
        if (number < pageWindow + 1) lastIndex += pageWindow - number;
        // If current page + pageWindow > totalPages, subtract difference to first index.
        if (number + pageWindow > totalPages - 1) firstIndex -= pageWindow + number + 1;
        const linkArray = [
            ...Array(totalPages).keys()
        ].slice(firstIndex, lastIndex);
        const firstElement = number * size + 1;
        const lastElement = number < totalPages - 1 ? (number + 1) * size : number * size + totalElements % size;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "row justify-content-between",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: `col col-12 col-md-8 col-lg-6 col-xl-6 paginator mb-2 ${smallOrder2}`,
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("ul", {
                        className: `pagination pagination-sm m-0 ${smallCenter}`,
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                className: `page-item ${number === 0 ? 'disabled' : ''}`,
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    className: "page-link",
                                    href: "#!",
                                    onClick: ()=>{
                                        this.props.navigate(0);
                                    },
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-angle-double-left"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                className: `page-item ${number === 0 ? 'disabled' : ''}`,
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    className: "page-link",
                                    href: "#!",
                                    onClick: ()=>{
                                        this.props.navigate(Math.max(number - 1, 0));
                                    },
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-angle-left"
                                    })
                                })
                            }),
                            linkArray.map((pageLink)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                    className: `page-item paginator-link ${pageLink === number ? 'active' : ''}`,
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                        className: `page-link ${pageLink === number ? 'active' : ''}`,
                                        href: "#!",
                                        onClick: ()=>{
                                            this.handleNavigate(pageLink);
                                        },
                                        children: pageLink + 1
                                    }, `${pageLink}-navigate`)
                                }, `li-${pageLink}`)),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                className: `page-item ${number === totalPages - 1 ? 'disabled' : ''}`,
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    className: "page-link",
                                    href: "#!",
                                    onClick: ()=>{
                                        this.props.navigate(Math.min(number + 1, totalPages - 1));
                                    },
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-angle-right"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                className: `page-item ${number === totalPages - 1 ? 'disabled' : ''}`,
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    className: "page-link",
                                    href: "#!",
                                    onClick: ()=>{
                                        this.props.navigate(totalPages - 1);
                                    },
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-angle-double-right"
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: `col col-12 col-lg-3 col-xl-4 mb-2 ${smallOrder1}`,
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                        className: "pager",
                        children: totalElements === 0 ? '' : `${firstElement} to ${lastElement} of ${totalElements}`
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: `col col-xs-12 col-sm-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 mb-2 ${smallOrder3} ${smallCenter}`,
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "input-group input-group-sm",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                                className: "input-group-text",
                                htmlFor: "perPageSelect",
                                children: "Per page"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("select", {
                                className: "form-select custom-select",
                                id: "perPageSelect",
                                onChange: setSize,
                                defaultValue: size || 5,
                                children: entriesPerPage.map((option)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                        value: option,
                                        children: option
                                    }, option))
                            })
                        ]
                    })
                })
            ]
        });
    }
}
var $54e37c13f6fd63e4$export$2e2bcd8739ae039 = $54e37c13f6fd63e4$var$Paginator;






parcelRequire("dBNnn");
const $187fb74469bf966e$var$Spinner = (props)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        className: `spinner ${props.className || ''} ${props.compact ? 'compact' : ''} ${props.noCenter ? '' : 'text-center'}`,
        children: [
            !props.noText && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("h2", {
                className: "text-muted fw-bold mb-0",
                children: "Loading"
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "lds-ellipsis",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {})
                ]
            })
        ]
    });
var $187fb74469bf966e$export$2e2bcd8739ae039 = $187fb74469bf966e$var$Spinner;


class $ab6a2c948f3ef8f0$var$NamespaceList extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updateNamespaceList", async (querySuffix = '')=>{
            const { page: page, size: size } = this.state.namespaceListParams;
            const query = this.searchBarRef.current.value || '*:*';
            this.setState({
                loading: true
            });
            (0, $d649e5ae846bb32a$export$2e2bcd8739ae039).queryEbiSearchForRelevantNamespacesWithHitCount(query + querySuffix, {
                fields: 'name,prefix,description',
                start: page * size,
                size: size
            }).then(([hitCount, namespaces])=>{
                this.setState({
                    namespaceList: namespaces,
                    namespaceListParams: {
                        page: page,
                        size: size,
                        totalPages: Math.ceil(hitCount / size),
                        totalElements: hitCount
                    }
                });
            }).finally(()=>{
                this.setState({
                    loading: false
                });
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handlePageChange", (page)=>{
            const { namespaceListParams: namespaceListParams } = this.state;
            if (namespaceListParams.page === page) return;
            this.setState({
                namespaceListParams: {
                    ...namespaceListParams,
                    page: page
                }
            }, ()=>this.updateNamespaceList());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleAlphabeticSearch", (e)=>{
            const { namespaceListParams: namespaceListParams } = this.state;
            const firstLetter = e.target.innerText.toLowerCase();
            this.setState({
                namespaceListParams: {
                    ...namespaceListParams,
                    page: 0
                }
            }, ()=>{
                this.updateNamespaceList(`AND prefix:${firstLetter}*`);
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSearchChange", (e)=>{
            clearTimeout(this.debounceRef.current);
            this.debounceRef.current = setTimeout(()=>{
                const { namespaceListParams: namespaceListParams } = this.state;
                this.setState({
                    namespaceListParams: {
                        ...namespaceListParams,
                        page: 0
                    }
                }, ()=>{
                    this.props.setSearchParams({
                        query: e.target.value
                    });
                    this.updateNamespaceList();
                });
            }, 500);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSetSize", (e)=>{
            const { namespaceListParams: namespaceListParams } = this.state;
            this.setState({
                namespaceListParams: {
                    ...namespaceListParams,
                    size: parseInt(e.target.value) || 0,
                    page: 0
                }
            }, ()=>this.updateNamespaceList());
        });
        this.state = {
            query: props.query,
            debounceSearch: undefined,
            namespaceList: [],
            loading: false,
            namespaceListParams: {
                page: 0,
                size: 20,
                totalPages: 0,
                totalElements: 0
            }
        };
        this.debounceRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.searchBarRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
    }
    componentDidMount() {
        this.searchBarRef.current.value = this.props.query;
        this.updateNamespaceList();
    }
    render() {
        const { namespaceList: namespaceList, namespaceListParams: { page: page, size: size, totalElements: totalElements, totalPages: totalPages }, loading: loading } = this.state;
        const prefixStart = null;
        // const alphabetSearch = Object.freeze('#ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''));
        const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-12 col-xl-8 mt-2 overflow-y-none p-1 d-none d-md-block",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $54e37c13f6fd63e4$export$2e2bcd8739ae039), {
                                    navigate: this.handlePageChange,
                                    number: page,
                                    setSize: this.handleSetSize,
                                    size: size,
                                    totalPages: totalPages,
                                    totalElements: totalElements
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-12 col-xl-4 mt-2 p-1",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                className: "input-group input-group-sm mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "input-group-text",
                                        id: "registry-search",
                                        title: "powered by EBI Search",
                                        children: "Search"
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        placeholder: "Input a search query",
                                        role: "searchbox",
                                        "aria-label": "Search",
                                        "aria-describedby": "registry-search",
                                        onChange: this.handleSearchChange,
                                        value: undefined,
                                        ref: this.searchBarRef
                                    })
                                ]
                            })
                        })
                    ]
                }),
                loading ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    children: namespaceList.length === 0 ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                        className: "text-center my-5",
                        children: "No items"
                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("table", {
                            className: "table table-sm table-striped table-hover table-borderless table-fixed",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("thead", {
                                    className: "table-light thead-rounded",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                className: `${isSmallScreen ? 'small-wide' : 'wide'}`,
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-list"
                                                    }),
                                                    " Name"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                className: `${isSmallScreen ? 'small-narrow' : 'med'} text-center`,
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-address-card"
                                                    }),
                                                    " Prefix"
                                                ]
                                            }),
                                            !isSmallScreen && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                className: "text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-info"
                                                    }),
                                                    " Description"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tbody", {
                                    children: // Page data.
                                    namespaceList.map((namespace)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $6ccca0d1af5c1d28$export$2e2bcd8739ae039), {
                                            ...namespace
                                        }, `namespace-${namespace.prefix}`))
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("footer", {
                    className: "d-block d-sm-none",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $54e37c13f6fd63e4$export$2e2bcd8739ae039), {
                        navigate: this.handlePageChange,
                        number: page,
                        setSize: this.handleSetSize,
                        size: size,
                        totalPages: totalPages,
                        totalElements: totalElements
                    })
                })
            ]
        });
    }
}
$ab6a2c948f3ef8f0$var$NamespaceList.propTypes = {
    setSearchParams: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).func.isRequired,
    query: (0, (/*@__PURE__*/$parcel$interopDefault($c28448d2a51cfc72$exports))).string.isRequired
};
var $ab6a2c948f3ef8f0$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($ab6a2c948f3ef8f0$var$NamespaceList, {
        ...props,
        setSearchParams: (0, $b08650187def67b8$export$f1a78c17382fe22a)()[1]
    });



parcelRequire("dBNnn");
const $0b74f6f839d040ed$var$PageTitle = ({ icon: icon, id: id, title: title, extraTitle: extraTitle, description: description })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h1", {
                        id: id,
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                className: `icon icon-common ${icon}`
                            }),
                            "\xa0",
                            title,
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                className: "fst-italic",
                                children: [
                                    " ",
                                    extraTitle
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                        children: description
                    })
                })
            })
        ]
    });
var $0b74f6f839d040ed$export$2e2bcd8739ae039 = $0b74f6f839d040ed$var$PageTitle;



class $badf0aba95db9f31$var$BrowseRegistryPage extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        const params = new URLSearchParams(window.location.search);
        this.state = {
            query: params.get('query') || ''
        };
    }
    componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
    }
    render() {
        const { query: query } = this.state;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                    icon: "icon-database",
                    title: "Registry",
                    description: "This is the list of Prefixes currently registered in Identifiers.org database. Clicking on one will show additional details and the related providers."
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ab6a2c948f3ef8f0$export$2e2bcd8739ae039), {
                        query: query
                    })
                })
            ]
        });
    }
}
var $badf0aba95db9f31$export$2e2bcd8739ae039 = (props)=>{
    const matomo = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($badf0aba95db9f31$var$BrowseRegistryPage, {
        ...props,
        matomo: matomo
    });
};





var $dBNnn = parcelRequire("dBNnn");





//
// namespaceListParams actions.
//
// Redux store update for namespace page data.
const $8c7b413aab6e553b$export$4afe53fe470ab482 = (namespaceListParams)=>{
    return {
        type: 'SET_NAMESPACELISTPARAMS',
        namespaceListParams: namespaceListParams
    };
};


const $8b8510f780f3f18d$export$1b3a086fec21f2f0 = (params)=>{
    return async (dispatch)=>{
        let requestUrl;
        // TODO: Refactor to strategy.
        if (params.content !== '') {
            requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/search/findByPrefixContaining`);
            requestUrl.searchParams.append('content', params.content);
        } else if (params.prefixStart === '#') requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/search/findByPrefixStartsWithNumbers`);
        else if (params.prefixStart !== '') {
            // TODO: What to do with '#' prefixstart?
            requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/search/findByPrefixStartsWith`);
            requestUrl.searchParams.append('prefixStart', params.prefixStart);
        } else requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces`);
        // Params to add to request: PAGE, SIZE, SORT
        requestUrl.searchParams.append('page', params.number);
        requestUrl.searchParams.append('size', params.size);
        requestUrl.searchParams.append('sort', params.sort);
        let data;
        try {
            const response = await fetch(requestUrl);
            data = await response.json();
        } catch (err) {
            console.error('Error fetching namespaces: ', err);
        }
        if (data) {
            dispatch($8b8510f780f3f18d$export$7105bc8169577b46(data._embedded.namespaces));
            dispatch((0, $8c7b413aab6e553b$export$4afe53fe470ab482)({
                ...params,
                ...data.page
            }));
        } else console.error("Null response from endpoint");
        return data;
    };
};
const $8b8510f780f3f18d$export$3b780324579b3b93 = (prefix)=>{
    return async (dispatch)=>{
        let data, response;
        let requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/search/findByPrefix?prefix=${prefix}`);
        try {
            response = await fetch(requestUrl);
            data = await response.json();
            if (data.deprecated && data["_links"]["successor"] !== undefined) {
                const succResponse = await fetch(data["_links"]["successor"]["href"]);
                if (succResponse.ok) {
                    const successor = await succResponse.json();
                    data["successor"] = successor.prefix;
                }
            }
        } catch (err) {
            console.error('Error fetching namespace', err);
        }
        dispatch($8b8510f780f3f18d$export$7105bc8169577b46([
            data
        ]));
        return data;
    };
};
const $8b8510f780f3f18d$export$bf0556f234ffb64e = (namespace)=>{
    return async (dispatch)=>{
        let stats = null;
        const statisticsUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/statistics/namespace/${namespace.prefix}`);
        try {
            const response = await fetch(statisticsUrl);
            if (response.status === 200) {
                stats = await response.json();
                stats = stats.payload;
            }
        } catch (err) {
            console.error("Error fetching namespace statistics", err);
        } finally{
            dispatch($8b8510f780f3f18d$export$822ee8c4fcfb573b(namespace.prefix, stats));
        }
        return stats;
    };
};
const $8b8510f780f3f18d$export$64108a6f9019e30c = (namespace)=>{
    return async (dispatch)=>{
        let requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/resources/search/findAllByNamespaceId`);
        requestUrl.searchParams.append('id', namespace._links.self.href.split('/').pop());
        let data;
        try {
            const response = await fetch(requestUrl);
            data = await response.json();
        } catch (err) {
            console.error('Error fetching namespaces: ', err);
            return;
        }
        const resources = await Promise.all(data._embedded.resources.map((resource)=>{
            let { _links: _links, ...newResource } = resource;
            // Add id to the resource as a field, we will need this for curation stuff.
            newResource.id = _links.self.href.split('/').pop();
            return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(newResource, [
                {
                    name: 'institution',
                    url: _links.institution.href
                },
                {
                    name: 'location',
                    url: _links.location.href
                }
            ]);
        }));
        dispatch($8b8510f780f3f18d$export$46c9bbef7bb58cc0(namespace.prefix, resources));
        return data;
    };
};
const $8b8510f780f3f18d$export$822ee8c4fcfb573b = (prefix, stats)=>{
    return {
        type: 'SET_STATISTICS',
        prefix: prefix,
        stats: stats
    };
};
const $8b8510f780f3f18d$export$7105bc8169577b46 = (namespaceList)=>{
    return {
        type: 'SET_NAMESPACELIST',
        namespaceList: namespaceList
    };
};
const $8b8510f780f3f18d$export$46c9bbef7bb58cc0 = (prefix, resources)=>{
    return {
        type: 'SET_RESOURCES',
        prefix: prefix,
        resources: resources
    };
};


// Config.


var $atqVQ = parcelRequire("atqVQ");

const $df5c80b7c7e65b14$export$9eb5d800a6b02c7 = async function() {
    const { auth: auth } = (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).getState();
    if (!auth || !auth.keycloak.token) {
        console.debug('Auth -> Not authenticated.');
        return undefined;
    }
    const tokenExpired = auth.keycloak.isTokenExpired();
    const tokenIssuedBy = (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ))).unix(auth.keycloak.tokenParsed.iat);
    const tokenExpiresBy = (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ))).unix(auth.keycloak.tokenParsed.exp);
    const tokenDuration = (tokenExpiresBy - tokenIssuedBy) / 1000;
    const tokenSecondsRemaining = (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ))).duration(tokenExpiresBy.diff((0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))())).asSeconds();
    const tokenStatusCaption = tokenExpired ? 'Token is expired' : `Token expires in ${tokenSecondsRemaining} seconds`;
    // Do not renew too often.
    if (tokenSecondsRemaining > tokenDuration * .75) return auth.keycloak.token;
    console.debug(`Auth -> ${tokenStatusCaption}. Issuing renewal (${tokenDuration} seconds)...`);
    auth.keycloak.updateToken(tokenDuration);
    return auth.keycloak.token;
};


const $3bf8418b78fef910$export$134268c9d8a064b8 = (field, value)=>{
    const action = {
        type: 'SET_NAMESPACEPATCHREDUCERFIELD',
        field: field,
        value: value
    };
    return action;
};
const $3bf8418b78fef910$export$38419f492887c415 = (id, namespace)=>{
    const action = {
        type: 'SET_NAMESPACEPATCHREDUCER',
        id: id,
        namespace: namespace
    };
    return action;
};
const $3bf8418b78fef910$export$dabb953a55f6d1a8 = (id, newNamespace)=>{
    return async ()=>{
        let requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/${id}`;
        let authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        let successor = undefined;
        if ("successor" in newNamespace) {
            successor = newNamespace.successor;
            delete newNamespace.successor;
        }
        let init = {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(newNamespace)
        };
        let response = await fetch(requestUrl, init);
        if (!response.ok) {
            console.error("Failed namespace patch");
            return response;
        }
        if (successor !== undefined) {
            requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/search/findByPrefix?prefix=${successor}`;
            authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
            let init = {
                method: 'GET',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                }
            };
            response = await fetch(requestUrl, init);
            if (!response.ok) {
                console.error("Failed namespace GET by prefix");
                return response;
            }
            const jsonResponse = await response.json();
            successor = jsonResponse["_links"].self.href;
            requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/namespaces/${id}/successor`;
            authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
            init = {
                method: 'PUT',
                headers: {
                    'content-type': 'text/uri-list',
                    'Authorization': `Bearer ${authToken}`
                },
                body: successor
            };
            return await fetch(requestUrl, init);
        } else return response;
    };
};
const $3bf8418b78fef910$export$7d3d3a092ec0a75e = (id)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).namespaceManagementEndpoint}/deactivateNamespace/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        return await fetch(requestUrl, init);
    };
};
const $3bf8418b78fef910$export$60da897e5bfcc5bc = (id)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).namespaceManagementEndpoint}/reactivateNamespace/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        return await fetch(requestUrl, init);
    };
};







var $dBNnn = parcelRequire("dBNnn");



var $atqVQ = parcelRequire("atqVQ");

// Config.


const $d4142ebfbbbc7d07$export$bf8f8f6ad1c6aeef = (field, value)=>{
    const action = {
        type: 'SET_RESOURCEPATCHREDUCERFIELD',
        field: field,
        value: value
    };
    return action;
};
const $d4142ebfbbbc7d07$export$c9c74c77c52d09d3 = (id, resource)=>{
    const action = {
        type: 'SET_RESOURCEPATCHREDUCER',
        id: id,
        resource: resource
    };
    return action;
};
const $d4142ebfbbbc7d07$export$c6019beea7db73df = (id, newResource)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/resources/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(newResource)
        };
        return await fetch(requestUrl, init);
    };
};
const $d4142ebfbbbc7d07$export$5f1c546ac6528127 = (id)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceManagementEndpoint}/deactivateResource/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        return await fetch(requestUrl, init);
    };
};
const $d4142ebfbbbc7d07$export$74153edf9cc3bff4 = (id, newResource)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceManagementEndpoint}/reactivateResource/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: '1.0',
                payload: {
                    providerUrlPattern: newResource.urlPattern
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};





var $dBNnn = parcelRequire("dBNnn");
class $e268fa1eccea0890$var$ReversibleField extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (newValue)=>{
            const { handleChangeField: handleChangeField, fieldName: fieldName } = this.props;
            const value = typeof newValue !== 'undefined' ? newValue : this.state.defaultValue;
            this.setState({
                value: value
            });
            handleChangeField(fieldName, value);
        });
        this.state = {
            defaultValue: props.defaultValue,
            value: props.defaultValue
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        return nextProps.defaultValue !== prevState.defaultValue ? {
            defaultValue: nextProps.default,
            value: nextProps.defaultValue
        } : null;
    }
    render() {
        const { handleChangeField: handleChangeField, props: { children: children }, state: { defaultValue: defaultValue, value: value } } = this;
        const modified = defaultValue !== value;
        const fieldChild = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Children.only(children);
        const isCheckbox = fieldChild.props.type === 'checkbox';
        const preparedFieldChild = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).cloneElement(fieldChild, {
            className: `form-control${modified ? ' border-warning border-2' : ''}${isCheckbox ? ' form-check-input checkbox-input' : ''}`,
            value: value || "",
            checked: value,
            onChange: (e)=>handleChangeField(fieldChild.props.type === 'checkbox' ? e.target.checked : e.target.value)
        });
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: `input-group input-group-sm${isCheckbox ? ' form-check justify-content-between' : ''}`,
            children: [
                preparedFieldChild,
                modified && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                            className: "btn btn-warning",
                            onClick: ()=>handleChangeField(undefined),
                            children: "Revert"
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                            className: "badge badge-dark ms-2 badge-modified",
                            children: "Modified"
                        })
                    ]
                })
            ]
        });
    }
}
var $e268fa1eccea0890$export$2e2bcd8739ae039 = $e268fa1eccea0890$var$ReversibleField;



var $29445ff8c44e0e0c$exports = {};
/*!
* sweetalert2 v11.19.1
* Released under the MIT License.
*/ (function(global, factory) {
    $29445ff8c44e0e0c$exports = factory();
})($29445ff8c44e0e0c$exports, function() {
    'use strict';
    function _assertClassBrand(e, t, n) {
        if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
        throw new TypeError("Private element is not present on this object");
    }
    function _checkPrivateRedeclaration(e, t) {
        if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldGet2(s, a) {
        return s.get(_assertClassBrand(s, a));
    }
    function _classPrivateFieldInitSpec(e, t, a) {
        _checkPrivateRedeclaration(e, t), t.set(e, a);
    }
    function _classPrivateFieldSet2(s, a, r) {
        return s.set(_assertClassBrand(s, a), r), r;
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = 'swal2-';
    /**
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        'container',
        'shown',
        'height-auto',
        'iosfix',
        'popup',
        'modal',
        'no-backdrop',
        'no-transition',
        'toast',
        'toast-shown',
        'show',
        'hide',
        'close',
        'title',
        'html-container',
        'actions',
        'confirm',
        'deny',
        'cancel',
        'footer',
        'icon',
        'icon-content',
        'image',
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'label',
        'textarea',
        'inputerror',
        'input-label',
        'validation-message',
        'progress-steps',
        'active-progress-step',
        'progress-step',
        'progress-step-line',
        'loader',
        'loading',
        'styled',
        'top',
        'top-start',
        'top-end',
        'top-left',
        'top-right',
        'center',
        'center-start',
        'center-end',
        'center-left',
        'center-right',
        'bottom',
        'bottom-start',
        'bottom-end',
        'bottom-left',
        'bottom-right',
        'grow-row',
        'grow-column',
        'grow-fullscreen',
        'rtl',
        'timer-progress-bar',
        'timer-progress-bar-container',
        'scrollbar-measure',
        'icon-success',
        'icon-warning',
        'icon-info',
        'icon-question',
        'icon-error',
        'draggable',
        'dragging'
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        'success',
        'warning',
        'info',
        'question',
        'error'
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = 'SweetAlert2:';
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn(`${consolePrefix} ${typeof message === 'object' ? message.join(' ') : message}`);
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error(`${consolePrefix} ${message}`);
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string?} useInstead
   */ const warnAboutDeprecation = function(deprecatedParam) {
        let useInstead = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        warnOnce(`"${deprecatedParam}" is deprecated and will be removed in the next major release.${useInstead ? ` Use "${useInstead}" instead.` : ''}`);
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */ const callIfFunction = (arg)=>typeof arg === 'function' ? arg() : arg;
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === 'function';
    /**
   * @param {any} arg
   * @returns {Promise<any>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(`.${swalClasses.container}`);
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(`.${className}`);
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses['icon-content']);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses['html-container']);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses['progress-steps']);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses['validation-message']);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.confirm}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.cancel}`);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(`.${swalClasses.actions} .${swalClasses.deny}`);
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses['input-label']);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(`.${swalClasses.loader}`);
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses['timer-progress-bar']);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`;
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute('tabindex') || '0');
            const tabindexB = parseInt(b.getAttribute('tabindex') || '0');
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute('tabindex') !== '-1');
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses['toast-shown']) && !hasClass(document.body, swalClasses['no-backdrop']);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute('data-loading');
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = '';
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, `text/html`);
            const head = parsed.querySelector('head');
            if (head) Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector('body');
            if (body) Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        const classList = className.split(/\s+/);
        for(let i = 0; i < classList.length; i++){
            if (!elem.classList.contains(classList[i])) return false;
        }
        return true;
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (!params.customClass) return;
        const customClass = params.customClass[/** @type {keyof SweetAlertCustomClass} */ className];
        if (!customClass) return;
        if (typeof customClass !== 'string' && !customClass.forEach) {
            warn(`Invalid type of customClass.${className}! Expected string or iterable object, got "${typeof customClass}"`);
            return;
        }
        addClass(elem, customClass);
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case 'select':
            case 'textarea':
            case 'file':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses[inputClass]}`);
            case 'checkbox':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.checkbox} input`);
            case 'radio':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:checked`) || popup.querySelector(`.${swalClasses.popup} > .${swalClasses.radio} input:first-child`);
            case 'range':
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.range} input`);
            default:
                return popup.querySelector(`.${swalClasses.popup} > .${swalClasses.input}`);
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== 'file') {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = '';
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        if (typeof classList === 'string') classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach((className)=>{
            if (Array.isArray(target)) target.forEach((elem)=>{
                if (condition) elem.classList.add(className);
                else elem.classList.remove(className);
            });
            else if (condition) target.classList.add(className);
            else target.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>{
        const children = Array.from(elem.children);
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child instanceof HTMLElement && hasClass(child, className)) return child;
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === `${parseInt(value)}`) value = parseInt(value);
        if (value || parseInt(value) === 0) elem.style.setProperty(property, typeof value === 'number' ? `${value}px` : value);
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flex';
        if (!elem) return;
        elem.style.display = display;
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        if (!elem) return;
        elem.style.display = 'none';
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const showWhenInnerHtmlPresent = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'block';
        if (!elem) return;
        new MutationObserver(()=>{
            toggle(elem, elem.innerHTML, display);
        }).observe(elem, {
            childList: true,
            subtree: true
        });
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement | null} */ const el = parent.querySelector(selector);
        if (el) el.style.setProperty(property, value);
    };
    /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */ const toggle = function(elem, condition) {
        let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'flex';
        if (condition) show(elem, display);
        else hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>!!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>!!(elem.scrollHeight > elem.clientHeight);
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue('animation-duration') || '0');
        const transDuration = parseFloat(style.getPropertyValue('transition-duration') || '0');
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = function(timer) {
        let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = 'none';
                timerProgressBar.style.width = '100%';
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = `width ${timer / 1000}s linear`;
                timerProgressBar.style.width = '0%';
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty('transition');
        timerProgressBar.style.width = '100%';
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = `${timerProgressBarPercent}%`;
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === 'undefined' || typeof document === 'undefined';
    const sweetHTML = `
 <div aria-labelledby="${swalClasses.title}" aria-describedby="${swalClasses['html-container']}" class="${swalClasses.popup}" tabindex="-1">
   <button type="button" class="${swalClasses.close}"></button>
   <ul class="${swalClasses['progress-steps']}"></ul>
   <div class="${swalClasses.icon}"></div>
   <img class="${swalClasses.image}" />
   <h2 class="${swalClasses.title}" id="${swalClasses.title}"></h2>
   <div class="${swalClasses['html-container']}" id="${swalClasses['html-container']}"></div>
   <input class="${swalClasses.input}" id="${swalClasses.input}" />
   <input type="file" class="${swalClasses.file}" />
   <div class="${swalClasses.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${swalClasses.select}" id="${swalClasses.select}"></select>
   <div class="${swalClasses.radio}"></div>
   <label class="${swalClasses.checkbox}">
     <input type="checkbox" id="${swalClasses.checkbox}" />
     <span class="${swalClasses.label}"></span>
   </label>
   <textarea class="${swalClasses.textarea}" id="${swalClasses.textarea}"></textarea>
   <div class="${swalClasses['validation-message']}" id="${swalClasses['validation-message']}"></div>
   <div class="${swalClasses.actions}">
     <div class="${swalClasses.loader}"></div>
     <button type="button" class="${swalClasses.confirm}"></button>
     <button type="button" class="${swalClasses.deny}"></button>
     <button type="button" class="${swalClasses.cancel}"></button>
   </div>
   <div class="${swalClasses.footer}"></div>
   <div class="${swalClasses['timer-progress-bar-container']}">
     <div class="${swalClasses['timer-progress-bar']}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, '');
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses['no-backdrop'],
            swalClasses['toast-shown'],
            swalClasses['has-column']
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement} */ const range = popup.querySelector(`.${swalClasses.range} input`);
        /** @type {HTMLOutputElement} */ const rangeOutput = popup.querySelector(`.${swalClasses.range} output`);
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement} */ const checkbox = popup.querySelector(`.${swalClasses.checkbox} input`);
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        input.oninput = resetValidationMessage$1;
        file.onchange = resetValidationMessage$1;
        select.onchange = resetValidationMessage$1;
        checkbox.onchange = resetValidationMessage$1;
        textarea.oninput = resetValidationMessage$1;
        range.oninput = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
        range.onchange = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>typeof target === 'string' ? document.querySelector(target) : target;
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        popup.setAttribute('role', params.toast ? 'alert' : 'dialog');
        popup.setAttribute('aria-live', params.toast ? 'polite' : 'assertive');
        if (!params.toast) popup.setAttribute('aria-modal', 'true');
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === 'rtl') addClass(getContainer(), swalClasses.rtl);
    };
    /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error('SweetAlert2 requires document to initialize');
            return;
        }
        const container = document.createElement('div');
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses['no-transition']);
        setInnerHtml(container, sweetHTML);
        container.dataset['swal2Theme'] = params.theme;
        const targetElement = getTarget(params.target);
        targetElement.appendChild(container);
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === 'object') handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {any} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if (param.jquery) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = '';
        if (0 in elem) for(let i = 0; i in elem; i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, 'actions');
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || '');
        applyCustomClass(loader, params, 'loader');
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, 'confirm', params);
        renderButton(denyButton, 'deny', params);
        renderButton(cancelButton, 'cancel', params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Apply custom background colors to action buttons
        if (params.confirmButtonColor) confirmButton.style.setProperty('--swal2-confirm-button-background-color', params.confirmButtonColor);
        if (params.denyButtonColor) denyButton.style.setProperty('--swal2-deny-button-background-color', params.denyButtonColor);
        if (params.cancelButtonColor) cancelButton.style.setProperty('--swal2-cancel-button-background-color', params.cancelButtonColor);
        // Apply the outline color to action buttons
        applyOutlineColor(confirmButton);
        applyOutlineColor(denyButton);
        applyOutlineColor(cancelButton);
    }
    /**
   * @param {HTMLElement} button
   */ function applyOutlineColor(button) {
        const buttonStyle = window.getComputedStyle(button);
        const outlineColor = buttonStyle.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, 'rgba($1, $2, $3, 0.5)');
        button.style.setProperty('--swal2-action-button-outline', buttonStyle.getPropertyValue('--swal2-outline').replace(/ rgba\(.*/, ` ${outlineColor}`));
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params[`show${buttonName}Button`], 'inline-block');
        setInnerHtml(button, params[`${buttonType}ButtonText`] || ''); // Set caption text
        button.setAttribute('aria-label', params[`${buttonType}ButtonAriaLabel`] || ''); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, `${buttonType}Button`);
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || '');
        // Custom class
        applyCustomClass(closeButton, params, 'closeButton');
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute('aria-label', params.closeButtonAriaLabel || '');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, 'container');
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === 'string') container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses['no-backdrop']);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses[`grow-${grow}`]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        'input',
        'file',
        'range',
        'select',
        'radio',
        'checkbox',
        'textarea'
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error(`Unexpected type of input! Expected ${Object.keys(renderInputType).join(' | ')}, got "${params.input}"`);
            return;
        }
        const inputContainer = getInputContainer(params.input);
        if (!inputContainer) return;
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for(let i = 0; i < input.attributes.length; i++){
            const attrName = input.attributes[i].name;
            if (![
                'id',
                'type',
                'value',
                'style'
            ].includes(attrName)) input.removeAttribute(attrName);
        }
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const popup = getPopup();
        if (!popup) return;
        const input = getInput$1(popup, inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        if (!params.input) return;
        const inputContainer = getInputContainer(params.input);
        if (inputContainer) applyCustomClass(inputContainer, params, 'input');
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder && params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement('label');
            const labelClass = swalClasses['input-label'];
            label.setAttribute('for', input.id);
            label.className = labelClass;
            if (typeof params.customClass === 'object') addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement('beforebegin', label);
        }
    };
    /**
   * @param {SweetAlertInput} inputType
   * @returns {HTMLElement | undefined}
   */ const getInputContainer = (inputType)=>{
        const popup = getPopup();
        if (!popup) return;
        return getDirectChildByClass(popup, swalClasses[/** @type {SwalClass} */ inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            'string',
            'number'
        ].includes(typeof inputValue)) input.value = `${inputValue}`;
        else if (!isPromise(inputValue)) warn(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof inputValue}"`);
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = renderInputType.search = renderInputType.date = renderInputType['datetime-local'] = renderInputType.time = renderInputType.week = renderInputType.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */ (input, params)=>{
        checkAndSetInputValue(input, params.inputValue);
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        input.type = params.input;
        return input;
    };
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.file = (input, params)=>{
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        return input;
    };
    /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.range = (range, params)=>{
        const rangeInput = range.querySelector('input');
        const rangeOutput = range.querySelector('output');
        checkAndSetInputValue(rangeInput, params.inputValue);
        rangeInput.type = params.input;
        checkAndSetInputValue(rangeOutput, params.inputValue);
        setInputLabel(rangeInput, range, params);
        return range;
    };
    /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */ renderInputType.select = (select, params)=>{
        select.textContent = '';
        if (params.inputPlaceholder) {
            const placeholder = document.createElement('option');
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
        }
        setInputLabel(select, select, params);
        return select;
    };
    /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */ renderInputType.radio = (radio)=>{
        radio.textContent = '';
        return radio;
    };
    /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const checkbox = getInput$1(getPopup(), 'checkbox');
        checkbox.value = '1';
        checkbox.checked = Boolean(params.inputValue);
        const label = checkboxContainer.querySelector('span');
        setInnerHtml(label, params.inputPlaceholder || params.inputLabel);
        return checkbox;
    };
    /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */ renderInputType.textarea = (textarea, params)=>{
        checkAndSetInputValue(textarea, params.inputValue);
        setInputPlaceholder(textarea, params);
        setInputLabel(textarea, textarea, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ('MutationObserver' in window) {
                const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textarea)) return;
                    const textareaWidth = textarea.offsetWidth + getMargin(textarea);
                    if (textareaWidth > initialPopupWidth) getPopup().style.width = `${textareaWidth}px`;
                    else applyNumericalStyle(getPopup(), 'width', params.width);
                };
                new MutationObserver(textareaResizeHandler).observe(textarea, {
                    attributes: true,
                    attributeFilter: [
                        'style'
                    ]
                });
            }
        });
        return textarea;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        showWhenInnerHtmlPresent(htmlContainer);
        applyCustomClass(htmlContainer, params, 'htmlContainer');
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, 'block');
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, 'block');
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        showWhenInnerHtmlPresent(footer);
        toggle(footer, params.footer, 'block');
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, 'footer');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${params.icon}"`);
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
        // Re-adjust the success icon on system theme change
        const colorSchemeQueryList = window.matchMedia('(prefers-color-scheme: dark)');
        colorSchemeQueryList.addEventListener('change', adjustSuccessIconBackgroundColor);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, 'icon');
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue('background-color');
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll('[class^=swal2-success-circular-line], .swal2-success-fix');
        for(let i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
    };
    const successIconHtml = `
  <div class="swal2-success-circular-line-left"></div>
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>
  <div class="swal2-success-circular-line-right"></div>
`;
    const errorIconHtml = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`;
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = '';
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === 'success') {
            newContent = successIconHtml;
            oldContent = oldContent.replace(/ style=".*?"/g, ''); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === 'error') newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: '?',
                warning: '!',
                info: 'i'
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            '.swal2-success-line-tip',
            '.swal2-success-line-long',
            '.swal2-x-mark-line-left',
            '.swal2-x-mark-line-right'
        ])setStyle(icon, sel, 'background-color', params.iconColor);
        setStyle(icon, '.swal2-success-ring', 'border-color', params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>`<div class="${swalClasses['icon-content']}">${content}</div>`;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, '');
        // Src, alt
        image.setAttribute('src', params.imageUrl);
        image.setAttribute('alt', params.imageAlt || '');
        // Width, height
        applyNumericalStyle(image, 'width', params.imageWidth);
        applyNumericalStyle(image, 'height', params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, 'image');
    };
    let dragging = false;
    let mousedownX = 0;
    let mousedownY = 0;
    let initialX = 0;
    let initialY = 0;
    /**
   * @param {HTMLElement} popup
   */ const addDraggableListeners = (popup)=>{
        popup.addEventListener('mousedown', down);
        document.body.addEventListener('mousemove', move);
        popup.addEventListener('mouseup', up);
        popup.addEventListener('touchstart', down);
        document.body.addEventListener('touchmove', move);
        popup.addEventListener('touchend', up);
    };
    /**
   * @param {HTMLElement} popup
   */ const removeDraggableListeners = (popup)=>{
        popup.removeEventListener('mousedown', down);
        document.body.removeEventListener('mousemove', move);
        popup.removeEventListener('mouseup', up);
        popup.removeEventListener('touchstart', down);
        document.body.removeEventListener('touchmove', move);
        popup.removeEventListener('touchend', up);
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const down = (event)=>{
        const popup = getPopup();
        if (event.target === popup || getIcon().contains(/** @type {HTMLElement} */ event.target)) {
            dragging = true;
            const clientXY = getClientXY(event);
            mousedownX = clientXY.clientX;
            mousedownY = clientXY.clientY;
            initialX = parseInt(popup.style.insetInlineStart) || 0;
            initialY = parseInt(popup.style.insetBlockStart) || 0;
            addClass(popup, 'swal2-dragging');
        }
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   */ const move = (event)=>{
        const popup = getPopup();
        if (dragging) {
            let { clientX: clientX, clientY: clientY } = getClientXY(event);
            popup.style.insetInlineStart = `${initialX + (clientX - mousedownX)}px`;
            popup.style.insetBlockStart = `${initialY + (clientY - mousedownY)}px`;
        }
    };
    const up = ()=>{
        const popup = getPopup();
        dragging = false;
        removeClass(popup, 'swal2-dragging');
    };
    /**
   * @param {MouseEvent | TouchEvent} event
   * @returns {{ clientX: number, clientY: number }}
   */ const getClientXY = (event)=>{
        let clientX = 0, clientY = 0;
        if (event.type.startsWith('mouse')) {
            clientX = /** @type {MouseEvent} */ event.clientX;
            clientY = /** @type {MouseEvent} */ event.clientY;
        } else if (event.type.startsWith('touch')) {
            clientX = /** @type {TouchEvent} */ event.touches[0].clientX;
            clientY = /** @type {TouchEvent} */ event.touches[0].clientY;
        }
        return {
            clientX: clientX,
            clientY: clientY
        };
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, 'width', params.width);
            popup.style.width = '100%';
            const loader = getLoader();
            if (loader) popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, 'width', params.width);
        // Padding
        applyNumericalStyle(popup, 'padding', params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
        if (params.draggable && !params.toast) {
            addClass(popup, swalClasses.draggable);
            addDraggableListeners(popup);
        } else {
            removeClass(popup, swalClasses.draggable);
            removeDraggableListeners(popup);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = `${swalClasses.popup} ${isVisible$1(popup) ? showClass.popup : ''}`;
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses['toast-shown']);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, 'popup');
        // TODO: remove in the next major
        if (typeof params.customClass === 'string') addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses[`icon-${params.icon}`]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps: progressSteps, currentProgressStep: currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = '';
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses['active-progress-step']);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement('li');
        addClass(stepEl, swalClasses['progress-step']);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement('li');
        addClass(lineEl, swalClasses['progress-step-line']);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, 'width', params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        showWhenInnerHtmlPresent(title);
        toggle(title, params.title || params.titleText, 'block');
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, 'title');
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === 'function' && popup) params.didRender(popup);
        globalState.eventEmitter.emit('didRender', popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */ /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: 'cancel',
        backdrop: 'backdrop',
        close: 'close',
        esc: 'esc',
        timer: 'timer'
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
            globalState.keydownTarget.removeEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            globalState.keydownHandler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
            globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
            globalState.keydownTarget.addEventListener('keydown', globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = true;
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // shift + tab when .swal2-popup is focused
            if (index === -2) index = focusableElements.length - 1;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            return;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = [
        'ArrowRight',
        'ArrowDown'
    ];
    const arrowKeysPreviousButton = [
        'ArrowLeft',
        'ArrowUp'
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === 'Enter') handleEnter(event, innerParams);
        else if (event.key === 'Tab') handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === 'Escape') handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const input = getInput$1(getPopup(), innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                'textarea',
                'file'
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        let btnIndex = -1;
        for(let i = 0; i < focusableElements.length; i++)if (targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
        }
        // Cycle to the next button
        if (!event.shiftKey) setFocus(btnIndex, 1);
        else setFocus(btnIndex, -1);
        event.stopPropagation();
        event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? 'nextElementSibling' : 'previousElementSibling';
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        if (callIfFunction(innerParams.allowEscapeKey)) {
            event.preventDefault();
            dismissWith(DismissReason.esc);
        }
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const container = getContainer();
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.contains(container)) return;
            if (el.hasAttribute('aria-hidden')) el.setAttribute('data-previous-aria-hidden', el.getAttribute('aria-hidden') || '');
            el.setAttribute('aria-hidden', 'true');
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute('data-previous-aria-hidden')) {
                el.setAttribute('aria-hidden', el.getAttribute('data-previous-aria-hidden') || '');
                el.removeAttribute('data-previous-aria-hidden');
            } else el.removeAttribute('aria-hidden');
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== 'undefined' && !!window.GestureEvent; // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = `${offset * -1}px`;
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== 'INPUT' && // #1603
        target.tagName !== 'TEXTAREA' && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return event.touches && event.touches.length && event.touches[0].touchType === 'stylus';
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = '';
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement('div');
        scrollDiv.className = swalClasses['scrollbar-measure'];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === 'scroll' // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'));
            document.body.style.paddingRight = `${previousBodyPadding + measureScrollbar()}px`;
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = `${previousBodyPadding}px`;
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute('style', 'display:none !important');
            container.removeAttribute('class');
            container.innerHTML = '';
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses['height-auto'],
            swalClasses['no-backdrop'],
            swalClasses['toast-shown']
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {any} error
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === 'undefined') return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        var _globalState$eventEmi;
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = hasCssAnimation(popup);
        if (typeof innerParams.willClose === 'function') innerParams.willClose(popup);
        (_globalState$eventEmi = globalState.eventEmitter) === null || _globalState$eventEmi === void 0 || _globalState$eventEmi.emit('willClose', popup);
        if (animationIsSupported) animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
        else // Otherwise, remove immediately
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        /**
     * @param {AnimationEvent | TransitionEvent} e
     */ const swalCloseAnimationFinished = function(e) {
            if (e.target === popup) {
                var _globalState$swalClos;
                (_globalState$swalClos = globalState.swalCloseEventFinishedCallback) === null || _globalState$swalClos === void 0 || _globalState$swalClos.call(globalState);
                delete globalState.swalCloseEventFinishedCallback;
                popup.removeEventListener('animationend', swalCloseAnimationFinished);
                popup.removeEventListener('transitionend', swalCloseAnimationFinished);
            }
        };
        popup.addEventListener('animationend', swalCloseAnimationFinished);
        popup.addEventListener('transitionend', swalCloseAnimationFinished);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            var _globalState$eventEmi2;
            if (typeof didClose === 'function') didClose.bind(instance.params)();
            (_globalState$eventEmi2 = globalState.eventEmitter) === null || _globalState$eventEmi2 === void 0 || _globalState$eventEmi2.emit('didClose');
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal();
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute('data-loading', 'true');
        popup.setAttribute('aria-busy', 'true');
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute('data-button-to-replace', buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === 'select' || params.input === 'radio') handleInputOptions(instance, params);
        else if ([
            'text',
            'email',
            'number',
            'tel',
            'textarea'
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case 'checkbox':
                return getCheckboxValue(input);
            case 'radio':
                return getRadioValue(input);
            case 'file':
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute('multiple') !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {Record<string, any>} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === 'select') populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === 'radio') populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === 'object') processInputOptions(params.inputOptions);
        else error(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof params.inputOptions}`);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === 'number' ? `${parseFloat(inputValue) || 0}` : `${inputValue}`;
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error(`Error in inputValue promise: ${err}`);
            input.value = '';
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement('option');
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement('optgroup');
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement('input');
            const radioLabelElement = document.createElement('label');
            radioInput.type = 'radio';
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement('span');
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll('input');
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        /** @type {InputOptionFlattened[]} */ const result = [];
        if (inputOptions instanceof Map) inputOptions.forEach((value, key)=>{
            let valueFormatted = value;
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        else Object.keys(inputOptions).forEach((key)=>{
            let valueFormatted = inputOptions[key];
            if (typeof valueFormatted === 'object') // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        return result;
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>{
        return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, 'confirm');
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, 'deny');
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error(`The "input" parameter is needed to be set when using returnInputValueOn${capitalizeFirstLetter(type)}`);
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage || input.validationMessage);
        } else if (type === 'deny') deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === 'deny') deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close({
                    isDenied: true,
                    value: typeof preDenyValue === 'undefined' ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else instance.close({
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const succeedWith = (instance, value)=>{
        instance.close({
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === 'undefined' ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute('aria-busy');
        domCache.popup.removeAttribute('data-loading');
        domCache.confirmButton.disabled = false;
        domCache.denyButton.disabled = false;
        domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = (domCache)=>{
        const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute('data-button-to-replace'));
        if (buttonToReplace.length) show(buttonToReplace[0], 'inline-block');
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === 'radio') {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll(`[name="${swalClasses.radio}"]`);
            for(let i = 0; i < radios.length; i++)radios[i].disabled = disabled;
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], false);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        setButtonsDisabled(this, [
            'confirmButton',
            'denyButton',
            'cancelButton'
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses['validation-message'];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.setAttribute('aria-describedby', swalClasses['validation-message']);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute('aria-invalid');
            input.removeAttribute('aria-describedby');
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: '',
        titleText: '',
        text: '',
        html: '',
        footer: '',
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        draggable: false,
        animation: true,
        theme: 'light',
        showClass: {
            popup: 'swal2-show',
            backdrop: 'swal2-backdrop-show',
            icon: 'swal2-icon-show'
        },
        hideClass: {
            popup: 'swal2-hide',
            backdrop: 'swal2-backdrop-hide',
            icon: 'swal2-icon-hide'
        },
        customClass: {},
        target: 'body',
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: 'OK',
        confirmButtonAriaLabel: '',
        confirmButtonColor: undefined,
        denyButtonText: 'No',
        denyButtonAriaLabel: '',
        denyButtonColor: undefined,
        cancelButtonText: 'Cancel',
        cancelButtonAriaLabel: '',
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: '&times;',
        closeButtonAriaLabel: 'Close this dialog',
        loaderHtml: '',
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: '',
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: '',
        inputLabel: '',
        inputValue: '',
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: 'center',
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true
    };
    const updatableParams = [
        'allowEscapeKey',
        'allowOutsideClick',
        'background',
        'buttonsStyling',
        'cancelButtonAriaLabel',
        'cancelButtonColor',
        'cancelButtonText',
        'closeButtonAriaLabel',
        'closeButtonHtml',
        'color',
        'confirmButtonAriaLabel',
        'confirmButtonColor',
        'confirmButtonText',
        'currentProgressStep',
        'customClass',
        'denyButtonAriaLabel',
        'denyButtonColor',
        'denyButtonText',
        'didClose',
        'didDestroy',
        'draggable',
        'footer',
        'hideClass',
        'html',
        'icon',
        'iconColor',
        'iconHtml',
        'imageAlt',
        'imageHeight',
        'imageUrl',
        'imageWidth',
        'preConfirm',
        'preDeny',
        'progressSteps',
        'returnFocus',
        'reverseButtons',
        'showCancelButton',
        'showCloseButton',
        'showConfirmButton',
        'showDenyButton',
        'text',
        'title',
        'titleText',
        'theme',
        'willClose'
    ];
    /** @type {Record<string, string | undefined>} */ const deprecatedParams = {
        allowEnterKey: undefined
    };
    const toastIncompatibleParams = [
        'allowOutsideClick',
        'allowEnterKey',
        'backdrop',
        'draggable',
        'focusConfirm',
        'focusDeny',
        'focusCancel',
        'returnFocus',
        'heightAuto',
        'keydownListenerCapture'
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn(`Unknown parameter "${param}"`);
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn(`The parameter "${param}" is incompatible with toasts`);
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        if (params.theme && ![
            'light',
            'dark',
            'auto',
            'borderless',
            'embed-iframe'
        ].includes(params.theme)) warn(`Invalid theme "${params.theme}". Expected "light", "dark", "auto", "borderless", or "embed-iframe"`);
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const container = getContainer();
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn(`You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.`);
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        showWarningsForParams(updatedParams);
        container.dataset['swal2Theme'] = updatedParams.theme;
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) validUpdatableParams[param] = params[param];
            else warn(`Invalid parameter to update: ${param}`);
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   */ function _destroy() {
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === 'function') innerParams.didDestroy();
        globalState.eventEmitter.emit('didDestroy');
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            delete instance.isAwaitingPromise;
            // Unset instance methods
            delete instance.disableButtons;
            delete instance.enableButtons;
            delete instance.getInput;
            delete instance.disableInput;
            delete instance.enableInput;
            delete instance.hideLoading;
            delete instance.disableLoading;
            delete instance.showValidationMessage;
            delete instance.resetValidationMessage;
            delete instance.close;
            delete instance.closePopup;
            delete instance.closeModal;
            delete instance.closeToast;
            delete instance.rejectPromise;
            delete instance.update;
            delete instance._destroy;
        }
    };
    /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = (e)=>{
            // prevent the modal text from being selected on double click on the container (allowOutsideClick: false)
            if (e.target === domCache.container) e.preventDefault();
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    const isJqueryElement = (elem)=>typeof elem === 'object' && elem.jquery;
    const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    const argsToParams = (args)=>{
        const params = {};
        if (typeof args[0] === 'object' && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            'title',
            'html',
            'icon'
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === 'string' || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error(`Unexpected type of ${name}! Expected "string" or "Element", got ${typeof arg}`);
        });
        return params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new this(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */ function mixin(mixinParams) {
        class MixinSwal extends this {
            _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    /**
   * @param {string} attr
   */ function bindClickHandler() {
        let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'data-swal-template';
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener('click', bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    const bodyClickListener = (event)=>{
        for(let el = event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    // Source: https://gist.github.com/mudge/5830382?permalink_comment_id=2691957#gistcomment-2691957
    class EventEmitter {
        constructor(){
            /** @type {Events} */ this.events = {};
        }
        /**
     * @param {string} eventName
     * @returns {EventHandlers}
     */ _getHandlersByEventName(eventName) {
            if (typeof this.events[eventName] === 'undefined') // not Set because we need to keep the FIFO order
            // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1748990334
            this.events[eventName] = [];
            return this.events[eventName];
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ on(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            if (!currentHandlers.includes(eventHandler)) currentHandlers.push(eventHandler);
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ once(eventName, eventHandler) {
            var _this = this;
            /**
       * @param {Array} args
       */ const onceFn = function() {
                _this.removeListener(eventName, onceFn);
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                eventHandler.apply(_this, args);
            };
            this.on(eventName, onceFn);
        }
        /**
     * @param {string} eventName
     * @param {Array} args
     */ emit(eventName) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            this._getHandlersByEventName(eventName).forEach(/**
       * @param {EventHandler} eventHandler
       */ (eventHandler)=>{
                try {
                    eventHandler.apply(this, args);
                } catch (error) {
                    console.error(error);
                }
            });
        }
        /**
     * @param {string} eventName
     * @param {EventHandler} eventHandler
     */ removeListener(eventName, eventHandler) {
            const currentHandlers = this._getHandlersByEventName(eventName);
            const index = currentHandlers.indexOf(eventHandler);
            if (index > -1) currentHandlers.splice(index, 1);
        }
        /**
     * @param {string} eventName
     */ removeAllListeners(eventName) {
            if (this.events[eventName] !== undefined) // https://github.com/sweetalert2/sweetalert2/pull/2763#discussion_r1749239222
            this.events[eventName].length = 0;
        }
        reset() {
            this.events = {};
        }
    }
    globalState.eventEmitter = new EventEmitter();
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const on = (eventName, eventHandler)=>{
        globalState.eventEmitter.on(eventName, eventHandler);
    };
    /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */ const once = (eventName, eventHandler)=>{
        globalState.eventEmitter.once(eventName, eventHandler);
    };
    /**
   * @param {string} [eventName]
   * @param {EventHandler} [eventHandler]
   */ const off = (eventName, eventHandler)=>{
        // Remove all handlers for all events
        if (!eventName) {
            globalState.eventEmitter.reset();
            return;
        }
        if (eventHandler) // Remove a specific handler
        globalState.eventEmitter.removeListener(eventName, eventHandler);
        else // Remove all handlers for a specific event
        globalState.eventEmitter.removeAllListeners(eventName);
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        off: off,
        on: on,
        once: once,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {Function} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        'swal-title',
        'swal-html',
        'swal-footer'
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        const template = typeof params.template === 'string' ? /** @type {HTMLTemplateElement} */ document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll('swal-param'));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                'name',
                'value'
            ]);
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            if (typeof defaultParams[paramName] === 'boolean') result[paramName] = value !== 'false';
            else if (typeof defaultParams[paramName] === 'object') result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalFunctionParams = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll('swal-function-param'));
        swalFunctions.forEach((param)=>{
            const paramName = /** @type {keyof SweetAlertOptions} */ param.getAttribute('name');
            const value = param.getAttribute('value');
            if (!paramName || !value) return;
            result[paramName] = new Function(`return ${value}`)();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalButtons = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll('swal-button'));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                'type',
                'color',
                'aria-label'
            ]);
            const type = button.getAttribute('type');
            if (!type || ![
                'confirm',
                'cancel',
                'deny'
            ].includes(type)) return;
            result[`${type}ButtonText`] = button.innerHTML;
            result[`show${capitalizeFirstLetter(type)}Button`] = true;
            if (button.hasAttribute('color')) result[`${type}ButtonColor`] = button.getAttribute('color');
            if (button.hasAttribute('aria-label')) result[`${type}ButtonAriaLabel`] = button.getAttribute('aria-label');
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Pick<SweetAlertOptions, 'imageUrl' | 'imageWidth' | 'imageHeight' | 'imageAlt'>}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const image = templateContent.querySelector('swal-image');
        if (image) {
            showWarningsForAttributes(image, [
                'src',
                'width',
                'height',
                'alt'
            ]);
            if (image.hasAttribute('src')) result.imageUrl = image.getAttribute('src') || undefined;
            if (image.hasAttribute('width')) result.imageWidth = image.getAttribute('width') || undefined;
            if (image.hasAttribute('height')) result.imageHeight = image.getAttribute('height') || undefined;
            if (image.hasAttribute('alt')) result.imageAlt = image.getAttribute('alt') || undefined;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement | null} */ const icon = templateContent.querySelector('swal-icon');
        if (icon) {
            showWarningsForAttributes(icon, [
                'type',
                'color'
            ]);
            if (icon.hasAttribute('type')) result.icon = icon.getAttribute('type');
            if (icon.hasAttribute('color')) result.iconColor = icon.getAttribute('color');
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {Record<string, any>}
   */ const getSwalInput = (templateContent)=>{
        /** @type {Record<string, any>} */ const result = {};
        /** @type {HTMLElement | null} */ const input = templateContent.querySelector('swal-input');
        if (input) {
            showWarningsForAttributes(input, [
                'type',
                'label',
                'placeholder',
                'value'
            ]);
            result.input = input.getAttribute('type') || 'text';
            if (input.hasAttribute('label')) result.inputLabel = input.getAttribute('label');
            if (input.hasAttribute('placeholder')) result.inputPlaceholder = input.getAttribute('placeholder');
            if (input.hasAttribute('value')) result.inputValue = input.getAttribute('value');
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll('swal-input-option'));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    'value'
                ]);
                const optionValue = option.getAttribute('value');
                if (!optionValue) return;
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {Record<string, any>}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        /** @type {Record<string, any>} */ const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement | null} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, '')] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            'swal-param',
            'swal-function-param',
            'swal-button',
            'swal-image',
            'swal-icon',
            'swal-input',
            'swal-input-option'
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn(`Unrecognized element <${tagName}>`);
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                `Unrecognized attribute "${attribute.name}" on <${el.tagName.toLowerCase()}>.`,
                `${allowedAttributes.length ? `Allowed attributes are: ${allowedAttributes.join(', ')}` : 'To set the value, use HTML within the element.'}`
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (typeof params.willOpen === 'function') params.willOpen(popup);
        globalState.eventEmitter.emit('willOpen', popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
            setAriaHidden();
        }
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === 'function') setTimeout(()=>params.didOpen(popup));
        globalState.eventEmitter.emit('didOpen', popup);
        removeClass(container, swalClasses['no-transition']);
    };
    /**
   * @param {AnimationEvent} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (event.target !== popup) return;
        const container = getContainer();
        popup.removeEventListener('animationend', swalOpenAnimationFinished);
        popup.removeEventListener('transitionend', swalOpenAnimationFinished);
        container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (hasCssAnimation(popup)) {
            container.style.overflowY = 'hidden';
            popup.addEventListener('animationend', swalOpenAnimationFinished);
            popup.addEventListener('transitionend', swalOpenAnimationFinished);
        } else container.style.overflowY = 'auto';
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== 'hidden') replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        addClass(container, params.showClass.backdrop);
        if (params.animation) {
            // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
            popup.style.setProperty('opacity', '0', 'important');
            show(popup, 'grid');
            setTimeout(()=>{
                // Animate popup right after showing it
                addClass(popup, params.showClass.popup);
                // and remove the opacity workaround
                popup.style.removeProperty('opacity');
            }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        } else show(popup, 'grid');
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses['height-auto']);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid email address');
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || 'Invalid URL');
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === 'email') params.inputValidator = defaultInputValidators['email'];
        if (params.input === 'url') params.inputValidator = defaultInputValidators['url'];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === 'string' && !document.querySelector(params.target) || typeof params.target !== 'string' && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = 'body';
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === 'string') params.title = params.title.split('\n').join('<br />');
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...any} args
     * @this {SweetAlert}
     */ constructor(){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, void 0);
            // Prevent run in Node env
            if (typeof window === 'undefined') return;
            currentInstance = this;
            // @ts-ignore
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet2(_promise, this, this._main(currentInstance.params));
        }
        _main(userParams) {
            let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                const swalPromiseResolve = privateMethods.swalPromiseResolve.get(globalState.currentInstance);
                const { isAwaitingPromise: isAwaitingPromise } = globalState.currentInstance;
                globalState.currentInstance._destroy();
                if (!isAwaitingPromise) swalPromiseResolve({
                    isDismissed: true
                });
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        then(onFulfilled) {
            return _classPrivateFieldGet2(_promise, this).then(onFulfilled);
        }
        finally(onFinally) {
            return _classPrivateFieldGet2(_promise, this).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        if (params.animation === false) {
            params.showClass = {
                backdrop: 'swal2-noanimation'
            };
            params.hideClass = {};
        }
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = {
            popup: getPopup(),
            container: getContainer(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            denyButton: getDenyButton(),
            cancelButton: getCancelButton(),
            loader: getLoader(),
            closeButton: getCloseButton(),
            validationMessage: getValidationMessage(),
            progressSteps: getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith('timer');
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, 'timerProgressBar');
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(innerParams.timer);
                });
            }
        }
    };
    /**
   * Initialize focus in the popup:
   *
   * 1. If `toast` is `true`, don't steal focus from the document.
   * 2. Else if there is an [autofocus] element, focus it.
   * 3. Else if `focusConfirm` is `true` and confirm button is visible, focus it.
   * 4. Else if `focusDeny` is `true` and deny button is visible, focus it.
   * 5. Else if `focusCancel` is `true` and cancel button is visible, focus it.
   * 6. Else focus the first focusable element in a popup (if any).
   *
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        // TODO: this is dumb, remove `allowEnterKey` param in the next major version
        if (!callIfFunction(innerParams.allowEnterKey)) {
            warnAboutDeprecation('allowEnterKey');
            blurActiveElement();
            return;
        }
        if (focusAutofocus(domCache)) return;
        if (focusButton(domCache, innerParams)) return;
        setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @returns {boolean}
   */ const focusAutofocus = (domCache)=>{
        const autofocusElements = Array.from(domCache.popup.querySelectorAll('[autofocus]'));
        for (const autofocusElement of autofocusElements)if (autofocusElement instanceof HTMLElement && isVisible$1(autofocusElement)) {
            autofocusElement.focus();
            return true;
        }
        return false;
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    const blurActiveElement = ()=>{
        if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
    };
    // Dear russian users visiting russian sites. Let's have fun.
    if (typeof window !== 'undefined' && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
        const now = new Date();
        const initiationDate = localStorage.getItem('swal-initiation');
        if (!initiationDate) localStorage.setItem('swal-initiation', `${now}`);
        else if ((now.getTime() - Date.parse(initiationDate)) / 86400000 > 3) setTimeout(()=>{
            document.body.style.pointerEvents = 'none';
            const ukrainianAnthem = document.createElement('audio');
            ukrainianAnthem.src = 'https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3';
            ukrainianAnthem.loop = true;
            document.body.appendChild(ukrainianAnthem);
            setTimeout(()=>{
                ukrainianAnthem.play().catch(()=>{
                // ignore
                });
            }, 2500);
        }, 500);
    }
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...any} args
     * @returns {any | undefined}
     */ SweetAlert[key] = function() {
            if (currentInstance && currentInstance[key]) return currentInstance[key](...arguments);
            return null;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = '11.19.1';
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof $29445ff8c44e0e0c$exports !== 'undefined' && $29445ff8c44e0e0c$exports.Sweetalert2) $29445ff8c44e0e0c$exports.swal = $29445ff8c44e0e0c$exports.sweetAlert = $29445ff8c44e0e0c$exports.Swal = $29445ff8c44e0e0c$exports.SweetAlert = $29445ff8c44e0e0c$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, ":root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-footer-border-color: #eee;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-background: transparent;--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.1s, box-shadow 0.1s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-confirm-button-background-color: #7066e0;--swal2-deny-button-background-color: #dc3741;--swal2-cancel-button-background-color: #6e7881}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:\"top-start     top            top-end\" \"center-start  center         center-end\" \"bottom-start  bottom-center  bottom-end\";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-confirm-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-deny-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border:0;border-radius:.25em;background:initial;background-color:var(--swal2-cancel-button-background-color);color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-outline)}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);color:inherit;font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:var(--swal2-input-background);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:\"!\";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:var(--swal2-background);box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}");


var $55d890a0ab07ade7$exports = {};


// sweetalert2-react-content v5.1.0
(function(global, factory) {
    $55d890a0ab07ade7$exports = factory((parcelRequire("dBNnn")), (parcelRequire("2NwrC")));
})($55d890a0ab07ade7$exports, function(React, client) {
    'use strict';
    const mounts = [
        {
            key: 'title',
            getter: (swal)=>swal.getTitle()
        },
        {
            key: 'html',
            getter: (swal)=>swal.getHtmlContainer()
        },
        {
            key: 'confirmButtonText',
            getter: (swal)=>swal.getConfirmButton()
        },
        {
            key: 'denyButtonText',
            getter: (swal)=>swal.getDenyButton()
        },
        {
            key: 'cancelButtonText',
            getter: (swal)=>swal.getCancelButton()
        },
        {
            key: 'footer',
            getter: (swal)=>swal.getFooter()
        },
        {
            key: 'closeButtonHtml',
            getter: (swal)=>swal.getCloseButton()
        },
        {
            key: 'iconHtml',
            getter: (swal)=>swal.getIconContent()
        },
        {
            key: 'loaderHtml',
            getter: (swal)=>swal.getLoader()
        }
    ];
    const noop = ()=>{};
    function withReactContent(ParentSwal) {
        /* Returns `params` separated into a tuple of `reactParams` (the React params that need to be rendered)
    and`otherParams` (all the other parameters, with any React params replaced with a space ' ') */ function extractReactParams(params) {
            const reactParams = {};
            const otherParams = {};
            const mountKeys = mounts.map((mount)=>mount.key);
            Object.entries(params).forEach((_ref)=>{
                let [key, value] = _ref;
                if (mountKeys.includes(key) && /*#__PURE__*/ React.isValidElement(value)) {
                    reactParams[key] = value;
                    otherParams[key] = ' ';
                } else otherParams[key] = value;
            });
            return [
                reactParams,
                otherParams
            ];
        }
        function render(swal, reactParams) {
            Object.entries(reactParams).forEach((_ref2)=>{
                let [key, value] = _ref2;
                const mount = mounts.find((mount)=>mount.key === key);
                const domElement = mount.getter(ParentSwal);
                const root = client.createRoot(domElement);
                root.render(value);
                swal.__roots.push(root);
            });
        }
        function unrender(swal) {
            swal.__roots.forEach((root)=>{
                root.unmount();
            });
            swal.__roots = [];
        }
        return class extends ParentSwal {
            static argsToParams(args) {
                if (/*#__PURE__*/ React.isValidElement(args[0]) || /*#__PURE__*/ React.isValidElement(args[1])) {
                    const params = {};
                    [
                        'title',
                        'html',
                        'icon'
                    ].forEach((name, index)=>{
                        if (args[index] !== undefined) params[name] = args[index];
                    });
                    return params;
                } else return ParentSwal.argsToParams(args);
            }
            _main(params, mixinParams) {
                this.__roots = [];
                this.__params = Object.assign({}, mixinParams, params);
                const [reactParams, otherParams] = extractReactParams(this.__params);
                const superWillOpen = otherParams.willOpen || noop;
                const superDidOpen = otherParams.didOpen || noop;
                const superDidDestroy = otherParams.didDestroy || noop;
                return super._main(Object.assign({}, otherParams, {
                    willOpen: (popup)=>{
                        render(this, reactParams);
                        superWillOpen(popup);
                    },
                    didOpen: (popup)=>{
                        // read more about why this setTimeout is needed here:
                        // https://github.com/reactwg/react-18/discussions/5 (What about the render callback?)
                        setTimeout(()=>{
                            superDidOpen(popup);
                        });
                    },
                    didDestroy: (popup)=>{
                        superDidDestroy(popup);
                        unrender(this);
                    }
                }));
            }
            update(params) {
                Object.assign(this.__params, params);
                unrender(this);
                const [reactParams, otherParams] = extractReactParams(this.__params);
                super.update(otherParams);
                render(this, reactParams);
            }
        };
    }
    return withReactContent;
});


const $c76c78ebffccd857$export$7172c8e9d7696d9b = (0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    customClass: {
        cancelButton: 'btn btn-danger mx-2',
        confirmButton: 'btn btn-success mx-2'
    },
    backdrop: true,
    buttonsStyling: false,
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Confirm',
    showCancelButton: true,
    type: 'question'
});
const $c76c78ebffccd857$export$c4a08e1df74d230d = (0, (/*@__PURE__*/$parcel$interopDefault($55d890a0ab07ade7$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    backdrop: true,
    buttonsStyling: false,
    confirmButtonText: 'Open those namespaces',
    cancelButtonText: 'Ok',
    customClass: {
        confirmButton: 'btn btn-success mx-2',
        cancelButton: 'btn btn-primary mx-2'
    },
    showCancelButton: true,
    title: 'Error deleting institution',
    type: 'error'
}));
const $c76c78ebffccd857$export$e8ef7fe519636aa2 = (0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    customClass: {
        confirmButton: 'btn btn-success mx-2'
    },
    buttonsStyling: false,
    type: 'success'
});
const $c76c78ebffccd857$export$438b25931d46d7ec = (0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    customClass: {
        confirmButton: 'btn btn-success mx-2'
    },
    buttonsStyling: false,
    type: 'error'
});
const $c76c78ebffccd857$export$d80014e59849ee30 = (0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    animation: false,
    customClass: {
        actions: 'beta-banner__actions',
        confirmButton: 'btn btn-light mx-2',
        content: 'beta-banner__content',
        popup: 'beta-banner'
    },
    buttonsStyling: false,
    confirmButtonText: 'Dismiss',
    toast: true,
    position: 'top',
    timer: 15000
});
const $c76c78ebffccd857$export$633d761a4bd5a2cf = (0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
    animation: false,
    customClass: {
        confirmButton: 'btn btn-light mx-2'
    },
    buttonsStyling: false,
    confirmButtonText: 'Dismiss'
});
const $c76c78ebffccd857$var$toast = (type, title, html, position, timer)=>(0, (/*@__PURE__*/$parcel$interopDefault($29445ff8c44e0e0c$exports))).mixin({
        type: type,
        title: title,
        html: html,
        toast: true,
        position: position,
        showConfirmButton: false,
        timer: timer || 3000
    }).fire();
const $c76c78ebffccd857$export$73e19c0339806233 = (title, html, timer)=>$c76c78ebffccd857$var$toast('success', title, html, 'top-end', timer);
const $c76c78ebffccd857$export$85ee8a1f69fea720 = (title, html, timer)=>$c76c78ebffccd857$var$toast('error', title, html, 'top-end', timer);
const $c76c78ebffccd857$export$4cc0fb945c4ba96e = (title, html, timer)=>$c76c78ebffccd857$var$toast('info', title, html, 'top-end', timer);



async function $bafaab9173a4f7a3$var$validateThroughAPI(url, payload) {
    const body = {
        apiVersion: 1,
        payload: payload
    };
    const init = {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(body)
    };
    const response = await fetch(url, init);
    const responseStatusCode = response.status;
    const json = await response.json();
    return {
        valid: responseStatusCode === 200,
        errorMessage: json.errorMessage
    };
}
const $bafaab9173a4f7a3$var$validationEndpoint = {
    'prefix': (0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRegistrationEndpoint,
    'resource': (0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRegistrationEndpoint
};
const $bafaab9173a4f7a3$var$validators = {
    namespacePrefix: async (namespacePrefix, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateNamespacePrefix`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            namespacePrefix: namespacePrefix
        });
    },
    // Resource edition provider name.
    name: async (providerName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderName`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerName: providerName
        });
    },
    description: async (providerDescription, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderDescription`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerDescription: providerDescription
        });
    },
    requestedPrefix: async (requestedPrefix, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateRequestedPrefix`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            requestedPrefix: requestedPrefix
        });
    },
    sampleId: async (sampleId, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateSampleId`;
        if (typeof registrationRequest.providerUrlPattern === 'undefined') return {
            valid: true
        };
        const payload = {
            sampleId: sampleId,
            providerUrlPattern: registrationRequest.providerUrlPattern
        };
        if (registrationRequest.hasOwnProperty("namespacePrefix")) payload.namespacePrefix = registrationRequest.namespacePrefix;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, payload);
    },
    idRegexPattern: async (idRegexPattern, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateIdRegexPattern`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            idRegexPattern: idRegexPattern,
            sampleId: registrationRequest.sampleId
        });
    },
    pattern: async (idRegexPattern, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateIdRegexPattern`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            idRegexPattern: idRegexPattern,
            sampleId: registrationRequest.sampleId
        });
    },
    supportingReferences: async (supportingReferences, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateReferences`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            supportingReferences: supportingReferences.split('\n')
        });
    },
    additionalInformation: async (additionalInformation, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateAdditionalInformation`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            additionalInformation: additionalInformation
        });
    },
    // Location and institution when selected from a dropdown will always be valid.
    institution: ()=>({
            valid: true
        }),
    location: ()=>({
            valid: true
        }),
    institutionName: async (institutionName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateInstitutionName`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            institutionName: institutionName
        });
    },
    institutionDescription: async (institutionDescription, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateInstitutionDescription`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            institutionDescription: institutionDescription
        });
    },
    institutionHomeUrl: async (institutionHomeUrl, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateInstitutionHomeUrl`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            institutionHomeUrl: institutionHomeUrl
        });
    },
    institutionLocation: async (institutionLocation, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateInstitutionLocation`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            institutionLocation: institutionLocation
        });
    },
    namespaceEmbeddedInLui: async (namespaceEmbeddedInLui, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateNamespaceEmbeddedInLui`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            namespaceEmbeddedInLui: namespaceEmbeddedInLui
        });
    },
    providerName: async (providerName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderName`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerName: providerName
        });
    },
    providerDescription: async (providerDescription, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderDescription`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerDescription: providerDescription
        });
    },
    providerHomeUrl: async (providerHomeUrl, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderHomeUrl`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerHomeUrl: providerHomeUrl
        });
    },
    resourceHomeUrl: async (providerHomeUrl, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderHomeUrl`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerHomeUrl: providerHomeUrl
        });
    },
    providerCode: async (providerCode, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderCode`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerCode: providerCode,
            namespacePrefix: registrationRequest.namespacePrefix
        });
    },
    providerUrlPattern: async (providerUrlPattern, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderUrlPattern`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerUrlPattern: providerUrlPattern,
            sampleId: registrationRequest.sampleId
        });
    },
    urlPattern: async (providerUrlPattern, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderUrlPattern`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerUrlPattern: providerUrlPattern
        });
    },
    providerLocation: async (providerLocation, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateProviderLocation`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            providerLocation: providerLocation
        });
    },
    requesterName: async (requesterName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateRequesterName`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            requester: {
                name: requesterName
            }
        });
    },
    authHelpUrl: async (requesterName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateAuthHelpUrl`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            requester: {
                name: requesterName
            }
        });
    },
    authHelpDescription: async (requesterName, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateAuthHelpDescription`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            requester: {
                name: requesterName
            }
        });
    },
    requesterEmail: async (requesterEmail, registrationRequest, registrationRequestType)=>{
        const url = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${$bafaab9173a4f7a3$var$validationEndpoint[registrationRequestType]}/validateRequesterEmail`;
        return $bafaab9173a4f7a3$var$validateThroughAPI(url, {
            requester: {
                email: requesterEmail
            }
        });
    },
    rorId: (rorId)=>{
        const rorIdLastPart = rorId.split('/').pop();
        const bad = {
            apiVersion: "1.0",
            errorMessage: "Incorrect ROR Id",
            payload: {
                "comment": "VALIDATION FAILED"
            }
        };
        const good = {
            apiVersion: "1.0",
            errorMessage: null,
            payload: {
                "comment": "VALIDATION OK"
            }
        };
        if (rorId.slice(0, 8) !== 'https://') return bad; // Start with 'https://'.
        if (rorIdLastPart.length !== 9) return bad; // Last part is not 9 long.
        if (rorIdLastPart[0] !== '0') return bad; // Last part not starting with 0.
        if (isNaN(parseInt(rorIdLastPart.split(rorIdLastPart.length - 2)))) return bad; // Last two chars not numbers.
        return good;
    }
};
var $bafaab9173a4f7a3$export$2e2bcd8739ae039 = $bafaab9173a4f7a3$var$validators;


class $6c2156d3d107af1f$var$ResourceItem extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        //
        // Field manipulation handler. Undefined 'value' field will revert to default.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (field, value)=>{
            const { resource: resource } = this.props;
            // Add/remove field to changed list if modified/reset, so it is validated or not when clicked on the perform
            // validation button.
            if (resource[field] !== value) this.setState((prevState)=>({
                    resourceFieldsChanged: prevState.resourceFieldsChanged.add(field),
                    newResource: {
                        ...this.state.newResource,
                        [field]: value
                    }
                }));
            else this.setState((prevState)=>{
                prevState.resourceFieldsChanged.delete(field);
                return {
                    resourceFieldsChanged: prevState.resourceFieldsChanged,
                    newResource: {
                        ...this.state.newResource,
                        [field]: resource[field]
                    }
                };
            });
            this.props.setResourcePatchField(field, value);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickAddInstitution", ()=>{
            this.props.navigate('/curation/#curation-institution');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickCommitChangesButton", async ()=>{
            const { state: { editResource: editResource, newResource: newResource, resourceId: resourceId, resourceFieldsChanged: resourceFieldsChanged }, props: { namespace: namespace, patchResource: patchResource, reactivateResource: reactivateResource } } = this;
            const dialogTitleCaption = editResource ? 'Confirm changes to resource' : reactivateResource ? 'Confirm reactivation' : undefined;
            const dialogTextCaption = editResource ? `Changed fields: ${[
                ...resourceFieldsChanged
            ].join(', ')}` : undefined;
            const buttonCaption = editResource ? 'edition' : reactivateResource ? 'reactivation' : undefined;
            if (editResource && resourceFieldsChanged.size === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No changes to commit');
                return;
            }
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: dialogTitleCaption,
                text: dialogTextCaption,
                confirmButtonText: `Commit ${buttonCaption}`,
                cancelButtonText: `Cancel ${buttonCaption}`
            });
            if (result.value) {
                const result = editResource ? await patchResource(resourceId, newResource) : reactivateResource ? await reactivateResource(resourceId, newResource) : undefined;
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Changes committed successfully');
                    await this.props.getResourcesFromRegistry(namespace);
                    this.setState({
                        editResource: false,
                        reactivateResource: false,
                        resourceFieldsChanged: new Set()
                    });
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error committing changes');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDiscardChangesButton", async ()=>{
            if (this.state.resourceFieldsChanged.size === 0) {
                this.setState({
                    editResource: false
                });
                return;
            }
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Are you sure?',
                text: 'All data changed will be lost',
                confirmButtonText: 'Discard changes',
                cancelButtonText: 'Continue editing'
            });
            if (result.value) this.setState({
                editResource: false,
                reactivateResource: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDeactivateButton", async ()=>{
            const { state: { resourceId: resourceId }, props: { deactivateResource: deactivateResource, namespace: namespace } } = this;
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm deactivation',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel'
            });
            if (result.value) {
                const result = await deactivateResource(resourceId);
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Resource deactivation successful');
                    await this.props.getResourcesFromRegistry(namespace);
                    this.setState({
                        editResource: false,
                        resourceFieldsChanged: new Set()
                    });
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error deactivating resource');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickValidateChangesButton", async ()=>{
            const { newResource: newResource } = this.state;
            const resourceFieldsToValidate = [
                ...this.state.resourceFieldsChanged
            ];
            if (resourceFieldsToValidate.length === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No fields have changed');
                return;
            }
            const validations = await Promise.all(resourceFieldsToValidate.map((field)=>(0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[field](newResource[field], newResource, 'resource')));
            const toastMessage = validations.filter((validations)=>!validations.valid).map((validations)=>validations.errorMessage).join('\n');
            if (toastMessage !== '') (0, $c76c78ebffccd857$export$85ee8a1f69fea720)(toastMessage, undefined, 10000);
            else (0, $c76c78ebffccd857$export$73e19c0339806233)('All fields OK!');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickEditButton", ()=>{
            this.setState({
                editResource: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickReactivateButton", async ()=>{
            this.setState({
                reactivateResource: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "dateFormatter", Intl.DateTimeFormat("en-GB"));
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "dateFormat", (dateStr)=>this.dateFormatter.format(new Date(dateStr)));
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "onlyDateFromIsoStr", (dateStr)=>dateStr ? dateStr.substring(0, 10) : dateStr);
        const params = new URLSearchParams(window.location.search);
        this.state = {
            editResource: params.get('editResource') === 'true' || false,
            reactivateResource: params.get('reactivateResource') === 'true' || false,
            resourceId: undefined,
            resourceFieldsChanged: new Set(),
            newResource: this.props.newResource
        };
    }
    async componentDidMount() {
        // Prepares model for resource patching.
        const { resource: resource } = this.props;
        const newResource = {
            providerCode: resource.providerCode,
            description: resource.description,
            urlPattern: resource.urlPattern,
            institution: resource.institution._links.self.href,
            resourceHomeUrl: resource.resourceHomeUrl,
            location: resource.location._links.self.href,
            sampleId: resource.sampleId,
            official: resource.official
        };
        this.setState({
            resourceId: resource.id,
            newResource: newResource
        });
        this.props.setResourcePatch(resource.id, newResource);
    }
    render() {
        const { handleChangeField: handleChangeField, handleClickAddInstitution: handleClickAddInstitution, handleClickCommitChangesButton: handleClickCommitChangesButton, handleClickDeactivateButton: handleClickDeactivateButton, handleClickDiscardChangesButton: handleClickDiscardChangesButton, handleClickEditButton: handleClickEditButton, handleClickReactivateButton: handleClickReactivateButton, handleClickValidateChangesButton: handleClickValidateChangesButton, props: { institutionList: institutionList, locationList: locationList, resource: resource }, state: { editResource: editResource, reactivateResource: reactivateResource, resourceId: resourceId } } = this;
        const providerCodeLabel = resource.providerCode === null || resource.providerCode.trim() === '' || resource.providerCode === 'CURATOR_REVIEW' ? 'Empty provider code' : resource.providerCode;
        const locationCountryCode = resource ? resource.location._links.self.href : undefined;
        const institutionId = resource ? resource.institution._links.self.href : undefined;
        const buttonCaption = editResource ? 'edition' : reactivateResource ? 'reactivation' : undefined;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                editResource || reactivateResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                            requiredRoles: [
                                'editResource'
                            ],
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-warning edit-button mb-1 me-2 w-20",
                                        onClick: handleClickValidateChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-tasks me-1"
                                            }),
                                            "Perform validation"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-success edit-button mb-1 me-2 w-15",
                                        onClick: handleClickCommitChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-check"
                                            }),
                                            " ",
                                            `Commit ${buttonCaption}`
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-danger edit-button mb-1 w-15",
                                        onClick: handleClickDiscardChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-times"
                                            }),
                                            " ",
                                            `Discard ${buttonCaption}`
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                            requiredRoles: [
                                'editResource'
                            ],
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-success edit-button mb-1 w-20",
                                        onClick: handleClickEditButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-edit me-1"
                                            }),
                                            "Edit resource"
                                        ]
                                    }),
                                    resource.deprecated ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-warning edit-button ms-2 mb-1 w-15",
                                        onClick: handleClickReactivateButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-caret-square-up me-1"
                                            }),
                                            "Reactivate resource"
                                        ]
                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-danger edit-button ms-2 mb-1 w-15",
                                        onClick: handleClickDeactivateButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-trash me-1"
                                            }),
                                            "Deactivate resource"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    id: `resource-${resourceId}`,
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col overflow-y-none",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm table-striped table-borderless",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("td", {
                                                rowSpan: "16",
                                                className: `w-20 align-middle ${resource.deprecated ? 'bg-danger text-white' : resource.official ? 'bg-warning' : 'bg-primary text-white'}`,
                                                children: [
                                                    resource.deprecated && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                                className: "fw-bold text-center mb-0 lh-05",
                                                                children: "DEACTIVATED"
                                                            }),
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                                className: "text-center mb-3",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                                                                    children: [
                                                                        "on ",
                                                                        (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(resource.deprecationDate).format('ll')
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                        requiredRoles: [
                                                            'editResource'
                                                        ],
                                                        fallbackComponent: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                            className: "fw-bold text-center n-0",
                                                            children: providerCodeLabel
                                                        }),
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                                    className: "text-center fw-bold m-0",
                                                                    children: "Provider code"
                                                                }),
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                    fieldName: "providerCode",
                                                                    defaultValue: resource.providerCode,
                                                                    handleChangeField: handleChangeField,
                                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                        type: "text"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                                    className: "text-center fw-bold m-0",
                                                                    children: "Primary"
                                                                }),
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                    fieldName: "official",
                                                                    defaultValue: resource.official,
                                                                    handleChangeField: handleChangeField,
                                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        className: "form-check-input"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                        className: "fw-bold text-center n-0",
                                                        children: providerCodeLabel
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                        className: "text-center m-0",
                                                        children: resource.mirId
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                        className: "fw-bold text-center m-0",
                                                        children: resource.official ? 'Primary' : ''
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium w-20 px-3",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "resourceitem-table__wide",
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.name,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "name",
                                                        defaultValue: resource.name,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : resource.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "resourceitem-table__wide",
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.description,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "description",
                                                        defaultValue: resource.description,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: "5"
                                                        })
                                                    })
                                                }) : resource.description
                                            })
                                        ]
                                    }),
                                    resource.deprecated && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "fw-medium px-3",
                                                        children: "Date of deactivation"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: this.dateFormat(resource.deprecationDate)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "px-3",
                                                        children: "Approximated expiration date"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editResource'
                                                            ],
                                                            fallbackComponent: resource.deprecationOfflineDate,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "deprecationOfflineDate",
                                                                defaultValue: this.onlyDateFromIsoStr(resource.deprecationOfflineDate),
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "date"
                                                                })
                                                            })
                                                        }) : resource.deprecationOfflineDate ? this.dateFormat(resource.deprecationOfflineDate) : "Unknown"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "fw-medium px-3",
                                                        children: "Deactivation statement"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editResource'
                                                            ],
                                                            fallbackComponent: resource.deprecationStatement,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "deprecationStatement",
                                                                defaultValue: resource.deprecationStatement,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : resource.deprecationStatement || "Not provided"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                requiredRoles: [
                                                    'editResource'
                                                ],
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                            scope: "row",
                                                            className: "fw-medium px-3",
                                                            children: "Deactivation landing page"
                                                        }),
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                            children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "renderDeprecatedLanding",
                                                                defaultValue: resource.renderDeprecatedLanding,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "form-check-input"
                                                                })
                                                            }) : resource.renderDeprecatedLanding ? "Yes" : "No"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "URL Pattern"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editResource || reactivateResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.urlPattern,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "urlPattern",
                                                        defaultValue: resource.urlPattern,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : resource.urlPattern
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3 align-middle",
                                                children: "Home URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.resourceHomeUrl,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "resourceHomeUrl",
                                                        defaultValue: resource.resourceHomeUrl,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    target: "_blank",
                                                    href: resource.resourceHomeUrl,
                                                    children: resource.resourceHomeUrl
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "Has protected URLs"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.protectedUrls,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "protectedUrls",
                                                        defaultValue: resource.protectedUrls,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "form-check-input"
                                                        })
                                                    })
                                                }) : resource.protectedUrls ? "Yes" : "No"
                                            })
                                        ]
                                    }),
                                    resource.protectedUrls && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "fw-medium px-3",
                                                        children: "Authorization help URL"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editResource'
                                                            ],
                                                            fallbackComponent: resource.authHelpUrl,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "authHelpUrl",
                                                                defaultValue: resource.authHelpUrl,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                            href: resource.authHelpUrl,
                                                            target: "_blank",
                                                            children: resource.authHelpUrl
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "fw-medium px-3",
                                                        children: "Authorization description"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editResource'
                                                            ],
                                                            fallbackComponent: resource.authHelpDescription,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "authHelpDescription",
                                                                defaultValue: resource.authHelpDescription,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                                    rows: "5"
                                                                })
                                                            })
                                                        }) : resource.authHelpDescription
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                requiredRoles: [
                                                    'editResource'
                                                ],
                                                fallbackComponent: resource.renderProtectedLanding,
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                            scope: "row",
                                                            className: "fw-medium px-3",
                                                            children: "Render protected landing"
                                                        }),
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                            children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "renderProtectedLanding",
                                                                defaultValue: resource.renderProtectedLanding,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "form-check-input"
                                                                })
                                                            }) : resource.renderProtectedLanding ? "Yes" : "No"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "px-3 fw-medium",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.location.countryName,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "location",
                                                        defaultValue: locationCountryCode,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                            className: "form-control",
                                                            value: resource.location,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select location..."
                                                                }),
                                                                locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                        value: location.id,
                                                                        children: location.label
                                                                    }, `option-${location.id}`))
                                                            ]
                                                        })
                                                    })
                                                }) : resource.location.countryName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "Sample ID (LUI)"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.sampleId,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "sampleId",
                                                        defaultValue: resource.sampleId,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                    href: resource.urlPattern.replace("{$id}", resource.sampleId),
                                                    children: [
                                                        " ",
                                                        resource.sampleId,
                                                        " "
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "Institution"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "d-flex",
                                                children: editResource ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editResource'
                                                    ],
                                                    fallbackComponent: resource.institution.name,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "institution",
                                                                defaultValue: institutionId,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                                    className: "form-control",
                                                                    value: institutionId,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: "Select institution..."
                                                                        }),
                                                                        institutionList.map((institution)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                                value: institution.id,
                                                                                children: institution.name
                                                                            }, `option-${institution.id}`))
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                                                className: "btn btn-sm btn-primary ms-2",
                                                                onClick: handleClickAddInstitution,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-plus"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }) : resource.institution.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium px-3",
                                                children: "Institution ROR ID"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "resourceitem-table__wide",
                                                children: resource.institution.rorId ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                    target: "_blank",
                                                    href: resource.institution.rorId,
                                                    children: [
                                                        " ",
                                                        resource.institution.rorId,
                                                        " "
                                                    ]
                                                }) : "Unknown"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        });
    }
}
//
// Redux Mappings
//
const $6c2156d3d107af1f$var$mapStateToProps = (state)=>({
        institutionList: state.institutionList,
        locationList: state.locationList
    });
const $6c2156d3d107af1f$var$mapDispatchToProps = (dispatch)=>({
        getResourcesFromRegistry: (namespace)=>dispatch((0, $8b8510f780f3f18d$export$64108a6f9019e30c)(namespace)),
        setResourcePatch: (id, resource)=>dispatch((0, $d4142ebfbbbc7d07$export$c9c74c77c52d09d3)(id, resource)),
        setResourcePatchField: (field, value)=>dispatch((0, $d4142ebfbbbc7d07$export$bf8f8f6ad1c6aeef)(field, value)),
        patchResource: (id, newResource)=>dispatch((0, $d4142ebfbbbc7d07$export$c6019beea7db73df)(id, newResource)),
        deactivateResource: (id)=>dispatch((0, $d4142ebfbbbc7d07$export$5f1c546ac6528127)(id)),
        reactivateResource: (id, newResource)=>dispatch((0, $d4142ebfbbbc7d07$export$74153edf9cc3bff4)(id, newResource))
    });
const $6c2156d3d107af1f$var$ConnectedResourceItem = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($6c2156d3d107af1f$var$mapStateToProps, $6c2156d3d107af1f$var$mapDispatchToProps)($6c2156d3d107af1f$var$ResourceItem);
var $6c2156d3d107af1f$export$2e2bcd8739ae039 = (props)=>{
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($6c2156d3d107af1f$var$ConnectedResourceItem, {
        ...props,
        navigate: navigate
    });
};





parcelRequire("dBNnn");
parcelRequire("atqVQ");
var $4b5af2b5aec7debd$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "row justify-content-md-center mb-3",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "col col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 bg-danger py-3  ",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h3", {
                    className: "text-center text-white mb-2",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                            className: "icon icon-common icon-trash"
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                            className: "mx-3",
                            children: [
                                " This namespace is ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "deactivated"
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                            className: "icon icon-common icon-trash"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                    className: "m-0 py-1 px-2 text-white text-center",
                    children: [
                        "The data from this namespace is, currently, either not available or supported anymore. See below for more information.",
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("br", {}),
                        "Compact identifiers still resolve as normal but we recommend that you use another namespace if you can."
                    ]
                })
            ]
        })
    });






class $56e7ce597e896584$var$NamespaceDetailsPage extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        //
        // Field manipulation handler. Undefined 'value' field will revert to default.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (field, value)=>{
            const namespace = this.props.namespaceList[0];
            // Add/remove field to changed list if modified/reset, so it is validated or not when clicked on the perform
            // validation button.
            if (namespace[field] !== value) this.setState((prevState)=>({
                    namespaceFieldsChanged: prevState.namespaceFieldsChanged.add(field),
                    newNamespace: {
                        ...this.state.newNamespace,
                        [field]: value
                    }
                }));
            else this.setState((prevState)=>{
                prevState.namespaceFieldsChanged.delete(field);
                return {
                    namespaceFieldsChanged: prevState.namespaceFieldsChanged,
                    newNamespace: {
                        ...this.state.newNamespace,
                        [field]: namespace[field]
                    }
                };
            });
            this.props.setNamespacePatchField(field, value);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickCommitChangesButton", async ()=>{
            const { state: { namespaceId: namespaceId, namespaceFieldsChanged: namespaceFieldsChanged, newNamespace: newNamespace }, props: { patchNamespace: patchNamespace } } = this;
            if (namespaceFieldsChanged.size === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No changes to commit');
                return;
            }
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm changes to namespace',
                text: `Changed fields: ${[
                    ...namespaceFieldsChanged
                ].join(', ')}`,
                confirmButtonText: 'Commit changes',
                cancelButtonText: 'Cancel'
            });
            if (result.value) {
                const result = await patchNamespace(namespaceId, newNamespace);
                if (result.ok) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Changed committed successfully');
                    await this.props.getNamespaceFromRegistry(this.props.params.prefix);
                    await this.props.getResourcesFromRegistry(this.props.namespaceList[0]);
                    this.setState({
                        editNamespace: false,
                        namespaceFieldsChanged: new Set()
                    });
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error committing changes');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDiscardChangesButton", async ()=>{
            if (this.state.namespaceFieldsChanged.size === 0) {
                this.setState({
                    editNamespace: false
                });
                return;
            }
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Are you sure?',
                text: 'All data changed will be lost',
                confirmButtonText: 'Discard changes',
                cancelButtonText: 'Continue editing'
            });
            if (result.value) this.setState({
                editNamespace: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDeactivateButton", async ()=>{
            const { state: { namespaceId: namespaceId }, props: { deactivateNamespace: deactivateNamespace } } = this;
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm deactivation',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel'
            });
            if (result.value) {
                const result = await deactivateNamespace(namespaceId);
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Namespace deactivation successful');
                    await this.props.getNamespaceFromRegistry(this.props.params.prefix);
                    await this.props.getResourcesFromRegistry(this.props.namespaceList[0]);
                    this.setState({
                        editNamespace: false,
                        namespaceFieldsChanged: new Set()
                    });
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error deactivating namespace');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickReactivateButton", async ()=>{
            const { state: { namespaceId: namespaceId }, props: { reactivateNamespace: reactivateNamespace } } = this;
            const result = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm reactivation',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel'
            });
            if (result.value) {
                const result = await reactivateNamespace(namespaceId);
                document.querySelector("#deactivationModal button.btn-close")?.click();
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Namespace reactivation successful');
                    await this.props.getNamespaceFromRegistry(this.props.params.prefix);
                    await this.props.getResourcesFromRegistry(this.props.namespaceList[0]);
                    this.setState({
                        editNamespace: false,
                        namespaceFieldsChanged: new Set()
                    });
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error reactivating namespace');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickValidateChangesButton", async ()=>{
            const { newNamespace: newNamespace } = this.state;
            const namespaceFieldsToValidate = [
                ...this.state.namespaceFieldsChanged
            ];
            if (namespaceFieldsToValidate.length === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No fields have changed');
                return;
            }
            const validations = await Promise.all(namespaceFieldsToValidate.map((field)=>(0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[field](newNamespace[field], newNamespace, 'prefix')));
            const toastMessage = validations.filter((validations)=>!validations.valid).map((validations)=>validations.errorMessage).join('\n');
            if (toastMessage !== '') (0, $c76c78ebffccd857$export$85ee8a1f69fea720)(toastMessage, undefined, 10000);
            else (0, $c76c78ebffccd857$export$73e19c0339806233)('All fields OK!');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickEditButton", ()=>{
            this.setState({
                editNamespace: true
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "dateFormatter", Intl.DateTimeFormat("en-GB"));
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "dateFormat", (dateStr)=>this.dateFormatter.format(new Date(dateStr)));
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "onlyDateFromIsoStr", (dateStr)=>dateStr ? dateStr.substring(0, 10) : dateStr);
        const params = new URLSearchParams(window.location.search);
        this.state = {
            editNamespace: params.get('editNamespace') === 'true' || false,
            namespaceId: undefined,
            namespaceFieldsChanged: new Set(),
            newNamespace: this.props.newNamespace,
            modalVisible: false
        };
    }
    async componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
        const { getNamespaceFromRegistry: getNamespaceFromRegistry, getResourcesFromRegistry: getResourcesFromRegistry, getSchemaOrgMetadataFromRegistry: getSchemaOrgMetadataFromRegistry, getStatisticsFromRegistry: getStatisticsFromRegistry, params: { prefix: prefix }, schemaOrgMetadata: schemaOrgMetadata, setNamespacePatch: setNamespacePatch } = this.props;
        await getNamespaceFromRegistry(prefix);
        await getResourcesFromRegistry(this.props.namespaceList[0]);
        // await getStatisticsFromRegistry(this.props.namespaceList[0]);
        // Prepares model for namespace patching.
        const { resources: resources, _links: _links, ...newNamespace } = this.props.namespaceList[0];
        const namespaceId = _links.self.href.split('/').pop();
        this.setState({
            namespaceId: namespaceId,
            newNamespace: newNamespace
        });
        setNamespacePatch(namespaceId, newNamespace);
        // Get Schema.org Metadata and append it to the document's head.
        if (!schemaOrgMetadata.dataset || schemaOrgMetadata.dataset && schemaOrgMetadata.dataset.name !== this.props.namespaceList[0].name) getSchemaOrgMetadataFromRegistry(namespaceId);
    }
    async componentWillUnmount() {
        const { getSchemaOrgMetadataFromRegistry: getSchemaOrgMetadataFromRegistry } = this.props;
        // Get Schema.org Metadata for the platform and append it to the document's head.
        await getSchemaOrgMetadataFromRegistry();
    }
    render() {
        const { handleChangeField: handleChangeField, handleClickCommitChangesButton: handleClickCommitChangesButton, handleClickDiscardChangesButton: handleClickDiscardChangesButton, handleClickDeactivateButton: handleClickDeactivateButton, handleClickEditButton: handleClickEditButton, handleClickReactivateButton: handleClickReactivateButton, handleClickValidateChangesButton: handleClickValidateChangesButton, state: { editNamespace: editNamespace } } = this;
        const namespace = this.props.namespaceList[0];
        let namespaceEffectivePrefix = '';
        if (namespace) {
            namespaceEffectivePrefix = namespace.prefix;
            if (namespace.namespaceEmbeddedInLui) {
                // This is necessary to enforce that the actual prefix matches the pattern
                const startPositionPrefix = namespace.pattern[0] === '^' ? 1 : 0;
                namespaceEffectivePrefix = namespace.pattern.slice(startPositionPrefix, namespace.pattern.indexOf(":"));
                if (namespaceEffectivePrefix.toLowerCase() != namespace.prefix) //if the effective prefix is still resolvable
                namespaceEffectivePrefix = namespace.prefix;
            }
        }
        const sampleUrl = namespace ? `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).satelliteUrl}/${namespaceEffectivePrefix}:${namespace.sampleId}` : '';
        return !namespace ? '' // Placeholder for empty/not found.
         : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                    icon: "icon-leaf",
                    title: "Namespace:",
                    extraTitle: namespace.name
                }),
                namespace.deprecated && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $4b5af2b5aec7debd$export$2e2bcd8739ae039), {
                    namespace: namespace
                }),
                editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                            requiredRoles: [
                                'editNamespace'
                            ],
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-warning edit-button me-2",
                                        onClick: handleClickValidateChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-tasks me-1"
                                            }),
                                            "Perform validation"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-success edit-button me-2",
                                        onClick: handleClickCommitChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-check"
                                            }),
                                            " Commit changes"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-danger edit-button",
                                        onClick: handleClickDiscardChangesButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-times"
                                            }),
                                            " Discard changes"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                            requiredRoles: [
                                'editNamespace'
                            ],
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-success edit-button",
                                        onClick: handleClickEditButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-edit me-1"
                                            }),
                                            "Edit namespace"
                                        ]
                                    }),
                                    namespace.deprecated ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-warning edit-button ms-2",
                                        onClick: handleClickReactivateButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-caret-square-up me-1"
                                            }),
                                            "Reactivate namespace"
                                        ]
                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        className: "btn btn-sm btn-danger edit-button ms-2",
                                        onClick: handleClickDeactivateButton,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-trash me-1"
                                            }),
                                            "Deactivate namespace"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-info"
                                }),
                                " General Information"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mb-3",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm table-striped table-borderless",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "w-35 fw-medium",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editNamespace'
                                                    ],
                                                    fallbackComponent: namespace.name,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "name",
                                                        defaultValue: namespace.name,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : namespace.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editNamespace'
                                                    ],
                                                    fallbackComponent: namespace.description,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "description",
                                                        defaultValue: namespace.description,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: "5"
                                                        })
                                                    })
                                                }) : namespace.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Local Unique Identifier (LUI) pattern"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editNamespace'
                                                    ],
                                                    fallbackComponent: namespace.pattern,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "pattern",
                                                        defaultValue: namespace.pattern,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : namespace.pattern
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Prefix embedded in LUI"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editNamespace'
                                                    ],
                                                    fallbackComponent: namespace.namespaceEmbeddedInLui,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "namespaceEmbeddedInLui",
                                                        defaultValue: namespace.namespaceEmbeddedInLui,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "form-check-input"
                                                        })
                                                    })
                                                }) : namespace.namespaceEmbeddedInLui ? "Yes" : "No"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Legacy registry identifier"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: namespace.mirId
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                namespace.deprecated && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "col",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-trash"
                                        }),
                                        " Deactivation information"
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "row mb-3",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "col overflow-y-none",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                    className: "table table-sm table-striped table-borderless",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "w-35 fw-medium",
                                                        children: "Date of deactivation"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: this.dateFormat(namespace.deprecationDate)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                        scope: "row",
                                                        className: "fw-medium",
                                                        children: [
                                                            "Approximated expiration date",
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                                className: "ms-1",
                                                                title: "Approximation of when this collection went offline",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-question-circle"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editNamespace'
                                                            ],
                                                            fallbackComponent: namespace.deprecationOfflineDate,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "deprecationOfflineDate",
                                                                defaultValue: this.onlyDateFromIsoStr(namespace.deprecationOfflineDate),
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "date"
                                                                })
                                                            })
                                                        }) : namespace.deprecationOfflineDate ? this.dateFormat(namespace.deprecationOfflineDate) : "Unknown"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                        scope: "row",
                                                        className: "fw-medium",
                                                        children: "Deactivation statement"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editNamespace'
                                                            ],
                                                            fallbackComponent: namespace.deprecationStatement,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "deprecationStatement",
                                                                defaultValue: namespace.deprecationStatement,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : namespace.deprecationStatement ? namespace.deprecationStatement : "Not provided"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                        scope: "row",
                                                        className: "fw-medium",
                                                        children: [
                                                            "Data acquisition",
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                                className: "ms-1",
                                                                title: "Instructions on how to currently access data",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-question-circle"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editNamespace'
                                                            ],
                                                            fallbackComponent: namespace.infoOnPostmortemAccess,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "infoOnPostmortemAccess",
                                                                defaultValue: namespace.infoOnPostmortemAccess,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : namespace.infoOnPostmortemAccess ? namespace.infoOnPostmortemAccess : "Not available"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("th", {
                                                        scope: "row",
                                                        className: "fw-medium",
                                                        children: [
                                                            "Succeeding namespace",
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                                className: "ms-1",
                                                                title: "Namespace that currently handles data of this namespace",
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                                    className: "icon icon-common icon-question-circle"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editNamespace'
                                                            ],
                                                            fallbackComponent: namespace.successor,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "successor",
                                                                defaultValue: namespace.successor,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : namespace.successor ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                            href: `/registry/${namespace.successor}`,
                                                            children: namespace.successor
                                                        }) : "Not available"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                requiredRoles: [
                                                    'editNamespace'
                                                ],
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                            scope: "row",
                                                            className: "fw-medium",
                                                            children: " Deactivation landing page "
                                                        }),
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                            children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "renderDeprecatedLanding",
                                                                defaultValue: namespace.renderDeprecatedLanding,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "checkbox",
                                                                    className: "form-check-input"
                                                                })
                                                            }) : namespace.renderDeprecatedLanding ? "Yes" : "No"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-barcode"
                                }),
                                " Identification schemes"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mb-3",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col overflow-y-none",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm table-striped table-borderless",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "w-35 fw-medium",
                                                children: "Prefix"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: namespaceEffectivePrefix
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Registry URI"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                    href: (0, $f5375947831a300f$export$e506a1d27d1eaa20).baseUrl + "registry/" + namespace.prefix,
                                                    target: "_blank",
                                                    children: [
                                                        (0, $f5375947831a300f$export$e506a1d27d1eaa20).baseUrl,
                                                        "registry/",
                                                        namespace.prefix
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Sample URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: sampleUrl,
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    children: sampleUrl
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Sample Compact identifier"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("td", {
                                                children: [
                                                    namespaceEffectivePrefix,
                                                    ":",
                                                    namespace.sampleId
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                                scope: "row",
                                                className: "fw-medium",
                                                children: "Sample ID (LUI)"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                children: editNamespace ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                    requiredRoles: [
                                                        'editNamespace'
                                                    ],
                                                    fallbackComponent: namespace.sampleId,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "sampleId",
                                                        defaultValue: namespace.sampleId,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                }) : namespace.sampleId
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-cubes"
                                }),
                                " Resources"
                            ]
                        })
                    })
                }),
                !namespace.resources && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: namespace.resources === undefined ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {
                            noText: true,
                            noCenter: true
                        }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            children: "No resources."
                        })
                    })
                }) || namespace.resources.sort((a, b)=>{
                    // Official resources always go first.
                    if (b.official - a.official !== 0) return b.official - a.official;
                    // Deprecated resources always go last.
                    if (a.deprecated - b.deprecated !== 0) return a.deprecated - b.deprecated;
                    // CURATOR_REVIEW provider code resources always go last.
                    if (a.providerCode === 'CURATOR_REVIEW' && b.providerCode !== 'CURATOR_REVIEW') return 1;
                    if (a.providerCode !== 'CURATOR_REVIEW' && b.providerCode === 'CURATOR_REVIEW') return -1;
                    return a.providerCode > b.providerCode ? 1 : a.providerCode < b.providerCode ? -1 : 0;
                }).map((resource)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $6c2156d3d107af1f$export$2e2bcd8739ae039), {
                        namespace: namespace,
                        resource: resource
                    }, `resource-${resource.mirId}`))
            ]
        });
    }
}
// Mapping
const $56e7ce597e896584$var$mapStateToProps = (state)=>{
    return {
        namespaceList: state.registryBrowser.namespaceList,
        newNamespace: state.curationEditNamespace,
        schemaOrgMetadata: state.schemaOrgMetadata
    };
};
const $56e7ce597e896584$var$mapDispatchToProps = (dispatch)=>({
        getNamespaceFromRegistry: (prefix)=>dispatch((0, $8b8510f780f3f18d$export$3b780324579b3b93)(prefix)),
        getResourcesFromRegistry: (namespace)=>dispatch((0, $8b8510f780f3f18d$export$64108a6f9019e30c)(namespace)),
        getStatisticsFromRegistry: (namespace)=>dispatch((0, $8b8510f780f3f18d$export$bf0556f234ffb64e)(namespace)),
        getSchemaOrgMetadataFromRegistry: (namespaceId)=>dispatch((0, $8a5c3ddb423770e6$export$78572dfc0a558ba6)(namespaceId)),
        setNamespacePatch: (id, namespace)=>dispatch((0, $3bf8418b78fef910$export$38419f492887c415)(id, namespace)),
        setNamespacePatchField: (field, value)=>dispatch((0, $3bf8418b78fef910$export$134268c9d8a064b8)(field, value)),
        patchNamespace: (id, newNamespace)=>dispatch((0, $3bf8418b78fef910$export$dabb953a55f6d1a8)(id, newNamespace)),
        deactivateNamespace: (id)=>dispatch((0, $3bf8418b78fef910$export$7d3d3a092ec0a75e)(id)),
        reactivateNamespace: (id)=>dispatch((0, $3bf8418b78fef910$export$60da897e5bfcc5bc)(id))
    });
const $56e7ce597e896584$var$ConnectedNamespaceDetailsPage = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($56e7ce597e896584$var$mapStateToProps, $56e7ce597e896584$var$mapDispatchToProps)($56e7ce597e896584$var$NamespaceDetailsPage);
function $56e7ce597e896584$export$2e2bcd8739ae039(props) {
    const params = (0, $bfdf1f7a109a1ee5$export$99eaa27ddbbb95ef)();
    const matomo = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($56e7ce597e896584$var$ConnectedNamespaceDetailsPage, {
        ...props,
        matomo: matomo,
        params: params
    });
}



parcelRequire("dBNnn");


const $d3c14c44ca61ec4e$var$AccountPage = ({ auth: auth })=>{
    if (!auth.keycloak.tokenParsed) return '';
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-user",
                title: "Account details"
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("h4", {
                            children: "Name"
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            children: auth.keycloak.tokenParsed.name
                        })
                    ]
                })
            })
        ]
    });
};
//
// Redux mappings.
//
const $d3c14c44ca61ec4e$var$mapStateToProps = (state)=>({
        auth: state.auth
    });
var $d3c14c44ca61ec4e$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($d3c14c44ca61ec4e$var$mapStateToProps)($d3c14c44ca61ec4e$var$AccountPage);



parcelRequire("dBNnn");


const $893ee9eaeec49a6c$var$NotFoundPage = ()=>{
    const { trackPageView: trackPageView } = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    trackPageView();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        children: [
            "404 - ",
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                to: "/",
                children: "Go home"
            })
        ]
    });
};
var $893ee9eaeec49a6c$export$2e2bcd8739ae039 = $893ee9eaeec49a6c$var$NotFoundPage;



parcelRequire("dBNnn");




var $dBNnn = parcelRequire("dBNnn");





var $dBNnn = parcelRequire("dBNnn");

var $atqVQ = parcelRequire("atqVQ");


parcelRequire("dBNnn");
// Data is assumed to be the namespace registration request
const $15915c864f56169e$var$getSampleUrl = (data)=>data.providerUrlPattern.replace("{$id}", data.sampleId);
const $15915c864f56169e$var$PrefixRegistrationSessionRequestDetails = ({ data: data })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-leaf"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Prefix details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Resource name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Requested prefix"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.requestedPrefix
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Regex pattern"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.idRegexPattern
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Supporting references"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.supportingReferences
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Additional information"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.additionalInformation
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-sitemap"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Institution details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "ROR Id"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionRorId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.institutionDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Home URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionHomeUrl
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-cube"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Provider details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.providerDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Home URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: data.providerHomeUrl,
                                                    children: data.providerHomeUrl
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Provider code"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerCode
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "URL Pattern"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerUrlPattern
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Has protected URLs?"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.protectedUrls ? "Yes" : "No"
                                            })
                                        ]
                                    }),
                                    data.protectedUrls && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-25 ps-2 fw-bold",
                                                        children: "Render protected landing"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-75 text-block",
                                                        children: data.renderProtectedLanding ? "Yes" : "No"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-25 ps-2 fw-bold",
                                                        children: "Auth help"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-75 text-block small",
                                                        children: data.authHelpDescription || ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-25 ps-2 fw-bold",
                                                        children: "Auth help URL"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-75 text-block",
                                                        children: data.authHelpUrl || ""
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Sample Id"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: $15915c864f56169e$var$getSampleUrl(data),
                                                    children: data.sampleId
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-user"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Requester details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Full name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.requesterName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: `mailto:${data.requesterEmail}`,
                                                    children: data.requesterEmail
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
var $15915c864f56169e$export$2e2bcd8739ae039 = $15915c864f56169e$var$PrefixRegistrationSessionRequestDetails;


class $0b52d5295e59372b$var$PrefixRegistrationSessionItem extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "toggle", ()=>{
            this.setState((state)=>({
                    expanded: !state.expanded
                }));
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { id: id, prefixRegistrationRequest: prefixRegistrationRequest } = this.props.request;
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-header",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-10 col-lg-9 col-xl-10",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                        className: "clear-link",
                                        href: "#!",
                                        onClick: this.toggle,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                                className: "m-0",
                                                children: [
                                                    expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-minus me-2"
                                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-plus me-2"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                        children: "Requested Prefix: "
                                                    }),
                                                    prefixRegistrationRequest.requestedPrefix
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                className: "m-0 ps-2 text-small text-muted",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "Date of original request: "
                                                        }),
                                                        (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(prefixRegistrationRequest.created).format('llll')
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-2 col-lg-3 col-xl-2 pt-2",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                                        className: "clear-link btn btn-warning w-100",
                                        to: `/curation/prefixRegistration/${id}`,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-ellipsis-h"
                                            }),
                                            " Manage"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $15915c864f56169e$export$2e2bcd8739ae039), {
                            data: prefixRegistrationRequest
                        })
                    })
                ]
            })
        });
    }
}
var $0b52d5295e59372b$export$2e2bcd8739ae039 = $0b52d5295e59372b$var$PrefixRegistrationSessionItem;


// Config.



//
// RegistrationSessionListParms actions.
//
// Redux store update for registration session list page params.
const $0e0f5b591af49dee$export$245672a997f95000 = (page, registrationSessionType)=>{
    return {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONLISTPARAMS`,
        page: page
    };
};


const $fab8772b27b16289$export$6e6fa9c7985b117e = (params, registrationSessionType)=>{
    return async (dispatch, getState)=>{
        const requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/${registrationSessionType}RegistrationSessions/search/findByClosedFalse`);
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        let data;
        Object.keys(params).forEach((param)=>{
            requestUrl.searchParams.append(param, params[param]);
        });
        try {
            const response = await fetch(requestUrl, init);
            data = await response.json();
        } catch (err) {
            console.error(`Error fetching ${registrationSessionType} registration request list: `, err);
            return;
        }
        await dispatch((0, $0e0f5b591af49dee$export$245672a997f95000)(data.page, registrationSessionType));
        const registrationRequests = await Promise.all(data._embedded[`${registrationSessionType}RegistrationSessions`].map((pfs)=>{
            let { _links: _links, ...newResource } = pfs;
            // Store id for curation requests.
            newResource['id'] = _links.self.href.split('/').pop();
            return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(newResource, [
                {
                    name: `${registrationSessionType}RegistrationRequest`,
                    url: _links[`${registrationSessionType}RegistrationRequest`].href
                }
            ], init);
        }));
        dispatch($fab8772b27b16289$export$7383307fc801ce8e(registrationRequests, registrationSessionType));
        return data;
    };
};
const $fab8772b27b16289$export$7383307fc801ce8e = (registrationSessionList, registrationSessionType)=>{
    return {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONLIST`,
        registrationSessionList: registrationSessionList
    };
};



// Assumes all fields are in paramsA.
const $a1a49588f2037639$export$9b26f48118e31e4d = (paramsA, paramsB)=>!Object.keys(paramsA).map((field)=>paramsA[field] === paramsB[field]).includes(false);


class $92ca162474bc98bd$var$PrefixRegistrationSessionList extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updatePrefixRegistrationSessionList", (params)=>{
            this.props.getPrefixRegistrationSessionList(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSetSize", (e)=>{
            const size = parseInt(e.target.value);
            const number = 0;
            this.props.setPrefixregistrationSessionListParams({
                size: size,
                number: number
            });
            this.updatePrefixRegistrationSessionList({
                size: size
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "navigate", (number)=>{
            const params = {
                ...this.props.prefixRegistrationSessionListParams,
                number: number
            };
            this.props.setPrefixregistrationSessionListParams(params);
        });
    }
    componentDidMount() {
        this.updatePrefixRegistrationSessionList(this.props.prefixRegistrationSessionListParams);
    }
    componentDidUpdate(prevProps) {
        if (!(0, $a1a49588f2037639$export$9b26f48118e31e4d)(this.props.prefixRegistrationSessionListParams, prevProps.prefixRegistrationSessionListParams)) {
            const params = {
                page: this.props.prefixRegistrationSessionListParams.number,
                size: this.props.prefixRegistrationSessionListParams.size
            };
            this.updatePrefixRegistrationSessionList(params);
        }
    }
    render() {
        const { handleSetSize: handleSetSize, navigate: navigate, props: { prefixRegistrationSessionListParams: { number: number, size: size, totalElements: totalElements, totalPages: totalPages }, prefixRegistrationSessionList: prefixRegistrationSessionList } } = this;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $54e37c13f6fd63e4$export$2e2bcd8739ae039), {
                    navigate: navigate,
                    number: number,
                    setSize: handleSetSize,
                    size: size,
                    totalElements: totalElements,
                    totalPages: totalPages
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row justify-content-md-center mt-2",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: prefixRegistrationSessionList.length === 0 ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            children: "No pending prefix registration requests"
                        }) : prefixRegistrationSessionList.map((data)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b52d5295e59372b$export$2e2bcd8739ae039), {
                                request: data
                            }, `prr-${data.prefixRegistrationRequest.requestedPrefix}-${data.created}`))
                    })
                })
            ]
        });
    }
}
// Mapping
const $92ca162474bc98bd$var$mapStateToProps = (state)=>({
        prefixRegistrationSessionList: state.curationDashboard.prefixRegistrationSessionList,
        prefixRegistrationSessionListParams: state.curationDashboard.prefixRegistrationSessionListParams
    });
const $92ca162474bc98bd$var$mapDispatchToProps = (dispatch)=>({
        getPrefixRegistrationSessionList: (params)=>dispatch((0, $fab8772b27b16289$export$6e6fa9c7985b117e)(params, 'prefix')),
        setPrefixregistrationSessionListParams: (params)=>dispatch((0, $0e0f5b591af49dee$export$245672a997f95000)(params, 'prefix'))
    });
var $92ca162474bc98bd$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($92ca162474bc98bd$var$mapStateToProps, $92ca162474bc98bd$var$mapDispatchToProps)($92ca162474bc98bd$var$PrefixRegistrationSessionList);





var $dBNnn = parcelRequire("dBNnn");





var $dBNnn = parcelRequire("dBNnn");

var $atqVQ = parcelRequire("atqVQ");


parcelRequire("dBNnn");
// Data is assumed to be the resource registration request
const $16a9df20d48176e0$var$getSampleUrl = (data)=>data.providerUrlPattern.replace("{$id}", data.sampleId);
const $16a9df20d48176e0$var$ResourceRegistrationSessionRequestDetails = ({ data: data })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-leaf"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Prefix details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tbody", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                            className: "w-25 ps-2 fw-bold",
                                            children: "Resource prefix"
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                            className: "w-75 text-block",
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                href: `https://identifiers.org/${data.namespacePrefix}`,
                                                children: data.namespacePrefix
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-sitemap"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Institution details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "ROR Id"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionRorId
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.institutionDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Home URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionHomeUrl
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.institutionLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-cube"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Provider details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "description"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block small align-middle",
                                                children: data.providerDescription
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Home URL"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: data.providerHomeUrl,
                                                    children: data.providerHomeUrl
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Provider code"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerCode
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "URL Pattern"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerUrlPattern
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Sample Id"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: $16a9df20d48176e0$var$getSampleUrl(data),
                                                    children: data.sampleId
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Location"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.providerLocation
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-4 col-lg-3 col-xl-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-user"
                                }),
                                " ",
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                    children: "Requester details"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-sm-8 col-lg-9 col-xl-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                            className: "table table-sm m-0 table-borderless table-striped",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Full name"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: data.requesterName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 ps-2 fw-bold",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75 text-block",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                                    href: `mailto:${data.requesterEmail}`,
                                                    children: data.requesterEmail
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
var $16a9df20d48176e0$export$2e2bcd8739ae039 = $16a9df20d48176e0$var$ResourceRegistrationSessionRequestDetails;


class $a14486d5fa2bcf35$var$ResourceRegistrationSessionItem extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "toggle", ()=>{
            this.setState((state)=>({
                    expanded: !state.expanded
                }));
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { id: id, resourceRegistrationRequest: resourceRegistrationRequest } = this.props.request;
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-header",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-10 col-lg-9 col-xl-10",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                        className: "clear-link",
                                        href: "#!",
                                        onClick: this.toggle,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                                className: "m-0",
                                                children: [
                                                    expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-minus me-2"
                                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-plus me-2"
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                        children: "Requested Resource: "
                                                    }),
                                                    "Provider ",
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                        children: resourceRegistrationRequest.providerCode
                                                    }),
                                                    " for namespace ",
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                        children: resourceRegistrationRequest.namespacePrefix
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                                className: "m-0 ps-2 text-small text-muted",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "Date of original request: "
                                                        }),
                                                        (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(resourceRegistrationRequest.created).format('llll')
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-2 col-lg-3 col-xl-2 pt-2",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                                        className: "clear-link btn btn-warning w-100",
                                        to: `/curation/resourceRegistration/${id}`,
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-ellipsis-h"
                                            }),
                                            " Manage"
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $16a9df20d48176e0$export$2e2bcd8739ae039), {
                            data: resourceRegistrationRequest
                        })
                    })
                ]
            })
        });
    }
}
var $a14486d5fa2bcf35$export$2e2bcd8739ae039 = $a14486d5fa2bcf35$var$ResourceRegistrationSessionItem;





class $b474856d389dda4b$var$ResourceRegistrationSessionList extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updateResourceRegistrationSessionList", (params)=>{
            this.props.getResourceRegistrationSessionList(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSetSize", (e)=>{
            const size = parseInt(e.target.value);
            const number = 0;
            this.props.setResourceRegistrationSessionListParams({
                size: size,
                number: number
            });
            this.updateResourceRegistrationSessionList({
                size: size
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "navigate", (number)=>{
            const params = {
                ...this.props.resourceRegistrationSessionListParams,
                number: number
            };
            this.props.setResourceRegistrationSessionListParams(params);
        });
    }
    componentDidMount() {
        this.updateResourceRegistrationSessionList(this.props.resourceRegistrationSessionListParams);
    }
    componentDidUpdate(prevProps) {
        if (!(0, $a1a49588f2037639$export$9b26f48118e31e4d)(this.props.resourceRegistrationSessionListParams, prevProps.resourceRegistrationSessionListParams)) {
            const params = {
                page: this.props.resourceRegistrationSessionListParams.number,
                size: this.props.resourceRegistrationSessionListParams.size
            };
            this.updateResourceRegistrationSessionList(params);
        }
    }
    render() {
        const { handleSetSize: handleSetSize, navigate: navigate, props: { resourceRegistrationSessionListParams: { number: number, size: size, totalElements: totalElements, totalPages: totalPages }, resourceRegistrationSessionList: resourceRegistrationSessionList } } = this;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $54e37c13f6fd63e4$export$2e2bcd8739ae039), {
                    navigate: navigate,
                    number: number,
                    setSize: handleSetSize,
                    size: size,
                    totalElements: totalElements,
                    totalPages: totalPages
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row justify-content-md-center mt-2",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: resourceRegistrationSessionList.length === 0 ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            children: "No pending resource registration requests"
                        }) : resourceRegistrationSessionList.map((data)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $a14486d5fa2bcf35$export$2e2bcd8739ae039), {
                                request: data
                            }, `prr-${data.resourceRegistrationRequest.providerCode}-${data.created}`))
                    })
                })
            ]
        });
    }
}
// Mapping
const $b474856d389dda4b$var$mapStateToProps = (state)=>({
        resourceRegistrationSessionList: state.curationDashboard.resourceRegistrationSessionList,
        resourceRegistrationSessionListParams: state.curationDashboard.resourceRegistrationSessionListParams
    });
const $b474856d389dda4b$var$mapDispatchToProps = (dispatch)=>({
        getResourceRegistrationSessionList: (params)=>dispatch((0, $fab8772b27b16289$export$6e6fa9c7985b117e)(params, 'resource')),
        setResourceRegistrationSessionListParams: (params)=>dispatch((0, $0e0f5b591af49dee$export$245672a997f95000)(params, 'resource'))
    });
var $b474856d389dda4b$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($b474856d389dda4b$var$mapStateToProps, $b474856d389dda4b$var$mapDispatchToProps)($b474856d389dda4b$var$ResourceRegistrationSessionList);




var $dBNnn = parcelRequire("dBNnn");




var $dBNnn = parcelRequire("dBNnn");




var $dBNnn = parcelRequire("dBNnn");


var $dBNnn = parcelRequire("dBNnn");

var $f41f3359367a57bb$export$2e2bcd8739ae039 = new Intl.DateTimeFormat('en', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});



var $d03f74b61e337a30$export$2e2bcd8739ae039 = ({ href: href, preload: preload })=>{
    const [loading, setLoading] = (0, $dBNnn.useState)(null);
    const [failed, setFailed] = (0, $dBNnn.useState)(false);
    const [expanded, setExpanded] = (0, $dBNnn.useState)(Boolean(preload));
    const [eventList, setEventList] = (0, $dBNnn.useState)([]);
    (0, $dBNnn.useEffect)(()=>{
        if ((preload || expanded) && loading === null) {
            const fn = async ()=>{
                setLoading(true);
                const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
                const init = {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                };
                fetch(href, init).then((response)=>response.json()).then((json)=>setEventList(json._embedded?.curationWarningEvents.slice(0, 5))).catch(()=>setFailed(true)).finally(()=>setLoading(false));
            };
            fn();
        }
    }, [
        expanded,
        preload,
        setLoading,
        setEventList,
        setFailed
    ]);
    if (loading) return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        children: [
            " ",
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {
                compact: true,
                noText: true,
                noCenter: true
            }),
            " "
        ]
    });
    if (failed) return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "alert-danger alert",
        children: " Failed get list of events for this warning! "
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        children: [
            !preload && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                type: "button",
                className: "btn btn-link text-decoration-none text-reset p-0 px-1 mt-2 mb-0",
                onClick: ()=>{
                    setExpanded(!expanded);
                },
                children: expanded ? "Hide history" : "See history"
            }),
            expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                className: "table table-striped",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tbody", {
                    children: eventList.map((e, idx)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                    children: e.type
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                    children: (0, $f41f3359367a57bb$export$2e2bcd8739ae039).format(new Date(e.created))
                                })
                            ]
                        }, idx))
                })
            })
        ]
    });
};





const $1a84e21940da008e$var$CurationWarningDetails = ({ curationWarningInit: curationWarningInit })=>{
    const [curationWarning, setCurationWarning] = (0, $dBNnn.useState)(curationWarningInit);
    const [expanded, setExpanded] = (0, $dBNnn.useState)(false);
    const isDisabled = curationWarning?.latestEvent?.type === "DISABLED";
    const renewCurationWarning = (0, $dBNnn.useCallback)(async (token)=>{
        const init = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        };
        await fetch(curationWarning._links.self.href, init).then(async (response)=>{
            if (response.ok) {
                const renewedCurationWarning = await response.json();
                setCurationWarning(renewedCurationWarning);
                setExpanded(false); // Lazy way to force refresh
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not renew information: ' + reason
            });
        }, async (reason1)=>{
            await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not renew information: ' + reason1
            });
        });
    }, [
        isDisabled,
        curationWarning
    ]);
    const toggleDisabledStatus = (0, $dBNnn.useCallback)(async ()=>{
        const cwId = curationWarning._links.self.href.split('/').pop();
        const endpoint = isDisabled ? "/curationApi/enable?" : "/curationApi/disable?";
        const params = new URLSearchParams({
            id: cwId
        });
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        await fetch((0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + endpoint + params, init).then(async (response)=>{
            if (response.ok) await renewCurationWarning(authToken);
            else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not change status: HTTP response ' + response.status
            });
        }, async (reason1)=>{
            await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not change status: ' + reason1
            });
        });
    }, [
        isDisabled,
        curationWarning,
        renewCurationWarning
    ]);
    const showMoreInfo = ![
        "curator-review"
    ].includes(curationWarning.type);
    const bgClass = isDisabled ? " bg-danger-subtle" : "";
    const txtClass = isDisabled ? " text-decoration-line-through" : "";
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        className: "card mb-2",
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: `card-header d-flex p-1 px-3${bgClass}`,
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                        className: `btn btn-link text-decoration-none text-reset text-start p-0 me-2 flex-grow-1${txtClass}`,
                        onClick: ()=>setExpanded(!expanded),
                        children: [
                            expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                className: "icon icon-common icon-caret-up me-1"
                            }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                className: "icon icon-common icon-caret-down me-1"
                            }),
                            $1a84e21940da008e$var$getLabelFor(curationWarning)
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                        className: `btn btn-sm rounded-pill py-0 btn-${isDisabled ? "success" : "danger"}`,
                        onClick: toggleDisabledStatus,
                        children: isDisabled ? "Enable" : "Disable"
                    })
                ]
            }),
            expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card-body p-1 px-3",
                children: [
                    showMoreInfo && $1a84e21940da008e$var$getDescriptionFor(curationWarning),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $d03f74b61e337a30$export$2e2bcd8739ae039), {
                        href: curationWarning._links.events.href,
                        preload: !showMoreInfo
                    })
                ]
            })
        ]
    });
};
var $1a84e21940da008e$export$2e2bcd8739ae039 = $1a84e21940da008e$var$CurationWarningDetails;
const $1a84e21940da008e$var$kebabCaseToSpaceSeparated = (str)=>{
    const fieldName = str.replaceAll("-", " ");
    return String(fieldName).charAt(0).toUpperCase() + String(fieldName).slice(1);
};
const $1a84e21940da008e$var$getLabelFor = (cw)=>{
    switch(cw.type){
        case "curator-review":
            const fieldName = $1a84e21940da008e$var$kebabCaseToSpaceSeparated(cw['moreDetails']['field-name']);
            return `${fieldName} value is empty or set to CURATOR_REVIEW`;
        case "wikidata-institution-diff":
            return "Possible discrepancy with Wikidata";
        case "url-not-ok":
            return "Invalid response from URL";
        case "low-availability-resource":
            return "Resource URL measuring low availability";
        default:
            return cw.type;
    }
};
const $1a84e21940da008e$var$getDescriptionFor = (cw)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
        className: "table table-striped mb-0",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tbody", {
            children: Object.entries(cw.moreDetails).map(([key, value], idx)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                            children: $1a84e21940da008e$var$kebabCaseToSpaceSeparated(key)
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($1a84e21940da008e$var$AnchorOrText, {
                                str: value
                            })
                        })
                    ]
                }, idx))
        })
    });
const $1a84e21940da008e$var$AnchorOrText = (props)=>{
    if (props.str.startsWith("http")) return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
        href: props.str,
        children: props.str
    });
    else return props.str;
};




const $7a8071c80d951b19$var$allSettledAndSuccessfulJsons = (fetches)=>Promise.allSettled(fetches).then((results)=>results.filter((r)=>r.status === "fulfilled" && r.value.status === 200)).then((results)=>Promise.all(results.map((r)=>r.value.json())));
var $7a8071c80d951b19$export$2e2bcd8739ae039 = ({ selectedTarget: selectedTarget, modalId: modalId, editHref: editHref })=>{
    const [loading, setLoading] = (0, $dBNnn.useState)(null);
    const [failed, setFailed] = (0, $dBNnn.useState)(false);
    const [curationWarnings, setCurationWarnings] = (0, $dBNnn.useState)([]);
    (0, $dBNnn.useEffect)(()=>{
        const fn = async ()=>{
            if (loading !== true && selectedTarget) {
                setLoading(true);
                setCurationWarnings([]);
                const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
                const init = {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                };
                const targetUrl = selectedTarget.type === 'Institution' ? (0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + `/restApi/institutions/` + selectedTarget.identifier : (0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + `/restApi/namespaces/search/findByPrefix?prefix=` + selectedTarget.identifier;
                fetch(targetUrl, init).then((response)=>response.json()).then((target)=>{
                    const directCws = fetch(target._links.curationWarnings.href, init);
                    if (selectedTarget.type === 'Prefix') // Fetch CW under namespace and under its resources
                    fetch(target._links.resources.href, init).then((resp)=>resp.json()).then((resources)=>{
                        const cwPromises = [
                            directCws,
                            ...resources._embedded.resources.map((res)=>fetch(res._links.curationWarnings.href, init))
                        ];
                        $7a8071c80d951b19$var$allSettledAndSuccessfulJsons(cwPromises).then((jsons)=>jsons.flatMap((json)=>json._embedded.curationWarnings)).then((warnings)=>warnings.filter((cw)=>cw.open)).then((warnings)=>setCurationWarnings(warnings)).catch(()=>setFailed(true)).finally(()=>setLoading(false));
                    }).catch(()=>setFailed(true));
                    else directCws.then((response)=>response.json()).then((json)=>{
                        setCurationWarnings(json._embedded.curationWarnings);
                        setFailed(false);
                    }).catch(()=>setFailed(true)).finally(()=>setLoading(false));
                }).catch(()=>setFailed(true));
            }
        };
        fn();
    }, [
        selectedTarget,
        setFailed,
        setLoading,
        setCurationWarnings
    ]);
    let body;
    if (!selectedTarget) body = /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {});
    else if (loading) body = /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {
        noText: true
    });
    else if (failed) body = /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "alert alert-danger",
        children: " Failed to get warnings! "
    });
    else body = curationWarnings.map((cw, idx)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $1a84e21940da008e$export$2e2bcd8739ae039), {
            curationWarningInit: cw,
            targetInfo: selectedTarget
        }, idx));
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "modal",
        id: modalId,
        tabIndex: -1,
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            className: "modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable",
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "modal-content",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "modal-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h6", {
                                className: "modal-title",
                                children: [
                                    "Open warnings for ",
                                    selectedTarget?.label,
                                    " (",
                                    selectedTarget?.identifier,
                                    ")",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b08650187def67b8$export$a6c7ac8248d6e38a), {
                                        to: editHref,
                                        target: "_blank",
                                        className: "ms-2",
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-external-link-alt"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                type: "button",
                                className: "btn-close",
                                "data-bs-dismiss": "modal",
                                "aria-label": "Close"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "modal-body",
                        children: body
                    })
                ]
            })
        })
    });
};




var $2NwrC = parcelRequire("2NwrC");

var $dBNnn = parcelRequire("dBNnn");
/*
 * List of events that DataTables can fire, so they can re-exported to React
 */ var $4908beb8b7defbe9$var$dtEvents = [
    'autoFill',
    'preAutoFill',
    'buttons-action',
    'buttons-processing',
    'column-reorder',
    'columns-reordered',
    'childRow',
    'column-sizing',
    'column-visibility',
    'destroy',
    'draw',
    'dt-error',
    'info',
    'init',
    'length',
    'options',
    'order',
    'page',
    'preDraw',
    'preInit',
    'preXhr',
    'processing',
    'requestChild',
    'search',
    'stateLoaded',
    'stateLoadParams',
    'stateSaveParams',
    'xhr',
    'key',
    'key-blur',
    'key-focus',
    'key-prefocus',
    'key-refocus',
    'key-return-submit',
    'responsive-display',
    'responsive-resize',
    'rowgroup-datasrc',
    'pre-row-reorder',
    'row-reorder',
    'row-reorder-canceled',
    'row-reorder-changed',
    'row-reordered',
    'dtsb-inserted',
    'deselect',
    'select',
    'select-blur',
    'selectItems',
    'selectStyle',
    'user-select',
    'stateRestore-change'
];
let $4908beb8b7defbe9$var$DataTablesLib = null;
// any here, so we can assign the `use` later - it is really a DataTableComponent though
const $4908beb8b7defbe9$var$Component = (0, $dBNnn.forwardRef)(function DataTable(props, ref) {
    const tableEl = (0, $dBNnn.useRef)(null);
    const table = (0, $dBNnn.useRef)(null);
    const options = (0, $dBNnn.useRef)(props.options ?? {});
    const cache = (0, $dBNnn.useRef)([]);
    // Expose the DataTables API via a reference
    (0, $dBNnn.useImperativeHandle)(ref, ()=>({
            dt: ()=>table.current
        }));
    // Expose some of the more common settings as props
    if (props.data) options.current.data = props.data;
    if (props.ajax) options.current.ajax = props.ajax;
    if (props.columns) options.current.columns = props.columns;
    // If slots are defined, create `columnDefs` entries for them to apply
    // to their target columns.
    if (props.slots) $4908beb8b7defbe9$var$applySlots(cache.current, options.current, props.slots);
    // Create the DataTable when the `<table>` is ready in the document
    (0, $dBNnn.useEffect)(()=>{
        if (!$4908beb8b7defbe9$var$DataTablesLib) throw new Error('DataTables library not set. See https://datatables.net/tn/23 for details.');
        if (tableEl.current) {
            const $ = $4908beb8b7defbe9$var$DataTablesLib.use('jq');
            const table$ = $(tableEl.current);
            // Bind to DataTable's events so they can be listened to with an `on` property
            $4908beb8b7defbe9$var$dtEvents.forEach((name)=>{
                // Create the `on*` name from the DataTables event name, which is camelCase
                // and an `on` prefix.
                const onName = 'on' + name[0].toUpperCase() + name.slice(1).replace(/-[a-z]/g, (match)=>match[1].toUpperCase());
                if (props[onName]) table$.on(name + '.dt', props[onName]);
            });
            // Initialise the DataTable
            table.current = new $4908beb8b7defbe9$var$DataTablesLib(tableEl.current, options.current);
        }
        // Unmount tidy up
        return ()=>{
            if (table.current) {
                // Unmount the created roots when this component unmounts
                let roots = cache.current.slice();
                cache.current.length = 0;
                setTimeout(()=>{
                    roots.forEach((r)=>{
                        r.unmount();
                    });
                }, 250);
                table.current.destroy();
                table.current = null;
            }
        };
    }, []);
    // On data change, clear and redraw
    (0, $dBNnn.useEffect)(()=>{
        if (props.data) {
            if (table.current) {
                table.current.clear();
                table.current.rows.add(props.data).draw(false);
            }
        }
    }, [
        props.data
    ]);
    return (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        children: (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
            ref: tableEl,
            className: props.className ?? '',
            id: props.id ?? '',
            children: props.children ?? null
        })
    });
});
$4908beb8b7defbe9$var$Component.use = function(lib) {
    $4908beb8b7defbe9$var$DataTablesLib = lib;
};
const $4908beb8b7defbe9$export$2e2bcd8739ae039 = $4908beb8b7defbe9$var$Component;
/**
 * Loop over the slots defined and apply them to their columns,
 * targeting based on the slot name (object key).
 *
 * @param options DataTables configuration object
 * @param slots Props passed in
 */ function $4908beb8b7defbe9$var$applySlots(cache, options, slots) {
    if (!options.columnDefs) options.columnDefs = [];
    Object.keys(slots).forEach((name)=>{
        let slot = slots[name];
        if (!slot) return;
        // Simple column index
        if (name.match(/^-?\d+$/)) // Note that unshift is used to make sure that this property is
        // applied in DataTables _after_ the end user's own options, if
        // they've provided any.
        options.columnDefs.unshift({
            target: parseInt(name),
            render: $4908beb8b7defbe9$var$slotRenderer(cache, slot)
        });
        else // Column name
        options.columnDefs.unshift({
            target: name + ':name',
            render: $4908beb8b7defbe9$var$slotRenderer(cache, slot)
        });
    });
}
/**
 * Create a rendering function that will create a React component
 * for a cell's rendering function.
 *
 * @param slot Function to create react component or orthogonal data
 * @returns Rendering function
 */ function $4908beb8b7defbe9$var$slotRenderer(cache, slot) {
    return function(data, type, row, meta) {
        if (slot.length === 4) {
            let result = slot(data, type, row, meta);
            return result['$$typeof'] ? $4908beb8b7defbe9$var$renderJsx(cache, result) : result;
        } else if (slot.length === 3) {
            // The function takes three parameters so it allows for
            // orthogonal data - not possible to cache the response
            let result = slot(data, type, row, meta);
            return result['$$typeof'] ? $4908beb8b7defbe9$var$renderJsx(cache, result) : result;
        }
        // Otherwise, we are expecting a JSX return from the function every
        // time and we can cache it. Note the `slot as any` - Typescript
        // doesn't appear to like the two argument option for `DataTableSlot`.
        return $4908beb8b7defbe9$var$slotCache(cache, ()=>slot(data, row));
    };
}
/**
 * Render a slot's element and cache it
 */ function $4908beb8b7defbe9$var$slotCache(cache, create) {
    // Execute the rendering function
    let result = create();
    // If the result is a JSX element, we need to render and then cache it
    if (result['$$typeof']) {
        let div = $4908beb8b7defbe9$var$renderJsx(cache, result);
        return div;
    }
    // Any other data just gets returned
    return result;
}
/**
 * Render JSX into a div which can be shown in a cell
 */ function $4908beb8b7defbe9$var$renderJsx(cache, jsx) {
    let div = document.createElement('div');
    let root = (0, $2NwrC.createRoot)(div);
    root.render(jsx);
    cache.push(root);
    return div;
}




/*! DataTables Bootstrap 5 integration
 * © SpryMedia Ltd - datatables.net/license
 */ var $de863994a018a098$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $de863994a018a098$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $de863994a018a098$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $de863994a018a098$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


/*! DataTables 2.2.2
 * © SpryMedia Ltd - datatables.net/license
 */ 
// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $d5722bd7562c0432$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($de863994a018a098$exports)));
var $d5722bd7562c0432$var$DataTable = function(selector, options) {
    // Check if called with a window or jQuery object for DOM less applications
    // This is for backwards compatibility
    if ($d5722bd7562c0432$var$DataTable.factory(selector, options)) return $d5722bd7562c0432$var$DataTable;
    // When creating with `new`, create a new DataTable, returning the API instance
    if (this instanceof $d5722bd7562c0432$var$DataTable) return $d5722bd7562c0432$var$$(selector).DataTable(options);
    else // Argument switching
    options = selector;
    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;
    if (emptyInit) options = {};
    // Method to get DT API instance from jQuery object
    this.api = function() {
        return new $d5722bd7562c0432$var$_Api(this);
    };
    this.each(function() {
        // For each initialisation we want to give it a clean initialisation
        // object that can be bashed around
        var o = {};
        var oInit = len > 1 ? $d5722bd7562c0432$var$_fnExtend(o, options, true) : options;
        var i = 0, iLen;
        var sId = this.getAttribute('id');
        var defaults = $d5722bd7562c0432$var$DataTable.defaults;
        var $this = $d5722bd7562c0432$var$$(this);
        /* Sanity check */ if (this.nodeName.toLowerCase() != 'table') {
            $d5722bd7562c0432$var$_fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
            return;
        }
        $d5722bd7562c0432$var$$(this).trigger('options.dt', oInit);
        /* Backwards compatibility for the defaults */ $d5722bd7562c0432$var$_fnCompatOpts(defaults);
        $d5722bd7562c0432$var$_fnCompatCols(defaults.column);
        /* Convert the camel-case defaults to Hungarian */ $d5722bd7562c0432$var$_fnCamelToHungarian(defaults, defaults, true);
        $d5722bd7562c0432$var$_fnCamelToHungarian(defaults.column, defaults.column, true);
        /* Setting up the initialisation object */ $d5722bd7562c0432$var$_fnCamelToHungarian(defaults, $d5722bd7562c0432$var$$.extend(oInit, $this.data()), true);
        /* Check to see if we are re-initialising a table */ var allSettings = $d5722bd7562c0432$var$DataTable.settings;
        for(i = 0, iLen = allSettings.length; i < iLen; i++){
            var s = allSettings[i];
            /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                if (emptyInit || bRetrieve) return s.oInstance;
                else if (bDestroy) {
                    new $d5722bd7562c0432$var$DataTable.Api(s).destroy();
                    break;
                } else {
                    $d5722bd7562c0432$var$_fnLog(s, 0, 'Cannot reinitialise DataTable', 3);
                    return;
                }
            }
            /* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */ if (s.sTableId == this.id) {
                allSettings.splice(i, 1);
                break;
            }
        }
        /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
            sId = "DataTables_Table_" + $d5722bd7562c0432$var$DataTable.ext._unique++;
            this.id = sId;
        }
        /* Create the settings object for this table and set some of the default parameters */ var oSettings = $d5722bd7562c0432$var$$.extend(true, {}, $d5722bd7562c0432$var$DataTable.models.oSettings, {
            "sDestroyWidth": $this[0].style.width,
            "sInstance": sId,
            "sTableId": sId,
            colgroup: $d5722bd7562c0432$var$$('<colgroup>').prependTo(this),
            fastData: function(row, column, type) {
                return $d5722bd7562c0432$var$_fnGetCellData(oSettings, row, column, type);
            }
        });
        oSettings.nTable = this;
        oSettings.oInit = oInit;
        allSettings.push(oSettings);
        // Make a single API instance available for internal handling
        oSettings.api = new $d5722bd7562c0432$var$_Api(oSettings);
        // Need to add the instance after the instance after the settings object has been added
        // to the settings array, so we can self reference the table instance if more than one
        oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
        // Backwards compatibility, before we apply all the defaults
        $d5722bd7562c0432$var$_fnCompatOpts(oInit);
        // If the length menu is given, but the init display length is not, use the length menu
        if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : $d5722bd7562c0432$var$$.isPlainObject(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0].value : oInit.aLengthMenu[0];
        // Apply the defaults and init options to make a single init object will all
        // options defined from defaults and instance options.
        oInit = $d5722bd7562c0432$var$_fnExtend($d5722bd7562c0432$var$$.extend(true, {}, defaults), oInit);
        // Map the initialisation options onto the settings object
        $d5722bd7562c0432$var$_fnMap(oSettings.oFeatures, oInit, [
            "bPaginate",
            "bLengthChange",
            "bFilter",
            "bSort",
            "bSortMulti",
            "bInfo",
            "bProcessing",
            "bAutoWidth",
            "bSortClasses",
            "bServerSide",
            "bDeferRender"
        ]);
        $d5722bd7562c0432$var$_fnMap(oSettings, oInit, [
            "ajax",
            "fnFormatNumber",
            "sServerMethod",
            "aaSorting",
            "aaSortingFixed",
            "aLengthMenu",
            "sPaginationType",
            "iStateDuration",
            "bSortCellsTop",
            "iTabIndex",
            "sDom",
            "fnStateLoadCallback",
            "fnStateSaveCallback",
            "renderer",
            "searchDelay",
            "rowId",
            "caption",
            "layout",
            "orderDescReverse",
            "typeDetect",
            [
                "iCookieDuration",
                "iStateDuration"
            ],
            [
                "oSearch",
                "oPreviousSearch"
            ],
            [
                "aoSearchCols",
                "aoPreSearchCols"
            ],
            [
                "iDisplayLength",
                "_iDisplayLength"
            ]
        ]);
        $d5722bd7562c0432$var$_fnMap(oSettings.oScroll, oInit, [
            [
                "sScrollX",
                "sX"
            ],
            [
                "sScrollXInner",
                "sXInner"
            ],
            [
                "sScrollY",
                "sY"
            ],
            [
                "bScrollCollapse",
                "bCollapse"
            ]
        ]);
        $d5722bd7562c0432$var$_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
        /* Callback functions which are array driven */ $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback);
        oSettings.rowIdFn = $d5722bd7562c0432$var$_fnGetObjectDataFn(oInit.rowId);
        /* Browser support detection */ $d5722bd7562c0432$var$_fnBrowserDetect(oSettings);
        var oClasses = oSettings.oClasses;
        $d5722bd7562c0432$var$$.extend(oClasses, $d5722bd7562c0432$var$DataTable.ext.classes, oInit.oClasses);
        $this.addClass(oClasses.table);
        if (!oSettings.oFeatures.bPaginate) oInit.iDisplayStart = 0;
        if (oSettings.iInitDisplayStart === undefined) {
            /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
            oSettings._iDisplayStart = oInit.iDisplayStart;
        }
        var defer = oInit.iDeferLoading;
        if (defer !== null) {
            oSettings.deferLoading = true;
            var tmp = Array.isArray(defer);
            oSettings._iRecordsDisplay = tmp ? defer[0] : defer;
            oSettings._iRecordsTotal = tmp ? defer[1] : defer;
        }
        /*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */ var columnsInit = [];
        var thead = this.getElementsByTagName('thead');
        var initHeaderLayout = $d5722bd7562c0432$var$_fnDetectHeader(oSettings, thead[0]);
        // If we don't have a columns array, then generate one with nulls
        if (oInit.aoColumns) columnsInit = oInit.aoColumns;
        else if (initHeaderLayout.length) for(i = 0, iLen = initHeaderLayout[0].length; i < iLen; i++)columnsInit.push(null);
        // Add the columns
        for(i = 0, iLen = columnsInit.length; i < iLen; i++)$d5722bd7562c0432$var$_fnAddColumn(oSettings);
        // Apply the column definitions
        $d5722bd7562c0432$var$_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, columnsInit, initHeaderLayout, function(iCol, oDef) {
            $d5722bd7562c0432$var$_fnColumnOptions(oSettings, iCol, oDef);
        });
        /* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */ var rowOne = $this.children('tbody').find('tr').eq(0);
        if (rowOne.length) {
            var a = function(cell, name) {
                return cell.getAttribute('data-' + name) !== null ? name : null;
            };
            $d5722bd7562c0432$var$$(rowOne[0]).children('th, td').each(function(i, cell) {
                var col = oSettings.aoColumns[i];
                if (!col) $d5722bd7562c0432$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
                if (col.mData === i) {
                    var sort = a(cell, 'sort') || a(cell, 'order');
                    var filter = a(cell, 'filter') || a(cell, 'search');
                    if (sort !== null || filter !== null) {
                        col.mData = {
                            _: i + '.display',
                            sort: sort !== null ? i + '.@data-' + sort : undefined,
                            type: sort !== null ? i + '.@data-' + sort : undefined,
                            filter: filter !== null ? i + '.@data-' + filter : undefined
                        };
                        col._isArrayHost = true;
                        $d5722bd7562c0432$var$_fnColumnOptions(oSettings, i);
                    }
                }
            });
        }
        // Must be done after everything which can be overridden by the state saving!
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoDrawCallback', $d5722bd7562c0432$var$_fnSaveState);
        var features = oSettings.oFeatures;
        if (oInit.bStateSave) features.bStateSave = true;
        // If aaSorting is not defined, then we use the first indicator in asSorting
        // in case that has been altered, so the default sort reflects that option
        if (oInit.aaSorting === undefined) {
            var sorting = oSettings.aaSorting;
            for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
        }
        // Do a first pass on the sorting classes (allows any size changes to be taken into
        // account, and also will apply sorting disabled classes if disabled
        $d5722bd7562c0432$var$_fnSortingClasses(oSettings);
        $d5722bd7562c0432$var$_fnCallbackReg(oSettings, 'aoDrawCallback', function() {
            if (oSettings.bSorted || $d5722bd7562c0432$var$_fnDataSource(oSettings) === 'ssp' || features.bDeferRender) $d5722bd7562c0432$var$_fnSortingClasses(oSettings);
        });
        /*
		 * Table HTML init
		 * Cache the header, body and footer as required, creating them if needed
		 */ var caption = $this.children('caption');
        if (oSettings.caption) {
            if (caption.length === 0) caption = $d5722bd7562c0432$var$$('<caption/>').appendTo($this);
            caption.html(oSettings.caption);
        }
        // Store the caption side, so we can remove the element from the document
        // when creating the element
        if (caption.length) {
            caption[0]._captionSide = caption.css('caption-side');
            oSettings.captionNode = caption[0];
        }
        if (thead.length === 0) thead = $d5722bd7562c0432$var$$('<thead/>').appendTo($this);
        oSettings.nTHead = thead[0];
        var tbody = $this.children('tbody');
        if (tbody.length === 0) tbody = $d5722bd7562c0432$var$$('<tbody/>').insertAfter(thead);
        oSettings.nTBody = tbody[0];
        var tfoot = $this.children('tfoot');
        if (tfoot.length === 0) // If we are a scrolling table, and no footer has been given, then we need to create
        // a tfoot element for the caption element to be appended to
        tfoot = $d5722bd7562c0432$var$$('<tfoot/>').appendTo($this);
        oSettings.nTFoot = tfoot[0];
        // Copy the data index array
        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
        // Initialisation complete - table can be drawn
        oSettings.bInitialised = true;
        // Language definitions
        var oLanguage = oSettings.oLanguage;
        $d5722bd7562c0432$var$$.extend(true, oLanguage, oInit.oLanguage);
        if (oLanguage.sUrl) // Get the language definitions from a file
        $d5722bd7562c0432$var$$.ajax({
            dataType: 'json',
            url: oLanguage.sUrl,
            success: function(json) {
                $d5722bd7562c0432$var$_fnCamelToHungarian(defaults.oLanguage, json);
                $d5722bd7562c0432$var$$.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'i18n', [
                    oSettings
                ], true);
                $d5722bd7562c0432$var$_fnInitialise(oSettings);
            },
            error: function() {
                // Error occurred loading language file
                $d5722bd7562c0432$var$_fnLog(oSettings, 0, 'i18n file loading error', 21);
                // Continue on as best we can
                $d5722bd7562c0432$var$_fnInitialise(oSettings);
            }
        });
        else {
            $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'i18n', [
                oSettings
            ], true);
            $d5722bd7562c0432$var$_fnInitialise(oSettings);
        }
    });
    _that = null;
    return this;
};
/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.ext = $d5722bd7562c0432$var$_ext = {
    /**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */ buttons: {},
    /**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */ classes: {},
    /**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */ builder: "-source-",
    /**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */ errMode: "alert",
    /**
	 * Legacy so v1 plug-ins don't throw js errors on load
	 */ feature: [],
    /**
	 * Feature plug-ins.
	 * 
	 * This is an object of callbacks which provide the features for DataTables
	 * to be initialised via the `layout` option.
	 */ features: {},
    /**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */ search: [],
    /**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */ selector: {
        cell: [],
        column: [],
        row: []
    },
    /**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */ legacy: {
        /**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */ ajax: null
    },
    /**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */ pager: {},
    renderer: {
        pageButton: {},
        header: {}
    },
    /**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */ order: {},
    /**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */ type: {
        /**
		 * Automatic column class assignment
		 */ className: {},
        /**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */ detect: [],
        /**
		 * Automatic renderer assignment
		 */ render: {},
        /**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */ search: {},
        /**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing Javascript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical Javascript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */ order: {}
    },
    /**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */ _unique: 0,
    //
    // Depreciated
    // The following properties are retained for backwards compatibility only.
    // The should not be used in new projects and will be removed in a future
    // version
    //
    /**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */ fnVersionCheck: $d5722bd7562c0432$var$DataTable.fnVersionCheck,
    /**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */ iApiIndex: 0,
    /**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */ sVersion: $d5722bd7562c0432$var$DataTable.version
};
//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$d5722bd7562c0432$var$$.extend($d5722bd7562c0432$var$_ext, {
    afnFiltering: $d5722bd7562c0432$var$_ext.search,
    aTypes: $d5722bd7562c0432$var$_ext.type.detect,
    ofnSearch: $d5722bd7562c0432$var$_ext.type.search,
    oSort: $d5722bd7562c0432$var$_ext.type.order,
    afnSortData: $d5722bd7562c0432$var$_ext.order,
    aoFeatures: $d5722bd7562c0432$var$_ext.feature,
    oStdClasses: $d5722bd7562c0432$var$_ext.classes,
    oPagination: $d5722bd7562c0432$var$_ext.pager
});
$d5722bd7562c0432$var$$.extend($d5722bd7562c0432$var$DataTable.ext.classes, {
    container: 'dt-container',
    empty: {
        row: 'dt-empty'
    },
    info: {
        container: 'dt-info'
    },
    layout: {
        row: 'dt-layout-row',
        cell: 'dt-layout-cell',
        tableRow: 'dt-layout-table',
        tableCell: '',
        start: 'dt-layout-start',
        end: 'dt-layout-end',
        full: 'dt-layout-full'
    },
    length: {
        container: 'dt-length',
        select: 'dt-input'
    },
    order: {
        canAsc: 'dt-orderable-asc',
        canDesc: 'dt-orderable-desc',
        isAsc: 'dt-ordering-asc',
        isDesc: 'dt-ordering-desc',
        none: 'dt-orderable-none',
        position: 'sorting_'
    },
    processing: {
        container: 'dt-processing'
    },
    scrolling: {
        body: 'dt-scroll-body',
        container: 'dt-scroll',
        footer: {
            self: 'dt-scroll-foot',
            inner: 'dt-scroll-footInner'
        },
        header: {
            self: 'dt-scroll-head',
            inner: 'dt-scroll-headInner'
        }
    },
    search: {
        container: 'dt-search',
        input: 'dt-input'
    },
    table: 'dataTable',
    tbody: {
        cell: '',
        row: ''
    },
    thead: {
        cell: '',
        row: ''
    },
    tfoot: {
        cell: '',
        row: ''
    },
    paging: {
        active: 'current',
        button: 'dt-paging-button',
        container: 'dt-paging',
        disabled: 'disabled',
        nav: ''
    }
});
/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */ // Defined else where
//  _selector_run
//  _selector_opts
//  _selector_row_indexes
var $d5722bd7562c0432$var$_ext; // DataTable.ext
var $d5722bd7562c0432$var$_Api; // DataTable.Api
var $d5722bd7562c0432$var$_api_register; // DataTable.Api.register
var $d5722bd7562c0432$var$_api_registerPlural; // DataTable.Api.registerPlural
var $d5722bd7562c0432$var$_re_dic = {};
var $d5722bd7562c0432$var$_re_new_lines = /[\r\n\u2028]/g;
var $d5722bd7562c0432$var$_re_html = /<([^>]*>)/g;
var $d5722bd7562c0432$var$_max_str_len = Math.pow(2, 28);
// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var $d5722bd7562c0432$var$_re_date = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/;
// Escape regular expression special characters
var $d5722bd7562c0432$var$_re_escape_regex = new RegExp('(\\' + [
    '/',
    '.',
    '*',
    '+',
    '?',
    '|',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\\',
    '$',
    '^',
    '-'
].join('|\\') + ')', 'g');
// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var $d5722bd7562c0432$var$_re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
var $d5722bd7562c0432$var$_empty = function(d) {
    return !d || d === true || d === '-' ? true : false;
};
var $d5722bd7562c0432$var$_intVal = function(s) {
    var integer = parseInt(s, 10);
    return !isNaN(integer) && isFinite(s) ? integer : null;
};
// Convert from a formatted number with characters other than `.` as the
// decimal place, to a Javascript number
var $d5722bd7562c0432$var$_numToDecimal = function(num, decimalPoint) {
    // Cache created regular expressions for speed as this function is called often
    if (!$d5722bd7562c0432$var$_re_dic[decimalPoint]) $d5722bd7562c0432$var$_re_dic[decimalPoint] = new RegExp($d5722bd7562c0432$var$_fnEscapeRegex(decimalPoint), 'g');
    return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace($d5722bd7562c0432$var$_re_dic[decimalPoint], '.') : num;
};
var $d5722bd7562c0432$var$_isNumber = function(d, decimalPoint, formatted, allowEmpty) {
    var type = typeof d;
    var strType = type === 'string';
    if (type === 'number' || type === 'bigint') return true;
    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if (allowEmpty && $d5722bd7562c0432$var$_empty(d)) return true;
    if (decimalPoint && strType) d = $d5722bd7562c0432$var$_numToDecimal(d, decimalPoint);
    if (formatted && strType) d = d.replace($d5722bd7562c0432$var$_re_formatted_numeric, '');
    return !isNaN(parseFloat(d)) && isFinite(d);
};
// A string without HTML in it can be considered to be HTML still
var $d5722bd7562c0432$var$_isHtml = function(d) {
    return $d5722bd7562c0432$var$_empty(d) || typeof d === 'string';
};
// Is a string a number surrounded by HTML?
var $d5722bd7562c0432$var$_htmlNumeric = function(d, decimalPoint, formatted, allowEmpty) {
    if (allowEmpty && $d5722bd7562c0432$var$_empty(d)) return true;
    // input and select strings mean that this isn't just a number
    if (typeof d === 'string' && d.match(/<(input|select)/i)) return null;
    var html = $d5722bd7562c0432$var$_isHtml(d);
    return !html ? null : $d5722bd7562c0432$var$_isNumber($d5722bd7562c0432$var$_stripHtml(d), decimalPoint, formatted, allowEmpty) ? true : null;
};
var $d5722bd7562c0432$var$_pluck = function(a, prop, prop2) {
    var out = [];
    var i = 0, ien = a.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[i]) out.push(a[i][prop]);
    }
    return out;
};
// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var $d5722bd7562c0432$var$_pluck_order = function(a, order, prop, prop2) {
    var out = [];
    var i = 0, ien = order.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < ien; i++)if (a[order[i]] && a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
    } else {
        for(; i < ien; i++)if (a[order[i]]) out.push(a[order[i]][prop]);
    }
    return out;
};
var $d5722bd7562c0432$var$_range = function(len, start) {
    var out = [];
    var end;
    if (start === undefined) {
        start = 0;
        end = len;
    } else {
        end = start;
        start = len;
    }
    for(var i = start; i < end; i++)out.push(i);
    return out;
};
var $d5722bd7562c0432$var$_removeEmpty = function(a) {
    var out = [];
    for(var i = 0, ien = a.length; i < ien; i++)if (a[i]) out.push(a[i]);
    return out;
};
// Replaceable function in api.util
var $d5722bd7562c0432$var$_stripHtml = function(input) {
    if (!input || typeof input !== 'string') return input;
    // Irrelevant check to workaround CodeQL's false positive on the regex
    if (input.length > $d5722bd7562c0432$var$_max_str_len) throw new Error('Exceeded max str len');
    var previous;
    input = input.replace($d5722bd7562c0432$var$_re_html, ''); // Complete tags
    // Safety for incomplete script tag - use do / while to ensure that
    // we get all instances
    do {
        previous = input;
        input = input.replace(/<script/i, '');
    }while (input !== previous);
    return previous;
};
// Replaceable function in api.util
var $d5722bd7562c0432$var$_escapeHtml = function(d) {
    if (Array.isArray(d)) d = d.join(',');
    return typeof d === 'string' ? d.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : d;
};
// Remove diacritics from a string by decomposing it and then removing
// non-ascii characters
var $d5722bd7562c0432$var$_normalize = function(str, both) {
    if (typeof str !== 'string') return str;
    // It is faster to just run `normalize` than it is to check if
    // we need to with a regex! (Check as it isn't available in old
    // Safari)
    var res = str.normalize ? str.normalize("NFD") : str;
    // Equally, here we check if a regex is needed or not
    return res.length !== str.length ? (both === true ? str + ' ' : '') + res.replace(/[\u0300-\u036f]/g, "") : res;
};
/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */ var $d5722bd7562c0432$var$_areAllUnique = function(src) {
    if (src.length < 2) return true;
    var sorted = src.slice().sort();
    var last = sorted[0];
    for(var i = 1, ien = sorted.length; i < ien; i++){
        if (sorted[i] === last) return false;
        last = sorted[i];
    }
    return true;
};
/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */ var $d5722bd7562c0432$var$_unique = function(src) {
    if (Array.from && Set) return Array.from(new Set(src));
    if ($d5722bd7562c0432$var$_areAllUnique(src)) return src.slice();
    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.app/compare-array-unique-versions/4 for more
    // information.
    var out = [], val, i, ien = src.length, j, k = 0;
    again: for(i = 0; i < ien; i++){
        val = src[i];
        for(j = 0; j < k; j++){
            if (out[j] === val) continue again;
        }
        out.push(val);
        k++;
    }
    return out;
};
// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var $d5722bd7562c0432$var$_flatten = function(out, val) {
    if (Array.isArray(val)) for(var i = 0; i < val.length; i++)$d5722bd7562c0432$var$_flatten(out, val[i]);
    else out.push(val);
    return out;
};
// Similar to jQuery's addClass, but use classList.add
function $d5722bd7562c0432$var$_addClass(el, name) {
    if (name) name.split(' ').forEach(function(n) {
        if (n) // `add` does deduplication, so no need to check `contains`
        el.classList.add(n);
    });
}
/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.util = {
    /**
	 * Return a string with diacritic characters decomposed
	 * @param {*} mixed Function or string to normalize
	 * @param {*} both Return original string and the normalized string
	 * @returns String or undefined
	 */ diacritics: function(mixed, both) {
        var type = typeof mixed;
        if (type !== 'function') return $d5722bd7562c0432$var$_normalize(mixed, both);
        $d5722bd7562c0432$var$_normalize = mixed;
    },
    /**
	 * Debounce a function
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ debounce: function(fn, timeout) {
        var timer;
        return function() {
            var that = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(that, args);
            }, timeout || 250);
        };
    },
    /**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ throttle: function(fn, freq) {
        var frequency = freq !== undefined ? freq : 200, last, timer;
        return function() {
            var that = this, now = +new Date(), args = arguments;
            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    },
    /**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */ escapeRegex: function(val) {
        return val.replace($d5722bd7562c0432$var$_re_escape_regex, '\\$1');
    },
    /**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */ set: function(source) {
        if ($d5722bd7562c0432$var$$.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */ return $d5722bd7562c0432$var$DataTable.util.set(source._);
        else if (source === null) // Nothing to do when the data source is null
        return function() {};
        else if (typeof source === 'function') return function(data, val, meta) {
            source(data, 'set', val, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            // Like the get, we need to get data from a nested object
            var setData = function(data, val, src) {
                var a = $d5722bd7562c0432$var$_fnSplitObjNotation(src), b;
                var aLast = a[a.length - 1];
                var arrayNotation, funcNotation, o, innerSrc;
                for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                    // Protect against prototype pollution
                    if (a[i] === '__proto__' || a[i] === 'constructor') throw new Error('Cannot set prototype values');
                    // Check if we are dealing with an array notation request
                    arrayNotation = a[i].match($d5722bd7562c0432$var$__reArray);
                    funcNotation = a[i].match($d5722bd7562c0432$var$__reFn);
                    if (arrayNotation) {
                        a[i] = a[i].replace($d5722bd7562c0432$var$__reArray, '');
                        data[a[i]] = [];
                        // Get the remainder of the nested object to set so we can recurse
                        b = a.slice();
                        b.splice(0, i + 1);
                        innerSrc = b.join('.');
                        // Traverse each entry in the array setting the properties requested
                        if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                            o = {};
                            setData(o, val[j], innerSrc);
                            data[a[i]].push(o);
                        }
                        else // We've been asked to save data to an array, but it
                        // isn't array data to be saved. Best that can be done
                        // is to just save the value.
                        data[a[i]] = val;
                        // The inner call to setData has already traversed through the remainder
                        // of the source and has set the data, thus we can exit here
                        return;
                    } else if (funcNotation) {
                        // Function call
                        a[i] = a[i].replace($d5722bd7562c0432$var$__reFn, '');
                        data = data[a[i]](val);
                    }
                    // If the nested object doesn't currently exist - since we are
                    // trying to set the value - create it
                    if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                    data = data[a[i]];
                }
                // Last item in the input - i.e, the actual set
                if (aLast.match($d5722bd7562c0432$var$__reFn)) // Function call
                data = data[aLast.replace($d5722bd7562c0432$var$__reFn, '')](val);
                else // If array notation is used, we just want to strip it and use the property name
                // and assign the value. If it isn't used, then we get the result we want anyway
                data[aLast.replace($d5722bd7562c0432$var$__reArray, '')] = val;
            };
            return function(data, val) {
                return setData(data, val, source);
            };
        } else // Array or flat object mapping
        return function(data, val) {
            data[source] = val;
        };
    },
    /**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */ get: function(source) {
        if ($d5722bd7562c0432$var$$.isPlainObject(source)) {
            // Build an object of get functions, and wrap them in a single call
            var o = {};
            $d5722bd7562c0432$var$$.each(source, function(key, val) {
                if (val) o[key] = $d5722bd7562c0432$var$DataTable.util.get(val);
            });
            return function(data, type, row, meta) {
                var t = o[type] || o._;
                return t !== undefined ? t(data, type, row, meta) : data;
            };
        } else if (source === null) // Give an empty string for rendering / sorting etc
        return function(data) {
            return data;
        };
        else if (typeof source === 'function') return function(data, type, row, meta) {
            return source(data, type, row, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */ var fetchData = function(data, type, src) {
                var arrayNotation, funcNotation, out, innerSrc;
                if (src !== "") {
                    var a = $d5722bd7562c0432$var$_fnSplitObjNotation(src);
                    for(var i = 0, iLen = a.length; i < iLen; i++){
                        // Check if we are dealing with special notation
                        arrayNotation = a[i].match($d5722bd7562c0432$var$__reArray);
                        funcNotation = a[i].match($d5722bd7562c0432$var$__reFn);
                        if (arrayNotation) {
                            // Array notation
                            a[i] = a[i].replace($d5722bd7562c0432$var$__reArray, '');
                            // Condition allows simply [] to be passed in
                            if (a[i] !== "") data = data[a[i]];
                            out = [];
                            // Get the remainder of the nested object to get
                            a.splice(0, i + 1);
                            innerSrc = a.join('.');
                            // Traverse each entry in the array getting the properties requested
                            if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                            // If a string is given in between the array notation indicators, that
                            // is used to join the strings together, otherwise an array is returned
                            var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                            data = join === "" ? out : out.join(join);
                            break;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace($d5722bd7562c0432$var$__reFn, '');
                            data = data[a[i]]();
                            continue;
                        }
                        if (data === null || data[a[i]] === null) return null;
                        else if (data === undefined || data[a[i]] === undefined) return undefined;
                        data = data[a[i]];
                    }
                }
                return data;
            };
            return function(data, type) {
                return fetchData(data, type, source);
            };
        } else // Array or flat object mapping
        return function(data) {
            return data[source];
        };
    },
    stripHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            $d5722bd7562c0432$var$_stripHtml = mixed;
            return;
        } else if (type === 'string') return $d5722bd7562c0432$var$_stripHtml(mixed);
        return mixed;
    },
    escapeHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            $d5722bd7562c0432$var$_escapeHtml = mixed;
            return;
        } else if (type === 'string' || Array.isArray(mixed)) return $d5722bd7562c0432$var$_escapeHtml(mixed);
        return mixed;
    },
    unique: $d5722bd7562c0432$var$_unique
};
/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnHungarianMap(o) {
    var hungarian = 'a aa ai ao as b fn i m o s ', match, newKey, map = {};
    $d5722bd7562c0432$var$$.each(o, function(key) {
        match = key.match(/^([^A-Z]+?)([A-Z])/);
        if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
            newKey = key.replace(match[0], match[2].toLowerCase());
            map[newKey] = key;
            if (match[1] === 'o') $d5722bd7562c0432$var$_fnHungarianMap(o[key]);
        }
    });
    o._hungarianMap = map;
}
/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnCamelToHungarian(src, user, force) {
    if (!src._hungarianMap) $d5722bd7562c0432$var$_fnHungarianMap(src);
    var hungarianKey;
    $d5722bd7562c0432$var$$.each(user, function(key) {
        hungarianKey = src._hungarianMap[key];
        if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
            // For objects, we need to buzz down into the object to copy parameters
            if (hungarianKey.charAt(0) === 'o') {
                // Copy the camelCase options over to the hungarian
                if (!user[hungarianKey]) user[hungarianKey] = {};
                $d5722bd7562c0432$var$$.extend(true, user[hungarianKey], user[key]);
                $d5722bd7562c0432$var$_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
            } else user[hungarianKey] = user[key];
        }
    });
}
/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */ var $d5722bd7562c0432$var$_fnCompatMap = function(o, knew, old) {
    if (o[knew] !== undefined) o[old] = o[knew];
};
/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */ function $d5722bd7562c0432$var$_fnCompatOpts(init) {
    $d5722bd7562c0432$var$_fnCompatMap(init, 'ordering', 'bSort');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderMulti', 'bSortMulti');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderClasses', 'bSortClasses');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'order', 'aaSorting');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'paging', 'bPaginate');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'pagingType', 'sPaginationType');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'pageLength', 'iDisplayLength');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'searching', 'bFilter');
    // Boolean initialisation of x-scrolling
    if (typeof init.sScrollX === 'boolean') init.sScrollX = init.sScrollX ? '100%' : '';
    if (typeof init.scrollX === 'boolean') init.scrollX = init.scrollX ? '100%' : '';
    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;
    if (searchCols) {
        for(var i = 0, ien = searchCols.length; i < ien; i++)if (searchCols[i]) $d5722bd7562c0432$var$_fnCamelToHungarian($d5722bd7562c0432$var$DataTable.models.oSearch, searchCols[i]);
    }
    // Enable search delay if server-side processing is enabled
    if (init.serverSide && !init.searchDelay) init.searchDelay = 400;
}
/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */ function $d5722bd7562c0432$var$_fnCompatCols(init) {
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderable', 'bSortable');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderData', 'aDataSort');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderSequence', 'asSorting');
    $d5722bd7562c0432$var$_fnCompatMap(init, 'orderDataType', 'sortDataType');
    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if (typeof dataSort === 'number' && !Array.isArray(dataSort)) init.aDataSort = [
        dataSort
    ];
}
/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnBrowserDetect(settings) {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if (!$d5722bd7562c0432$var$DataTable.__browser) {
        var browser = {};
        $d5722bd7562c0432$var$DataTable.__browser = browser;
        // Scrolling feature / quirks detection
        var n = $d5722bd7562c0432$var$$('<div/>').css({
            position: 'fixed',
            top: 0,
            left: -1 * window.pageXOffset,
            height: 1,
            width: 1,
            overflow: 'hidden'
        }).append($d5722bd7562c0432$var$$('<div/>').css({
            position: 'absolute',
            top: 1,
            left: 1,
            width: 100,
            overflow: 'scroll'
        }).append($d5722bd7562c0432$var$$('<div/>').css({
            width: '100%',
            height: 10
        }))).appendTo('body');
        var outer = n.children();
        var inner = outer.children();
        // Get scrollbar width
        browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
        // In rtl text layout, some browsers (most, but not all) will place the
        // scrollbar on the left, rather than the right.
        browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
        n.remove();
    }
    $d5722bd7562c0432$var$$.extend(settings.oBrowser, $d5722bd7562c0432$var$DataTable.__browser);
    settings.oScroll.iBarWidth = $d5722bd7562c0432$var$DataTable.__browser.barWidth;
}
/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAddColumn(oSettings) {
    // Add column to aoColumns array
    var oDefaults = $d5722bd7562c0432$var$DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $d5722bd7562c0432$var$$.extend({}, $d5722bd7562c0432$var$DataTable.models.oColumn, oDefaults, {
        "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
            iCol
        ],
        "mData": oDefaults.mData ? oDefaults.mData : iCol,
        idx: iCol,
        searchFixed: {},
        colEl: $d5722bd7562c0432$var$$('<col>').attr('data-dt-column', iCol)
    });
    oSettings.aoColumns.push(oCol);
    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[iCol] = $d5722bd7562c0432$var$$.extend({}, $d5722bd7562c0432$var$DataTable.models.oSearch, searchCols[iCol]);
}
/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnColumnOptions(oSettings, iCol, oOptions) {
    var oCol = oSettings.aoColumns[iCol];
    /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
        // Backwards compatibility
        $d5722bd7562c0432$var$_fnCompatCols(oOptions);
        // Map camel case parameters to their Hungarian counterparts
        $d5722bd7562c0432$var$_fnCamelToHungarian($d5722bd7562c0432$var$DataTable.defaults.column, oOptions, true);
        /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
        if (oOptions.sType) oCol._sManualType = oOptions.sType;
        // `class` is a reserved word in Javascript, so we need to provide
        // the ability to use a valid name for the camel case input
        if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
        var origClass = oCol.sClass;
        $d5722bd7562c0432$var$$.extend(oCol, oOptions);
        $d5722bd7562c0432$var$_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
        // Merge class from previously defined classes with this one, rather than just
        // overwriting it in the extend above
        if (origClass !== oCol.sClass) oCol.sClass = origClass + ' ' + oCol.sClass;
        /* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
            oOptions.iDataSort
        ];
        $d5722bd7562c0432$var$_fnMap(oCol, oOptions, "aDataSort");
    }
    /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
    var mData = $d5722bd7562c0432$var$_fnGetObjectDataFn(mDataSrc);
    // The `render` option can be given as an array to access the helper rendering methods.
    // The first element is the rendering method to use, the rest are the parameters to pass
    if (oCol.mRender && Array.isArray(oCol.mRender)) {
        var copy = oCol.mRender.slice();
        var name = copy.shift();
        oCol.mRender = $d5722bd7562c0432$var$DataTable.render[name].apply(window, copy);
    }
    oCol._render = oCol.mRender ? $d5722bd7562c0432$var$_fnGetObjectDataFn(oCol.mRender) : null;
    var attrTest = function(src) {
        return typeof src === 'string' && src.indexOf('@') !== -1;
    };
    oCol._bAttrSrc = $d5722bd7562c0432$var$$.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
    oCol._setter = null;
    oCol.fnGetData = function(rowData, type, meta) {
        var innerData = mData(rowData, type, undefined, meta);
        return oCol._render && type ? oCol._render(innerData, type, rowData, meta) : innerData;
    };
    oCol.fnSetData = function(rowData, val, meta) {
        return $d5722bd7562c0432$var$_fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
    };
    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if (typeof mDataSrc !== 'number' && !oCol._isArrayHost) oSettings._rowReadObject = true;
    /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) oCol.bSortable = false;
}
/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAdjustColumnSizing(settings) {
    $d5722bd7562c0432$var$_fnCalculateColumnWidths(settings);
    $d5722bd7562c0432$var$_fnColumnSizes(settings);
    var scroll = settings.oScroll;
    if (scroll.sY !== '' || scroll.sX !== '') $d5722bd7562c0432$var$_fnScrollDraw(settings);
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'column-sizing', [
        settings
    ]);
}
/**
 * Apply column sizes
 *
 * @param {*} settings DataTables settings object
 */ function $d5722bd7562c0432$var$_fnColumnSizes(settings) {
    var cols = settings.aoColumns;
    for(var i = 0; i < cols.length; i++){
        var width = $d5722bd7562c0432$var$_fnColumnsSumWidth(settings, [
            i
        ], false, false);
        cols[i].colEl.css('width', width);
        if (settings.oScroll.sX) cols[i].colEl.css('min-width', width);
    }
}
/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnVisibleToColumnIndex(oSettings, iMatch) {
    var aiVis = $d5722bd7562c0432$var$_fnGetColumns(oSettings, 'bVisible');
    return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
}
/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnColumnIndexToVisible(oSettings, iMatch) {
    var aiVis = $d5722bd7562c0432$var$_fnGetColumns(oSettings, 'bVisible');
    var iPos = aiVis.indexOf(iMatch);
    return iPos !== -1 ? iPos : null;
}
/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnVisbleColumns(settings) {
    var layout = settings.aoHeader;
    var columns = settings.aoColumns;
    var vis = 0;
    if (layout.length) {
        for(var i = 0, ien = layout[0].length; i < ien; i++)if (columns[i].bVisible && $d5722bd7562c0432$var$$(layout[0][i].cell).css('display') !== 'none') vis++;
    }
    return vis;
}
/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnGetColumns(oSettings, sParam) {
    var a = [];
    oSettings.aoColumns.map(function(val, i) {
        if (val[sParam]) a.push(i);
    });
    return a;
}
/**
 * Allow the result from a type detection function to be `true` while
 * translating that into a string. Old type detection functions will
 * return the type name if it passes. An obect store would be better,
 * but not backwards compatible.
 *
 * @param {*} typeDetect Object or function for type detection
 * @param {*} res Result from the type detection function
 * @returns Type name or false
 */ function $d5722bd7562c0432$var$_typeResult(typeDetect, res) {
    return res === true ? typeDetect._name : res;
}
/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnColumnTypes(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = $d5722bd7562c0432$var$DataTable.ext.type.detect;
    var i, ien, j, jen, k, ken;
    var col, detectedType, cache;
    // For each column, spin over the data type detection functions, seeing if one matches
    for(i = 0, ien = columns.length; i < ien; i++){
        col = columns[i];
        cache = [];
        if (!col.sType && col._sManualType) col.sType = col._sManualType;
        else if (!col.sType) {
            // With SSP type detection can be unreliable and error prone, so we provide a way
            // to turn it off.
            if (!settings.typeDetect) return;
            for(j = 0, jen = types.length; j < jen; j++){
                var typeDetect = types[j];
                // There can be either one, or three type detection functions
                var oneOf = typeDetect.oneOf;
                var allOf = typeDetect.allOf || typeDetect;
                var init = typeDetect.init;
                var one = false;
                detectedType = null;
                // Fast detect based on column assignment
                if (init) {
                    detectedType = $d5722bd7562c0432$var$_typeResult(typeDetect, init(settings, col, i));
                    if (detectedType) {
                        col.sType = detectedType;
                        break;
                    }
                }
                for(k = 0, ken = data.length; k < ken; k++){
                    if (!data[k]) continue;
                    // Use a cache array so we only need to get the type data
                    // from the formatter once (when using multiple detectors)
                    if (cache[k] === undefined) cache[k] = $d5722bd7562c0432$var$_fnGetCellData(settings, k, i, 'type');
                    // Only one data point in the column needs to match this function
                    if (oneOf && !one) one = $d5722bd7562c0432$var$_typeResult(typeDetect, oneOf(cache[k], settings));
                    // All data points need to match this function
                    detectedType = $d5722bd7562c0432$var$_typeResult(typeDetect, allOf(cache[k], settings));
                    // If null, then this type can't apply to this column, so
                    // rather than testing all cells, break out. There is an
                    // exception for the last type which is `html`. We need to
                    // scan all rows since it is possible to mix string and HTML
                    // types
                    if (!detectedType && j !== types.length - 3) break;
                    // Only a single match is needed for html type since it is
                    // bottom of the pile and very similar to string - but it
                    // must not be empty
                    if (detectedType === 'html' && !$d5722bd7562c0432$var$_empty(cache[k])) break;
                }
                // Type is valid for all data points in the column - use this
                // type
                if (oneOf && one && detectedType || !oneOf && detectedType) {
                    col.sType = detectedType;
                    break;
                }
            }
            // Fall back - if no type was detected, always use string
            if (!col.sType) col.sType = 'string';
        }
        // Set class names for header / footer for auto type classes
        var autoClass = $d5722bd7562c0432$var$_ext.type.className[col.sType];
        if (autoClass) {
            $d5722bd7562c0432$var$_columnAutoClass(settings.aoHeader, i, autoClass);
            $d5722bd7562c0432$var$_columnAutoClass(settings.aoFooter, i, autoClass);
        }
        var renderer = $d5722bd7562c0432$var$_ext.type.render[col.sType];
        // This can only happen once! There is no way to remove
        // a renderer. After the first time the renderer has
        // already been set so createTr will run the renderer itself.
        if (renderer && !col._render) {
            col._render = $d5722bd7562c0432$var$DataTable.util.get(renderer);
            $d5722bd7562c0432$var$_columnAutoRender(settings, i);
        }
    }
}
/**
 * Apply an auto detected renderer to data which doesn't yet have
 * a renderer
 */ function $d5722bd7562c0432$var$_columnAutoRender(settings, colIdx) {
    var data = settings.aoData;
    for(var i = 0; i < data.length; i++)if (data[i].nTr) {
        // We have to update the display here since there is no
        // invalidation check for the data
        var display = $d5722bd7562c0432$var$_fnGetCellData(settings, i, colIdx, 'display');
        data[i].displayData[colIdx] = display;
        $d5722bd7562c0432$var$_fnWriteCell(data[i].anCells[colIdx], display);
    // No need to update sort / filter data since it has
    // been invalidated and will be re-read with the
    // renderer now applied
    }
}
/**
 * Apply a class name to a column's header cells
 */ function $d5722bd7562c0432$var$_columnAutoClass(container, colIdx, className) {
    container.forEach(function(row) {
        if (row[colIdx] && row[colIdx].unique) $d5722bd7562c0432$var$_addClass(row[colIdx].cell, className);
    });
}
/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {array} headerLayout Layout for header as it was loaded
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnApplyColumnDefs(oSettings, aoColDefs, aoCols, headerLayout, fn) {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;
    if (aoCols) {
        for(i = 0, iLen = aoCols.length; i < iLen; i++)if (aoCols[i] && aoCols[i].name) columns[i].sName = aoCols[i].name;
    }
    // Column definitions with aTargets
    if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
        def = aoColDefs[i];
        /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
        if (!Array.isArray(aTargets)) aTargets = [
            aTargets
        ];
        for(j = 0, jLen = aTargets.length; j < jLen; j++){
            var target = aTargets[j];
            if (typeof target === 'number' && target >= 0) {
                /* Add columns that we don't yet know about */ while(columns.length <= target)$d5722bd7562c0432$var$_fnAddColumn(oSettings);
                /* Integer, basic index */ fn(target, def);
            } else if (typeof target === 'number' && target < 0) /* Negative integer, right to left column counting */ fn(columns.length + target, def);
            else if (typeof target === 'string') for(k = 0, kLen = columns.length; k < kLen; k++){
                if (target === '_all') // Apply to all columns
                fn(k, def);
                else if (target.indexOf(':name') !== -1) // Column selector
                {
                    if (columns[k].sName === target.replace(':name', '')) fn(k, def);
                } else // Cell selector
                headerLayout.forEach(function(row) {
                    if (row[k]) {
                        var cell = $d5722bd7562c0432$var$$(row[k].cell);
                        // Legacy support. Note that it means that we don't support
                        // an element name selector only, since they are treated as
                        // class names for 1.x compat.
                        if (target.match(/^[a-z][\w-]*$/i)) target = '.' + target;
                        if (cell.is(target)) fn(k, def);
                    }
                });
            }
        }
    }
    // Statically defined columns array
    if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
}
/**
 * Get the width for a given set of columns
 *
 * @param {*} settings DataTables settings object
 * @param {*} targets Columns - comma separated string or array of numbers
 * @param {*} original Use the original width (true) or calculated (false)
 * @param {*} incVisible Include visible columns (true) or not (false)
 * @returns Combined CSS value
 */ function $d5722bd7562c0432$var$_fnColumnsSumWidth(settings, targets, original, incVisible) {
    if (!Array.isArray(targets)) targets = $d5722bd7562c0432$var$_fnColumnsFromHeader(targets);
    var sum = 0;
    var unit;
    var columns = settings.aoColumns;
    for(var i = 0, ien = targets.length; i < ien; i++){
        var column = columns[targets[i]];
        var definedWidth = original ? column.sWidthOrig : column.sWidth;
        if (!incVisible && column.bVisible === false) continue;
        if (definedWidth === null || definedWidth === undefined) return null; // can't determine a defined width - browser defined
        else if (typeof definedWidth === 'number') {
            unit = 'px';
            sum += definedWidth;
        } else {
            var matched = definedWidth.match(/([\d\.]+)([^\d]*)/);
            if (matched) {
                sum += matched[1] * 1;
                unit = matched.length === 3 ? matched[2] : 'px';
            }
        }
    }
    return sum + unit;
}
function $d5722bd7562c0432$var$_fnColumnsFromHeader(cell) {
    var attr = $d5722bd7562c0432$var$$(cell).closest('[data-dt-column]').attr('data-dt-column');
    if (!attr) return [];
    return attr.split(',').map(function(val) {
        return val * 1;
    });
}
/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a Javascript source, rather than a
 * DOM source.
 *  @param {object} settings dataTables settings object
 *  @param {array} data data array to be added
 *  @param {node} [tr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [tds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAddData(settings, dataIn, tr, tds) {
    /* Create the object for storing information about this new row */ var rowIdx = settings.aoData.length;
    var rowModel = $d5722bd7562c0432$var$$.extend(true, {}, $d5722bd7562c0432$var$DataTable.models.oRow, {
        src: tr ? 'dom' : 'data',
        idx: rowIdx
    });
    rowModel._aData = dataIn;
    settings.aoData.push(rowModel);
    var columns = settings.aoColumns;
    for(var i = 0, iLen = columns.length; i < iLen; i++)// Invalidate the column types as the new data needs to be revalidated
    columns[i].sType = null;
    /* Add to the display array */ settings.aiDisplayMaster.push(rowIdx);
    var id = settings.rowIdFn(dataIn);
    if (id !== undefined) settings.aIds[id] = rowModel;
    /* Create the DOM information, or register it if already present */ if (tr || !settings.oFeatures.bDeferRender) $d5722bd7562c0432$var$_fnCreateTr(settings, rowIdx, tr, tds);
    return rowIdx;
}
/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAddTr(settings, trs) {
    var row;
    // Allow an individual node to be passed in
    if (!(trs instanceof $d5722bd7562c0432$var$$)) trs = $d5722bd7562c0432$var$$(trs);
    return trs.map(function(i, el) {
        row = $d5722bd7562c0432$var$_fnGetRowElements(settings, el);
        return $d5722bd7562c0432$var$_fnAddData(settings, row.data, el, row.cells);
    });
}
/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnGetCellData(settings, rowIdx, colIdx, type) {
    if (type === 'search') type = 'filter';
    else if (type === 'order') type = 'sort';
    var row = settings.aoData[rowIdx];
    if (!row) return undefined;
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = row._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData(rowData, type, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
    // Allow for a node being returned for non-display types
    if (type !== 'display' && cellData && typeof cellData === 'object' && cellData.nodeName) cellData = cellData.innerHTML;
    if (cellData === undefined) {
        if (settings.iDrawError != draw && defaultContent === null) {
            $d5722bd7562c0432$var$_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
            settings.iDrawError = draw;
        }
        return defaultContent;
    }
    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
    else if (typeof cellData === 'function') // If the data source is a function, then we run it and use the return,
    // executing in the scope of the data object (for instances)
    return cellData.call(rowData);
    if (cellData === null && type === 'display') return '';
    if (type === 'filter') {
        var fomatters = $d5722bd7562c0432$var$DataTable.ext.type.search;
        if (fomatters[col.sType]) cellData = fomatters[col.sType](cellData);
    }
    return cellData;
}
/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnSetCellData(settings, rowIdx, colIdx, val) {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    col.fnSetData(rowData, val, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
}
/**
 * Write a value to a cell
 * @param {*} td Cell
 * @param {*} val Value
 */ function $d5722bd7562c0432$var$_fnWriteCell(td, val) {
    if (val && typeof val === 'object' && val.nodeName) $d5722bd7562c0432$var$$(td).empty().append(val);
    else td.innerHTML = val;
}
// Private variable that is used to match action syntax in the data property object
var $d5722bd7562c0432$var$__reArray = /\[.*?\]$/;
var $d5722bd7562c0432$var$__reFn = /\(\)$/;
/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */ function $d5722bd7562c0432$var$_fnSplitObjNotation(str) {
    var parts = str.match(/(\\.|[^.])+/g) || [
        ''
    ];
    return parts.map(function(s) {
        return s.replace(/\\\./g, '.');
    });
}
/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */ var $d5722bd7562c0432$var$_fnGetObjectDataFn = $d5722bd7562c0432$var$DataTable.util.get;
/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */ var $d5722bd7562c0432$var$_fnSetObjectDataFn = $d5722bd7562c0432$var$DataTable.util.set;
/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnGetDataMaster(settings) {
    return $d5722bd7562c0432$var$_pluck(settings.aoData, '_aData');
}
/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnClearTable(settings) {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
}
/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */ function $d5722bd7562c0432$var$_fnInvalidate(settings, rowIdx, src, colIdx) {
    var row = settings.aoData[rowIdx];
    var i, ien;
    // Remove the cached data for the row
    row._aSortData = null;
    row._aFilterData = null;
    row.displayData = null;
    // Are we reading last data from DOM or the data object?
    if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') // Read the data from the DOM
    row._aData = $d5722bd7562c0432$var$_fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
    else {
        // Reading from data object, update the DOM
        var cells = row.anCells;
        var display = $d5722bd7562c0432$var$_fnGetRowDisplay(settings, rowIdx);
        if (cells) {
            if (colIdx !== undefined) $d5722bd7562c0432$var$_fnWriteCell(cells[colIdx], display[colIdx]);
            else for(i = 0, ien = cells.length; i < ien; i++)$d5722bd7562c0432$var$_fnWriteCell(cells[i], display[i]);
        }
    }
    // Column specific invalidation
    var cols = settings.aoColumns;
    if (colIdx !== undefined) {
        // Type - the data might have changed
        cols[colIdx].sType = null;
        // Max length string. Its a fairly cheep recalculation, so not worth
        // something more complicated
        cols[colIdx].maxLenString = null;
    } else {
        for(i = 0, ien = cols.length; i < ien; i++){
            cols[i].sType = null;
            cols[i].maxLenString = null;
        }
        // Update DataTables special `DT_*` attributes for the row
        $d5722bd7562c0432$var$_fnRowAttributes(settings, row);
    }
}
/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnGetRowElements(settings, row, colIdx, d) {
    var tds = [], td = row.firstChild, name, col, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
    // Allow the data object to be passed in, or construct
    d = d !== undefined ? d : objectRead ? {} : [];
    var attr = function(str, td) {
        if (typeof str === 'string') {
            var idx = str.indexOf('@');
            if (idx !== -1) {
                var attr = str.substring(idx + 1);
                var setter = $d5722bd7562c0432$var$_fnSetObjectDataFn(str);
                setter(d, td.getAttribute(attr));
            }
        }
    };
    // Read data from a cell and store into the data object
    var cellProcess = function(cell) {
        if (colIdx === undefined || colIdx === i) {
            col = columns[i];
            contents = cell.innerHTML.trim();
            if (col && col._bAttrSrc) {
                var setter = $d5722bd7562c0432$var$_fnSetObjectDataFn(col.mData._);
                setter(d, contents);
                attr(col.mData.sort, cell);
                attr(col.mData.type, cell);
                attr(col.mData.filter, cell);
            } else // Depending on the `data` option for the columns the data can
            // be read to either an object or an array.
            if (objectRead) {
                if (!col._setter) // Cache the setter function
                col._setter = $d5722bd7562c0432$var$_fnSetObjectDataFn(col.mData);
                col._setter(d, contents);
            } else d[i] = contents;
        }
        i++;
    };
    if (td) // `tr` element was passed in
    while(td){
        name = td.nodeName.toUpperCase();
        if (name == "TD" || name == "TH") {
            cellProcess(td);
            tds.push(td);
        }
        td = td.nextSibling;
    }
    else {
        // Existing row object passed in
        tds = row.anCells;
        for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
    }
    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;
    if (rowNode) {
        var id = rowNode.getAttribute('id');
        if (id) $d5722bd7562c0432$var$_fnSetObjectDataFn(settings.rowId)(d, id);
    }
    return {
        data: d,
        cells: tds
    };
}
/**
 * Render and cache a row's display data for the columns, if required
 * @returns 
 */ function $d5722bd7562c0432$var$_fnGetRowDisplay(settings, rowIdx) {
    var rowModal = settings.aoData[rowIdx];
    var columns = settings.aoColumns;
    if (!rowModal.displayData) {
        // Need to render and cache
        rowModal.displayData = [];
        for(var colIdx = 0, len = columns.length; colIdx < len; colIdx++)rowModal.displayData.push($d5722bd7562c0432$var$_fnGetCellData(settings, rowIdx, colIdx, 'display'));
    }
    return rowModal.displayData;
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnCreateTr(oSettings, iRow, nTrIn, anTds) {
    var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create, trClass = oSettings.oClasses.tbody.row;
    if (row.nTr === null) {
        nTr = nTrIn || document.createElement('tr');
        row.nTr = nTr;
        row.anCells = cells;
        $d5722bd7562c0432$var$_addClass(nTr, trClass);
        /* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */ nTr._DT_RowIndex = iRow;
        /* Special parameters can be given by the data source to be used on the row */ $d5722bd7562c0432$var$_fnRowAttributes(oSettings, row);
        /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
            oCol = oSettings.aoColumns[i];
            create = nTrIn && anTds[i] ? false : true;
            nTd = create ? document.createElement(oCol.sCellType) : anTds[i];
            if (!nTd) $d5722bd7562c0432$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
            nTd._DT_CellIndex = {
                row: iRow,
                column: i
            };
            cells.push(nTd);
            var display = $d5722bd7562c0432$var$_fnGetRowDisplay(oSettings, iRow);
            // Need to create the HTML if new, or if a rendering function is defined
            if (create || (oCol.mRender || oCol.mData !== i) && (!$d5722bd7562c0432$var$$.isPlainObject(oCol.mData) || oCol.mData._ !== i + '.display')) $d5722bd7562c0432$var$_fnWriteCell(nTd, display[i]);
            // column class
            $d5722bd7562c0432$var$_addClass(nTd, oCol.sClass);
            // Visibility - add or remove as required
            if (oCol.bVisible && create) nTr.appendChild(nTd);
            else if (!oCol.bVisible && !create) nTd.parentNode.removeChild(nTd);
            if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, $d5722bd7562c0432$var$_fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
        }
        $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoRowCreatedCallback', 'row-created', [
            nTr,
            rowData,
            iRow,
            cells
        ]);
    } else $d5722bd7562c0432$var$_addClass(row.nTr, trClass);
}
/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnRowAttributes(settings, row) {
    var tr = row.nTr;
    var data = row._aData;
    if (tr) {
        var id = settings.rowIdFn(data);
        if (id) tr.id = id;
        if (data.DT_RowClass) {
            // Remove any classes added by DT_RowClass before
            var a = data.DT_RowClass.split(' ');
            row.__rowc = row.__rowc ? $d5722bd7562c0432$var$_unique(row.__rowc.concat(a)) : a;
            $d5722bd7562c0432$var$$(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
        }
        if (data.DT_RowAttr) $d5722bd7562c0432$var$$(tr).attr(data.DT_RowAttr);
        if (data.DT_RowData) $d5722bd7562c0432$var$$(tr).data(data.DT_RowData);
    }
}
/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnBuildHead(settings, side) {
    var classes = settings.oClasses;
    var columns = settings.aoColumns;
    var i, ien, row;
    var target = side === 'header' ? settings.nTHead : settings.nTFoot;
    var titleProp = side === 'header' ? 'sTitle' : side;
    // Footer might be defined
    if (!target) return;
    // If no cells yet and we have content for them, then create
    if (side === 'header' || $d5722bd7562c0432$var$_pluck(settings.aoColumns, titleProp).join('')) {
        row = $d5722bd7562c0432$var$$('tr', target);
        // Add a row if needed
        if (!row.length) row = $d5722bd7562c0432$var$$('<tr/>').appendTo(target);
        // Add the number of cells needed to make up to the number of columns
        if (row.length === 1) {
            var cellCount = 0;
            $d5722bd7562c0432$var$$('td, th', row).each(function() {
                cellCount += this.colSpan;
            });
            for(i = cellCount, ien = columns.length; i < ien; i++)$d5722bd7562c0432$var$$('<th/>').html(columns[i][titleProp] || '').appendTo(row);
        }
    }
    var detected = $d5722bd7562c0432$var$_fnDetectHeader(settings, target, true);
    if (side === 'header') {
        settings.aoHeader = detected;
        $d5722bd7562c0432$var$$('tr', target).addClass(classes.thead.row);
    } else {
        settings.aoFooter = detected;
        $d5722bd7562c0432$var$$('tr', target).addClass(classes.tfoot.row);
    }
    // Every cell needs to be passed through the renderer
    $d5722bd7562c0432$var$$(target).children('tr').children('th, td').each(function() {
        $d5722bd7562c0432$var$_fnRenderer(settings, side)(settings, $d5722bd7562c0432$var$$(this), classes);
    });
}
/**
 * Build a layout structure for a header or footer
 *
 * @param {*} settings DataTables settings
 * @param {*} source Source layout array
 * @param {*} incColumns What columns should be included
 * @returns Layout array
 */ function $d5722bd7562c0432$var$_fnHeaderLayout(settings, source, incColumns) {
    var row, column, cell;
    var local = [];
    var structure = [];
    var columns = settings.aoColumns;
    var columnCount = columns.length;
    var rowspan, colspan;
    if (!source) return;
    // Default is to work on only visible columns
    if (!incColumns) incColumns = $d5722bd7562c0432$var$_range(columnCount).filter(function(idx) {
        return columns[idx].bVisible;
    });
    // Make a copy of the master layout array, but with only the columns we want
    for(row = 0; row < source.length; row++){
        // Remove any columns we haven't selected
        local[row] = source[row].slice().filter(function(cell, i) {
            return incColumns.includes(i);
        });
        // Prep the structure array - it needs an element for each row
        structure.push([]);
    }
    for(row = 0; row < local.length; row++)for(column = 0; column < local[row].length; column++){
        rowspan = 1;
        colspan = 1;
        // Check to see if there is already a cell (row/colspan) covering our target
        // insert point. If there is, then there is nothing to do.
        if (structure[row][column] === undefined) {
            cell = local[row][column].cell;
            // Expand for rowspan
            while(local[row + rowspan] !== undefined && local[row][column].cell == local[row + rowspan][column].cell){
                structure[row + rowspan][column] = null;
                rowspan++;
            }
            // And for colspan
            while(local[row][column + colspan] !== undefined && local[row][column].cell == local[row][column + colspan].cell){
                // Which also needs to go over rows
                for(var k = 0; k < rowspan; k++)structure[row + k][column + colspan] = null;
                colspan++;
            }
            var titleSpan = $d5722bd7562c0432$var$$('span.dt-column-title', cell);
            structure[row][column] = {
                cell: cell,
                colspan: colspan,
                rowspan: rowspan,
                title: titleSpan.length ? titleSpan.html() : $d5722bd7562c0432$var$$(cell).html()
            };
        }
    }
    return structure;
}
/**
 * Draw the header (or footer) element based on the column visibility states.
 *
 *  @param object oSettings dataTables settings object
 *  @param array aoSource Layout array from _fnDetectHeader
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnDrawHead(settings, source) {
    var layout = $d5722bd7562c0432$var$_fnHeaderLayout(settings, source);
    var tr, n;
    for(var row = 0; row < source.length; row++){
        tr = source[row].row;
        // All cells are going to be replaced, so empty out the row
        // Can't use $().empty() as that kills event handlers
        if (tr) while(n = tr.firstChild)tr.removeChild(n);
        for(var column = 0; column < layout[row].length; column++){
            var point = layout[row][column];
            if (point) $d5722bd7562c0432$var$$(point.cell).appendTo(tr).attr('rowspan', point.rowspan).attr('colspan', point.colspan);
        }
    }
}
/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnDraw(oSettings, ajaxComplete) {
    // Allow for state saving and a custom start position
    $d5722bd7562c0432$var$_fnStart(oSettings);
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [
        oSettings
    ]);
    if (aPreDraw.indexOf(false) !== -1) {
        $d5722bd7562c0432$var$_fnProcessingDisplay(oSettings, false);
        return;
    }
    var anRows = [];
    var iRowCount = 0;
    var bServerSide = $d5722bd7562c0432$var$_fnDataSource(oSettings) == 'ssp';
    var aiDisplay = oSettings.aiDisplay;
    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();
    var columns = oSettings.aoColumns;
    var body = $d5722bd7562c0432$var$$(oSettings.nTBody);
    oSettings.bDrawing = true;
    /* Server-side processing draw intercept */ if (oSettings.deferLoading) {
        oSettings.deferLoading = false;
        oSettings.iDraw++;
        $d5722bd7562c0432$var$_fnProcessingDisplay(oSettings, false);
    } else if (!bServerSide) oSettings.iDraw++;
    else if (!oSettings.bDestroying && !ajaxComplete) {
        // Show loading message for server-side processing
        if (oSettings.iDraw === 0) body.empty().append($d5722bd7562c0432$var$_emptyRow(oSettings));
        $d5722bd7562c0432$var$_fnAjaxUpdate(oSettings);
        return;
    }
    if (aiDisplay.length !== 0) {
        var iStart = bServerSide ? 0 : iDisplayStart;
        var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
        for(var j = iStart; j < iEnd; j++){
            var iDataIndex = aiDisplay[j];
            var aoData = oSettings.aoData[iDataIndex];
            if (aoData.nTr === null) $d5722bd7562c0432$var$_fnCreateTr(oSettings, iDataIndex);
            var nRow = aoData.nTr;
            // Add various classes as needed
            for(var i = 0; i < columns.length; i++){
                var col = columns[i];
                var td = aoData.anCells[i];
                $d5722bd7562c0432$var$_addClass(td, $d5722bd7562c0432$var$_ext.type.className[col.sType]); // auto class
                $d5722bd7562c0432$var$_addClass(td, oSettings.oClasses.tbody.cell); // all cells
            }
            // Row callback functions - might want to manipulate the row
            // iRowCount and j are not currently documented. Are they at all
            // useful?
            $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoRowCallback', null, [
                nRow,
                aoData._aData,
                iRowCount,
                j,
                iDataIndex
            ]);
            anRows.push(nRow);
            iRowCount++;
        }
    } else anRows[0] = $d5722bd7562c0432$var$_emptyRow(oSettings);
    /* Header and footer callbacks */ $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [
        $d5722bd7562c0432$var$$(oSettings.nTHead).children('tr')[0],
        $d5722bd7562c0432$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [
        $d5722bd7562c0432$var$$(oSettings.nTFoot).children('tr')[0],
        $d5722bd7562c0432$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    // replaceChildren is faster, but only became widespread in 2020,
    // so a fall back in jQuery is provided for older browsers.
    if (body[0].replaceChildren) body[0].replaceChildren.apply(body[0], anRows);
    else {
        body.children().detach();
        body.append($d5722bd7562c0432$var$$(anRows));
    }
    // Empty table needs a specific class
    $d5722bd7562c0432$var$$(oSettings.nTableWrapper).toggleClass('dt-empty-footer', $d5722bd7562c0432$var$$('tr', oSettings.nTFoot).length === 0);
    /* Call all required callback functions for the end of a draw */ $d5722bd7562c0432$var$_fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [
        oSettings
    ], true);
    /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
}
/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnReDraw(settings, holdPosition, recompute) {
    var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
    if (recompute === undefined || recompute === true) {
        // Resolve any column types that are unknown due to addition or invalidation
        $d5722bd7562c0432$var$_fnColumnTypes(settings);
        if (sort) $d5722bd7562c0432$var$_fnSort(settings);
        if (filter) $d5722bd7562c0432$var$_fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
    }
    if (holdPosition !== true) settings._iDisplayStart = 0;
    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;
    $d5722bd7562c0432$var$_fnDraw(settings);
    settings._drawHold = false;
}
/*
 * Table is empty - create a row with an empty message in it
 */ function $d5722bd7562c0432$var$_emptyRow(settings) {
    var oLang = settings.oLanguage;
    var zero = oLang.sZeroRecords;
    var dataSrc = $d5722bd7562c0432$var$_fnDataSource(settings);
    if (settings.iDraw < 1 && dataSrc === 'ssp' || settings.iDraw <= 1 && dataSrc === 'ajax') zero = oLang.sLoadingRecords;
    else if (oLang.sEmptyTable && settings.fnRecordsTotal() === 0) zero = oLang.sEmptyTable;
    return $d5722bd7562c0432$var$$('<tr/>').append($d5722bd7562c0432$var$$('<td />', {
        'colSpan': $d5722bd7562c0432$var$_fnVisbleColumns(settings),
        'class': settings.oClasses.empty.row
    }).html(zero))[0];
}
/**
 * Expand the layout items into an object for the rendering function
 */ function $d5722bd7562c0432$var$_layoutItems(row, align, items) {
    if (Array.isArray(items)) {
        for(var i = 0; i < items.length; i++)$d5722bd7562c0432$var$_layoutItems(row, align, items[i]);
        return;
    }
    var rowCell = row[align];
    // If it is an object, then there can be multiple features contained in it
    if ($d5722bd7562c0432$var$$.isPlainObject(items)) {
        // A feature plugin cannot be named "features" due to this check
        if (items.features) {
            if (items.rowId) row.id = items.rowId;
            if (items.rowClass) row.className = items.rowClass;
            rowCell.id = items.id;
            rowCell.className = items.className;
            $d5722bd7562c0432$var$_layoutItems(row, align, items.features);
        } else Object.keys(items).map(function(key) {
            rowCell.contents.push({
                feature: key,
                opts: items[key]
            });
        });
    } else rowCell.contents.push(items);
}
/**
 * Find, or create a layout row
 */ function $d5722bd7562c0432$var$_layoutGetRow(rows, rowNum, align) {
    var row;
    // Find existing rows
    for(var i = 0; i < rows.length; i++){
        row = rows[i];
        if (row.rowNum === rowNum) // full is on its own, but start and end share a row
        {
            if (align === 'full' && row.full || (align === 'start' || align === 'end') && (row.start || row.end)) {
                if (!row[align]) row[align] = {
                    contents: []
                };
                return row;
            }
        }
    }
    // If we get this far, then there was no match, create a new row
    row = {
        rowNum: rowNum
    };
    row[align] = {
        contents: []
    };
    rows.push(row);
    return row;
}
/**
 * Convert a `layout` object given by a user to the object structure needed
 * for the renderer. This is done twice, once for above and once for below
 * the table. Ordering must also be considered.
 *
 * @param {*} settings DataTables settings object
 * @param {*} layout Layout object to convert
 * @param {string} side `top` or `bottom`
 * @returns Converted array structure - one item for each row.
 */ function $d5722bd7562c0432$var$_layoutArray(settings, layout, side) {
    var rows = [];
    // Split out into an array
    $d5722bd7562c0432$var$$.each(layout, function(pos, items) {
        if (items === null) return;
        var parts = pos.match(/^([a-z]+)([0-9]*)([A-Za-z]*)$/);
        var rowNum = parts[2] ? parts[2] * 1 : 0;
        var align = parts[3] ? parts[3].toLowerCase() : 'full';
        // Filter out the side we aren't interested in
        if (parts[1] !== side) return;
        // Get or create the row we should attach to
        var row = $d5722bd7562c0432$var$_layoutGetRow(rows, rowNum, align);
        $d5722bd7562c0432$var$_layoutItems(row, align, items);
    });
    // Order by item identifier
    rows.sort(function(a, b) {
        var order1 = a.rowNum;
        var order2 = b.rowNum;
        // If both in the same row, then the row with `full` comes first
        if (order1 === order2) {
            var ret = a.full && !b.full ? -1 : 1;
            return side === 'bottom' ? ret * -1 : ret;
        }
        return order2 - order1;
    });
    // Invert for below the table
    if (side === 'bottom') rows.reverse();
    for(var row = 0; row < rows.length; row++){
        delete rows[row].rowNum;
        $d5722bd7562c0432$var$_layoutResolve(settings, rows[row]);
    }
    return rows;
}
/**
 * Convert the contents of a row's layout object to nodes that can be inserted
 * into the document by a renderer. Execute functions, look up plug-ins, etc.
 *
 * @param {*} settings DataTables settings object
 * @param {*} row Layout object for this row
 */ function $d5722bd7562c0432$var$_layoutResolve(settings, row) {
    var getFeature = function(feature, opts) {
        if (!$d5722bd7562c0432$var$_ext.features[feature]) $d5722bd7562c0432$var$_fnLog(settings, 0, 'Unknown feature: ' + feature);
        return $d5722bd7562c0432$var$_ext.features[feature].apply(this, [
            settings,
            opts
        ]);
    };
    var resolve = function(item) {
        if (!row[item]) return;
        var line = row[item].contents;
        for(var i = 0, ien = line.length; i < ien; i++){
            if (!line[i]) continue;
            else if (typeof line[i] === 'string') line[i] = getFeature(line[i], null);
            else if ($d5722bd7562c0432$var$$.isPlainObject(line[i])) // If it's an object, it just has feature and opts properties from
            // the transform in _layoutArray
            line[i] = getFeature(line[i].feature, line[i].opts);
            else if (typeof line[i].node === 'function') line[i] = line[i].node(settings);
            else if (typeof line[i] === 'function') {
                var inst = line[i](settings);
                line[i] = typeof inst.node === 'function' ? inst.node() : inst;
            }
        }
    };
    resolve('start');
    resolve('end');
    resolve('full');
}
/**
 * Add the options to the page HTML for the table
 *  @param {object} settings DataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAddOptionsHtml(settings) {
    var classes = settings.oClasses;
    var table = $d5722bd7562c0432$var$$(settings.nTable);
    // Wrapper div around everything DataTables controls
    var insert = $d5722bd7562c0432$var$$('<div/>').attr({
        id: settings.sTableId + '_wrapper',
        'class': classes.container
    }).insertBefore(table);
    settings.nTableWrapper = insert[0];
    if (settings.sDom) // Legacy
    $d5722bd7562c0432$var$_fnLayoutDom(settings, settings.sDom, insert);
    else {
        var top = $d5722bd7562c0432$var$_layoutArray(settings, settings.layout, 'top');
        var bottom = $d5722bd7562c0432$var$_layoutArray(settings, settings.layout, 'bottom');
        var renderer = $d5722bd7562c0432$var$_fnRenderer(settings, 'layout');
        // Everything above - the renderer will actually insert the contents into the document
        top.forEach(function(item) {
            renderer(settings, insert, item);
        });
        // The table - always the center of attention
        renderer(settings, insert, {
            full: {
                table: true,
                contents: [
                    $d5722bd7562c0432$var$_fnFeatureHtmlTable(settings)
                ]
            }
        });
        // Everything below
        bottom.forEach(function(item) {
            renderer(settings, insert, item);
        });
    }
    // Processing floats on top, so it isn't an inserted feature
    $d5722bd7562c0432$var$_processingHtml(settings);
}
/**
 * Draw the table with the legacy DOM property
 * @param {*} settings DT settings object
 * @param {*} dom DOM string
 * @param {*} insert Insert point
 */ function $d5722bd7562c0432$var$_fnLayoutDom(settings, dom, insert) {
    var parts = dom.match(/(".*?")|('.*?')|./g);
    var featureNode, option, newNode, next, attr;
    for(var i = 0; i < parts.length; i++){
        featureNode = null;
        option = parts[i];
        if (option == '<') {
            // New container div
            newNode = $d5722bd7562c0432$var$$('<div/>');
            // Check to see if we should append an id and/or a class name to the container
            next = parts[i + 1];
            if (next[0] == "'" || next[0] == '"') {
                attr = next.replace(/['"]/g, '');
                var id = '', className;
                /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */ if (attr.indexOf('.') != -1) {
                    var split = attr.split('.');
                    id = split[0];
                    className = split[1];
                } else if (attr[0] == "#") id = attr;
                else className = attr;
                newNode.attr('id', id.substring(1)).addClass(className);
                i++; // Move along the position array
            }
            insert.append(newNode);
            insert = newNode;
        } else if (option == '>') // End container div
        insert = insert.parent();
        else if (option == 't') // Table
        featureNode = $d5722bd7562c0432$var$_fnFeatureHtmlTable(settings);
        else $d5722bd7562c0432$var$DataTable.ext.feature.forEach(function(feature) {
            if (option == feature.cFeature) featureNode = feature.fnInit(settings);
        });
        // Add to the display
        if (featureNode) insert.append(featureNode);
    }
}
/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell that that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param {node} thead The header/footer element for the table
 *  @returns {array} Calculated layout array
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnDetectHeader(settings, thead, write) {
    var columns = settings.aoColumns;
    var rows = $d5722bd7562c0432$var$$(thead).children('tr');
    var row, cell;
    var i, k, l, iLen, shifted, column, colspan, rowspan;
    var isHeader = thead && thead.nodeName.toLowerCase() === 'thead';
    var layout = [];
    var unique;
    var shift = function(a, i, j) {
        var k = a[i];
        while(k[j])j++;
        return j;
    };
    // We know how many rows there are in the layout - so prep it
    for(i = 0, iLen = rows.length; i < iLen; i++)layout.push([]);
    for(i = 0, iLen = rows.length; i < iLen; i++){
        row = rows[i];
        column = 0;
        // For every cell in the row..
        cell = row.firstChild;
        while(cell){
            if (cell.nodeName.toUpperCase() == 'TD' || cell.nodeName.toUpperCase() == 'TH') {
                var cols = [];
                // Get the col and rowspan attributes from the DOM and sanitise them
                colspan = cell.getAttribute('colspan') * 1;
                rowspan = cell.getAttribute('rowspan') * 1;
                colspan = !colspan || colspan === 0 || colspan === 1 ? 1 : colspan;
                rowspan = !rowspan || rowspan === 0 || rowspan === 1 ? 1 : rowspan;
                // There might be colspan cells already in this row, so shift our target
                // accordingly
                shifted = shift(layout, i, column);
                // Cache calculation for unique columns
                unique = colspan === 1 ? true : false;
                // Perform header setup
                if (write) {
                    if (unique) {
                        // Allow column options to be set from HTML attributes
                        $d5722bd7562c0432$var$_fnColumnOptions(settings, shifted, $d5722bd7562c0432$var$$(cell).data());
                        // Get the width for the column. This can be defined from the
                        // width attribute, style attribute or `columns.width` option
                        var columnDef = columns[shifted];
                        var width = cell.getAttribute('width') || null;
                        var t = cell.style.width.match(/width:\s*(\d+[pxem%]+)/);
                        if (t) width = t[1];
                        columnDef.sWidthOrig = columnDef.sWidth || width;
                        if (isHeader) {
                            // Column title handling - can be user set, or read from the DOM
                            // This happens before the render, so the original is still in place
                            if (columnDef.sTitle !== null && !columnDef.autoTitle) cell.innerHTML = columnDef.sTitle;
                            if (!columnDef.sTitle && unique) {
                                columnDef.sTitle = $d5722bd7562c0432$var$_stripHtml(cell.innerHTML);
                                columnDef.autoTitle = true;
                            }
                        } else // Footer specific operations
                        if (columnDef.footer) cell.innerHTML = columnDef.footer;
                        // Fall back to the aria-label attribute on the table header if no ariaTitle is
                        // provided.
                        if (!columnDef.ariaTitle) columnDef.ariaTitle = $d5722bd7562c0432$var$$(cell).attr("aria-label") || columnDef.sTitle;
                        // Column specific class names
                        if (columnDef.className) $d5722bd7562c0432$var$$(cell).addClass(columnDef.className);
                    }
                    // Wrap the column title so we can write to it in future
                    if ($d5722bd7562c0432$var$$('span.dt-column-title', cell).length === 0) $d5722bd7562c0432$var$$('<span>').addClass('dt-column-title').append(cell.childNodes).appendTo(cell);
                    if (isHeader && $d5722bd7562c0432$var$$('span.dt-column-order', cell).length === 0) $d5722bd7562c0432$var$$('<span>').addClass('dt-column-order').appendTo(cell);
                }
                // If there is col / rowspan, copy the information into the layout grid
                for(l = 0; l < colspan; l++){
                    for(k = 0; k < rowspan; k++){
                        layout[i + k][shifted + l] = {
                            cell: cell,
                            unique: unique
                        };
                        layout[i + k].row = row;
                    }
                    cols.push(shifted + l);
                }
                // Assign an attribute so spanning cells can still be identified
                // as belonging to a column
                cell.setAttribute('data-dt-column', $d5722bd7562c0432$var$_unique(cols).join(','));
            }
            cell = cell.nextSibling;
        }
    }
    return layout;
}
/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */ function $d5722bd7562c0432$var$_fnStart(oSettings) {
    var bServerSide = $d5722bd7562c0432$var$_fnDataSource(oSettings) == 'ssp';
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    // Check and see if we have an initial draw position from state saving
    if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
        oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
        oSettings.iInitDisplayStart = -1;
    }
}
/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */ function $d5722bd7562c0432$var$_fnBuildAjax(oSettings, data, fn) {
    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function(json) {
        var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
        if (json === null || typeof status === 'number' && status == 204) {
            json = {};
            $d5722bd7562c0432$var$_fnAjaxDataSrc(oSettings, json, []);
        }
        var error = json.error || json.sError;
        if (error) $d5722bd7562c0432$var$_fnLog(oSettings, 0, error);
        // Microsoft often wrap JSON as a string in another JSON object
        // Let's handle that automatically
        if (json.d && typeof json.d === 'string') try {
            json = JSON.parse(json.d);
        } catch (e) {
        // noop
        }
        oSettings.json = json;
        $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'xhr', [
            oSettings,
            json,
            oSettings.jqXHR
        ], true);
        fn(json);
    };
    if ($d5722bd7562c0432$var$$.isPlainObject(ajax) && ajax.data) {
        ajaxData = ajax.data;
        var newData = typeof ajaxData === 'function' ? ajaxData(data, oSettings) : ajaxData; // an object object or array to merge
        // If the function returned something, use that alone
        data = typeof ajaxData === 'function' && newData ? newData : $d5722bd7562c0432$var$$.extend(true, data, newData);
        // Remove the data property as we've resolved it already and don't want
        // jQuery to do it again (it is restored at the end of the function)
        delete ajax.data;
    }
    var baseAjax = {
        "url": typeof ajax === 'string' ? ajax : '',
        "data": data,
        "success": callback,
        "dataType": "json",
        "cache": false,
        "type": oSettings.sServerMethod,
        "error": function(xhr, error) {
            var ret = $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'xhr', [
                oSettings,
                null,
                oSettings.jqXHR
            ], true);
            if (ret.indexOf(true) === -1) {
                if (error == "parsererror") $d5722bd7562c0432$var$_fnLog(oSettings, 0, 'Invalid JSON response', 1);
                else if (xhr.readyState === 4) $d5722bd7562c0432$var$_fnLog(oSettings, 0, 'Ajax error', 7);
            }
            $d5722bd7562c0432$var$_fnProcessingDisplay(oSettings, false);
        }
    };
    // If `ajax` option is an object, extend and override our default base
    if ($d5722bd7562c0432$var$$.isPlainObject(ajax)) $d5722bd7562c0432$var$$.extend(baseAjax, ajax);
    // Store the data submitted for the API
    oSettings.oAjaxData = data;
    // Allow plug-ins and external processes to modify the data
    $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'preXhr', [
        oSettings,
        data,
        baseAjax
    ], true);
    if (typeof ajax === 'function') // Is a function - let the caller define what needs to be done
    oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
    else if (ajax.url === '') {
        // No url, so don't load any data. Just apply an empty data array
        // to the object for the callback.
        var empty = {};
        $d5722bd7562c0432$var$DataTable.util.set(ajax.dataSrc)(empty, []);
        callback(empty);
    } else // Object to extend the base settings
    oSettings.jqXHR = $d5722bd7562c0432$var$$.ajax(baseAjax);
    // Restore for next time around
    if (ajaxData) ajax.data = ajaxData;
}
/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAjaxUpdate(settings) {
    settings.iDraw++;
    $d5722bd7562c0432$var$_fnProcessingDisplay(settings, true);
    $d5722bd7562c0432$var$_fnBuildAjax(settings, $d5722bd7562c0432$var$_fnAjaxParameters(settings), function(json) {
        $d5722bd7562c0432$var$_fnAjaxUpdateDraw(settings, json);
    });
}
/**
 * Build up the parameters in an object needed for a server-side processing
 * request.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAjaxParameters(settings) {
    var columns = settings.aoColumns, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, colData = function(idx, prop) {
        return typeof columns[idx][prop] === 'function' ? 'function' : columns[idx][prop];
    };
    return {
        draw: settings.iDraw,
        columns: columns.map(function(column, i) {
            return {
                data: colData(i, 'mData'),
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: preColSearch[i].search,
                    regex: preColSearch[i].regex,
                    fixed: Object.keys(column.searchFixed).map(function(name) {
                        return {
                            name: name,
                            term: column.searchFixed[name].toString()
                        };
                    })
                }
            };
        }),
        order: $d5722bd7562c0432$var$_fnSortFlatten(settings).map(function(val) {
            return {
                column: val.col,
                dir: val.dir,
                name: colData(val.col, 'sName')
            };
        }),
        start: settings._iDisplayStart,
        length: features.bPaginate ? settings._iDisplayLength : -1,
        search: {
            value: preSearch.search,
            regex: preSearch.regex,
            fixed: Object.keys(settings.searchFixed).map(function(name) {
                return {
                    name: name,
                    term: settings.searchFixed[name].toString()
                };
            })
        }
    };
}
/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnAjaxUpdateDraw(settings, json) {
    var data = $d5722bd7562c0432$var$_fnAjaxDataSrc(settings, json);
    var draw = $d5722bd7562c0432$var$_fnAjaxDataSrcParam(settings, 'draw', json);
    var recordsTotal = $d5722bd7562c0432$var$_fnAjaxDataSrcParam(settings, 'recordsTotal', json);
    var recordsFiltered = $d5722bd7562c0432$var$_fnAjaxDataSrcParam(settings, 'recordsFiltered', json);
    if (draw !== undefined) {
        // Protect against out of sequence returns
        if (draw * 1 < settings.iDraw) return;
        settings.iDraw = draw * 1;
    }
    // No data in returned object, so rather than an array, we show an empty table
    if (!data) data = [];
    $d5722bd7562c0432$var$_fnClearTable(settings);
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
    for(var i = 0, ien = data.length; i < ien; i++)$d5722bd7562c0432$var$_fnAddData(settings, data[i]);
    settings.aiDisplay = settings.aiDisplayMaster.slice();
    $d5722bd7562c0432$var$_fnColumnTypes(settings);
    $d5722bd7562c0432$var$_fnDraw(settings, true);
    $d5722bd7562c0432$var$_fnInitComplete(settings);
    $d5722bd7562c0432$var$_fnProcessingDisplay(settings, false);
}
/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} settings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */ function $d5722bd7562c0432$var$_fnAjaxDataSrc(settings, json, write) {
    var dataProp = 'data';
    if ($d5722bd7562c0432$var$$.isPlainObject(settings.ajax) && settings.ajax.dataSrc !== undefined) {
        // Could in inside a `dataSrc` object, or not!
        var dataSrc = settings.ajax.dataSrc;
        // string, function and object are valid types
        if (typeof dataSrc === 'string' || typeof dataSrc === 'function') dataProp = dataSrc;
        else if (dataSrc.data !== undefined) dataProp = dataSrc.data;
    }
    if (!write) {
        if (dataProp === 'data') // If the default, then we still want to support the old style, and safely ignore
        // it if possible
        return json.aaData || json[dataProp];
        return dataProp !== "" ? $d5722bd7562c0432$var$_fnGetObjectDataFn(dataProp)(json) : json;
    }
    // set
    $d5722bd7562c0432$var$_fnSetObjectDataFn(dataProp)(json, write);
}
/**
 * Very similar to _fnAjaxDataSrc, but for the other SSP properties
 * @param {*} settings DataTables settings object
 * @param {*} param Target parameter
 * @param {*} json JSON data
 * @returns Resolved value
 */ function $d5722bd7562c0432$var$_fnAjaxDataSrcParam(settings, param, json) {
    var dataSrc = $d5722bd7562c0432$var$$.isPlainObject(settings.ajax) ? settings.ajax.dataSrc : null;
    if (dataSrc && dataSrc[param]) // Get from custom location
    return $d5722bd7562c0432$var$_fnGetObjectDataFn(dataSrc[param])(json);
    // else - Default behaviour
    var old = '';
    // Legacy support
    if (param === 'draw') old = 'sEcho';
    else if (param === 'recordsTotal') old = 'iTotalRecords';
    else if (param === 'recordsFiltered') old = 'iTotalDisplayRecords';
    return json[old] !== undefined ? json[old] : json[param];
}
/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} settings dataTables settings object
 *  @param {object} input search information
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnFilterComplete(settings, input) {
    var columnsSearch = settings.aoPreSearchCols;
    // In server-side processing all filtering is done by the server, so no point hanging around here
    if ($d5722bd7562c0432$var$_fnDataSource(settings) != 'ssp') {
        // Check if any of the rows were invalidated
        $d5722bd7562c0432$var$_fnFilterData(settings);
        // Start from the full data set
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Global filter first
        $d5722bd7562c0432$var$_fnFilter(settings.aiDisplay, settings, input.search, input);
        $d5722bd7562c0432$var$$.each(settings.searchFixed, function(name, term) {
            $d5722bd7562c0432$var$_fnFilter(settings.aiDisplay, settings, term, {});
        });
        // Then individual column filters
        for(var i = 0; i < columnsSearch.length; i++){
            var col = columnsSearch[i];
            $d5722bd7562c0432$var$_fnFilter(settings.aiDisplay, settings, col.search, col, i);
            $d5722bd7562c0432$var$$.each(settings.aoColumns[i].searchFixed, function(name, term) {
                $d5722bd7562c0432$var$_fnFilter(settings.aiDisplay, settings, term, {}, i);
            });
        }
        // And finally global filtering
        $d5722bd7562c0432$var$_fnFilterCustom(settings);
    }
    // Tell the draw function we have been filtering
    settings.bFiltered = true;
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'search', [
        settings
    ]);
}
/**
 * Apply custom filtering functions
 * 
 * This is legacy now that we have named functions, but it is widely used
 * from 1.x, so it is not yet deprecated.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnFilterCustom(settings) {
    var filters = $d5722bd7562c0432$var$DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;
    for(var i = 0, ien = filters.length; i < ien; i++){
        var rows = [];
        // Loop over each row and see if it should be included
        for(var j = 0, jen = displayRows.length; j < jen; j++){
            rowIdx = displayRows[j];
            row = settings.aoData[rowIdx];
            if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
        }
        // So the array reference doesn't break set the results into the
        // existing array
        displayRows.length = 0;
        $d5722bd7562c0432$var$_fnArrayApply(displayRows, rows);
    }
}
/**
 * Filter the data table based on user input and draw the table
 */ function $d5722bd7562c0432$var$_fnFilter(searchRows, settings, input, options, column) {
    if (input === '') return;
    var i = 0;
    var matched = [];
    // Search term can be a function, regex or string - if a string we apply our
    // smart filtering regex (assuming the options require that)
    var searchFunc = typeof input === 'function' ? input : null;
    var rpSearch = input instanceof RegExp ? input : searchFunc ? null : $d5722bd7562c0432$var$_fnFilterCreateSearch(input, options);
    // Then for each row, does the test pass. If not, lop the row from the array
    for(i = 0; i < searchRows.length; i++){
        var row = settings.aoData[searchRows[i]];
        var data = column === undefined ? row._sFilterRow : row._aFilterData[column];
        if (searchFunc && searchFunc(data, row._aData, searchRows[i], column) || rpSearch && rpSearch.test(data)) matched.push(searchRows[i]);
    }
    // Mutate the searchRows array
    searchRows.length = matched.length;
    for(i = 0; i < matched.length; i++)searchRows[i] = matched[i];
}
/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnFilterCreateSearch(search, inOpts) {
    var not = [];
    var options = $d5722bd7562c0432$var$$.extend({}, {
        boundary: false,
        caseInsensitive: true,
        exact: false,
        regex: false,
        smart: true
    }, inOpts);
    if (typeof search !== 'string') search = search.toString();
    // Remove diacritics if normalize is set up to do so
    search = $d5722bd7562c0432$var$_normalize(search);
    if (options.exact) return new RegExp('^' + $d5722bd7562c0432$var$_fnEscapeRegex(search) + '$', options.caseInsensitive ? 'i' : '');
    search = options.regex ? search : $d5722bd7562c0432$var$_fnEscapeRegex(search);
    if (options.smart) {
        /* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. And a negative look around for
		 * finding rows which don't contain a given string.
		 * 
		 * So this is the sort of thing we want to generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */ var parts = search.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [
            ''
        ];
        var a = parts.map(function(word) {
            var negative = false;
            var m;
            // Determine if it is a "does not include"
            if (word.charAt(0) === '!') {
                negative = true;
                word = word.substring(1);
            }
            // Strip the quotes from around matched phrases
            if (word.charAt(0) === '"') {
                m = word.match(/^"(.*)"$/);
                word = m ? m[1] : word;
            } else if (word.charAt(0) === '\u201C') {
                // Smart quote match (iPhone users)
                m = word.match(/^\u201C(.*)\u201D$/);
                word = m ? m[1] : word;
            }
            // For our "not" case, we need to modify the string that is
            // allowed to match at the end of the expression.
            if (negative) {
                if (word.length > 1) not.push('(?!' + word + ')');
                word = '';
            }
            return word.replace(/"/g, '');
        });
        var match = not.length ? not.join('') : '';
        var boundary = options.boundary ? '\\b' : '';
        search = '^(?=.*?' + boundary + a.join(')(?=.*?' + boundary) + ')(' + match + '.)*$';
    }
    return new RegExp(search, options.caseInsensitive ? 'i' : '');
}
/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */ var $d5722bd7562c0432$var$_fnEscapeRegex = $d5722bd7562c0432$var$DataTable.util.escapeRegex;
var $d5722bd7562c0432$var$__filter_div = $d5722bd7562c0432$var$$('<div>')[0];
var $d5722bd7562c0432$var$__filter_div_textContent = $d5722bd7562c0432$var$__filter_div.textContent !== undefined;
// Update the filtering data for each row if needed (by invalidation or first run)
function $d5722bd7562c0432$var$_fnFilterData(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var column;
    var j, jen, filterData, cellData, row;
    var wasInvalidated = false;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aFilterData) {
            filterData = [];
            for(j = 0, jen = columns.length; j < jen; j++){
                column = columns[j];
                if (column.bSearchable) {
                    cellData = $d5722bd7562c0432$var$_fnGetCellData(settings, rowIdx, j, 'filter');
                    // Search in DataTables is string based
                    if (cellData === null) cellData = '';
                    if (typeof cellData !== 'string' && cellData.toString) cellData = cellData.toString();
                } else cellData = '';
                // If it looks like there is an HTML entity in the string,
                // attempt to decode it so sorting works as expected. Note that
                // we could use a single line of jQuery to do this, but the DOM
                // method used here is much faster https://jsperf.com/html-decode
                if (cellData.indexOf && cellData.indexOf('&') !== -1) {
                    $d5722bd7562c0432$var$__filter_div.innerHTML = cellData;
                    cellData = $d5722bd7562c0432$var$__filter_div_textContent ? $d5722bd7562c0432$var$__filter_div.textContent : $d5722bd7562c0432$var$__filter_div.innerText;
                }
                if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, '');
                filterData.push(cellData);
            }
            row._aFilterData = filterData;
            row._sFilterRow = filterData.join('  ');
            wasInvalidated = true;
        }
    }
    return wasInvalidated;
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnInitialise(settings) {
    var i;
    var init = settings.oInit;
    var deferLoading = settings.deferLoading;
    var dataSrc = $d5722bd7562c0432$var$_fnDataSource(settings);
    // Ensure that the table data is fully initialised
    if (!settings.bInitialised) {
        setTimeout(function() {
            $d5722bd7562c0432$var$_fnInitialise(settings);
        }, 200);
        return;
    }
    // Build the header / footer for the table
    $d5722bd7562c0432$var$_fnBuildHead(settings, 'header');
    $d5722bd7562c0432$var$_fnBuildHead(settings, 'footer');
    // Load the table's state (if needed) and then render around it and draw
    $d5722bd7562c0432$var$_fnLoadState(settings, init, function() {
        // Then draw the header / footer
        $d5722bd7562c0432$var$_fnDrawHead(settings, settings.aoHeader);
        $d5722bd7562c0432$var$_fnDrawHead(settings, settings.aoFooter);
        // Cache the paging start point, as the first redraw will reset it
        var iAjaxStart = settings.iInitDisplayStart;
        // Local data load
        // Check if there is data passing into the constructor
        if (init.aaData) for(i = 0; i < init.aaData.length; i++)$d5722bd7562c0432$var$_fnAddData(settings, init.aaData[i]);
        else if (deferLoading || dataSrc == 'dom') // Grab the data from the page
        $d5722bd7562c0432$var$_fnAddTr(settings, $d5722bd7562c0432$var$$(settings.nTBody).children('tr'));
        // Filter not yet applied - copy the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Enable features
        $d5722bd7562c0432$var$_fnAddOptionsHtml(settings);
        $d5722bd7562c0432$var$_fnSortInit(settings);
        $d5722bd7562c0432$var$_colGroup(settings);
        /* Okay to show that something is going on now */ $d5722bd7562c0432$var$_fnProcessingDisplay(settings, true);
        $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'preInit', [
            settings
        ], true);
        // If there is default sorting required - let's do it. The sort function
        // will do the drawing for us. Otherwise we draw the table regardless of the
        // Ajax source - this allows the table to look initialised for Ajax sourcing
        // data (show 'loading' message possibly)
        $d5722bd7562c0432$var$_fnReDraw(settings);
        // Server-side processing init complete is done by _fnAjaxUpdateDraw
        if (dataSrc != 'ssp' || deferLoading) {
            // if there is an ajax source load the data
            if (dataSrc == 'ajax') $d5722bd7562c0432$var$_fnBuildAjax(settings, {}, function(json) {
                var aData = $d5722bd7562c0432$var$_fnAjaxDataSrc(settings, json);
                // Got the data - add it to the table
                for(i = 0; i < aData.length; i++)$d5722bd7562c0432$var$_fnAddData(settings, aData[i]);
                // Reset the init display for cookie saving. We've already done
                // a filter, and therefore cleared it before. So we need to make
                // it appear 'fresh'
                settings.iInitDisplayStart = iAjaxStart;
                $d5722bd7562c0432$var$_fnReDraw(settings);
                $d5722bd7562c0432$var$_fnProcessingDisplay(settings, false);
                $d5722bd7562c0432$var$_fnInitComplete(settings);
            }, settings);
            else {
                $d5722bd7562c0432$var$_fnInitComplete(settings);
                $d5722bd7562c0432$var$_fnProcessingDisplay(settings, false);
            }
        }
    });
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnInitComplete(settings) {
    if (settings._bInitComplete) return;
    var args = [
        settings,
        settings.json
    ];
    settings._bInitComplete = true;
    // Table is fully set up and we have data, so calculate the
    // column widths
    $d5722bd7562c0432$var$_fnAdjustColumnSizing(settings);
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'plugin-init', args, true);
    $d5722bd7562c0432$var$_fnCallbackFire(settings, 'aoInitComplete', 'init', args, true);
}
function $d5722bd7562c0432$var$_fnLengthChange(settings, val) {
    var len = parseInt(val, 10);
    settings._iDisplayLength = len;
    $d5722bd7562c0432$var$_fnLengthOverflow(settings);
    // Fire length change event
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'length', [
        settings,
        len
    ]);
}
/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnPageChange(settings, action, redraw) {
    var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
    if (records === 0 || len === -1) start = 0;
    else if (typeof action === "number") {
        start = action * len;
        if (start > records) start = 0;
    } else if (action == "first") start = 0;
    else if (action == "previous") {
        start = len >= 0 ? start - len : 0;
        if (start < 0) start = 0;
    } else if (action == "next") {
        if (start + len < records) start += len;
    } else if (action == "last") start = Math.floor((records - 1) / len) * len;
    else if (action === 'ellipsis') return;
    else $d5722bd7562c0432$var$_fnLog(settings, 0, "Unknown paging action: " + action, 5);
    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, changed ? 'page' : 'page-nc', [
        settings
    ]);
    if (changed && redraw) $d5722bd7562c0432$var$_fnDraw(settings);
    return changed;
}
/**
 * Generate the node required for the processing node
 *  @param {object} settings DataTables settings object
 */ function $d5722bd7562c0432$var$_processingHtml(settings) {
    var table = settings.nTable;
    var scrolling = settings.oScroll.sX !== '' || settings.oScroll.sY !== '';
    if (settings.oFeatures.bProcessing) {
        var n = $d5722bd7562c0432$var$$('<div/>', {
            'id': settings.sTableId + '_processing',
            'class': settings.oClasses.processing.container,
            'role': 'status'
        }).html(settings.oLanguage.sProcessing).append('<div><div></div><div></div><div></div><div></div></div>');
        // Different positioning depending on if scrolling is enabled or not
        if (scrolling) n.prependTo($d5722bd7562c0432$var$$('div.dt-scroll', settings.nTableWrapper));
        else n.insertBefore(table);
        $d5722bd7562c0432$var$$(table).on('processing.dt.DT', function(e, s, show) {
            n.css('display', show ? 'block' : 'none');
        });
    }
}
/**
 * Display or hide the processing indicator
 *  @param {object} settings DataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 */ function $d5722bd7562c0432$var$_fnProcessingDisplay(settings, show) {
    // Ignore cases when we are still redrawing
    if (settings.bDrawing && show === false) return;
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'processing', [
        settings,
        show
    ]);
}
/**
 * Show the processing element if an action takes longer than a given time
 *
 * @param {*} settings DataTables settings object
 * @param {*} enable Do (true) or not (false) async processing (local feature enablement)
 * @param {*} run Function to run
 */ function $d5722bd7562c0432$var$_fnProcessingRun(settings, enable, run) {
    if (!enable) // Immediate execution, synchronous
    run();
    else {
        $d5722bd7562c0432$var$_fnProcessingDisplay(settings, true);
        // Allow the processing display to show if needed
        setTimeout(function() {
            run();
            $d5722bd7562c0432$var$_fnProcessingDisplay(settings, false);
        }, 0);
    }
}
/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnFeatureHtmlTable(settings) {
    var table = $d5722bd7562c0432$var$$(settings.nTable);
    // Scrolling from here on in
    var scroll = settings.oScroll;
    if (scroll.sX === '' && scroll.sY === '') return settings.nTable;
    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses.scrolling;
    var caption = settings.captionNode;
    var captionSide = caption ? caption._captionSide : null;
    var headerClone = $d5722bd7562c0432$var$$(table[0].cloneNode(false));
    var footerClone = $d5722bd7562c0432$var$$(table[0].cloneNode(false));
    var footer = table.children('tfoot');
    var _div = '<div/>';
    var size = function(s) {
        return !s ? null : $d5722bd7562c0432$var$_fnStringToCss(s);
    };
    if (!footer.length) footer = null;
    /*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */ var scroller = $d5722bd7562c0432$var$$(_div, {
        'class': classes.container
    }).append($d5722bd7562c0432$var$$(_div, {
        'class': classes.header.self
    }).css({
        overflow: 'hidden',
        position: 'relative',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($d5722bd7562c0432$var$$(_div, {
        'class': classes.header.inner
    }).css({
        'box-sizing': 'content-box',
        width: scroll.sXInner || '100%'
    }).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($d5722bd7562c0432$var$$(_div, {
        'class': classes.body
    }).css({
        position: 'relative',
        overflow: 'auto',
        width: size(scrollX)
    }).append(table));
    if (footer) scroller.append($d5722bd7562c0432$var$$(_div, {
        'class': classes.footer.self
    }).css({
        overflow: 'hidden',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($d5722bd7562c0432$var$$(_div, {
        'class': classes.footer.inner
    }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;
    // When the body is scrolled, then we also want to scroll the headers
    $d5722bd7562c0432$var$$(scrollBody).on('scroll.DT', function() {
        var scrollLeft = this.scrollLeft;
        scrollHead.scrollLeft = scrollLeft;
        if (footer) scrollFoot.scrollLeft = scrollLeft;
    });
    // When focus is put on the header cells, we might need to scroll the body
    $d5722bd7562c0432$var$$('th, td', scrollHead).on('focus', function() {
        var scrollLeft = scrollHead.scrollLeft;
        scrollBody.scrollLeft = scrollLeft;
        if (footer) scrollBody.scrollLeft = scrollLeft;
    });
    $d5722bd7562c0432$var$$(scrollBody).css('max-height', scrollY);
    if (!scroll.bCollapse) $d5722bd7562c0432$var$$(scrollBody).css('height', scrollY);
    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;
    // On redraw - align columns
    settings.aoDrawCallback.push($d5722bd7562c0432$var$_fnScrollDraw);
    return scroller[0];
}
/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Correct colgroup > col values if needed
 *   3. Copy colgroup > col over to header and footer
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnScrollDraw(settings) {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var scroll = settings.oScroll, barWidth = scroll.iBarWidth, divHeader = $d5722bd7562c0432$var$$(settings.nScrollHead), divHeaderInner = divHeader.children('div'), divHeaderTable = divHeaderInner.children('table'), divBodyEl = settings.nScrollBody, divBody = $d5722bd7562c0432$var$$(divBodyEl), divFooter = $d5722bd7562c0432$var$$(settings.nScrollFoot), divFooterInner = divFooter.children('div'), divFooterTable = divFooterInner.children('table'), header = $d5722bd7562c0432$var$$(settings.nTHead), table = $d5722bd7562c0432$var$$(settings.nTable), footer = settings.nTFoot && $d5722bd7562c0432$var$$('th, td', settings.nTFoot).length ? $d5722bd7562c0432$var$$(settings.nTFoot) : null, browser = settings.oBrowser, headerCopy, footerCopy;
    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
    if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
        settings.scrollBarVis = scrollBarVis;
        $d5722bd7562c0432$var$_fnAdjustColumnSizing(settings);
        return; // adjust column sizing will call this function again
    } else settings.scrollBarVis = scrollBarVis;
    // 1. Re-create the table inside the scrolling div
    // Remove the old minimised thead and tfoot elements in the inner table
    table.children('thead, tfoot').remove();
    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo(table);
    headerCopy.find('th, td').removeAttr('tabindex');
    headerCopy.find('[id]').removeAttr('id');
    if (footer) {
        footerCopy = footer.clone().prependTo(table);
        footerCopy.find('[id]').removeAttr('id');
    }
    // 2. Correct colgroup > col values if needed
    // It is possible that the cell sizes are smaller than the content, so we need to
    // correct colgroup>col for such cases. This can happen if the auto width detection
    // uses a cell which has a longer string, but isn't the widest! For example 
    // "Chief Executive Officer (CEO)" is the longest string in the demo, but
    // "Systems Administrator" is actually the widest string since it doesn't collapse.
    // Note the use of translating into a column index to get the `col` element. This
    // is because of Responsive which might remove `col` elements, knocking the alignment
    // of the indexes out.
    if (settings.aiDisplay.length) {
        // Get the column sizes from the first row in the table. This should really be a
        // [].find, but it wasn't supported in Chrome until Sept 2015, and DT has 10 year
        // browser support
        var firstTr = null;
        var start = $d5722bd7562c0432$var$_fnDataSource(settings) !== 'ssp' ? settings._iDisplayStart : 0;
        for(i = start; i < start + settings.aiDisplay.length; i++){
            var idx = settings.aiDisplay[i];
            var tr = settings.aoData[idx].nTr;
            if (tr) {
                firstTr = tr;
                break;
            }
        }
        if (firstTr) {
            var colSizes = $d5722bd7562c0432$var$$(firstTr).children('th, td').map(function(vis) {
                return {
                    idx: $d5722bd7562c0432$var$_fnVisibleToColumnIndex(settings, vis),
                    width: $d5722bd7562c0432$var$$(this).outerWidth()
                };
            });
            // Check against what the colgroup > col is set to and correct if needed
            for(var i = 0; i < colSizes.length; i++){
                var colEl = settings.aoColumns[colSizes[i].idx].colEl[0];
                var colWidth = colEl.style.width.replace('px', '');
                if (colWidth !== colSizes[i].width) {
                    colEl.style.width = colSizes[i].width + 'px';
                    if (scroll.sX) colEl.style.minWidth = colSizes[i].width + 'px';
                }
            }
        }
    }
    // 3. Copy the colgroup over to the header and footer
    divHeaderTable.find('colgroup').remove();
    divHeaderTable.append(settings.colgroup.clone());
    if (footer) {
        divFooterTable.find('colgroup').remove();
        divFooterTable.append(settings.colgroup.clone());
    }
    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely.
    $d5722bd7562c0432$var$$('th, td', headerCopy).each(function() {
        $d5722bd7562c0432$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    if (footer) $d5722bd7562c0432$var$$('th, td', footerCopy).each(function() {
        $d5722bd7562c0432$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing">');
    });
    // 4. Clean up
    // Figure out if there are scrollbar present - if so then we need a the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var isScrolling = Math.floor(table.height()) > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
    var paddingSide = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
    // Set the width's of the header and footer tables
    var outerWidth = table.outerWidth();
    divHeaderTable.css('width', $d5722bd7562c0432$var$_fnStringToCss(outerWidth));
    divHeaderInner.css('width', $d5722bd7562c0432$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    if (footer) {
        divFooterTable.css('width', $d5722bd7562c0432$var$_fnStringToCss(outerWidth));
        divFooterInner.css('width', $d5722bd7562c0432$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    }
    // Correct DOM ordering for colgroup - comes before the thead
    table.children('colgroup').prependTo(table);
    // Adjust the position of the header in case we loose the y-scrollbar
    divBody.trigger('scroll');
    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
}
/**
 * Calculate the width of columns for the table
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnCalculateColumnWidths(settings) {
    // Not interested in doing column width calculation if auto-width is disabled
    if (!settings.oFeatures.bAutoWidth) return;
    var table = settings.nTable, columns = settings.aoColumns, scroll = settings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, visibleColumns = $d5722bd7562c0432$var$_fnGetColumns(settings, 'bVisible'), tableWidthAttr = table.getAttribute('width'), tableContainer = table.parentNode, i, column, columnIdx;
    var styleWidth = table.style.width;
    var containerWidth = $d5722bd7562c0432$var$_fnWrapperWidth(settings);
    // Don't re-run for the same width as the last time
    if (containerWidth === settings.containerWidth) return false;
    settings.containerWidth = containerWidth;
    // If there is no width applied as a CSS style or as an attribute, we assume that
    // the width is intended to be 100%, which is usually is in CSS, but it is very
    // difficult to correctly parse the rules to get the final result.
    if (!styleWidth && !tableWidthAttr) {
        table.style.width = '100%';
        styleWidth = '100%';
    }
    if (styleWidth && styleWidth.indexOf('%') !== -1) tableWidthAttr = styleWidth;
    // Let plug-ins know that we are doing a recalc, in case they have changed any of the
    // visible columns their own way (e.g. Responsive uses display:none).
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'column-calc', {
        visible: visibleColumns
    }, false);
    // Construct a single row, worst case, table with the widest
    // node in the data, assign any user defined widths, then insert it into
    // the DOM and allow the browser to do all the hard work of calculating
    // table widths
    var tmpTable = $d5722bd7562c0432$var$$(table.cloneNode()).css('visibility', 'hidden').removeAttr('id');
    // Clean up the table body
    tmpTable.append('<tbody>');
    var tr = $d5722bd7562c0432$var$$('<tr/>').appendTo(tmpTable.find('tbody'));
    // Clone the table header and footer - we can't use the header / footer
    // from the cloned table, since if scrolling is active, the table's
    // real header and footer are contained in different table tags
    tmpTable.append($d5722bd7562c0432$var$$(settings.nTHead).clone()).append($d5722bd7562c0432$var$$(settings.nTFoot).clone());
    // Remove any assigned widths from the footer (from scrolling)
    tmpTable.find('tfoot th, tfoot td').css('width', '');
    // Apply custom sizing to the cloned header
    tmpTable.find('thead th, thead td').each(function() {
        // Get the `width` from the header layout
        var width = $d5722bd7562c0432$var$_fnColumnsSumWidth(settings, this, true, false);
        if (width) {
            this.style.width = width;
            // For scrollX we need to force the column width otherwise the
            // browser will collapse it. If this width is smaller than the
            // width the column requires, then it will have no effect
            if (scrollX) {
                this.style.minWidth = width;
                $d5722bd7562c0432$var$$(this).append($d5722bd7562c0432$var$$('<div/>').css({
                    width: width,
                    margin: 0,
                    padding: 0,
                    border: 0,
                    height: 1
                }));
            }
        } else this.style.width = '';
    });
    // Find the widest piece of data for each column and put it into the table
    for(i = 0; i < visibleColumns.length; i++){
        columnIdx = visibleColumns[i];
        column = columns[columnIdx];
        var longest = $d5722bd7562c0432$var$_fnGetMaxLenString(settings, columnIdx);
        var autoClass = $d5722bd7562c0432$var$_ext.type.className[column.sType];
        var text = longest + column.sContentPadding;
        var insert = longest.indexOf('<') === -1 ? document.createTextNode(text) : text;
        $d5722bd7562c0432$var$$('<td/>').addClass(autoClass).addClass(column.sClass).append(insert).appendTo(tr);
    }
    // Tidy the temporary table - remove name attributes so there aren't
    // duplicated in the dom (radio elements for example)
    $d5722bd7562c0432$var$$('[name]', tmpTable).removeAttr('name');
    // Table has been built, attach to the document so we can work with it.
    // A holding element is used, positioned at the top of the container
    // with minimal height, so it has no effect on if the container scrolls
    // or not. Otherwise it might trigger scrolling when it actually isn't
    // needed
    var holder = $d5722bd7562c0432$var$$('<div/>').css(scrollX || scrollY ? {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: 'hidden'
    } : {}).append(tmpTable).appendTo(tableContainer);
    // When scrolling (X or Y) we want to set the width of the table as 
    // appropriate. However, when not scrolling leave the table width as it
    // is. This results in slightly different, but I think correct behaviour
    if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
    else if (scrollX) {
        tmpTable.css('width', 'auto');
        tmpTable.removeAttr('width');
        // If there is no width attribute or style, then allow the table to
        // collapse
        if (tmpTable.outerWidth() < tableContainer.clientWidth && tableWidthAttr) tmpTable.outerWidth(tableContainer.clientWidth);
    } else if (scrollY) tmpTable.outerWidth(tableContainer.clientWidth);
    else if (tableWidthAttr) tmpTable.outerWidth(tableWidthAttr);
    // Get the width of each column in the constructed table
    var total = 0;
    var bodyCells = tmpTable.find('tbody tr').eq(0).children();
    for(i = 0; i < visibleColumns.length; i++){
        // Use getBounding for sub-pixel accuracy, which we then want to round up!
        var bounding = bodyCells[i].getBoundingClientRect().width;
        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here
        total += bounding;
        // Width for each column to use
        columns[visibleColumns[i]].sWidth = $d5722bd7562c0432$var$_fnStringToCss(bounding);
    }
    table.style.width = $d5722bd7562c0432$var$_fnStringToCss(total);
    // Finished with the table - ditch it
    holder.remove();
    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if (tableWidthAttr) table.style.width = $d5722bd7562c0432$var$_fnStringToCss(tableWidthAttr);
    if ((tableWidthAttr || scrollX) && !settings._reszEvt) {
        var resize = $d5722bd7562c0432$var$DataTable.util.throttle(function() {
            var newWidth = $d5722bd7562c0432$var$_fnWrapperWidth(settings);
            // Don't do it if destroying or the container width is 0
            if (!settings.bDestroying && newWidth !== 0) $d5722bd7562c0432$var$_fnAdjustColumnSizing(settings);
        });
        // For browsers that support it (~2020 onwards for wide support) we can watch for the
        // container changing width.
        if (window.ResizeObserver) {
            // This is a tricky beast - if the element is visible when `.observe()` is called,
            // then the callback is immediately run. Which we don't want. If the element isn't
            // visible, then it isn't run, but we want it to run when it is then made visible.
            // This flag allows the above to be satisfied.
            var first = $d5722bd7562c0432$var$$(settings.nTableWrapper).is(':visible');
            // Use an empty div to attach the observer so it isn't impacted by height changes
            var resizer = $d5722bd7562c0432$var$$('<div>').css({
                width: '100%',
                height: 0
            }).addClass('dt-autosize').appendTo(settings.nTableWrapper);
            settings.resizeObserver = new ResizeObserver(function(e) {
                if (first) first = false;
                else resize();
            });
            settings.resizeObserver.observe(resizer[0]);
        } else // For old browsers, the best we can do is listen for a window resize
        $d5722bd7562c0432$var$$(window).on('resize.DT-' + settings.sInstance, resize);
        settings._reszEvt = true;
    }
}
/**
 * Get the width of the DataTables wrapper element
 *
 * @param {*} settings DataTables settings object
 * @returns Width
 */ function $d5722bd7562c0432$var$_fnWrapperWidth(settings) {
    return $d5722bd7562c0432$var$$(settings.nTableWrapper).is(':visible') ? $d5722bd7562c0432$var$$(settings.nTableWrapper).width() : 0;
}
/**
 * Get the maximum strlen for each data column
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string} string of the max length
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnGetMaxLenString(settings, colIdx) {
    var column = settings.aoColumns[colIdx];
    if (!column.maxLenString) {
        var s, max = '', maxLen = -1;
        for(var i = 0, ien = settings.aiDisplayMaster.length; i < ien; i++){
            var rowIdx = settings.aiDisplayMaster[i];
            var data = $d5722bd7562c0432$var$_fnGetRowDisplay(settings, rowIdx)[colIdx];
            var cellString = data && typeof data === 'object' && data.nodeType ? data.innerHTML : data + '';
            // Remove id / name attributes from elements so they
            // don't interfere with existing elements
            cellString = cellString.replace(/id=".*?"/g, '').replace(/name=".*?"/g, '');
            s = $d5722bd7562c0432$var$_stripHtml(cellString).replace(/&nbsp;/g, ' ');
            if (s.length > maxLen) {
                // We want the HTML in the string, but the length that
                // is important is the stripped string
                max = cellString;
                maxLen = s.length;
            }
        }
        column.maxLenString = max;
    }
    return column.maxLenString;
}
/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnStringToCss(s) {
    if (s === null) return '0px';
    if (typeof s == 'number') return s < 0 ? '0px' : s + 'px';
    // Check it has a unit character already
    return s.match(/\d$/) ? s + 'px' : s;
}
/**
 * Re-insert the `col` elements for current visibility
 *
 * @param {*} settings DT settings
 */ function $d5722bd7562c0432$var$_colGroup(settings) {
    var cols = settings.aoColumns;
    settings.colgroup.empty();
    for($d5722bd7562c0432$var$i = 0; $d5722bd7562c0432$var$i < cols.length; $d5722bd7562c0432$var$i++)if (cols[$d5722bd7562c0432$var$i].bVisible) settings.colgroup.append(cols[$d5722bd7562c0432$var$i].colEl);
}
function $d5722bd7562c0432$var$_fnSortInit(settings) {
    var target = settings.nTHead;
    var headerRows = target.querySelectorAll('tr');
    var legacyTop = settings.bSortCellsTop;
    var notSelector = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
    // Legacy support for `orderCellsTop`
    if (legacyTop === true) target = headerRows[0];
    else if (legacyTop === false) target = headerRows[headerRows.length - 1];
    $d5722bd7562c0432$var$_fnSortAttachListener(settings, target, target === settings.nTHead ? 'tr' + notSelector + ' th' + notSelector + ', tr' + notSelector + ' td' + notSelector : 'th' + notSelector + ', td' + notSelector);
    // Need to resolve the user input array into our internal structure
    var order = [];
    $d5722bd7562c0432$var$_fnSortResolve(settings, order, settings.aaSorting);
    settings.aaSorting = order;
}
function $d5722bd7562c0432$var$_fnSortAttachListener(settings, node, selector, column, callback) {
    $d5722bd7562c0432$var$_fnBindAction(node, selector, function(e) {
        var run = false;
        var columns = column === undefined ? $d5722bd7562c0432$var$_fnColumnsFromHeader(e.target) : [
            column
        ];
        if (columns.length) {
            for(var i = 0, ien = columns.length; i < ien; i++){
                var ret = $d5722bd7562c0432$var$_fnSortAdd(settings, columns[i], i, e.shiftKey);
                if (ret !== false) run = true;
                // If the first entry is no sort, then subsequent
                // sort columns are ignored
                if (settings.aaSorting.length === 1 && settings.aaSorting[0][1] === '') break;
            }
            if (run) $d5722bd7562c0432$var$_fnProcessingRun(settings, true, function() {
                $d5722bd7562c0432$var$_fnSort(settings);
                $d5722bd7562c0432$var$_fnSortDisplay(settings, settings.aiDisplay);
                $d5722bd7562c0432$var$_fnReDraw(settings, false, false);
                if (callback) callback();
            });
        }
    });
}
/**
 * Sort the display array to match the master's order
 * @param {*} settings
 */ function $d5722bd7562c0432$var$_fnSortDisplay(settings, display) {
    if (display.length < 2) return;
    var master = settings.aiDisplayMaster;
    var masterMap = {};
    var map = {};
    var i;
    // Rather than needing an `indexOf` on master array, we can create a map
    for(i = 0; i < master.length; i++)masterMap[master[i]] = i;
    // And then cache what would be the indexOf fom the display
    for(i = 0; i < display.length; i++)map[display[i]] = masterMap[display[i]];
    display.sort(function(a, b) {
        // Short version of this function is simply `master.indexOf(a) - master.indexOf(b);`
        return map[a] - map[b];
    });
}
function $d5722bd7562c0432$var$_fnSortResolve(settings, nestedSort, sort) {
    var push = function(a) {
        if ($d5722bd7562c0432$var$$.isPlainObject(a)) {
            if (a.idx !== undefined) // Index based ordering
            nestedSort.push([
                a.idx,
                a.dir
            ]);
            else if (a.name) {
                // Name based ordering
                var cols = $d5722bd7562c0432$var$_pluck(settings.aoColumns, 'sName');
                var idx = cols.indexOf(a.name);
                if (idx !== -1) nestedSort.push([
                    idx,
                    a.dir
                ]);
            }
        } else // Plain column index and direction pair
        nestedSort.push(a);
    };
    if ($d5722bd7562c0432$var$$.isPlainObject(sort)) // Object
    push(sort);
    else if (sort.length && typeof sort[0] === 'number') // 1D array
    push(sort);
    else if (sort.length) // 2D array
    for(var z = 0; z < sort.length; z++)push(sort[z]); // Object or array
}
function $d5722bd7562c0432$var$_fnSortFlatten(settings) {
    var i, k, kLen, aSort = [], extSort = $d5722bd7562c0432$var$DataTable.ext.type.order, aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $d5722bd7562c0432$var$$.isPlainObject(fixed), nestedSort = [];
    if (!settings.oFeatures.bSort) return aSort;
    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if (Array.isArray(fixed)) $d5722bd7562c0432$var$_fnSortResolve(settings, nestedSort, fixed);
    if (fixedObj && fixed.pre) $d5722bd7562c0432$var$_fnSortResolve(settings, nestedSort, fixed.pre);
    $d5722bd7562c0432$var$_fnSortResolve(settings, nestedSort, settings.aaSorting);
    if (fixedObj && fixed.post) $d5722bd7562c0432$var$_fnSortResolve(settings, nestedSort, fixed.post);
    for(i = 0; i < nestedSort.length; i++){
        srcCol = nestedSort[i][0];
        if (aoColumns[srcCol]) {
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || 'string';
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = aoColumns[iCol].asSorting.indexOf(nestedSort[i][1]);
                if (nestedSort[i][1]) aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: extSort[sType + "-pre"],
                    sorter: extSort[sType + "-" + nestedSort[i][1]]
                });
            }
        }
    }
    return aSort;
}
/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnSort(oSettings, col, dir) {
    var i, ien, iLen, aiOrig = [], extSort = $d5722bd7562c0432$var$DataTable.ext.type.order, aoData = oSettings.aoData, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
    // Make sure the columns all have types defined
    $d5722bd7562c0432$var$_fnColumnTypes(oSettings);
    // Allow a specific column to be sorted, which will _not_ alter the display
    // master
    if (col !== undefined) {
        var srcCol = oSettings.aoColumns[col];
        aSort = [
            {
                src: col,
                col: col,
                dir: dir,
                index: 0,
                type: srcCol.sType,
                formatter: extSort[srcCol.sType + "-pre"],
                sorter: extSort[srcCol.sType + "-" + dir]
            }
        ];
        displayMaster = displayMaster.slice();
    } else aSort = $d5722bd7562c0432$var$_fnSortFlatten(oSettings);
    for(i = 0, ien = aSort.length; i < ien; i++){
        sortCol = aSort[i];
        // Load the data needed for the sort, for each cell
        $d5722bd7562c0432$var$_fnSortData(oSettings, sortCol.col);
    }
    /* No sorting required if server-side or no sorting array */ if ($d5722bd7562c0432$var$_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
        // Reset the initial positions on each pass so we get a stable sort
        for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[i] = i;
        // If the first sort is desc, then reverse the array to preserve original
        // order, just in reverse
        if (aSort.length && aSort[0].dir === 'desc' && oSettings.orderDescReverse) aiOrig.reverse();
        /* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on it's own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var test;
		 *    test = oSort['string-asc']('data11', 'data12');
		 *      if (test !== 0)
		 *        return test;
		 *    test = oSort['numeric-desc']('data21', 'data22');
		 *    if (test !== 0)
		 *      return test;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 */ displayMaster.sort(function(a, b) {
            var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
            for(k = 0; k < len; k++){
                sort = aSort[k];
                // Data, which may have already been through a `-pre` function
                x = dataA[sort.col];
                y = dataB[sort.col];
                if (sort.sorter) {
                    // If there is a custom sorter (`-asc` or `-desc`) for this
                    // data type, use it
                    test = sort.sorter(x, y);
                    if (test !== 0) return test;
                } else {
                    // Otherwise, use generic sorting
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === 'asc' ? test : -test;
                }
            }
            x = aiOrig[a];
            y = aiOrig[b];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    } else if (aSort.length === 0) // Apply index order
    displayMaster.sort(function(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    });
    if (col === undefined) {
        // Tell the draw function that we have sorted the data
        oSettings.bSorted = true;
        oSettings.sortDetails = aSort;
        $d5722bd7562c0432$var$_fnCallbackFire(oSettings, null, 'order', [
            oSettings,
            aSort
        ]);
    }
    return displayMaster;
}
/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {int} addIndex Counter
 *  @param {boolean} [shift=false] Shift click add
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnSortAdd(settings, colIdx, addIndex, shift) {
    var col = settings.aoColumns[colIdx];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function(a, overflow) {
        var idx = a._idx;
        if (idx === undefined) idx = asSorting.indexOf(a[1]);
        return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
    };
    if (!col.bSortable) return false;
    // Convert to 2D array if needed
    if (typeof sorting[0] === 'number') sorting = settings.aaSorting = [
        sorting
    ];
    // If appending the sort then we are multi-column sorting
    if ((shift || addIndex) && settings.oFeatures.bSortMulti) {
        // Are we already doing some kind of sort on this column?
        var sortIdx = $d5722bd7562c0432$var$_pluck(sorting, '0').indexOf(colIdx);
        if (sortIdx !== -1) {
            // Yes, modify the sort
            nextSortIdx = next(sorting[sortIdx], true);
            if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
            if (nextSortIdx === null) sorting.splice(sortIdx, 1);
            else {
                sorting[sortIdx][1] = asSorting[nextSortIdx];
                sorting[sortIdx]._idx = nextSortIdx;
            }
        } else if (shift) {
            // No sort on this column yet, being added by shift click
            // add it as itself
            sorting.push([
                colIdx,
                asSorting[0],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        } else {
            // No sort on this column yet, being added from a colspan
            // so add with same direction as first column
            sorting.push([
                colIdx,
                sorting[0][1],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        }
    } else if (sorting.length && sorting[0][0] == colIdx) {
        // Single column - already sorting on this column, modify the sort
        nextSortIdx = next(sorting[0]);
        sorting.length = 1;
        sorting[0][1] = asSorting[nextSortIdx];
        sorting[0]._idx = nextSortIdx;
    } else {
        // Single column - sort only on this column
        sorting.length = 0;
        sorting.push([
            colIdx,
            asSorting[0]
        ]);
        sorting[0]._idx = 0;
    }
}
/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnSortingClasses(settings) {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.order.position;
    var sort = $d5722bd7562c0432$var$_fnSortFlatten(settings);
    var features = settings.oFeatures;
    var i, ien, colIdx;
    if (features.bSort && features.bSortClasses) {
        // Remove old sorting classes
        for(i = 0, ien = oldSort.length; i < ien; i++){
            colIdx = oldSort[i].src;
            // Remove column sorting
            $d5722bd7562c0432$var$$($d5722bd7562c0432$var$_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
        }
        // Add new column sorting
        for(i = 0, ien = sort.length; i < ien; i++){
            colIdx = sort[i].src;
            $d5722bd7562c0432$var$$($d5722bd7562c0432$var$_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
        }
    }
    settings.aLastSort = sort;
}
// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function $d5722bd7562c0432$var$_fnSortData(settings, colIdx) {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[colIdx];
    var customSort = $d5722bd7562c0432$var$DataTable.ext.order[column.sSortDataType];
    var customData;
    if (customSort) customData = customSort.call(settings.oInstance, settings, colIdx, $d5722bd7562c0432$var$_fnColumnIndexToVisible(settings, colIdx));
    // Use / populate cache
    var row, cellData;
    var formatter = $d5722bd7562c0432$var$DataTable.ext.type.order[column.sType + "-pre"];
    var data = settings.aoData;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        // Sparse array
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aSortData) row._aSortData = [];
        if (!row._aSortData[colIdx] || customSort) {
            cellData = customSort ? customData[rowIdx] : $d5722bd7562c0432$var$_fnGetCellData(settings, rowIdx, colIdx, 'sort');
            row._aSortData[colIdx] = formatter ? formatter(cellData, settings) : cellData;
        }
    }
}
/**
 * State information for a table
 *
 * @param {*} settings
 * @returns State object
 */ function $d5722bd7562c0432$var$_fnSaveState(settings) {
    if (settings._bLoadingState) return;
    // Sort state saving uses [[idx, order]] structure.
    var sorting = [];
    $d5722bd7562c0432$var$_fnSortResolve(settings, sorting, settings.aaSorting);
    /* Store the interesting variables */ var columns = settings.aoColumns;
    var state = {
        time: +new Date(),
        start: settings._iDisplayStart,
        length: settings._iDisplayLength,
        order: sorting.map(function(sort) {
            // If a column name is available, use it
            return columns[sort[0]] && columns[sort[0]].sName ? [
                columns[sort[0]].sName,
                sort[1]
            ] : sort.slice();
        }),
        search: $d5722bd7562c0432$var$$.extend({}, settings.oPreviousSearch),
        columns: settings.aoColumns.map(function(col, i) {
            return {
                name: col.sName,
                visible: col.bVisible,
                search: $d5722bd7562c0432$var$$.extend({}, settings.aoPreSearchCols[i])
            };
        })
    };
    settings.oSavedState = state;
    $d5722bd7562c0432$var$_fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [
        settings,
        state
    ]);
    if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
}
/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnLoadState(settings, init, callback) {
    if (!settings.oFeatures.bStateSave) {
        callback();
        return;
    }
    var loaded = function(state) {
        $d5722bd7562c0432$var$_fnImplementState(settings, state, callback);
    };
    var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
    if (state !== undefined) $d5722bd7562c0432$var$_fnImplementState(settings, state, callback);
    // otherwise, wait for the loaded callback to be executed
    return true;
}
function $d5722bd7562c0432$var$_fnImplementState(settings, s, callback) {
    var i, ien;
    var columns = settings.aoColumns;
    var currentNames = $d5722bd7562c0432$var$_pluck(settings.aoColumns, 'sName');
    settings._bLoadingState = true;
    // When StateRestore was introduced the state could now be implemented at any time
    // Not just initialisation. To do this an api instance is required in some places
    var api = settings._bInitComplete ? new $d5722bd7562c0432$var$DataTable.Api(settings) : null;
    if (!s || !s.time) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Reject old data
    var duration = settings.iStateDuration;
    if (duration > 0 && s.time < +new Date() - duration * 1000) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Allow custom and plug-in manipulation functions to alter the saved data set and
    // cancelling of loading by returning false
    var abStateLoad = $d5722bd7562c0432$var$_fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [
        settings,
        s
    ]);
    if (abStateLoad.indexOf(false) !== -1) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Store the saved state so it might be accessed at any time
    settings.oLoadedState = $d5722bd7562c0432$var$$.extend(true, {}, s);
    // This is needed for ColReorder, which has to happen first to allow all
    // the stored indexes to be usable. It is not publicly documented.
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'stateLoadInit', [
        settings,
        s
    ], true);
    // Page Length
    if (s.length !== undefined) {
        // If already initialised just set the value directly so that the select element is also updated
        if (api) api.page.len(s.length);
        else settings._iDisplayLength = s.length;
    }
    // Restore key features
    if (s.start !== undefined) {
        if (api === null) {
            settings._iDisplayStart = s.start;
            settings.iInitDisplayStart = s.start;
        } else $d5722bd7562c0432$var$_fnPageChange(settings, s.start / settings._iDisplayLength);
    }
    // Order
    if (s.order !== undefined) {
        settings.aaSorting = [];
        $d5722bd7562c0432$var$$.each(s.order, function(i, col) {
            var set = [
                col[0],
                col[1]
            ];
            // A column name was stored and should be used for restore
            if (typeof col[0] === 'string') {
                var idx = currentNames.indexOf(col[0]);
                // Find the name from the current list of column names, or fallback to index 0
                set[0] = idx >= 0 ? idx : 0;
            } else if (set[0] >= columns.length) // If a column name, but it is out of bounds, set to 0
            set[0] = 0;
            settings.aaSorting.push(set);
        });
    }
    // Search
    if (s.search !== undefined) $d5722bd7562c0432$var$$.extend(settings.oPreviousSearch, s.search);
    // Columns
    if (s.columns) {
        var set = s.columns;
        var incoming = $d5722bd7562c0432$var$_pluck(s.columns, 'name');
        // Check if it is a 2.2 style state object with a `name` property for the columns, and if
        // the name was defined. If so, then create a new array that will map the state object
        // given, to the current columns (don't bother if they are already matching tho).
        if (incoming.join('').length && incoming.join('') !== currentNames.join('')) {
            set = [];
            // For each column, try to find the name in the incoming array
            for(i = 0; i < currentNames.length; i++)if (currentNames[i] != '') {
                var idx = incoming.indexOf(currentNames[i]);
                if (idx >= 0) set.push(s.columns[idx]);
                else // No matching column name in the state's columns, so this might be a new
                // column and thus can't have a state already.
                set.push({});
            } else // If no name, but other columns did have a name, then there is no knowing
            // where this one came from originally so it can't be restored.
            set.push({});
        }
        // If the number of columns to restore is different from current, then all bets are off.
        if (set.length === columns.length) {
            for(i = 0, ien = set.length; i < ien; i++){
                var col = set[i];
                // Visibility
                if (col.visible !== undefined) {
                    // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                    if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                    api.column(i).visible(col.visible, false);
                    else columns[i].bVisible = col.visible;
                }
                // Search
                if (col.search !== undefined) $d5722bd7562c0432$var$$.extend(settings.aoPreSearchCols[i], col.search);
            }
            // If the api is defined then we need to adjust the columns once the visibility has been changed
            if (api) api.columns.adjust();
        }
    }
    settings._bLoadingState = false;
    $d5722bd7562c0432$var$_fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [
        settings,
        s
    ]);
    callback();
}
/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnLog(settings, level, msg, tn) {
    msg = 'DataTables warning: ' + (settings ? 'table id=' + settings.sTableId + ' - ' : '') + msg;
    if (tn) msg += ". For more information about this error, please see https://datatables.net/tn/" + tn;
    if (!level) {
        // Backwards compatibility pre 1.10
        var ext = $d5722bd7562c0432$var$DataTable.ext;
        var type = ext.sErrMode || ext.errMode;
        if (settings) $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'dt-error', [
            settings,
            tn,
            msg
        ], true);
        if (type == 'alert') alert(msg);
        else if (type == 'throw') throw new Error(msg);
        else if (typeof type == 'function') type(settings, tn, msg);
    } else if (window.console && console.log) console.log(msg);
}
/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnMap(ret, src, name, mappedName) {
    if (Array.isArray(name)) {
        $d5722bd7562c0432$var$$.each(name, function(i, val) {
            if (Array.isArray(val)) $d5722bd7562c0432$var$_fnMap(ret, src, val[0], val[1]);
            else $d5722bd7562c0432$var$_fnMap(ret, src, val);
        });
        return;
    }
    if (mappedName === undefined) mappedName = name;
    if (src[name] !== undefined) ret[mappedName] = src[name];
}
/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */ function $d5722bd7562c0432$var$_fnExtend(out, extender, breakRefs) {
    var val;
    for(var prop in extender)if (Object.prototype.hasOwnProperty.call(extender, prop)) {
        val = extender[prop];
        if ($d5722bd7562c0432$var$$.isPlainObject(val)) {
            if (!$d5722bd7562c0432$var$$.isPlainObject(out[prop])) out[prop] = {};
            $d5722bd7562c0432$var$$.extend(true, out[prop], val);
        } else if (breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val)) out[prop] = val.slice();
        else out[prop] = val;
    }
    return out;
}
/**
 * Bind an event handers to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object|string} selector Selector (for delegated events) or data object
 *   to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnBindAction(n, selector, fn) {
    $d5722bd7562c0432$var$$(n).on('click.DT', selector, function(e) {
        fn(e);
    }).on('keypress.DT', selector, function(e) {
        if (e.which === 13) {
            e.preventDefault();
            fn(e);
        }
    }).on('selectstart.DT', selector, function() {
        // Don't want a double click resulting in text selection
        return false;
    });
}
/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} settings dataTables settings object
 *  @param {string} store Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnCallbackReg(settings, store, fn) {
    if (fn) settings[store].push(fn);
}
/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @param {boolean} [bubbles] True if the event should bubble
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnCallbackFire(settings, callbackArr, eventName, args, bubbles) {
    var ret = [];
    if (callbackArr) ret = settings[callbackArr].slice().reverse().map(function(val) {
        return val.apply(settings.oInstance, args);
    });
    if (eventName !== null) {
        var e = $d5722bd7562c0432$var$$.Event(eventName + '.dt');
        var table = $d5722bd7562c0432$var$$(settings.nTable);
        // Expose the DataTables API on the event object for easy access
        e.dt = settings.api;
        table[bubbles ? 'trigger' : 'triggerHandler'](e, args);
        // If not yet attached to the document, trigger the event
        // on the body directly to sort of simulate the bubble
        if (bubbles && table.parents('body').length === 0) $d5722bd7562c0432$var$$('body').trigger(e, args);
        ret.push(e.result);
    }
    return ret;
}
function $d5722bd7562c0432$var$_fnLengthOverflow(settings) {
    var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
    /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
    // Keep the start record on the current page
    start -= start % len;
    if (len === -1 || start < 0) start = 0;
    settings._iDisplayStart = start;
}
function $d5722bd7562c0432$var$_fnRenderer(settings, type) {
    var renderer = settings.renderer;
    var host = $d5722bd7562c0432$var$DataTable.ext.renderer[type];
    if ($d5722bd7562c0432$var$$.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
    // the default.
    return host[renderer[type]] || host._;
    else if (typeof renderer === 'string') // Common renderer - if there is one available for this type use it,
    // otherwise use the default
    return host[renderer] || host._;
    // Use the default
    return host._;
}
/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnDataSource(settings) {
    if (settings.oFeatures.bServerSide) return 'ssp';
    else if (settings.ajax) return 'ajax';
    return 'dom';
}
/**
 * Common replacement for language strings
 *
 * @param {*} settings DT settings object
 * @param {*} str String with values to replace
 * @param {*} entries Plural number for _ENTRIES_ - can be undefined
 * @returns String
 */ function $d5722bd7562c0432$var$_fnMacros(settings, str, entries) {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is
    // used only internally
    var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), max = settings.fnRecordsTotal(), all = len === -1;
    return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, max)).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len))).replace(/_ENTRIES_/g, settings.api.i18n('entries', '', entries)).replace(/_ENTRIES-MAX_/g, settings.api.i18n('entries', '', max)).replace(/_ENTRIES-TOTAL_/g, settings.api.i18n('entries', '', vis));
}
/**
 * Add elements to an array as quickly as possible, but stack stafe.
 *
 * @param {*} arr Array to add the data to
 * @param {*} data Data array that is to be added
 * @returns 
 */ function $d5722bd7562c0432$var$_fnArrayApply(arr, data) {
    if (!data) return;
    // Chrome can throw a max stack error if apply is called with
    // too large an array, but apply is faster.
    if (data.length < 10000) arr.push.apply(arr, data);
    else for($d5722bd7562c0432$var$i = 0; $d5722bd7562c0432$var$i < data.length; $d5722bd7562c0432$var$i++)arr.push(data[$d5722bd7562c0432$var$i]);
}
/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */ var $d5722bd7562c0432$var$__apiStruct = [];
/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */ var $d5722bd7562c0432$var$__arrayProto = Array.prototype;
/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */ var $d5722bd7562c0432$var$_toSettings = function(mixed) {
    var idx, jq;
    var settings = $d5722bd7562c0432$var$DataTable.settings;
    var tables = $d5722bd7562c0432$var$_pluck(settings, 'nTable');
    if (!mixed) return [];
    else if (mixed.nTable && mixed.oFeatures) // DataTables settings object
    return [
        mixed
    ];
    else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
        // Table node
        idx = tables.indexOf(mixed);
        return idx !== -1 ? [
            settings[idx]
        ] : null;
    } else if (mixed && typeof mixed.settings === 'function') return mixed.settings().toArray();
    else if (typeof mixed === 'string') // jQuery selector
    jq = $d5722bd7562c0432$var$$(mixed).get();
    else if (mixed instanceof $d5722bd7562c0432$var$$) // jQuery object (also DataTables instance)
    jq = mixed.get();
    if (jq) return settings.filter(function(v, idx) {
        return jq.includes(tables[idx]);
    });
};
/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new DataTable.Api( 'table.dataTable' );
 */ $d5722bd7562c0432$var$_Api = function(context, data) {
    if (!(this instanceof $d5722bd7562c0432$var$_Api)) return new $d5722bd7562c0432$var$_Api(context, data);
    var i;
    var settings = [];
    var ctxSettings = function(o) {
        var a = $d5722bd7562c0432$var$_toSettings(o);
        if (a) settings.push.apply(settings, a);
    };
    if (Array.isArray(context)) for(i = 0; i < context.length; i++)ctxSettings(context[i]);
    else ctxSettings(context);
    // Remove duplicates
    this.context = settings.length > 1 ? $d5722bd7562c0432$var$_unique(settings) : settings;
    // Initial data
    $d5722bd7562c0432$var$_fnArrayApply(this, data);
    // selector
    this.selector = {
        rows: null,
        cols: null,
        opts: null
    };
    $d5722bd7562c0432$var$_Api.extend(this, this, $d5722bd7562c0432$var$__apiStruct);
};
$d5722bd7562c0432$var$DataTable.Api = $d5722bd7562c0432$var$_Api;
// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$d5722bd7562c0432$var$$.extend($d5722bd7562c0432$var$_Api.prototype, {
    any: function() {
        return this.count() !== 0;
    },
    context: [],
    count: function() {
        return this.flatten().length;
    },
    each: function(fn) {
        for(var i = 0, ien = this.length; i < ien; i++)fn.call(this, this[i], i, this);
        return this;
    },
    eq: function(idx) {
        var ctx = this.context;
        return ctx.length > idx ? new $d5722bd7562c0432$var$_Api(ctx[idx], this[idx]) : null;
    },
    filter: function(fn) {
        var a = $d5722bd7562c0432$var$__arrayProto.filter.call(this, fn, this);
        return new $d5722bd7562c0432$var$_Api(this.context, a);
    },
    flatten: function() {
        var a = [];
        return new $d5722bd7562c0432$var$_Api(this.context, a.concat.apply(a, this.toArray()));
    },
    get: function(idx) {
        return this[idx];
    },
    join: $d5722bd7562c0432$var$__arrayProto.join,
    includes: function(find) {
        return this.indexOf(find) === -1 ? false : true;
    },
    indexOf: $d5722bd7562c0432$var$__arrayProto.indexOf,
    iterator: function(flatten, type, fn, alwaysNew) {
        var a = [], ret, i, ien, j, jen, context = this.context, rows, items, item, selector = this.selector;
        // Argument shifting
        if (typeof flatten === 'string') {
            alwaysNew = fn;
            fn = type;
            type = flatten;
            flatten = false;
        }
        for(i = 0, ien = context.length; i < ien; i++){
            var apiInst = new $d5722bd7562c0432$var$_Api(context[i]);
            if (type === 'table') {
                ret = fn.call(apiInst, context[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'columns' || type === 'rows') {
                // this has same length as context - one entry for each table
                ret = fn.call(apiInst, context[i], this[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'every' || type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
                // columns and rows share the same structure.
                // 'this' is an array of column indexes for each context
                items = this[i];
                if (type === 'column-rows') rows = $d5722bd7562c0432$var$_selector_row_indexes(context[i], selector.opts);
                for(j = 0, jen = items.length; j < jen; j++){
                    item = items[j];
                    if (type === 'cell') ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                    else ret = fn.call(apiInst, context[i], item, i, j, rows);
                    if (ret !== undefined) a.push(ret);
                }
            }
        }
        if (a.length || alwaysNew) {
            var api = new $d5722bd7562c0432$var$_Api(context, flatten ? a.concat.apply([], a) : a);
            var apiSelector = api.selector;
            apiSelector.rows = selector.rows;
            apiSelector.cols = selector.cols;
            apiSelector.opts = selector.opts;
            return api;
        }
        return this;
    },
    lastIndexOf: $d5722bd7562c0432$var$__arrayProto.lastIndexOf,
    length: 0,
    map: function(fn) {
        var a = $d5722bd7562c0432$var$__arrayProto.map.call(this, fn, this);
        return new $d5722bd7562c0432$var$_Api(this.context, a);
    },
    pluck: function(prop) {
        var fn = $d5722bd7562c0432$var$DataTable.util.get(prop);
        return this.map(function(el) {
            return fn(el);
        });
    },
    pop: $d5722bd7562c0432$var$__arrayProto.pop,
    push: $d5722bd7562c0432$var$__arrayProto.push,
    reduce: $d5722bd7562c0432$var$__arrayProto.reduce,
    reduceRight: $d5722bd7562c0432$var$__arrayProto.reduceRight,
    reverse: $d5722bd7562c0432$var$__arrayProto.reverse,
    // Object with rows, columns and opts
    selector: null,
    shift: $d5722bd7562c0432$var$__arrayProto.shift,
    slice: function() {
        return new $d5722bd7562c0432$var$_Api(this.context, this);
    },
    sort: $d5722bd7562c0432$var$__arrayProto.sort,
    splice: $d5722bd7562c0432$var$__arrayProto.splice,
    toArray: function() {
        return $d5722bd7562c0432$var$__arrayProto.slice.call(this);
    },
    to$: function() {
        return $d5722bd7562c0432$var$$(this);
    },
    toJQuery: function() {
        return $d5722bd7562c0432$var$$(this);
    },
    unique: function() {
        return new $d5722bd7562c0432$var$_Api(this.context, $d5722bd7562c0432$var$_unique(this.toArray()));
    },
    unshift: $d5722bd7562c0432$var$__arrayProto.unshift
});
function $d5722bd7562c0432$var$_api_scope(scope, fn, struc) {
    return function() {
        var ret = fn.apply(scope || this, arguments);
        // Method extension
        $d5722bd7562c0432$var$_Api.extend(ret, ret, struc.methodExt);
        return ret;
    };
}
function $d5722bd7562c0432$var$_api_find(src, name) {
    for(var i = 0, ien = src.length; i < ien; i++){
        if (src[i].name === name) return src[i];
    }
    return null;
}
window.__apiStruct = $d5722bd7562c0432$var$__apiStruct;
$d5722bd7562c0432$var$_Api.extend = function(scope, obj, ext) {
    // Only extend API instances and static properties of the API
    if (!ext.length || !obj || !(obj instanceof $d5722bd7562c0432$var$_Api) && !obj.__dt_wrapper) return;
    var i, ien, struct;
    for(i = 0, ien = ext.length; i < ien; i++){
        struct = ext[i];
        if (struct.name === '__proto__') continue;
        // Value
        obj[struct.name] = struct.type === 'function' ? $d5722bd7562c0432$var$_api_scope(scope, struct.val, struct) : struct.type === 'object' ? {} : struct.val;
        obj[struct.name].__dt_wrapper = true;
        // Property extension
        $d5722bd7562c0432$var$_Api.extend(scope, obj[struct.name], struct.propExt);
    }
};
//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]
$d5722bd7562c0432$var$_Api.register = $d5722bd7562c0432$var$_api_register = function(name, val) {
    if (Array.isArray(name)) {
        for(var j = 0, jen = name.length; j < jen; j++)$d5722bd7562c0432$var$_Api.register(name[j], val);
        return;
    }
    var i, ien, heir = name.split('.'), struct = $d5722bd7562c0432$var$__apiStruct, key, method;
    for(i = 0, ien = heir.length; i < ien; i++){
        method = heir[i].indexOf('()') !== -1;
        key = method ? heir[i].replace('()', '') : heir[i];
        var src = $d5722bd7562c0432$var$_api_find(struct, key);
        if (!src) {
            src = {
                name: key,
                val: {},
                methodExt: [],
                propExt: [],
                type: 'object'
            };
            struct.push(src);
        }
        if (i === ien - 1) {
            src.val = val;
            src.type = typeof val === 'function' ? 'function' : $d5722bd7562c0432$var$$.isPlainObject(val) ? 'object' : 'other';
        } else struct = method ? src.methodExt : src.propExt;
    }
};
$d5722bd7562c0432$var$_Api.registerPlural = $d5722bd7562c0432$var$_api_registerPlural = function(pluralName, singularName, val) {
    $d5722bd7562c0432$var$_Api.register(pluralName, val);
    $d5722bd7562c0432$var$_Api.register(singularName, function() {
        var ret = val.apply(this, arguments);
        if (ret === this) // Returned item is the API instance that was passed in, return it
        return this;
        else if (ret instanceof $d5722bd7562c0432$var$_Api) // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ? Array.isArray(ret[0]) ? new $d5722bd7562c0432$var$_Api(ret.context, ret[0]) : ret[0] : undefined;
        // Non-API return - just fire it back
        return ret;
    });
};
/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */ var $d5722bd7562c0432$var$__table_selector = function(selector, a) {
    if (Array.isArray(selector)) {
        var result = [];
        selector.forEach(function(sel) {
            var inner = $d5722bd7562c0432$var$__table_selector(sel, a);
            $d5722bd7562c0432$var$_fnArrayApply(result, inner);
        });
        return result.filter(function(item) {
            return item;
        });
    }
    // Integer is used to pick out a table by index
    if (typeof selector === 'number') return [
        a[selector]
    ];
    // Perform a jQuery selector on the table nodes
    var nodes = a.map(function(el) {
        return el.nTable;
    });
    return $d5722bd7562c0432$var$$(nodes).filter(selector).map(function() {
        // Need to translate back from the table node to the settings
        var idx = nodes.indexOf(this);
        return a[idx];
    }).toArray();
};
/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */ $d5722bd7562c0432$var$_api_register('tables()', function(selector) {
    // A new instance is created if there was a selector specified
    return selector !== undefined && selector !== null ? new $d5722bd7562c0432$var$_Api($d5722bd7562c0432$var$__table_selector(selector, this.context)) : this;
});
$d5722bd7562c0432$var$_api_register('table()', function(selector) {
    var tables = this.tables(selector);
    var ctx = tables.context;
    // Truncate to the first matched table
    return ctx.length ? new $d5722bd7562c0432$var$_Api(ctx[0]) : tables;
});
// Common methods, combined to reduce size
[
    [
        'nodes',
        'node',
        'nTable'
    ],
    [
        'body',
        'body',
        'nTBody'
    ],
    [
        'header',
        'header',
        'nTHead'
    ],
    [
        'footer',
        'footer',
        'nTFoot'
    ]
].forEach(function(item) {
    $d5722bd7562c0432$var$_api_registerPlural('tables().' + item[0] + '()', 'table().' + item[1] + '()', function() {
        return this.iterator('table', function(ctx) {
            return ctx[item[2]];
        }, 1);
    });
});
// Structure methods
[
    [
        'header',
        'aoHeader'
    ],
    [
        'footer',
        'aoFooter'
    ]
].forEach(function(item) {
    $d5722bd7562c0432$var$_api_register('table().' + item[0] + '.structure()', function(selector) {
        var indexes = this.columns(selector).indexes().flatten();
        var ctx = this.context[0];
        return $d5722bd7562c0432$var$_fnHeaderLayout(ctx, ctx[item[1]], indexes);
    });
});
$d5722bd7562c0432$var$_api_registerPlural('tables().containers()', 'table().container()', function() {
    return this.iterator('table', function(ctx) {
        return ctx.nTableWrapper;
    }, 1);
});
$d5722bd7562c0432$var$_api_register('tables().every()', function(fn) {
    var that = this;
    return this.iterator('table', function(s, i) {
        fn.call(that.table(i), i);
    });
});
$d5722bd7562c0432$var$_api_register('caption()', function(value, side) {
    var context = this.context;
    // Getter - return existing node's content
    if (value === undefined) {
        var caption = context[0].captionNode;
        return caption && context.length ? caption.innerHTML : null;
    }
    return this.iterator('table', function(ctx) {
        var table = $d5722bd7562c0432$var$$(ctx.nTable);
        var caption = $d5722bd7562c0432$var$$(ctx.captionNode);
        var container = $d5722bd7562c0432$var$$(ctx.nTableWrapper);
        // Create the node if it doesn't exist yet
        if (!caption.length) {
            caption = $d5722bd7562c0432$var$$('<caption/>').html(value);
            ctx.captionNode = caption[0];
            // If side isn't set, we need to insert into the document to let the
            // CSS decide so we can read it back, otherwise there is no way to
            // know if the CSS would put it top or bottom for scrolling
            if (!side) {
                table.prepend(caption);
                side = caption.css('caption-side');
            }
        }
        caption.html(value);
        if (side) {
            caption.css('caption-side', side);
            caption[0]._captionSide = side;
        }
        if (container.find('div.dataTables_scroll').length) {
            var selector = side === 'top' ? 'Head' : 'Foot';
            container.find('div.dataTables_scroll' + selector + ' table').prepend(caption);
        } else table.prepend(caption);
    }, 1);
});
$d5722bd7562c0432$var$_api_register('caption.node()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].captionNode : null;
});
/**
 * Redraw the tables in the current context.
 */ $d5722bd7562c0432$var$_api_register('draw()', function(paging) {
    return this.iterator('table', function(settings) {
        if (paging === 'page') $d5722bd7562c0432$var$_fnDraw(settings);
        else {
            if (typeof paging === 'string') paging = paging === 'full-hold' ? false : true;
            $d5722bd7562c0432$var$_fnReDraw(settings, paging === false);
        }
    });
});
/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 */ /**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('page()', function(action) {
    if (action === undefined) return this.page.info().page; // not an expensive call
    // else, have an action to take on all tables
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnPageChange(settings, action);
    });
});
/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */ $d5722bd7562c0432$var$_api_register('page.info()', function() {
    if (this.context.length === 0) return undefined;
    var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
    return {
        "page": all ? 0 : Math.floor(start / len),
        "pages": all ? 1 : Math.ceil(visRecords / len),
        "start": start,
        "end": settings.fnDisplayEnd(),
        "length": len,
        "recordsTotal": settings.fnRecordsTotal(),
        "recordsDisplay": visRecords,
        "serverSide": $d5722bd7562c0432$var$_fnDataSource(settings) === 'ssp'
    };
});
/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 */ /**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('page.len()', function(len) {
    // Note that we can't call this function 'length()' because `length`
    // is a Javascript property of functions which defines how many arguments
    // the function expects.
    if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
    // else, set the page length
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnLengthChange(settings, len);
    });
});
var $d5722bd7562c0432$var$__reload = function(settings, holdPosition, callback) {
    // Use the draw event to trigger a callback
    if (callback) {
        var api = new $d5722bd7562c0432$var$_Api(settings);
        api.one('draw', function() {
            callback(api.ajax.json());
        });
    }
    if ($d5722bd7562c0432$var$_fnDataSource(settings) == 'ssp') $d5722bd7562c0432$var$_fnReDraw(settings, holdPosition);
    else {
        $d5722bd7562c0432$var$_fnProcessingDisplay(settings, true);
        // Cancel an existing request
        var xhr = settings.jqXHR;
        if (xhr && xhr.readyState !== 4) xhr.abort();
        // Trigger xhr
        $d5722bd7562c0432$var$_fnBuildAjax(settings, {}, function(json) {
            $d5722bd7562c0432$var$_fnClearTable(settings);
            var data = $d5722bd7562c0432$var$_fnAjaxDataSrc(settings, json);
            for(var i = 0, ien = data.length; i < ien; i++)$d5722bd7562c0432$var$_fnAddData(settings, data[i]);
            $d5722bd7562c0432$var$_fnReDraw(settings, holdPosition);
            $d5722bd7562c0432$var$_fnInitComplete(settings);
            $d5722bd7562c0432$var$_fnProcessingDisplay(settings, false);
        });
    }
};
/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */ $d5722bd7562c0432$var$_api_register('ajax.json()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].json;
// else return undefined;
});
/**
 * Get the data submitted in the last Ajax request
 */ $d5722bd7562c0432$var$_api_register('ajax.params()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].oAjaxData;
// else return undefined;
});
/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('ajax.reload()', function(callback, resetPaging) {
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$__reload(settings, resetPaging === false, callback);
    });
});
/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 */ /**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('ajax.url()', function(url) {
    var ctx = this.context;
    if (url === undefined) {
        // get
        if (ctx.length === 0) return undefined;
        ctx = ctx[0];
        return $d5722bd7562c0432$var$$.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax;
    }
    // set
    return this.iterator('table', function(settings) {
        if ($d5722bd7562c0432$var$$.isPlainObject(settings.ajax)) settings.ajax.url = url;
        else settings.ajax = url;
    });
});
/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('ajax.url().load()', function(callback, resetPaging) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator('table', function(ctx) {
        $d5722bd7562c0432$var$__reload(ctx, resetPaging === false, callback);
    });
});
var $d5722bd7562c0432$var$_selector_run = function(type, selector, selectFn, settings, opts) {
    var out = [], res, a, i, ien, j, jen, selectorType = typeof selector;
    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) selector = [
        selector
    ];
    for(i = 0, ien = selector.length; i < ien; i++){
        // Only split on simple strings - complex expressions will be jQuery selectors
        a = selector[i] && selector[i].split && !selector[i].match(/[[(:]/) ? selector[i].split(',') : [
            selector[i]
        ];
        for(j = 0, jen = a.length; j < jen; j++){
            res = selectFn(typeof a[j] === 'string' ? a[j].trim() : a[j]);
            // Remove empty items
            res = res.filter(function(item) {
                return item !== null && item !== undefined;
            });
            if (res && res.length) out = out.concat(res);
        }
    }
    // selector extensions
    var ext = $d5722bd7562c0432$var$_ext.selector[type];
    if (ext.length) for(i = 0, ien = ext.length; i < ien; i++)out = ext[i](settings, opts, out);
    return $d5722bd7562c0432$var$_unique(out);
};
var $d5722bd7562c0432$var$_selector_opts = function(opts) {
    if (!opts) opts = {};
    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if (opts.filter && opts.search === undefined) opts.search = opts.filter;
    return $d5722bd7562c0432$var$$.extend({
        search: 'none',
        order: 'current',
        page: 'all'
    }, opts);
};
// Reduce the API instance to the first item found
var $d5722bd7562c0432$var$_selector_first = function(old) {
    var inst = new $d5722bd7562c0432$var$_Api(old.context[0]);
    // Use a push rather than passing to the constructor, since it will
    // merge arrays down automatically, which isn't what is wanted here
    if (old.length) inst.push(old[0]);
    inst.selector = old.selector;
    // Limit to a single row / column / cell
    if (inst.length && inst[0].length > 1) inst[0].splice(1);
    return inst;
};
var $d5722bd7562c0432$var$_selector_row_indexes = function(settings, opts) {
    var i, ien, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
    var search = opts.search, order = opts.order, page = opts.page; // all, current
    if ($d5722bd7562c0432$var$_fnDataSource(settings) == 'ssp') // In server-side processing mode, most options are irrelevant since
    // rows not shown don't exist and the index order is the applied order
    // Removed is a special case - for consistency just return an empty
    // array
    return search === 'removed' ? [] : $d5722bd7562c0432$var$_range(0, displayMaster.length);
    if (page == 'current') // Current page implies that order=current and filter=applied, since it is
    // fairly senseless otherwise, regardless of what order and search actually
    // are
    for(i = settings._iDisplayStart, ien = settings.fnDisplayEnd(); i < ien; i++)a.push(displayFiltered[i]);
    else if (order == 'current' || order == 'applied') {
        if (search == 'none') a = displayMaster.slice();
        else if (search == 'applied') a = displayFiltered.slice();
        else if (search == 'removed') {
            // O(n+m) solution by creating a hash map
            var displayFilteredMap = {};
            for(i = 0, ien = displayFiltered.length; i < ien; i++)displayFilteredMap[displayFiltered[i]] = null;
            displayMaster.forEach(function(item) {
                if (!Object.prototype.hasOwnProperty.call(displayFilteredMap, item)) a.push(item);
            });
        }
    } else if (order == 'index' || order == 'original') for(i = 0, ien = settings.aoData.length; i < ien; i++){
        if (!settings.aoData[i]) continue;
        if (search == 'none') a.push(i);
        else {
            tmp = displayFiltered.indexOf(i);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(i);
        }
    }
    else if (typeof order === 'number') {
        // Order the rows by the given column
        var ordered = $d5722bd7562c0432$var$_fnSort(settings, order, 'asc');
        if (search === 'none') a = ordered;
        else for(i = 0; i < ordered.length; i++){
            tmp = displayFiltered.indexOf(ordered[i]);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(ordered[i]);
        }
    }
    return a;
};
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */ var $d5722bd7562c0432$var$__row_selector = function(settings, selector, opts) {
    var rows;
    var run = function(sel) {
        var selInt = $d5722bd7562c0432$var$_intVal(sel);
        var aoData = settings.aoData;
        // Short cut - selector is a number and no options provided (default is
        // all records, so no need to check if the index is in there, since it
        // must be - dev error if the index doesn't exist).
        if (selInt !== null && !opts) return [
            selInt
        ];
        if (!rows) rows = $d5722bd7562c0432$var$_selector_row_indexes(settings, opts);
        if (selInt !== null && rows.indexOf(selInt) !== -1) // Selector - integer
        return [
            selInt
        ];
        else if (sel === null || sel === undefined || sel === '') // Selector - none
        return rows;
        // Selector - function
        if (typeof sel === 'function') return rows.map(function(idx) {
            var row = aoData[idx];
            return sel(idx, row._aData, row.nTr) ? idx : null;
        });
        // Selector - node
        if (sel.nodeName) {
            var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
            var cellIdx = sel._DT_CellIndex;
            if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
            return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                rowIdx
            ] : [];
            else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                cellIdx.row
            ] : [];
            else {
                var host = $d5722bd7562c0432$var$$(sel).closest('*[data-dt-row]');
                return host.length ? [
                    host.data('dt-row')
                ] : [];
            }
        }
        // ID selector. Want to always be able to select rows by id, regardless
        // of if the tr element has been created or not, so can't rely upon
        // jQuery here - hence a custom implementation. This does not match
        // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
        // but to select it using a CSS selector engine (like Sizzle or
        // querySelect) it would need to need to be escaped for some characters.
        // DataTables simplifies this for row selectors since you can select
        // only a row. A # indicates an id any anything that follows is the id -
        // unescaped.
        if (typeof sel === 'string' && sel.charAt(0) === '#') {
            // get row index from id
            var rowObj = settings.aIds[sel.replace(/^#/, '')];
            if (rowObj !== undefined) return [
                rowObj.idx
            ];
        // need to fall through to jQuery in case there is DOM id that
        // matches
        }
        // Get nodes in the order from the `rows` array with null values removed
        var nodes = $d5722bd7562c0432$var$_removeEmpty($d5722bd7562c0432$var$_pluck_order(settings.aoData, rows, 'nTr'));
        // Selector - jQuery selector string, array of nodes or jQuery object/
        // As jQuery's .filter() allows jQuery objects to be passed in filter,
        // it also allows arrays, so this will cope with all three options
        return $d5722bd7562c0432$var$$(nodes).filter(sel).map(function() {
            return this._DT_RowIndex;
        }).toArray();
    };
    var matched = $d5722bd7562c0432$var$_selector_run('row', selector, run, settings, opts);
    if (opts.order === 'current' || opts.order === 'applied') $d5722bd7562c0432$var$_fnSortDisplay(settings, matched);
    return matched;
};
$d5722bd7562c0432$var$_api_register('rows()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($d5722bd7562c0432$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $d5722bd7562c0432$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $d5722bd7562c0432$var$__row_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;
    return inst;
});
$d5722bd7562c0432$var$_api_register('rows().nodes()', function() {
    return this.iterator('row', function(settings, row) {
        return settings.aoData[row].nTr || undefined;
    }, 1);
});
$d5722bd7562c0432$var$_api_register('rows().data()', function() {
    return this.iterator(true, 'rows', function(settings, rows) {
        return $d5722bd7562c0432$var$_pluck_order(settings.aoData, rows, '_aData');
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('rows().cache()', 'row().cache()', function(type) {
    return this.iterator('row', function(settings, row) {
        var r = settings.aoData[row];
        return type === 'search' ? r._aFilterData : r._aSortData;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('rows().invalidate()', 'row().invalidate()', function(src) {
    return this.iterator('row', function(settings, row) {
        $d5722bd7562c0432$var$_fnInvalidate(settings, row, src);
    });
});
$d5722bd7562c0432$var$_api_registerPlural('rows().indexes()', 'row().index()', function() {
    return this.iterator('row', function(settings, row) {
        return row;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('rows().ids()', 'row().id()', function(hash) {
    var a = [];
    var context = this.context;
    // `iterator` will drop undefined values, but in this case we want them
    for(var i = 0, ien = context.length; i < ien; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
        var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
        a.push((hash === true ? '#' : '') + id);
    }
    return new $d5722bd7562c0432$var$_Api(context, a);
});
$d5722bd7562c0432$var$_api_registerPlural('rows().remove()', 'row().remove()', function() {
    this.iterator('row', function(settings, row) {
        var data = settings.aoData;
        var rowData = data[row];
        // Delete from the display arrays
        var idx = settings.aiDisplayMaster.indexOf(row);
        if (idx !== -1) settings.aiDisplayMaster.splice(idx, 1);
        // For server-side processing tables - subtract the deleted row from the count
        if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
        // Check for an 'overflow' they case for displaying the table
        $d5722bd7562c0432$var$_fnLengthOverflow(settings);
        // Remove the row's ID reference if there is one
        var id = settings.rowIdFn(rowData._aData);
        if (id !== undefined) delete settings.aIds[id];
        data[row] = null;
    });
    return this;
});
$d5722bd7562c0432$var$_api_register('rows.add()', function(rows) {
    var newRows = this.iterator('table', function(settings) {
        var row, i, ien;
        var out = [];
        for(i = 0, ien = rows.length; i < ien; i++){
            row = rows[i];
            if (row.nodeName && row.nodeName.toUpperCase() === 'TR') out.push($d5722bd7562c0432$var$_fnAddTr(settings, row)[0]);
            else out.push($d5722bd7562c0432$var$_fnAddData(settings, row));
        }
        return out;
    }, 1);
    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows(-1);
    modRows.pop();
    $d5722bd7562c0432$var$_fnArrayApply(modRows, newRows);
    return modRows;
});
/**
 *
 */ $d5722bd7562c0432$var$_api_register('row()', function(selector, opts) {
    return $d5722bd7562c0432$var$_selector_first(this.rows(selector, opts));
});
$d5722bd7562c0432$var$_api_register('row().data()', function(data) {
    var ctx = this.context;
    if (data === undefined) // Get
    return ctx.length && this.length && this[0].length ? ctx[0].aoData[this[0]]._aData : undefined;
    // Set
    var row = ctx[0].aoData[this[0]];
    row._aData = data;
    // If the DOM has an id, and the data source is an array
    if (Array.isArray(data) && row.nTr && row.nTr.id) $d5722bd7562c0432$var$_fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
    // Automatically invalidate
    $d5722bd7562c0432$var$_fnInvalidate(ctx[0], this[0], 'data');
    return this;
});
$d5722bd7562c0432$var$_api_register('row().node()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && this[0].length) {
        var row = ctx[0].aoData[this[0]];
        if (row && row.nTr) return row.nTr;
    }
    return null;
});
$d5722bd7562c0432$var$_api_register('row.add()', function(row) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if (row instanceof $d5722bd7562c0432$var$$ && row.length) row = row[0];
    var rows = this.iterator('table', function(settings) {
        if (row.nodeName && row.nodeName.toUpperCase() === 'TR') return $d5722bd7562c0432$var$_fnAddTr(settings, row)[0];
        return $d5722bd7562c0432$var$_fnAddData(settings, row);
    });
    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row(rows[0]);
});
$d5722bd7562c0432$var$$(document).on('plugin-init.dt', function(e, context) {
    var api = new $d5722bd7562c0432$var$_Api(context);
    api.on('stateSaveParams.DT', function(e, settings, d) {
        // This could be more compact with the API, but it is a lot faster as a simple
        // internal loop
        var idFn = settings.rowIdFn;
        var rows = settings.aiDisplayMaster;
        var ids = [];
        for(var i = 0; i < rows.length; i++){
            var rowIdx = rows[i];
            var data = settings.aoData[rowIdx];
            if (data._detailsShow) ids.push('#' + idFn(data._aData));
        }
        d.childRows = ids;
    });
    // For future state loads (e.g. with StateRestore)
    api.on('stateLoaded.DT', function(e, settings, state) {
        $d5722bd7562c0432$var$__details_state_load(api, state);
    });
    // And the initial load state
    $d5722bd7562c0432$var$__details_state_load(api, api.state.loaded());
});
var $d5722bd7562c0432$var$__details_state_load = function(api, state) {
    if (state && state.childRows) api.rows(state.childRows.map(function(id) {
        // Escape any `:` characters from the row id. Accounts for
        // already escaped characters.
        return id.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
    })).every(function() {
        $d5722bd7562c0432$var$_fnCallbackFire(api.settings()[0], null, 'requestChild', [
            this
        ]);
    });
};
var $d5722bd7562c0432$var$__details_add = function(ctx, row, data, klass) {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function(r, k) {
        // Recursion to allow for arrays of jQuery objects
        if (Array.isArray(r) || r instanceof $d5722bd7562c0432$var$$) {
            for(var i = 0, ien = r.length; i < ien; i++)addRow(r[i], k);
            return;
        }
        // If we get a TR element, then just add it directly - up to the dev
        // to add the correct number of columns etc
        if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
            r.setAttribute('data-dt-row', row.idx);
            rows.push(r);
        } else {
            // Otherwise create a row with a wrapper
            var created = $d5722bd7562c0432$var$$('<tr><td></td></tr>').attr('data-dt-row', row.idx).addClass(k);
            $d5722bd7562c0432$var$$('td', created).addClass(k).html(r)[0].colSpan = $d5722bd7562c0432$var$_fnVisbleColumns(ctx);
            rows.push(created[0]);
        }
    };
    addRow(data, klass);
    if (row._details) row._details.detach();
    row._details = $d5722bd7562c0432$var$$(rows);
    // If the children were already shown, that state should be retained
    if (row._detailsShow) row._details.insertAfter(row.nTr);
};
// Make state saving of child row details async to allow them to be batch processed
var $d5722bd7562c0432$var$__details_state = $d5722bd7562c0432$var$DataTable.util.throttle(function(ctx) {
    $d5722bd7562c0432$var$_fnSaveState(ctx[0]);
}, 500);
var $d5722bd7562c0432$var$__details_remove = function(api, idx) {
    var ctx = api.context;
    if (ctx.length) {
        var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
        if (row && row._details) {
            row._details.remove();
            row._detailsShow = undefined;
            row._details = undefined;
            $d5722bd7562c0432$var$$(row.nTr).removeClass('dt-hasChild');
            $d5722bd7562c0432$var$__details_state(ctx);
        }
    }
};
var $d5722bd7562c0432$var$__details_display = function(api, show) {
    var ctx = api.context;
    if (ctx.length && api.length) {
        var row = ctx[0].aoData[api[0]];
        if (row._details) {
            row._detailsShow = show;
            if (show) {
                row._details.insertAfter(row.nTr);
                $d5722bd7562c0432$var$$(row.nTr).addClass('dt-hasChild');
            } else {
                row._details.detach();
                $d5722bd7562c0432$var$$(row.nTr).removeClass('dt-hasChild');
            }
            $d5722bd7562c0432$var$_fnCallbackFire(ctx[0], null, 'childRow', [
                show,
                api.row(api[0])
            ]);
            $d5722bd7562c0432$var$__details_events(ctx[0]);
            $d5722bd7562c0432$var$__details_state(ctx);
        }
    }
};
var $d5722bd7562c0432$var$__details_events = function(settings) {
    var api = new $d5722bd7562c0432$var$_Api(settings);
    var namespace = '.dt.DT_details';
    var drawEvent = 'draw' + namespace;
    var colvisEvent = 'column-sizing' + namespace;
    var destroyEvent = 'destroy' + namespace;
    var data = settings.aoData;
    api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);
    if ($d5722bd7562c0432$var$_pluck(data, '_details').length > 0) {
        // On each draw, insert the required elements into the document
        api.on(drawEvent, function(e, ctx) {
            if (settings !== ctx) return;
            api.rows({
                page: 'current'
            }).eq(0).each(function(idx) {
                // Internal data grab
                var row = data[idx];
                if (row._detailsShow) row._details.insertAfter(row.nTr);
            });
        });
        // Column visibility change - update the colspan
        api.on(colvisEvent, function(e, ctx) {
            if (settings !== ctx) return;
            // Update the colspan for the details rows (note, only if it already has
            // a colspan)
            var row, visible = $d5722bd7562c0432$var$_fnVisbleColumns(ctx);
            for(var i = 0, ien = data.length; i < ien; i++){
                row = data[i];
                if (row && row._details) row._details.each(function() {
                    var el = $d5722bd7562c0432$var$$(this).children('td');
                    if (el.length == 1) el.attr('colspan', visible);
                });
            }
        });
        // Table destroyed - nuke any child rows
        api.on(destroyEvent, function(e, ctx) {
            if (settings !== ctx) return;
            for(var i = 0, ien = data.length; i < ien; i++)if (data[i] && data[i]._details) $d5722bd7562c0432$var$__details_remove(api, i);
        });
    }
};
// Strings for the method names to help minification
var $d5722bd7562c0432$var$_emp = '';
var $d5722bd7562c0432$var$_child_obj = $d5722bd7562c0432$var$_emp + 'row().child';
var $d5722bd7562c0432$var$_child_mth = $d5722bd7562c0432$var$_child_obj + '()';
// data can be:
//  tr
//  string
//  jQuery or array of any of the above
$d5722bd7562c0432$var$_api_register($d5722bd7562c0432$var$_child_mth, function(data, klass) {
    var ctx = this.context;
    if (data === undefined) // get
    return ctx.length && this.length && ctx[0].aoData[this[0]] ? ctx[0].aoData[this[0]]._details : undefined;
    else if (data === true) // show
    this.child.show();
    else if (data === false) // remove
    $d5722bd7562c0432$var$__details_remove(this);
    else if (ctx.length && this.length) // set
    $d5722bd7562c0432$var$__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
    return this;
});
$d5722bd7562c0432$var$_api_register([
    $d5722bd7562c0432$var$_child_obj + '.show()',
    $d5722bd7562c0432$var$_child_mth + '.show()' // only when `child()` was called with parameters (without
], function() {
    $d5722bd7562c0432$var$__details_display(this, true);
    return this;
});
$d5722bd7562c0432$var$_api_register([
    $d5722bd7562c0432$var$_child_obj + '.hide()',
    $d5722bd7562c0432$var$_child_mth + '.hide()' // only when `child()` was called with parameters (without
], function() {
    $d5722bd7562c0432$var$__details_display(this, false);
    return this;
});
$d5722bd7562c0432$var$_api_register([
    $d5722bd7562c0432$var$_child_obj + '.remove()',
    $d5722bd7562c0432$var$_child_mth + '.remove()' // only when `child()` was called with parameters (without
], function() {
    $d5722bd7562c0432$var$__details_remove(this);
    return this;
});
$d5722bd7562c0432$var$_api_register($d5722bd7562c0432$var$_child_obj + '.isShown()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && ctx[0].aoData[this[0]]) // _detailsShown as false or undefined will fall through to return false
    return ctx[0].aoData[this[0]]._detailsShow || false;
    return false;
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */ // can be an array of these items, comma separated list, or an array of comma
// separated lists
var $d5722bd7562c0432$var$__re_column_selector = /^([^:]+)?:(name|title|visIdx|visible)$/;
// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var $d5722bd7562c0432$var$__columnData = function(settings, column, r1, r2, rows, type) {
    var a = [];
    for(var row = 0, ien = rows.length; row < ien; row++)a.push($d5722bd7562c0432$var$_fnGetCellData(settings, rows[row], column, type));
    return a;
};
var $d5722bd7562c0432$var$__column_header = function(settings, column, row) {
    var header = settings.aoHeader;
    var target = row !== undefined ? row : settings.bSortCellsTop // legacy support
     ? 0 : header.length - 1;
    return header[target][column].cell;
};
var $d5722bd7562c0432$var$__column_selector = function(settings, selector, opts) {
    var columns = settings.aoColumns, names = $d5722bd7562c0432$var$_pluck(columns, 'sName'), titles = $d5722bd7562c0432$var$_pluck(columns, 'sTitle'), cells = $d5722bd7562c0432$var$DataTable.util.get('[].[].cell')(settings.aoHeader), nodes = $d5722bd7562c0432$var$_unique($d5722bd7562c0432$var$_flatten([], cells));
    var run = function(s) {
        var selInt = $d5722bd7562c0432$var$_intVal(s);
        // Selector - all
        if (s === '') return $d5722bd7562c0432$var$_range(columns.length);
        // Selector - index
        if (selInt !== null) return [
            selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
        ];
        // Selector = function
        if (typeof s === 'function') {
            var rows = $d5722bd7562c0432$var$_selector_row_indexes(settings, opts);
            return columns.map(function(col, idx) {
                return s(idx, $d5722bd7562c0432$var$__columnData(settings, idx, 0, 0, rows), $d5722bd7562c0432$var$__column_header(settings, idx)) ? idx : null;
            });
        }
        // jQuery or string selector
        var match = typeof s === 'string' ? s.match($d5722bd7562c0432$var$__re_column_selector) : '';
        if (match) switch(match[2]){
            case 'visIdx':
            case 'visible':
                // Selector is a column index
                if (match[1] && match[1].match(/^\d+$/)) {
                    var idx = parseInt(match[1], 10);
                    // Visible index given, convert to column index
                    if (idx < 0) {
                        // Counting from the right
                        var visColumns = columns.map(function(col, i) {
                            return col.bVisible ? i : null;
                        });
                        return [
                            visColumns[visColumns.length + idx]
                        ];
                    }
                    // Counting from the left
                    return [
                        $d5722bd7562c0432$var$_fnVisibleToColumnIndex(settings, idx)
                    ];
                }
                return columns.map(function(col, idx) {
                    // Not visible, can't match
                    if (!col.bVisible) return null;
                    // Selector
                    if (match[1]) return $d5722bd7562c0432$var$$(nodes[idx]).filter(match[1]).length > 0 ? idx : null;
                    // `:visible` on its own
                    return idx;
                });
            case 'name':
                // match by name. `names` is column index complete and in order
                return names.map(function(name, i) {
                    return name === match[1] ? i : null;
                });
            case 'title':
                // match by column title
                return titles.map(function(title, i) {
                    return title === match[1] ? i : null;
                });
            default:
                return [];
        }
        // Cell in the table body
        if (s.nodeName && s._DT_CellIndex) return [
            s._DT_CellIndex.column
        ];
        // jQuery selector on the TH elements for the columns
        var jqResult = $d5722bd7562c0432$var$$(nodes).filter(s).map(function() {
            return $d5722bd7562c0432$var$_fnColumnsFromHeader(this); // `nodes` is column index complete and in order
        }).toArray().sort(function(a, b) {
            return a - b;
        });
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise a node which might have a `dt-column` data attribute, or be
        // a child or such an element
        var host = $d5722bd7562c0432$var$$(s).closest('*[data-dt-column]');
        return host.length ? [
            host.data('dt-column')
        ] : [];
    };
    return $d5722bd7562c0432$var$_selector_run('column', selector, run, settings, opts);
};
var $d5722bd7562c0432$var$__setColumnVis = function(settings, column, vis) {
    var cols = settings.aoColumns, col = cols[column], data = settings.aoData, cells, i, ien, tr;
    // Get
    if (vis === undefined) return col.bVisible;
    // Set
    // No change
    if (col.bVisible === vis) return false;
    if (vis) {
        // Insert column
        // Need to decide if we should use appendChild or insertBefore
        var insertBefore = $d5722bd7562c0432$var$_pluck(cols, 'bVisible').indexOf(true, column + 1);
        for(i = 0, ien = data.length; i < ien; i++)if (data[i]) {
            tr = data[i].nTr;
            cells = data[i].anCells;
            if (tr) // insertBefore can act like appendChild if 2nd arg is null
            tr.insertBefore(cells[column], cells[insertBefore] || null);
        }
    } else // Remove column
    $d5722bd7562c0432$var$$($d5722bd7562c0432$var$_pluck(settings.aoData, 'anCells', column)).detach();
    // Common actions
    col.bVisible = vis;
    $d5722bd7562c0432$var$_colGroup(settings);
    return true;
};
$d5722bd7562c0432$var$_api_register('columns()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($d5722bd7562c0432$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $d5722bd7562c0432$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $d5722bd7562c0432$var$__column_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;
    return inst;
});
$d5722bd7562c0432$var$_api_registerPlural('columns().header()', 'column().header()', function(row) {
    return this.iterator('column', function(settings, column) {
        return $d5722bd7562c0432$var$__column_header(settings, column, row);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().footer()', 'column().footer()', function(row) {
    return this.iterator('column', function(settings, column) {
        var footer = settings.aoFooter;
        if (!footer.length) return null;
        return settings.aoFooter[row !== undefined ? row : 0][column].cell;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().data()', 'column().data()', function() {
    return this.iterator('column-rows', $d5722bd7562c0432$var$__columnData, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().render()', 'column().render()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $d5722bd7562c0432$var$__columnData(settings, column, i, j, rows, type);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].mData;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().cache()', 'column().cache()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $d5722bd7562c0432$var$_pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().init()', 'column().init()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column];
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().nodes()', 'column().nodes()', function() {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $d5722bd7562c0432$var$_pluck_order(settings.aoData, rows, 'anCells', column);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().titles()', 'column().title()', function(title, row) {
    return this.iterator('column', function(settings, column) {
        // Argument shifting
        if (typeof title === 'number') {
            row = title;
            title = undefined;
        }
        var span = $d5722bd7562c0432$var$$('span.dt-column-title', this.column(column).header(row));
        if (title !== undefined) {
            span.html(title);
            return this;
        }
        return span.html();
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().types()', 'column().type()', function() {
    return this.iterator('column', function(settings, column) {
        var type = settings.aoColumns[column].sType;
        // If the type was invalidated, then resolve it. This actually does
        // all columns at the moment. Would only happen once if getting all
        // column's data types.
        if (!type) $d5722bd7562c0432$var$_fnColumnTypes(settings);
        return type;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().visible()', 'column().visible()', function(vis, calc) {
    var that = this;
    var changed = [];
    var ret = this.iterator('column', function(settings, column) {
        if (vis === undefined) return settings.aoColumns[column].bVisible;
         // else
        if ($d5722bd7562c0432$var$__setColumnVis(settings, column, vis)) changed.push(column);
    });
    // Group the column visibility changes
    if (vis !== undefined) this.iterator('table', function(settings) {
        // Redraw the header after changes
        $d5722bd7562c0432$var$_fnDrawHead(settings, settings.aoHeader);
        $d5722bd7562c0432$var$_fnDrawHead(settings, settings.aoFooter);
        // Update colspan for no records display. Child rows and extensions will use their own
        // listeners to do this - only need to update the empty table item here
        if (!settings.aiDisplay.length) $d5722bd7562c0432$var$$(settings.nTBody).find('td[colspan]').attr('colspan', $d5722bd7562c0432$var$_fnVisbleColumns(settings));
        $d5722bd7562c0432$var$_fnSaveState(settings);
        // Second loop once the first is done for events
        that.iterator('column', function(settings, column) {
            if (changed.includes(column)) $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'column-visibility', [
                settings,
                column,
                vis,
                calc
            ]);
        });
        if (changed.length && (calc === undefined || calc)) that.columns.adjust();
    });
    return ret;
});
$d5722bd7562c0432$var$_api_registerPlural('columns().widths()', 'column().width()', function() {
    // Injects a fake row into the table for just a moment so the widths can
    // be read, regardless of colspan in the header and rows being present in
    // the body
    var columns = this.columns(':visible').count();
    var row = $d5722bd7562c0432$var$$('<tr>').html('<td>' + Array(columns).join('</td><td>') + '</td>');
    $d5722bd7562c0432$var$$(this.table().body()).append(row);
    var widths = row.children().map(function() {
        return $d5722bd7562c0432$var$$(this).outerWidth();
    });
    row.remove();
    return this.iterator('column', function(settings, column) {
        var visIdx = $d5722bd7562c0432$var$_fnColumnIndexToVisible(settings, column);
        return visIdx !== null ? widths[visIdx] : 0;
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('columns().indexes()', 'column().index()', function(type) {
    return this.iterator('column', function(settings, column) {
        return type === 'visible' ? $d5722bd7562c0432$var$_fnColumnIndexToVisible(settings, column) : column;
    }, 1);
});
$d5722bd7562c0432$var$_api_register('columns.adjust()', function() {
    return this.iterator('table', function(settings) {
        // Force a column sizing to happen with a manual call - otherwise it can skip
        // if the size hasn't changed
        settings.containerWidth = -1;
        $d5722bd7562c0432$var$_fnAdjustColumnSizing(settings);
    }, 1);
});
$d5722bd7562c0432$var$_api_register('column.index()', function(type, idx) {
    if (this.context.length !== 0) {
        var ctx = this.context[0];
        if (type === 'fromVisible' || type === 'toData') return $d5722bd7562c0432$var$_fnVisibleToColumnIndex(ctx, idx);
        else if (type === 'fromData' || type === 'toVisible') return $d5722bd7562c0432$var$_fnColumnIndexToVisible(ctx, idx);
    }
});
$d5722bd7562c0432$var$_api_register('column()', function(selector, opts) {
    return $d5722bd7562c0432$var$_selector_first(this.columns(selector, opts));
});
var $d5722bd7562c0432$var$__cell_selector = function(settings, selector, opts) {
    var data = settings.aoData;
    var rows = $d5722bd7562c0432$var$_selector_row_indexes(settings, opts);
    var cells = $d5722bd7562c0432$var$_removeEmpty($d5722bd7562c0432$var$_pluck_order(data, rows, 'anCells'));
    var allCells = $d5722bd7562c0432$var$$($d5722bd7562c0432$var$_flatten([], cells));
    var row;
    var columns = settings.aoColumns.length;
    var a, i, ien, j, o, host;
    var run = function(s) {
        var fnSelector = typeof s === 'function';
        if (s === null || s === undefined || fnSelector) {
            // All cells and function selectors
            a = [];
            for(i = 0, ien = rows.length; i < ien; i++){
                row = rows[i];
                for(j = 0; j < columns; j++){
                    o = {
                        row: row,
                        column: j
                    };
                    if (fnSelector) {
                        // Selector - function
                        host = data[row];
                        if (s(o, $d5722bd7562c0432$var$_fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                    } else // Selector - all
                    a.push(o);
                }
            }
            return a;
        }
        // Selector - index
        if ($d5722bd7562c0432$var$$.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
        return s.column !== undefined && s.row !== undefined && rows.indexOf(s.row) !== -1 ? [
            s
        ] : [];
        // Selector - jQuery filtered cells
        var jqResult = allCells.filter(s).map(function(i, el) {
            return {
                row: el._DT_CellIndex.row,
                column: el._DT_CellIndex.column
            };
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise the selector is a node, and there is one last option - the
        // element might be a child of an element which has dt-row and dt-column
        // data attributes
        host = $d5722bd7562c0432$var$$(s).closest('*[data-dt-row]');
        return host.length ? [
            {
                row: host.data('dt-row'),
                column: host.data('dt-column')
            }
        ] : [];
    };
    return $d5722bd7562c0432$var$_selector_run('cell', selector, run, settings, opts);
};
$d5722bd7562c0432$var$_api_register('cells()', function(rowSelector, columnSelector, opts) {
    // Argument shifting
    if ($d5722bd7562c0432$var$$.isPlainObject(rowSelector)) {
        // Indexes
        if (rowSelector.row === undefined) {
            // Selector options in first parameter
            opts = rowSelector;
            rowSelector = null;
        } else {
            // Cell index objects in first parameter
            opts = columnSelector;
            columnSelector = null;
        }
    }
    if ($d5722bd7562c0432$var$$.isPlainObject(columnSelector)) {
        opts = columnSelector;
        columnSelector = null;
    }
    // Cell selector
    if (columnSelector === null || columnSelector === undefined) return this.iterator('table', function(settings) {
        return $d5722bd7562c0432$var$__cell_selector(settings, rowSelector, $d5722bd7562c0432$var$_selector_opts(opts));
    });
    // The default built in options need to apply to row and columns
    var internalOpts = opts ? {
        page: opts.page,
        order: opts.order,
        search: opts.search
    } : {};
    // Row + column selector
    var columns = this.columns(columnSelector, internalOpts);
    var rows = this.rows(rowSelector, internalOpts);
    var i, ien, j, jen;
    var cellsNoOpts = this.iterator('table', function(settings, idx) {
        var a = [];
        for(i = 0, ien = rows[idx].length; i < ien; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
            row: rows[idx][i],
            column: columns[idx][j]
        });
        return a;
    }, 1);
    // There is currently only one extension which uses a cell selector extension
    // It is a _major_ performance drag to run this if it isn't needed, so this is
    // an extension specific check at the moment
    var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
    $d5722bd7562c0432$var$$.extend(cells.selector, {
        cols: columnSelector,
        rows: rowSelector,
        opts: opts
    });
    return cells;
});
$d5722bd7562c0432$var$_api_registerPlural('cells().nodes()', 'cell().node()', function() {
    return this.iterator('cell', function(settings, row, column) {
        var data = settings.aoData[row];
        return data && data.anCells ? data.anCells[column] : undefined;
    }, 1);
});
$d5722bd7562c0432$var$_api_register('cells().data()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return $d5722bd7562c0432$var$_fnGetCellData(settings, row, column);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('cells().cache()', 'cell().cache()', function(type) {
    type = type === 'search' ? '_aFilterData' : '_aSortData';
    return this.iterator('cell', function(settings, row, column) {
        return settings.aoData[row][type][column];
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('cells().render()', 'cell().render()', function(type) {
    return this.iterator('cell', function(settings, row, column) {
        return $d5722bd7562c0432$var$_fnGetCellData(settings, row, column, type);
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('cells().indexes()', 'cell().index()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return {
            row: row,
            column: column,
            columnVisible: $d5722bd7562c0432$var$_fnColumnIndexToVisible(settings, column)
        };
    }, 1);
});
$d5722bd7562c0432$var$_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function(src) {
    return this.iterator('cell', function(settings, row, column) {
        $d5722bd7562c0432$var$_fnInvalidate(settings, row, src, column);
    });
});
$d5722bd7562c0432$var$_api_register('cell()', function(rowSelector, columnSelector, opts) {
    return $d5722bd7562c0432$var$_selector_first(this.cells(rowSelector, columnSelector, opts));
});
$d5722bd7562c0432$var$_api_register('cell().data()', function(data) {
    var ctx = this.context;
    var cell = this[0];
    if (data === undefined) // Get
    return ctx.length && cell.length ? $d5722bd7562c0432$var$_fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
    // Set
    $d5722bd7562c0432$var$_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
    $d5722bd7562c0432$var$_fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);
    return this;
});
/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 */ /**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('order()', function(order, dir) {
    var ctx = this.context;
    var args = Array.prototype.slice.call(arguments);
    if (order === undefined) // get
    return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
    // set
    if (typeof order === 'number') // Simple column / direction passed in
    order = [
        [
            order,
            dir
        ]
    ];
    else if (args.length > 1) // Arguments passed in (list of 1D arrays)
    order = args;
    // otherwise a 2D array was passed in
    return this.iterator('table', function(settings) {
        settings.aaSorting = Array.isArray(order) ? order.slice() : order;
    });
});
/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */ $d5722bd7562c0432$var$_api_register('order.listener()', function(node, column, callback) {
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnSortAttachListener(settings, node, {}, column, callback);
    });
});
$d5722bd7562c0432$var$_api_register('order.fixed()', function(set) {
    if (!set) {
        var ctx = this.context;
        var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
        return Array.isArray(fixed) ? {
            pre: fixed
        } : fixed;
    }
    return this.iterator('table', function(settings) {
        settings.aaSortingFixed = $d5722bd7562c0432$var$$.extend(true, {}, set);
    });
});
// Order by the selected column(s)
$d5722bd7562c0432$var$_api_register([
    'columns().order()',
    'column().order()'
], function(dir) {
    var that = this;
    if (!dir) return this.iterator('column', function(settings, idx) {
        var sort = $d5722bd7562c0432$var$_fnSortFlatten(settings);
        for(var i = 0, ien = sort.length; i < ien; i++){
            if (sort[i].col === idx) return sort[i].dir;
        }
        return null;
    }, 1);
    else return this.iterator('table', function(settings, i) {
        settings.aaSorting = that[i].map(function(col) {
            return [
                col,
                dir
            ];
        });
    });
});
$d5722bd7562c0432$var$_api_registerPlural('columns().orderable()', 'column().orderable()', function(directions) {
    return this.iterator('column', function(settings, idx) {
        var col = settings.aoColumns[idx];
        return directions ? col.asSorting : col.bSortable;
    }, 1);
});
$d5722bd7562c0432$var$_api_register('processing()', function(show) {
    return this.iterator('table', function(ctx) {
        $d5722bd7562c0432$var$_fnProcessingDisplay(ctx, show);
    });
});
$d5722bd7562c0432$var$_api_register('search()', function(input, regex, smart, caseInsen) {
    var ctx = this.context;
    if (input === undefined) // get
    return ctx.length !== 0 ? ctx[0].oPreviousSearch.search : undefined;
    // set
    return this.iterator('table', function(settings) {
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $d5722bd7562c0432$var$_fnFilterComplete(settings, $d5722bd7562c0432$var$$.extend(settings.oPreviousSearch, regex, {
            search: input
        }));
        else // Compat for the old options
        $d5722bd7562c0432$var$_fnFilterComplete(settings, $d5722bd7562c0432$var$$.extend(settings.oPreviousSearch, {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        }));
    });
});
$d5722bd7562c0432$var$_api_register('search.fixed()', function(name, search) {
    var ret = this.iterator(true, 'table', function(settings) {
        var fixed = settings.searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
$d5722bd7562c0432$var$_api_registerPlural('columns().search()', 'column().search()', function(input, regex, smart, caseInsen) {
    return this.iterator('column', function(settings, column) {
        var preSearch = settings.aoPreSearchCols;
        if (input === undefined) // get
        return preSearch[column].search;
        // set
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $d5722bd7562c0432$var$$.extend(preSearch[column], regex, {
            search: input
        });
        else // Old style (with not all options available)
        $d5722bd7562c0432$var$$.extend(preSearch[column], {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        });
        $d5722bd7562c0432$var$_fnFilterComplete(settings, settings.oPreviousSearch);
    });
});
$d5722bd7562c0432$var$_api_register([
    'columns().search.fixed()',
    'column().search.fixed()'
], function(name, search) {
    var ret = this.iterator(true, 'column', function(settings, colIdx) {
        var fixed = settings.aoColumns[colIdx].searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
/*
 * State API methods
 */ $d5722bd7562c0432$var$_api_register('state()', function(set, ignoreTime) {
    // getter
    if (!set) return this.context.length ? this.context[0].oSavedState : null;
    var setMutate = $d5722bd7562c0432$var$$.extend(true, {}, set);
    // setter
    return this.iterator('table', function(settings) {
        if (ignoreTime !== false) setMutate.time = +new Date() + 100;
        $d5722bd7562c0432$var$_fnImplementState(settings, setMutate, function() {});
    });
});
$d5722bd7562c0432$var$_api_register('state.clear()', function() {
    return this.iterator('table', function(settings) {
        // Save an empty object
        settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
    });
});
$d5722bd7562c0432$var$_api_register('state.loaded()', function() {
    return this.context.length ? this.context[0].oLoadedState : null;
});
$d5722bd7562c0432$var$_api_register('state.save()', function() {
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnSaveState(settings);
    });
});
// Can be assigned in DateTable.use() - note luxon and moment vars are in helpers.js
var $d5722bd7562c0432$var$__bootstrap;
var $d5722bd7562c0432$var$__foundation;
/**
 * Set the libraries that DataTables uses, or the global objects.
 * Note that the arguments can be either way around (legacy support)
 * and the second is optional. See docs.
 */ $d5722bd7562c0432$var$DataTable.use = function(arg1, arg2) {
    // Reverse arguments for legacy support
    var module = typeof arg1 === 'string' ? arg2 : arg1;
    var type = typeof arg2 === 'string' ? arg2 : arg1;
    // Getter
    if (module === undefined && typeof type === 'string') switch(type){
        case 'lib':
        case 'jq':
            return $d5722bd7562c0432$var$$;
        case 'win':
            return window;
        case 'datetime':
            return $d5722bd7562c0432$var$DataTable.DateTime;
        case 'luxon':
            return $d5722bd7562c0432$var$__luxon;
        case 'moment':
            return $d5722bd7562c0432$var$__moment;
        case 'bootstrap':
            // Use local if set, otherwise try window, which could be undefined
            return $d5722bd7562c0432$var$__bootstrap || window.bootstrap;
        case 'foundation':
            // Ditto
            return $d5722bd7562c0432$var$__foundation || window.Foundation;
        default:
            return null;
    }
    // Setter
    if (type === 'lib' || type === 'jq' || module && module.fn && module.fn.jquery) $d5722bd7562c0432$var$$ = module;
    else if (type === 'win' || module && module.document) {
        window = module;
        document = module.document;
    } else if (type === 'datetime' || module && module.type === 'DateTime') $d5722bd7562c0432$var$DataTable.DateTime = module;
    else if (type === 'luxon' || module && module.FixedOffsetZone) $d5722bd7562c0432$var$__luxon = module;
    else if (type === 'moment' || module && module.isMoment) $d5722bd7562c0432$var$__moment = module;
    else if (type === 'bootstrap' || module && module.Modal && module.Modal.NAME === 'modal') // This is currently for BS5 only. BS3/4 attach to jQuery, so no need to use `.use()`
    $d5722bd7562c0432$var$__bootstrap = module;
    else if (type === 'foundation' || module && module.Reveal) $d5722bd7562c0432$var$__foundation = module;
};
/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */ $d5722bd7562c0432$var$DataTable.factory = function(root, jq) {
    var is = false;
    // Test if the first parameter is a window object
    if (root && root.document) {
        window = root;
        document = root.document;
    }
    // Test if the second parameter is a jQuery object
    if (jq && jq.fn && jq.fn.jquery) {
        $d5722bd7562c0432$var$$ = jq;
        is = true;
    }
    return is;
};
/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @param {string} [version2=current DataTables version] As above, but optional.
 *   If not given the current DataTables version will be used.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */ $d5722bd7562c0432$var$DataTable.versionCheck = function(version, version2) {
    var aThis = version2 ? version2.split('.') : $d5722bd7562c0432$var$DataTable.version.split('.');
    var aThat = version.split('.');
    var iThis, iThat;
    for(var i = 0, iLen = aThat.length; i < iLen; i++){
        iThis = parseInt(aThis[i], 10) || 0;
        iThat = parseInt(aThat[i], 10) || 0;
        // Parts are the same, keep comparing
        if (iThis === iThat) continue;
        // Parts are different, return immediately
        return iThis > iThat;
    }
    return true;
};
/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */ $d5722bd7562c0432$var$DataTable.isDataTable = function(table) {
    var t = $d5722bd7562c0432$var$$(table).get(0);
    var is = false;
    if (table instanceof $d5722bd7562c0432$var$DataTable.Api) return true;
    $d5722bd7562c0432$var$$.each($d5722bd7562c0432$var$DataTable.settings, function(i, o) {
        var head = o.nScrollHead ? $d5722bd7562c0432$var$$('table', o.nScrollHead)[0] : null;
        var foot = o.nScrollFoot ? $d5722bd7562c0432$var$$('table', o.nScrollFoot)[0] : null;
        if (o.nTable === t || head === t || foot === t) is = true;
    });
    return is;
};
/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */ $d5722bd7562c0432$var$DataTable.tables = function(visible) {
    var api = false;
    if ($d5722bd7562c0432$var$$.isPlainObject(visible)) {
        api = visible.api;
        visible = visible.visible;
    }
    var a = $d5722bd7562c0432$var$DataTable.settings.filter(function(o) {
        return !visible || visible && $d5722bd7562c0432$var$$(o.nTable).is(':visible') ? true : false;
    }).map(function(o) {
        return o.nTable;
    });
    return api ? new $d5722bd7562c0432$var$_Api(a) : a;
};
/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */ $d5722bd7562c0432$var$DataTable.camelToHungarian = $d5722bd7562c0432$var$_fnCamelToHungarian;
/**
 *
 */ $d5722bd7562c0432$var$_api_register('$()', function(selector, opts) {
    var rows = this.rows(opts).nodes(), jqRows = $d5722bd7562c0432$var$$(rows);
    return $d5722bd7562c0432$var$$([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
});
// jQuery functions to operate on the tables
$d5722bd7562c0432$var$$.each([
    'on',
    'one',
    'off'
], function(i, key) {
    $d5722bd7562c0432$var$_api_register(key + '()', function() {
        var args = Array.prototype.slice.call(arguments);
        // Add the `dt` namespace automatically if it isn't already present
        args[0] = args[0].split(/\s/).map(function(e) {
            return !e.match(/\.dt\b/) ? e + '.dt' : e;
        }).join(' ');
        var inst = $d5722bd7562c0432$var$$(this.tables().nodes());
        inst[key].apply(inst, args);
        return this;
    });
});
$d5722bd7562c0432$var$_api_register('clear()', function() {
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnClearTable(settings);
    });
});
$d5722bd7562c0432$var$_api_register('error()', function(msg) {
    return this.iterator('table', function(settings) {
        $d5722bd7562c0432$var$_fnLog(settings, 0, msg);
    });
});
$d5722bd7562c0432$var$_api_register('settings()', function() {
    return new $d5722bd7562c0432$var$_Api(this.context, this.context);
});
$d5722bd7562c0432$var$_api_register('init()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
});
$d5722bd7562c0432$var$_api_register('data()', function() {
    return this.iterator('table', function(settings) {
        return $d5722bd7562c0432$var$_pluck(settings.aoData, '_aData');
    }).flatten();
});
$d5722bd7562c0432$var$_api_register('trigger()', function(name, args, bubbles) {
    return this.iterator('table', function(settings) {
        return $d5722bd7562c0432$var$_fnCallbackFire(settings, null, name, args, bubbles);
    }).flatten();
});
$d5722bd7562c0432$var$_api_register('ready()', function(fn) {
    var ctx = this.context;
    // Get status of first table
    if (!fn) return ctx.length ? ctx[0]._bInitComplete || false : null;
    // Function to run either once the table becomes ready or
    // immediately if it is already ready.
    return this.tables().every(function() {
        var api = this;
        if (this.context[0]._bInitComplete) fn.call(api);
        else this.on('init.dt.DT', function() {
            fn.call(api);
        });
    });
});
$d5722bd7562c0432$var$_api_register('destroy()', function(remove) {
    remove = remove || false;
    return this.iterator('table', function(settings) {
        var classes = settings.oClasses;
        var table = settings.nTable;
        var tbody = settings.nTBody;
        var thead = settings.nTHead;
        var tfoot = settings.nTFoot;
        var jqTable = $d5722bd7562c0432$var$$(table);
        var jqTbody = $d5722bd7562c0432$var$$(tbody);
        var jqWrapper = $d5722bd7562c0432$var$$(settings.nTableWrapper);
        var rows = settings.aoData.map(function(r) {
            return r ? r.nTr : null;
        });
        var orderClasses = classes.order;
        // Flag to note that the table is currently being destroyed - no action
        // should be taken
        settings.bDestroying = true;
        // Fire off the destroy callbacks for plug-ins etc
        $d5722bd7562c0432$var$_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
            settings
        ], true);
        // If not being removed from the document, make all columns visible
        if (!remove) new $d5722bd7562c0432$var$_Api(settings).columns().visible(true);
        // Container width change listener
        if (settings.resizeObserver) settings.resizeObserver.disconnect();
        // Blitz all `DT` namespaced events (these are internal events, the
        // lowercase, `dt` events are user subscribed and they are responsible
        // for removing them
        jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
        $d5722bd7562c0432$var$$(window).off('.DT-' + settings.sInstance);
        // When scrolling we had to break the table up - restore it
        if (table != thead.parentNode) {
            jqTable.children('thead').detach();
            jqTable.append(thead);
        }
        if (tfoot && table != tfoot.parentNode) {
            jqTable.children('tfoot').detach();
            jqTable.append(tfoot);
        }
        // Clean up the header
        $d5722bd7562c0432$var$$(thead).find('span.dt-column-order').remove();
        $d5722bd7562c0432$var$$(thead).find('span.dt-column-title').each(function() {
            var title = $d5722bd7562c0432$var$$(this).html();
            $d5722bd7562c0432$var$$(this).parent().append(title);
            $d5722bd7562c0432$var$$(this).remove();
        });
        settings.colgroup.remove();
        settings.aaSorting = [];
        settings.aaSortingFixed = [];
        $d5722bd7562c0432$var$_fnSortingClasses(settings);
        $d5722bd7562c0432$var$$(jqTable).find('th, td').removeClass($d5722bd7562c0432$var$$.map($d5722bd7562c0432$var$DataTable.ext.type.className, function(v) {
            return v;
        }).join(' '));
        $d5722bd7562c0432$var$$('th, td', thead).removeClass(orderClasses.none + ' ' + orderClasses.canAsc + ' ' + orderClasses.canDesc + ' ' + orderClasses.isAsc + ' ' + orderClasses.isDesc).css('width', '').removeAttr('data-dt-column').removeAttr('aria-sort');
        // Add the TR elements back into the table in their original order
        jqTbody.children().detach();
        jqTbody.append(rows);
        var orig = settings.nTableWrapper.parentNode;
        var insertBefore = settings.nTableWrapper.nextSibling;
        // Remove the DataTables generated nodes, events and classes
        var removedMethod = remove ? 'remove' : 'detach';
        jqTable[removedMethod]();
        jqWrapper[removedMethod]();
        // If we need to reattach the table to the document
        if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            orig.insertBefore(table, insertBefore);
            // Restore the width of the original table - was read from the style property,
            // so we can restore directly to that
            jqTable.css('width', settings.sDestroyWidth).removeClass(classes.table);
        }
        /* Remove the settings object from the settings array */ var idx = $d5722bd7562c0432$var$DataTable.settings.indexOf(settings);
        if (idx !== -1) $d5722bd7562c0432$var$DataTable.settings.splice(idx, 1);
    });
});
// Add the `every()` method for rows, columns and cells in a compact form
$d5722bd7562c0432$var$$.each([
    'column',
    'row',
    'cell'
], function(i, type) {
    $d5722bd7562c0432$var$_api_register(type + 's().every()', function(fn) {
        var opts = this.selector.opts;
        var api = this;
        var inst;
        var counter = 0;
        return this.iterator('every', function(settings, selectedIdx, tableIdx) {
            inst = api[type](selectedIdx, opts);
            if (type === 'cell') fn.call(inst, inst[0][0].row, inst[0][0].column, tableIdx, counter);
            else fn.call(inst, selectedIdx, tableIdx, counter);
            counter++;
        });
    });
});
// i18n method for extensions to be able to use the language object from the
// DataTable
$d5722bd7562c0432$var$_api_register('i18n()', function(token, def, plural) {
    var ctx = this.context[0];
    var resolved = $d5722bd7562c0432$var$_fnGetObjectDataFn(token)(ctx.oLanguage);
    if (resolved === undefined) resolved = def;
    if ($d5722bd7562c0432$var$$.isPlainObject(resolved)) resolved = plural !== undefined && resolved[plural] !== undefined ? resolved[plural] : resolved._;
    return typeof resolved === 'string' ? resolved.replace('%d', plural) // nb: plural might be undefined,
     : resolved;
});
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */ $d5722bd7562c0432$var$DataTable.version = "2.2.2";
/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */ $d5722bd7562c0432$var$DataTable.settings = [];
/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.models = {};
/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.models.oSearch = {
    /**
	 * Flag to indicate if the filtering should be case insensitive or not
	 */ "caseInsensitive": true,
    /**
	 * Applied search term
	 */ "search": "",
    /**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 */ "regex": false,
    /**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 */ "smart": true,
    /**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 */ "return": false
};
/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.models.oRow = {
    /**
	 * TR element for the row
	 */ "nTr": null,
    /**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 */ "anCells": null,
    /**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 */ "_aData": [],
    /**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 */ "_aSortData": null,
    /**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 */ "_aFilterData": null,
    /**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 */ "_sFilterRow": null,
    /**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 */ "src": null,
    /**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 */ "idx": -1,
    /**
	 * Cached display value
	 */ displayData: null
};
/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.models.oColumn = {
    /**
	 * Column index.
	 */ "idx": null,
    /**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 */ "aDataSort": null,
    /**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 */ "asSorting": null,
    /**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 */ "bSearchable": null,
    /**
	 * Flag to indicate if the column is sortable or not.
	 */ "bSortable": null,
    /**
	 * Flag to indicate if the column is currently visible in the table or not
	 */ "bVisible": null,
    /**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 */ "_sManualType": null,
    /**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 */ "_bAttrSrc": false,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 */ "fnGetData": null,
    /**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 */ "fnSetData": null,
    /**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 */ "mData": null,
    /**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 */ "mRender": null,
    /**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 */ "sClass": null,
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 */ "sContentPadding": null,
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 */ "sName": null,
    /**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 */ "sSortDataType": 'std',
    /**
	 * Class to be applied to the header element when sorting on this column
	 */ "sSortingClass": null,
    /**
	 * Title of the column - what is seen in the TH element (nTh).
	 */ "sTitle": null,
    /**
	 * Column sorting and filtering type
	 */ "sType": null,
    /**
	 * Width of the column
	 */ "sWidth": null,
    /**
	 * Width of the column when it was first "encountered"
	 */ "sWidthOrig": null,
    /** Cached string which is the longest in the column */ maxLenString: null,
    /**
	 * Store for named searches
	 */ searchFixed: null
};
/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a Javascript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */ /**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.defaults = {
    /**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in Javascript, for
	 * example with a custom Ajax call.
	 */ "aaData": null,
    /**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 */ "aaSorting": [
        [
            0,
            'asc'
        ]
    ],
    /**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 */ "aaSortingFixed": [],
    /**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use Javascript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 */ "ajax": null,
    /**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 */ "aLengthMenu": [
        10,
        25,
        50,
        100
    ],
    /**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 */ "aoColumns": null,
    /**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 */ "aoColumnDefs": null,
    /**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 */ "aoSearchCols": [],
    /**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 */ "bAutoWidth": true,
    /**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 */ "bDeferRender": true,
    /**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 */ "bDestroy": false,
    /**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 */ "bFilter": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bInfo": true,
    /**
	 * Used only for compatiblity with DT1
	 * @deprecated
	 */ "bLengthChange": true,
    /**
	 * Enable or disable pagination.
	 */ "bPaginate": true,
    /**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 */ "bProcessing": false,
    /**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 */ "bRetrieve": false,
    /**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 */ "bScrollCollapse": false,
    /**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 */ "bServerSide": false,
    /**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 */ "bSort": true,
    /**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 */ "bSortMulti": true,
    /**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 */ "bSortCellsTop": null,
    /**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 */ "bSortClasses": true,
    /**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display display will match what thy had previously set up.
	 */ "bStateSave": false,
    /**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 */ "fnCreatedRow": null,
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 */ "fnDrawCallback": null,
    /**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 */ "fnFooterCallback": null,
    /**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 */ "fnFormatNumber": function(toFormat) {
        return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
    },
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 */ "fnHeaderCallback": null,
    /**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 */ "fnInfoCallback": null,
    /**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 */ "fnInitComplete": null,
    /**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 */ "fnPreDrawCallback": null,
    /**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 */ "fnRowCallback": null,
    /**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateLoadCallback": function(settings) {
        try {
            return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
        } catch (e) {
            return {};
        }
    },
    /**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 */ "fnStateLoadParams": null,
    /**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 */ "fnStateLoaded": null,
    /**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateSaveCallback": function(settings, data) {
        try {
            (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
        } catch (e) {
        // noop
        }
    },
    /**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 */ "fnStateSaveParams": null,
    /**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 */ "iStateDuration": 7200,
    /**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 */ "iDisplayLength": 10,
    /**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 */ "iDisplayStart": 0,
    /**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 */ "iTabIndex": 0,
    /**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 */ "oClasses": {},
    /**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 */ "oLanguage": {
        /**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 */ "oAria": {
            /**
			 * ARIA label that is added to the table headers when the column may be sorted
			 */ "orderable": ": Activate to sort",
            /**
			 * ARIA label that is added to the table headers when the column is currently being sorted
			 */ "orderableReverse": ": Activate to invert sorting",
            /**
			 * ARIA label that is added to the table headers when the column is currently being 
			 * sorted and next step is to remove sorting
			 */ "orderableRemove": ": Activate to remove sorting",
            paginate: {
                first: 'First',
                last: 'Last',
                next: 'Next',
                previous: 'Previous',
                number: ''
            }
        },
        /**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 */ "oPaginate": {
            /**
			 * Label and character for first page button («)
			 */ "sFirst": "\u00AB",
            /**
			 * Last page button (»)
			 */ "sLast": "\u00BB",
            /**
			 * Next page button (›)
			 */ "sNext": "\u203A",
            /**
			 * Previous page button (‹)
			 */ "sPrevious": "\u2039"
        },
        /**
		 * Plural object for the data type the table is showing
		 */ entries: {
            _: "entries",
            1: "entry"
        },
        /**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 */ "sEmptyTable": "No data available in table",
        /**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
        /**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 */ "sInfoEmpty": "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
        /**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 */ "sInfoFiltered": "(filtered from _MAX_ total _ENTRIES-MAX_)",
        /**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 */ "sInfoPostFix": "",
        /**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 */ "sDecimal": "",
        /**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 */ "sThousands": ",",
        /**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 */ "sLengthMenu": "_MENU_ _ENTRIES_ per page",
        /**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 */ "sLoadingRecords": "Loading...",
        /**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 */ "sProcessing": "",
        /**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 */ "sSearch": "Search:",
        /**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */ "sSearchPlaceholder": "",
        /**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 */ "sUrl": "",
        /**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 */ "sZeroRecords": "No matching records found"
    },
    /** The initial data order is reversed when `desc` ordering */ orderDescReverse: true,
    /**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 */ "oSearch": $d5722bd7562c0432$var$$.extend({}, $d5722bd7562c0432$var$DataTable.models.oSearch),
    /**
	 * Table and control layout. This replaces the legacy `dom` option.
	 */ layout: {
        topStart: 'pageLength',
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
    },
    /**
	 * Legacy DOM layout option
	 */ "sDom": null,
    /**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 */ "searchDelay": null,
    /**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 */ "sPaginationType": "",
    /**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 */ "sScrollX": "",
    /**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 */ "sScrollXInner": "",
    /**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 */ "sScrollY": "",
    /**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 */ "sServerMethod": "GET",
    /**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 */ "renderer": null,
    /**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 */ "rowId": "DT_RowId",
    /**
	 * Caption value
	 */ "caption": null,
    /**
	 * For server-side processing - use the data from the DOM for the first draw
	 */ iDeferLoading: null
};
$d5722bd7562c0432$var$_fnHungarianMap($d5722bd7562c0432$var$DataTable.defaults);
/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */ /**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */ $d5722bd7562c0432$var$DataTable.defaults.column = {
    /**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 */ "aDataSort": null,
    "iDataSort": -1,
    ariaTitle: '',
    /**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 */ "asSorting": [
        'asc',
        'desc',
        ''
    ],
    /**
	 * Enable or disable filtering on the data in this column.
	 */ "bSearchable": true,
    /**
	 * Enable or disable ordering on this column.
	 */ "bSortable": true,
    /**
	 * Enable or disable the display of this column.
	 */ "bVisible": true,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 */ "mData": null,
    /**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted Javascript notation. Just as you use a `.` in
	 *      Javascript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 */ "mRender": null,
    /**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 */ "sCellType": "td",
    /**
	 * Class to give to each cell in this column.
	 */ "sClass": "",
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 */ "sContentPadding": "",
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 */ "sName": "",
    /**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 */ "sSortDataType": "std",
    /**
	 * The title of this column.
	 */ "sTitle": null,
    /**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by Javascript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 */ "sType": null,
    /**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 */ "sWidth": null
};
$d5722bd7562c0432$var$_fnHungarianMap($d5722bd7562c0432$var$DataTable.defaults.column);
/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 */ $d5722bd7562c0432$var$DataTable.models.oSettings = {
    /**
	 * Primary features of DataTables and their enablement state.
	 */ "oFeatures": {
        /**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bAutoWidth": null,
        /**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and Javascript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bDeferRender": null,
        /**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bFilter": null,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bInfo": true,
        /**
		 * Used only for compatiblity with DT1
		 * @deprecated
		 */ "bLengthChange": true,
        /**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bPaginate": null,
        /**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bProcessing": null,
        /**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bServerSide": null,
        /**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSort": null,
        /**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortMulti": null,
        /**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortClasses": null,
        /**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bStateSave": null
    },
    /**
	 * Scrolling settings for a table.
	 */ "oScroll": {
        /**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bCollapse": null,
        /**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 */ "iBarWidth": 0,
        /**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sX": null,
        /**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @deprecated
		 */ "sXInner": null,
        /**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sY": null
    },
    /**
	 * Language information for the table.
	 */ "oLanguage": {
        /**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 */ "fnInfoCallback": null
    },
    /**
	 * Browser support parameters
	 */ "oBrowser": {
        /**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 */ "bScrollbarLeft": false,
        /**
		 * Browser scrollbar width
		 */ "barWidth": 0
    },
    "ajax": null,
    /**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 */ "aanFeatures": [],
    /**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 */ "aoData": [],
    /**
	 * Array of indexes which are in the current display (after filtering etc)
	 */ "aiDisplay": [],
    /**
	 * Array of indexes for display - no filtering
	 */ "aiDisplayMaster": [],
    /**
	 * Map of row ids to data indexes
	 */ "aIds": {},
    /**
	 * Store information about each column that is in use
	 */ "aoColumns": [],
    /**
	 * Store information about the table's header
	 */ "aoHeader": [],
    /**
	 * Store information about the table's footer
	 */ "aoFooter": [],
    /**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "oPreviousSearch": {},
    /**
	 * Store for named searches
	 */ searchFixed: {},
    /**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 */ "aoPreSearchCols": [],
    /**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSorting": null,
    /**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSortingFixed": [],
    /**
	 * If restoring a table - we should restore its width
	 */ "sDestroyWidth": 0,
    /**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 */ "aoRowCallback": [],
    /**
	 * Callback functions for the header on each draw.
	 */ "aoHeaderCallback": [],
    /**
	 * Callback function for the footer on each draw.
	 */ "aoFooterCallback": [],
    /**
	 * Array of callback functions for draw callback functions
	 */ "aoDrawCallback": [],
    /**
	 * Array of callback functions for row created function
	 */ "aoRowCreatedCallback": [],
    /**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 */ "aoPreDrawCallback": [],
    /**
	 * Callback functions for when the table has been initialised.
	 */ "aoInitComplete": [],
    /**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 */ "aoStateSaveParams": [],
    /**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 */ "aoStateLoadParams": [],
    /**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 */ "aoStateLoaded": [],
    /**
	 * Cache the table ID for quick access
	 */ "sTableId": "",
    /**
	 * The TABLE node for the main table
	 */ "nTable": null,
    /**
	 * Permanent ref to the thead element
	 */ "nTHead": null,
    /**
	 * Permanent ref to the tfoot element - if it exists
	 */ "nTFoot": null,
    /**
	 * Permanent ref to the tbody element
	 */ "nTBody": null,
    /**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 */ "nTableWrapper": null,
    /**
	 * Indicate if all required information has been read in
	 */ "bInitialised": false,
    /**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 */ "aoOpenRows": [],
    /**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sDom": null,
    /**
	 * Search delay (in mS)
	 */ "searchDelay": null,
    /**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sPaginationType": "two_button",
    /**
	 * Number of paging controls on the page. Only used for backwards compatibility
	 */ pagingControls: 0,
    /**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "iStateDuration": 0,
    /**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateSave": [],
    /**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateLoad": [],
    /**
	 * State that was saved. Useful for back reference
	 */ "oSavedState": null,
    /**
	 * State that was loaded. Useful for back reference
	 */ "oLoadedState": null,
    /**
	 * Note if draw should be blocked while getting data
	 */ "bAjaxDataGet": true,
    /**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 */ "jqXHR": null,
    /**
	 * JSON returned from the server in the last Ajax request
	 */ "json": undefined,
    /**
	 * Data submitted as part of the last Ajax request
	 */ "oAjaxData": undefined,
    /**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sServerMethod": null,
    /**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "fnFormatNumber": null,
    /**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aLengthMenu": null,
    /**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 */ "iDraw": 0,
    /**
	 * Indicate if a redraw is being done - useful for Ajax
	 */ "bDrawing": false,
    /**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 */ "iDrawError": -1,
    /**
	 * Paging display length
	 */ "_iDisplayLength": 10,
    /**
	 * Paging start point - aiDisplay index
	 */ "_iDisplayStart": 0,
    /**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsTotal": 0,
    /**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsDisplay": 0,
    /**
	 * The classes to use for the table
	 */ "oClasses": {},
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bFiltered": false,
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bSorted": false,
    /**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column, if the top one (true) or bottom one (false)
	 * should be used for sorting / title by DataTables.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "bSortCellsTop": null,
    /**
	 * Initialisation object that is used for the table
	 */ "oInit": null,
    /**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 */ "aoDestroyCallback": [],
    /**
	 * Get the number of records in the current record set, before filtering
	 */ "fnRecordsTotal": function() {
        return $d5722bd7562c0432$var$_fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
    },
    /**
	 * Get the number of records in the current record set, after filtering
	 */ "fnRecordsDisplay": function() {
        return $d5722bd7562c0432$var$_fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
    },
    /**
	 * Get the display end point - aiDisplay index
	 */ "fnDisplayEnd": function() {
        var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
        if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
        else return !paginate || calc > records || len === -1 ? records : calc;
    },
    /**
	 * The DataTables object for this table
	 */ "oInstance": null,
    /**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 */ "sInstance": null,
    /**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */ "iTabIndex": 0,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollHead": null,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollFoot": null,
    /**
	 * Last applied sort
	 */ "aLastSort": [],
    /**
	 * Stored plug-in instances
	 */ "oPlugins": {},
    /**
	 * Function used to get a row's id from the row's data
	 */ "rowIdFn": null,
    /**
	 * Data location where to store a row's id
	 */ "rowId": null,
    caption: '',
    captionNode: null,
    colgroup: null,
    /** Delay loading of data */ deferLoading: null,
    /** Allow auto type detection */ typeDetect: true,
    /** ResizeObserver for the container div */ resizeObserver: null,
    /** Keep a record of the last size of the container, so we can skip duplicates */ containerWidth: -1
};
/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */ var $d5722bd7562c0432$var$extPagination = $d5722bd7562c0432$var$DataTable.ext.pager;
// Paging buttons configuration
$d5722bd7562c0432$var$$.extend($d5722bd7562c0432$var$extPagination, {
    simple: function() {
        return [
            'previous',
            'next'
        ];
    },
    full: function() {
        return [
            'first',
            'previous',
            'next',
            'last'
        ];
    },
    numbers: function() {
        return [
            'numbers'
        ];
    },
    simple_numbers: function() {
        return [
            'previous',
            'numbers',
            'next'
        ];
    },
    full_numbers: function() {
        return [
            'first',
            'previous',
            'numbers',
            'next',
            'last'
        ];
    },
    first_last: function() {
        return [
            'first',
            'last'
        ];
    },
    first_last_numbers: function() {
        return [
            'first',
            'numbers',
            'last'
        ];
    },
    // For testing and plug-ins to use
    _numbers: $d5722bd7562c0432$var$_pagingNumbers,
    // Number of number buttons - legacy, use `numbers` option for paging feature
    numbers_length: 7
});
$d5722bd7562c0432$var$$.extend(true, $d5722bd7562c0432$var$DataTable.ext.renderer, {
    pagingButton: {
        _: function(settings, buttonType, content, active, disabled) {
            var classes = settings.oClasses.paging;
            var btnClasses = [
                classes.button
            ];
            var btn;
            if (active) btnClasses.push(classes.active);
            if (disabled) btnClasses.push(classes.disabled);
            if (buttonType === 'ellipsis') btn = $d5722bd7562c0432$var$$('<span class="ellipsis"></span>').html(content)[0];
            else btn = $d5722bd7562c0432$var$$('<button>', {
                class: btnClasses.join(' '),
                role: 'link',
                type: 'button'
            }).html(content);
            return {
                display: btn,
                clicker: btn
            };
        }
    },
    pagingContainer: {
        _: function(settings, buttons) {
            // No wrapping element - just append directly to the host
            return buttons;
        }
    }
});
// Common function to remove new lines, strip HTML and diacritic control
var $d5722bd7562c0432$var$_filterString = function(stripHtml, normalize) {
    return function(str) {
        if ($d5722bd7562c0432$var$_empty(str) || typeof str !== 'string') return str;
        str = str.replace($d5722bd7562c0432$var$_re_new_lines, " ");
        if (stripHtml) str = $d5722bd7562c0432$var$_stripHtml(str);
        if (normalize) str = $d5722bd7562c0432$var$_normalize(str, false);
        return str;
    };
};
/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */ /**
 * Common logic for moment, luxon or a date action.
 *
 * Happens after __mldObj, so don't need to call `resolveWindowsLibs` again
 */ function $d5722bd7562c0432$var$__mld(dtLib, momentFn, luxonFn, dateFn, arg1) {
    if ($d5722bd7562c0432$var$__moment) return dtLib[momentFn](arg1);
    else if ($d5722bd7562c0432$var$__luxon) return dtLib[luxonFn](arg1);
    return dateFn ? dtLib[dateFn](arg1) : dtLib;
}
var $d5722bd7562c0432$var$__mlWarning = false;
var $d5722bd7562c0432$var$__luxon; // Can be assigned in DateTable.use()
var $d5722bd7562c0432$var$__moment; // Can be assigned in DateTable.use()
/**
 * 
 */ function $d5722bd7562c0432$var$resolveWindowLibs() {
    if (window.luxon && !$d5722bd7562c0432$var$__luxon) $d5722bd7562c0432$var$__luxon = window.luxon;
    if (window.moment && !$d5722bd7562c0432$var$__moment) $d5722bd7562c0432$var$__moment = window.moment;
}
function $d5722bd7562c0432$var$__mldObj(d, format, locale) {
    var dt;
    $d5722bd7562c0432$var$resolveWindowLibs();
    if ($d5722bd7562c0432$var$__moment) {
        dt = $d5722bd7562c0432$var$__moment.utc(d, format, locale, true);
        if (!dt.isValid()) return null;
    } else if ($d5722bd7562c0432$var$__luxon) {
        dt = format && typeof d === 'string' ? $d5722bd7562c0432$var$__luxon.DateTime.fromFormat(d, format) : $d5722bd7562c0432$var$__luxon.DateTime.fromISO(d);
        if (!dt.isValid) return null;
        dt = dt.setLocale(locale);
    } else if (!format) // No format given, must be ISO
    dt = new Date(d);
    else {
        if (!$d5722bd7562c0432$var$__mlWarning) alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
        $d5722bd7562c0432$var$__mlWarning = true;
    }
    return dt;
}
// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function $d5722bd7562c0432$var$__mlHelper(localeString) {
    return function(from, to, locale, def) {
        // Luxon and Moment support
        // Argument shifting
        if (arguments.length === 0) {
            locale = 'en';
            to = null; // means toLocaleString
            from = null; // means iso8601
        } else if (arguments.length === 1) {
            locale = 'en';
            to = from;
            from = null;
        } else if (arguments.length === 2) {
            locale = to;
            to = from;
            from = null;
        }
        var typeName = 'datetime' + (to ? '-' + to : '');
        // Add type detection and sorting specific to this date format - we need to be able to identify
        // date type columns as such, rather than as numbers in extensions. Hence the need for this.
        if (!$d5722bd7562c0432$var$DataTable.ext.type.order[typeName + '-pre']) $d5722bd7562c0432$var$DataTable.type(typeName, {
            detect: function(d) {
                // The renderer will give the value to type detect as the type!
                return d === typeName ? typeName : false;
            },
            order: {
                pre: function(d) {
                    // The renderer gives us Moment, Luxon or Date obects for the sorting, all of which have a
                    // `valueOf` which gives milliseconds epoch
                    return d.valueOf();
                }
            },
            className: 'dt-right'
        });
        return function(d, type) {
            // Allow for a default value
            if (d === null || d === undefined) {
                if (def === '--now') {
                    // We treat everything as UTC further down, so no changes are
                    // made, as such need to get the local date / time as if it were
                    // UTC
                    var local = new Date();
                    d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                } else d = '';
            }
            if (type === 'type') // Typing uses the type name for fast matching
            return typeName;
            if (d === '') return type !== 'sort' ? '' : $d5722bd7562c0432$var$__mldObj('0000-01-01 00:00:00', null, locale);
            // Shortcut. If `from` and `to` are the same, we are using the renderer to
            // format for ordering, not display - its already in the display format.
            if (to !== null && from === to && type !== 'sort' && type !== 'type' && !(d instanceof Date)) return d;
            var dt = $d5722bd7562c0432$var$__mldObj(d, from, locale);
            if (dt === null) return d;
            if (type === 'sort') return dt;
            var formatted = to === null ? $d5722bd7562c0432$var$__mld(dt, 'toDate', 'toJSDate', '')[localeString]() : $d5722bd7562c0432$var$__mld(dt, 'format', 'toFormat', 'toISOString', to);
            // XSS protection
            return type === 'display' ? $d5722bd7562c0432$var$_escapeHtml(formatted) : formatted;
        };
    };
}
// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var $d5722bd7562c0432$var$__thousands = ',';
var $d5722bd7562c0432$var$__decimal = '.';
if (window.Intl !== undefined) try {
    var $d5722bd7562c0432$var$num = new Intl.NumberFormat().formatToParts(100000.1);
    for(var $d5722bd7562c0432$var$i = 0; $d5722bd7562c0432$var$i < $d5722bd7562c0432$var$num.length; $d5722bd7562c0432$var$i++){
        if ($d5722bd7562c0432$var$num[$d5722bd7562c0432$var$i].type === 'group') $d5722bd7562c0432$var$__thousands = $d5722bd7562c0432$var$num[$d5722bd7562c0432$var$i].value;
        else if ($d5722bd7562c0432$var$num[$d5722bd7562c0432$var$i].type === 'decimal') $d5722bd7562c0432$var$__decimal = $d5722bd7562c0432$var$num[$d5722bd7562c0432$var$i].value;
    }
} catch (e) {
// noop
}
// Formatted date time detection - use by declaring the formats you are going to use
$d5722bd7562c0432$var$DataTable.datetime = function(format, locale) {
    var typeName = 'datetime-' + format;
    if (!locale) locale = 'en';
    if (!$d5722bd7562c0432$var$DataTable.ext.type.order[typeName]) $d5722bd7562c0432$var$DataTable.type(typeName, {
        detect: function(d) {
            var dt = $d5722bd7562c0432$var$__mldObj(d, format, locale);
            return d === '' || dt ? typeName : false;
        },
        order: {
            pre: function(d) {
                return $d5722bd7562c0432$var$__mldObj(d, format, locale) || 0;
            }
        },
        className: 'dt-right'
    });
};
/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `moment` - Uses the MomentJS library to convert from a given format into another.
 * This renderer has three overloads:
 *   * 1 parameter:
 *     * `string` - Format to convert to (assumes input is ISO8601 and locale is `en`)
 *   * 2 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to. Assumes `en` locale
 *   * 3 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to
 *     * `string` - Locale
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */ $d5722bd7562c0432$var$DataTable.render = {
    date: $d5722bd7562c0432$var$__mlHelper('toLocaleDateString'),
    datetime: $d5722bd7562c0432$var$__mlHelper('toLocaleString'),
    time: $d5722bd7562c0432$var$__mlHelper('toLocaleTimeString'),
    number: function(thousands, decimal, precision, prefix, postfix) {
        // Auto locale detection
        if (thousands === null || thousands === undefined) thousands = $d5722bd7562c0432$var$__thousands;
        if (decimal === null || decimal === undefined) decimal = $d5722bd7562c0432$var$__decimal;
        return {
            display: function(d) {
                if (typeof d !== 'number' && typeof d !== 'string') return d;
                if (d === '' || d === null) return d;
                var negative = d < 0 ? '-' : '';
                var flo = parseFloat(d);
                var abs = Math.abs(flo);
                // Scientific notation for large and small numbers
                if (abs >= 100000000000 || abs < 0.0001 && abs !== 0) {
                    var exp = flo.toExponential(precision).split(/e\+?/);
                    return exp[0] + ' x 10<sup>' + exp[1] + '</sup>';
                }
                // If NaN then there isn't much formatting that we can do - just
                // return immediately, escaping any HTML (this was supposed to
                // be a number after all)
                if (isNaN(flo)) return $d5722bd7562c0432$var$_escapeHtml(d);
                flo = flo.toFixed(precision);
                d = Math.abs(flo);
                var intPart = parseInt(d, 10);
                var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';
                // If zero, then can't have a negative prefix
                if (intPart === 0 && parseFloat(floatPart) === 0) negative = '';
                return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || '');
            }
        };
    },
    text: function() {
        return {
            display: $d5722bd7562c0432$var$_escapeHtml,
            filter: $d5722bd7562c0432$var$_escapeHtml
        };
    }
};
var $d5722bd7562c0432$var$_extTypes = $d5722bd7562c0432$var$DataTable.ext.type;
// Get / set type
$d5722bd7562c0432$var$DataTable.type = function(name, prop, val) {
    if (!prop) return {
        className: $d5722bd7562c0432$var$_extTypes.className[name],
        detect: $d5722bd7562c0432$var$_extTypes.detect.find(function(fn) {
            return fn._name === name;
        }),
        order: {
            pre: $d5722bd7562c0432$var$_extTypes.order[name + '-pre'],
            asc: $d5722bd7562c0432$var$_extTypes.order[name + '-asc'],
            desc: $d5722bd7562c0432$var$_extTypes.order[name + '-desc']
        },
        render: $d5722bd7562c0432$var$_extTypes.render[name],
        search: $d5722bd7562c0432$var$_extTypes.search[name]
    };
    var setProp = function(prop, propVal) {
        $d5722bd7562c0432$var$_extTypes[prop][name] = propVal;
    };
    var setDetect = function(detect) {
        // `detect` can be a function or an object - we set a name
        // property for either - that is used for the detection
        Object.defineProperty(detect, "_name", {
            value: name
        });
        var idx = $d5722bd7562c0432$var$_extTypes.detect.findIndex(function(item) {
            return item._name === name;
        });
        if (idx === -1) $d5722bd7562c0432$var$_extTypes.detect.unshift(detect);
        else $d5722bd7562c0432$var$_extTypes.detect.splice(idx, 1, detect);
    };
    var setOrder = function(obj) {
        $d5722bd7562c0432$var$_extTypes.order[name + '-pre'] = obj.pre; // can be undefined
        $d5722bd7562c0432$var$_extTypes.order[name + '-asc'] = obj.asc; // can be undefined
        $d5722bd7562c0432$var$_extTypes.order[name + '-desc'] = obj.desc; // can be undefined
    };
    // prop is optional
    if (val === undefined) {
        val = prop;
        prop = null;
    }
    if (prop === 'className') setProp('className', val);
    else if (prop === 'detect') setDetect(val);
    else if (prop === 'order') setOrder(val);
    else if (prop === 'render') setProp('render', val);
    else if (prop === 'search') setProp('search', val);
    else if (!prop) {
        if (val.className) setProp('className', val.className);
        if (val.detect !== undefined) setDetect(val.detect);
        if (val.order) setOrder(val.order);
        if (val.render !== undefined) setProp('render', val.render);
        if (val.search !== undefined) setProp('search', val.search);
    }
};
// Get a list of types
$d5722bd7562c0432$var$DataTable.types = function() {
    return $d5722bd7562c0432$var$_extTypes.detect.map(function(fn) {
        return fn._name;
    });
};
var $d5722bd7562c0432$var$__diacriticSort = function(a, b) {
    a = a !== null && a !== undefined ? a.toString().toLowerCase() : '';
    b = b !== null && b !== undefined ? b.toString().toLowerCase() : '';
    // Checked for `navigator.languages` support in `oneOf` so this code can't execute in old
    // Safari and thus can disable this check
    // eslint-disable-next-line compat/compat
    return a.localeCompare(b, navigator.languages[0] || navigator.language, {
        numeric: true,
        ignorePunctuation: true
    });
};
var $d5722bd7562c0432$var$__diacriticHtmlSort = function(a, b) {
    a = $d5722bd7562c0432$var$_stripHtml(a);
    b = $d5722bd7562c0432$var$_stripHtml(b);
    return $d5722bd7562c0432$var$__diacriticSort(a, b);
};
//
// Built in data types
//
$d5722bd7562c0432$var$DataTable.type('string', {
    detect: function() {
        return 'string';
    },
    order: {
        pre: function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return $d5722bd7562c0432$var$_empty(a) && typeof a !== 'boolean' ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
        }
    },
    search: $d5722bd7562c0432$var$_filterString(false, true)
});
$d5722bd7562c0432$var$DataTable.type('string-utf8', {
    detect: {
        allOf: function(d) {
            return true;
        },
        oneOf: function(d) {
            // At least one data point must contain a non-ASCII character
            // This line will also check if navigator.languages is supported or not. If not (Safari 10.0-)
            // this data type won't be supported.
            // eslint-disable-next-line compat/compat
            return !$d5722bd7562c0432$var$_empty(d) && navigator.languages && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $d5722bd7562c0432$var$__diacriticSort,
        desc: function(a, b) {
            return $d5722bd7562c0432$var$__diacriticSort(a, b) * -1;
        }
    },
    search: $d5722bd7562c0432$var$_filterString(false, true)
});
$d5722bd7562c0432$var$DataTable.type('html', {
    detect: {
        allOf: function(d) {
            return $d5722bd7562c0432$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<`
            return !$d5722bd7562c0432$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1;
        }
    },
    order: {
        pre: function(a) {
            return $d5722bd7562c0432$var$_empty(a) ? '' : a.replace ? $d5722bd7562c0432$var$_stripHtml(a).trim().toLowerCase() : a + '';
        }
    },
    search: $d5722bd7562c0432$var$_filterString(true, true)
});
$d5722bd7562c0432$var$DataTable.type('html-utf8', {
    detect: {
        allOf: function(d) {
            return $d5722bd7562c0432$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<` and a non-ASCII character
            // eslint-disable-next-line compat/compat
            return navigator.languages && !$d5722bd7562c0432$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1 && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $d5722bd7562c0432$var$__diacriticHtmlSort,
        desc: function(a, b) {
            return $d5722bd7562c0432$var$__diacriticHtmlSort(a, b) * -1;
        }
    },
    search: $d5722bd7562c0432$var$_filterString(true, true)
});
$d5722bd7562c0432$var$DataTable.type('date', {
    className: 'dt-type-date',
    detect: {
        allOf: function(d) {
            // V8 tries _very_ hard to make a string passed into `Date.parse()`
            // valid, so we need to use a regex to restrict date formats. Use a
            // plug-in for anything other than ISO8601 style strings
            if (d && !(d instanceof Date) && !$d5722bd7562c0432$var$_re_date.test(d)) return null;
            var parsed = Date.parse(d);
            return parsed !== null && !isNaN(parsed) || $d5722bd7562c0432$var$_empty(d);
        },
        oneOf: function(d) {
            // At least one entry must be a date or a string with a date
            return d instanceof Date || typeof d === 'string' && $d5722bd7562c0432$var$_re_date.test(d);
        }
    },
    order: {
        pre: function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        }
    }
});
$d5722bd7562c0432$var$DataTable.type('html-num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_htmlNumeric(d, decimal, true, false);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_htmlNumeric(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$__numericReplace(d, dp, $d5722bd7562c0432$var$_re_html, $d5722bd7562c0432$var$_re_formatted_numeric);
        }
    },
    search: $d5722bd7562c0432$var$_filterString(true, true)
});
$d5722bd7562c0432$var$DataTable.type('html-num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_htmlNumeric(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_htmlNumeric(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$__numericReplace(d, dp, $d5722bd7562c0432$var$_re_html);
        }
    },
    search: $d5722bd7562c0432$var$_filterString(true, true)
});
$d5722bd7562c0432$var$DataTable.type('num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_isNumber(d, decimal, true, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_isNumber(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$__numericReplace(d, dp, $d5722bd7562c0432$var$_re_formatted_numeric);
        }
    }
});
$d5722bd7562c0432$var$DataTable.type('num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_isNumber(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$_isNumber(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $d5722bd7562c0432$var$__numericReplace(d, dp);
        }
    }
});
var $d5722bd7562c0432$var$__numericReplace = function(d, decimalPlace, re1, re2) {
    if (d !== 0 && (!d || d === '-')) return -Infinity;
    var type = typeof d;
    if (type === 'number' || type === 'bigint') return d;
    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place Javascript recognises - it is not locale aware.
    if (decimalPlace) d = $d5722bd7562c0432$var$_numToDecimal(d, decimalPlace);
    if (d.replace) {
        if (re1) d = d.replace(re1, '');
        if (re2) d = d.replace(re2, '');
    }
    return d * 1;
};
$d5722bd7562c0432$var$$.extend(true, $d5722bd7562c0432$var$DataTable.ext.renderer, {
    footer: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.tfoot.cell);
        }
    },
    header: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.thead.cell);
            if (!settings.oFeatures.bSort) cell.addClass(classes.order.none);
            var legacyTop = settings.bSortCellsTop;
            var headerRows = cell.closest('thead').find('tr');
            var rowIdx = cell.parent().index();
            // Conditions to not apply the ordering icons
            if (// Cells and rows which have the attribute to disable the icons
            cell.attr('data-dt-order') === 'disable' || cell.parent().attr('data-dt-order') === 'disable' || // Legacy support for `orderCellsTop`. If it is set, then cells
            // which are not in the top or bottom row of the header (depending
            // on the value) do not get the sorting classes applied to them
            legacyTop === true && rowIdx !== 0 || legacyTop === false && rowIdx !== headerRows.length - 1) return;
            // No additional mark-up required
            // Attach a sort listener to update on sort - note that using the
            // `DT` namespace will allow the event to be removed automatically
            // on destroy, while the `dt` namespaced event is the one we are
            // listening for
            $d5722bd7562c0432$var$$(settings.nTable).on('order.dt.DT column-visibility.dt.DT', function(e, ctx) {
                if (settings !== ctx) return; // table, not a nested one
                var sorting = ctx.sortDetails;
                if (!sorting) return;
                var i;
                var orderClasses = classes.order;
                var columns = ctx.api.columns(cell);
                var col = settings.aoColumns[columns.flatten()[0]];
                var orderable = columns.orderable().includes(true);
                var ariaType = '';
                var indexes = columns.indexes();
                var sortDirs = columns.orderable(true).flatten();
                var orderedColumns = $d5722bd7562c0432$var$_pluck(sorting, 'col');
                var tabIndex = settings.iTabIndex;
                cell.removeClass(orderClasses.isAsc + ' ' + orderClasses.isDesc).toggleClass(orderClasses.none, !orderable).toggleClass(orderClasses.canAsc, orderable && sortDirs.includes('asc')).toggleClass(orderClasses.canDesc, orderable && sortDirs.includes('desc'));
                // Determine if all of the columns that this cell covers are included in the
                // current ordering
                var isOrdering = true;
                for(i = 0; i < indexes.length; i++)if (!orderedColumns.includes(indexes[i])) isOrdering = false;
                if (isOrdering) {
                    // Get the ordering direction for the columns under this cell
                    // Note that it is possible for a cell to be asc and desc sorting
                    // (column spanning cells)
                    var orderDirs = columns.order();
                    cell.addClass(orderDirs.includes('asc') ? orderClasses.isAsc : '' + orderDirs.includes('desc') ? orderClasses.isDesc : '');
                }
                // Find the first visible column that has ordering applied to it - it get's
                // the aria information, as the ARIA spec says that only one column should
                // be marked with aria-sort
                var firstVis = -1; // column index
                for(i = 0; i < orderedColumns.length; i++)if (settings.aoColumns[orderedColumns[i]].bVisible) {
                    firstVis = orderedColumns[i];
                    break;
                }
                if (indexes[0] == firstVis) {
                    var firstSort = sorting[0];
                    var sortOrder = col.asSorting;
                    cell.attr('aria-sort', firstSort.dir === 'asc' ? 'ascending' : 'descending');
                    // Determine if the next click will remove sorting or change the sort
                    ariaType = !sortOrder[firstSort.index + 1] ? 'Remove' : 'Reverse';
                } else cell.removeAttr('aria-sort');
                // Make the headers tab-able for keyboard navigation
                if (orderable) {
                    var orderSpan = cell.find('.dt-column-order');
                    orderSpan.attr('role', 'button').attr('aria-label', orderable ? col.ariaTitle + ctx.api.i18n('oAria.orderable' + ariaType) : col.ariaTitle);
                    if (tabIndex !== -1) orderSpan.attr('tabindex', tabIndex);
                }
            });
        }
    },
    layout: {
        _: function(settings, container, items) {
            var classes = settings.oClasses.layout;
            var row = $d5722bd7562c0432$var$$('<div/>').attr('id', items.id || null).addClass(items.className || classes.row).appendTo(container);
            $d5722bd7562c0432$var$DataTable.ext.renderer.layout._forLayoutRow(items, function(key, val) {
                if (key === 'id' || key === 'className') return;
                var klass = '';
                if (val.table) {
                    row.addClass(classes.tableRow);
                    klass += classes.tableCell + ' ';
                }
                if (key === 'start') klass += classes.start;
                else if (key === 'end') klass += classes.end;
                else klass += classes.full;
                $d5722bd7562c0432$var$$('<div/>').attr({
                    id: val.id || null,
                    "class": val.className ? val.className : classes.cell + ' ' + klass
                }).append(val.contents).appendTo(row);
            });
        },
        // Shared for use by the styling frameworks
        _forLayoutRow: function(items, fn) {
            // As we are inserting dom elements, we need start / end in a
            // specific order, this function is used for sorting the layout
            // keys.
            var layoutEnum = function(x) {
                switch(x){
                    case '':
                        return 0;
                    case 'start':
                        return 1;
                    case 'end':
                        return 2;
                    default:
                        return 3;
                }
            };
            Object.keys(items).sort(function(a, b) {
                return layoutEnum(a) - layoutEnum(b);
            }).forEach(function(key) {
                fn(key, items[key]);
            });
        }
    }
});
$d5722bd7562c0432$var$DataTable.feature = {};
// Third parameter is internal only!
$d5722bd7562c0432$var$DataTable.feature.register = function(name, cb, legacy) {
    $d5722bd7562c0432$var$DataTable.ext.features[name] = cb;
    if (legacy) $d5722bd7562c0432$var$_ext.feature.push({
        cFeature: legacy,
        fnInit: cb
    });
};
function $d5722bd7562c0432$var$_divProp(el, prop, val) {
    if (val) el[prop] = val;
}
$d5722bd7562c0432$var$DataTable.feature.register('div', function(settings, opts) {
    var n = $d5722bd7562c0432$var$$('<div>')[0];
    if (opts) {
        $d5722bd7562c0432$var$_divProp(n, 'className', opts.className);
        $d5722bd7562c0432$var$_divProp(n, 'id', opts.id);
        $d5722bd7562c0432$var$_divProp(n, 'innerHTML', opts.html);
        $d5722bd7562c0432$var$_divProp(n, 'textContent', opts.text);
    }
    return n;
});
$d5722bd7562c0432$var$DataTable.feature.register('info', function(settings, opts) {
    // For compatibility with the legacy `info` top level option
    if (!settings.oFeatures.bInfo) return null;
    var lang = settings.oLanguage, tid = settings.sTableId, n = $d5722bd7562c0432$var$$('<div/>', {
        'class': settings.oClasses.info.container
    });
    opts = $d5722bd7562c0432$var$$.extend({
        callback: lang.fnInfoCallback,
        empty: lang.sInfoEmpty,
        postfix: lang.sInfoPostFix,
        search: lang.sInfoFiltered,
        text: lang.sInfo
    }, opts);
    // Update display on each draw
    settings.aoDrawCallback.push(function(s) {
        $d5722bd7562c0432$var$_fnUpdateInfo(s, opts, n);
    });
    // For the first info display in the table, we add a callback and aria information.
    if (!settings._infoEl) {
        n.attr({
            'aria-live': 'polite',
            id: tid + '_info',
            role: 'status'
        });
        // Table is described by our info div
        $d5722bd7562c0432$var$$(settings.nTable).attr('aria-describedby', tid + '_info');
        settings._infoEl = n;
    }
    return n;
}, 'i');
/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $d5722bd7562c0432$var$_fnUpdateInfo(settings, opts, node) {
    var start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? opts.text : opts.empty;
    if (total !== max) // Record set after filtering
    out += ' ' + opts.search;
    // Convert the macros
    out += opts.postfix;
    out = $d5722bd7562c0432$var$_fnMacros(settings, out);
    if (opts.callback) out = opts.callback.call(settings.oInstance, settings, start, end, max, total, out);
    node.html(out);
    $d5722bd7562c0432$var$_fnCallbackFire(settings, null, 'info', [
        settings,
        node[0],
        out
    ]);
}
var $d5722bd7562c0432$var$__searchCounter = 0;
// opts
// - text
// - placeholder
$d5722bd7562c0432$var$DataTable.feature.register('search', function(settings, opts) {
    // Don't show the input if filtering isn't available on the table
    if (!settings.oFeatures.bFilter) return null;
    var classes = settings.oClasses.search;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var input = '<input type="search" class="' + classes.input + '"/>';
    opts = $d5722bd7562c0432$var$$.extend({
        placeholder: language.sSearchPlaceholder,
        processing: false,
        text: language.sSearch
    }, opts);
    // The _INPUT_ is optional - is appended if not present
    if (opts.text.indexOf('_INPUT_') === -1) opts.text += '_INPUT_';
    opts.text = $d5722bd7562c0432$var$_fnMacros(settings, opts.text);
    // We can put the <input> outside of the label if it is at the start or end
    // which helps improve accessability (not all screen readers like implicit
    // for elements).
    var end = opts.text.match(/_INPUT_$/);
    var start = opts.text.match(/^_INPUT_/);
    var removed = opts.text.replace(/_INPUT_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_INPUT_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_INPUT_';
    var filter = $d5722bd7562c0432$var$$('<div>').addClass(classes.container).append(str.replace(/_INPUT_/, input));
    // add for and id to label and input
    filter.find('label').attr('for', 'dt-search-' + $d5722bd7562c0432$var$__searchCounter);
    filter.find('input').attr('id', 'dt-search-' + $d5722bd7562c0432$var$__searchCounter);
    $d5722bd7562c0432$var$__searchCounter++;
    var searchFn = function(event) {
        var val = this.value;
        if (previousSearch.return && event.key !== "Enter") return;
        /* Now do the filter */ if (val != previousSearch.search) $d5722bd7562c0432$var$_fnProcessingRun(settings, opts.processing, function() {
            previousSearch.search = val;
            $d5722bd7562c0432$var$_fnFilterComplete(settings, previousSearch);
            // Need to redraw, without resorting
            settings._iDisplayStart = 0;
            $d5722bd7562c0432$var$_fnDraw(settings);
        });
    };
    var searchDelay = settings.searchDelay !== null ? settings.searchDelay : 0;
    var jqFilter = $d5722bd7562c0432$var$$('input', filter).val(previousSearch.search).attr('placeholder', opts.placeholder).on('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? $d5722bd7562c0432$var$DataTable.util.debounce(searchFn, searchDelay) : searchFn).on('mouseup.DT', function(e) {
        // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
        // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
        // checks the value to see if it has changed. In other browsers it won't have.
        setTimeout(function() {
            searchFn.call(jqFilter[0], e);
        }, 10);
    }).on('keypress.DT', function(e) {
        /* Prevent form submission */ if (e.keyCode == 13) return false;
    }).attr('aria-controls', tableId);
    // Update the input elements whenever the table is filtered
    $d5722bd7562c0432$var$$(settings.nTable).on('search.dt.DT', function(ev, s) {
        if (settings === s && jqFilter[0] !== document.activeElement) jqFilter.val(typeof previousSearch.search !== 'function' ? previousSearch.search : '');
    });
    return filter;
}, 'f');
// opts
// - type - button configuration
// - buttons - number of buttons to show - must be odd
$d5722bd7562c0432$var$DataTable.feature.register('paging', function(settings, opts) {
    // Don't show the paging input if the table doesn't have paging enabled
    if (!settings.oFeatures.bPaginate) return null;
    opts = $d5722bd7562c0432$var$$.extend({
        buttons: $d5722bd7562c0432$var$DataTable.ext.pager.numbers_length,
        type: settings.sPaginationType,
        boundaryNumbers: true,
        firstLast: true,
        previousNext: true,
        numbers: true
    }, opts);
    var host = $d5722bd7562c0432$var$$('<div/>').addClass(settings.oClasses.paging.container + (opts.type ? ' paging_' + opts.type : '')).append($d5722bd7562c0432$var$$('<nav>').attr('aria-label', 'pagination').addClass(settings.oClasses.paging.nav));
    var draw = function() {
        $d5722bd7562c0432$var$_pagingDraw(settings, host.children(), opts);
    };
    settings.aoDrawCallback.push(draw);
    // Responsive redraw of paging control
    $d5722bd7562c0432$var$$(settings.nTable).on('column-sizing.dt.DT', draw);
    return host;
}, 'p');
/**
 * Dynamically create the button type array based on the configuration options.
 * This will only happen if the paging type is not defined.
 */ function $d5722bd7562c0432$var$_pagingDynamic(opts) {
    var out = [];
    if (opts.numbers) out.push('numbers');
    if (opts.previousNext) {
        out.unshift('previous');
        out.push('next');
    }
    if (opts.firstLast) {
        out.unshift('first');
        out.push('last');
    }
    return out;
}
function $d5722bd7562c0432$var$_pagingDraw(settings, host, opts) {
    if (!settings._bInitComplete) return;
    var plugin = opts.type ? $d5722bd7562c0432$var$DataTable.ext.pager[opts.type] : $d5722bd7562c0432$var$_pagingDynamic, aria = settings.oLanguage.oAria.paginate || {}, start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = [], buttonEls = [], buttonsNested = plugin(opts).map(function(val) {
        return val === 'numbers' ? $d5722bd7562c0432$var$_pagingNumbers(page, pages, opts.buttons, opts.boundaryNumbers) : val;
    });
    // .flat() would be better, but not supported in old Safari
    buttons = buttons.concat.apply(buttons, buttonsNested);
    for(var i = 0; i < buttons.length; i++){
        var button = buttons[i];
        var btnInfo = $d5722bd7562c0432$var$_pagingButtonInfo(settings, button, page, pages);
        var btn = $d5722bd7562c0432$var$_fnRenderer(settings, 'pagingButton')(settings, button, btnInfo.display, btnInfo.active, btnInfo.disabled);
        var ariaLabel = typeof button === 'string' ? aria[button] : aria.number ? aria.number + (button + 1) : null;
        // Common attributes
        $d5722bd7562c0432$var$$(btn.clicker).attr({
            'aria-controls': settings.sTableId,
            'aria-disabled': btnInfo.disabled ? 'true' : null,
            'aria-current': btnInfo.active ? 'page' : null,
            'aria-label': ariaLabel,
            'data-dt-idx': button,
            'tabIndex': btnInfo.disabled ? -1 : settings.iTabIndex && btn.clicker[0].nodeName.toLowerCase() !== 'span' ? settings.iTabIndex : null
        });
        if (typeof button !== 'number') $d5722bd7562c0432$var$$(btn.clicker).addClass(button);
        $d5722bd7562c0432$var$_fnBindAction(btn.clicker, {
            action: button
        }, function(e) {
            e.preventDefault();
            $d5722bd7562c0432$var$_fnPageChange(settings, e.data.action, true);
        });
        buttonEls.push(btn.display);
    }
    var wrapped = $d5722bd7562c0432$var$_fnRenderer(settings, 'pagingContainer')(settings, buttonEls);
    var activeEl = host.find(document.activeElement).data('dt-idx');
    host.empty().append(wrapped);
    if (activeEl !== undefined) host.find('[data-dt-idx=' + activeEl + ']').trigger('focus');
    // Responsive - check if the buttons are over two lines based on the
    // height of the buttons and the container.
    if (buttonEls.length) {
        var outerHeight = $d5722bd7562c0432$var$$(buttonEls[0]).outerHeight();
        if (opts.buttons > 1 && // prevent infinite
        outerHeight > 0 && // will be 0 if hidden
        $d5722bd7562c0432$var$$(host).height() >= outerHeight * 2 - 10) $d5722bd7562c0432$var$_pagingDraw(settings, host, $d5722bd7562c0432$var$$.extend({}, opts, {
            buttons: opts.buttons - 2
        }));
    }
}
/**
 * Get properties for a button based on the current paging state of the table
 *
 * @param {*} settings DT settings object
 * @param {*} button The button type in question
 * @param {*} page Table's current page
 * @param {*} pages Number of pages
 * @returns Info object
 */ function $d5722bd7562c0432$var$_pagingButtonInfo(settings, button, page, pages) {
    var lang = settings.oLanguage.oPaginate;
    var o = {
        display: '',
        active: false,
        disabled: false
    };
    switch(button){
        case 'ellipsis':
            o.display = '&#x2026;';
            break;
        case 'first':
            o.display = lang.sFirst;
            if (page === 0) o.disabled = true;
            break;
        case 'previous':
            o.display = lang.sPrevious;
            if (page === 0) o.disabled = true;
            break;
        case 'next':
            o.display = lang.sNext;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        case 'last':
            o.display = lang.sLast;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        default:
            if (typeof button === 'number') {
                o.display = settings.fnFormatNumber(button + 1);
                if (page === button) o.active = true;
            }
            break;
    }
    return o;
}
/**
 * Compute what number buttons to show in the paging control
 *
 * @param {*} page Current page
 * @param {*} pages Total number of pages
 * @param {*} buttons Target number of number buttons
 * @param {boolean} addFirstLast Indicate if page 1 and end should be included
 * @returns Buttons to show
 */ function $d5722bd7562c0432$var$_pagingNumbers(page, pages, buttons, addFirstLast) {
    var numbers = [], half = Math.floor(buttons / 2), before = addFirstLast ? 2 : 1, after = addFirstLast ? 1 : 0;
    if (pages <= buttons) numbers = $d5722bd7562c0432$var$_range(0, pages);
    else if (buttons === 1) // Single button - current page only
    numbers = [
        page
    ];
    else if (buttons === 3) {
        // Special logic for just three buttons
        if (page <= 1) numbers = [
            0,
            1,
            'ellipsis'
        ];
        else if (page >= pages - 2) {
            numbers = $d5722bd7562c0432$var$_range(pages - 2, pages);
            numbers.unshift('ellipsis');
        } else numbers = [
            'ellipsis',
            page,
            'ellipsis'
        ];
    } else if (page <= half) {
        numbers = $d5722bd7562c0432$var$_range(0, buttons - before);
        numbers.push('ellipsis');
        if (addFirstLast) numbers.push(pages - 1);
    } else if (page >= pages - 1 - half) {
        numbers = $d5722bd7562c0432$var$_range(pages - (buttons - before), pages);
        numbers.unshift('ellipsis');
        if (addFirstLast) numbers.unshift(0);
    } else {
        numbers = $d5722bd7562c0432$var$_range(page - half + before, page + half - after);
        numbers.push('ellipsis');
        numbers.unshift('ellipsis');
        if (addFirstLast) {
            numbers.push(pages - 1);
            numbers.unshift(0);
        }
    }
    return numbers;
}
var $d5722bd7562c0432$var$__lengthCounter = 0;
// opts
// - menu
// - text
$d5722bd7562c0432$var$DataTable.feature.register('pageLength', function(settings, opts) {
    var features = settings.oFeatures;
    // For compatibility with the legacy `pageLength` top level option
    if (!features.bPaginate || !features.bLengthChange) return null;
    opts = $d5722bd7562c0432$var$$.extend({
        menu: settings.aLengthMenu,
        text: settings.oLanguage.sLengthMenu
    }, opts);
    var classes = settings.oClasses.length, tableId = settings.sTableId, menu = opts.menu, lengths = [], language = [], i;
    // Options can be given in a number of ways
    if (Array.isArray(menu[0])) {
        // Old 1.x style - 2D array
        lengths = menu[0];
        language = menu[1];
    } else {
        for(i = 0; i < menu.length; i++)// An object with different label and value
        if ($d5722bd7562c0432$var$$.isPlainObject(menu[i])) {
            lengths.push(menu[i].value);
            language.push(menu[i].label);
        } else {
            // Or just a number to display and use
            lengths.push(menu[i]);
            language.push(menu[i]);
        }
    }
    // We can put the <select> outside of the label if it is at the start or
    // end which helps improve accessability (not all screen readers like
    // implicit for elements).
    var end = opts.text.match(/_MENU_$/);
    var start = opts.text.match(/^_MENU_/);
    var removed = opts.text.replace(/_MENU_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_MENU_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_MENU_';
    // Wrapper element - use a span as a holder for where the select will go
    var tmpId = 'tmp-' + +new Date();
    var div = $d5722bd7562c0432$var$$('<div/>').addClass(classes.container).append(str.replace('_MENU_', '<span id="' + tmpId + '"></span>'));
    // Save text node content for macro updating
    var textNodes = [];
    Array.prototype.slice.call(div.find('label')[0].childNodes).forEach(function(el) {
        if (el.nodeType === Node.TEXT_NODE) textNodes.push({
            el: el,
            text: el.textContent
        });
    });
    // Update the label text in case it has an entries value
    var updateEntries = function(len) {
        textNodes.forEach(function(node) {
            node.el.textContent = $d5722bd7562c0432$var$_fnMacros(settings, node.text, len);
        });
    };
    // Next, the select itself, along with the options
    var select = $d5722bd7562c0432$var$$('<select/>', {
        'aria-controls': tableId,
        'class': classes.select
    });
    for(i = 0; i < lengths.length; i++)select[0][i] = new Option(typeof language[i] === 'number' ? settings.fnFormatNumber(language[i]) : language[i], lengths[i]);
    // add for and id to label and input
    div.find('label').attr('for', 'dt-length-' + $d5722bd7562c0432$var$__lengthCounter);
    select.attr('id', 'dt-length-' + $d5722bd7562c0432$var$__lengthCounter);
    $d5722bd7562c0432$var$__lengthCounter++;
    // Swap in the select list
    div.find('#' + tmpId).replaceWith(select);
    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $d5722bd7562c0432$var$$('select', div).val(settings._iDisplayLength).on('change.DT', function() {
        $d5722bd7562c0432$var$_fnLengthChange(settings, $d5722bd7562c0432$var$$(this).val());
        $d5722bd7562c0432$var$_fnDraw(settings);
    });
    // Update node value whenever anything changes the table's length
    $d5722bd7562c0432$var$$(settings.nTable).on('length.dt.DT', function(e, s, len) {
        if (settings === s) {
            $d5722bd7562c0432$var$$('select', div).val(len);
            // Resolve plurals in the text for the new length
            updateEntries(len);
        }
    });
    updateEntries(settings._iDisplayLength);
    return div;
}, 'l');
// jQuery access
$d5722bd7562c0432$var$$.fn.dataTable = $d5722bd7562c0432$var$DataTable;
// Provide access to the host jQuery object (circular reference)
$d5722bd7562c0432$var$DataTable.$ = $d5722bd7562c0432$var$$;
// Legacy aliases
$d5722bd7562c0432$var$$.fn.dataTableSettings = $d5722bd7562c0432$var$DataTable.settings;
$d5722bd7562c0432$var$$.fn.dataTableExt = $d5722bd7562c0432$var$DataTable.ext;
// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$d5722bd7562c0432$var$$.fn.DataTable = function(opts) {
    return $d5722bd7562c0432$var$$(this).dataTable(opts).api();
};
// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$d5722bd7562c0432$var$$.each($d5722bd7562c0432$var$DataTable, function(prop, val) {
    $d5722bd7562c0432$var$$.fn.DataTable[prop] = val;
});
var $d5722bd7562c0432$export$2e2bcd8739ae039 = $d5722bd7562c0432$var$DataTable;


// Allow reassignment of the $ variable
let $947004827f9a47b0$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($de863994a018a098$exports)));
/**
 * DataTables integration for Bootstrap 5.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See https://datatables.net/manual/styling/bootstrap
 * for further information.
 */ /* Set the defaults for DataTables initialisation */ $947004827f9a47b0$var$$.extend(true, (0, $d5722bd7562c0432$export$2e2bcd8739ae039).defaults, {
    renderer: 'bootstrap'
});
/* Default class modification */ $947004827f9a47b0$var$$.extend(true, (0, $d5722bd7562c0432$export$2e2bcd8739ae039).ext.classes, {
    container: "dt-container dt-bootstrap5",
    search: {
        input: "form-control form-control-sm"
    },
    length: {
        select: "form-select form-select-sm"
    },
    processing: {
        container: "dt-processing card"
    },
    layout: {
        row: 'row mt-2 justify-content-between',
        cell: 'd-md-flex justify-content-between align-items-center',
        tableCell: 'col-12',
        start: 'dt-layout-start col-md-auto me-auto',
        end: 'dt-layout-end col-md-auto ms-auto',
        full: 'dt-layout-full col-md'
    }
});
/* Bootstrap paging button renderer */ (0, $d5722bd7562c0432$export$2e2bcd8739ae039).ext.renderer.pagingButton.bootstrap = function(settings, buttonType, content, active, disabled) {
    var btnClasses = [
        'dt-paging-button',
        'page-item'
    ];
    if (active) btnClasses.push('active');
    if (disabled) btnClasses.push('disabled');
    var li = $947004827f9a47b0$var$$('<li>').addClass(btnClasses.join(' '));
    var a = $947004827f9a47b0$var$$('<button>', {
        'class': 'page-link',
        role: 'link',
        type: 'button'
    }).html(content).appendTo(li);
    return {
        display: li,
        clicker: a
    };
};
(0, $d5722bd7562c0432$export$2e2bcd8739ae039).ext.renderer.pagingContainer.bootstrap = function(settings, buttonEls) {
    return $947004827f9a47b0$var$$('<ul/>').addClass('pagination').append(buttonEls);
};
var $947004827f9a47b0$export$2e2bcd8739ae039 = (0, $d5722bd7562c0432$export$2e2bcd8739ae039);


(0, $4908beb8b7defbe9$export$2e2bcd8739ae039).use((0, $947004827f9a47b0$export$2e2bcd8739ae039));
const $15732d161a99cf4a$var$CurationWarningList = ()=>{
    const [tableRows, setTableRows] = (0, $dBNnn.useState)([]);
    const [filteredTableRows, setFilteredTableRows] = (0, $dBNnn.useState)([]);
    const [loading, setLoading] = (0, $dBNnn.useState)(null);
    const [failed, setFailed] = (0, $dBNnn.useState)(false);
    const [selectedTarget, setSelectedTarget] = (0, $dBNnn.useState)(null);
    const [hideDisabled, setHideDisabled] = (0, $dBNnn.useState)(true);
    const tableApiRef = (0, $dBNnn.useRef)();
    const getLinkToTarget = (0, $dBNnn.useCallback)((targetInfo, col)=>{
        const href = $15732d161a99cf4a$var$getHrefForTarget(targetInfo);
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
            className: "btn btn-link m-0 p-1 text-decoration-none",
            href: href,
            target: "_blank",
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                className: "icon icon-common icon-external-link-alt"
            })
        });
    }, []);
    const getSelectTargetBttn = (0, $dBNnn.useCallback)((targetInfo, col)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
            type: "button",
            className: "btn btn-primary text-light py-1 px-2",
            "data-bs-toggle": "modal",
            "data-bs-target": "#targetInfoModal",
            onClick: ()=>setSelectedTarget(targetInfo),
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                className: "icon icon-common icon-search-plus"
            })
        }), []);
    const parseWarningSummaryIntoRows = (0, $dBNnn.useCallback)((summaryPayload)=>{
        if (summaryPayload == null || !Array.isArray(summaryPayload.summaryEntries)) return [];
        const usageScores = summaryPayload.namespaceUsage;
        return summaryPayload.summaryEntries.map((r)=>[
                `${r.targetInfo.label} (${r.targetInfo.identifier})`,
                r.targetInfo,
                usageScores[r.targetInfo.identifier] || 0,
                r.allDisabled ? "Yes" : "No",
                r.lowAvailabilityResources,
                r.hasCurationValues,
                r.failingInstitutionUrl,
                r.hasPossibleWikidataError,
                r.targetInfo
            ]);
    }, []);
    const fetchWarningSummaryRows = (0, $dBNnn.useCallback)(async ()=>{
        if (loading === null || loading === false) {
            setLoading(true);
            const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
            const init = {
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            };
            await fetch((0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + "/curationApi/warningsSummary", init).then((response)=>response.json()).then((json)=>parseWarningSummaryIntoRows(json.payload)).then((rows)=>{
                setTableRows(rows);
                setFilteredTableRows(rows);
            }).catch(()=>setFailed(true)).finally(()=>setLoading(false));
        }
    }, []);
    // Update filtered rows based on hideDisable variable
    (0, $dBNnn.useEffect)(()=>{
        setFilteredTableRows(hideDisabled ? tableRows.filter((r)=>r[3] !== 'Yes') : tableRows);
        tableApiRef.current?.dt().column(3).visible(!hideDisabled).draw();
    }, [
        tableRows,
        hideDisabled
    ]);
    // Fetch warning summary on component mount
    (0, $dBNnn.useEffect)(()=>{
        fetchWarningSummaryRows().then(()=>{
            tableApiRef.current?.dt().draw();
        });
    }, []);
    if (loading) return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        children: [
            " ",
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {}),
            " "
        ]
    });
    if (failed) return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "alert alert-danger",
        children: " Failed to download warnings! "
    });
    const numDisabled = tableRows.filter((r)=>r[3] === 'Yes').length;
    const opts = {
        columnDefs: [
            {
                searchable: false,
                targets: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8
                ]
            },
            {
                sortable: false,
                targets: [
                    8
                ]
            },
            {
                className: 'align-middle',
                targets: '_all'
            },
            {
                className: 'text-center',
                targets: [
                    1,
                    8
                ]
            },
            {
                className: 'text-end',
                targets: [
                    2,
                    4,
                    6
                ]
            }
        ],
        order: [
            [
                3,
                'asc'
            ],
            [
                2,
                'desc'
            ]
        ],
        layout: {
            topStart: {
                info: {
                    text: "Warnings _START_ to _END_ out of _TOTAL_"
                },
                paging: {}
            },
            topEnd: {
                pageLength: {
                    text: 'Entries per page: _MENU_',
                    menu: [
                        5,
                        20,
                        100
                    ]
                },
                search: {
                    placeholder: 'Search here...',
                    text: ''
                }
            },
            bottomStart: null,
            bottomEnd: null
        },
        pageLength: 20,
        stateSave: true
    };
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        id: "curation-warning-list-container",
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "form-check form-switch float-end mt-2 ms-2",
                title: `${numDisabled} disabled rows`,
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                        className: "form-check-input rounded-pill",
                        onChange: (e)=>{
                            setHideDisabled(e.target.checked);
                        },
                        type: "checkbox",
                        role: "switch",
                        id: "checkChecked",
                        checked: hideDisabled
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                        className: "form-check-label",
                        htmlFor: "checkChecked",
                        children: "Hide disabled"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $4908beb8b7defbe9$export$2e2bcd8739ae039), {
                data: filteredTableRows,
                slots: {
                    1: getLinkToTarget,
                    8: getSelectTargetBttn
                },
                options: opts,
                className: "table table-sm table-striped table-bordered",
                ref: tableApiRef,
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                colSpan: 2,
                                scope: "col",
                                children: "Target"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Target usage score based on previous month",
                                children: "Access score"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Whether all warnings are disabled",
                                children: "Disabled"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Number of resources marked as low availability",
                                children: "Low availability"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Whether one or more fields are marked as CURATOR_REVIEW",
                                children: "Curation review"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Number of institutions with non-responsive URLs",
                                children: "Bad institution URL"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                className: "cursor-pointer",
                                scope: "col",
                                title: "Whether there is discrepancy between institution information and Wikidata",
                                children: "Wikidata discrepancy"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("th", {
                                scope: "col"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7a8071c80d951b19$export$2e2bcd8739ae039), {
                selectedTarget: selectedTarget,
                modalId: "targetInfoModal",
                editHref: $15732d161a99cf4a$var$getHrefForTarget(selectedTarget)
            })
        ]
    });
};
const $15732d161a99cf4a$var$getHrefForTarget = (targetInfo)=>{
    if (!targetInfo) return null;
    return targetInfo.type === 'Institution' ? '/curation?institution=' + targetInfo.identifier : '/registry/' + targetInfo.identifier;
};
var $15732d161a99cf4a$export$2e2bcd8739ae039 = $15732d161a99cf4a$var$CurationWarningList;





var $dBNnn = parcelRequire("dBNnn");

// Actions.
//
// CurationInstitutionListParams actions.
//
// Redux store update for curation institution list params.
const $22895992872eef9c$export$c13af6061ee536ae = (params)=>{
    return {
        type: 'SET_CURATIONINSTITUTIONLISTPARAMS',
        params: params
    };
};





const $3bc7cb1d45ed9dfa$export$35da54bdb48ffacd = (params)=>{
    return async (dispatch)=>{
        let requestURL;
        if (params.nameContent && params.nameContent.length > 2) requestURL = new URL((0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + '/restApi/institutions/search/findByNameContainingIgnoreCase');
        else {
            requestURL = new URL((0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi + '/restApi/institutions');
            params['sort'] = 'name,asc';
        }
        Object.keys(params).forEach((param)=>{
            requestURL.searchParams.append(param, params[param]);
        });
        const response = await fetch(requestURL);
        const json = await response.json();
        await dispatch((0, $22895992872eef9c$export$c13af6061ee536ae)(json.page));
        const institutions = await Promise.all(json._embedded.institutions.map((institution)=>{
            let { _links: _links, ...newInstitution } = institution;
            // Add id to the resource as a field, we will need this for curation stuff.
            newInstitution.id = _links.self.href.split('/').pop();
            return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(newInstitution, [
                {
                    name: 'location',
                    url: _links.location.href
                }
            ], undefined, true);
        }));
        dispatch($3bc7cb1d45ed9dfa$export$72d1ef47184d0e39(institutions));
    };
};
const $3bc7cb1d45ed9dfa$export$ee8b0119f8804693 = (institutionId)=>{
    return async (dispatch)=>{
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        };
        let requestURL = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).institutionManagementEndpoint}/deleteById/${institutionId}`);
        const response = await fetch(requestURL, init);
        let namespacesUsingInstitution = [];
        // If unable to delete, determine which namespaces are using that institution and return them.
        if (response.status === 400) {
            let namespacesUsingInstitutionRequestURL = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/resources/search/findAllByInstitutionId?id=${institutionId}`);
            const resourcesUsingInstitutionResponse = await fetch(namespacesUsingInstitutionRequestURL);
            const resourcesUsingInstitutionData = await resourcesUsingInstitutionResponse.json();
            const resourcesUsingInstitution = await Promise.all(resourcesUsingInstitutionData._embedded.resources.map((resource)=>{
                let { _links: _links, ...newResource } = resource;
                return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(newResource, [
                    {
                        name: 'namespace',
                        url: _links.namespace.href
                    }
                ], undefined, true);
            }));
            namespacesUsingInstitution = resourcesUsingInstitution.map((resource)=>({
                    name: resource.namespace.name,
                    prefix: resource.namespace.prefix
                }));
        }
        return {
            status: response.status,
            namespacesUsingInstitution: namespacesUsingInstitution
        };
    };
};
const $3bc7cb1d45ed9dfa$export$72d1ef47184d0e39 = (curationInstitutionList)=>{
    return {
        type: 'SET_CURATIONINSTITUTIONLIST',
        curationInstitutionList: curationInstitutionList
    };
};







var $dBNnn = parcelRequire("dBNnn");

// Config.


const $533cd6dd9024b3b0$export$c643c4a95449c505 = (field, value)=>{
    const action = {
        type: 'SET_INSTITUTIONPATCHREDUCERFIELD',
        field: field,
        value: value
    };
    return action;
};
const $533cd6dd9024b3b0$export$9097fdabc1a5282d = (id, institution)=>{
    const action = {
        type: 'SET_INSTITUTIONPATCHREDUCER',
        id: id,
        institution: institution
    };
    return action;
};
const $533cd6dd9024b3b0$export$8b127fe7721cd0aa = (id, newInstitution)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/institutions/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify(newInstitution)
        };
        return await fetch(requestUrl, init);
    };
};






class $88d51b65f0f23f79$var$CurationInstitutionItem extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "toggle", ()=>{
            this.setState((state)=>({
                    expanded: !state.expanded
                }));
        });
        //
        // Field manipulation handler. Undefined 'value' field will revert to default.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (field, value)=>{
            const { props: { institution: institution } } = this;
            // Add/remove field to changed list if modified/reset, so it is validated or not when clicked on the perform
            // validation button.
            if (institution[field] !== value) this.setState((prevState)=>({
                    institutionFieldsChanged: prevState.institutionFieldsChanged.add(field),
                    newInstitution: {
                        ...this.state.newInstitution,
                        [field]: value
                    }
                }));
            else this.setState((prevState)=>{
                prevState.institutionFieldsChanged.delete(field);
                return {
                    institutionFieldsChanged: prevState.institutionFieldsChanged,
                    newInstitution: {
                        ...this.state.newInstitution,
                        [field]: institution[field]
                    }
                };
            });
            this.props.setInstitutionPatchField(field, value);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickCommitButton", async ()=>{
            const { state: { institutionId: institutionId, institutionFieldsChanged: institutionFieldsChanged, newInstitution: newInstitution }, props: { curationInstitutionListParams: curationInstitutionListParams, getCurationInstitutionListFromRegistry: getCurationInstitutionListFromRegistry, patchInstitution: patchInstitution, setInstitutionPatch: setInstitutionPatch } } = this;
            if (institutionFieldsChanged.size === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No changes to commit');
                return;
            }
            // Make sure the current institution is in redux state for committing.
            await setInstitutionPatch(institutionId, newInstitution);
            const modalResponse = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm changes to institution',
                text: `Changed fields: ${[
                    ...institutionFieldsChanged
                ].join(', ')}`,
                confirmButtonText: 'Commit changes',
                cancelButtonText: 'Cancel'
            });
            if (modalResponse.value) {
                const result = await patchInstitution(institutionId, newInstitution);
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Changed committed successfully');
                    this.setState({
                        editInstitution: false,
                        expanded: false,
                        institutionFieldsChanged: new Set()
                    });
                    await getCurationInstitutionListFromRegistry(curationInstitutionListParams);
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error committing changes');
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDiscardButton", async ()=>{
            const { institutionFieldsChanged: institutionFieldsChanged } = this.state;
            if (institutionFieldsChanged.size === 0) {
                this.setState({
                    editInstitution: false,
                    expanded: false
                });
                return;
            }
            const modalResponse = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Are you sure?',
                text: 'All data changed will be lost',
                confirmButtonText: 'Discard changes',
                cancelButtonText: 'Continue editing'
            });
            if (modalResponse.value) this.setState({
                editInstitution: false,
                expanded: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickEditButton", ()=>{
            const { props: { institution: { id: id, homeUrl: homeUrl, description: description, name: name, location: location }, setInstitutionPatch: setInstitutionPatch }, state: { editInstitution: editInstitution } } = this;
            const newInstitution = {
                name: name,
                description: description,
                homeUrl: homeUrl,
                location: location.id
            };
            if (editInstitution) this.setState({
                editInstitution: false
            });
            else {
                this.setState({
                    editInstitution: true,
                    expanded: true
                });
                setInstitutionPatch(id, newInstitution);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickDeleteButton", async ()=>{
            const { props: { curationInstitutionListParams: curationInstitutionListParams, deleteInstitution: deleteInstitution, getCurationInstitutionListFromRegistry: getCurationInstitutionListFromRegistry }, state: { institutionId: institutionId } } = this;
            const modalResponse = await (0, $c76c78ebffccd857$export$7172c8e9d7696d9b).fire({
                title: 'Confirm institution deletion',
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel'
            });
            if (modalResponse.value) {
                const result = await deleteInstitution(institutionId);
                // Correct deletion.
                if (result.status === 200) {
                    (0, $c76c78ebffccd857$export$73e19c0339806233)('Institution deleted successfully');
                    this.setState({
                        editInstitution: false,
                        expanded: false,
                        institutionFieldsChanged: new Set()
                    });
                    await getCurationInstitutionListFromRegistry(curationInstitutionListParams);
                // Some namespaces are using the institution.
                } else if (result.status === 400) {
                    const namespaceDetailsUrl = `${window.location.protocol}//${window.location.host}/registry`;
                    const html = /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "The following Namespaces are using that Institution:"
                            }),
                            result.namespacesUsingInstitution.map((namespace)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                        className: "col mb-3",
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                            className: "d-inline border bg-light p-1",
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                                href: `${namespaceDetailsUrl}/${namespace.prefix}`,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                        className: "align-top text-warning fw-bold border border-secondary badge bg-dark me-2",
                                                        children: namespace.prefix
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                        className: "clear-link",
                                                        children: namespace.name
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                }, `namespace-${namespace.prefix}`))
                        ]
                    });
                    const namespacesUsingInstitutionsModalResult = await (0, $c76c78ebffccd857$export$c4a08e1df74d230d).fire({
                        html: html
                    });
                    if (namespacesUsingInstitutionsModalResult.value) result.namespacesUsingInstitution.forEach((namespace)=>window.open(`${namespaceDetailsUrl}/${namespace.prefix}`, '_blank'));
                // Failed deletion.
                } else (0, $c76c78ebffccd857$export$85ee8a1f69fea720)('Error deleting institution');
            }
        });
        this.state = {
            expanded: false,
            editInstitution: false,
            institutionFieldsChanged: new Set(),
            institutionId: this.props.institution.id,
            newInstitution: {
                description: this.props.institution.description,
                homeUrl: this.props.institution.homeUrl,
                name: this.props.institution.name,
                location: this.props.institution.location.id
            }
        };
    }
    render() {
        const { handleChangeField: handleChangeField, handleClickCommitButton: handleClickCommitButton, handleClickDeleteButton: handleClickDeleteButton, handleClickEditButton: handleClickEditButton, handleClickDiscardButton: handleClickDiscardButton, props: { institution: { name: name, homeUrl: homeUrl, description: description, location: location, rorId: rorId }, locationList: locationList }, state: { editInstitution: editInstitution, expanded: expanded } } = this;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-1",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-header py-1 pe-1",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-10 col-lg-9 col-xl-10",
                                    children: editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                        requiredRoles: [
                                            'editInstitution'
                                        ],
                                        fallbackComponent: name,
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                            fieldName: "name",
                                            defaultValue: name,
                                            handleChangeField: handleChangeField,
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                type: "text"
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                        className: "clear-link",
                                        href: "#!",
                                        onClick: this.toggle,
                                        children: [
                                            expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-minus me-2"
                                            }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-plus me-2"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                className: "icon icon-common icon-sitemap me-2"
                                            }),
                                            name
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col col-md-2 col-lg-3 col-xl-2 text-end",
                                    children: !editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                        requiredRoles: [
                                            'editInstitution'
                                        ],
                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                                    className: "clear-link btn btn-warning btn-sm m-0 me-2 py-0 px-2",
                                                    onClick: handleClickEditButton,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                            className: "icon icon-common icon-ellipsis-h me-1"
                                                        }),
                                                        "Edit"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                                    className: "clear-link btn btn-danger btn-sm m-0 py-0 px-2",
                                                    onClick: handleClickDeleteButton,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                            className: "icon icon-common icon-trash me-1"
                                                        }),
                                                        "Delete"
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                                className: "clear-link btn btn-success btn-sm m-0 me-2 py-0 px-2",
                                                onClick: handleClickCommitButton,
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-check me-1"
                                                    }),
                                                    "Commit"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                                className: "clear-link btn btn-danger btn-sm m-0 py-0 px-2",
                                                onClick: handleClickDiscardButton,
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                        className: "icon icon-common icon-ellipsis-h me-1"
                                                    }),
                                                    "Discard"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "col bg-light p-2",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                    className: "table table-sm table-striped table-borderless mb-0",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-15 align-middle",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "Home URL"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editInstitution'
                                                            ],
                                                            fallbackComponent: homeUrl,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "homeUrl",
                                                                defaultValue: homeUrl,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : homeUrl
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-15 align-middle",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "Description"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editInstitution'
                                                            ],
                                                            fallbackComponent: description,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "description",
                                                                defaultValue: description,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                                    rows: 5
                                                                })
                                                            })
                                                        }) : description
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-15 align-middle",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "Location"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editResource'
                                                            ],
                                                            fallbackComponent: location.countryName,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "location",
                                                                defaultValue: location.id,
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                                    className: "form-control",
                                                                    value: location,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                            value: "",
                                                                            disabled: true,
                                                                            children: "Select location..."
                                                                        }),
                                                                        locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                                value: location.id,
                                                                                children: location.label
                                                                            }, `option-${location.id}`))
                                                                    ]
                                                                })
                                                            })
                                                        }) : location.countryName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        className: "w-15 align-middle",
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                            children: "ROR Id"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                        children: editInstitution ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $ad1e82774825a5c5$export$2e2bcd8739ae039), {
                                                            requiredRoles: [
                                                                'editInstitution'
                                                            ],
                                                            fallbackComponent: rorId,
                                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                                fieldName: "rorId",
                                                                defaultValue: rorId || '',
                                                                handleChangeField: handleChangeField,
                                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                                    type: "text"
                                                                })
                                                            })
                                                        }) : rorId || 'No ROR Id stored'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        });
    }
}
//
// Redux Mappings
//
const $88d51b65f0f23f79$var$mapStateToProps = (state)=>({
        locationList: state.locationList,
        curationInstitutionListParams: state.curationDashboard.curationInstitutionListParams
    });
const $88d51b65f0f23f79$var$mapDispatchToProps = (dispatch)=>({
        deleteInstitution: (institutionId)=>dispatch((0, $3bc7cb1d45ed9dfa$export$ee8b0119f8804693)(institutionId)),
        getCurationInstitutionListFromRegistry: (params)=>dispatch((0, $3bc7cb1d45ed9dfa$export$35da54bdb48ffacd)(params)),
        setInstitutionPatch: (id, institution)=>dispatch((0, $533cd6dd9024b3b0$export$9097fdabc1a5282d)(id, institution)),
        setInstitutionPatchField: (field, value)=>dispatch((0, $533cd6dd9024b3b0$export$c643c4a95449c505)(field, value)),
        patchInstitution: (id, newInstitution)=>dispatch((0, $533cd6dd9024b3b0$export$8b127fe7721cd0aa)(id, newInstitution))
    });
var $88d51b65f0f23f79$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($88d51b65f0f23f79$var$mapStateToProps, $88d51b65f0f23f79$var$mapDispatchToProps)($88d51b65f0f23f79$var$CurationInstitutionItem);



class $642ce97a23bd4535$var$CurationInstitutionList extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updateCurationInstitutionList", (params)=>{
            if ('institution' in this.props.params) this.props.getCurationInstitutionListFromRegistry({
                size: 1000
            });
            else this.props.getCurationInstitutionListFromRegistry(params);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeSearchInput", (e)=>{
            const { curationInstitutionListParams: curationInstitutionListParams } = this.props;
            clearTimeout(this.state.debounceSearch);
            const nameContent = e.currentTarget.value;
            // Debouce search field.
            this.setState({
                debounceSearch: setTimeout(()=>{
                    this.props.setCurationInstitutionListParams({
                        nameContent: nameContent
                    });
                    this.updateCurationInstitutionList({
                        ...curationInstitutionListParams,
                        nameContent: nameContent
                    });
                }, 500)
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleNavigate", (number)=>{
            const { curationInstitutionListParams: curationInstitutionListParams } = this.props;
            this.props.setCurationInstitutionListParams({
                number: number
            });
            this.updateCurationInstitutionList({
                ...curationInstitutionListParams,
                page: number
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSetSize", (e)=>{
            const { curationInstitutionListParams: curationInstitutionListParams } = this.props;
            const size = parseInt(e.target.value);
            const number = 0;
            this.props.setCurationInstitutionListParams({
                size: size,
                number: number
            });
            this.updateCurationInstitutionList({
                ...curationInstitutionListParams,
                size: size
            });
        });
        this.state = {
            debounceSearch: undefined
        };
    }
    componentDidMount() {
        this.updateCurationInstitutionList({
            page: this.props.curationInstitutionListParams.number
        });
    }
    render() {
        const { handleChangeSearchInput: handleChangeSearchInput, handleNavigate: handleNavigate, handleSetSize: handleSetSize, props: { curationInstitutionList: curationInstitutionList, curationInstitutionListParams: { number: number, size: size, totalElements: totalElements, totalPages: totalPages } }, state: { nameContent: nameContent } } = this;
        let filteredInstitutionList = curationInstitutionList;
        if ('institution' in this.props.params) {
            const institutionId = this.props.params.institution;
            filteredInstitutionList = curationInstitutionList.filter((i)=>i.id === institutionId);
        }
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group input-group-sm mb-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    id: "registry-search",
                                    children: "Search"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                    type: "text",
                                    className: "form-control",
                                    placeholder: "Input a search query",
                                    "aria-label": "Search",
                                    "aria-describedby": "registry-search",
                                    onChange: handleChangeSearchInput,
                                    value: nameContent,
                                    spellCheck: false
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $54e37c13f6fd63e4$export$2e2bcd8739ae039), {
                    number: number,
                    totalPages: totalPages,
                    totalElements: totalElements,
                    navigate: handleNavigate,
                    setSize: handleSetSize,
                    size: size
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row justify-content-md-center mt-2",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: filteredInstitutionList.length === 0 ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            children: "No institutions stored."
                        }) : filteredInstitutionList.map((institution)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $88d51b65f0f23f79$export$2e2bcd8739ae039), {
                                institution: institution
                            }, `cii-${institution.id}`))
                    })
                })
            ]
        });
    }
}
// Redux mapping functions.
const $642ce97a23bd4535$var$mapStateToProps = (state)=>({
        curationInstitutionList: state.curationDashboard.curationInstitutionList,
        curationInstitutionListParams: state.curationDashboard.curationInstitutionListParams
    });
const $642ce97a23bd4535$var$mapDispatchToProps = (dispatch)=>({
        getCurationInstitutionListFromRegistry: (params)=>dispatch((0, $3bc7cb1d45ed9dfa$export$35da54bdb48ffacd)(params)),
        setCurationInstitutionListParams: (params)=>dispatch((0, $22895992872eef9c$export$c13af6061ee536ae)(params))
    });
const $642ce97a23bd4535$var$ConnectedCurationInstitutionList = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($642ce97a23bd4535$var$mapStateToProps, $642ce97a23bd4535$var$mapDispatchToProps)($642ce97a23bd4535$var$CurationInstitutionList);
var $642ce97a23bd4535$export$2e2bcd8739ae039 = (props)=>{
    const [params] = (0, $b08650187def67b8$export$f1a78c17382fe22a)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($642ce97a23bd4535$var$ConnectedCurationInstitutionList, {
        ...props,
        params: params
    });
};





var $dBNnn = parcelRequire("dBNnn");
var $f74f990e1ffb93a2$exports = {};
$f74f990e1ffb93a2$exports = $parcel$resolve("ePaEF");


var $d60ecf7b09d88516$exports = {};
$d60ecf7b09d88516$exports = $parcel$resolve("dX9Cm");


var $33979f2b806afa9b$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dBNnn.memo)(()=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        className: "modal-content",
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                className: "modal-header",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                className: "icon icon-common icon-info me-2"
                            }),
                            "Instructions for handling curation warnings"
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                        type: "button",
                        className: "btn-close",
                        "data-bs-dismiss": "modal",
                        "aria-label": "Close"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "modal-body",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "container-fluid",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#warnings-and-table-descrition",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "warnings-and-table-descrition",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "Warnings and how to solve them"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    className: "card-body collapse",
                                    id: "warnings-and-table-descrition",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "Curation warnings indicate possible issues with values on the identifiers.org registry"
                                                }),
                                                '. Their objective is to flag entries that likely need to be updated. Each type of warning indicates a different issue, for example, the "low availability" warning indicates that the link checker has measured low availability for URLs under a specific resource.'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "The summary table aggregates different warnings by the entry that caused the warning to be raised"
                                                }),
                                                ". We label these as the ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("em", {
                                                    children: "targets"
                                                }),
                                                " of warnings. This can be a namespace or an institution. Curators must check the summary table, identify entries that need fixing, and act as needed by updating entries to solve warnings. Each row of the table provides a link ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                    className: "icon icon-common icon-external-link-alt"
                                                }),
                                                " to the target of the warning. For example, changing a URL pattern or homepage URL when it has been changed by the date provider."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                "When applicable, ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "a curator may deprecate a namespace or resource to disable verification of an entry"
                                                }),
                                                ". Deprecating a namespace disables validation on all it's resources, while deprecating a resource disables verification only on it."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#types-of-warnings-description",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "types-of-warnings-description",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "Description of columns"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    className: "card-body collapse",
                                    id: "types-of-warnings-description",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                            children: "Find below the descriptions of values of each column. Beware that rows can indicate warnings for namespaces or institutions and not all columns are applicable to all rows. For example, low availability does not apply to institutions since the link checker does not track its availability."
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                "The type of entry a column applies to is displayed by ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                    className: "badge bg-light text-dark",
                                                    children: "badges"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: " Target "
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: [
                                                        "This indicates which type of entry that row groups warnings by. It's either one of:",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("ul", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                                                    children: "Institution name and its database ID or"
                                                                }),
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                                                                    children: "Name of namespace that the rows refer to and it's prefix"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: [
                                                        "Access score",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                            className: "badge bg-light rounded-pill text-dark ms-1",
                                                            children: "Namespaces"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: "A numerical score that indicates how much usage a namespace has. The aim of this column is to allow the prioritization of warnings based on how used a namespace is. The higher the score, the more usage it has. This is currently implemented based on the number of visits on the matomo tracker."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: [
                                                        "Low availability",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                            className: "badge bg-light rounded-pill text-dark ms-1",
                                                            children: "Namespaces"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: "This number indicates the number of resources under the namespace that are marked as low availability by the link checker service. This directly relates to URI resolution and takes priority over other warnings. Please beware that even after correcting URLs, it takes time for the the link checker to update its availability metric as measurements only are discarded after 36h. If a resource has gone completely offline, the curator can deprecate it or its namespace to disable this warning."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: [
                                                        "Curation review",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                            className: "badge bg-light rounded-pill text-dark ms-1",
                                                            children: "Both"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: 'Some registry entries have the value "CURATOR_REVIEW" set as to mark the entry to be curated. This indicates whether a namespace or institution has this value set in any of its attributes. Updating the entries in the registry to not have this will solve the warning.'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: [
                                                        "Bad institution URL",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                            className: "badge bg-light rounded-pill text-dark ms-1",
                                                            children: "Institutions"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: "Since the link checker does not measure availability for institution URLs, a one shot request is made by the verifier to check them. Errors detected this way are listed in this column."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                            className: "row border-top border-bottom border-info py-2",
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                                    className: "col-12 col-sm-12 col-md-3 col-lg-2 fw-bold",
                                                    children: [
                                                        "Wikidata discrepancy",
                                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                            className: "badge bg-light rounded-pill text-dark ms-1",
                                                            children: "Institutions"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                                    className: "col-12 col-sm-12 col-md-9 col-lg-10",
                                                    children: "Using a best-effort algorithm, the validator tries to match institutions to wikidata entries. Then use these entries to validate institution entries on the registry. Since the algorithm does not guarantee matches, false positives are possible ."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#sorting-description",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "sorting-description",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "Sorting the summary table"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    id: "sorting-description",
                                    className: "card-body collapse",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                "The column headers can be used to sort rows. The indicator to the right of the column header indicates the current sorting.",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: " By pressing shift, the table can be sorted by multiple columns in the order they are clicked"
                                                }),
                                                "."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                            children: "For example, if you click on the first column header, you sort rows by the values on the first column. Then by holding the shift key and pressing the second column header, it will keep the sort on the first column and further sort on the second column."
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "Sorting and pagination is maintained across sessions"
                                                }),
                                                ". Clear the browser to reset settings. The default settings is to sort by number of low availability and usage score."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#individual-warnings-description",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "individual-warnings-description",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "Inspecting individual curation warnings under row"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    id: "individual-warnings-description",
                                    className: "card-body collapse",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "One row of the summary table can indicate multiple warning"
                                                }),
                                                ". Clicking on the link ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                    className: "icon icon-common icon-external-link-alt"
                                                }),
                                                " of that row takes you to the namespace or institution target of these warnings. To see all warnings and their details, click on the right-most column of that row that contains the button with the ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                    className: "icon icon-common icon-search-plus"
                                                }),
                                                " icon. This will load the individual warnings grouped under that row."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f74f990e1ffb93a2$exports))),
                                                alt: "Button to show individual warnings",
                                                className: "img-fluid border border-dark mt-1 mb-5"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "On the warning list that opens, each item lists information on a different warning"
                                                }),
                                                ". The curator can click on it to expand it and see more details. Each warning type will list different information when expanded. For low availability resources, it will list the URLs and the availability of that resource. For Wikidata discrepancies, it will list the values that are different and the expected values. The link ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                                    className: "icon icon-common icon-external-link-alt"
                                                }),
                                                " at the top of this view also takes you to the target of these warnings."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d60ecf7b09d88516$exports))),
                                                alt: "Individual warnings under row",
                                                className: "img-fluid mt-1 mb-5 mx-auto"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                'If a warning does not have extra information associated with it, the history of that warning will show. This is the case for the "curator review" warnings.',
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: " The history lists the most recent events where the warning has been opened and closed"
                                                }),
                                                '. For warnings with extra information, this history can be seen by clicking the "See history" button after it is expanded.'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#warning-update-descrition",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "warning-update-descrition",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "How warnings are updated"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    className: "card-body collapse",
                                    id: "warning-update-descrition",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "Warnings are updated periodically by the registry verifier job"
                                                }),
                                                ". This job runs weekly and checks all entries for possible issues. After running, it sends notifications to the registry for warnings that are active."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                            children: "When a active warning is not notified by the job, it is marked as solved. A history of when jobs are opened and solved is kept for each warning by the registry. This history can be seen when inspecting a row of the warning summary table."
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                            children: "Please note that the availability metric of the link checker takes 36h to update. So a resource may be marked as low availability from one run of the validator job."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card mt-3",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "card-header",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("button", {
                                        type: "button",
                                        "data-bs-toggle": "collapse",
                                        "data-bs-target": "#disabled-warning-descrition",
                                        title: "Click to toogle",
                                        className: "h4 my-0 py-0 collapsed",
                                        "aria-expanded": "false",
                                        "aria-controls": "disabled-warning-descrition",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                                className: "collapse-symbol"
                                            }),
                                            "Disabled warnings"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                    className: "card-body collapse",
                                    id: "disabled-warning-descrition",
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                "When inspecting a line of the warning summary table, ",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: "you can disable specific warnings"
                                                }),
                                                ". This is intended as way to ignore warnings due to reasons such as them being false positives."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                            children: "Disabled warnings still show on the summary table and upon notification they stay as disabled. Please note that a disabled warning will still be marked as solved if not notified by a run of the verifier job. So it could happen that an intermittent warning to be marked as disabled, then be detected as solved by the verifier, and then notified again later by the verifier job."
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                            children: [
                                                "When all warnings are marked as disabled, the summary table line is considered disabled, allowing sorting the table to show other warnings first.",
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                                    children: " To enable a warning"
                                                }),
                                                ', simply click on the "',
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("em", {
                                                    children: "enable"
                                                }),
                                                '" button when inspecting a line in the warning table.'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }), ()=>true);


const $409781430455e694$var$CurationDashboardPage = ()=>{
    const { trackPageView: trackPageView } = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    trackPageView();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-leaf",
                title: "Prefix Registration Requests",
                description: "This is the list of Prefix Registration Requests sent by resource administrators. Clicking on one will expand the information and allow to perform actions like requesting amendments or aproving/rejecting it."
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row mb-5",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $92ca162474bc98bd$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-cube",
                title: "Resource Registration Requests",
                description: "This is the list of Resource Registration Requests sent by resource administrators. Clicking one will expand information and actions like in the one above."
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row mb-5",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b474856d389dda4b$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-exclamation-triangle",
                title: "Summary of open curation warnings",
                description: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                    children: [
                        "This table summarizes warnings that require curator attention.",
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                            type: "button",
                            "data-bs-toggle": "modal",
                            className: "btn btn-link d-inline px-1 py-0 m-0",
                            "data-bs-target": "#curation-warning-instructions-modal",
                            children: "Click here for more information."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row mb-5",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $15732d161a99cf4a$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "modal",
                            id: "curation-warning-instructions-modal",
                            tabIndex: "-1",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                className: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $33979f2b806afa9b$export$2e2bcd8739ae039), {})
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                id: "curation-institution",
                icon: "icon-sitemap",
                title: "Institutions",
                description: "This is the list of Institutions currently stored in the registry. Clicking on one will show the detail fields and allow modifications or deletion."
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $642ce97a23bd4535$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
};
var $409781430455e694$export$2e2bcd8739ae039 = $409781430455e694$var$CurationDashboardPage;




var $dBNnn = parcelRequire("dBNnn");




var $dBNnn = parcelRequire("dBNnn");



var $dBNnn = parcelRequire("dBNnn");

var $dBNnn = parcelRequire("dBNnn");
var $c0b31a52896d9e30$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $c0b31a52896d9e30$var$isDateObject = (value1)=>value1 instanceof Date;
var $c0b31a52896d9e30$var$isNullOrUndefined = (value1)=>value1 == null;
const $c0b31a52896d9e30$var$isObjectType = (value1)=>typeof value1 === 'object';
var $c0b31a52896d9e30$var$isObject = (value1)=>!$c0b31a52896d9e30$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $c0b31a52896d9e30$var$isObjectType(value1) && !$c0b31a52896d9e30$var$isDateObject(value1);
var $c0b31a52896d9e30$var$getEventValue = (event)=>$c0b31a52896d9e30$var$isObject(event) && event.target ? $c0b31a52896d9e30$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $c0b31a52896d9e30$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $c0b31a52896d9e30$var$isNameInFieldArray = (names, name)=>names.has($c0b31a52896d9e30$var$getNodeParentName(name));
var $c0b31a52896d9e30$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $c0b31a52896d9e30$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $c0b31a52896d9e30$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $c0b31a52896d9e30$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($c0b31a52896d9e30$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $c0b31a52896d9e30$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$c0b31a52896d9e30$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $c0b31a52896d9e30$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $c0b31a52896d9e30$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $c0b31a52896d9e30$var$isUndefined = (val)=>val === undefined;
var $c0b31a52896d9e30$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$c0b31a52896d9e30$var$isObject(object)) return defaultValue;
    const result = $c0b31a52896d9e30$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$c0b31a52896d9e30$var$isNullOrUndefined(result) ? result : result[key], object);
    return $c0b31a52896d9e30$var$isUndefined(result) || result === object ? $c0b31a52896d9e30$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $c0b31a52896d9e30$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $c0b31a52896d9e30$var$isKey = (value1)=>/^\w*$/.test(value1);
var $c0b31a52896d9e30$var$stringToPath = (input)=>$c0b31a52896d9e30$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $c0b31a52896d9e30$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $c0b31a52896d9e30$var$isKey(path) ? [
        path
    ] : $c0b31a52896d9e30$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $c0b31a52896d9e30$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $c0b31a52896d9e30$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $c0b31a52896d9e30$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $c0b31a52896d9e30$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $c0b31a52896d9e30$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useContext($c0b31a52896d9e30$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $c0b31a52896d9e30$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createElement($c0b31a52896d9e30$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $c0b31a52896d9e30$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $c0b31a52896d9e30$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $c0b31a52896d9e30$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $c0b31a52896d9e30$var$isPrimitive = (value1)=>$c0b31a52896d9e30$var$isNullOrUndefined(value1) || !$c0b31a52896d9e30$var$isObjectType(value1);
function $c0b31a52896d9e30$var$deepEqual(object1, object2) {
    if ($c0b31a52896d9e30$var$isPrimitive(object1) || $c0b31a52896d9e30$var$isPrimitive(object2)) return object1 === object2;
    if ($c0b31a52896d9e30$var$isDateObject(object1) && $c0b31a52896d9e30$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($c0b31a52896d9e30$var$isDateObject(val1) && $c0b31a52896d9e30$var$isDateObject(val2) || $c0b31a52896d9e30$var$isObject(val1) && $c0b31a52896d9e30$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$c0b31a52896d9e30$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
const $c0b31a52896d9e30$var$useDeepEqualEffect = (effect, deps)=>{
    const ref = $dBNnn.useRef(deps);
    if (!$c0b31a52896d9e30$var$deepEqual(deps, ref.current)) ref.current = deps;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $dBNnn.useEffect(effect, ref.current);
};
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $c0b31a52896d9e30$export$606f11b2eb45ecc6(props) {
    const methods = $c0b31a52896d9e30$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $c0b31a52896d9e30$var$useDeepEqualEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useMemo(()=>$c0b31a52896d9e30$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $c0b31a52896d9e30$var$isString = (value1)=>typeof value1 === 'string';
var $c0b31a52896d9e30$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($c0b31a52896d9e30$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $c0b31a52896d9e30$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $c0b31a52896d9e30$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $c0b31a52896d9e30$export$3c773aa2b84f29e0(props) {
    const methods = $c0b31a52896d9e30$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useState(control._getWatch(name, defaultValue));
    $c0b31a52896d9e30$var$useDeepEqualEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>!disabled && updateValue($c0b31a52896d9e30$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, defaultValue))
        }), [
        name,
        defaultValue,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $c0b31a52896d9e30$export$e8c786024a2b0a79(props) {
    const methods = $c0b31a52896d9e30$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $c0b31a52896d9e30$var$isNameInFieldArray(control._names.array, name);
    const value1 = $c0b31a52896d9e30$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $c0b31a52896d9e30$export$3988ae62b71be9a3(control._formValues, name, $c0b31a52896d9e30$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $c0b31a52896d9e30$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(props);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$c0b31a52896d9e30$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$c0b31a52896d9e30$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$c0b31a52896d9e30$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$c0b31a52896d9e30$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$c0b31a52896d9e30$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$c0b31a52896d9e30$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $c0b31a52896d9e30$var$getEventValue(event),
                name: name
            },
            type: $c0b31a52896d9e30$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $c0b31a52896d9e30$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $c0b31a52896d9e30$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback((elm)=>{
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus(),
            select: ()=>elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useMemo(()=>({
            name: name,
            value: value1,
            ...$c0b31a52896d9e30$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...$c0b31a52896d9e30$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $c0b31a52896d9e30$var$cloneObject($c0b31a52896d9e30$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $c0b31a52896d9e30$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($c0b31a52896d9e30$var$isUndefined($c0b31a52896d9e30$export$3988ae62b71be9a3(control._formValues, name))) $c0b31a52896d9e30$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $c0b31a52896d9e30$export$bd0bf19f25da8474 = (props)=>props.render($c0b31a52896d9e30$export$e8c786024a2b0a79(props));
const $c0b31a52896d9e30$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($c0b31a52896d9e30$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $c0b31a52896d9e30$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $c0b31a52896d9e30$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $c0b31a52896d9e30$export$a7fed597f4b8afd8(props) {
    const methods = $c0b31a52896d9e30$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $c0b31a52896d9e30$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $c0b31a52896d9e30$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $c0b31a52896d9e30$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $c0b31a52896d9e30$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $c0b31a52896d9e30$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $c0b31a52896d9e30$var$isEmptyObject = (value1)=>$c0b31a52896d9e30$var$isObject(value1) && !Object.keys(value1).length;
var $c0b31a52896d9e30$var$isFileInput = (element)=>element.type === 'file';
var $c0b31a52896d9e30$var$isFunction = (value1)=>typeof value1 === 'function';
var $c0b31a52896d9e30$var$isHTMLElement = (value1)=>{
    if (!$c0b31a52896d9e30$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $c0b31a52896d9e30$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $c0b31a52896d9e30$var$isRadioInput = (element)=>element.type === 'radio';
var $c0b31a52896d9e30$var$isRadioOrCheckbox = (ref)=>$c0b31a52896d9e30$var$isRadioInput(ref) || $c0b31a52896d9e30$var$isCheckBoxInput(ref);
var $c0b31a52896d9e30$var$live = (ref)=>$c0b31a52896d9e30$var$isHTMLElement(ref) && ref.isConnected;
function $c0b31a52896d9e30$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $c0b31a52896d9e30$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $c0b31a52896d9e30$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$c0b31a52896d9e30$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $c0b31a52896d9e30$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $c0b31a52896d9e30$var$isKey(path) ? [
        path
    ] : $c0b31a52896d9e30$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $c0b31a52896d9e30$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($c0b31a52896d9e30$var$isObject(childObject) && $c0b31a52896d9e30$var$isEmptyObject(childObject) || Array.isArray(childObject) && $c0b31a52896d9e30$var$isEmptyArray(childObject))) $c0b31a52896d9e30$var$unset(object, paths.slice(0, -1));
    return object;
}
var $c0b31a52896d9e30$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($c0b31a52896d9e30$var$isFunction(data[key])) return true;
    }
    return false;
};
function $c0b31a52896d9e30$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($c0b31a52896d9e30$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $c0b31a52896d9e30$var$isObject(data[key]) && !$c0b31a52896d9e30$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $c0b31a52896d9e30$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$c0b31a52896d9e30$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $c0b31a52896d9e30$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($c0b31a52896d9e30$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $c0b31a52896d9e30$var$isObject(data[key]) && !$c0b31a52896d9e30$var$objectHasFunction(data[key])) {
            if ($c0b31a52896d9e30$var$isUndefined(formValues) || $c0b31a52896d9e30$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $c0b31a52896d9e30$var$markFieldsDirty(data[key], []) : {
                ...$c0b31a52896d9e30$var$markFieldsDirty(data[key])
            };
            else $c0b31a52896d9e30$var$getDirtyFieldsFromDefaultValues(data[key], $c0b31a52896d9e30$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$c0b31a52896d9e30$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $c0b31a52896d9e30$var$getDirtyFields = (defaultValues, formValues)=>$c0b31a52896d9e30$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $c0b31a52896d9e30$var$markFieldsDirty(formValues));
const $c0b31a52896d9e30$var$defaultResult = {
    value: false,
    isValid: false
};
const $c0b31a52896d9e30$var$validResult = {
    value: true,
    isValid: true
};
var $c0b31a52896d9e30$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$c0b31a52896d9e30$var$isUndefined(options[0].attributes.value) ? $c0b31a52896d9e30$var$isUndefined(options[0].value) || options[0].value === '' ? $c0b31a52896d9e30$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $c0b31a52896d9e30$var$validResult : $c0b31a52896d9e30$var$defaultResult;
    }
    return $c0b31a52896d9e30$var$defaultResult;
};
var $c0b31a52896d9e30$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$c0b31a52896d9e30$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $c0b31a52896d9e30$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $c0b31a52896d9e30$var$defaultReturn = {
    isValid: false,
    value: null
};
var $c0b31a52896d9e30$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $c0b31a52896d9e30$var$defaultReturn) : $c0b31a52896d9e30$var$defaultReturn;
function $c0b31a52896d9e30$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($c0b31a52896d9e30$var$isFileInput(ref)) return ref.files;
    if ($c0b31a52896d9e30$var$isRadioInput(ref)) return $c0b31a52896d9e30$var$getRadioValue(_f.refs).value;
    if ($c0b31a52896d9e30$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($c0b31a52896d9e30$var$isCheckBoxInput(ref)) return $c0b31a52896d9e30$var$getCheckboxValue(_f.refs).value;
    return $c0b31a52896d9e30$var$getFieldValueAs($c0b31a52896d9e30$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $c0b31a52896d9e30$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        field && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $c0b31a52896d9e30$var$isRegex = (value1)=>value1 instanceof RegExp;
var $c0b31a52896d9e30$var$getRuleValue = (rule)=>$c0b31a52896d9e30$var$isUndefined(rule) ? rule : $c0b31a52896d9e30$var$isRegex(rule) ? rule.source : $c0b31a52896d9e30$var$isObject(rule) ? $c0b31a52896d9e30$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $c0b31a52896d9e30$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $c0b31a52896d9e30$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $c0b31a52896d9e30$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $c0b31a52896d9e30$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $c0b31a52896d9e30$var$VALIDATION_MODE.all,
        isOnTouch: mode === $c0b31a52896d9e30$var$VALIDATION_MODE.onTouched
    });
const $c0b31a52896d9e30$var$ASYNC_FUNCTION = 'AsyncFunction';
var $c0b31a52896d9e30$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($c0b31a52896d9e30$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $c0b31a52896d9e30$var$ASYNC_FUNCTION || $c0b31a52896d9e30$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $c0b31a52896d9e30$var$ASYNC_FUNCTION));
var $c0b31a52896d9e30$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $c0b31a52896d9e30$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $c0b31a52896d9e30$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($c0b31a52896d9e30$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($c0b31a52896d9e30$var$isObject(currentField)) {
                if ($c0b31a52896d9e30$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $c0b31a52896d9e30$var$schemaErrorLookup(errors, _fields, name) {
    const error = $c0b31a52896d9e30$export$3988ae62b71be9a3(errors, name);
    if (error || $c0b31a52896d9e30$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $c0b31a52896d9e30$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $c0b31a52896d9e30$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $c0b31a52896d9e30$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $c0b31a52896d9e30$var$VALIDATION_MODE.all));
};
var $c0b31a52896d9e30$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $c0b31a52896d9e30$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $c0b31a52896d9e30$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $c0b31a52896d9e30$var$unsetEmptyArray = (ref, name)=>!$c0b31a52896d9e30$var$compact($c0b31a52896d9e30$export$3988ae62b71be9a3(ref, name)).length && $c0b31a52896d9e30$var$unset(ref, name);
var $c0b31a52896d9e30$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $c0b31a52896d9e30$var$convertToArrayPayload($c0b31a52896d9e30$export$3988ae62b71be9a3(errors, name));
    $c0b31a52896d9e30$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $c0b31a52896d9e30$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $c0b31a52896d9e30$var$isMessage = (value1)=>$c0b31a52896d9e30$var$isString(value1);
function $c0b31a52896d9e30$var$getValidateError(result, ref, type = 'validate') {
    if ($c0b31a52896d9e30$var$isMessage(result) || Array.isArray(result) && result.every($c0b31a52896d9e30$var$isMessage) || $c0b31a52896d9e30$var$isBoolean(result) && !result) return {
        type: type,
        message: $c0b31a52896d9e30$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $c0b31a52896d9e30$var$getValueAndMessage = (validationData)=>$c0b31a52896d9e30$var$isObject(validationData) && !$c0b31a52896d9e30$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $c0b31a52896d9e30$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $c0b31a52896d9e30$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($c0b31a52896d9e30$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $c0b31a52896d9e30$var$isRadioInput(ref);
    const isCheckBox = $c0b31a52896d9e30$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $c0b31a52896d9e30$var$isFileInput(ref)) && $c0b31a52896d9e30$var$isUndefined(ref.value) && $c0b31a52896d9e30$var$isUndefined(inputValue) || $c0b31a52896d9e30$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $c0b31a52896d9e30$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.maxLength, minType = $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $c0b31a52896d9e30$var$isNullOrUndefined(inputValue)) || $c0b31a52896d9e30$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$c0b31a52896d9e30$var$getCheckboxValue(refs).isValid || isRadio && !$c0b31a52896d9e30$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $c0b31a52896d9e30$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $c0b31a52896d9e30$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$c0b31a52896d9e30$var$isNullOrUndefined(min) || !$c0b31a52896d9e30$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $c0b31a52896d9e30$var$getValueAndMessage(max);
        const minOutput = $c0b31a52896d9e30$var$getValueAndMessage(min);
        if (!$c0b31a52896d9e30$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$c0b31a52896d9e30$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$c0b31a52896d9e30$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($c0b31a52896d9e30$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($c0b31a52896d9e30$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.max, $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($c0b31a52896d9e30$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $c0b31a52896d9e30$var$getValueAndMessage(maxLength);
        const minLengthOutput = $c0b31a52896d9e30$var$getValueAndMessage(minLength);
        const exceedMax = !$c0b31a52896d9e30$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$c0b31a52896d9e30$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $c0b31a52896d9e30$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $c0b31a52896d9e30$var$getValueAndMessage(pattern);
        if ($c0b31a52896d9e30$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($c0b31a52896d9e30$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $c0b31a52896d9e30$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($c0b31a52896d9e30$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($c0b31a52896d9e30$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$c0b31a52896d9e30$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $c0b31a52896d9e30$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$c0b31a52896d9e30$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $c0b31a52896d9e30$var$defaultOptions = {
    mode: $c0b31a52896d9e30$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $c0b31a52896d9e30$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $c0b31a52896d9e30$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$c0b31a52896d9e30$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $c0b31a52896d9e30$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    const _fields = {};
    let _defaultValues = $c0b31a52896d9e30$var$isObject(_options.defaultValues) || $c0b31a52896d9e30$var$isObject(_options.values) ? $c0b31a52896d9e30$var$cloneObject(_options.values || _options.defaultValues) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $c0b31a52896d9e30$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $c0b31a52896d9e30$var$createSubject(),
        state: $c0b31a52896d9e30$var$createSubject()
    };
    const validationModeBeforeSubmit = $c0b31a52896d9e30$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $c0b31a52896d9e30$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $c0b31a52896d9e30$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $c0b31a52896d9e30$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $c0b31a52896d9e30$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$c0b31a52896d9e30$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $c0b31a52896d9e30$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $c0b31a52896d9e30$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $c0b31a52896d9e30$export$3988ae62b71be9a3(_formValues, name, $c0b31a52896d9e30$var$isUndefined(value1) ? $c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $c0b31a52896d9e30$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $c0b31a52896d9e30$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $c0b31a52896d9e30$var$deepEqual($c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $c0b31a52896d9e30$var$unset(_formState.dirtyFields, name) : $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $c0b31a52896d9e30$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $c0b31a52896d9e30$var$unset(_formState.errors, name);
        }
        if ((error ? !$c0b31a52896d9e30$var$deepEqual(previousFieldError, error) : previousFieldError) || !$c0b31a52896d9e30$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $c0b31a52896d9e30$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $c0b31a52896d9e30$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $c0b31a52896d9e30$export$3988ae62b71be9a3(errors, name);
            error ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $c0b31a52896d9e30$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $c0b31a52896d9e30$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $c0b31a52896d9e30$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($c0b31a52896d9e30$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $c0b31a52896d9e30$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $c0b31a52896d9e30$var$unset(_formState.errors, _f.name));
                }
                !$c0b31a52896d9e30$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$c0b31a52896d9e30$var$live(ref)) : !$c0b31a52896d9e30$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, data), !$c0b31a52896d9e30$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$c0b31a52896d9e30$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $c0b31a52896d9e30$var$isUndefined(defaultValue) ? _defaultValues : $c0b31a52896d9e30$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$c0b31a52896d9e30$var$compact($c0b31a52896d9e30$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, $c0b31a52896d9e30$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $c0b31a52896d9e30$var$isHTMLElement(fieldReference.ref) && $c0b31a52896d9e30$var$isNullOrUndefined(value1) ? '' : value1;
                if ($c0b31a52896d9e30$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($c0b31a52896d9e30$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($c0b31a52896d9e30$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $c0b31a52896d9e30$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $c0b31a52896d9e30$var$isObject(fieldValue) || field && !field._f) && !$c0b31a52896d9e30$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $c0b31a52896d9e30$var$cloneObject(value1);
        $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $c0b31a52896d9e30$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $c0b31a52896d9e30$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$c0b31a52896d9e30$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $c0b31a52896d9e30$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $c0b31a52896d9e30$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $c0b31a52896d9e30$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $c0b31a52896d9e30$var$deepEqual(fieldValue, $c0b31a52896d9e30$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $c0b31a52896d9e30$var$getFieldValue(field._f) : $c0b31a52896d9e30$var$getEventValue(event);
            const isBlurEvent = event.type === $c0b31a52896d9e30$var$EVENTS.BLUR || event.type === $c0b31a52896d9e30$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$c0b31a52896d9e30$var$hasValidation(field._f) && !_options.resolver && !$c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $c0b31a52896d9e30$var$skipValidation(isBlurEvent, $c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $c0b31a52896d9e30$var$isWatched(name, _names, isBlurEvent);
            $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$c0b31a52896d9e30$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $c0b31a52896d9e30$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $c0b31a52896d9e30$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $c0b31a52896d9e30$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $c0b31a52896d9e30$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $c0b31a52896d9e30$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $c0b31a52896d9e30$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($c0b31a52896d9e30$var$isUndefined(name) ? name : fieldNames);
            isValid = $c0b31a52896d9e30$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$c0b31a52896d9e30$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$c0b31a52896d9e30$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $c0b31a52896d9e30$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $c0b31a52896d9e30$var$isUndefined(fieldNames) ? values : $c0b31a52896d9e30$var$isString(fieldNames) ? $c0b31a52896d9e30$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$c0b31a52896d9e30$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$c0b31a52896d9e30$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$c0b31a52896d9e30$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $c0b31a52896d9e30$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$c0b31a52896d9e30$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $c0b31a52896d9e30$var$convertToArrayPayload(name).forEach((inputName)=>$c0b31a52896d9e30$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$c0b31a52896d9e30$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($c0b31a52896d9e30$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $c0b31a52896d9e30$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $c0b31a52896d9e30$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $c0b31a52896d9e30$var$unset(_fields, fieldName);
                $c0b31a52896d9e30$var$unset(_formValues, fieldName);
            }
            !options.keepError && $c0b31a52896d9e30$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $c0b31a52896d9e30$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $c0b31a52896d9e30$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $c0b31a52896d9e30$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $c0b31a52896d9e30$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $c0b31a52896d9e30$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($c0b31a52896d9e30$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $c0b31a52896d9e30$var$isBoolean(options.disabled) || $c0b31a52896d9e30$var$isBoolean(_options.disabled);
        $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $c0b31a52896d9e30$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $c0b31a52896d9e30$var$getRuleValue(options.min),
                max: $c0b31a52896d9e30$var$getRuleValue(options.max),
                minLength: $c0b31a52896d9e30$var$getRuleValue(options.minLength),
                maxLength: $c0b31a52896d9e30$var$getRuleValue(options.maxLength),
                pattern: $c0b31a52896d9e30$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $c0b31a52896d9e30$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $c0b31a52896d9e30$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($c0b31a52896d9e30$var$live),
                                    fieldRef,
                                    ...Array.isArray($c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($c0b31a52896d9e30$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $c0b31a52896d9e30$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($c0b31a52896d9e30$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $c0b31a52896d9e30$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $c0b31a52896d9e30$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$c0b31a52896d9e30$export$adaa4cf7ef1b65be(fieldValues, name, undefined);
            $c0b31a52896d9e30$var$unset(_formState.errors, 'root');
            if ($c0b31a52896d9e30$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $c0b31a52896d9e30$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name)) {
            if ($c0b31a52896d9e30$var$isUndefined(options.defaultValue)) setValue(name, $c0b31a52896d9e30$var$cloneObject($c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $c0b31a52896d9e30$export$adaa4cf7ef1b65be(_defaultValues, name, $c0b31a52896d9e30$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $c0b31a52896d9e30$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $c0b31a52896d9e30$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $c0b31a52896d9e30$var$cloneObject($c0b31a52896d9e30$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $c0b31a52896d9e30$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $c0b31a52896d9e30$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $c0b31a52896d9e30$var$cloneObject(updatedValues);
        const isEmptyResetValues = $c0b31a52896d9e30$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($c0b31a52896d9e30$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$c0b31a52896d9e30$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(values, fieldName, $c0b31a52896d9e30$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $c0b31a52896d9e30$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($c0b31a52896d9e30$var$isWeb && $c0b31a52896d9e30$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($c0b31a52896d9e30$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                for (const fieldName of _names.mount)setValue(fieldName, $c0b31a52896d9e30$export$3988ae62b71be9a3(values, fieldName));
            }
            _formValues = $c0b31a52896d9e30$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$c0b31a52896d9e30$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $c0b31a52896d9e30$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $c0b31a52896d9e30$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($c0b31a52896d9e30$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $c0b31a52896d9e30$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$c0b31a52896d9e30$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $c0b31a52896d9e30$var$generateId = ()=>{
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $c0b31a52896d9e30$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $c0b31a52896d9e30$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$c0b31a52896d9e30$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $c0b31a52896d9e30$var$appendAt = (data, value1)=>[
        ...data,
        ...$c0b31a52896d9e30$var$convertToArrayPayload(value1)
    ];
var $c0b31a52896d9e30$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $c0b31a52896d9e30$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$c0b31a52896d9e30$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $c0b31a52896d9e30$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($c0b31a52896d9e30$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $c0b31a52896d9e30$var$prependAt = (data, value1)=>[
        ...$c0b31a52896d9e30$var$convertToArrayPayload(value1),
        ...$c0b31a52896d9e30$var$convertToArrayPayload(data)
    ];
function $c0b31a52896d9e30$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $c0b31a52896d9e30$var$compact(temp).length ? temp : [];
}
var $c0b31a52896d9e30$var$removeArrayAt = (data, index)=>$c0b31a52896d9e30$var$isUndefined(index) ? [] : $c0b31a52896d9e30$var$removeAtIndexes(data, $c0b31a52896d9e30$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $c0b31a52896d9e30$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $c0b31a52896d9e30$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $c0b31a52896d9e30$export$310131896651d559(props) {
    const methods = $c0b31a52896d9e30$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(control._getFieldArray(name).map($c0b31a52896d9e30$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    rules && control.register(name, rules);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === _name.current || !fieldArrayName) {
                    const fieldValues = $c0b31a52896d9e30$export$3988ae62b71be9a3(values, _name.current);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($c0b31a52896d9e30$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $c0b31a52896d9e30$var$convertToArrayPayload($c0b31a52896d9e30$var$cloneObject(value1));
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $c0b31a52896d9e30$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $c0b31a52896d9e30$var$appendAt(ids.current, appendValue.map($c0b31a52896d9e30$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$appendAt, {
            argA: $c0b31a52896d9e30$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $c0b31a52896d9e30$var$convertToArrayPayload($c0b31a52896d9e30$var$cloneObject(value1));
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $c0b31a52896d9e30$var$getFocusFieldName(name, 0, options);
        ids.current = $c0b31a52896d9e30$var$prependAt(ids.current, prependValue.map($c0b31a52896d9e30$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$prependAt, {
            argA: $c0b31a52896d9e30$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $c0b31a52896d9e30$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($c0b31a52896d9e30$export$3988ae62b71be9a3(control._fields, name)) && $c0b31a52896d9e30$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $c0b31a52896d9e30$var$convertToArrayPayload($c0b31a52896d9e30$var$cloneObject(value1));
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $c0b31a52896d9e30$var$getFocusFieldName(name, index, options);
        ids.current = $c0b31a52896d9e30$var$insert(ids.current, index, insertValue.map($c0b31a52896d9e30$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$insert, {
            argA: index,
            argB: $c0b31a52896d9e30$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $c0b31a52896d9e30$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $c0b31a52896d9e30$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $c0b31a52896d9e30$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $c0b31a52896d9e30$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $c0b31a52896d9e30$var$cloneObject(value1);
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $c0b31a52896d9e30$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $c0b31a52896d9e30$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $c0b31a52896d9e30$var$convertToArrayPayload($c0b31a52896d9e30$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($c0b31a52896d9e30$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        control._state.action = false;
        $c0b31a52896d9e30$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$c0b31a52896d9e30$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$c0b31a52896d9e30$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $c0b31a52896d9e30$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $c0b31a52896d9e30$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $c0b31a52896d9e30$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $c0b31a52896d9e30$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($c0b31a52896d9e30$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $c0b31a52896d9e30$var$getValidationModes(control._options.mode).isOnSubmit)) $c0b31a52896d9e30$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $c0b31a52896d9e30$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$c0b31a52896d9e30$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $c0b31a52896d9e30$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $c0b31a52896d9e30$var$cloneObject(control._formValues)
        });
        control._names.focus && $c0b31a52896d9e30$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        !$c0b31a52896d9e30$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $c0b31a52896d9e30$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $c0b31a52896d9e30$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
const $c0b31a52896d9e30$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect;
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $c0b31a52896d9e30$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $c0b31a52896d9e30$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $c0b31a52896d9e30$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...props.formControl ? props.formControl : $c0b31a52896d9e30$export$1361f5e0e4cca3c3(props),
            formState: formState
        };
        if (props.formControl && props.defaultValues && !$c0b31a52896d9e30$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
    }
    const control = _formControl.current.control;
    control._options = props;
    $c0b31a52896d9e30$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
        if (props.errors && !$c0b31a52896d9e30$var$isEmptyObject(props.errors)) control._setErrors(props.errors);
    }, [
        control,
        props.errors,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        if (props.values && !$c0b31a52896d9e30$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, control._options.resetOptions);
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $c0b31a52896d9e30$var$getProxyFormState(formState, control);
    return _formControl.current;
}


const $7c5541f459ee75eb$var$RegistrationRequestField = (props)=>{
    const { field: { onChange: onChange, onBlur: onBlur, value: value, name: name, ref: ref }, fieldState: { invalid: invalid, isTouched: isTouched, error: error } } = (0, $c0b31a52896d9e30$export$e8c786024a2b0a79)({
        name: props.id,
        control: props.control,
        disabled: props.disabled
    });
    const id = `form-control-${props.id}`;
    const validityClass = isTouched ? invalid ? 'is-invalid' : 'is-valid' : '';
    const helpElementId = `${id}-helpblock`;
    let PreparedAutocompleter;
    if (props.autocompleter) PreparedAutocompleter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createElement(props.autocompleter, {
        watchedId: props.id,
        setValue: props.autocompleterSetValue
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
        className: "row mb-3",
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                className: "col-md-12 col-md-2 col-lg-3 col-form-label form-control-label form-label",
                htmlFor: props.id,
                children: props.label
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "col-sm-12 col-md-10 col-lg-9 pt-1",
                children: [
                    (()=>{
                        switch(props.type){
                            case "text":
                            case "password":
                                return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                    onChange: onChange,
                                    onBlur: onBlur,
                                    value: value,
                                    name: name,
                                    ref: ref,
                                    id: props.id,
                                    type: props.type,
                                    className: `form-control ${validityClass}`,
                                    "aria-describedby": helpElementId,
                                    readOnly: props.readonly,
                                    placeholder: props.placeholder
                                });
                            case "checkbox":
                                return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                    onChange: onChange,
                                    onBlur: onBlur,
                                    checked: value,
                                    value: value,
                                    name: name,
                                    ref: ref,
                                    id: props.id,
                                    type: props.type,
                                    className: validityClass,
                                    "aria-describedby": helpElementId,
                                    readOnly: props.readonly,
                                    placeholder: props.placeholder
                                });
                            case "textarea":
                                return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    onChange: onChange,
                                    onBlur: onBlur,
                                    value: value,
                                    name: name,
                                    ref: ref,
                                    id: props.id,
                                    className: "form-control textarea " + validityClass,
                                    "aria-describedby": helpElementId,
                                    readOnly: props.readonly,
                                    placeholder: props.placeholder,
                                    rows: props.rows
                                });
                            case "select":
                                return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                    onChange: onChange,
                                    onBlur: onBlur,
                                    value: value,
                                    name: name,
                                    ref: ref,
                                    id: props.id,
                                    className: "form-control form-select " + validityClass,
                                    "aria-describedby": helpElementId,
                                    disabled: props.readonly,
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: props.placeholder || 'Select...'
                                        }),
                                        props.options.map((option)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                value: option.shortId,
                                                children: option.label
                                            }, `option-${option.shortId}`))
                                    ]
                                });
                        }
                    })(),
                    props.autocompleter && PreparedAutocompleter,
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: invalid ? 'd-block text-danger' : 'd-none',
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                className: "icon icon-common icon-times-circle"
                            }),
                            " ",
                            error?.message
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("small", {
                        id: `${id}-helpblock`,
                        className: `form-text my-1 text-muted ${props.type === 'checkbox' && "ms-2"}`,
                        children: [
                            props.description,
                            props.example && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Example:"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "text-dark",
                                        children: props.example
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $7c5541f459ee75eb$export$2e2bcd8739ae039 // export default (props) => {
 //   const {
 //     register,
 //     getFieldState,
 //     formState
 //   } = useFormContext();
 //   const MemoizedRegistrationRequestField = memo(RegistrationRequestField,
 //       (prevProps, nextProps) => {
 //         const prevIsDirty = getFieldState(prevProps.id, prevProps.formState).isDirty;
 //         const nextIsDirty = getFieldState(prevProps.id, nextProps.formState).isDirty;
 //         return prevIsDirty === nextIsDirty
 //       }
 //   );
 //   return <MemoizedRegistrationRequestField
 //       {...props}
 //       register={register}
 //       getFieldState={getFieldState}
 //       formState={formState}
 //   />
 // }
 = $7c5541f459ee75eb$var$RegistrationRequestField;




var $dBNnn = parcelRequire("dBNnn");

const $f8fa6e5ad033993d$export$cf793a48d03156e1 = ({ storageKey: storageKey, getValues: getValues })=>{
    const saveCurrentValuesToLocalStorage = (0, $dBNnn.useCallback)(async ()=>{
        const values = getValues();
        try {
            const jsonStringValues = JSON.stringify(values);
            localStorage.setItem(storageKey, jsonStringValues);
            await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                title: "Current form values saved successfully",
                text: "Current form values were saved successfully, when you wish to continue the session, click on the load button bellow",
                icon: "success"
            });
        } catch (error) {
            await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                icon: "error",
                title: "Error on value save",
                text: error.message
            });
        }
    }, [
        getValues,
        storageKey
    ]);
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
        className: "form-control btn btn-secondary text-white",
        type: "button",
        onClick: saveCurrentValuesToLocalStorage,
        children: "Save contents"
    });
};
const $f8fa6e5ad033993d$export$51cde66861b188e5 = ({ storageKey: storageKey, reset: reset, trigger: trigger })=>{
    const setValuesFromLocalStorage = (0, $dBNnn.useCallback)(async ()=>{
        const localStorageValues = localStorage.getItem(storageKey);
        if (localStorageValues) try {
            const parsedLocalStorage = JSON.parse(localStorageValues);
            reset(parsedLocalStorage);
            await trigger().then(()=>(0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    icon: "success",
                    title: "Load successful",
                    text: "Your data was successfully loaded"
                }));
        } catch (error) {
            await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                icon: "error",
                title: "Error on value load",
                text: error.message
            });
        }
        else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
            icon: "error",
            title: "Error on value load",
            text: "We couldn't find any saved form. Perhaps you didn't save before or you cleared you local data"
        });
    }, [
        reset,
        trigger,
        storageKey
    ]);
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
        className: "form-control btn btn-secondary text-white",
        type: "button",
        onClick: setValuesFromLocalStorage,
        children: "Load previous save"
    });
};




var $dBNnn = parcelRequire("dBNnn");


var $c39515924d99e8fd$export$2e2bcd8739ae039 = async (rorId)=>{
    let requestURL = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).rorIdEndpoint}/getInstitutionForRorId`);
    const init = {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            apiVersion: '1.0',
            payload: {
                rorId: rorId
            }
        })
    };
    const response = await fetch(requestURL, init);
    return response.status === 200 ? await response.json() : null;
};






const $041baa87cb412ad3$export$bfba6e2b5c20c25 = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true
};
const $041baa87cb412ad3$export$ff274046684546 = (setInstitutionIsProvider, formContext)=>(event)=>{
        const { setValue: setValue, getValues: getValues, formState: { defaultValues: defaultValues } } = formContext;
        const source = event.target.checked ? getValues() : defaultValues;
        setValue("providerName", source.institutionName, $041baa87cb412ad3$export$bfba6e2b5c20c25);
        setValue("providerDescription", source.institutionDescription, $041baa87cb412ad3$export$bfba6e2b5c20c25);
        setValue("providerHomeUrl", source.institutionHomeUrl, $041baa87cb412ad3$export$bfba6e2b5c20c25);
        setValue("providerLocation", source.institutionLocation, $041baa87cb412ad3$export$bfba6e2b5c20c25);
        setInstitutionIsProvider(event.target.checked);
    };
const $041baa87cb412ad3$var$rorDebounce = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef(-1);
const $041baa87cb412ad3$export$ab59a7c256710b61 = (formContext)=>{
    const func = (event)=>{
        const { getFieldState: getFieldState, setValue: setValue, getValues: getValues, formState: formState } = formContext;
        const { invalid: invalid } = getFieldState("institutionRorId", formState);
        const hasDescription = Boolean(getValues("institutionDescription"));
        if (!invalid && event.target.value) (0, $c39515924d99e8fd$export$2e2bcd8739ae039)(event.target.value).then((rorIdInformation)=>{
            if (rorIdInformation !== null) {
                setValue('institutionName', rorIdInformation.name, $041baa87cb412ad3$export$bfba6e2b5c20c25);
                setValue('institutionHomeUrl', rorIdInformation.homeUrl, $041baa87cb412ad3$export$bfba6e2b5c20c25);
                !hasDescription && setValue('institutionDescription', rorIdInformation.description, $041baa87cb412ad3$export$bfba6e2b5c20c25);
                setValue('institutionLocation', rorIdInformation.location.countryCode, $041baa87cb412ad3$export$bfba6e2b5c20c25);
            }
        }).catch((e)=>(0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                icon: "error",
                title: "Error on ROR Retrieval",
                text: e.message
            }));
    };
    return (event)=>{
        clearTimeout($041baa87cb412ad3$var$rorDebounce.current);
        $041baa87cb412ad3$var$rorDebounce.current = setTimeout(()=>func(event), 100);
    };
};
const $041baa87cb412ad3$var$DisconnectedPrefixAutoCompleter = (props)=>{
    const [selected, setSelected] = (0, $dBNnn.useState)(false);
    const [focused, setFocused] = (0, $dBNnn.useState)(false);
    const [debouncer, setDebouncer] = (0, $dBNnn.useState)(0);
    const onWatchedChanged = ()=>{
        clearTimeout(debouncer);
        setDebouncer(setTimeout(()=>{
            const watched = document.getElementById(props.watchedId);
            setSelected(false);
            if (watched.value) props.getNamespacesFromRegistry({
                content: watched.value
            });
        }, 75));
    };
    const onClick = (event)=>{
        setSelected(true);
        props.setValue(event.target.innerText);
    };
    const onSuggestionMouseOver = (e)=>e.target.classList.add("suggestion__selected", "text-white");
    const onSuggestionMouseOut = (e)=>e.target.classList.remove("suggestion__selected", "text-white");
    const onFocus = ()=>setFocused(true);
    const onLoseFocus = ()=>//Delay to make sure element stays on screen long enough for click
        setTimeout(()=>setFocused(false), 100);
    (0, $dBNnn.useEffect)(()=>{
        const watched = document.getElementById(props.watchedId);
        // if (watched.value) new Promise(() => onWatchedChanged());
        watched.addEventListener('input', onWatchedChanged);
        watched.addEventListener('focus', onFocus);
        watched.addEventListener('blur', onLoseFocus);
        return ()=>{
            watched.removeEventListener('input', onWatchedChanged);
            watched.removeEventListener('focus', onFocus);
            watched.removeEventListener('blur', onLoseFocus);
        };
    });
    if (selected || !focused) return undefined;
    else return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "inline-search-container",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "suggestions-box",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row mx-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col align-self-end",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                            className: "text-muted text-end my-0",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("small", {
                                children: "Suggestions"
                            })
                        })
                    })
                }),
                props.namespaceList.length === 0 ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "suggestion",
                    children: "No namespaces found"
                }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("ul", {
                    className: "suggestion-list pb-2",
                    children: props.namespaceList.map((suggestion)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("li", {
                            className: "px-2 py-1",
                            onClick: onClick,
                            onMouseOver: onSuggestionMouseOver,
                            onMouseOut: onSuggestionMouseOut,
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                children: suggestion.prefix
                            })
                        }, `sugg-${suggestion.prefix}`))
                })
            ]
        })
    });
};
const $041baa87cb412ad3$var$mapStateToProps = (state)=>({
        namespaceList: state.registryBrowser.namespaceList
    });
const $041baa87cb412ad3$var$mapDispatchToProps = (dispatch)=>({
        getNamespacesFromRegistry: (params)=>dispatch((0, $8b8510f780f3f18d$export$1b3a086fec21f2f0)(params))
    });
const $041baa87cb412ad3$export$32164a9ad960006c = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($041baa87cb412ad3$var$mapStateToProps, $041baa87cb412ad3$var$mapDispatchToProps)($041baa87cb412ad3$var$DisconnectedPrefixAutoCompleter);
const $041baa87cb412ad3$export$42bfa838b73a9e90 = (props)=>{
    const { control: control, resetField: resetField, trigger: trigger } = props;
    const renderProtectedUrlInputs = (0, $c0b31a52896d9e30$export$3c773aa2b84f29e0)({
        name: "protectedUrls",
        control: control
    });
    (0, $dBNnn.useEffect)(()=>{
        if (renderProtectedUrlInputs) trigger([
            "authHelpDescription",
            "authHelpUrl"
        ]);
        else {
            resetField("authHelpDescription");
            resetField("authHelpUrl");
        }
    }, [
        renderProtectedUrlInputs
    ]);
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                id: "protectedUrls",
                description: "Tick this box if users are required to authenticate to access resolved URLs.",
                label: "Are links protected?",
                type: "checkbox",
                control: control
            }),
            renderProtectedUrlInputs && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                        id: "authHelpDescription",
                        description: "A short text describing the need for authentication and how to authenticate. This should be a little paragraph to give some information to users. The URL bellow should be where users find further details.",
                        label: "Authentication description",
                        type: "textarea",
                        disabled: !renderProtectedUrlInputs,
                        control: control
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                        id: "authHelpUrl",
                        description: "URL for users to get details on how to authenticate to access resource",
                        label: "Authentication details URL",
                        type: "text",
                        disabled: !renderProtectedUrlInputs,
                        control: control
                    })
                ]
            })
        ]
    });
};



var $e777121d3fc9ac6f$exports = {};
/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */ 'use strict';
function $e777121d3fc9ac6f$var$Cache(maxSize) {
    this._maxSize = maxSize;
    this.clear();
}
$e777121d3fc9ac6f$var$Cache.prototype.clear = function() {
    this._size = 0;
    this._values = Object.create(null);
};
$e777121d3fc9ac6f$var$Cache.prototype.get = function(key) {
    return this._values[key];
};
$e777121d3fc9ac6f$var$Cache.prototype.set = function(key, value) {
    this._size >= this._maxSize && this.clear();
    if (!(key in this._values)) this._size++;
    return this._values[key] = value;
};
var $e777121d3fc9ac6f$var$SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g, $e777121d3fc9ac6f$var$DIGIT_REGEX = /^\d+$/, $e777121d3fc9ac6f$var$LEAD_DIGIT_REGEX = /^\d/, $e777121d3fc9ac6f$var$SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, $e777121d3fc9ac6f$var$CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/, $e777121d3fc9ac6f$var$MAX_CACHE_SIZE = 512;
var $e777121d3fc9ac6f$var$pathCache = new $e777121d3fc9ac6f$var$Cache($e777121d3fc9ac6f$var$MAX_CACHE_SIZE), $e777121d3fc9ac6f$var$setCache = new $e777121d3fc9ac6f$var$Cache($e777121d3fc9ac6f$var$MAX_CACHE_SIZE), $e777121d3fc9ac6f$var$getCache = new $e777121d3fc9ac6f$var$Cache($e777121d3fc9ac6f$var$MAX_CACHE_SIZE);
var $e777121d3fc9ac6f$var$config;
$e777121d3fc9ac6f$exports = {
    Cache: $e777121d3fc9ac6f$var$Cache,
    split: $e777121d3fc9ac6f$var$split,
    normalizePath: $e777121d3fc9ac6f$var$normalizePath,
    setter: function(path) {
        var parts = $e777121d3fc9ac6f$var$normalizePath(path);
        return $e777121d3fc9ac6f$var$setCache.get(path) || $e777121d3fc9ac6f$var$setCache.set(path, function setter(obj, value) {
            var index = 0;
            var len = parts.length;
            var data = obj;
            while(index < len - 1){
                var part = parts[index];
                if (part === '__proto__' || part === 'constructor' || part === 'prototype') return obj;
                data = data[parts[index++]];
            }
            data[parts[index]] = value;
        });
    },
    getter: function(path, safe) {
        var parts = $e777121d3fc9ac6f$var$normalizePath(path);
        return $e777121d3fc9ac6f$var$getCache.get(path) || $e777121d3fc9ac6f$var$getCache.set(path, function getter(data) {
            var index = 0, len = parts.length;
            while(index < len){
                if (data != null || !safe) data = data[parts[index++]];
                else return;
            }
            return data;
        });
    },
    join: function(segments) {
        return segments.reduce(function(path, part) {
            return path + ($e777121d3fc9ac6f$var$isQuoted(part) || $e777121d3fc9ac6f$var$DIGIT_REGEX.test(part) ? '[' + part + ']' : (path ? '.' : '') + part);
        }, '');
    },
    forEach: function(path, cb, thisArg) {
        $e777121d3fc9ac6f$var$forEach(Array.isArray(path) ? path : $e777121d3fc9ac6f$var$split(path), cb, thisArg);
    }
};
function $e777121d3fc9ac6f$var$normalizePath(path) {
    return $e777121d3fc9ac6f$var$pathCache.get(path) || $e777121d3fc9ac6f$var$pathCache.set(path, $e777121d3fc9ac6f$var$split(path).map(function(part) {
        return part.replace($e777121d3fc9ac6f$var$CLEAN_QUOTES_REGEX, '$2');
    }));
}
function $e777121d3fc9ac6f$var$split(path) {
    return path.match($e777121d3fc9ac6f$var$SPLIT_REGEX) || [
        ''
    ];
}
function $e777121d3fc9ac6f$var$forEach(parts, iter, thisArg) {
    var len = parts.length, part, idx, isArray, isBracket;
    for(idx = 0; idx < len; idx++){
        part = parts[idx];
        if (part) {
            if ($e777121d3fc9ac6f$var$shouldBeQuoted(part)) part = '"' + part + '"';
            isBracket = $e777121d3fc9ac6f$var$isQuoted(part);
            isArray = !isBracket && /^\d+$/.test(part);
            iter.call(thisArg, part, isBracket, isArray, idx, parts);
        }
    }
}
function $e777121d3fc9ac6f$var$isQuoted(str) {
    return typeof str === 'string' && str && [
        "'",
        '"'
    ].indexOf(str.charAt(0)) !== -1;
}
function $e777121d3fc9ac6f$var$hasLeadingNumber(part) {
    return part.match($e777121d3fc9ac6f$var$LEAD_DIGIT_REGEX) && !part.match($e777121d3fc9ac6f$var$DIGIT_REGEX);
}
function $e777121d3fc9ac6f$var$hasSpecialChars(part) {
    return $e777121d3fc9ac6f$var$SPEC_CHAR_REGEX.test(part);
}
function $e777121d3fc9ac6f$var$shouldBeQuoted(part) {
    return !$e777121d3fc9ac6f$var$isQuoted(part) && ($e777121d3fc9ac6f$var$hasLeadingNumber(part) || $e777121d3fc9ac6f$var$hasSpecialChars(part));
}


var $f445cff46cb04123$exports = {};
const $f445cff46cb04123$var$reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
const $f445cff46cb04123$var$words = (str)=>str.match($f445cff46cb04123$var$reWords) || [];
const $f445cff46cb04123$var$upperFirst = (str)=>str[0].toUpperCase() + str.slice(1);
const $f445cff46cb04123$var$join = (str, d)=>$f445cff46cb04123$var$words(str).join(d).toLowerCase();
const $f445cff46cb04123$var$camelCase = (str)=>$f445cff46cb04123$var$words(str).reduce((acc, next)=>`${acc}${!acc ? next.toLowerCase() : next[0].toUpperCase() + next.slice(1).toLowerCase()}`, '');
const $f445cff46cb04123$var$pascalCase = (str)=>$f445cff46cb04123$var$upperFirst($f445cff46cb04123$var$camelCase(str));
const $f445cff46cb04123$var$snakeCase = (str)=>$f445cff46cb04123$var$join(str, '_');
const $f445cff46cb04123$var$kebabCase = (str)=>$f445cff46cb04123$var$join(str, '-');
const $f445cff46cb04123$var$sentenceCase = (str)=>$f445cff46cb04123$var$upperFirst($f445cff46cb04123$var$join(str, ' '));
const $f445cff46cb04123$var$titleCase = (str)=>$f445cff46cb04123$var$words(str).map($f445cff46cb04123$var$upperFirst).join(' ');
$f445cff46cb04123$exports = {
    words: $f445cff46cb04123$var$words,
    upperFirst: $f445cff46cb04123$var$upperFirst,
    camelCase: $f445cff46cb04123$var$camelCase,
    pascalCase: $f445cff46cb04123$var$pascalCase,
    snakeCase: $f445cff46cb04123$var$snakeCase,
    kebabCase: $f445cff46cb04123$var$kebabCase,
    sentenceCase: $f445cff46cb04123$var$sentenceCase,
    titleCase: $f445cff46cb04123$var$titleCase
};


var $e8af384fb65a728e$exports = {};
/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */ $e8af384fb65a728e$exports = function(edges) {
    return $e8af384fb65a728e$var$toposort($e8af384fb65a728e$var$uniqueNodes(edges), edges);
};
$e8af384fb65a728e$exports.array = $e8af384fb65a728e$var$toposort;
function $e8af384fb65a728e$var$toposort(nodes, edges) {
    var cursor = nodes.length, sorted = new Array(cursor), visited = {}, i = cursor, outgoingEdges = $e8af384fb65a728e$var$makeOutgoingEdges(edges), nodesHash = $e8af384fb65a728e$var$makeNodesHash(nodes);
    // check for unknown nodes
    edges.forEach(function(edge) {
        if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) throw new Error('Unknown node. There is an unknown node in the supplied edges.');
    });
    while(i--)if (!visited[i]) visit(nodes[i], i, new Set());
    return sorted;
    function visit(node, i, predecessors) {
        if (predecessors.has(node)) {
            var nodeRep;
            try {
                nodeRep = ", node was:" + JSON.stringify(node);
            } catch (e) {
                nodeRep = "";
            }
            throw new Error('Cyclic dependency' + nodeRep);
        }
        if (!nodesHash.has(node)) throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: ' + JSON.stringify(node));
        if (visited[i]) return;
        visited[i] = true;
        var outgoing = outgoingEdges.get(node) || new Set();
        outgoing = Array.from(outgoing);
        if (i = outgoing.length) {
            predecessors.add(node);
            do {
                var child = outgoing[--i];
                visit(child, nodesHash.get(child), predecessors);
            }while (i);
            predecessors.delete(node);
        }
        sorted[--cursor] = node;
    }
}
function $e8af384fb65a728e$var$uniqueNodes(arr) {
    var res = new Set();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        res.add(edge[0]);
        res.add(edge[1]);
    }
    return Array.from(res);
}
function $e8af384fb65a728e$var$makeOutgoingEdges(arr) {
    var edges = new Map();
    for(var i = 0, len = arr.length; i < len; i++){
        var edge = arr[i];
        if (!edges.has(edge[0])) edges.set(edge[0], new Set());
        if (!edges.has(edge[1])) edges.set(edge[1], new Set());
        edges.get(edge[0]).add(edge[1]);
    }
    return edges;
}
function $e8af384fb65a728e$var$makeNodesHash(arr) {
    var res = new Map();
    for(var i = 0, len = arr.length; i < len; i++)res.set(arr[i], i);
    return res;
}


const $0d9a35220db777bc$var$toString = Object.prototype.toString;
const $0d9a35220db777bc$var$errorToString = Error.prototype.toString;
const $0d9a35220db777bc$var$regExpToString = RegExp.prototype.toString;
const $0d9a35220db777bc$var$symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : ()=>'';
const $0d9a35220db777bc$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function $0d9a35220db777bc$var$printNumber(val) {
    if (val != +val) return 'NaN';
    const isNegativeZero = val === 0 && 1 / val < 0;
    return isNegativeZero ? '-0' : '' + val;
}
function $0d9a35220db777bc$var$printSimpleValue(val, quoteStrings = false) {
    if (val == null || val === true || val === false) return '' + val;
    const typeOf = typeof val;
    if (typeOf === 'number') return $0d9a35220db777bc$var$printNumber(val);
    if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
    if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
    if (typeOf === 'symbol') return $0d9a35220db777bc$var$symbolToString.call(val).replace($0d9a35220db777bc$var$SYMBOL_REGEXP, 'Symbol($1)');
    const tag = $0d9a35220db777bc$var$toString.call(val).slice(8, -1);
    if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
    if (tag === 'Error' || val instanceof Error) return '[' + $0d9a35220db777bc$var$errorToString.call(val) + ']';
    if (tag === 'RegExp') return $0d9a35220db777bc$var$regExpToString.call(val);
    return null;
}
function $0d9a35220db777bc$export$5790025c6e6c2ba6(value, quoteStrings) {
    let result = $0d9a35220db777bc$var$printSimpleValue(value, quoteStrings);
    if (result !== null) return result;
    return JSON.stringify(value, function(key, value) {
        let result = $0d9a35220db777bc$var$printSimpleValue(this[key], quoteStrings);
        if (result !== null) return result;
        return value;
    }, 2);
}
function $0d9a35220db777bc$var$toArray(value) {
    return value == null ? [] : [].concat(value);
}
let $0d9a35220db777bc$var$_Symbol$toStringTag, $0d9a35220db777bc$var$_Symbol$hasInstance, $0d9a35220db777bc$var$_Symbol$toStringTag2;
let $0d9a35220db777bc$var$strReg = /\$\{\s*(\w+)\s*\}/g;
$0d9a35220db777bc$var$_Symbol$toStringTag = Symbol.toStringTag;
class $0d9a35220db777bc$var$ValidationErrorNoStack {
    constructor(errorOrErrors, value, field, type){
        this.name = void 0;
        this.message = void 0;
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = void 0;
        this.inner = void 0;
        this[$0d9a35220db777bc$var$_Symbol$toStringTag] = 'Error';
        this.name = 'ValidationError';
        this.value = value;
        this.path = field;
        this.type = type;
        this.errors = [];
        this.inner = [];
        $0d9a35220db777bc$var$toArray(errorOrErrors).forEach((err)=>{
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) {
                this.errors.push(...err.errors);
                const innerErrors = err.inner.length ? err.inner : [
                    err
                ];
                this.inner.push(...innerErrors);
            } else this.errors.push(err);
        });
        this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    }
}
$0d9a35220db777bc$var$_Symbol$hasInstance = Symbol.hasInstance;
$0d9a35220db777bc$var$_Symbol$toStringTag2 = Symbol.toStringTag;
class $0d9a35220db777bc$export$2191b9da168c6cf0 extends Error {
    static formatError(message, params) {
        // Attempt to make the path more friendly for error message interpolation.
        const path = params.label || params.path || 'this';
        // Store the original path under `originalPath` so it isn't lost to custom
        // message functions; e.g., ones provided in `setLocale()` calls.
        params = Object.assign({}, params, {
            path: path,
            originalPath: params.path
        });
        if (typeof message === 'string') return message.replace($0d9a35220db777bc$var$strReg, (_, key)=>$0d9a35220db777bc$export$5790025c6e6c2ba6(params[key]));
        if (typeof message === 'function') return message(params);
        return message;
    }
    static isError(err) {
        return err && err.name === 'ValidationError';
    }
    constructor(errorOrErrors, value, field, type, disableStack){
        const errorNoStack = new $0d9a35220db777bc$var$ValidationErrorNoStack(errorOrErrors, value, field, type);
        if (disableStack) return errorNoStack;
        super();
        this.value = void 0;
        this.path = void 0;
        this.type = void 0;
        this.params = void 0;
        this.errors = [];
        this.inner = [];
        this[$0d9a35220db777bc$var$_Symbol$toStringTag2] = 'Error';
        this.name = errorNoStack.name;
        this.message = errorNoStack.message;
        this.type = errorNoStack.type;
        this.value = errorNoStack.value;
        this.path = errorNoStack.path;
        this.errors = errorNoStack.errors;
        this.inner = errorNoStack.inner;
        if (Error.captureStackTrace) Error.captureStackTrace(this, $0d9a35220db777bc$export$2191b9da168c6cf0);
    }
    static [$0d9a35220db777bc$var$_Symbol$hasInstance](inst) {
        return $0d9a35220db777bc$var$ValidationErrorNoStack[Symbol.hasInstance](inst) || super[Symbol.hasInstance](inst);
    }
}
let $0d9a35220db777bc$var$mixed = {
    default: '${path} is invalid',
    required: '${path} is a required field',
    defined: '${path} must be defined',
    notNull: '${path} cannot be null',
    oneOf: '${path} must be one of the following values: ${values}',
    notOneOf: '${path} must not be one of the following values: ${values}',
    notType: ({ path: path, type: type, value: value, originalValue: originalValue })=>{
        const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${$0d9a35220db777bc$export$5790025c6e6c2ba6(originalValue, true)}\`).` : '.';
        return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${$0d9a35220db777bc$export$5790025c6e6c2ba6(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${$0d9a35220db777bc$export$5790025c6e6c2ba6(value, true)}\`` + castMsg;
    }
};
let $0d9a35220db777bc$var$string = {
    length: '${path} must be exactly ${length} characters',
    min: '${path} must be at least ${min} characters',
    max: '${path} must be at most ${max} characters',
    matches: '${path} must match the following: "${regex}"',
    email: '${path} must be a valid email',
    url: '${path} must be a valid URL',
    uuid: '${path} must be a valid UUID',
    datetime: '${path} must be a valid ISO date-time',
    datetime_precision: '${path} must be a valid ISO date-time with a sub-second precision of exactly ${precision} digits',
    datetime_offset: '${path} must be a valid ISO date-time with UTC "Z" timezone',
    trim: '${path} must be a trimmed string',
    lowercase: '${path} must be a lowercase string',
    uppercase: '${path} must be a upper case string'
};
let $0d9a35220db777bc$var$number = {
    min: '${path} must be greater than or equal to ${min}',
    max: '${path} must be less than or equal to ${max}',
    lessThan: '${path} must be less than ${less}',
    moreThan: '${path} must be greater than ${more}',
    positive: '${path} must be a positive number',
    negative: '${path} must be a negative number',
    integer: '${path} must be an integer'
};
let $0d9a35220db777bc$var$date = {
    min: '${path} field must be later than ${min}',
    max: '${path} field must be at earlier than ${max}'
};
let $0d9a35220db777bc$var$boolean = {
    isValue: '${path} field must be ${value}'
};
let $0d9a35220db777bc$var$object = {
    noUnknown: '${path} field has unspecified keys: ${unknown}',
    exact: '${path} object contains unknown properties: ${properties}'
};
let $0d9a35220db777bc$var$array = {
    min: '${path} field must have at least ${min} items',
    max: '${path} field must have less than or equal to ${max} items',
    length: '${path} must have ${length} items'
};
let $0d9a35220db777bc$var$tuple = {
    notType: (params)=>{
        const { path: path, value: value, spec: spec } = params;
        const typeLen = spec.types.length;
        if (Array.isArray(value)) {
            if (value.length < typeLen) return `${path} tuple value has too few items, expected a length of ${typeLen} but got ${value.length} for value: \`${$0d9a35220db777bc$export$5790025c6e6c2ba6(value, true)}\``;
            if (value.length > typeLen) return `${path} tuple value has too many items, expected a length of ${typeLen} but got ${value.length} for value: \`${$0d9a35220db777bc$export$5790025c6e6c2ba6(value, true)}\``;
        }
        return $0d9a35220db777bc$export$2191b9da168c6cf0.formatError($0d9a35220db777bc$var$mixed.notType, params);
    }
};
var $0d9a35220db777bc$export$d7f512c98c859244 = Object.assign(Object.create(null), {
    mixed: $0d9a35220db777bc$var$mixed,
    string: $0d9a35220db777bc$var$string,
    number: $0d9a35220db777bc$var$number,
    date: $0d9a35220db777bc$var$date,
    object: $0d9a35220db777bc$var$object,
    array: $0d9a35220db777bc$var$array,
    boolean: $0d9a35220db777bc$var$boolean,
    tuple: $0d9a35220db777bc$var$tuple
});
const $0d9a35220db777bc$export$213e2a3e7c4f326e = (obj)=>obj && obj.__isYupSchema__;
class $0d9a35220db777bc$var$Condition {
    static fromOptions(refs, config) {
        if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
        let { is: is, then: then, otherwise: otherwise } = config;
        let check = typeof is === 'function' ? is : (...values)=>values.every((value)=>value === is);
        return new $0d9a35220db777bc$var$Condition(refs, (values, schema)=>{
            var _branch;
            let branch = check(...values) ? then : otherwise;
            return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
        });
    }
    constructor(refs, builder){
        this.fn = void 0;
        this.refs = refs;
        this.refs = refs;
        this.fn = builder;
    }
    resolve(base, options) {
        let values = this.refs.map((ref)=>// TODO: ? operator here?
            ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
        let schema = this.fn(values, base, options);
        if (schema === undefined || // @ts-ignore this can be base
        schema === base) return base;
        if (!$0d9a35220db777bc$export$213e2a3e7c4f326e(schema)) throw new TypeError('conditions must return a schema object');
        return schema.resolve(options);
    }
}
const $0d9a35220db777bc$var$prefixes = {
    context: '$',
    value: '.'
};
function $0d9a35220db777bc$export$eff4d24c3ff7876e(key, options) {
    return new $0d9a35220db777bc$var$Reference(key, options);
}
class $0d9a35220db777bc$var$Reference {
    constructor(key, options = {}){
        this.key = void 0;
        this.isContext = void 0;
        this.isValue = void 0;
        this.isSibling = void 0;
        this.path = void 0;
        this.getter = void 0;
        this.map = void 0;
        if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
        this.key = key.trim();
        if (key === '') throw new TypeError('ref must be a non-empty string');
        this.isContext = this.key[0] === $0d9a35220db777bc$var$prefixes.context;
        this.isValue = this.key[0] === $0d9a35220db777bc$var$prefixes.value;
        this.isSibling = !this.isContext && !this.isValue;
        let prefix = this.isContext ? $0d9a35220db777bc$var$prefixes.context : this.isValue ? $0d9a35220db777bc$var$prefixes.value : '';
        this.path = this.key.slice(prefix.length);
        this.getter = this.path && (0, $e777121d3fc9ac6f$exports.getter)(this.path, true);
        this.map = options.map;
    }
    getValue(value, parent, context) {
        let result = this.isContext ? context : this.isValue ? value : parent;
        if (this.getter) result = this.getter(result || {});
        if (this.map) result = this.map(result);
        return result;
    }
    /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */ cast(value, options) {
        return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
    }
    resolve() {
        return this;
    }
    describe() {
        return {
            type: 'ref',
            key: this.key
        };
    }
    toString() {
        return `Ref(${this.key})`;
    }
    static isRef(value) {
        return value && value.__isYupRef;
    }
}
// @ts-ignore
$0d9a35220db777bc$var$Reference.prototype.__isYupRef = true;
const $0d9a35220db777bc$var$isAbsent = (value)=>value == null;
function $0d9a35220db777bc$var$createValidation(config) {
    function validate({ value: value, path: path = '', options: options, originalValue: originalValue, schema: schema }, panic, next) {
        const { name: name, test: test, params: params, message: message, skipAbsent: skipAbsent } = config;
        let { parent: parent, context: context, abortEarly: abortEarly = schema.spec.abortEarly, disableStackTrace: disableStackTrace = schema.spec.disableStackTrace } = options;
        function resolve(item) {
            return $0d9a35220db777bc$var$Reference.isRef(item) ? item.getValue(value, parent, context) : item;
        }
        function createError(overrides = {}) {
            const nextParams = Object.assign({
                value: value,
                originalValue: originalValue,
                label: schema.spec.label,
                path: overrides.path || path,
                spec: schema.spec,
                disableStackTrace: overrides.disableStackTrace || disableStackTrace
            }, params, overrides.params);
            for (const key of Object.keys(nextParams))nextParams[key] = resolve(nextParams[key]);
            const error = new $0d9a35220db777bc$export$2191b9da168c6cf0($0d9a35220db777bc$export$2191b9da168c6cf0.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name, nextParams.disableStackTrace);
            error.params = nextParams;
            return error;
        }
        const invalid = abortEarly ? panic : next;
        let ctx = {
            path: path,
            parent: parent,
            type: name,
            from: options.from,
            createError: createError,
            resolve: resolve,
            options: options,
            originalValue: originalValue,
            schema: schema
        };
        const handleResult = (validOrError)=>{
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(validOrError)) invalid(validOrError);
            else if (!validOrError) invalid(createError());
            else next(null);
        };
        const handleError = (err)=>{
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) invalid(err);
            else panic(err);
        };
        const shouldSkip = skipAbsent && $0d9a35220db777bc$var$isAbsent(value);
        if (shouldSkip) return handleResult(true);
        let result;
        try {
            var _result;
            result = test.call(ctx, value, ctx);
            if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
                if (options.sync) throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
                return Promise.resolve(result).then(handleResult, handleError);
            }
        } catch (err) {
            handleError(err);
            return;
        }
        handleResult(result);
    }
    validate.OPTIONS = config;
    return validate;
}
function $0d9a35220db777bc$export$c52e5867d5879e24(schema, path, value, context = value) {
    let parent, lastPart, lastPartDebug;
    // root path: ''
    if (!path) return {
        parent: parent,
        parentPath: path,
        schema: schema
    };
    (0, $e777121d3fc9ac6f$exports.forEach)(path, (_part, isBracket, isArray)=>{
        let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
        schema = schema.resolve({
            context: context,
            parent: parent,
            value: value
        });
        let isTuple = schema.type === 'tuple';
        let idx = isArray ? parseInt(part, 10) : 0;
        if (schema.innerType || isTuple) {
            if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
            if (value && idx >= value.length) throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
            parent = value;
            value = value && value[idx];
            schema = isTuple ? schema.spec.types[idx] : schema.innerType;
        }
        // sometimes the array index part of a path doesn't exist: "nested.arr.child"
        // in these cases the current part is the next schema and should be processed
        // in this iteration. For cases where the index signature is included this
        // check will fail and we'll handle the `child` part on the next iteration like normal
        if (!isArray) {
            if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
            parent = value;
            value = value && value[part];
            schema = schema.fields[part];
        }
        lastPart = part;
        lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
    });
    return {
        schema: schema,
        parent: parent,
        parentPath: lastPart
    };
}
function $0d9a35220db777bc$export$cfedb76369cc7782(obj, path, value, context) {
    return $0d9a35220db777bc$export$c52e5867d5879e24(obj, path, value, context).schema;
}
class $0d9a35220db777bc$var$ReferenceSet extends Set {
    describe() {
        const description = [];
        for (const item of this.values())description.push($0d9a35220db777bc$var$Reference.isRef(item) ? item.describe() : item);
        return description;
    }
    resolveAll(resolve) {
        let result = [];
        for (const item of this.values())result.push(resolve(item));
        return result;
    }
    clone() {
        return new $0d9a35220db777bc$var$ReferenceSet(this.values());
    }
    merge(newItems, removeItems) {
        const next = this.clone();
        newItems.forEach((value)=>next.add(value));
        removeItems.forEach((value)=>next.delete(value));
        return next;
    }
}
// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function $0d9a35220db777bc$var$clone(src, seen = new Map()) {
    if ($0d9a35220db777bc$export$213e2a3e7c4f326e(src) || !src || typeof src !== 'object') return src;
    if (seen.has(src)) return seen.get(src);
    let copy;
    if (src instanceof Date) {
        // Date
        copy = new Date(src.getTime());
        seen.set(src, copy);
    } else if (src instanceof RegExp) {
        // RegExp
        copy = new RegExp(src);
        seen.set(src, copy);
    } else if (Array.isArray(src)) {
        // Array
        copy = new Array(src.length);
        seen.set(src, copy);
        for(let i = 0; i < src.length; i++)copy[i] = $0d9a35220db777bc$var$clone(src[i], seen);
    } else if (src instanceof Map) {
        // Map
        copy = new Map();
        seen.set(src, copy);
        for (const [k, v] of src.entries())copy.set(k, $0d9a35220db777bc$var$clone(v, seen));
    } else if (src instanceof Set) {
        // Set
        copy = new Set();
        seen.set(src, copy);
        for (const v of src)copy.add($0d9a35220db777bc$var$clone(v, seen));
    } else if (src instanceof Object) {
        // Object
        copy = {};
        seen.set(src, copy);
        for (const [k, v] of Object.entries(src))copy[k] = $0d9a35220db777bc$var$clone(v, seen);
    } else throw Error(`Unable to clone ${src}`);
    return copy;
}
// If `CustomSchemaMeta` isn't extended with any keys, we'll fall back to a
// loose Record definition allowing free form usage.
class $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(options){
        this.type = void 0;
        this.deps = [];
        this.tests = void 0;
        this.transforms = void 0;
        this.conditions = [];
        this._mutate = void 0;
        this.internalTests = {};
        this._whitelist = new $0d9a35220db777bc$var$ReferenceSet();
        this._blacklist = new $0d9a35220db777bc$var$ReferenceSet();
        this.exclusiveTests = Object.create(null);
        this._typeCheck = void 0;
        this.spec = void 0;
        this.tests = [];
        this.transforms = [];
        this.withMutation(()=>{
            this.typeError($0d9a35220db777bc$var$mixed.notType);
        });
        this.type = options.type;
        this._typeCheck = options.check;
        this.spec = Object.assign({
            strip: false,
            strict: false,
            abortEarly: true,
            recursive: true,
            disableStackTrace: false,
            nullable: false,
            optional: true,
            coerce: true
        }, options == null ? void 0 : options.spec);
        this.withMutation((s)=>{
            s.nonNullable();
        });
    }
    // TODO: remove
    get _type() {
        return this.type;
    }
    clone(spec) {
        if (this._mutate) {
            if (spec) Object.assign(this.spec, spec);
            return this;
        }
        // if the nested value is a schema we can skip cloning, since
        // they are already immutable
        const next = Object.create(Object.getPrototypeOf(this));
        // @ts-expect-error this is readonly
        next.type = this.type;
        next._typeCheck = this._typeCheck;
        next._whitelist = this._whitelist.clone();
        next._blacklist = this._blacklist.clone();
        next.internalTests = Object.assign({}, this.internalTests);
        next.exclusiveTests = Object.assign({}, this.exclusiveTests);
        // @ts-expect-error this is readonly
        next.deps = [
            ...this.deps
        ];
        next.conditions = [
            ...this.conditions
        ];
        next.tests = [
            ...this.tests
        ];
        next.transforms = [
            ...this.transforms
        ];
        next.spec = $0d9a35220db777bc$var$clone(Object.assign({}, this.spec, spec));
        return next;
    }
    label(label) {
        let next = this.clone();
        next.spec.label = label;
        return next;
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
    withMutation(fn) {
        let before = this._mutate;
        this._mutate = true;
        let result = fn(this);
        this._mutate = before;
        return result;
    }
    concat(schema) {
        if (!schema || schema === this) return this;
        if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
        let base = this;
        let combined = schema.clone();
        const mergedSpec = Object.assign({}, base.spec, combined.spec);
        combined.spec = mergedSpec;
        combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);
        // manually merge the blacklist/whitelist (the other `schema` takes
        // precedence in case of conflicts)
        combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
        combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);
        // start with the current tests
        combined.tests = base.tests;
        combined.exclusiveTests = base.exclusiveTests;
        // manually add the new tests to ensure
        // the deduping logic is consistent
        combined.withMutation((next)=>{
            schema.tests.forEach((fn)=>{
                next.test(fn.OPTIONS);
            });
        });
        combined.transforms = [
            ...base.transforms,
            ...combined.transforms
        ];
        return combined;
    }
    isType(v) {
        if (v == null) {
            if (this.spec.nullable && v === null) return true;
            if (this.spec.optional && v === undefined) return true;
            return false;
        }
        return this._typeCheck(v);
    }
    resolve(options) {
        let schema = this;
        if (schema.conditions.length) {
            let conditions = schema.conditions;
            schema = schema.clone();
            schema.conditions = [];
            schema = conditions.reduce((prevSchema, condition)=>condition.resolve(prevSchema, options), schema);
            schema = schema.resolve(options);
        }
        return schema;
    }
    resolveOptions(options) {
        var _options$strict, _options$abortEarly, _options$recursive, _options$disableStack;
        return Object.assign({}, options, {
            from: options.from || [],
            strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
            abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
            recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive,
            disableStackTrace: (_options$disableStack = options.disableStackTrace) != null ? _options$disableStack : this.spec.disableStackTrace
        });
    }
    /**
   * Run the configured transform pipeline over an input value.
   */ cast(value, options = {}) {
        let resolvedSchema = this.resolve(Object.assign({
            value: value
        }, options));
        let allowOptionality = options.assert === 'ignore-optionality';
        let result = resolvedSchema._cast(value, options);
        if (options.assert !== false && !resolvedSchema.isType(result)) {
            if (allowOptionality && $0d9a35220db777bc$var$isAbsent(result)) return result;
            let formattedValue = $0d9a35220db777bc$export$5790025c6e6c2ba6(value);
            let formattedResult = $0d9a35220db777bc$export$5790025c6e6c2ba6(result);
            throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
        }
        return result;
    }
    _cast(rawValue, options) {
        let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn)=>fn.call(this, prevValue, rawValue, this), rawValue);
        if (value === undefined) value = this.getDefault(options);
        return value;
    }
    _validate(_value, options = {}, panic, next) {
        let { path: path, originalValue: originalValue = _value, strict: strict = this.spec.strict } = options;
        let value = _value;
        if (!strict) value = this._cast(value, Object.assign({
            assert: false
        }, options));
        let initialTests = [];
        for (let test of Object.values(this.internalTests))if (test) initialTests.push(test);
        this.runTests({
            path: path,
            value: value,
            originalValue: originalValue,
            options: options,
            tests: initialTests
        }, panic, (initialErrors)=>{
            // even if we aren't ending early we can't proceed further if the types aren't correct
            if (initialErrors.length) return next(initialErrors, value);
            this.runTests({
                path: path,
                value: value,
                originalValue: originalValue,
                options: options,
                tests: this.tests
            }, panic, next);
        });
    }
    /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */ runTests(runOptions, panic, next) {
        let fired = false;
        let { tests: tests, value: value, originalValue: originalValue, path: path, options: options } = runOptions;
        let panicOnce = (arg)=>{
            if (fired) return;
            fired = true;
            panic(arg, value);
        };
        let nextOnce = (arg)=>{
            if (fired) return;
            fired = true;
            next(arg, value);
        };
        let count = tests.length;
        let nestedErrors = [];
        if (!count) return nextOnce([]);
        let args = {
            value: value,
            originalValue: originalValue,
            path: path,
            options: options,
            schema: this
        };
        for(let i = 0; i < tests.length; i++){
            const test = tests[i];
            test(args, panicOnce, function finishTestRun(err) {
                if (err) Array.isArray(err) ? nestedErrors.push(...err) : nestedErrors.push(err);
                if (--count <= 0) nextOnce(nestedErrors);
            });
        }
    }
    asNestedTest({ key: key, index: index, parent: parent, parentPath: parentPath, originalParent: originalParent, options: options }) {
        const k = key != null ? key : index;
        if (k == null) throw TypeError('Must include `key` or `index` for nested validations');
        const isIndex = typeof k === 'number';
        let value = parent[k];
        const testOptions = Object.assign({}, options, {
            // Nested validations fields are always strict:
            //    1. parent isn't strict so the casting will also have cast inner values
            //    2. parent is strict in which case the nested values weren't cast either
            strict: true,
            parent: parent,
            value: value,
            originalValue: originalParent[k],
            // FIXME: tests depend on `index` being passed around deeply,
            //   we should not let the options.key/index bleed through
            key: undefined,
            // index: undefined,
            [isIndex ? 'index' : 'key']: k,
            path: isIndex || k.includes('.') ? `${parentPath || ''}[${isIndex ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
        });
        return (_, panic, next)=>this.resolve(testOptions)._validate(value, testOptions, panic, next);
    }
    validate(value, options) {
        var _options$disableStack2;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let disableStackTrace = (_options$disableStack2 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack2 : schema.spec.disableStackTrace;
        return new Promise((resolve, reject)=>schema._validate(value, options, (error, parsed)=>{
                if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
                reject(error);
            }, (errors, validated)=>{
                if (errors.length) reject(new $0d9a35220db777bc$export$2191b9da168c6cf0(errors, validated, undefined, undefined, disableStackTrace));
                else resolve(validated);
            }));
    }
    validateSync(value, options) {
        var _options$disableStack3;
        let schema = this.resolve(Object.assign({}, options, {
            value: value
        }));
        let result;
        let disableStackTrace = (_options$disableStack3 = options == null ? void 0 : options.disableStackTrace) != null ? _options$disableStack3 : schema.spec.disableStackTrace;
        schema._validate(value, Object.assign({}, options, {
            sync: true
        }), (error, parsed)=>{
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(error)) error.value = parsed;
            throw error;
        }, (errors, validated)=>{
            if (errors.length) throw new $0d9a35220db777bc$export$2191b9da168c6cf0(errors, value, undefined, undefined, disableStackTrace);
            result = validated;
        });
        return result;
    }
    isValid(value, options) {
        return this.validate(value, options).then(()=>true, (err)=>{
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        });
    }
    isValidSync(value, options) {
        try {
            this.validateSync(value, options);
            return true;
        } catch (err) {
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) return false;
            throw err;
        }
    }
    _getDefault(options) {
        let defaultValue = this.spec.default;
        if (defaultValue == null) return defaultValue;
        return typeof defaultValue === 'function' ? defaultValue.call(this, options) : $0d9a35220db777bc$var$clone(defaultValue);
    }
    getDefault(options) {
        let schema = this.resolve(options || {});
        return schema._getDefault(options);
    }
    default(def) {
        if (arguments.length === 0) return this._getDefault();
        let next = this.clone({
            default: def
        });
        return next;
    }
    strict(isStrict = true) {
        return this.clone({
            strict: isStrict
        });
    }
    nullability(nullable, message) {
        const next = this.clone({
            nullable: nullable
        });
        next.internalTests.nullable = $0d9a35220db777bc$var$createValidation({
            message: message,
            name: 'nullable',
            test (value) {
                return value === null ? this.schema.spec.nullable : true;
            }
        });
        return next;
    }
    optionality(optional, message) {
        const next = this.clone({
            optional: optional
        });
        next.internalTests.optionality = $0d9a35220db777bc$var$createValidation({
            message: message,
            name: 'optionality',
            test (value) {
                return value === undefined ? this.schema.spec.optional : true;
            }
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    defined(message = $0d9a35220db777bc$var$mixed.defined) {
        return this.optionality(false, message);
    }
    nullable() {
        return this.nullability(true);
    }
    nonNullable(message = $0d9a35220db777bc$var$mixed.notNull) {
        return this.nullability(false, message);
    }
    required(message = $0d9a35220db777bc$var$mixed.required) {
        return this.clone().withMutation((next)=>next.nonNullable(message).defined(message));
    }
    notRequired() {
        return this.clone().withMutation((next)=>next.nullable().optional());
    }
    transform(fn) {
        let next = this.clone();
        next.transforms.push(fn);
        return next;
    }
    /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */ test(...args) {
        let opts;
        if (args.length === 1) {
            if (typeof args[0] === 'function') opts = {
                test: args[0]
            };
            else opts = args[0];
        } else if (args.length === 2) opts = {
            name: args[0],
            test: args[1]
        };
        else opts = {
            name: args[0],
            message: args[1],
            test: args[2]
        };
        if (opts.message === undefined) opts.message = $0d9a35220db777bc$var$mixed.default;
        if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
        let next = this.clone();
        let validate = $0d9a35220db777bc$var$createValidation(opts);
        let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
        if (opts.exclusive) {
            if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
        }
        if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
        next.tests = next.tests.filter((fn)=>{
            if (fn.OPTIONS.name === opts.name) {
                if (isExclusive) return false;
                if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
            }
            return true;
        });
        next.tests.push(validate);
        return next;
    }
    when(keys, options) {
        if (!Array.isArray(keys) && typeof keys !== 'string') {
            options = keys;
            keys = '.';
        }
        let next = this.clone();
        let deps = $0d9a35220db777bc$var$toArray(keys).map((key)=>new $0d9a35220db777bc$var$Reference(key));
        deps.forEach((dep)=>{
            // @ts-ignore readonly array
            if (dep.isSibling) next.deps.push(dep.key);
        });
        next.conditions.push(typeof options === 'function' ? new $0d9a35220db777bc$var$Condition(deps, options) : $0d9a35220db777bc$var$Condition.fromOptions(deps, options));
        return next;
    }
    typeError(message) {
        let next = this.clone();
        next.internalTests.typeError = $0d9a35220db777bc$var$createValidation({
            message: message,
            name: 'typeError',
            skipAbsent: true,
            test (value) {
                if (!this.schema._typeCheck(value)) return this.createError({
                    params: {
                        type: this.schema.type
                    }
                });
                return true;
            }
        });
        return next;
    }
    oneOf(enums, message = $0d9a35220db777bc$var$mixed.oneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._whitelist.add(val);
            next._blacklist.delete(val);
        });
        next.internalTests.whiteList = $0d9a35220db777bc$var$createValidation({
            message: message,
            name: 'oneOf',
            skipAbsent: true,
            test (value) {
                let valids = this.schema._whitelist;
                let resolved = valids.resolveAll(this.resolve);
                return resolved.includes(value) ? true : this.createError({
                    params: {
                        values: Array.from(valids).join(', '),
                        resolved: resolved
                    }
                });
            }
        });
        return next;
    }
    notOneOf(enums, message = $0d9a35220db777bc$var$mixed.notOneOf) {
        let next = this.clone();
        enums.forEach((val)=>{
            next._blacklist.add(val);
            next._whitelist.delete(val);
        });
        next.internalTests.blacklist = $0d9a35220db777bc$var$createValidation({
            message: message,
            name: 'notOneOf',
            test (value) {
                let invalids = this.schema._blacklist;
                let resolved = invalids.resolveAll(this.resolve);
                if (resolved.includes(value)) return this.createError({
                    params: {
                        values: Array.from(invalids).join(', '),
                        resolved: resolved
                    }
                });
                return true;
            }
        });
        return next;
    }
    strip(strip = true) {
        let next = this.clone();
        next.spec.strip = strip;
        return next;
    }
    /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */ describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const { label: label, meta: meta, optional: optional, nullable: nullable } = next.spec;
        const description = {
            meta: meta,
            label: label,
            optional: optional,
            nullable: nullable,
            default: next.getDefault(options),
            type: next.type,
            oneOf: next._whitelist.describe(),
            notOneOf: next._blacklist.describe(),
            tests: next.tests.map((fn)=>({
                    name: fn.OPTIONS.name,
                    params: fn.OPTIONS.params
                })).filter((n, idx, list)=>list.findIndex((c)=>c.name === n.name) === idx)
        };
        return description;
    }
}
// @ts-expect-error
$0d9a35220db777bc$export$19342e026b58ebb7.prototype.__isYupSchema__ = true;
for (const method of [
    'validate',
    'validateSync'
])$0d9a35220db777bc$export$19342e026b58ebb7.prototype[`${method}At`] = function(path, value, options = {}) {
    const { parent: parent, parentPath: parentPath, schema: schema } = $0d9a35220db777bc$export$c52e5867d5879e24(this, path, value, options.context);
    return schema[method](parent && parent[parentPath], Object.assign({}, options, {
        parent: parent,
        path: path
    }));
};
for (const alias of [
    'equals',
    'is'
])$0d9a35220db777bc$export$19342e026b58ebb7.prototype[alias] = $0d9a35220db777bc$export$19342e026b58ebb7.prototype.oneOf;
for (const alias of [
    'not',
    'nope'
])$0d9a35220db777bc$export$19342e026b58ebb7.prototype[alias] = $0d9a35220db777bc$export$19342e026b58ebb7.prototype.notOneOf;
const $0d9a35220db777bc$var$returnsTrue = ()=>true;
function $0d9a35220db777bc$export$9b30b6294c1449a8(spec) {
    return new $0d9a35220db777bc$export$1e88358c94ddec71(spec);
}
class $0d9a35220db777bc$export$1e88358c94ddec71 extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(spec){
        super(typeof spec === 'function' ? {
            type: 'mixed',
            check: spec
        } : Object.assign({
            type: 'mixed',
            check: $0d9a35220db777bc$var$returnsTrue
        }, spec));
    }
}
$0d9a35220db777bc$export$9b30b6294c1449a8.prototype = $0d9a35220db777bc$export$1e88358c94ddec71.prototype;
function $0d9a35220db777bc$export$87b259aa03e3d267() {
    return new $0d9a35220db777bc$export$c7980688f11e1f49();
}
class $0d9a35220db777bc$export$c7980688f11e1f49 extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'boolean',
            check (v) {
                if (v instanceof Boolean) v = v.valueOf();
                return typeof v === 'boolean';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (ctx.spec.coerce && !ctx.isType(value)) {
                    if (/^(true|1)$/i.test(String(value))) return true;
                    if (/^(false|0)$/i.test(String(value))) return false;
                }
                return value;
            });
        });
    }
    isTrue(message = $0d9a35220db777bc$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'true'
            },
            test (value) {
                return $0d9a35220db777bc$var$isAbsent(value) || value === true;
            }
        });
    }
    isFalse(message = $0d9a35220db777bc$var$boolean.isValue) {
        return this.test({
            message: message,
            name: 'is-value',
            exclusive: true,
            params: {
                value: 'false'
            },
            test (value) {
                return $0d9a35220db777bc$var$isAbsent(value) || value === false;
            }
        });
    }
    default(def) {
        return super.default(def);
    }
    defined(msg) {
        return super.defined(msg);
    }
    optional() {
        return super.optional();
    }
    required(msg) {
        return super.required(msg);
    }
    notRequired() {
        return super.notRequired();
    }
    nullable() {
        return super.nullable();
    }
    nonNullable(msg) {
        return super.nonNullable(msg);
    }
    strip(v) {
        return super.strip(v);
    }
}
$0d9a35220db777bc$export$87b259aa03e3d267.prototype = $0d9a35220db777bc$export$c7980688f11e1f49.prototype;
/**
 * This file is a modified version of the file from the following repository:
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */ // prettier-ignore
//                1 YYYY                2 MM        3 DD              4 HH     5 mm        6 ss           7 msec         8 Z 9 ±   10 tzHH    11 tzmm
const $0d9a35220db777bc$var$isoReg = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,.](\d{1,}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function $0d9a35220db777bc$var$parseIsoDate(date) {
    const struct = $0d9a35220db777bc$var$parseDateStruct(date);
    if (!struct) return Date.parse ? Date.parse(date) : Number.NaN;
    // timestamps without timezone identifiers should be considered local time
    if (struct.z === undefined && struct.plusMinus === undefined) return new Date(struct.year, struct.month, struct.day, struct.hour, struct.minute, struct.second, struct.millisecond).valueOf();
    let totalMinutesOffset = 0;
    if (struct.z !== 'Z' && struct.plusMinus !== undefined) {
        totalMinutesOffset = struct.hourOffset * 60 + struct.minuteOffset;
        if (struct.plusMinus === '+') totalMinutesOffset = 0 - totalMinutesOffset;
    }
    return Date.UTC(struct.year, struct.month, struct.day, struct.hour, struct.minute + totalMinutesOffset, struct.second, struct.millisecond);
}
function $0d9a35220db777bc$var$parseDateStruct(date) {
    var _regexResult$7$length, _regexResult$;
    const regexResult = $0d9a35220db777bc$var$isoReg.exec(date);
    if (!regexResult) return null;
    // use of toNumber() avoids NaN timestamps caused by “undefined”
    // values being passed to Date constructor
    return {
        year: $0d9a35220db777bc$var$toNumber(regexResult[1]),
        month: $0d9a35220db777bc$var$toNumber(regexResult[2], 1) - 1,
        day: $0d9a35220db777bc$var$toNumber(regexResult[3], 1),
        hour: $0d9a35220db777bc$var$toNumber(regexResult[4]),
        minute: $0d9a35220db777bc$var$toNumber(regexResult[5]),
        second: $0d9a35220db777bc$var$toNumber(regexResult[6]),
        millisecond: regexResult[7] ? // allow arbitrary sub-second precision beyond milliseconds
        $0d9a35220db777bc$var$toNumber(regexResult[7].substring(0, 3)) : 0,
        precision: (_regexResult$7$length = (_regexResult$ = regexResult[7]) == null ? void 0 : _regexResult$.length) != null ? _regexResult$7$length : undefined,
        z: regexResult[8] || undefined,
        plusMinus: regexResult[9] || undefined,
        hourOffset: $0d9a35220db777bc$var$toNumber(regexResult[10]),
        minuteOffset: $0d9a35220db777bc$var$toNumber(regexResult[11])
    };
}
function $0d9a35220db777bc$var$toNumber(str, defaultValue = 0) {
    return Number(str) || defaultValue;
}
// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let $0d9a35220db777bc$var$rEmail = // eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let $0d9a35220db777bc$var$rUrl = // eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
// eslint-disable-next-line
let $0d9a35220db777bc$var$rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let $0d9a35220db777bc$var$yearMonthDay = '^\\d{4}-\\d{2}-\\d{2}';
let $0d9a35220db777bc$var$hourMinuteSecond = '\\d{2}:\\d{2}:\\d{2}';
let $0d9a35220db777bc$var$zOrOffset = '(([+-]\\d{2}(:?\\d{2})?)|Z)';
let $0d9a35220db777bc$var$rIsoDateTime = new RegExp(`${$0d9a35220db777bc$var$yearMonthDay}T${$0d9a35220db777bc$var$hourMinuteSecond}(\\.\\d+)?${$0d9a35220db777bc$var$zOrOffset}$`);
let $0d9a35220db777bc$var$isTrimmed = (value)=>$0d9a35220db777bc$var$isAbsent(value) || value === value.trim();
let $0d9a35220db777bc$var$objStringTag = ({}).toString();
function $0d9a35220db777bc$export$22b082955e083ec3() {
    return new $0d9a35220db777bc$export$49bf8b2ede5138eb();
}
class $0d9a35220db777bc$export$49bf8b2ede5138eb extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'string',
            check (value) {
                if (value instanceof String) value = value.valueOf();
                return typeof value === 'string';
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce || ctx.isType(value)) return value;
                // don't ever convert arrays
                if (Array.isArray(value)) return value;
                const strValue = value != null && value.toString ? value.toString() : value;
                // no one wants plain objects converted to [Object object]
                if (strValue === $0d9a35220db777bc$var$objStringTag) return value;
                return strValue;
            });
        });
    }
    required(message) {
        return super.required(message).withMutation((schema)=>schema.test({
                message: message || $0d9a35220db777bc$var$mixed.required,
                name: 'required',
                skipAbsent: true,
                test: (value)=>!!value.length
            }));
    }
    notRequired() {
        return super.notRequired().withMutation((schema)=>{
            schema.tests = schema.tests.filter((t)=>t.OPTIONS.name !== 'required');
            return schema;
        });
    }
    length(length, message = $0d9a35220db777bc$var$string.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message = $0d9a35220db777bc$var$string.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message = $0d9a35220db777bc$var$string.max) {
        return this.test({
            name: 'max',
            exclusive: true,
            message: message,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    matches(regex, options) {
        let excludeEmptyString = false;
        let message;
        let name;
        if (options) {
            if (typeof options === 'object') ({ excludeEmptyString: excludeEmptyString = false, message: message, name: name } = options);
            else message = options;
        }
        return this.test({
            name: name || 'matches',
            message: message || $0d9a35220db777bc$var$string.matches,
            params: {
                regex: regex
            },
            skipAbsent: true,
            test: (value)=>value === '' && excludeEmptyString || value.search(regex) !== -1
        });
    }
    email(message = $0d9a35220db777bc$var$string.email) {
        return this.matches($0d9a35220db777bc$var$rEmail, {
            name: 'email',
            message: message,
            excludeEmptyString: true
        });
    }
    url(message = $0d9a35220db777bc$var$string.url) {
        return this.matches($0d9a35220db777bc$var$rUrl, {
            name: 'url',
            message: message,
            excludeEmptyString: true
        });
    }
    uuid(message = $0d9a35220db777bc$var$string.uuid) {
        return this.matches($0d9a35220db777bc$var$rUUID, {
            name: 'uuid',
            message: message,
            excludeEmptyString: false
        });
    }
    datetime(options) {
        let message = '';
        let allowOffset;
        let precision;
        if (options) {
            if (typeof options === 'object') ({ message: message = '', allowOffset: allowOffset = false, precision: precision } = options);
            else message = options;
        }
        return this.matches($0d9a35220db777bc$var$rIsoDateTime, {
            name: 'datetime',
            message: message || $0d9a35220db777bc$var$string.datetime,
            excludeEmptyString: true
        }).test({
            name: 'datetime_offset',
            message: message || $0d9a35220db777bc$var$string.datetime_offset,
            params: {
                allowOffset: allowOffset
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || allowOffset) return true;
                const struct = $0d9a35220db777bc$var$parseDateStruct(value);
                if (!struct) return false;
                return !!struct.z;
            }
        }).test({
            name: 'datetime_precision',
            message: message || $0d9a35220db777bc$var$string.datetime_precision,
            params: {
                precision: precision
            },
            skipAbsent: true,
            test: (value)=>{
                if (!value || precision == undefined) return true;
                const struct = $0d9a35220db777bc$var$parseDateStruct(value);
                if (!struct) return false;
                return struct.precision === precision;
            }
        });
    }
    //-- transforms --
    ensure() {
        return this.default('').transform((val)=>val === null ? '' : val);
    }
    trim(message = $0d9a35220db777bc$var$string.trim) {
        return this.transform((val)=>val != null ? val.trim() : val).test({
            message: message,
            name: 'trim',
            test: $0d9a35220db777bc$var$isTrimmed
        });
    }
    lowercase(message = $0d9a35220db777bc$var$string.lowercase) {
        return this.transform((value)=>!$0d9a35220db777bc$var$isAbsent(value) ? value.toLowerCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$0d9a35220db777bc$var$isAbsent(value) || value === value.toLowerCase()
        });
    }
    uppercase(message = $0d9a35220db777bc$var$string.uppercase) {
        return this.transform((value)=>!$0d9a35220db777bc$var$isAbsent(value) ? value.toUpperCase() : value).test({
            message: message,
            name: 'string_case',
            exclusive: true,
            skipAbsent: true,
            test: (value)=>$0d9a35220db777bc$var$isAbsent(value) || value === value.toUpperCase()
        });
    }
}
$0d9a35220db777bc$export$22b082955e083ec3.prototype = $0d9a35220db777bc$export$49bf8b2ede5138eb.prototype;
//
// String Interfaces
//
let $0d9a35220db777bc$var$isNaN$1 = (value)=>value != +value;
function $0d9a35220db777bc$export$98e628dec113755e() {
    return new $0d9a35220db777bc$export$f192ec5e9228ab19();
}
class $0d9a35220db777bc$export$f192ec5e9228ab19 extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'number',
            check (value) {
                if (value instanceof Number) value = value.valueOf();
                return typeof value === 'number' && !$0d9a35220db777bc$var$isNaN$1(value);
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                if (!ctx.spec.coerce) return value;
                let parsed = value;
                if (typeof parsed === 'string') {
                    parsed = parsed.replace(/\s/g, '');
                    if (parsed === '') return NaN;
                    // don't use parseFloat to avoid positives on alpha-numeric strings
                    parsed = +parsed;
                }
                // null -> NaN isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (ctx.isType(parsed) || parsed === null) return parsed;
                return parseFloat(parsed);
            });
        });
    }
    min(min, message = $0d9a35220db777bc$var$number.min) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(min);
            }
        });
    }
    max(max, message = $0d9a35220db777bc$var$number.max) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(max);
            }
        });
    }
    lessThan(less, message = $0d9a35220db777bc$var$number.lessThan) {
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                less: less
            },
            skipAbsent: true,
            test (value) {
                return value < this.resolve(less);
            }
        });
    }
    moreThan(more, message = $0d9a35220db777bc$var$number.moreThan) {
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                more: more
            },
            skipAbsent: true,
            test (value) {
                return value > this.resolve(more);
            }
        });
    }
    positive(msg = $0d9a35220db777bc$var$number.positive) {
        return this.moreThan(0, msg);
    }
    negative(msg = $0d9a35220db777bc$var$number.negative) {
        return this.lessThan(0, msg);
    }
    integer(message = $0d9a35220db777bc$var$number.integer) {
        return this.test({
            name: 'integer',
            message: message,
            skipAbsent: true,
            test: (val)=>Number.isInteger(val)
        });
    }
    truncate() {
        return this.transform((value)=>!$0d9a35220db777bc$var$isAbsent(value) ? value | 0 : value);
    }
    round(method) {
        var _method;
        let avail = [
            'ceil',
            'floor',
            'round',
            'trunc'
        ];
        method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';
        // this exists for symemtry with the new Math.trunc
        if (method === 'trunc') return this.truncate();
        if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
        return this.transform((value)=>!$0d9a35220db777bc$var$isAbsent(value) ? Math[method](value) : value);
    }
}
$0d9a35220db777bc$export$98e628dec113755e.prototype = $0d9a35220db777bc$export$f192ec5e9228ab19.prototype;
//
// Number Interfaces
//
let $0d9a35220db777bc$var$invalidDate = new Date('');
let $0d9a35220db777bc$var$isDate = (obj)=>Object.prototype.toString.call(obj) === '[object Date]';
function $0d9a35220db777bc$export$324d90190a8b822a() {
    return new $0d9a35220db777bc$export$18ec3cc5a157503f();
}
class $0d9a35220db777bc$export$18ec3cc5a157503f extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(){
        super({
            type: 'date',
            check (v) {
                return $0d9a35220db777bc$var$isDate(v) && !isNaN(v.getTime());
            }
        });
        this.withMutation(()=>{
            this.transform((value, _raw, ctx)=>{
                // null -> InvalidDate isn't useful; treat all nulls as null and let it fail on
                // nullability check vs TypeErrors
                if (!ctx.spec.coerce || ctx.isType(value) || value === null) return value;
                value = $0d9a35220db777bc$var$parseIsoDate(value);
                // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
                return !isNaN(value) ? new Date(value) : $0d9a35220db777bc$export$18ec3cc5a157503f.INVALID_DATE;
            });
        });
    }
    prepareParam(ref, name) {
        let param;
        if (!$0d9a35220db777bc$var$Reference.isRef(ref)) {
            let cast = this.cast(ref);
            if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
            param = cast;
        } else param = ref;
        return param;
    }
    min(min, message = $0d9a35220db777bc$var$date.min) {
        let limit = this.prepareParam(min, 'min');
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            test (value) {
                return value >= this.resolve(limit);
            }
        });
    }
    max(max, message = $0d9a35220db777bc$var$date.max) {
        let limit = this.prepareParam(max, 'max');
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value <= this.resolve(limit);
            }
        });
    }
}
$0d9a35220db777bc$export$18ec3cc5a157503f.INVALID_DATE = $0d9a35220db777bc$var$invalidDate;
$0d9a35220db777bc$export$324d90190a8b822a.prototype = $0d9a35220db777bc$export$18ec3cc5a157503f.prototype;
$0d9a35220db777bc$export$324d90190a8b822a.INVALID_DATE = $0d9a35220db777bc$var$invalidDate;
// @ts-expect-error
function $0d9a35220db777bc$var$sortFields(fields, excludedEdges = []) {
    let edges = [];
    let nodes = new Set();
    let excludes = new Set(excludedEdges.map(([a, b])=>`${a}-${b}`));
    function addNode(depPath, key) {
        let node = (0, $e777121d3fc9ac6f$exports.split)(depPath)[0];
        nodes.add(node);
        if (!excludes.has(`${key}-${node}`)) edges.push([
            key,
            node
        ]);
    }
    for (const key of Object.keys(fields)){
        let value = fields[key];
        nodes.add(key);
        if ($0d9a35220db777bc$var$Reference.isRef(value) && value.isSibling) addNode(value.path, key);
        else if ($0d9a35220db777bc$export$213e2a3e7c4f326e(value) && 'deps' in value) value.deps.forEach((path)=>addNode(path, key));
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($e8af384fb65a728e$exports))).array(Array.from(nodes), edges).reverse();
}
function $0d9a35220db777bc$var$findIndex(arr, err) {
    let idx = Infinity;
    arr.some((key, ii)=>{
        var _err$path;
        if ((_err$path = err.path) != null && _err$path.includes(key)) {
            idx = ii;
            return true;
        }
    });
    return idx;
}
function $0d9a35220db777bc$var$sortByKeyOrder(keys) {
    return (a, b)=>{
        return $0d9a35220db777bc$var$findIndex(keys, a) - $0d9a35220db777bc$var$findIndex(keys, b);
    };
}
const $0d9a35220db777bc$var$parseJson = (value, _, ctx)=>{
    if (typeof value !== 'string') return value;
    let parsed = value;
    try {
        parsed = JSON.parse(value);
    } catch (err) {
    /* */ }
    return ctx.isType(parsed) ? parsed : value;
};
// @ts-ignore
function $0d9a35220db777bc$var$deepPartial(schema) {
    if ('fields' in schema) {
        const partial = {};
        for (const [key, fieldSchema] of Object.entries(schema.fields))partial[key] = $0d9a35220db777bc$var$deepPartial(fieldSchema);
        return schema.setFields(partial);
    }
    if (schema.type === 'array') {
        const nextArray = schema.optional();
        if (nextArray.innerType) nextArray.innerType = $0d9a35220db777bc$var$deepPartial(nextArray.innerType);
        return nextArray;
    }
    if (schema.type === 'tuple') return schema.optional().clone({
        types: schema.spec.types.map($0d9a35220db777bc$var$deepPartial)
    });
    if ('optional' in schema) return schema.optional();
    return schema;
}
const $0d9a35220db777bc$var$deepHas = (obj, p)=>{
    const path = [
        ...(0, $e777121d3fc9ac6f$exports.normalizePath)(p)
    ];
    if (path.length === 1) return path[0] in obj;
    let last = path.pop();
    let parent = (0, $e777121d3fc9ac6f$exports.getter)((0, $e777121d3fc9ac6f$exports.join)(path), true)(obj);
    return !!(parent && last in parent);
};
let $0d9a35220db777bc$var$isObject = (obj)=>Object.prototype.toString.call(obj) === '[object Object]';
function $0d9a35220db777bc$var$unknown(ctx, value) {
    let known = Object.keys(ctx.fields);
    return Object.keys(value).filter((key)=>known.indexOf(key) === -1);
}
const $0d9a35220db777bc$var$defaultSort = $0d9a35220db777bc$var$sortByKeyOrder([]);
function $0d9a35220db777bc$export$be5493f9613cbbe(spec) {
    return new $0d9a35220db777bc$export$18b4fc70ec7eccf8(spec);
}
class $0d9a35220db777bc$export$18b4fc70ec7eccf8 extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(spec){
        super({
            type: 'object',
            check (value) {
                return $0d9a35220db777bc$var$isObject(value) || typeof value === 'function';
            }
        });
        this.fields = Object.create(null);
        this._sortErrors = $0d9a35220db777bc$var$defaultSort;
        this._nodes = [];
        this._excludedEdges = [];
        this.withMutation(()=>{
            if (spec) this.shape(spec);
        });
    }
    _cast(_value, options = {}) {
        var _options$stripUnknown;
        let value = super._cast(_value, options);
        //should ignore nulls here
        if (value === undefined) return this.getDefault(options);
        if (!this._typeCheck(value)) return value;
        let fields = this.fields;
        let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
        let props = [].concat(this._nodes, Object.keys(value).filter((v)=>!this._nodes.includes(v)));
        let intermediateValue = {}; // is filled during the transform below
        let innerOptions = Object.assign({}, options, {
            parent: intermediateValue,
            __validating: options.__validating || false
        });
        let isChanged = false;
        for (const prop of props){
            let field = fields[prop];
            let exists = prop in value;
            if (field) {
                let fieldValue;
                let inputValue = value[prop];
                // safe to mutate since this is fired in sequence
                innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
                field = field.resolve({
                    value: inputValue,
                    context: options.context,
                    parent: intermediateValue
                });
                let fieldSpec = field instanceof $0d9a35220db777bc$export$19342e026b58ebb7 ? field.spec : undefined;
                let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
                if (fieldSpec != null && fieldSpec.strip) {
                    isChanged = isChanged || prop in value;
                    continue;
                }
                fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
                field.cast(value[prop], innerOptions) : value[prop];
                if (fieldValue !== undefined) intermediateValue[prop] = fieldValue;
            } else if (exists && !strip) intermediateValue[prop] = value[prop];
            if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) isChanged = true;
        }
        return isChanged ? intermediateValue : value;
    }
    _validate(_value, options = {}, panic, next) {
        let { from: from = [], originalValue: originalValue = _value, recursive: recursive = this.spec.recursive } = options;
        options.from = [
            {
                schema: this,
                value: originalValue
            },
            ...from
        ];
        // this flag is needed for handling `strict` correctly in the context of
        // validation vs just casting. e.g strict() on a field is only used when validating
        options.__validating = true;
        options.originalValue = originalValue;
        super._validate(_value, options, panic, (objectErrors, value)=>{
            if (!recursive || !$0d9a35220db777bc$var$isObject(value)) {
                next(objectErrors, value);
                return;
            }
            originalValue = originalValue || value;
            let tests = [];
            for (let key of this._nodes){
                let field = this.fields[key];
                if (!field || $0d9a35220db777bc$var$Reference.isRef(field)) continue;
                tests.push(field.asNestedTest({
                    options: options,
                    key: key,
                    parent: value,
                    parentPath: options.path,
                    originalParent: originalValue
                }));
            }
            this.runTests({
                tests: tests,
                value: value,
                originalValue: originalValue,
                options: options
            }, panic, (fieldErrors)=>{
                next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
            });
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        next.fields = Object.assign({}, this.fields);
        next._nodes = this._nodes;
        next._excludedEdges = this._excludedEdges;
        next._sortErrors = this._sortErrors;
        return next;
    }
    concat(schema) {
        let next = super.concat(schema);
        let nextFields = next.fields;
        for (let [field, schemaOrRef] of Object.entries(this.fields)){
            const target = nextFields[field];
            nextFields[field] = target === undefined ? schemaOrRef : target;
        }
        return next.withMutation((s)=>// XXX: excludes here is wrong
            s.setFields(nextFields, [
                ...this._excludedEdges,
                ...schema._excludedEdges
            ]));
    }
    _getDefault(options) {
        if ('default' in this.spec) return super._getDefault(options);
        // if there is no default set invent one
        if (!this._nodes.length) return undefined;
        let dft = {};
        this._nodes.forEach((key)=>{
            var _innerOptions;
            const field = this.fields[key];
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            dft[key] = field && 'getDefault' in field ? field.getDefault(innerOptions) : undefined;
        });
        return dft;
    }
    setFields(shape, excludedEdges) {
        let next = this.clone();
        next.fields = shape;
        next._nodes = $0d9a35220db777bc$var$sortFields(shape, excludedEdges);
        next._sortErrors = $0d9a35220db777bc$var$sortByKeyOrder(Object.keys(shape));
        // XXX: this carries over edges which may not be what you want
        if (excludedEdges) next._excludedEdges = excludedEdges;
        return next;
    }
    shape(additions, excludes = []) {
        return this.clone().withMutation((next)=>{
            let edges = next._excludedEdges;
            if (excludes.length) {
                if (!Array.isArray(excludes[0])) excludes = [
                    excludes
                ];
                edges = [
                    ...next._excludedEdges,
                    ...excludes
                ];
            }
            // XXX: excludes here is wrong
            return next.setFields(Object.assign(next.fields, additions), edges);
        });
    }
    partial() {
        const partial = {};
        for (const [key, schema] of Object.entries(this.fields))partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
        return this.setFields(partial);
    }
    deepPartial() {
        const next = $0d9a35220db777bc$var$deepPartial(this);
        return next;
    }
    pick(keys) {
        const picked = {};
        for (const key of keys)if (this.fields[key]) picked[key] = this.fields[key];
        return this.setFields(picked, this._excludedEdges.filter(([a, b])=>keys.includes(a) && keys.includes(b)));
    }
    omit(keys) {
        const remaining = [];
        for (const key of Object.keys(this.fields)){
            if (keys.includes(key)) continue;
            remaining.push(key);
        }
        return this.pick(remaining);
    }
    from(from, to, alias) {
        let fromGetter = (0, $e777121d3fc9ac6f$exports.getter)(from, true);
        return this.transform((obj)=>{
            if (!obj) return obj;
            let newObj = obj;
            if ($0d9a35220db777bc$var$deepHas(obj, from)) {
                newObj = Object.assign({}, obj);
                if (!alias) delete newObj[from];
                newObj[to] = fromGetter(obj);
            }
            return newObj;
        });
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($0d9a35220db777bc$var$parseJson);
    }
    /**
   * Similar to `noUnknown` but only validates that an object is the right shape without stripping the unknown keys
   */ exact(message) {
        return this.test({
            name: 'exact',
            exclusive: true,
            message: message || $0d9a35220db777bc$var$object.exact,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $0d9a35220db777bc$var$unknown(this.schema, value);
                return unknownKeys.length === 0 || this.createError({
                    params: {
                        properties: unknownKeys.join(', ')
                    }
                });
            }
        });
    }
    stripUnknown() {
        return this.clone({
            noUnknown: true
        });
    }
    noUnknown(noAllow = true, message = $0d9a35220db777bc$var$object.noUnknown) {
        if (typeof noAllow !== 'boolean') {
            message = noAllow;
            noAllow = true;
        }
        let next = this.test({
            name: 'noUnknown',
            exclusive: true,
            message: message,
            test (value) {
                if (value == null) return true;
                const unknownKeys = $0d9a35220db777bc$var$unknown(this.schema, value);
                return !noAllow || unknownKeys.length === 0 || this.createError({
                    params: {
                        unknown: unknownKeys.join(', ')
                    }
                });
            }
        });
        next.spec.noUnknown = noAllow;
        return next;
    }
    unknown(allow = true, message = $0d9a35220db777bc$var$object.noUnknown) {
        return this.noUnknown(!allow, message);
    }
    transformKeys(fn) {
        return this.transform((obj)=>{
            if (!obj) return obj;
            const result = {};
            for (const key of Object.keys(obj))result[fn(key)] = obj[key];
            return result;
        });
    }
    camelCase() {
        return this.transformKeys((0, $f445cff46cb04123$exports.camelCase));
    }
    snakeCase() {
        return this.transformKeys((0, $f445cff46cb04123$exports.snakeCase));
    }
    constantCase() {
        return this.transformKeys((key)=>(0, $f445cff46cb04123$exports.snakeCase)(key).toUpperCase());
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.fields = {};
        for (const [key, value] of Object.entries(next.fields)){
            var _innerOptions2;
            let innerOptions = options;
            if ((_innerOptions2 = innerOptions) != null && _innerOptions2.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[key]
            });
            base.fields[key] = value.describe(innerOptions);
        }
        return base;
    }
}
$0d9a35220db777bc$export$be5493f9613cbbe.prototype = $0d9a35220db777bc$export$18b4fc70ec7eccf8.prototype;
function $0d9a35220db777bc$export$2f23118c22fb2630(type) {
    return new $0d9a35220db777bc$export$4347112b8447a7d(type);
}
class $0d9a35220db777bc$export$4347112b8447a7d extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(type){
        super({
            type: 'array',
            spec: {
                types: type
            },
            check (v) {
                return Array.isArray(v);
            }
        });
        // `undefined` specifically means uninitialized, as opposed to "no subtype"
        this.innerType = void 0;
        this.innerType = type;
    }
    _cast(_value, _opts) {
        const value = super._cast(_value, _opts);
        // should ignore nulls here
        if (!this._typeCheck(value) || !this.innerType) return value;
        let isChanged = false;
        const castArray = value.map((v, idx)=>{
            const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
                path: `${_opts.path || ''}[${idx}]`
            }));
            if (castElement !== v) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        var _options$recursive;
        // let sync = options.sync;
        // let path = options.path;
        let innerType = this.innerType;
        // let endEarly = options.abortEarly ?? this.spec.abortEarly;
        let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
        options.originalValue != null ? options.originalValue : _value;
        super._validate(_value, options, panic, (arrayErrors, value)=>{
            var _options$originalValu2;
            if (!recursive || !innerType || !this._typeCheck(value)) {
                next(arrayErrors, value);
                return;
            }
            // #950 Ensure that sparse array empty slots are validated
            let tests = new Array(value.length);
            for(let index = 0; index < value.length; index++){
                var _options$originalValu;
                tests[index] = innerType.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(arrayErrors), value));
        });
    }
    clone(spec) {
        const next = super.clone(spec);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        return next;
    }
    /** Parse an input JSON string to an object */ json() {
        return this.transform($0d9a35220db777bc$var$parseJson);
    }
    concat(schema) {
        let next = super.concat(schema);
        // @ts-expect-error readonly
        next.innerType = this.innerType;
        if (schema.innerType) // @ts-expect-error readonly
        next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat and will break
        next.innerType.concat(schema.innerType) : schema.innerType;
        return next;
    }
    of(schema) {
        // FIXME: this should return a new instance of array without the default to be
        let next = this.clone();
        if (!$0d9a35220db777bc$export$213e2a3e7c4f326e(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + $0d9a35220db777bc$export$5790025c6e6c2ba6(schema));
        // @ts-expect-error readonly
        next.innerType = schema;
        next.spec = Object.assign({}, next.spec, {
            types: schema
        });
        return next;
    }
    length(length, message = $0d9a35220db777bc$var$array.length) {
        return this.test({
            message: message,
            name: 'length',
            exclusive: true,
            params: {
                length: length
            },
            skipAbsent: true,
            test (value) {
                return value.length === this.resolve(length);
            }
        });
    }
    min(min, message) {
        message = message || $0d9a35220db777bc$var$array.min;
        return this.test({
            message: message,
            name: 'min',
            exclusive: true,
            params: {
                min: min
            },
            skipAbsent: true,
            // FIXME(ts): Array<typeof T>
            test (value) {
                return value.length >= this.resolve(min);
            }
        });
    }
    max(max, message) {
        message = message || $0d9a35220db777bc$var$array.max;
        return this.test({
            message: message,
            name: 'max',
            exclusive: true,
            params: {
                max: max
            },
            skipAbsent: true,
            test (value) {
                return value.length <= this.resolve(max);
            }
        });
    }
    ensure() {
        return this.default(()=>[]).transform((val, original)=>{
            // We don't want to return `null` for nullable schema
            if (this._typeCheck(val)) return val;
            return original == null ? [] : [].concat(original);
        });
    }
    compact(rejector) {
        let reject = !rejector ? (v)=>!!v : (v, i, a)=>!rejector(v, i, a);
        return this.transform((values)=>values != null ? values.filter(reject) : values);
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        if (next.innerType) {
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[0]
            });
            base.innerType = next.innerType.describe(innerOptions);
        }
        return base;
    }
}
$0d9a35220db777bc$export$2f23118c22fb2630.prototype = $0d9a35220db777bc$export$4347112b8447a7d.prototype;
// @ts-ignore
function $0d9a35220db777bc$export$65e3907585753458(schemas) {
    return new $0d9a35220db777bc$export$411c3b3687e8ecc8(schemas);
}
class $0d9a35220db777bc$export$411c3b3687e8ecc8 extends $0d9a35220db777bc$export$19342e026b58ebb7 {
    constructor(schemas){
        super({
            type: 'tuple',
            spec: {
                types: schemas
            },
            check (v) {
                const types = this.spec.types;
                return Array.isArray(v) && v.length === types.length;
            }
        });
        this.withMutation(()=>{
            this.typeError($0d9a35220db777bc$var$tuple.notType);
        });
    }
    _cast(inputValue, options) {
        const { types: types } = this.spec;
        const value = super._cast(inputValue, options);
        if (!this._typeCheck(value)) return value;
        let isChanged = false;
        const castArray = types.map((type, idx)=>{
            const castElement = type.cast(value[idx], Object.assign({}, options, {
                path: `${options.path || ''}[${idx}]`
            }));
            if (castElement !== value[idx]) isChanged = true;
            return castElement;
        });
        return isChanged ? castArray : value;
    }
    _validate(_value, options = {}, panic, next) {
        let itemTypes = this.spec.types;
        super._validate(_value, options, panic, (tupleErrors, value)=>{
            var _options$originalValu2;
            // intentionally not respecting recursive
            if (!this._typeCheck(value)) {
                next(tupleErrors, value);
                return;
            }
            let tests = [];
            for (let [index, itemSchema] of itemTypes.entries()){
                var _options$originalValu;
                tests[index] = itemSchema.asNestedTest({
                    options: options,
                    index: index,
                    parent: value,
                    parentPath: options.path,
                    originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
                });
            }
            this.runTests({
                value: value,
                tests: tests,
                originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
                options: options
            }, panic, (innerTypeErrors)=>next(innerTypeErrors.concat(tupleErrors), value));
        });
    }
    describe(options) {
        const next = (options ? this.resolve(options) : this).clone();
        const base = super.describe(options);
        base.innerType = next.spec.types.map((schema, index)=>{
            var _innerOptions;
            let innerOptions = options;
            if ((_innerOptions = innerOptions) != null && _innerOptions.value) innerOptions = Object.assign({}, innerOptions, {
                parent: innerOptions.value,
                value: innerOptions.value[index]
            });
            return schema.describe(innerOptions);
        });
        return base;
    }
}
$0d9a35220db777bc$export$65e3907585753458.prototype = $0d9a35220db777bc$export$411c3b3687e8ecc8.prototype;
function $0d9a35220db777bc$export$488013bae63b21da(builder) {
    return new $0d9a35220db777bc$export$71117d144d3091c9(builder);
}
function $0d9a35220db777bc$var$catchValidationError(fn) {
    try {
        return fn();
    } catch (err) {
        if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) return Promise.reject(err);
        throw err;
    }
}
class $0d9a35220db777bc$export$71117d144d3091c9 {
    constructor(builder){
        this.type = 'lazy';
        this.__isYupSchema__ = true;
        this.spec = void 0;
        this._resolve = (value, options = {})=>{
            let schema = this.builder(value, options);
            if (!$0d9a35220db777bc$export$213e2a3e7c4f326e(schema)) throw new TypeError('lazy() functions must return a valid schema');
            if (this.spec.optional) schema = schema.optional();
            return schema.resolve(options);
        };
        this.builder = builder;
        this.spec = {
            meta: undefined,
            optional: false
        };
    }
    clone(spec) {
        const next = new $0d9a35220db777bc$export$71117d144d3091c9(this.builder);
        next.spec = Object.assign({}, this.spec, spec);
        return next;
    }
    optionality(optional) {
        const next = this.clone({
            optional: optional
        });
        return next;
    }
    optional() {
        return this.optionality(true);
    }
    resolve(options) {
        return this._resolve(options.value, options);
    }
    cast(value, options) {
        return this._resolve(value, options).cast(value, options);
    }
    asNestedTest(config) {
        let { key: key, index: index, parent: parent, options: options } = config;
        let value = parent[index != null ? index : key];
        return this._resolve(value, Object.assign({}, options, {
            value: value,
            parent: parent
        })).asNestedTest(config);
    }
    validate(value, options) {
        return $0d9a35220db777bc$var$catchValidationError(()=>this._resolve(value, options).validate(value, options));
    }
    validateSync(value, options) {
        return this._resolve(value, options).validateSync(value, options);
    }
    validateAt(path, value, options) {
        return $0d9a35220db777bc$var$catchValidationError(()=>this._resolve(value, options).validateAt(path, value, options));
    }
    validateSyncAt(path, value, options) {
        return this._resolve(value, options).validateSyncAt(path, value, options);
    }
    isValid(value, options) {
        try {
            return this._resolve(value, options).isValid(value, options);
        } catch (err) {
            if ($0d9a35220db777bc$export$2191b9da168c6cf0.isError(err)) return Promise.resolve(false);
            throw err;
        }
    }
    isValidSync(value, options) {
        return this._resolve(value, options).isValidSync(value, options);
    }
    describe(options) {
        return options ? this.resolve(options).describe(options) : {
            type: 'lazy',
            meta: this.spec.meta,
            label: undefined
        };
    }
    meta(...args) {
        if (args.length === 0) return this.spec.meta;
        let next = this.clone();
        next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
        return next;
    }
}
function $0d9a35220db777bc$export$c8aadf3621e41efb(custom) {
    Object.keys(custom).forEach((type)=>{
        // @ts-ignore
        Object.keys(custom[type]).forEach((method)=>{
            // @ts-ignore
            $0d9a35220db777bc$export$d7f512c98c859244[type][method] = custom[type][method];
        });
    });
}
function $0d9a35220db777bc$export$20be359f745f973c(schemaType, name, fn) {
    if (!schemaType || !$0d9a35220db777bc$export$213e2a3e7c4f326e(schemaType.prototype)) throw new TypeError('You must provide a yup schema constructor function');
    if (typeof name !== 'string') throw new TypeError('A Method name must be provided');
    if (typeof fn !== 'function') throw new TypeError('Method function must be provided');
    schemaType.prototype[name] = fn;
}



(0, $0d9a35220db777bc$export$20be359f745f973c)((0, $0d9a35220db777bc$export$19342e026b58ebb7), 'validatePrefixRequestWithRegistryEndpoint', function() {
    return this.test('validatePrefixRequestWithRegistryEndpoint', "Rejected by endpoint - contact support via feedback button", async function(value, textContext) {
        if (value) {
            let attributeToValidate, otherValues;
            if (this.path in (0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)) {
                attributeToValidate = this.path;
                otherValues = this.parent;
            } else {
                attributeToValidate = textContext.options.context.attr;
                otherValues = textContext.options.context.otherValues;
            }
            try {
                const response = await (0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[attributeToValidate](value, otherValues, "prefix");
                return response.valid ? true : this.createError({
                    message: response.errorMessage
                });
            } catch (e) {
                console.error(this, e);
                return false;
            }
        } else return true;
    });
});
const $cec0a1ffceed72c5$var$isRegexValid = async (value)=>{
    try {
        new RegExp(value);
    } catch  {
        return false;
    }
    return true;
};
const $cec0a1ffceed72c5$var$PrefixRegistrationRequestSchema = (0, $0d9a35220db777bc$export$be5493f9613cbbe)({
    name: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Name").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    description: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Description").required().min(50).validatePrefixRequestWithRegistryEndpoint(),
    additionalInformation: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Additional information").notRequired().validatePrefixRequestWithRegistryEndpoint(),
    supportingReferences: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Supporting references").notRequired().validatePrefixRequestWithRegistryEndpoint(),
    requestedPrefix: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Requested prefix").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    sampleId: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Sample ID").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    idRegexPattern: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("LUI pattern").required().trim().test('valid regex', ({ value: value })=>`"${value}" is not a valid regex`, $cec0a1ffceed72c5$var$isRegexValid).validatePrefixRequestWithRegistryEndpoint(),
    institutionName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution name").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    institutionDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution description").required().min(50).validatePrefixRequestWithRegistryEndpoint(),
    institutionHomeUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution home URL").required().trim().url().matches(/^http/, "Must be a http(s) URL").validatePrefixRequestWithRegistryEndpoint(),
    institutionLocation: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution location").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    institutionRorId: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Instituton ROR ID").notRequired().trim().url().matches(/^https:\/\/ror.org\/0[a-z|0-9]{6}[0-9]{2}$/, {
        message: "Please input the whole https URL, ex: https://ror.org/02catss52",
        excludeEmptyString: true
    }),
    providerName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider Name").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    providerDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider description").required().validatePrefixRequestWithRegistryEndpoint(),
    providerHomeUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider home URL").required().trim().url().matches(/^http/, "Must be a http(s) URL").validatePrefixRequestWithRegistryEndpoint(),
    providerCode: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider code").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    providerLocation: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider location").required().trim().validatePrefixRequestWithRegistryEndpoint(),
    providerUrlPattern: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider URL pattern").required().trim().matches(/^http.+\{\$id\}/, "Pattern must be a http(s) URL that contains the {$id} placeholder").validatePrefixRequestWithRegistryEndpoint(),
    protectedUrls: (0, $0d9a35220db777bc$export$87b259aa03e3d267)().label("Has protected URLs").default(false),
    authHelpUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Authentication details URL").trim().url().when("protectedUrls", {
        is: true,
        then: (schema)=>schema.required().validatePrefixRequestWithRegistryEndpoint(),
        otherwise: (schema)=>schema.nullable().transform(()=>null)
    }),
    authHelpDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Authentication description").trim().when("protectedUrls", {
        is: true,
        then: (schema)=>schema.required().min(50).validatePrefixRequestWithRegistryEndpoint(),
        otherwise: (schema)=>schema.nullable().transform(()=>null)
    }),
    requester: (0, $0d9a35220db777bc$export$be5493f9613cbbe)({
        email: (0, $0d9a35220db777bc$export$eff4d24c3ff7876e)('requester.email'),
        name: (0, $0d9a35220db777bc$export$eff4d24c3ff7876e)('requester.name')
    }),
    requesterEmail: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Requester e-mail").required().trim().email().validatePrefixRequestWithRegistryEndpoint(),
    requesterName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Requester name").required().trim().validatePrefixRequestWithRegistryEndpoint()
});
const $cec0a1ffceed72c5$export$5d8af23af486a67a = {
    name: "",
    description: "",
    additionalInformation: "",
    supportingReferences: "",
    requestedPrefix: "",
    sampleId: "",
    idRegexPattern: "",
    institutionName: "",
    institutionDescription: "",
    institutionHomeUrl: "",
    institutionLocation: "",
    institutionRorId: "",
    providerName: "",
    providerDescription: "",
    providerHomeUrl: "",
    providerCode: "",
    providerLocation: "",
    providerUrlPattern: "",
    protectedUrls: false,
    authHelpUrl: "",
    authHelpDescription: "",
    requester: {
        email: "",
        name: ""
    },
    requesterEmail: "",
    requesterName: ""
};
var $cec0a1ffceed72c5$export$2e2bcd8739ae039 = $cec0a1ffceed72c5$var$PrefixRegistrationRequestSchema;



var $1ac0f7db9141201a$var$t = function(e, t, i) {
    if (e && "reportValidity" in e) {
        var n = (0, $c0b31a52896d9e30$export$3988ae62b71be9a3)(i, t);
        e.setCustomValidity(n && n.message || ""), e.reportValidity();
    }
}, $1ac0f7db9141201a$export$6bd436d70894afff = function(r, e) {
    var i = function(i) {
        var n = e.fields[i];
        n && n.ref && "reportValidity" in n.ref ? $1ac0f7db9141201a$var$t(n.ref, i, r) : n && n.refs && n.refs.forEach(function(e) {
            return $1ac0f7db9141201a$var$t(e, i, r);
        });
    };
    for(var n in e.fields)i(n);
}, $1ac0f7db9141201a$export$f0545b73a179e3a2 = function(t, n) {
    n.shouldUseNativeValidation && $1ac0f7db9141201a$export$6bd436d70894afff(t, n);
    var a = {};
    for(var f in t){
        var s = (0, $c0b31a52896d9e30$export$3988ae62b71be9a3)(n.fields, f), c = Object.assign(t[f] || {}, {
            ref: s && s.ref
        });
        if ($1ac0f7db9141201a$var$o(n.names || Object.keys(t), f)) {
            var u = Object.assign({}, (0, $c0b31a52896d9e30$export$3988ae62b71be9a3)(a, f));
            (0, $c0b31a52896d9e30$export$adaa4cf7ef1b65be)(u, "root", c), (0, $c0b31a52896d9e30$export$adaa4cf7ef1b65be)(a, f, u);
        } else (0, $c0b31a52896d9e30$export$adaa4cf7ef1b65be)(a, f, c);
    }
    return a;
}, $1ac0f7db9141201a$var$o = function(r, e) {
    var t = $1ac0f7db9141201a$var$a(e);
    return r.some(function(r) {
        return $1ac0f7db9141201a$var$a(r).match("^" + t + "\\.\\d+");
    });
};
function $1ac0f7db9141201a$var$a(r) {
    return r.replace(/\]|\[/g, "");
}



function $82ae2888d048f377$export$d55832dfcd4989a(o, n, s) {
    return void 0 === s && (s = {}), function(a, i, c) {
        try {
            return Promise.resolve(function(t, r) {
                try {
                    var u = (null != n && n.context, Promise.resolve(o["sync" === s.mode ? "validateSync" : "validate"](a, Object.assign({
                        abortEarly: !1
                    }, n, {
                        context: i
                    }))).then(function(t) {
                        return c.shouldUseNativeValidation && (0, $1ac0f7db9141201a$export$6bd436d70894afff)({}, c), {
                            values: s.raw ? Object.assign({}, a) : t,
                            errors: {}
                        };
                    }));
                } catch (e) {
                    return r(e);
                }
                return u && u.then ? u.then(void 0, r) : u;
            }(0, function(e) {
                if (!e.inner) throw e;
                var o, n;
                return {
                    values: {},
                    errors: (0, $1ac0f7db9141201a$export$f0545b73a179e3a2)((o = e, n = !c.shouldUseNativeValidation && "all" === c.criteriaMode, (o.inner || []).reduce(function(e, t) {
                        if (e[t.path] || (e[t.path] = {
                            message: t.message,
                            type: t.type
                        }), n) {
                            var o = e[t.path].types, s = o && o[t.type];
                            e[t.path] = (0, $c0b31a52896d9e30$export$b196c2a4f765bd30)(t.path, n, e, t.type, s ? [].concat(s, t.message) : t.message);
                        }
                        return e;
                    }, {})), c)
                };
            }));
        } catch (e) {
            return Promise.reject(e);
        }
    };
}





const $e8943780a0c792c7$export$4986381bddf68254 = (values)=>{
    const requestBody = {
        apiVersion: "1.0",
        payload: {
            ...values,
            requester: {
                name: values.requesterName,
                email: values.requesterEmail
            }
        }
    };
    const fetch_options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    };
    // Make request and update the store.
    const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRequestEndpoint}`;
    return fetch(requestUrl, fetch_options);
};
const $e8943780a0c792c7$var$submitPrefixRequest = (values)=>{
    const requestBody = {
        apiVersion: "1.0",
        payload: {
            ...values,
            supportingReferences: values.supportingReferences.split(/\/r?\/n/),
            requester: {
                name: values.requesterName,
                email: values.requesterEmail
            }
        }
    };
    const fetch_options = {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify(requestBody)
    };
    // Make request and update the store.
    const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRequestEndpoint}`;
    return fetch(requestUrl, fetch_options);
};
const $e8943780a0c792c7$export$687114be72585981 = async (values)=>{
    await $e8943780a0c792c7$var$submitPrefixRequest(values).then((response)=>response.json().then((json)=>{
            if (response.ok) (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                icon: 'success',
                title: 'Prefix registration request sent',
                text: 'Thank you. We will contact you shortly with more information about your request'
            });
            else (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                icon: 'error',
                title: 'Something went wrong when submitting request',
                text: json.errorMessage
            });
        })).catch((err)=>{
        console.error(err);
        (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
            icon: 'error',
            title: 'Something went wrong when submitting request',
            text: err.message
        });
    });
};
const $e8943780a0c792c7$export$661eaad38edc3ff0 = async (values)=>$e8943780a0c792c7$export$4986381bddf68254(values).then((response)=>response.json().then((json)=>{
            if (response.ok) (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                icon: 'success',
                title: 'Resource registration request sent',
                text: 'Thank you. We will contact you shortly with more information about your request'
            });
            else (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                icon: 'error',
                title: 'Something went wrong when submitting request',
                text: json.errorMessage
            });
        })).catch((err)=>{
        console.error(err);
        (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
            icon: 'error',
            title: 'Something went wrong when submitting request',
            text: err.message
        });
    });


const $d2598729d0ac37bf$var$PrefixRequestForm = (props)=>{
    const [institutionIsProvider, setInstitutionIsProvider] = (0, $dBNnn.useState)(false);
    const methods = (0, $c0b31a52896d9e30$export$87c0cf8eb5a167e0)({
        resolver: (0, $82ae2888d048f377$export$d55832dfcd4989a)((0, $cec0a1ffceed72c5$export$2e2bcd8739ae039)),
        defaultValues: (0, $cec0a1ffceed72c5$export$5d8af23af486a67a),
        mode: 'onBlur',
        reValidateMode: 'onBlur'
    });
    const { handleSubmit: handleSubmit, formState: formState, getValues: getValues, reset: reset, control: control, resetField: resetField, trigger: trigger } = methods;
    const { isValid: isValid } = formState;
    (0, $dBNnn.useEffect)(()=>{
        const rorIdInput = document.querySelector("#institutionRorId");
        rorIdInput.addEventListener('blur', (0, $041baa87cb412ad3$export$ab59a7c256710b61)(methods));
        return ()=>{
            rorIdInput.removeEventListener('blur', (0, $041baa87cb412ad3$export$ab59a7c256710b61)(methods));
        };
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("form", {
        "data-matomo-form": "",
        "data-matomo-name": "cloud_login",
        className: "form",
        autoComplete: "off",
        onSubmit: handleSubmit((0, $e8943780a0c792c7$export$687114be72585981)),
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-leaf"
                                    }),
                                    " Namespace Details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                className: "text-muted",
                                children: [
                                    "This section collects information related to the new ID space that is being requested, including its requested prefix, e.g.\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "text-dark",
                                        children: "pdb"
                                    }),
                                    ",\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "text-dark",
                                        children: "uniprot"
                                    }),
                                    " or\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                        className: "text-dark",
                                        children: "kegg.genes"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "name",
                                description: "The name of the new ID space.",
                                example: "Protein Data Bank",
                                label: "Namespace Name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "description",
                                description: "Short description of the ID space in one or multiple sentences.",
                                example: "The Protein Data Bank is the single worldwide archive of structural data of biological macromolecules",
                                label: "Description",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "requestedPrefix",
                                description: "Character string meant to precede the colon in resolved identifiers. No spaces or punctuation, only lowercase alphanumerical characters, underscores and dots.",
                                example: "pdb",
                                label: "Requested Prefix",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "sampleId",
                                description: "An example local identifier.",
                                example: "2gc4",
                                label: "Sample Id",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "idRegexPattern",
                                description: "A regular expression definition of the IDs in this namespace.",
                                example: "^[0-9][A-Za-z0-9]{3}$",
                                label: "Regex pattern",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "supportingReferences",
                                description: "Supporting references (URLs, citations), if any, to published work describing the resource. Enter one per line.",
                                example: "https://doi.org/10.1093/nar/28.1.235",
                                label: "Supporting references",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "additionalInformation",
                                description: "Anything else you wish to tell or ask us.",
                                label: "Additional information",
                                required: false,
                                rows: "5",
                                type: "textarea",
                                control: control
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-sitemap"
                                    }),
                                    " Institution details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "This section of the form collects the information of the institution that runs the first provider being registered in the new namespace being requested. Examples are EMBL-EBI, Kyoto University or NCBI."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionRorId",
                                description: "The ROR ID of the organization.",
                                example: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                            href: "https://ror.org/02catss52",
                                            target: "_blank",
                                            children: "https://ror.org/02catss52"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                            href: "https://ror.org/05cy4wa09",
                                            target: "_blank",
                                            children: "https://ror.org/05cy4wa09"
                                        })
                                    ]
                                }),
                                label: "ROR ID",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionName",
                                description: "The name of the institution that runs the provider.",
                                example: "European Bioinformatics Institute, Hinxton, Cambridge, UK",
                                label: "Name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionDescription",
                                description: "Short description of the institution in one or multiple sentences.",
                                example: "The European Bioinformatics Institute (EMBL-EBI) is the part of EMBL dedicated to big data and online services",
                                label: "Description",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionHomeUrl",
                                description: "A valid URL for the homepage of the institution.",
                                example: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    href: "https://www.ebi.ac.uk/",
                                    target: "_blank",
                                    children: "https://www.ebi.ac.uk/"
                                }),
                                label: "Home URL",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionLocation",
                                description: "The home country of the institution.",
                                label: "Location",
                                optionlabelfield: "countryName",
                                optionsfield: "locations",
                                options: props.locationList,
                                type: "select",
                                control: control
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-cube"
                                    }),
                                    " Provider details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "This section collects information related to the first provider being registered in this new namespace."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                className: "row mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                                        className: "col-lg-3 col-form-label form-control-label form-label",
                                        htmlFor: "institutionIsProvider",
                                        children: "Copy Institution details"
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                        className: "col-sm-12 col-md-10 col-lg-9",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                id: "institutionIsProvider",
                                                defaultChecked: institutionIsProvider,
                                                onChange: (0, $041baa87cb412ad3$export$ff274046684546)(setInstitutionIsProvider, methods),
                                                type: "checkbox"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                                                className: "form-text text-muted d-inline ms-2",
                                                id: "institutionIsProvider-helpblock",
                                                htmlFor: "institutionIsProvider",
                                                children: "Tick this box to copy the details provided for the owning institution of the provider. Please, keep in mind that 'URL Pattern' and 'Provider code' will need to be filled after the autofill."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerName",
                                description: "The name of the provider.",
                                readonly: institutionIsProvider,
                                example: "ChEBI (Chemical Entities of Biological Interest)",
                                label: "Name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerDescription",
                                description: "Short description of the provider in one or multiple sentences.",
                                readonly: institutionIsProvider,
                                example: "ChEBI (Chemical Entities of Biological Interest) at EMBL-EBI",
                                label: "Description",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerHomeUrl",
                                description: "URL for a home page that describes the role of the provider in the current namespace.",
                                readonly: institutionIsProvider,
                                example: "https://www.pdbe.org/",
                                label: "Home URL",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerLocation",
                                description: "The location from which the provider is offering its services (main location in case of multiple ones).",
                                readonly: institutionIsProvider,
                                label: "Location",
                                optionlabelfield: "countryName",
                                optionsfield: "locations",
                                options: props.locationList,
                                type: "select",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerCode",
                                description: " A unique identifier for the provider within the namespace. Something related to the institution name is recommended. Only lowercase characters, underscores and dots. ",
                                example: "ebi",
                                label: "Provider code",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerUrlPattern",
                                description: 'A URL-like string specifying a rule for resolving this identifier. The rule should contain the key "{$id}", which acts as a placeholder for the resolution services.',
                                example: "https://www.ebi.ac.uk/pdbe/entry/pdb/{$id}",
                                label: "URL Pattern",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $041baa87cb412ad3$export$42bfa838b73a9e90), {
                                control: control,
                                resetField: resetField,
                                trigger: trigger
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-user"
                                    }),
                                    " Requester details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "Contact details associated with this prefix registration request for identifiers.org curator team to reach out if needed, for both resolution of this request and future updates to the namespace information and/ or the first registered provider."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "requesterName",
                                description: "The full name of the person making this request.",
                                field: "requesterName",
                                label: "Full name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "requesterEmail",
                                description: "The email address of the person making this request.",
                                field: "requesterEmail",
                                label: "Email",
                                type: "text",
                                control: control
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "card-body",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "row",
                        children: formState.isSubmitting ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("center", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {
                                noText: true
                            })
                        }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-12 col-lg-6 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                        className: "form-control btn btn-primary text-white",
                                        type: "submit",
                                        disabled: !isValid,
                                        title: !isValid ? "There are errors on the form" : undefined,
                                        children: "Submit prefix request"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-sm-12 col-md-6 col-lg-3 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $f8fa6e5ad033993d$export$cf793a48d03156e1), {
                                        storageKey: "idorg-prefix-form",
                                        getValues: getValues
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-sm-12 col-md-6 col-lg-3 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $f8fa6e5ad033993d$export$51cde66861b188e5), {
                                        storageKey: "idorg-prefix-form",
                                        reset: reset,
                                        trigger: trigger
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
const $d2598729d0ac37bf$var$mapStateToProps = (state)=>({
        locationList: state.locationList
    });
var $d2598729d0ac37bf$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($d2598729d0ac37bf$var$mapStateToProps)($d2598729d0ac37bf$var$PrefixRequestForm);


var $dbdafc94b4d4c1f8$export$2e2bcd8739ae039 = ()=>{
    const { trackPageView: trackPageView } = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    (0, $dBNnn.useEffect)(()=>{
        trackPageView();
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-list",
                title: "Request prefix form",
                description: "Please complete this form to register an identifier prefix that can be recognized by the meta-resolvers at identifiers.org and n2t.net. Completing all fields will enable a swift processing of your request."
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "container py-3",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "mx-auto col-sm-12 col-lg-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $d2598729d0ac37bf$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
};




var $dBNnn = parcelRequire("dBNnn");




var $dBNnn = parcelRequire("dBNnn");









(0, $0d9a35220db777bc$export$20be359f745f973c)((0, $0d9a35220db777bc$export$19342e026b58ebb7), 'validateResourceRequestWithRegistryEndpoint', function() {
    return this.test('validateResourceRequestWithRegistryEndpoint', "Rejected by endpoint", async function(value, textContext) {
        if (value) {
            let attributeToValidate, otherValues;
            if (this.path in (0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)) {
                attributeToValidate = this.path;
                otherValues = this.parent;
            } else {
                attributeToValidate = textContext.options.context.attr;
                otherValues = textContext.options.context.otherValues;
            }
            try {
                const response = await (0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[attributeToValidate](value, otherValues, "resource");
                return response.valid ? true : this.createError({
                    message: response.errorMessage
                });
            } catch (e) {
                console.error(this, e);
                return false;
            }
        } else return true;
    });
});
const $1cb369ff0751b226$var$ResourceRegistrationRequestSchema = (0, $0d9a35220db777bc$export$be5493f9613cbbe)({
    namespacePrefix: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Prefix").required().trim().validateResourceRequestWithRegistryEndpoint(),
    sampleId: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Sample ID").required().trim().validateResourceRequestWithRegistryEndpoint(),
    institutionName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution name").required().trim().validateResourceRequestWithRegistryEndpoint(),
    institutionDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution description").required().min(50).validateResourceRequestWithRegistryEndpoint(),
    institutionHomeUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution home URL").required().trim().url().matches(/^http/, "Must be a http(s) URL").validateResourceRequestWithRegistryEndpoint(),
    institutionLocation: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Institution location").required().trim().validateResourceRequestWithRegistryEndpoint(),
    institutionRorId: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Instituton ROR ID").notRequired().trim().url().matches(/^https:\/\/ror.org\/0[a-z|0-9]{6}[0-9]{2}$/, {
        message: "Please input the whole https URL, ex: https://ror.org/02catss52",
        excludeEmptyString: true
    }),
    providerName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider Name").required().trim().validateResourceRequestWithRegistryEndpoint(),
    providerDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider description").required().validateResourceRequestWithRegistryEndpoint(),
    providerHomeUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider home URL").required().trim().url().matches(/^http/, "Must be a http(s) URL").validateResourceRequestWithRegistryEndpoint(),
    providerCode: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider code").required().trim().validateResourceRequestWithRegistryEndpoint(),
    providerLocation: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider location").required().trim().validateResourceRequestWithRegistryEndpoint(),
    providerUrlPattern: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Provider URL pattern").required().trim().matches(/^http.+\{\$id\}/, "Pattern must be a http(s) URL that contains the {$id} placeholder").validateResourceRequestWithRegistryEndpoint(),
    protectedUrls: (0, $0d9a35220db777bc$export$87b259aa03e3d267)().label("Has protected URLs").default(false),
    authHelpUrl: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Authentication details URL").trim().url().when("protectedUrls", {
        is: true,
        then: (schema)=>schema.required().validatePrefixRequestWithRegistryEndpoint(),
        otherwise: (schema)=>schema.nullable().transform(()=>null)
    }),
    authHelpDescription: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Authentication description").trim().when("protectedUrls", {
        is: true,
        then: (schema)=>schema.required().min(50).validatePrefixRequestWithRegistryEndpoint(),
        otherwise: (schema)=>schema.nullable().transform(()=>null)
    }),
    requester: (0, $0d9a35220db777bc$export$be5493f9613cbbe)({
        email: (0, $0d9a35220db777bc$export$eff4d24c3ff7876e)('requester.email'),
        name: (0, $0d9a35220db777bc$export$eff4d24c3ff7876e)('requester.name')
    }),
    requesterEmail: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Requester e-mail").required().trim().email().validateResourceRequestWithRegistryEndpoint(),
    requesterName: (0, $0d9a35220db777bc$export$22b082955e083ec3)().label("Requester name").required().trim().validateResourceRequestWithRegistryEndpoint()
});
var $1cb369ff0751b226$export$2e2bcd8739ae039 = $1cb369ff0751b226$var$ResourceRegistrationRequestSchema;
const $1cb369ff0751b226$export$764f7c6a01659145 = {
    namespacePrefix: "",
    sampleId: "",
    institutionName: "",
    institutionDescription: "",
    institutionHomeUrl: "",
    institutionLocation: "",
    institutionRorId: "",
    providerName: "",
    providerDescription: "",
    providerHomeUrl: "",
    providerCode: "",
    providerLocation: "",
    providerUrlPattern: "",
    protectedUrls: false,
    authHelpUrl: "",
    authHelpDescription: "",
    requester: {
        email: "",
        name: ""
    },
    requesterName: "",
    requesterEmail: ""
};



const $97f30d247df654a7$var$ResourceRequestForm = (props)=>{
    const [institutionIsProvider, setInstitutionIsProvider] = (0, $dBNnn.useState)(false);
    const methods = (0, $c0b31a52896d9e30$export$87c0cf8eb5a167e0)({
        resolver: (0, $82ae2888d048f377$export$d55832dfcd4989a)((0, $1cb369ff0751b226$export$2e2bcd8739ae039)),
        defaultValues: (0, $1cb369ff0751b226$export$764f7c6a01659145),
        mode: 'onBlur',
        reValidateMode: 'onBlur'
    });
    const { handleSubmit: handleSubmit, formState: formState, getValues: getValues, setValue: setValue, reset: reset, control: control, resetField: resetField, trigger: trigger } = methods;
    const { isValid: isValid } = formState;
    (0, $dBNnn.useEffect)(()=>{
        const rorIdInput = document.querySelector("#institutionRorId");
        rorIdInput.addEventListener('blur', (0, $041baa87cb412ad3$export$ab59a7c256710b61)(methods));
        return ()=>{
            rorIdInput.removeEventListener('blur', (0, $041baa87cb412ad3$export$ab59a7c256710b61)(methods));
        };
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("form", {
        className: "form",
        role: "form",
        onSubmit: handleSubmit((0, $e8943780a0c792c7$export$661eaad38edc3ff0)),
        autoComplete: "off",
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-leaf"
                                    }),
                                    " Namespace details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                className: "text-muted",
                                children: "Select the namespace where you want the new provider to be added. Start typing the prefix of the namespace, and choose one of the suggestions."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "card-body",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                            id: "namespacePrefix",
                            type: "text",
                            placeholderCaption: "Select the namespace where you want to add a resource",
                            label: "Namespace",
                            autocompleter: (0, $041baa87cb412ad3$export$32164a9ad960006c),
                            autocompleterSetValue: (val)=>setValue("namespacePrefix", val, (0, $041baa87cb412ad3$export$bfba6e2b5c20c25)),
                            control: control
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-sitemap"
                                    }),
                                    " Institution details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "This section of the form collects the information of the institution that runs the provider being registered. Examples are EMBL-EBI, Kyoto University or NCBI."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionRorId",
                                description: "The ROR ID of the organization.",
                                example: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                            href: "https://ror.org/02catss52",
                                            target: "_blank",
                                            children: "https://ror.org/02catss52"
                                        }),
                                        " or ",
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                            href: "https://ror.org/05cy4wa09",
                                            target: "_blank",
                                            children: "https://ror.org/05cy4wa09"
                                        })
                                    ]
                                }),
                                label: "ROR ID",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionName",
                                description: "The name of the institution that runs the provider.",
                                formsection: "Institution details",
                                example: "European Bioinformatics Institute, Hinxton, Cambridge, UK",
                                label: "Name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionDescription",
                                description: "Short description of the institution in one or multiple sentences.",
                                example: "The European Bioinformatics Institute (EMBL-EBI) is the part of EMBL dedicated to big data and online services",
                                label: "Description",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionHomeUrl",
                                description: "A valid URL for the homepage of the institution.",
                                example: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                                    href: "https://www.ebi.ac.uk/",
                                    target: "_blank",
                                    children: "https://www.ebi.ac.uk/"
                                }),
                                formsection: "Institution details",
                                label: "Home URL",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "institutionLocation",
                                description: "The home country of the institution.",
                                label: "Location",
                                optionlabelfield: "countryName",
                                optionsfield: "locations",
                                options: props.locationList,
                                registrationType: "RESOURCE",
                                type: "select",
                                control: control
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-cube"
                                    }),
                                    " Provider details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "This section collects information related to the provider being registered."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                className: "row mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                                        className: "col-lg-3 col-form-label form-label form-control-label",
                                        htmlFor: "institutionIsProvider",
                                        children: "Copy Institution details"
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                        className: "col-sm-12 col-md-10 col-lg-9",
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                id: "institutionIsProvider",
                                                defaultChecked: institutionIsProvider,
                                                onChange: (0, $041baa87cb412ad3$export$ff274046684546)(setInstitutionIsProvider, methods),
                                                type: "checkbox"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("label", {
                                                id: "institutionIsProvider-helpblock",
                                                className: "form-text text-muted d-inline ms-2",
                                                htmlFor: "institutionIsProvider",
                                                children: "Tick this box to copy the details provided for the owning institution of the provider. Please, keep in mind that 'URL Pattern' and 'Provider code' will need to be filled after the autofill."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerName",
                                description: "The name of the provider.",
                                readonly: institutionIsProvider,
                                example: "ChEBI (Chemical Entities of Biological Interest)",
                                label: "Name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerDescription",
                                description: "Short description of the provider in one or multiple sentences.",
                                readonly: institutionIsProvider,
                                example: "ChEBI (Chemical Entities of Biological Interest) at EMBL-EBI",
                                label: "Description",
                                rows: "5",
                                type: "textarea",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerHomeUrl",
                                description: "URL for a home page that describes the role of the provider in the current namespace.",
                                readonly: institutionIsProvider,
                                example: "https://www.pdbe.org/",
                                label: "Home URL",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerCode",
                                description: "This is a unique identifier for the provider within the namespace, for forced resolution requests. No spaces or punctuation, only lowercase alphanumerical characters, underscores and dots.",
                                example: "pdb",
                                label: "Provider code",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerUrlPattern",
                                description: 'A URL-like string specifying a rule for resolving this identifier. The rule should contain the key "{$id}", which acts as a placeholder for the resolution services.',
                                example: "https://www.ebi.ac.uk/pdbe/entry/pdb/{$id}",
                                label: "URL Pattern",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "sampleId",
                                description: "An example local identifier available for this provider within the namespace where it's being registered.",
                                example: "2gc4",
                                formsection: "Provider details",
                                label: "Sample Id",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "providerLocation",
                                description: "The location from which the provider is offering its services (main location in case of multiple ones).",
                                readonly: institutionIsProvider,
                                label: "Location",
                                optionlabelfield: "countryName",
                                optionsfield: "locations",
                                options: props.locationList,
                                type: "select",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $041baa87cb412ad3$export$42bfa838b73a9e90), {
                                control: control,
                                resetField: resetField,
                                trigger: trigger
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "card mb-3",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h2", {
                                className: "mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-user"
                                    }),
                                    " Requester details"
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("p", {
                                children: "Contact details associated with this resource registration request for identifiers.org curator team to reach out if needed, for both resolution of this request and future updates to the resource information."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "requesterName",
                                description: "The full name of the person making this request.",
                                field: "requesterName",
                                label: "Full name",
                                type: "text",
                                control: control
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $7c5541f459ee75eb$export$2e2bcd8739ae039), {
                                id: "requesterEmail",
                                description: "The email address of the person making this request.",
                                field: "requesterEmail",
                                label: "Email",
                                type: "text",
                                control: control
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "card",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "card-body",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "row",
                        children: formState.isSubmitting ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("center", {
                            className: "col-12",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $187fb74469bf966e$export$2e2bcd8739ae039), {
                                noText: true
                            })
                        }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-12 col-lg-6 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("button", {
                                        className: "form-control btn btn-primary text-white",
                                        type: "submit",
                                        disabled: !isValid,
                                        title: !isValid ? "There are errors on the form" : undefined,
                                        children: "Submit resource request"
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-sm-12 col-md-6 col-lg-3 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $f8fa6e5ad033993d$export$cf793a48d03156e1), {
                                        storageKey: "idorg-resource-form",
                                        getValues: getValues
                                    })
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                    className: "col-sm-12 col-md-6 col-lg-3 mb-1",
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $f8fa6e5ad033993d$export$51cde66861b188e5), {
                                        storageKey: "idorg-resource-form",
                                        reset: reset,
                                        trigger: trigger
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
const $97f30d247df654a7$var$mapStateToProps = (state)=>({
        locationList: state.locationList
    });
var $97f30d247df654a7$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($97f30d247df654a7$var$mapStateToProps)($97f30d247df654a7$var$ResourceRequestForm);


var $4bee0cfe66d07d4c$export$2e2bcd8739ae039 = ()=>{
    const { trackPageView: trackPageView } = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    (0, $dBNnn.useEffect)(()=>{
        trackPageView();
    });
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                icon: "icon-list",
                title: "Request resource form",
                description: "Please complete this form to register a new resource, in an existing namespace, that can be recognized by the meta-resolvers at identifiers.org and n2t.net. Completing all fields will enable a swift processing of your request."
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "container py-3",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "mx-auto col-sm-12 col-lg-10",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $97f30d247df654a7$export$2e2bcd8739ae039), {})
                    })
                })
            })
        ]
    });
};





var $dBNnn = parcelRequire("dBNnn");


// Config.

//
// RegistrationSessionAmend actions.
//
// Redux store update for registration session new amend fields.
const $77331a657270a7ed$export$74718fb23d8f954f = (field, value, registrationSessionType)=>{
    const action = {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONAMENDFIELD`,
        field: field,
        value: value
    };
    return action;
};
const $77331a657270a7ed$export$66c277e8e4d86f3f = (registrationSessionAmend, registrationSessionType)=>{
    const action = {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONAMEND`,
        registrationSessionAmend: registrationSessionAmend
    };
    return action;
};




const $5973b98c9401bfd3$export$6a4e501b1ad77fba = (id)=>{
    return async (dispatch, getState)=>{
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/prefixRegistrationSessions/${id}`);
        const init = {
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        let data;
        try {
            const response = await fetch(requestUrl, init);
            data = await response.json();
        } catch (err) {
            console.error('Error fetching prefix registration request: ', err);
            return;
        }
        // Fetches current prefixRegistrationRequest.
        await (0, $df9764f9470d541a$export$adb5405149b9ba8a)(data, [
            {
                name: 'prefixRegistrationRequest',
                url: data._links.prefixRegistrationRequest.href
            }
        ], init);
        const eventsUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/prefixRegistrationSessionEvents/search/findByPrefixRegistrationSessionId?id=${id}`;
        const eventsResponse = await fetch(eventsUrl, init);
        let eventsData = await eventsResponse.json();
        // Fetch amend event prefixRegistrationRequest.
        if (eventsData._embedded.prefixRegistrationSessionEventAmends) eventsData._embedded.prefixRegistrationSessionEventAmends = await Promise.all(eventsData._embedded.prefixRegistrationSessionEventAmends.map((event)=>{
            return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(event, [
                {
                    name: 'prefixRegistrationRequest',
                    url: event._links.prefixRegistrationRequest.href
                }
            ], init);
        }));
        // Also fetch start event prefixRegistrationRequest.
        const event = eventsData._embedded.prefixRegistrationSessionEventStarts[0];
        eventsData._embedded.prefixRegistrationSessionEventStarts[0] = await (0, $df9764f9470d541a$export$adb5405149b9ba8a)(event, [
            {
                name: 'prefixRegistrationRequest',
                url: event._links.prefixRegistrationRequest.href
            }
        ], init);
        // Flatten event list and sort by date.
        let events = Object.keys(eventsData._embedded).map((_)=>eventsData._embedded[_]);
        data.prefixRegistrationSessionEvents = events.flat();
        data.prefixRegistrationSessionEvents.sort((a, b)=>new Date(b.created) - new Date(a.created));
        // Dispatch redux state update.
        dispatch($5973b98c9401bfd3$export$7f2eca678e3b6f5f(data));
        // Prepare amend template in state as a copy of the request.
        dispatch((0, $77331a657270a7ed$export$66c277e8e4d86f3f)(data.prefixRegistrationRequest, 'prefix'));
        return data;
    };
};
const $5973b98c9401bfd3$export$7f2eca678e3b6f5f = (prefixRegistrationSession)=>{
    return {
        type: 'SET_PREFIXREGISTRATIONSESSION',
        prefixRegistrationSession: prefixRegistrationSession
    };
};
const $5973b98c9401bfd3$export$58d1512488a18363 = (id, reason)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRegistrationEndpoint}/acceptPrefixRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    acceptanceReason: reason
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $5973b98c9401bfd3$export$e47dc073c4b000b2 = (id, reason)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRegistrationEndpoint}/rejectPrefixRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    rejectionReason: reason
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $5973b98c9401bfd3$export$2b3aef57b1406a97 = (id, comment)=>{
    return async (undefined, getState)=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRegistrationEndpoint}/commentPrefixRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    comment: comment
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $5973b98c9401bfd3$export$acfa29766acd2a75 = (id, prefixRegistrationRequest, additionalInformation)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).prefixRegistrationEndpoint}/amendPrefixRegistrationRequest/${id}`;
        // Data transformation for the API. This should be extracted to a model converter.
        // Supporting references must be an array to talk to the API. It is split here by commas.
        prefixRegistrationRequest.supportingReferences = prefixRegistrationRequest.supportingReferences.split(',');
        // Also, requester data must be inside a subobject.
        prefixRegistrationRequest['requester'] = {
            name: prefixRegistrationRequest.requesterName,
            email: prefixRegistrationRequest.requesterEmail
        };
        // Also, country codes must be trimmed in institutionLocation and providerLocation.
        prefixRegistrationRequest.institutionLocation = prefixRegistrationRequest.institutionLocation.split('/').pop();
        prefixRegistrationRequest.providerLocation = prefixRegistrationRequest.providerLocation.split('/').pop();
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: additionalInformation || 'Source: curation web interface',
                    prefixRegistrationRequest: prefixRegistrationRequest
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};





var $dBNnn = parcelRequire("dBNnn");
class $107a64541f1a41b5$var$RegistrationSessionNewEventBtn extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        // If isCancel, the button will look like a cancel button.
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClick", ()=>{
            const { props: { handleShow: handleShow }, state: { isCancel: isCancel } } = this;
            this.setState({
                isCancel: !isCancel
            });
            handleShow();
        });
        this.state = {
            isCancel: this.props.isCancel
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If isCancel changed, change state.
        if (nextProps.isCancel !== prevState.isCancel) return {
            isCancel: nextProps.isCancel
        };
        else return null;
    }
    render() {
        const { handleClick: handleClick, state: { isCancel: isCancel }, props: { icon: icon, caption: caption, color: color } } = this;
        const bgColor = isCancel ? 'bg-gray' : '';
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
            className: `col p-2 rounded-top-lg ${bgColor}`,
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                className: `btn ${isCancel ? 'btn-dark' : 'btn-' + color} w-100 text-white`,
                href: "#!",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                        className: `icon icon-common icon-${isCancel ? 'times' : icon}`
                    }),
                    "\xa0",
                    isCancel ? `Cancel ${caption.toLowerCase()}` : caption
                ]
            })
        });
    }
}
var // Mapping
$107a64541f1a41b5$export$2e2bcd8739ae039 = $107a64541f1a41b5$var$RegistrationSessionNewEventBtn;



parcelRequire("dBNnn");



var $dBNnn = parcelRequire("dBNnn");


class $86adaa5147ee0ac0$var$RegistrationSessionEventStart extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "toggle", ()=>{
            this.setState((state)=>({
                    expanded: !state.expanded
                }));
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { data: data, registrationSessionType: registrationSessionType } = this.props;
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "col mb-3",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                className: "text-muted fw-bold me-3",
                                children: "Additional information:"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                className: "text-dark",
                                children: data.additionalInformation
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-xs-8 col-sm-6 col-md-5 col-lg-4 col-xl-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                            className: "btn btn-secondary w-100",
                            href: "#!",
                            onClick: this.toggle,
                            children: expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                className: "text-white",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-minus"
                                    }),
                                    " Hide request contents\xa0"
                                ]
                            }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                className: "text-white",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-plus"
                                    }),
                                    " Show request contents\xa0"
                                ]
                            })
                        })
                    })
                }),
                expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "card-body",
                    children: [
                        registrationSessionType === 'prefix' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $15915c864f56169e$export$2e2bcd8739ae039), {
                            data: data.prefixRegistrationRequest
                        }),
                        registrationSessionType === 'resource' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $16a9df20d48176e0$export$2e2bcd8739ae039), {
                            data: data.resourceRegistrationRequest
                        })
                    ]
                })
            ]
        });
    }
}
var $86adaa5147ee0ac0$export$2e2bcd8739ae039 = $86adaa5147ee0ac0$var$RegistrationSessionEventStart;





var $dBNnn = parcelRequire("dBNnn");


class $be192f002c432f25$var$RegistrationSessionEventAmend extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "toggle", ()=>{
            this.setState((state)=>({
                    expanded: !state.expanded
                }));
        });
        this.state = {
            expanded: false
        };
    }
    render() {
        const { data: data, registrationSessionType: registrationSessionType } = this.props;
        const { expanded: expanded } = this.state;
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "col mb-3",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                className: "text-muted fw-bold me-3",
                                children: "Additional information:"
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                className: "text-dark",
                                children: data.additionalInformation
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col col-xs-8 col-sm-6 col-md-5 col-lg-4 col-xl-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("a", {
                            className: "btn btn-secondary w-100",
                            href: "#!",
                            onClick: this.toggle,
                            children: expanded ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                className: "text-white",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-minus"
                                    }),
                                    " Hide request contents\xa0"
                                ]
                            }) : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("span", {
                                className: "text-white",
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-plus"
                                    }),
                                    " Show request contents\xa0"
                                ]
                            })
                        })
                    })
                }),
                expanded && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "card-body",
                    children: [
                        registrationSessionType === 'prefix' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $15915c864f56169e$export$2e2bcd8739ae039), {
                            data: data.prefixRegistrationRequest
                        }),
                        registrationSessionType === 'resource' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $16a9df20d48176e0$export$2e2bcd8739ae039), {
                            data: data.resourceRegistrationRequest
                        })
                    ]
                })
            ]
        });
    }
}
var $be192f002c432f25$export$2e2bcd8739ae039 = $be192f002c432f25$var$RegistrationSessionEventAmend;



parcelRequire("dBNnn");
const $5211abe3bc85ffcc$var$PrefixRegistrationSessionEventComment = ({ data: data })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "card",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                    className: "icon icon-common icon-quote-left text-muted me-3"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark font-italic",
                    children: data.comment
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                    className: "icon icon-common icon-quote-right text-muted ms-3"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-muted fw-bold me-3",
                    children: "Additional information:"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark",
                    children: data.additionalInformation
                })
            ]
        })
    });
var $5211abe3bc85ffcc$export$2e2bcd8739ae039 = $5211abe3bc85ffcc$var$PrefixRegistrationSessionEventComment;



parcelRequire("dBNnn");
const $3f07f7291c0d8e51$var$RegistrationSessionEventAccept = ({ data: data })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "card",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-success fw-bold me-3",
                    children: "Acceptance reason:"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark font-italic",
                    children: data.acceptanceReason
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "fw-bold me-3",
                    children: "Additional information:"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark",
                    children: data.additionalInformation
                })
            ]
        })
    });
var $3f07f7291c0d8e51$export$2e2bcd8739ae039 = $3f07f7291c0d8e51$var$RegistrationSessionEventAccept;



parcelRequire("dBNnn");
const $b8fd468fc443d9d4$var$RegistrationSessionEventReject = ({ data: data })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
        className: "card",
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "card-body",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-danger fw-bold me-3",
                    children: "Rejection reason:"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark font-italic",
                    children: data.rejectionReason
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("hr", {}),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-muted fw-bold me-3",
                    children: "Additional information:"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                    className: "text-dark",
                    children: data.additionalInformation
                })
            ]
        })
    });
var $b8fd468fc443d9d4$export$2e2bcd8739ae039 = $b8fd468fc443d9d4$var$RegistrationSessionEventReject;



var $atqVQ = parcelRequire("atqVQ");
const $bc645780c41f7c76$var$RegistrationSessionEvent = ({ data: data, registrationSessionType: registrationSessionType })=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
        children: [
            data.eventName === 'START' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "callout callout-primary",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "bg-dark text-white rounded-2 d-flex justify-content-between mb-3 px-3 ",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-search-document me-1"
                                    }),
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                        children: [
                                            "Original request submission at ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(data.created).format('llll')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-user me-1"
                                        }),
                                        data.actor
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $86adaa5147ee0ac0$export$2e2bcd8739ae039), {
                        data: data,
                        registrationSessionType: registrationSessionType
                    })
                ]
            }),
            " ",
            data.eventName === 'AMEND' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "callout callout-warning",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "bg-dark text-white rounded-2 d-flex justify-content-between mb-3 px-3 ",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-edit"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                        children: [
                                            "Request amend at ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(data.created).format('llll')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-user me-1"
                                        }),
                                        data.actor
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $be192f002c432f25$export$2e2bcd8739ae039), {
                        data: data,
                        registrationSessionType: registrationSessionType
                    })
                ]
            }),
            " ",
            data.eventName === 'COMMENT' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "callout callout-secondary",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "bg-dark text-white rounded-2 d-flex justify-content-between mb-3 px-3 ",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-comment"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                        children: [
                                            "Request comment at ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(data.created).format('llll')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-user me-1"
                                        }),
                                        data.actor
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $5211abe3bc85ffcc$export$2e2bcd8739ae039), {
                        data: data,
                        registrationSessionType: registrationSessionType
                    })
                ]
            }),
            " ",
            data.eventName === 'ACCEPT' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "callout callout-success",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "bg-dark text-white rounded-2 d-flex justify-content-between mb-3 px-3 ",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-check"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                        children: [
                                            "Request accept at ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(data.created).format('llll')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-user me-1"
                                        }),
                                        data.actor
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $3f07f7291c0d8e51$export$2e2bcd8739ae039), {
                        data: data,
                        registrationSessionType: registrationSessionType
                    })
                ]
            }),
            " ",
            data.eventName === 'REJECT' && /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                className: "callout callout-danger",
                children: [
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "bg-dark text-white rounded-2 d-flex justify-content-between mb-3 px-3 ",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-times"
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                        children: [
                                            "Request reject at ",
                                            (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ)))(data.created).format('llll')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("strong", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-user me-1"
                                        }),
                                        data.actor
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b8fd468fc443d9d4$export$2e2bcd8739ae039), {
                        data: data,
                        registrationSessionType: registrationSessionType
                    })
                ]
            })
        ]
    });
var $bc645780c41f7c76$export$2e2bcd8739ae039 = $bc645780c41f7c76$var$RegistrationSessionEvent;





var $dBNnn = parcelRequire("dBNnn");



//
// RegistrationSessionAccept actions.
//
// Redux store update for prefix registration session new accept.
const $2d5e9727fc6969a9$export$e461252096d6a232 = (acceptanceReason, additionalInformation, registrationSessionType)=>{
    const action = {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONACCEPT`,
        acceptanceReason: acceptanceReason,
        additionalInformation: additionalInformation
    };
    return action;
};



class $52301abfec5370a9$var$PrefixRegistrationSessionAcceptForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleAccept", async ()=>{
            const { id: id, prefixRegistrationRequestAccept: prefixRegistrationRequestAccept, setPrefixRegistrationSessionAccept: setPrefixRegistrationSessionAccept } = this.props;
            const { acceptanceReason: acceptanceReason } = this.state;
            const response = await prefixRegistrationRequestAccept(id, acceptanceReason || 'No acceptance reason specified.');
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Prefix Registration Request accepted succesfully'
                });
                setPrefixRegistrationSessionAccept('', '');
                this.props.navigate('/curation');
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not accept Prefix Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleAcceptanceReasonChange", (e)=>{
            const { setPrefixRegistrationSessionAccept: setPrefixRegistrationSessionAccept } = this.props;
            setPrefixRegistrationSessionAccept(e.target.value, 'additionalInformation');
        });
        this.state = {
            acceptanceReason: this.props.prefixRegistrationSessionAccept.acceptanceReason
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If acceptanceReason changed, change state.
        if (nextProps.prefixRegistrationSessionAccept.acceptanceReason !== prevState.acceptanceReason) return {
            acceptanceReason: nextProps.prefixRegistrationSessionAccept.acceptanceReason
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, handleAccept: handleAccept, handleAcceptanceReasonChange: handleAcceptanceReasonChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4 rounded-all-but-top-left-lg",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Accept request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Acceptance reason"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Acceptace reason",
                                    onChange: handleAcceptanceReasonChange
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-success w-100 text-white",
                            href: "#!",
                            onClick: handleAccept,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Confirm approval"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $52301abfec5370a9$var$mapStateToProps = (state)=>({
        prefixRegistrationSessionAccept: state.curationDashboard.prefixRegistrationSessionAccept
    });
const $52301abfec5370a9$var$mapDispatchToProps = (dispatch)=>({
        prefixRegistrationRequestAccept: (id, reason)=>dispatch((0, $5973b98c9401bfd3$export$58d1512488a18363)(id, reason)),
        setPrefixRegistrationSessionAccept: (acceptanceReason)=>dispatch((0, $2d5e9727fc6969a9$export$e461252096d6a232)(acceptanceReason, undefined, 'prefix'))
    });
const $52301abfec5370a9$var$ConnectedPrefixRegistrationSessionAcceptForm = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($52301abfec5370a9$var$mapStateToProps, $52301abfec5370a9$var$mapDispatchToProps)($52301abfec5370a9$var$PrefixRegistrationSessionAcceptForm);
function $52301abfec5370a9$export$2e2bcd8739ae039(props) {
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($52301abfec5370a9$var$ConnectedPrefixRegistrationSessionAcceptForm, {
        ...props,
        navigate: navigate
    });
}





var $dBNnn = parcelRequire("dBNnn");







class $729fa0f20d84171a$var$PrefixRegistrationSessionAmendForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickAmend", async ()=>{
            const { id: id, handleFormSubmit: handleFormSubmit, prefixRegistrationRequestAmend: prefixRegistrationRequestAmend, prefixRegistrationSessionAmend: prefixRegistrationSessionAmend } = this.props;
            const response = await prefixRegistrationRequestAmend(id, prefixRegistrationSessionAmend);
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Prefix Registration Request amended succesfully'
                });
                handleFormSubmit();
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not amend Prefix Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickValidate", async ()=>{
            const { prefixRegistrationSessionAmend: prefixRegistrationSessionAmend } = this.props;
            const fieldsToValidate = [
                ...this.state.fieldsChanged
            ];
            if (fieldsToValidate.length === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No fields have changed');
                return;
            }
            // TODO: This has to be refactored to merge with the request prefix form. Take validators to a global place and use
            // them everywhere.
            const validations = await Promise.all(fieldsToValidate.map((field)=>(0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[field](prefixRegistrationSessionAmend[field], prefixRegistrationSessionAmend, 'prefix')));
            const toastMessage = validations.filter((validations)=>!validations.valid).map((validations)=>validations.errorMessage).join('\n');
            if (toastMessage !== '') (0, $c76c78ebffccd857$export$85ee8a1f69fea720)(toastMessage, undefined, 10000);
            else (0, $c76c78ebffccd857$export$73e19c0339806233)('All fields OK!');
        });
        //
        // Field manipulation handler. Undefined 'value' field will revert to default.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (field, value)=>{
            const { setPrefixRegistrationSessionAmendField: setPrefixRegistrationSessionAmendField, prefixRegistrationSession: { prefixRegistrationRequest: prefixRegistrationRequest } } = this.props;
            if (typeof value === 'undefined') value = prefixRegistrationRequest[field];
            setPrefixRegistrationSessionAmendField(field, value);
            // Add/remove field to changed list if modified/reset, so it is validated or not when clicked on the perform
            // validation button.
            if (prefixRegistrationRequest[field] !== value) this.setState((prevState)=>({
                    fieldsChanged: prevState.fieldsChanged.add(field)
                }));
            else this.setState((prevState)=>{
                prevState.fieldsChanged.delete(field);
                return {
                    fieldsChanged: prevState.fieldsChanged
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSelectInstitution", async (e)=>{
            const { getInstitutionFromRegistry: getInstitutionFromRegistry } = this.props;
            const institutionShortId = e.target.value;
            const institution = await getInstitutionFromRegistry(institutionShortId);
            this.setState({
                institutionSelected: institutionShortId
            });
            this.handleChangeField('rorId', institution.rorId);
            this.institutionRorIdRef.current.handleChangeField(institution.rorId || '');
            this.handleChangeField('institutionName', institution.name);
            this.institutionNameRef.current.handleChangeField(institution.name);
            this.handleChangeField('institutionDescription', institution.description);
            this.institutionDescriptionRef.current.handleChangeField(institution.description);
            this.handleChangeField('institutionHomeUrl', institution.homeUrl);
            this.institutionHomeUrlRef.current.handleChangeField(institution.homeUrl);
            this.handleChangeField('institutionLocation', institution.location.shortId);
            this.institutionLocationRef.current.handleChangeField(institution.location.shortId);
        });
        this.state = {
            fieldsChanged: new Set(),
            institutionSelected: ''
        };
        // Refs to chaneg institution fiends when one is loaded from the dropdown.
        // ReversibleInput component wasn't intended to be changed from the outside. This is a hack but
        // there is no time to refactor the component.
        this.institutionRorIdRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionNameRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionDescriptionRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionHomeUrlRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionLocationRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
    }
    render() {
        const { handleChangeField: handleChangeField, handleClickAmend: handleClickAmend, handleClickValidate: handleClickValidate, handleSelectInstitution: handleSelectInstitution, props: { isOpen: isOpen, institutionList: institutionList, locationList: locationList, prefixRegistrationSession: { prefixRegistrationRequest: prefixRegistrationRequest }, prefixRegistrationSessionAmend: prefixRegistrationSessionAmend }, state: { institutionSelected: institutionSelected } } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-edit"
                                }),
                                " New amend"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-leaf"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Prefix details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold align-middle",
                                                    children: "Resource name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "name",
                                                        defaultValue: prefixRegistrationRequest.name,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold align-middle",
                                                    children: "Description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "description",
                                                        defaultValue: prefixRegistrationRequest.description,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: "5"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Requested prefix"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "requestedPrefix",
                                                        defaultValue: prefixRegistrationRequest.requestedPrefix,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Sample ID"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "sampleId",
                                                        defaultValue: prefixRegistrationRequest.sampleId,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Regex pattern"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "idRegexPattern",
                                                        defaultValue: prefixRegistrationRequest.idRegexPattern,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Namespace in LUI"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "namespaceEmbeddedInLui",
                                                        defaultValue: prefixRegistrationRequest.namespaceEmbeddedInLui,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "form-check-input"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "supporting references"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "supportingReferences",
                                                        defaultValue: prefixRegistrationRequest.supportingReferences,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Additional information"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "additionalInformation",
                                                        defaultValue: prefixRegistrationRequest.additionalInformation,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-sitemap"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Institution details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Institution"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                        className: "form-control form-select",
                                                        id: "institutiondropdown",
                                                        value: institutionSelected,
                                                        onChange: handleSelectInstitution,
                                                        children: [
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Autofill institution..."
                                                            }),
                                                            institutionList.map((institution)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: institution.shortId,
                                                                    children: institution.name
                                                                }, `institution-${institution.shortId}`))
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "ROR Id"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionRorId",
                                                        defaultValue: prefixRegistrationRequest.institutionRorId,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionRorIdRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionName",
                                                        defaultValue: prefixRegistrationRequest.institutionName,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionNameRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionDescription",
                                                        defaultValue: prefixRegistrationRequest.institutionDescription,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionDescriptionRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Home URL"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionHomeUrl",
                                                        defaultValue: prefixRegistrationRequest.institutionHomeUrl,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionHomeUrlRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionLocation",
                                                        defaultValue: prefixRegistrationRequest.institutionLocation,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionLocationRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                            className: "form-control",
                                                            value: prefixRegistrationSessionAmend.institutionLocation,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select location..."
                                                                }),
                                                                locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                        value: location.shortId,
                                                                        children: location.label
                                                                    }, `option-${location.shortId}`))
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-cube"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Provider details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerName",
                                                        defaultValue: prefixRegistrationRequest.providerName,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerDescription",
                                                        defaultValue: prefixRegistrationRequest.providerDescription,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Home URL"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerHomeUrl",
                                                        defaultValue: prefixRegistrationRequest.providerHomeUrl,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Provider code"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerCode",
                                                        defaultValue: prefixRegistrationRequest.providerCode,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "URL Pattern"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerUrlPattern",
                                                        defaultValue: prefixRegistrationRequest.providerUrlPattern,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "has Protected URLs?"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "protectedUrls",
                                                        defaultValue: prefixRegistrationRequest.protectedUrls,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "checkbox"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Render protected landing?"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "renderProtectedLanding",
                                                        defaultValue: prefixRegistrationRequest.renderProtectedLanding,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "checkbox"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Auth description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "authHelpDescription",
                                                        defaultValue: prefixRegistrationRequest.authHelpDescription,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Auth URL"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "authHelpUrl",
                                                        defaultValue: prefixRegistrationRequest.authHelpUrl,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerLocation",
                                                        defaultValue: prefixRegistrationRequest.providerLocation,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                            className: "form-control",
                                                            value: prefixRegistrationSessionAmend.providerLocation,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select location..."
                                                                }),
                                                                locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                        value: location.shortId,
                                                                        children: location.label
                                                                    }, `option-${location.shortId}`))
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-user"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Requester details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Full name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "requesterName",
                                                        defaultValue: prefixRegistrationRequest.requesterName,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "requesterEmail",
                                                        defaultValue: prefixRegistrationRequest.requesterEmail,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-6 mt-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                className: "btn btn-warning w-100 me-1 no-highlight-visited",
                                href: "#!",
                                onClick: handleClickValidate,
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-check"
                                    }),
                                    " Perform validation"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-6 mt-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                className: "btn btn-warning w-100 ms-1 no-highlight-visited",
                                href: "#!",
                                onClick: handleClickAmend,
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-edit"
                                    }),
                                    " Confirm amend"
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : null;
    }
}
// Mapping
const $729fa0f20d84171a$var$mapStateToProps = (state)=>({
        prefixRegistrationSession: state.curationDashboard.prefixRegistrationSession,
        prefixRegistrationSessionAmend: state.curationDashboard.prefixRegistrationSessionAmend,
        institutionList: state.institutionList,
        locationList: state.locationList
    });
const $729fa0f20d84171a$var$mapDispatchToProps = (dispatch)=>({
        getInstitutionFromRegistry: (institutionId)=>dispatch((0, $c3dc2e9b5981d644$export$e78039615e6b2be0)(institutionId)),
        prefixRegistrationRequestAmend: (id, prefixRegistrationRequest, additionalInformation)=>dispatch((0, $5973b98c9401bfd3$export$acfa29766acd2a75)(id, prefixRegistrationRequest, additionalInformation)),
        setPrefixRegistrationSessionAmendField: (field, value)=>dispatch((0, $77331a657270a7ed$export$74718fb23d8f954f)(field, value, 'prefix'))
    });
var $729fa0f20d84171a$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($729fa0f20d84171a$var$mapStateToProps, $729fa0f20d84171a$var$mapDispatchToProps)($729fa0f20d84171a$var$PrefixRegistrationSessionAmendForm);





var $dBNnn = parcelRequire("dBNnn");


//
// RegistrationSessionComment actions.
//
// Redux store update for registration session new comment.
const $fcf34a000d6a7ee8$export$72d12b63b07eac5 = (comment, additionalInformation, registrationSessionType)=>{
    const action = {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONCOMMENT`,
        comment: comment,
        additionalInformation: additionalInformation
    };
    return action;
};



class $4913e7844933bdf5$var$PrefixRegistrationSessionCommentForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleComment", async ()=>{
            const { id: id, handleFormSubmit: handleFormSubmit, prefixRegistrationRequestComment: prefixRegistrationRequestComment, setPrefixRegistrationSessionComment: setPrefixRegistrationSessionComment } = this.props;
            const { comment: comment } = this.state;
            if (!comment || comment === '') return;
            const response = await prefixRegistrationRequestComment(id, comment);
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Prefix Registration Request comment added successfully'
                });
                setPrefixRegistrationSessionComment('', '');
                handleFormSubmit();
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not add comment to Prefix Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleCommentChange", (e)=>{
            const { setPrefixRegistrationSessionComment: setPrefixRegistrationSessionComment } = this.props;
            setPrefixRegistrationSessionComment(e.target.value, 'additionalInformation');
        });
        this.state = {
            comment: this.props.prefixRegistrationSessionComment.comment
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If comment changed, change state.
        if (nextProps.prefixRegistrationSessionComment.comment !== prevState.comment) return {
            comment: nextProps.prefixRegistrationSessionComment.comment
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, state: { comment: comment }, handleComment: handleComment, handleCommentChange: handleCommentChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Add comment to request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Comment"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Comment reason",
                                    onChange: handleCommentChange,
                                    value: comment
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-secondary w-100 text-white",
                            href: "#!",
                            onClick: handleComment,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-plus"
                                }),
                                " Add comment"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $4913e7844933bdf5$var$mapStateToProps = (state)=>({
        prefixRegistrationSessionComment: state.curationDashboard.prefixRegistrationSessionComment
    });
const $4913e7844933bdf5$var$mapDispatchToProps = (dispatch)=>({
        prefixRegistrationRequestComment: (id, reason)=>dispatch((0, $5973b98c9401bfd3$export$2b3aef57b1406a97)(id, reason)),
        setPrefixRegistrationSessionComment: (comment)=>dispatch((0, $fcf34a000d6a7ee8$export$72d12b63b07eac5)(comment, undefined, 'prefix'))
    });
var $4913e7844933bdf5$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($4913e7844933bdf5$var$mapStateToProps, $4913e7844933bdf5$var$mapDispatchToProps)($4913e7844933bdf5$var$PrefixRegistrationSessionCommentForm);





var $dBNnn = parcelRequire("dBNnn");



//
// RegistrationSessionReject actions.
//
// Redux store update for registration session new reject.
const $3f52de16fcf58df5$export$71755c40e1fcc4f1 = (rejectionReason, additionalInformation, registrationSessionType)=>{
    const action = {
        type: `SET_${registrationSessionType.toUpperCase()}REGISTRATIONSESSIONREJECT`,
        rejectionReason: rejectionReason,
        additionalInformation: additionalInformation
    };
    return action;
};



class $b4d723416af22f04$var$PrefixRegistrationSessionRejectForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleReject", async ()=>{
            const { id: id, prefixRegistrationRequestReject: prefixRegistrationRequestReject, setPrefixRegistrationSessionReject: setPrefixRegistrationSessionReject, navigate: navigate } = this.props;
            const { rejectionReason: rejectionReason } = this.state;
            const response = await prefixRegistrationRequestReject(id, rejectionReason || 'No rejection reason specified.');
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Prefix Registration Request rejected succesfully'
                });
                setPrefixRegistrationSessionReject('', '');
                navigate('/curation');
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not reject Prefix Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleRejectionReasonChange", (e)=>{
            const { setPrefixRegistrationSessionReject: setPrefixRegistrationSessionReject } = this.props;
            setPrefixRegistrationSessionReject(e.target.value, 'additionalInformation');
        });
        this.state = {
            rejectionReason: this.props.prefixRegistrationSessionReject.rejectionReason
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If rejectionReason changed, change state.
        if (nextProps.prefixRegistrationSessionReject.rejectionReason !== prevState.rejectionReason) return {
            rejectionReason: nextProps.prefixRegistrationSessionReject.rejectionReason
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, handleReject: handleReject, handleRejectionReasonChange: handleRejectionReasonChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4 rounded-all-but-top-right-lg",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Reject request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Rejection reason"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Rejectace reason",
                                    onChange: handleRejectionReasonChange
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-danger w-100 text-white",
                            href: "#!",
                            onClick: handleReject,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-times"
                                }),
                                " Confirm reject"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $b4d723416af22f04$var$mapStateToProps = (state)=>({
        prefixRegistrationSessionReject: state.curationDashboard.prefixRegistrationSessionReject
    });
const $b4d723416af22f04$var$mapDispatchToProps = (dispatch)=>({
        prefixRegistrationRequestReject: (id, reason)=>dispatch((0, $5973b98c9401bfd3$export$e47dc073c4b000b2)(id, reason)),
        setPrefixRegistrationSessionReject: (rejectionReason)=>dispatch((0, $3f52de16fcf58df5$export$71755c40e1fcc4f1)(rejectionReason, undefined, 'prefix'))
    });
const $b4d723416af22f04$var$ConnectedPrefixRegistrationSessionRejectForm = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($b4d723416af22f04$var$mapStateToProps, $b4d723416af22f04$var$mapDispatchToProps)($b4d723416af22f04$var$PrefixRegistrationSessionRejectForm);
var $b4d723416af22f04$export$2e2bcd8739ae039 = (props)=>{
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($b4d723416af22f04$var$ConnectedPrefixRegistrationSessionRejectForm, {
        ...props,
        navigate: navigate
    });
};





class $81b074b0662e2fab$var$ManagePrefixRegistrationRequestPage extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updatePrefixRegistrationSession", (id)=>{
            this.props.getPrefixRegistrationSession(id);
        });
        //
        // Form management functions.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "hideAllForms", ()=>{
            this.setState({
                acceptFormVisible: false,
                amendFormVisible: false,
                commentFormVisible: false,
                rejectFormVisible: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleFormVisibility", (formName)=>{
            const { id: id } = this.props.params;
            this.hideAllForms();
            this.setState({
                [`${formName}Visible`]: !this.state[`${formName}Visible`]
            });
            this.updatePrefixRegistrationSession(id);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleFormSubmit", ()=>{
            const { id: id } = this.props.params;
            this.hideAllForms();
            this.updatePrefixRegistrationSession(id);
        });
        this.state = {
            acceptFormVisible: false,
            amendFormVisible: false,
            commentFormVisible: false,
            rejectFormVisible: false
        };
    }
    componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
        const { id: id } = this.props.params;
        this.updatePrefixRegistrationSession(id);
    }
    render() {
        const { handleFormSubmit: handleFormSubmit, handleFormVisibility: handleFormVisibility, props: { prefixRegistrationSession: { prefixRegistrationRequest: prefixRegistrationRequest, prefixRegistrationSessionEvents: prefixRegistrationSessionEvents }, params: { id: id } }, state: { acceptFormVisible: acceptFormVisible, amendFormVisible: amendFormVisible, commentFormVisible: commentFormVisible, rejectFormVisible: rejectFormVisible } } = this;
        return !prefixRegistrationRequest ? '' : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                    icon: "icon-leaf",
                    title: `Managing request:`,
                    extraTitle: prefixRegistrationRequest.name
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-hand-point-up"
                                        }),
                                        " Current request details"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $15915c864f56169e$export$2e2bcd8739ae039), {
                                    data: prefixRegistrationRequest
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row mt-5 mx-0",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Accept",
                            color: "success",
                            handleShow: ()=>handleFormVisibility('acceptForm'),
                            icon: "check",
                            isCancel: acceptFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Amend",
                            color: "warning",
                            handleShow: ()=>handleFormVisibility('amendForm'),
                            icon: "edit",
                            isCancel: amendFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Comment",
                            color: "secondary",
                            handleShow: ()=>handleFormVisibility('commentForm'),
                            icon: "comment",
                            isCancel: commentFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Reject",
                            color: "danger",
                            handleShow: ()=>handleFormVisibility('rejectForm'),
                            icon: "times",
                            isCancel: rejectFormVisible
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $52301abfec5370a9$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: acceptFormVisible
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $729fa0f20d84171a$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: amendFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $4913e7844933bdf5$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: commentFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $b4d723416af22f04$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: rejectFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("hr", {
                    className: "my-5"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-history"
                                    }),
                                    " Previous events"
                                ]
                            }),
                            prefixRegistrationSessionEvents.map((prse)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bc645780c41f7c76$export$2e2bcd8739ae039), {
                                    data: prse,
                                    registrationSessionType: "prefix"
                                }, `prse-${prse.name}-${prse.created}`))
                        ]
                    })
                })
            ]
        });
    }
}
// Mapping
const $81b074b0662e2fab$var$mapStateToProps = (state)=>({
        prefixRegistrationSession: state.curationDashboard.prefixRegistrationSession
    });
const $81b074b0662e2fab$var$mapDispatchToProps = (dispatch)=>({
        getPrefixRegistrationSession: (params)=>dispatch((0, $5973b98c9401bfd3$export$6a4e501b1ad77fba)(params))
    });
const $81b074b0662e2fab$var$ConnectedManagePrefixRegistrationRequestPage = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($81b074b0662e2fab$var$mapStateToProps, $81b074b0662e2fab$var$mapDispatchToProps)($81b074b0662e2fab$var$ManagePrefixRegistrationRequestPage);
function $81b074b0662e2fab$export$2e2bcd8739ae039(props) {
    const params = (0, $bfdf1f7a109a1ee5$export$99eaa27ddbbb95ef)();
    const matomo = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($81b074b0662e2fab$var$ConnectedManagePrefixRegistrationRequestPage, {
        ...props,
        matomo: matomo,
        params: params
    });
}





var $dBNnn = parcelRequire("dBNnn");



// Config.




const $d97ca66fc50ed502$export$923512c69f364fc3 = (id)=>{
    return async (dispatch, getState)=>{
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const requestUrl = new URL(`${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/resourceRegistrationSessions/${id}`);
        const init = {
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        };
        let data;
        try {
            const response = await fetch(requestUrl, init);
            data = await response.json();
        } catch (err) {
            console.error('Error fetching resource registration request: ', err);
            return;
        }
        // Fetches current resourceRegistrationRequest.
        await (0, $df9764f9470d541a$export$adb5405149b9ba8a)(data, [
            {
                name: 'resourceRegistrationRequest',
                url: data._links.resourceRegistrationRequest.href
            }
        ], init);
        const eventsUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/restApi/resourceRegistrationSessionEvents/search/findByResourceRegistrationSessionId?id=${id}`;
        const eventsResponse = await fetch(eventsUrl, init);
        let eventsData = await eventsResponse.json();
        // Fetch amend event resourceRegistrationRequest.
        if (eventsData._embedded.resourceRegistrationSessionEventAmends) eventsData._embedded.resourceRegistrationSessionEventAmends = await Promise.all(eventsData._embedded.resourceRegistrationSessionEventAmends.map((event)=>{
            return (0, $df9764f9470d541a$export$adb5405149b9ba8a)(event, [
                {
                    name: 'resourceRegistrationRequest',
                    url: event._links.resourceRegistrationRequest.href
                }
            ], init);
        }));
        // Also fetch start event resourceRegistrationRequest.
        const event = eventsData._embedded.resourceRegistrationSessionEventStarts[0];
        eventsData._embedded.resourceRegistrationSessionEventStarts[0] = await (0, $df9764f9470d541a$export$adb5405149b9ba8a)(event, [
            {
                name: 'resourceRegistrationRequest',
                url: event._links.resourceRegistrationRequest.href
            }
        ], init);
        // Flatten event list and sort by date.
        let events = Object.keys(eventsData._embedded).map((_)=>eventsData._embedded[_]);
        data.resourceRegistrationSessionEvents = events.flat();
        data.resourceRegistrationSessionEvents.sort((a, b)=>new Date(b.created) - new Date(a.created));
        // Dispatch redux state update.
        dispatch($d97ca66fc50ed502$export$21a16bb62c998db3(data));
        // Prepare amend template in state as a copy of the request.
        dispatch((0, $77331a657270a7ed$export$66c277e8e4d86f3f)(data.resourceRegistrationRequest, 'resource'));
        return data;
    };
};
const $d97ca66fc50ed502$export$21a16bb62c998db3 = (resourceRegistrationSession)=>{
    return {
        type: 'SET_RESOURCEREGISTRATIONSESSION',
        resourceRegistrationSession: resourceRegistrationSession
    };
};
const $d97ca66fc50ed502$export$260c51e79f7bf960 = (id, reason)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRegistrationEndpoint}/acceptResourceRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    acceptanceReason: reason
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $d97ca66fc50ed502$export$6d4db88c0a9c1ea2 = (id, reason)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRegistrationEndpoint}/rejectResourceRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    rejectionReason: reason
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $d97ca66fc50ed502$export$3b4b9620994ddca4 = (id, comment)=>{
    return async (undefined, getState)=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRegistrationEndpoint}/commentResourceRegistrationRequest/${id}`;
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: 'Source: curation web interface',
                    comment: comment
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};
const $d97ca66fc50ed502$export$6602753bd24ec520 = (id, resourceRegistrationRequest, additionalInformation)=>{
    return async ()=>{
        const requestUrl = `${(0, $f5375947831a300f$export$e506a1d27d1eaa20).registryApi}/${(0, $f5375947831a300f$export$e506a1d27d1eaa20).resourceRegistrationEndpoint}/amendResourceRegistrationRequest/${id}`;
        // Data transformation for the API. This should be extracted to a model converter.
        // Requester data must be inside a subobject.
        resourceRegistrationRequest['requester'] = {
            name: resourceRegistrationRequest.requesterName,
            email: resourceRegistrationRequest.requesterEmail
        };
        // Also, country codes must be trimmed in institutionLocation and providerLocation.
        resourceRegistrationRequest.institutionLocation = resourceRegistrationRequest.institutionLocation.split('/').pop();
        resourceRegistrationRequest.providerLocation = resourceRegistrationRequest.providerLocation.split('/').pop();
        const authToken = await (0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7)();
        const init = {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            body: JSON.stringify({
                apiVersion: (0, $f5375947831a300f$export$e506a1d27d1eaa20).apiVersion,
                payload: {
                    additionalInformation: additionalInformation || 'Source: curation web interface',
                    resourceRegistrationRequest: resourceRegistrationRequest
                }
            })
        };
        return await fetch(requestUrl, init);
    };
};







var $dBNnn = parcelRequire("dBNnn");





class $0f01519269721c53$var$ResourceRegistrationSessionAcceptForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleAccept", async ()=>{
            const { id: id, resourceRegistrationRequestAccept: resourceRegistrationRequestAccept, setResourceRegistrationSessionAccept: setResourceRegistrationSessionAccept } = this.props;
            const { acceptanceReason: acceptanceReason } = this.state;
            const response = await resourceRegistrationRequestAccept(id, acceptanceReason || 'No acceptance reason specified.');
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Resource Registration Request accepted succesfully'
                });
                setResourceRegistrationSessionAccept('', '');
                this.props.navigate('/curation');
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not accept Resource Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleAcceptanceReasonChange", (e)=>{
            const { setResourceRegistrationSessionAccept: setResourceRegistrationSessionAccept } = this.props;
            setResourceRegistrationSessionAccept(e.target.value, 'additionalInformation');
        });
        this.state = {
            acceptanceReason: this.props.resourceRegistrationSessionAccept.acceptanceReason
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If acceptanceReason changed, change state.
        if (nextProps.resourceRegistrationSessionAccept.acceptanceReason !== prevState.acceptanceReason) return {
            acceptanceReason: nextProps.resourceRegistrationSessionAccept.acceptanceReason
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, handleAccept: handleAccept, handleAcceptanceReasonChange: handleAcceptanceReasonChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4 rounded-all-but-top-left-lg",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Accept request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Acceptance reason"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Acceptace reason",
                                    onChange: handleAcceptanceReasonChange
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-success w-100 text-white",
                            href: "#!",
                            onClick: handleAccept,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Confirm approval"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $0f01519269721c53$var$mapStateToProps = (state)=>({
        resourceRegistrationSessionAccept: state.curationDashboard.resourceRegistrationSessionAccept
    });
const $0f01519269721c53$var$mapDispatchToProps = (dispatch)=>({
        resourceRegistrationRequestAccept: (id, reason)=>dispatch((0, $d97ca66fc50ed502$export$260c51e79f7bf960)(id, reason)),
        setResourceRegistrationSessionAccept: (acceptanceReason)=>dispatch((0, $2d5e9727fc6969a9$export$e461252096d6a232)(acceptanceReason, undefined, 'resource'))
    });
const $0f01519269721c53$var$ConnectedResourceRegistrationSessionAcceptForm = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($0f01519269721c53$var$mapStateToProps, $0f01519269721c53$var$mapDispatchToProps)($0f01519269721c53$var$ResourceRegistrationSessionAcceptForm);
function $0f01519269721c53$export$2e2bcd8739ae039(props) {
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($0f01519269721c53$var$ConnectedResourceRegistrationSessionAcceptForm, {
        ...props,
        navigate: navigate
    });
}





var $dBNnn = parcelRequire("dBNnn");







class $f4e9169e76646b3d$var$ResourceRegistrationSessionAmendForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickAmend", async ()=>{
            const { id: id, handleFormSubmit: handleFormSubmit, resourceRegistrationRequestAmend: resourceRegistrationRequestAmend, resourceRegistrationSessionAmend: resourceRegistrationSessionAmend } = this.props;
            const response = await resourceRegistrationRequestAmend(id, resourceRegistrationSessionAmend);
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Resource Registration Request amended succesfully'
                });
                handleFormSubmit();
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not amend Resource Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleClickValidate", async ()=>{
            const { resourceRegistrationSessionAmend: resourceRegistrationSessionAmend } = this.props;
            const fieldsToValidate = [
                ...this.state.fieldsChanged
            ];
            if (fieldsToValidate.length === 0) {
                (0, $c76c78ebffccd857$export$4cc0fb945c4ba96e)('No fields have changed');
                return;
            }
            const validations = await Promise.all(fieldsToValidate.map((field)=>(0, $bafaab9173a4f7a3$export$2e2bcd8739ae039)[field](resourceRegistrationSessionAmend[field], resourceRegistrationSessionAmend, 'resource')));
            const toastMessage = validations.filter((validations)=>!validations.valid).map((validations)=>validations.errorMessage).join('\n');
            if (toastMessage !== '') (0, $c76c78ebffccd857$export$85ee8a1f69fea720)(toastMessage, undefined, 10000);
            else (0, $c76c78ebffccd857$export$73e19c0339806233)('All fields OK!');
        });
        //
        // Field manipulation handler. Undefined 'value' field will revert to default.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleChangeField", (field, value)=>{
            const { setResourceRegistrationSessionAmendField: setResourceRegistrationSessionAmendField, resourceRegistrationSession: { resourceRegistrationRequest: resourceRegistrationRequest } } = this.props;
            if (typeof value === 'undefined') value = resourceRegistrationRequest[field];
            setResourceRegistrationSessionAmendField(field, value);
            // Add/remove field to changed list if modified/reset, so it is validated or not when clicked on the perform
            // validation button.
            if (resourceRegistrationRequest[field] !== value) this.setState((prevState)=>({
                    fieldsChanged: prevState.fieldsChanged.add(field)
                }));
            else this.setState((prevState)=>{
                prevState.fieldsChanged.delete(field);
                return {
                    fieldsChanged: prevState.fieldsChanged
                };
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleSelectInstitution", async (e)=>{
            const { getInstitutionFromRegistry: getInstitutionFromRegistry } = this.props;
            const institutionShortId = e.target.value;
            const institution = await getInstitutionFromRegistry(institutionShortId);
            this.setState({
                institutionSelected: institutionShortId
            });
            this.handleChangeField('rorId', institution.rorId);
            this.institutionRorIdRef.current.handleChangeField(institution.rorId || '');
            this.handleChangeField('institutionName', institution.name);
            this.institutionNameRef.current.handleChangeField(institution.name);
            this.handleChangeField('institutionDescription', institution.description);
            this.institutionDescriptionRef.current.handleChangeField(institution.description);
            this.handleChangeField('institutionHomeUrl', institution.homeUrl);
            this.institutionHomeUrlRef.current.handleChangeField(institution.homeUrl);
            this.handleChangeField('institutionLocation', institution.location.shortId);
            this.institutionLocationRef.current.handleChangeField(institution.location.shortId);
        });
        this.state = {
            fieldsChanged: new Set(),
            institutionSelected: ''
        };
        // Refs to chaneg institution fiends when one is loaded from the dropdown.
        // ReversibleInput component wasn't intended to be changed from the outside. This is a hack but
        // there is no time to refactor the component.
        this.institutionRorIdRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionNameRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionDescriptionRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionHomeUrlRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
        this.institutionLocationRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createRef();
    }
    render() {
        const { handleChangeField: handleChangeField, handleClickAmend: handleClickAmend, handleClickValidate: handleClickValidate, handleSelectInstitution: handleSelectInstitution, props: { institutionList: institutionList, isOpen: isOpen, locationList: locationList, resourceRegistrationSession: { resourceRegistrationRequest: resourceRegistrationRequest }, resourceRegistrationSessionAmend: resourceRegistrationSessionAmend }, state: { institutionSelected: institutionSelected } } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-edit"
                                }),
                                " New amend"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-leaf"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Resource details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("tbody", {
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-25 align-middle ps-2 fw-bold align-middle",
                                                children: "Namespace Prefix"
                                            }),
                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                className: "w-75",
                                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                    fieldName: "namespacePrefix",
                                                    defaultValue: resourceRegistrationRequest.namespacePrefix,
                                                    handleChangeField: handleChangeField,
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                        type: "text"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-sitemap"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Institution details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Institution"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                        className: "form-control form-select",
                                                        id: "institutiondropdown",
                                                        value: institutionSelected,
                                                        onChange: handleSelectInstitution,
                                                        children: [
                                                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                value: "",
                                                                children: "Autofill institution..."
                                                            }),
                                                            institutionList.map((institution)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: institution.shortId,
                                                                    children: institution.name
                                                                }, `institution-${institution.shortId}`))
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "ROR Id"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "rorId",
                                                        defaultValue: resourceRegistrationRequest.institutionRorId || '',
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionRorIdRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionName",
                                                        defaultValue: resourceRegistrationRequest.institutionName,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionNameRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionDescription",
                                                        defaultValue: resourceRegistrationRequest.institutionDescription,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionDescriptionRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Home URL"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionHomeUrl",
                                                        defaultValue: resourceRegistrationRequest.institutionHomeUrl,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionHomeUrlRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "institutionLocation",
                                                        defaultValue: resourceRegistrationRequest.institutionLocation,
                                                        handleChangeField: handleChangeField,
                                                        ref: this.institutionLocationRef,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                            className: "form-control",
                                                            value: resourceRegistrationSessionAmend.institutionLocation,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select location..."
                                                                }),
                                                                locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                        value: location.shortId,
                                                                        children: location.label
                                                                    }, `option-${location.shortId}`))
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-cube"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Provider details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerName",
                                                        defaultValue: resourceRegistrationRequest.providerName,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "description"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerDescription",
                                                        defaultValue: resourceRegistrationRequest.providerDescription,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                                            rows: 5
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Home URL"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerHomeUrl",
                                                        defaultValue: resourceRegistrationRequest.providerHomeUrl,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Provider code"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerCode",
                                                        defaultValue: resourceRegistrationRequest.providerCode,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "URL Pattern"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerUrlPattern",
                                                        defaultValue: resourceRegistrationRequest.providerUrlPattern,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Sample ID"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "sampleId",
                                                        defaultValue: resourceRegistrationRequest.sampleId,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Location"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "providerLocation",
                                                        defaultValue: resourceRegistrationRequest.providerLocation,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("select", {
                                                            className: "form-control",
                                                            value: resourceRegistrationSessionAmend.providerLocation,
                                                            children: [
                                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                    value: "",
                                                                    disabled: true,
                                                                    children: "Select location..."
                                                                }),
                                                                locationList.map((location)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("option", {
                                                                        value: location.id,
                                                                        children: location.label
                                                                    }, `option-${location.id}`))
                                                            ]
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-4 col-lg-3 col-xl-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-user"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("strong", {
                                        children: "Requester details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-sm-8 col-lg-9 col-xl-10",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("table", {
                                className: "table table-sm m-0 table-borderless table-striped",
                                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tbody", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Full name"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "requesterName",
                                                        defaultValue: resourceRegistrationRequest.requesterName,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-25 align-middle ps-2 fw-bold",
                                                    children: "Email"
                                                }),
                                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("td", {
                                                    className: "w-75",
                                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $e268fa1eccea0890$export$2e2bcd8739ae039), {
                                                        fieldName: "requesterEmail",
                                                        defaultValue: resourceRegistrationRequest.requesterEmail,
                                                        handleChangeField: handleChangeField,
                                                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("input", {
                                                            type: "text"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-6 mt-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                className: "btn btn-warning - me-1 no-highlight-visited",
                                href: "#!",
                                onClick: handleClickValidate,
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-check"
                                    }),
                                    " Perform validation"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                            className: "col col-6 mt-2",
                            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                                className: "btn btn-warning w-100 ms-1 no-highlight-visited",
                                href: "#!",
                                onClick: handleClickAmend,
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-edit"
                                    }),
                                    " Confirm amend"
                                ]
                            })
                        })
                    ]
                })
            ]
        }) : null;
    }
}
// Mapping
const $f4e9169e76646b3d$var$mapStateToProps = (state)=>({
        resourceRegistrationSession: state.curationDashboard.resourceRegistrationSession,
        resourceRegistrationSessionAmend: state.curationDashboard.resourceRegistrationSessionAmend,
        institutionList: state.institutionList,
        locationList: state.locationList
    });
const $f4e9169e76646b3d$var$mapDispatchToProps = (dispatch)=>({
        getInstitutionFromRegistry: (institutionId)=>dispatch((0, $c3dc2e9b5981d644$export$e78039615e6b2be0)(institutionId)),
        resourceRegistrationRequestAmend: (id, resourceRegistrationRequest, additionalInformation)=>dispatch((0, $d97ca66fc50ed502$export$6602753bd24ec520)(id, resourceRegistrationRequest, additionalInformation)),
        setResourceRegistrationSessionAmendField: (field, value)=>dispatch((0, $77331a657270a7ed$export$74718fb23d8f954f)(field, value, 'resource'))
    });
var $f4e9169e76646b3d$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($f4e9169e76646b3d$var$mapStateToProps, $f4e9169e76646b3d$var$mapDispatchToProps)($f4e9169e76646b3d$var$ResourceRegistrationSessionAmendForm);





var $dBNnn = parcelRequire("dBNnn");




class $bc6cb1afad1e9fd7$var$ResourceRegistrationSessionCommentForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleComment", async ()=>{
            const { id: id, handleFormSubmit: handleFormSubmit, resourceRegistrationRequestComment: resourceRegistrationRequestComment, setResourceRegistrationSessionComment: setResourceRegistrationSessionComment } = this.props;
            const { comment: comment } = this.state;
            if (!comment || comment === '') return;
            const response = await resourceRegistrationRequestComment(id, comment);
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Resource Registration Request comment added successfully'
                });
                setResourceRegistrationSessionComment('', '');
                handleFormSubmit();
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not add comment to Resource Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleCommentChange", (e)=>{
            const { setResourceRegistrationSessionComment: setResourceRegistrationSessionComment } = this.props;
            setResourceRegistrationSessionComment(e.target.value, 'additionalInformation');
        });
        this.state = {
            comment: this.props.resourceRegistrationSessionComment.comment
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If comment changed, change state.
        if (nextProps.resourceRegistrationSessionComment.comment !== prevState.comment) return {
            comment: nextProps.resourceRegistrationSessionComment.comment
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, state: { comment: comment }, handleComment: handleComment, handleCommentChange: handleCommentChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Add comment to request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Comment"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Comment reason",
                                    onChange: handleCommentChange,
                                    value: comment
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-secondary w-100 text-white",
                            href: "#!",
                            onClick: handleComment,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-plus"
                                }),
                                " Add comment"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $bc6cb1afad1e9fd7$var$mapStateToProps = (state)=>({
        resourceRegistrationSessionComment: state.curationDashboard.resourceRegistrationSessionComment
    });
const $bc6cb1afad1e9fd7$var$mapDispatchToProps = (dispatch)=>({
        resourceRegistrationRequestComment: (id, reason)=>dispatch((0, $d97ca66fc50ed502$export$3b4b9620994ddca4)(id, reason)),
        setResourceRegistrationSessionComment: (comment)=>dispatch((0, $fcf34a000d6a7ee8$export$72d12b63b07eac5)(comment, undefined, 'resource'))
    });
var $bc6cb1afad1e9fd7$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($bc6cb1afad1e9fd7$var$mapStateToProps, $bc6cb1afad1e9fd7$var$mapDispatchToProps)($bc6cb1afad1e9fd7$var$ResourceRegistrationSessionCommentForm);





var $dBNnn = parcelRequire("dBNnn");





class $305e64740d2a45ac$var$ResourceRegistrationSessionRejectForm extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleReject", async ()=>{
            const { id: id, resourceRegistrationRequestReject: resourceRegistrationRequestReject, setResourceRegistrationSessionReject: setResourceRegistrationSessionReject, navigate: navigate } = this.props;
            const { rejectionReason: rejectionReason } = this.state;
            const response = await resourceRegistrationRequestReject(id, rejectionReason || 'No rejection reason specified.');
            if (response.status === 200) {
                await (0, $c76c78ebffccd857$export$e8ef7fe519636aa2).fire({
                    title: 'Resource Registration Request rejected succesfully'
                });
                setResourceRegistrationSessionReject('', '');
                navigate('/curation');
            } else await (0, $c76c78ebffccd857$export$438b25931d46d7ec).fire({
                title: 'Error',
                text: 'Could not reject Resource Registration Request'
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleRejectionReasonChange", (e)=>{
            const { setResourceRegistrationSessionReject: setResourceRegistrationSessionReject } = this.props;
            setResourceRegistrationSessionReject(e.target.value, 'additionalInformation');
        });
        this.state = {
            rejectionReason: this.props.resourceRegistrationSessionReject.rejectionReason
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        // If rejectionReason changed, change state.
        if (nextProps.resourceRegistrationSessionReject.rejectionReason !== prevState.rejectionReason) return {
            rejectionReason: nextProps.resourceRegistrationSessionReject.rejectionReason
        };
        else return null;
    }
    render() {
        const { props: { isOpen: isOpen }, handleReject: handleReject, handleRejectionReasonChange: handleRejectionReasonChange } = this;
        return isOpen ? /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
            className: "bg-gray pt-3 pb-2 px-4 rounded-all-but-top-right-lg",
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mb-3",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-check"
                                }),
                                " Reject request"
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row g-0 align-items-center bg-light rounded p-2 mb-1",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "input-group",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("span", {
                                    className: "input-group-text",
                                    children: "Rejection reason"
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("textarea", {
                                    className: "form-control",
                                    "aria-label": "Rejectace reason",
                                    onChange: handleRejectionReasonChange
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col mt-2",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("a", {
                            className: "btn btn-danger w-100 text-white",
                            href: "#!",
                            onClick: handleReject,
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                    className: "icon icon-common icon-times"
                                }),
                                " Confirm reject"
                            ]
                        })
                    })
                })
            ]
        }) : null;
    }
}
// Mapping
const $305e64740d2a45ac$var$mapStateToProps = (state)=>({
        resourceRegistrationSessionReject: state.curationDashboard.resourceRegistrationSessionReject
    });
const $305e64740d2a45ac$var$mapDispatchToProps = (dispatch)=>({
        resourceRegistrationRequestReject: (id, reason)=>dispatch((0, $d97ca66fc50ed502$export$6d4db88c0a9c1ea2)(id, reason)),
        setResourceRegistrationSessionReject: (rejectionReason)=>dispatch((0, $3f52de16fcf58df5$export$71755c40e1fcc4f1)(rejectionReason, undefined, 'resource'))
    });
const $305e64740d2a45ac$var$ConnectedResourceRegistrationSessionRejectForm = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($305e64740d2a45ac$var$mapStateToProps, $305e64740d2a45ac$var$mapDispatchToProps)($305e64740d2a45ac$var$ResourceRegistrationSessionRejectForm);
var $305e64740d2a45ac$export$2e2bcd8739ae039 = (props)=>{
    const navigate = (0, $bfdf1f7a109a1ee5$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($305e64740d2a45ac$var$ConnectedResourceRegistrationSessionRejectForm, {
        ...props,
        navigate: navigate
    });
};




class $c5889211749d5491$var$ManageResourceRegistrationRequestPage extends (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).Component {
    constructor(props){
        super(props);
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "updateResourceRegistrationSession", (id)=>{
            this.props.getResourceRegistrationSession(id);
        });
        //
        // Form management functions.
        //
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "hideAllForms", ()=>{
            this.setState({
                acceptFormVisible: false,
                amendFormVisible: false,
                commentFormVisible: false,
                rejectFormVisible: false
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleFormVisibility", (formName)=>{
            const { id: id } = this.props.params;
            this.hideAllForms();
            this.setState({
                [`${formName}Visible`]: !this.state[`${formName}Visible`]
            });
            this.updateResourceRegistrationSession(id);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($ee16f7e54946bcf0$exports)))(this, "handleFormSubmit", ()=>{
            const { id: id } = this.props.params;
            this.hideAllForms();
            this.updateResourceRegistrationSession(id);
        });
        this.state = {
            acceptFormVisible: false,
            amendFormVisible: false,
            commentFormVisible: false,
            rejectFormVisible: false
        };
    }
    componentDidMount() {
        const { trackPageView: trackPageView } = this.props.matomo;
        trackPageView();
        const { id: id } = this.props.params;
        this.updateResourceRegistrationSession(id);
    }
    render() {
        const { handleFormSubmit: handleFormSubmit, handleFormVisibility: handleFormVisibility, props: { resourceRegistrationSession: { resourceRegistrationRequest: resourceRegistrationRequest, resourceRegistrationSessionEvents: resourceRegistrationSessionEvents }, params: { id: id } }, state: { acceptFormVisible: acceptFormVisible, amendFormVisible: amendFormVisible, commentFormVisible: commentFormVisible, rejectFormVisible: rejectFormVisible } } = this;
        return !resourceRegistrationRequest ? '' : /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $8e95fc83e6ec5c3c$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0b74f6f839d040ed$export$2e2bcd8739ae039), {
                    icon: "icon-leaf",
                    title: `Managing request:`,
                    extraTitle: resourceRegistrationRequest.providerCode
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                        className: "col",
                        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                            className: "card-body",
                            children: [
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                                    children: [
                                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                            className: "icon icon-common icon-hand-point-up"
                                        }),
                                        " Current request details"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $16a9df20d48176e0$export$2e2bcd8739ae039), {
                                    data: resourceRegistrationRequest
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                    className: "row mt-5 mx-0",
                    children: [
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Accept",
                            color: "success",
                            handleShow: ()=>handleFormVisibility('acceptForm'),
                            icon: "check",
                            isCancel: acceptFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Amend",
                            color: "warning",
                            handleShow: ()=>handleFormVisibility('amendForm'),
                            icon: "edit",
                            isCancel: amendFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Comment",
                            color: "secondary",
                            handleShow: ()=>handleFormVisibility('commentForm'),
                            icon: "comment",
                            isCancel: commentFormVisible
                        }),
                        /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $107a64541f1a41b5$export$2e2bcd8739ae039), {
                            caption: "Reject",
                            color: "danger",
                            handleShow: ()=>handleFormVisibility('rejectForm'),
                            icon: "times",
                            isCancel: rejectFormVisible
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0f01519269721c53$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: acceptFormVisible
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $f4e9169e76646b3d$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: amendFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bc6cb1afad1e9fd7$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: commentFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $305e64740d2a45ac$export$2e2bcd8739ae039), {
                    id: id,
                    isOpen: rejectFormVisible,
                    handleShow: ()=>handleFormVisibility('acceptForm'),
                    handleFormSubmit: handleFormSubmit
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("hr", {
                    className: "my-5"
                }),
                /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)("h4", {
                                children: [
                                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("i", {
                                        className: "icon icon-common icon-history"
                                    }),
                                    " Previous events"
                                ]
                            }),
                            resourceRegistrationSessionEvents.map((prse)=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bc645780c41f7c76$export$2e2bcd8739ae039), {
                                    data: prse,
                                    registrationSessionType: "resource"
                                }, `prse-${prse.name}-${prse.created}`))
                        ]
                    })
                })
            ]
        });
    }
}
// Mapping
const $c5889211749d5491$var$mapStateToProps = (state)=>({
        resourceRegistrationSession: state.curationDashboard.resourceRegistrationSession
    });
const $c5889211749d5491$var$mapDispatchToProps = (dispatch)=>({
        getResourceRegistrationSession: (params)=>dispatch((0, $d97ca66fc50ed502$export$923512c69f364fc3)(params))
    });
const $c5889211749d5491$var$ConnectedManageResourceRegistrationRequestPage = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($c5889211749d5491$var$mapStateToProps, $c5889211749d5491$var$mapDispatchToProps)($c5889211749d5491$var$ManageResourceRegistrationRequestPage);
function $c5889211749d5491$export$2e2bcd8739ae039(props) {
    const params = (0, $bfdf1f7a109a1ee5$export$99eaa27ddbbb95ef)();
    const matomo = (0, $26f6a2459c708f92$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)($c5889211749d5491$var$ConnectedManageResourceRegistrationRequestPage, {
        ...props,
        params: params,
        matomo: matomo
    });
}






const $0f6ec7cc72078790$var$PrivateRoute = (props)=>{
    const { auth: auth, doSignIn: doSignIn, children: children } = props;
    const requiredRoles = props.requiredRoles || [];
    // Authenticated route.
    if (auth.authenticated) {
        // Check if all roles required are present.
        const rolesMet = requiredRoles.every((role)=>auth.keycloak.hasResourceRole(role));
        if (rolesMet) return children;
        else return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$444b3ab0cb9aec40), {
            to: "/"
        });
    } else {
        doSignIn({
            redirectUri: window.location.href
        });
        return /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $8e95fc83e6ec5c3c$exports.Fragment), {});
    }
};
//
// Mapping functions.
//
const $0f6ec7cc72078790$var$mapStateToProps = (state)=>({
        auth: state.auth
    });
const $0f6ec7cc72078790$var$mapDispatchToProps = (dispatch)=>({
        doSignIn: ()=>dispatch((0, $0b883306a510c740$export$7abc584011c1e113)())
    });
var $0f6ec7cc72078790$export$2e2bcd8739ae039 = (0, $edfd7b4d382be2ae$export$2e2bcd8739ae039)($0f6ec7cc72078790$var$mapStateToProps, $0f6ec7cc72078790$var$mapDispatchToProps)($0f6ec7cc72078790$var$PrivateRoute);


const $5527d0df700f1d87$var$AppRouter = ()=>/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $b08650187def67b8$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $6fdc6fa6a39680d8$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)("div", {
                    className: "w-100 pt-5",
                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $bfdf1f7a109a1ee5$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $235bf69e728e9dd0$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/registry",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $badf0aba95db9f31$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/registry/:prefix",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $56e7ce597e896584$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/prefixregistrationrequest",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $dbdafc94b4d4c1f8$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/resourceregistrationrequest",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $4bee0cfe66d07d4c$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/curation",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0f6ec7cc72078790$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $409781430455e694$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/curation/prefixRegistration/:id",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0f6ec7cc72078790$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $81b074b0662e2fab$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/curation/resourceRegistration/:id",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0f6ec7cc72078790$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $c5889211749d5491$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                path: "/curation/resourceRegistration/:id",
                                element: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $0f6ec7cc72078790$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $d3c14c44ca61ec4e$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $bfdf1f7a109a1ee5$export$e7b0ac011bb776c6), {
                                component: (0, $893ee9eaeec49a6c$export$2e2bcd8739ae039)
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $174bb9519d39d5ba$export$2e2bcd8739ae039), {})
        ]
    });
var $5527d0df700f1d87$export$2e2bcd8739ae039 = $5527d0df700f1d87$var$AppRouter;





// eslint-disable-next-line import/prefer-default-export
const $86d435f31e2e4334$export$882fee97acc33843 = {
    TRACK_EVENT: 'trackEvent',
    TRACK_LINK: 'trackLink',
    TRACK_SEARCH: 'trackSiteSearch',
    TRACK_VIEW: 'trackPageView',
    TRACK_ECOMMERCE_ORDER: 'trackEcommerceOrder',
    TRACK_ECOMMERCE_CART_UPDATE: 'trackEcommerceCartUpdate'
};


var $27e502f1d53c9652$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $27e502f1d53c9652$var$MatomoTracker {
    constructor(userOptions){
        if (!userOptions.urlBase) throw new Error('Matomo urlBase is required.');
        if (!userOptions.siteId) throw new Error('Matomo siteId is required.');
        this.initialize(userOptions);
    }
    initialize({ urlBase: urlBase, siteId: siteId, userId: userId, trackerUrl: trackerUrl, srcUrl: srcUrl, disabled: disabled, heartBeat: heartBeat, linkTracking: linkTracking = true, configurations: configurations = {} }) {
        var _a;
        const normalizedUrlBase = urlBase[urlBase.length - 1] !== '/' ? `${urlBase}/` : urlBase;
        if (typeof window === 'undefined') return;
        window._paq = window._paq || [];
        if (window._paq.length !== 0) return;
        if (disabled) return;
        this.pushInstruction('setTrackerUrl', trackerUrl !== null && trackerUrl !== void 0 ? trackerUrl : `${normalizedUrlBase}matomo.php`);
        this.pushInstruction('setSiteId', siteId);
        if (userId) this.pushInstruction('setUserId', userId);
        Object.entries(configurations).forEach(([name, instructions])=>{
            if (instructions instanceof Array) // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            this.pushInstruction(name, ...instructions);
            else this.pushInstruction(name, instructions);
        });
        // accurately measure the time spent on the last pageview of a visit
        if (!heartBeat || heartBeat && heartBeat.active) this.enableHeartBeatTimer((_a = heartBeat && heartBeat.seconds) !== null && _a !== void 0 ? _a : 15);
        // // measure outbound links and downloads
        // // might not work accurately on SPAs because new links (dom elements) are created dynamically without a server-side page reload.
        this.enableLinkTracking(linkTracking);
        const doc = document;
        const scriptElement = doc.createElement('script');
        const scripts = doc.getElementsByTagName('script')[0];
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.src = srcUrl || `${normalizedUrlBase}matomo.js`;
        if (scripts && scripts.parentNode) scripts.parentNode.insertBefore(scriptElement, scripts);
    }
    enableHeartBeatTimer(seconds) {
        this.pushInstruction('enableHeartBeatTimer', seconds);
    }
    enableLinkTracking(active) {
        this.pushInstruction('enableLinkTracking', active);
    }
    trackEventsForElements(elements) {
        if (elements.length) elements.forEach((element)=>{
            element.addEventListener('click', ()=>{
                const { matomoCategory: matomoCategory, matomoAction: matomoAction, matomoName: matomoName, matomoValue: matomoValue } = element.dataset;
                if (matomoCategory && matomoAction) this.trackEvent({
                    category: matomoCategory,
                    action: matomoAction,
                    name: matomoName,
                    value: Number(matomoValue)
                });
                else throw new Error(`Error: data-matomo-category and data-matomo-action are required.`);
            });
        });
    }
    // Tracks events based on data attributes
    trackEvents() {
        const matchString = '[data-matomo-event="click"]';
        let firstTime = false;
        if (!this.mutationObserver) {
            firstTime = true;
            this.mutationObserver = new MutationObserver((mutations)=>{
                mutations.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        // only track HTML elements
                        if (!(node instanceof HTMLElement)) return;
                        // check the inserted element for being a code snippet
                        if (node.matches(matchString)) this.trackEventsForElements([
                            node
                        ]);
                        const elements = Array.from(node.querySelectorAll(matchString));
                        this.trackEventsForElements(elements);
                    });
                });
            });
        }
        this.mutationObserver.observe(document, {
            childList: true,
            subtree: true
        });
        // Now track all already existing elements
        if (firstTime) {
            const elements = Array.from(document.querySelectorAll(matchString));
            this.trackEventsForElements(elements);
        }
    }
    stopObserving() {
        if (this.mutationObserver) this.mutationObserver.disconnect();
    }
    // Tracks events
    // https://matomo.org/docs/event-tracking/#tracking-events
    trackEvent(_a) {
        var { category: category, action: action, name: name, value: value } = _a, otherParams = $27e502f1d53c9652$var$__rest(_a, [
            "category",
            "action",
            "name",
            "value"
        ]);
        if (category && action) this.track(Object.assign({
            data: [
                (0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_EVENT,
                category,
                action,
                name,
                value
            ]
        }, otherParams));
        else throw new Error(`Error: category and action are required.`);
    }
    // Tracks site search
    // https://developer.matomo.org/guides/tracking-javascript-guide#internal-search-tracking
    trackSiteSearch(_a) {
        var { keyword: keyword, category: category, count: count } = _a, otherParams = $27e502f1d53c9652$var$__rest(_a, [
            "keyword",
            "category",
            "count"
        ]);
        if (keyword) this.track(Object.assign({
            data: [
                (0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_SEARCH,
                keyword,
                category,
                count
            ]
        }, otherParams));
        else throw new Error(`Error: keyword is required.`);
    }
    // Tracks outgoing links to other sites and downloads
    // https://developer.matomo.org/guides/tracking-javascript-guide#enabling-download-outlink-tracking
    trackLink({ href: href, linkType: linkType = 'link' }) {
        this.pushInstruction((0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_LINK, href, linkType);
    }
    // Tracks page views
    // https://developer.matomo.org/guides/spa-tracking#tracking-a-new-page-view
    trackPageView(params) {
        this.track(Object.assign({
            data: [
                (0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_VIEW
            ]
        }, params));
    }
    // Adds a product to an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    // https://matomo.org/docs/ecommerce-analytics/#1-addecommerceitemproductsku-productname-productcategory-price-quantity
    addEcommerceItem({ sku: sku, productName: productName, productCategory: productCategory, productPrice: productPrice = 0.0, productQuantity: productQuantity = 1 }) {
        this.pushInstruction('addEcommerceItem', sku, productName, productCategory, productPrice, productQuantity);
    }
    // Removes a product from an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    removeEcommerceItem({ sku: sku }) {
        this.pushInstruction('removeEcommerceItem', sku);
    }
    // Removes all products from an Ecommerce order to be tracked via trackEcommerceOrder.
    // https://matomo.org/docs/ecommerce-analytics
    clearEcommerceCart() {
        this.pushInstruction('clearEcommerceCart');
    }
    // Tracks an Ecommerce order containing items added via addEcommerceItem.
    // https://matomo.org/docs/ecommerce-analytics/#2-trackecommerceorderorderid-revenue-subtotal-tax-shipping-discount
    trackEcommerceOrder({ orderId: orderId, orderRevenue: orderRevenue, orderSubTotal: orderSubTotal, taxAmount: taxAmount, shippingAmount: shippingAmount, discountOffered: discountOffered = false }) {
        this.track({
            data: [
                (0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_ECOMMERCE_ORDER,
                orderId,
                orderRevenue,
                orderSubTotal,
                taxAmount,
                shippingAmount,
                discountOffered
            ]
        });
    }
    // Tracks updates to an Ecommerce Cart before an actual purchase.
    // This will replace currently tracked information of the cart. Always include all items of the updated cart!
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-an-ecommerce-cart-update-containing-two-products
    trackEcommerceCartUpdate(amount) {
        this.pushInstruction((0, $86d435f31e2e4334$export$882fee97acc33843).TRACK_ECOMMERCE_CART_UPDATE, amount);
    }
    // Marks the next page view as an Ecommerce product page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-product-page-view
    setEcommerceView({ sku: sku, productName: productName, productCategory: productCategory, productPrice: productPrice }) {
        this.pushInstruction('setEcommerceView', sku, productName, productCategory, productPrice);
    }
    // Marks the next tracked page view as an Ecommerce category page.
    // https://matomo.org/docs/ecommerce-analytics/#example-tracking-a-category-page-view
    setEcommerceCategoryView(productCategory) {
        this.setEcommerceView({
            productCategory: productCategory,
            productName: false,
            sku: false
        });
    }
    // Sends the tracked page/view/search to Matomo
    track({ data: data = [], documentTitle: documentTitle = window.document.title, href: href, customDimensions: customDimensions = false }) {
        if (data.length) {
            if (customDimensions && Array.isArray(customDimensions) && customDimensions.length) customDimensions.map((customDimension)=>this.pushInstruction('setCustomDimension', customDimension.id, customDimension.value));
            this.pushInstruction('setCustomUrl', href !== null && href !== void 0 ? href : window.location.href);
            this.pushInstruction('setDocumentTitle', documentTitle);
            this.pushInstruction(...data);
        }
    }
    /**
     * Pushes an instruction to Matomo for execution, this is equivalent to pushing entries into the `_paq` array.
     *
     * For example:
     *
     * ```ts
     * pushInstruction('setDocumentTitle', document.title)
     * ```
     * Is the equivalent of:
     *
     * ```ts
     * _paq.push(['setDocumentTitle', document.title]);
     * ```
     *
     * @param name The name of the instruction to be executed.
     * @param args The arguments to pass along with the instruction.
     */ pushInstruction(name, ...args) {
        if (typeof window !== 'undefined') // eslint-disable-next-line
        window._paq.push([
            name,
            ...args
        ]);
        return this;
    }
}
var $27e502f1d53c9652$export$2e2bcd8739ae039 = $27e502f1d53c9652$var$MatomoTracker;



var $cb39102ab3c918ce$export$2e2bcd8739ae039 = (0, $27e502f1d53c9652$export$2e2bcd8739ae039);


function $b3398955cbe6b94e$var$createInstance(params) {
    return new (0, $cb39102ab3c918ce$export$2e2bcd8739ae039)(params);
}
var $b3398955cbe6b94e$export$2e2bcd8739ae039 = $b3398955cbe6b94e$var$createInstance;


var $dBNnn = parcelRequire("dBNnn");

const $3e6ee78456431aee$var$MatomoProvider = function({ children: children, value: value }) {
    const Context = (0, $35ad84941ce9372a$export$2e2bcd8739ae039);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dBNnn))).createElement(Context.Provider, {
        value: value
    }, children);
};
var $3e6ee78456431aee$export$2e2bcd8739ae039 = $3e6ee78456431aee$var$MatomoProvider;



/*!
  * Bootstrap v5.3.5 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $aae29f65524edcb9$exports = {};

$parcel$export($aae29f65524edcb9$exports, "popperGenerator", function () { return $2b4a84a776b44018$export$ed5e13716264f202; });
$parcel$export($aae29f65524edcb9$exports, "detectOverflow", function () { return $ec033e75f072b98e$export$2e2bcd8739ae039; });
$parcel$export($aae29f65524edcb9$exports, "createPopperBase", function () { return $2b4a84a776b44018$export$8f7491d57c8f97a9; });
$parcel$export($aae29f65524edcb9$exports, "createPopper", function () { return $1be4688b6a9a4ecd$export$8f7491d57c8f97a9; });
$parcel$export($aae29f65524edcb9$exports, "createPopperLite", function () { return $ada296752ea99901$export$8f7491d57c8f97a9; });
var $a211345e5aa598ca$exports = {};

$parcel$export($a211345e5aa598ca$exports, "top", function () { return $a211345e5aa598ca$export$1e95b668f3b82d; });
$parcel$export($a211345e5aa598ca$exports, "bottom", function () { return $a211345e5aa598ca$export$40e543e69a8b3fbb; });
$parcel$export($a211345e5aa598ca$exports, "right", function () { return $a211345e5aa598ca$export$79ffe56a765070d2; });
$parcel$export($a211345e5aa598ca$exports, "left", function () { return $a211345e5aa598ca$export$eabcd2c8791e7bf4; });
$parcel$export($a211345e5aa598ca$exports, "auto", function () { return $a211345e5aa598ca$export$dfb5619354ba860; });
$parcel$export($a211345e5aa598ca$exports, "basePlacements", function () { return $a211345e5aa598ca$export$aec2ce47c367b8c3; });
$parcel$export($a211345e5aa598ca$exports, "start", function () { return $a211345e5aa598ca$export$b3571188c770cc5a; });
$parcel$export($a211345e5aa598ca$exports, "end", function () { return $a211345e5aa598ca$export$bd5df0f255a350f8; });
$parcel$export($a211345e5aa598ca$exports, "clippingParents", function () { return $a211345e5aa598ca$export$390fd549c5303b4d; });
$parcel$export($a211345e5aa598ca$exports, "viewport", function () { return $a211345e5aa598ca$export$d7b7311ec04a3e8f; });
$parcel$export($a211345e5aa598ca$exports, "popper", function () { return $a211345e5aa598ca$export$ae5ab1c730825774; });
$parcel$export($a211345e5aa598ca$exports, "reference", function () { return $a211345e5aa598ca$export$ca50aac9f3ba507f; });
$parcel$export($a211345e5aa598ca$exports, "variationPlacements", function () { return $a211345e5aa598ca$export$368f9a87e87fa4e1; });
$parcel$export($a211345e5aa598ca$exports, "placements", function () { return $a211345e5aa598ca$export$803cd8101b6c182b; });
$parcel$export($a211345e5aa598ca$exports, "beforeRead", function () { return $a211345e5aa598ca$export$421679a7c3d56e; });
$parcel$export($a211345e5aa598ca$exports, "read", function () { return $a211345e5aa598ca$export$aafa59e2e03f2942; });
$parcel$export($a211345e5aa598ca$exports, "afterRead", function () { return $a211345e5aa598ca$export$6964f6c886723980; });
$parcel$export($a211345e5aa598ca$exports, "beforeMain", function () { return $a211345e5aa598ca$export$c65e99957a05207c; });
$parcel$export($a211345e5aa598ca$exports, "main", function () { return $a211345e5aa598ca$export$f22da7240b7add18; });
$parcel$export($a211345e5aa598ca$exports, "afterMain", function () { return $a211345e5aa598ca$export$bab79516f2d662fe; });
$parcel$export($a211345e5aa598ca$exports, "beforeWrite", function () { return $a211345e5aa598ca$export$8d4d2d70e7d46032; });
$parcel$export($a211345e5aa598ca$exports, "write", function () { return $a211345e5aa598ca$export$68d8715fc104d294; });
$parcel$export($a211345e5aa598ca$exports, "afterWrite", function () { return $a211345e5aa598ca$export$70a6e5159acce2e6; });
$parcel$export($a211345e5aa598ca$exports, "modifierPhases", function () { return $a211345e5aa598ca$export$d087d3878fdf71d5; });
var $a211345e5aa598ca$export$1e95b668f3b82d = 'top';
var $a211345e5aa598ca$export$40e543e69a8b3fbb = 'bottom';
var $a211345e5aa598ca$export$79ffe56a765070d2 = 'right';
var $a211345e5aa598ca$export$eabcd2c8791e7bf4 = 'left';
var $a211345e5aa598ca$export$dfb5619354ba860 = 'auto';
var $a211345e5aa598ca$export$aec2ce47c367b8c3 = [
    $a211345e5aa598ca$export$1e95b668f3b82d,
    $a211345e5aa598ca$export$40e543e69a8b3fbb,
    $a211345e5aa598ca$export$79ffe56a765070d2,
    $a211345e5aa598ca$export$eabcd2c8791e7bf4
];
var $a211345e5aa598ca$export$b3571188c770cc5a = 'start';
var $a211345e5aa598ca$export$bd5df0f255a350f8 = 'end';
var $a211345e5aa598ca$export$390fd549c5303b4d = 'clippingParents';
var $a211345e5aa598ca$export$d7b7311ec04a3e8f = 'viewport';
var $a211345e5aa598ca$export$ae5ab1c730825774 = 'popper';
var $a211345e5aa598ca$export$ca50aac9f3ba507f = 'reference';
var $a211345e5aa598ca$export$368f9a87e87fa4e1 = /*#__PURE__*/ $a211345e5aa598ca$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $a211345e5aa598ca$export$b3571188c770cc5a,
        placement + "-" + $a211345e5aa598ca$export$bd5df0f255a350f8
    ]);
}, []);
var $a211345e5aa598ca$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($a211345e5aa598ca$export$aec2ce47c367b8c3, [
    $a211345e5aa598ca$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $a211345e5aa598ca$export$b3571188c770cc5a,
        placement + "-" + $a211345e5aa598ca$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $a211345e5aa598ca$export$421679a7c3d56e = 'beforeRead';
var $a211345e5aa598ca$export$aafa59e2e03f2942 = 'read';
var $a211345e5aa598ca$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $a211345e5aa598ca$export$c65e99957a05207c = 'beforeMain';
var $a211345e5aa598ca$export$f22da7240b7add18 = 'main';
var $a211345e5aa598ca$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $a211345e5aa598ca$export$8d4d2d70e7d46032 = 'beforeWrite';
var $a211345e5aa598ca$export$68d8715fc104d294 = 'write';
var $a211345e5aa598ca$export$70a6e5159acce2e6 = 'afterWrite';
var $a211345e5aa598ca$export$d087d3878fdf71d5 = [
    $a211345e5aa598ca$export$421679a7c3d56e,
    $a211345e5aa598ca$export$aafa59e2e03f2942,
    $a211345e5aa598ca$export$6964f6c886723980,
    $a211345e5aa598ca$export$c65e99957a05207c,
    $a211345e5aa598ca$export$f22da7240b7add18,
    $a211345e5aa598ca$export$bab79516f2d662fe,
    $a211345e5aa598ca$export$8d4d2d70e7d46032,
    $a211345e5aa598ca$export$68d8715fc104d294,
    $a211345e5aa598ca$export$70a6e5159acce2e6
];


var $86a39382939aaef6$exports = {};

$parcel$export($86a39382939aaef6$exports, "applyStyles", function () { return $4a07a7df25ef6039$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "arrow", function () { return $719c72d1691bfbda$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "computeStyles", function () { return $7fdb07da4cdf6b13$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "eventListeners", function () { return $3dbb3c5d5f912bac$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "flip", function () { return $6a420e93fb976199$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "hide", function () { return $7dad020c5df049cc$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "offset", function () { return $02ba835fd29363b7$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "popperOffsets", function () { return $437aede822684c8a$export$2e2bcd8739ae039; });
$parcel$export($86a39382939aaef6$exports, "preventOverflow", function () { return $56a9d7a9fef2c250$export$2e2bcd8739ae039; });
function $e0f66f9507336c6b$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $34c4b045651cb087$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d1331a6f9d840ca9$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d1331a6f9d840ca9$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d1331a6f9d840ca9$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $4a07a7df25ef6039$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element) || !(0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $4a07a7df25ef6039$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element) || !(0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $4a07a7df25ef6039$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $4a07a7df25ef6039$var$applyStyles,
    effect: $4a07a7df25ef6039$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $f69fe1f10a6a7727$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $858bb682855dd767$export$8960430cfd85939f = Math.max;
var $858bb682855dd767$export$96ec731ed4dcb222 = Math.min;
var $858bb682855dd767$export$2077e0241d6afd3c = Math.round;



function $26ee79f4c7edd89d$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $663609a67231b2ac$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $26ee79f4c7edd89d$export$2e2bcd8739ae039)());
}


function $a000cc20bd3f46a3$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $858bb682855dd767$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $858bb682855dd767$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(element) ? (0, $34c4b045651cb087$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $663609a67231b2ac$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $b792b18a3d4b56b8$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $944c016378b505ae$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d1331a6f9d840ca9$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $6241c8401c1b8fa3$export$2e2bcd8739ae039(element) {
    return (0, $34c4b045651cb087$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $3b83bc80894b9f9b$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(element)) >= 0;
}




function $f15cb1b89273d592$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $d44894530437f52b$export$2e2bcd8739ae039(element) {
    if ((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d1331a6f9d840ca9$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $ce4d37df1dc4998c$var$getTrueOffsetParent(element) {
    if (!(0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $ce4d37df1dc4998c$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $26ee79f4c7edd89d$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $26ee79f4c7edd89d$export$2e2bcd8739ae039)());
    if (isIE && (0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $d44894530437f52b$export$2e2bcd8739ae039)(element);
    if ((0, $d1331a6f9d840ca9$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $ce4d37df1dc4998c$export$2e2bcd8739ae039(element) {
    var window = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(element);
    var offsetParent = $ce4d37df1dc4998c$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3b83bc80894b9f9b$export$2e2bcd8739ae039)(offsetParent) && (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $ce4d37df1dc4998c$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $ce4d37df1dc4998c$var$getContainingBlock(element) || window;
}


function $e272bb841bc582b5$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $77703887af7930de$export$f28d906d67a997f3(min, value, max) {
    return (0, $858bb682855dd767$export$8960430cfd85939f)(min, (0, $858bb682855dd767$export$96ec731ed4dcb222)(value, max));
}
function $77703887af7930de$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $77703887af7930de$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $0f2d27212a1c542c$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $11d0db50a4067c72$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $0f2d27212a1c542c$export$2e2bcd8739ae039)(), paddingObject);
}


function $25ca6b3c7b2060ab$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $719c72d1691bfbda$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $11d0db50a4067c72$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $25ca6b3c7b2060ab$export$2e2bcd8739ae039)(padding, (0, $a211345e5aa598ca$export$aec2ce47c367b8c3)));
};
function $719c72d1691bfbda$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $e272bb841bc582b5$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4),
        (0, $a211345e5aa598ca$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $719c72d1691bfbda$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $b792b18a3d4b56b8$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $a211345e5aa598ca$export$1e95b668f3b82d) : (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $a211345e5aa598ca$export$40e543e69a8b3fbb) : (0, $a211345e5aa598ca$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $ce4d37df1dc4998c$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $77703887af7930de$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $719c72d1691bfbda$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $944c016378b505ae$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $719c72d1691bfbda$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $719c72d1691bfbda$var$arrow,
    effect: $719c72d1691bfbda$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $0d203f384a1261bb$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $7fdb07da4cdf6b13$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $7fdb07da4cdf6b13$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $858bb682855dd767$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $858bb682855dd767$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $7fdb07da4cdf6b13$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4);
    var sideY = (0, $a211345e5aa598ca$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $ce4d37df1dc4998c$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $34c4b045651cb087$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(popper);
            if ((0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $a211345e5aa598ca$export$1e95b668f3b82d) || (placement === (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4) || placement === (0, $a211345e5aa598ca$export$79ffe56a765070d2)) && variation === (0, $a211345e5aa598ca$export$bd5df0f255a350f8)) {
            sideY = (0, $a211345e5aa598ca$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4) || (placement === (0, $a211345e5aa598ca$export$1e95b668f3b82d) || placement === (0, $a211345e5aa598ca$export$40e543e69a8b3fbb)) && variation === (0, $a211345e5aa598ca$export$bd5df0f255a350f8)) {
            sideX = (0, $a211345e5aa598ca$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $7fdb07da4cdf6b13$var$unsetSides);
    var _ref4 = roundOffsets === true ? $7fdb07da4cdf6b13$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $34c4b045651cb087$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $7fdb07da4cdf6b13$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $7fdb07da4cdf6b13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $7fdb07da4cdf6b13$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7fdb07da4cdf6b13$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $7fdb07da4cdf6b13$var$computeStyles,
    data: {}
};



var $3dbb3c5d5f912bac$var$passive = {
    passive: true
};
function $3dbb3c5d5f912bac$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $3dbb3c5d5f912bac$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $3dbb3c5d5f912bac$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $3dbb3c5d5f912bac$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $3dbb3c5d5f912bac$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $3dbb3c5d5f912bac$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $3dbb3c5d5f912bac$var$effect,
    data: {}
};


var $4d29a4c9854ed4cc$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $4d29a4c9854ed4cc$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $4d29a4c9854ed4cc$var$hash[matched];
    });
}



var $8c1bbeea2755e5e4$var$hash = {
    start: 'end',
    end: 'start'
};
function $8c1bbeea2755e5e4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $8c1bbeea2755e5e4$var$hash[matched];
    });
}








function $4969a91367879491$export$2e2bcd8739ae039(node) {
    var win = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $8d738847cbb1ece2$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)((0, $f15cb1b89273d592$export$2e2bcd8739ae039)(element)).left + (0, $4969a91367879491$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7c2c7f521eea8bec$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(element);
    var html = (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $663609a67231b2ac$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8d738847cbb1ece2$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $f56a1d6f1fb72188$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $4969a91367879491$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $858bb682855dd767$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $858bb682855dd767$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8d738847cbb1ece2$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $858bb682855dd767$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $8b10c06ea416129f$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a7a020cf279dc3f6$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(node) && (0, $8b10c06ea416129f$export$2e2bcd8739ae039)(node)) return node;
    return $a7a020cf279dc3f6$export$2e2bcd8739ae039((0, $d44894530437f52b$export$2e2bcd8739ae039)(node));
}





function $cdffbe5b24f47cd8$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a7a020cf279dc3f6$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $34c4b045651cb087$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $8b10c06ea416129f$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($cdffbe5b24f47cd8$export$2e2bcd8739ae039((0, $d44894530437f52b$export$2e2bcd8739ae039)(target)));
}










function $b94490130bdb0087$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $40d34f475f2231d8$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $40d34f475f2231d8$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $a211345e5aa598ca$export$d7b7311ec04a3e8f) ? (0, $b94490130bdb0087$export$2e2bcd8739ae039)((0, $7c2c7f521eea8bec$export$2e2bcd8739ae039)(element, strategy)) : (0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(clippingParent) ? $40d34f475f2231d8$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b94490130bdb0087$export$2e2bcd8739ae039)((0, $f56a1d6f1fb72188$export$2e2bcd8739ae039)((0, $f15cb1b89273d592$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $40d34f475f2231d8$var$getClippingParents(element) {
    var clippingParents = (0, $cdffbe5b24f47cd8$export$2e2bcd8739ae039)((0, $d44894530437f52b$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $6241c8401c1b8fa3$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(element) ? (0, $ce4d37df1dc4998c$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(clippingParent) && (0, $944c016378b505ae$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $40d34f475f2231d8$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $40d34f475f2231d8$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $40d34f475f2231d8$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $858bb682855dd767$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $858bb682855dd767$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $858bb682855dd767$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $858bb682855dd767$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $40d34f475f2231d8$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $55a6331ad969ca28$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $a211345e5aa598ca$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $a211345e5aa598ca$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $a211345e5aa598ca$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $a211345e5aa598ca$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $e272bb841bc582b5$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $a211345e5aa598ca$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $a211345e5aa598ca$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $ec033e75f072b98e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $a211345e5aa598ca$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $a211345e5aa598ca$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $a211345e5aa598ca$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $11d0db50a4067c72$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $25ca6b3c7b2060ab$export$2e2bcd8739ae039)(padding, (0, $a211345e5aa598ca$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $a211345e5aa598ca$export$ae5ab1c730825774) ? (0, $a211345e5aa598ca$export$ca50aac9f3ba507f) : (0, $a211345e5aa598ca$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $40d34f475f2231d8$export$2e2bcd8739ae039)((0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $55a6331ad969ca28$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b94490130bdb0087$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $a211345e5aa598ca$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $a211345e5aa598ca$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $a211345e5aa598ca$export$79ffe56a765070d2),
                (0, $a211345e5aa598ca$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $a211345e5aa598ca$export$1e95b668f3b82d),
                (0, $a211345e5aa598ca$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $f911cea796f98176$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $a211345e5aa598ca$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $a211345e5aa598ca$export$368f9a87e87fa4e1) : (0, $a211345e5aa598ca$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $a211345e5aa598ca$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $ec033e75f072b98e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6a420e93fb976199$var$getExpandedFallbackPlacements(placement) {
    if ((0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement) === (0, $a211345e5aa598ca$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $4d29a4c9854ed4cc$export$2e2bcd8739ae039)(placement);
    return [
        (0, $8c1bbeea2755e5e4$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $8c1bbeea2755e5e4$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6a420e93fb976199$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $4d29a4c9854ed4cc$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6a420e93fb976199$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement) === (0, $a211345e5aa598ca$export$dfb5619354ba860) ? (0, $f911cea796f98176$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(placement) === (0, $a211345e5aa598ca$export$b3571188c770cc5a);
        var isVertical = [
            (0, $a211345e5aa598ca$export$1e95b668f3b82d),
            (0, $a211345e5aa598ca$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $ec033e75f072b98e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $a211345e5aa598ca$export$79ffe56a765070d2) : (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $a211345e5aa598ca$export$40e543e69a8b3fbb) : (0, $a211345e5aa598ca$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $4d29a4c9854ed4cc$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $4d29a4c9854ed4cc$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6a420e93fb976199$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6a420e93fb976199$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $7dad020c5df049cc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $7dad020c5df049cc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $a211345e5aa598ca$export$1e95b668f3b82d),
        (0, $a211345e5aa598ca$export$79ffe56a765070d2),
        (0, $a211345e5aa598ca$export$40e543e69a8b3fbb),
        (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $7dad020c5df049cc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $ec033e75f072b98e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $ec033e75f072b98e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $7dad020c5df049cc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $7dad020c5df049cc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $7dad020c5df049cc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $7dad020c5df049cc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $7dad020c5df049cc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $7dad020c5df049cc$var$hide
};




function $02ba835fd29363b7$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4),
        (0, $a211345e5aa598ca$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4),
        (0, $a211345e5aa598ca$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $02ba835fd29363b7$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $a211345e5aa598ca$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $02ba835fd29363b7$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $02ba835fd29363b7$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $02ba835fd29363b7$var$offset
};



function $437aede822684c8a$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $55a6331ad969ca28$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $437aede822684c8a$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $437aede822684c8a$var$popperOffsets,
    data: {}
};





function $23a70a4c473efbca$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $56a9d7a9fef2c250$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $ec033e75f072b98e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $f69fe1f10a6a7727$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $0d203f384a1261bb$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $e272bb841bc582b5$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $23a70a4c473efbca$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $a211345e5aa598ca$export$1e95b668f3b82d) : (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $a211345e5aa598ca$export$40e543e69a8b3fbb) : (0, $a211345e5aa598ca$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $a211345e5aa598ca$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $a211345e5aa598ca$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $b792b18a3d4b56b8$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $0f2d27212a1c542c$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $77703887af7930de$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $ce4d37df1dc4998c$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $77703887af7930de$export$f28d906d67a997f3)(tether ? (0, $858bb682855dd767$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $858bb682855dd767$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $a211345e5aa598ca$export$1e95b668f3b82d) : (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $a211345e5aa598ca$export$40e543e69a8b3fbb) : (0, $a211345e5aa598ca$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $a211345e5aa598ca$export$1e95b668f3b82d),
            (0, $a211345e5aa598ca$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $77703887af7930de$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $77703887af7930de$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $56a9d7a9fef2c250$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $56a9d7a9fef2c250$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $67be69367f56b739$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b044618fd3577613$export$2e2bcd8739ae039(node) {
    if (node === (0, $34c4b045651cb087$export$2e2bcd8739ae039)(node) || !(0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(node)) return (0, $4969a91367879491$export$2e2bcd8739ae039)(node);
    else return (0, $67be69367f56b739$export$2e2bcd8739ae039)(node);
}








function $c242c06d759f492b$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $858bb682855dd767$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $858bb682855dd767$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $c242c06d759f492b$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(offsetParent) && $c242c06d759f492b$var$isElementScaled(offsetParent);
    var documentElement = (0, $f15cb1b89273d592$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e0f66f9507336c6b$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $8b10c06ea416129f$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b044618fd3577613$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d1331a6f9d840ca9$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $a000cc20bd3f46a3$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8d738847cbb1ece2$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $78ebfcf079c85f63$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $78ebfcf079c85f63$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $78ebfcf079c85f63$var$order(modifiers); // order based on phase
    return (0, $a211345e5aa598ca$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $50dd886301dd939c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $84b418938fbd4d2b$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2b4a84a776b44018$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $2b4a84a776b44018$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $2b4a84a776b44018$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2b4a84a776b44018$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $2b4a84a776b44018$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d1331a6f9d840ca9$export$45a5e7f76e0caa8d)(reference) ? (0, $cdffbe5b24f47cd8$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $cdffbe5b24f47cd8$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $cdffbe5b24f47cd8$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $78ebfcf079c85f63$export$2e2bcd8739ae039)((0, $84b418938fbd4d2b$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2b4a84a776b44018$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $c242c06d759f492b$export$2e2bcd8739ae039)(reference, (0, $ce4d37df1dc4998c$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $b792b18a3d4b56b8$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $50dd886301dd939c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2b4a84a776b44018$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2b4a84a776b44018$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2b4a84a776b44018$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $1be4688b6a9a4ecd$export$d34966752335dd47 = [
    (0, $3dbb3c5d5f912bac$export$2e2bcd8739ae039),
    (0, $437aede822684c8a$export$2e2bcd8739ae039),
    (0, $7fdb07da4cdf6b13$export$2e2bcd8739ae039),
    (0, $4a07a7df25ef6039$export$2e2bcd8739ae039),
    (0, $02ba835fd29363b7$export$2e2bcd8739ae039),
    (0, $6a420e93fb976199$export$2e2bcd8739ae039),
    (0, $56a9d7a9fef2c250$export$2e2bcd8739ae039),
    (0, $719c72d1691bfbda$export$2e2bcd8739ae039),
    (0, $7dad020c5df049cc$export$2e2bcd8739ae039)
];
var $1be4688b6a9a4ecd$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2b4a84a776b44018$export$ed5e13716264f202)({
    defaultModifiers: $1be4688b6a9a4ecd$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ada296752ea99901$export$d34966752335dd47 = [
    (0, $3dbb3c5d5f912bac$export$2e2bcd8739ae039),
    (0, $437aede822684c8a$export$2e2bcd8739ae039),
    (0, $7fdb07da4cdf6b13$export$2e2bcd8739ae039),
    (0, $4a07a7df25ef6039$export$2e2bcd8739ae039)
];
var $ada296752ea99901$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2b4a84a776b44018$export$ed5e13716264f202)({
    defaultModifiers: $ada296752ea99901$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($aae29f65524edcb9$exports, $a211345e5aa598ca$exports);
$parcel$exportWildcard($aae29f65524edcb9$exports, $86a39382939aaef6$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$elementMap = new Map();
const $00fe7cf7a0ed8e69$var$Data = {
    set (element, key, instance) {
        if (!$00fe7cf7a0ed8e69$var$elementMap.has(element)) $00fe7cf7a0ed8e69$var$elementMap.set(element, new Map());
        const instanceMap = $00fe7cf7a0ed8e69$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($00fe7cf7a0ed8e69$var$elementMap.has(element)) return $00fe7cf7a0ed8e69$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$00fe7cf7a0ed8e69$var$elementMap.has(element)) return;
        const instanceMap = $00fe7cf7a0ed8e69$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $00fe7cf7a0ed8e69$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $00fe7cf7a0ed8e69$var$MAX_UID = 1000000;
const $00fe7cf7a0ed8e69$var$MILLISECONDS_MULTIPLIER = 1000;
const $00fe7cf7a0ed8e69$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $00fe7cf7a0ed8e69$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $00fe7cf7a0ed8e69$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $00fe7cf7a0ed8e69$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $00fe7cf7a0ed8e69$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $00fe7cf7a0ed8e69$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $00fe7cf7a0ed8e69$var$MILLISECONDS_MULTIPLIER;
};
const $00fe7cf7a0ed8e69$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($00fe7cf7a0ed8e69$var$TRANSITION_END));
};
const $00fe7cf7a0ed8e69$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $00fe7cf7a0ed8e69$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($00fe7cf7a0ed8e69$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($00fe7cf7a0ed8e69$var$parseSelector(object));
    return null;
};
const $00fe7cf7a0ed8e69$var$isVisible = (element)=>{
    if (!$00fe7cf7a0ed8e69$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $00fe7cf7a0ed8e69$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $00fe7cf7a0ed8e69$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $00fe7cf7a0ed8e69$var$findShadowRoot(element.parentNode);
};
const $00fe7cf7a0ed8e69$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $00fe7cf7a0ed8e69$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $00fe7cf7a0ed8e69$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $00fe7cf7a0ed8e69$var$DOMContentLoadedCallbacks = [];
const $00fe7cf7a0ed8e69$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$00fe7cf7a0ed8e69$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $00fe7cf7a0ed8e69$var$DOMContentLoadedCallbacks)callback();
        });
        $00fe7cf7a0ed8e69$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $00fe7cf7a0ed8e69$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $00fe7cf7a0ed8e69$var$defineJQueryPlugin = (plugin)=>{
    $00fe7cf7a0ed8e69$var$onDOMContentLoaded(()=>{
        const $ = $00fe7cf7a0ed8e69$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $00fe7cf7a0ed8e69$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $00fe7cf7a0ed8e69$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $00fe7cf7a0ed8e69$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $00fe7cf7a0ed8e69$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($00fe7cf7a0ed8e69$var$TRANSITION_END, handler);
        $00fe7cf7a0ed8e69$var$execute(callback);
    };
    transitionElement.addEventListener($00fe7cf7a0ed8e69$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $00fe7cf7a0ed8e69$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $00fe7cf7a0ed8e69$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $00fe7cf7a0ed8e69$var$stripNameRegex = /\..*/;
const $00fe7cf7a0ed8e69$var$stripUidRegex = /::\d+$/;
const $00fe7cf7a0ed8e69$var$eventRegistry = {}; // Events storage
let $00fe7cf7a0ed8e69$var$uidEvent = 1;
const $00fe7cf7a0ed8e69$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $00fe7cf7a0ed8e69$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $00fe7cf7a0ed8e69$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$00fe7cf7a0ed8e69$var$uidEvent++}` || element.uidEvent || $00fe7cf7a0ed8e69$var$uidEvent++;
}
function $00fe7cf7a0ed8e69$var$getElementEvents(element) {
    const uid = $00fe7cf7a0ed8e69$var$makeEventUid(element);
    element.uidEvent = uid;
    $00fe7cf7a0ed8e69$var$eventRegistry[uid] = $00fe7cf7a0ed8e69$var$eventRegistry[uid] || {};
    return $00fe7cf7a0ed8e69$var$eventRegistry[uid];
}
function $00fe7cf7a0ed8e69$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $00fe7cf7a0ed8e69$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $00fe7cf7a0ed8e69$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $00fe7cf7a0ed8e69$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $00fe7cf7a0ed8e69$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $00fe7cf7a0ed8e69$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $00fe7cf7a0ed8e69$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $00fe7cf7a0ed8e69$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $00fe7cf7a0ed8e69$var$getTypeEvent(originalTypeEvent);
    if (!$00fe7cf7a0ed8e69$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $00fe7cf7a0ed8e69$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $00fe7cf7a0ed8e69$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $00fe7cf7a0ed8e69$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $00fe7cf7a0ed8e69$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $00fe7cf7a0ed8e69$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $00fe7cf7a0ed8e69$var$makeEventUid(callable, originalTypeEvent.replace($00fe7cf7a0ed8e69$var$namespaceRegex, ''));
    const fn = isDelegated ? $00fe7cf7a0ed8e69$var$bootstrapDelegationHandler(element, handler, callable) : $00fe7cf7a0ed8e69$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $00fe7cf7a0ed8e69$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $00fe7cf7a0ed8e69$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $00fe7cf7a0ed8e69$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $00fe7cf7a0ed8e69$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $00fe7cf7a0ed8e69$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($00fe7cf7a0ed8e69$var$stripNameRegex, '');
    return $00fe7cf7a0ed8e69$var$customEvents[event] || event;
}
const $00fe7cf7a0ed8e69$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $00fe7cf7a0ed8e69$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $00fe7cf7a0ed8e69$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $00fe7cf7a0ed8e69$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $00fe7cf7a0ed8e69$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $00fe7cf7a0ed8e69$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$00fe7cf7a0ed8e69$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($00fe7cf7a0ed8e69$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $00fe7cf7a0ed8e69$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $00fe7cf7a0ed8e69$var$getjQuery();
        const typeEvent = $00fe7cf7a0ed8e69$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $00fe7cf7a0ed8e69$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $00fe7cf7a0ed8e69$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $00fe7cf7a0ed8e69$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $00fe7cf7a0ed8e69$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $00fe7cf7a0ed8e69$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$00fe7cf7a0ed8e69$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$00fe7cf7a0ed8e69$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $00fe7cf7a0ed8e69$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $00fe7cf7a0ed8e69$var$normalizeData(element.getAttribute(`data-bs-${$00fe7cf7a0ed8e69$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $00fe7cf7a0ed8e69$var$isElement(element) ? $00fe7cf7a0ed8e69$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$00fe7cf7a0ed8e69$var$isElement(element) ? $00fe7cf7a0ed8e69$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $00fe7cf7a0ed8e69$var$isElement(value) ? 'element' : $00fe7cf7a0ed8e69$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$VERSION = '5.3.5';
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$BaseComponent extends $00fe7cf7a0ed8e69$var$Config {
    constructor(element, config){
        super();
        element = $00fe7cf7a0ed8e69$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $00fe7cf7a0ed8e69$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $00fe7cf7a0ed8e69$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $00fe7cf7a0ed8e69$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $00fe7cf7a0ed8e69$var$Data.get($00fe7cf7a0ed8e69$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $00fe7cf7a0ed8e69$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $00fe7cf7a0ed8e69$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$00fe7cf7a0ed8e69$var$parseSelector(sel)).join(',') : null;
};
const $00fe7cf7a0ed8e69$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$00fe7cf7a0ed8e69$var$isDisabled(el) && $00fe7cf7a0ed8e69$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $00fe7cf7a0ed8e69$var$getSelector(element);
        if (selector) return $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $00fe7cf7a0ed8e69$var$getSelector(element);
        return selector ? $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $00fe7cf7a0ed8e69$var$getSelector(element);
        return selector ? $00fe7cf7a0ed8e69$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $00fe7cf7a0ed8e69$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $00fe7cf7a0ed8e69$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($00fe7cf7a0ed8e69$var$isDisabled(this)) return;
        const target = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$f = 'alert';
const $00fe7cf7a0ed8e69$var$DATA_KEY$a = 'bs.alert';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$b = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$a}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLOSE = `close${$00fe7cf7a0ed8e69$var$EVENT_KEY$b}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLOSED = `closed${$00fe7cf7a0ed8e69$var$EVENT_KEY$b}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$5 = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$caec2af78bcc877f extends $00fe7cf7a0ed8e69$var$BaseComponent {
    // Getters
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$enableDismissTrigger($00fe7cf7a0ed8e69$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$e = 'button';
const $00fe7cf7a0ed8e69$var$DATA_KEY$9 = 'bs.button';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$a = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$9}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$6 = '.data-api';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$3 = 'active';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$6 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$a}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$353f5b6fc5456de1 extends $00fe7cf7a0ed8e69$var$BaseComponent {
    // Getters
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$6, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$5);
    const data = $00fe7cf7a0ed8e69$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$d = 'swipe';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$9 = '.bs.swipe';
const $00fe7cf7a0ed8e69$var$EVENT_TOUCHSTART = `touchstart${$00fe7cf7a0ed8e69$var$EVENT_KEY$9}`;
const $00fe7cf7a0ed8e69$var$EVENT_TOUCHMOVE = `touchmove${$00fe7cf7a0ed8e69$var$EVENT_KEY$9}`;
const $00fe7cf7a0ed8e69$var$EVENT_TOUCHEND = `touchend${$00fe7cf7a0ed8e69$var$EVENT_KEY$9}`;
const $00fe7cf7a0ed8e69$var$EVENT_POINTERDOWN = `pointerdown${$00fe7cf7a0ed8e69$var$EVENT_KEY$9}`;
const $00fe7cf7a0ed8e69$var$EVENT_POINTERUP = `pointerup${$00fe7cf7a0ed8e69$var$EVENT_KEY$9}`;
const $00fe7cf7a0ed8e69$var$POINTER_TYPE_TOUCH = 'touch';
const $00fe7cf7a0ed8e69$var$POINTER_TYPE_PEN = 'pen';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $00fe7cf7a0ed8e69$var$SWIPE_THRESHOLD = 40;
const $00fe7cf7a0ed8e69$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $00fe7cf7a0ed8e69$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$Swipe extends $00fe7cf7a0ed8e69$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$00fe7cf7a0ed8e69$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$c;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$c;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$d;
    }
    // Public
    dispose() {
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._element, $00fe7cf7a0ed8e69$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $00fe7cf7a0ed8e69$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $00fe7cf7a0ed8e69$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $00fe7cf7a0ed8e69$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $00fe7cf7a0ed8e69$var$POINTER_TYPE_PEN || event.pointerType === $00fe7cf7a0ed8e69$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$c = 'carousel';
const $00fe7cf7a0ed8e69$var$DATA_KEY$8 = 'bs.carousel';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$8 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$8}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$5 = '.data-api';
const $00fe7cf7a0ed8e69$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $00fe7cf7a0ed8e69$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $00fe7cf7a0ed8e69$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $00fe7cf7a0ed8e69$var$ORDER_NEXT = 'next';
const $00fe7cf7a0ed8e69$var$ORDER_PREV = 'prev';
const $00fe7cf7a0ed8e69$var$DIRECTION_LEFT = 'left';
const $00fe7cf7a0ed8e69$var$DIRECTION_RIGHT = 'right';
const $00fe7cf7a0ed8e69$var$EVENT_SLIDE = `slide${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_SLID = `slid${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN$1 = `keydown${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEENTER$1 = `mouseenter${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_MOUSELEAVE$1 = `mouseleave${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_DRAG_START = `dragstart${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}`;
const $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$3 = `load${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$5}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$5 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$8}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$5}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_CAROUSEL = 'carousel';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$2 = 'active';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SLIDE = 'slide';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_END = 'carousel-item-end';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_START = 'carousel-item-start';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $00fe7cf7a0ed8e69$var$SELECTOR_ACTIVE = '.active';
const $00fe7cf7a0ed8e69$var$SELECTOR_ITEM = '.carousel-item';
const $00fe7cf7a0ed8e69$var$SELECTOR_ACTIVE_ITEM = $00fe7cf7a0ed8e69$var$SELECTOR_ACTIVE + $00fe7cf7a0ed8e69$var$SELECTOR_ITEM;
const $00fe7cf7a0ed8e69$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $00fe7cf7a0ed8e69$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $00fe7cf7a0ed8e69$var$KEY_TO_DIRECTION = {
    [$00fe7cf7a0ed8e69$var$ARROW_LEFT_KEY$1]: $00fe7cf7a0ed8e69$var$DIRECTION_RIGHT,
    [$00fe7cf7a0ed8e69$var$ARROW_RIGHT_KEY$1]: $00fe7cf7a0ed8e69$var$DIRECTION_LEFT
};
const $00fe7cf7a0ed8e69$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $00fe7cf7a0ed8e69$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$144901db2ea8e967 extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $00fe7cf7a0ed8e69$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$b;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$b;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$c;
    }
    // Public
    next() {
        this._slide($00fe7cf7a0ed8e69$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $00fe7cf7a0ed8e69$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($00fe7cf7a0ed8e69$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $00fe7cf7a0ed8e69$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $00fe7cf7a0ed8e69$var$EventHandler.one(this._element, $00fe7cf7a0ed8e69$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $00fe7cf7a0ed8e69$var$EventHandler.one(this._element, $00fe7cf7a0ed8e69$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $00fe7cf7a0ed8e69$var$ORDER_NEXT : $00fe7cf7a0ed8e69$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $00fe7cf7a0ed8e69$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_ITEM_IMG, this._element))$00fe7cf7a0ed8e69$var$EventHandler.on(img, $00fe7cf7a0ed8e69$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $00fe7cf7a0ed8e69$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($00fe7cf7a0ed8e69$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($00fe7cf7a0ed8e69$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $00fe7cf7a0ed8e69$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $00fe7cf7a0ed8e69$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $00fe7cf7a0ed8e69$var$ORDER_NEXT;
        const nextElement = element || $00fe7cf7a0ed8e69$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($00fe7cf7a0ed8e69$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $00fe7cf7a0ed8e69$var$CLASS_NAME_START : $00fe7cf7a0ed8e69$var$CLASS_NAME_END;
        const orderClassName = isNext ? $00fe7cf7a0ed8e69$var$CLASS_NAME_NEXT : $00fe7cf7a0ed8e69$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $00fe7cf7a0ed8e69$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($00fe7cf7a0ed8e69$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($00fe7cf7a0ed8e69$var$isRTL()) return direction === $00fe7cf7a0ed8e69$var$DIRECTION_LEFT ? $00fe7cf7a0ed8e69$var$ORDER_PREV : $00fe7cf7a0ed8e69$var$ORDER_NEXT;
        return direction === $00fe7cf7a0ed8e69$var$DIRECTION_LEFT ? $00fe7cf7a0ed8e69$var$ORDER_NEXT : $00fe7cf7a0ed8e69$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($00fe7cf7a0ed8e69$var$isRTL()) return order === $00fe7cf7a0ed8e69$var$ORDER_PREV ? $00fe7cf7a0ed8e69$var$DIRECTION_LEFT : $00fe7cf7a0ed8e69$var$DIRECTION_RIGHT;
        return order === $00fe7cf7a0ed8e69$var$ORDER_PREV ? $00fe7cf7a0ed8e69$var$DIRECTION_RIGHT : $00fe7cf7a0ed8e69$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$5, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $00fe7cf7a0ed8e69$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($00fe7cf7a0ed8e69$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$00fe7cf7a0ed8e69$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$b = 'collapse';
const $00fe7cf7a0ed8e69$var$DATA_KEY$7 = 'bs.collapse';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$7 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$7}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$4 = '.data-api';
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$6 = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY$7}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$6 = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY$7}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$6 = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY$7}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$6 = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY$7}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$4 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$7}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$4}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$7 = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE = 'collapse';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE} .${$00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $00fe7cf7a0ed8e69$var$WIDTH = 'width';
const $00fe7cf7a0ed8e69$var$HEIGHT = 'height';
const $00fe7cf7a0ed8e69$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $00fe7cf7a0ed8e69$var$Default$a = {
    parent: null,
    toggle: true
};
const $00fe7cf7a0ed8e69$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$78768a9af065a7b extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $00fe7cf7a0ed8e69$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $00fe7cf7a0ed8e69$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$a;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$a;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($00fe7cf7a0ed8e69$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$00fe7cf7a0ed8e69$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $00fe7cf7a0ed8e69$var$reflow(this._element);
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSE);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $00fe7cf7a0ed8e69$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_HORIZONTAL) ? $00fe7cf7a0ed8e69$var$WIDTH : $00fe7cf7a0ed8e69$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $00fe7cf7a0ed8e69$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($00fe7cf7a0ed8e69$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$4, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $00fe7cf7a0ed8e69$var$SelectorEngine.getMultipleElementsFromSelector(this))$00fe7cf7a0ed8e69$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$a = 'dropdown';
const $00fe7cf7a0ed8e69$var$DATA_KEY$6 = 'bs.dropdown';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$6 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$6}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$3 = '.data-api';
const $00fe7cf7a0ed8e69$var$ESCAPE_KEY$2 = 'Escape';
const $00fe7cf7a0ed8e69$var$TAB_KEY$1 = 'Tab';
const $00fe7cf7a0ed8e69$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $00fe7cf7a0ed8e69$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$5 = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$5 = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$5 = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$5 = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$3 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DATA_API = `keydown${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYUP_DATA_API = `keyup${$00fe7cf7a0ed8e69$var$EVENT_KEY$6}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$3}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6 = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPUP = 'dropup';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPEND = 'dropend';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPSTART = 'dropstart';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3}.${$00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6}`;
const $00fe7cf7a0ed8e69$var$SELECTOR_MENU = '.dropdown-menu';
const $00fe7cf7a0ed8e69$var$SELECTOR_NAVBAR = '.navbar';
const $00fe7cf7a0ed8e69$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $00fe7cf7a0ed8e69$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $00fe7cf7a0ed8e69$var$PLACEMENT_TOP = $00fe7cf7a0ed8e69$var$isRTL() ? 'top-end' : 'top-start';
const $00fe7cf7a0ed8e69$var$PLACEMENT_TOPEND = $00fe7cf7a0ed8e69$var$isRTL() ? 'top-start' : 'top-end';
const $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOM = $00fe7cf7a0ed8e69$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOMEND = $00fe7cf7a0ed8e69$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $00fe7cf7a0ed8e69$var$PLACEMENT_RIGHT = $00fe7cf7a0ed8e69$var$isRTL() ? 'left-start' : 'right-start';
const $00fe7cf7a0ed8e69$var$PLACEMENT_LEFT = $00fe7cf7a0ed8e69$var$isRTL() ? 'right-start' : 'left-start';
const $00fe7cf7a0ed8e69$var$PLACEMENT_TOPCENTER = 'top';
const $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $00fe7cf7a0ed8e69$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $00fe7cf7a0ed8e69$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $00fe7cf7a0ed8e69$var$SelectorEngine.next(this._element, $00fe7cf7a0ed8e69$var$SELECTOR_MENU)[0] || $00fe7cf7a0ed8e69$var$SelectorEngine.prev(this._element, $00fe7cf7a0ed8e69$var$SELECTOR_MENU)[0] || $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$9;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$9;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($00fe7cf7a0ed8e69$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($00fe7cf7a0ed8e69$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$00fe7cf7a0ed8e69$var$EventHandler.on(element, 'mouseover', $00fe7cf7a0ed8e69$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6);
        $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($00fe7cf7a0ed8e69$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$00fe7cf7a0ed8e69$var$EventHandler.off(element, 'mouseover', $00fe7cf7a0ed8e69$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $00fe7cf7a0ed8e69$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$00fe7cf7a0ed8e69$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$00fe7cf7a0ed8e69$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $aae29f65524edcb9$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($00fe7cf7a0ed8e69$var$isElement(this._config.reference)) referenceElement = $00fe7cf7a0ed8e69$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $aae29f65524edcb9$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPEND)) return $00fe7cf7a0ed8e69$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPSTART)) return $00fe7cf7a0ed8e69$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPUP_CENTER)) return $00fe7cf7a0ed8e69$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPDOWN_CENTER)) return $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPUP)) return isEnd ? $00fe7cf7a0ed8e69$var$PLACEMENT_TOPEND : $00fe7cf7a0ed8e69$var$PLACEMENT_TOP;
        return isEnd ? $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOMEND : $00fe7cf7a0ed8e69$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($00fe7cf7a0ed8e69$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $00fe7cf7a0ed8e69$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$00fe7cf7a0ed8e69$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$00fe7cf7a0ed8e69$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $00fe7cf7a0ed8e69$var$getNextActiveElement(items, target, key === $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $00fe7cf7a0ed8e69$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $00fe7cf7a0ed8e69$var$TAB_KEY$1) return;
        const openToggles = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $00fe7cf7a0ed8e69$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $00fe7cf7a0ed8e69$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $00fe7cf7a0ed8e69$var$ARROW_UP_KEY$1,
            $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3) ? this : $00fe7cf7a0ed8e69$var$SelectorEngine.prev(this, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3)[0] || $00fe7cf7a0ed8e69$var$SelectorEngine.next(this, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3)[0] || $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DATA_API, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3, $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DATA_API, $00fe7cf7a0ed8e69$var$SELECTOR_MENU, $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$3, $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.clearMenus);
$00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_KEYUP_DATA_API, $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.clearMenus);
$00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$3, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $00fe7cf7a0ed8e69$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$9 = 'backdrop';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$4 = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$5 = 'show';
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEDOWN = `mousedown.bs.${$00fe7cf7a0ed8e69$var$NAME$9}`;
const $00fe7cf7a0ed8e69$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $00fe7cf7a0ed8e69$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$Backdrop extends $00fe7cf7a0ed8e69$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$8;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$8;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $00fe7cf7a0ed8e69$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $00fe7cf7a0ed8e69$var$reflow(element);
        element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $00fe7cf7a0ed8e69$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $00fe7cf7a0ed8e69$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $00fe7cf7a0ed8e69$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $00fe7cf7a0ed8e69$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $00fe7cf7a0ed8e69$var$EventHandler.on(element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEDOWN, ()=>{
            $00fe7cf7a0ed8e69$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $00fe7cf7a0ed8e69$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$8 = 'focustrap';
const $00fe7cf7a0ed8e69$var$DATA_KEY$5 = 'bs.focustrap';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$5 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$5}`;
const $00fe7cf7a0ed8e69$var$EVENT_FOCUSIN$2 = `focusin${$00fe7cf7a0ed8e69$var$EVENT_KEY$5}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_TAB = `keydown.tab${$00fe7cf7a0ed8e69$var$EVENT_KEY$5}`;
const $00fe7cf7a0ed8e69$var$TAB_KEY = 'Tab';
const $00fe7cf7a0ed8e69$var$TAB_NAV_FORWARD = 'forward';
const $00fe7cf7a0ed8e69$var$TAB_NAV_BACKWARD = 'backward';
const $00fe7cf7a0ed8e69$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $00fe7cf7a0ed8e69$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$FocusTrap extends $00fe7cf7a0ed8e69$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$7;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$7;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $00fe7cf7a0ed8e69$var$EventHandler.off(document, $00fe7cf7a0ed8e69$var$EVENT_KEY$5); // guard against infinite focus loop
        $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $00fe7cf7a0ed8e69$var$EventHandler.off(document, $00fe7cf7a0ed8e69$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $00fe7cf7a0ed8e69$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $00fe7cf7a0ed8e69$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $00fe7cf7a0ed8e69$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $00fe7cf7a0ed8e69$var$TAB_NAV_BACKWARD : $00fe7cf7a0ed8e69$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $00fe7cf7a0ed8e69$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $00fe7cf7a0ed8e69$var$PROPERTY_PADDING = 'padding-right';
const $00fe7cf7a0ed8e69$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $00fe7cf7a0ed8e69$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($00fe7cf7a0ed8e69$var$SELECTOR_FIXED_CONTENT, $00fe7cf7a0ed8e69$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($00fe7cf7a0ed8e69$var$SELECTOR_STICKY_CONTENT, $00fe7cf7a0ed8e69$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $00fe7cf7a0ed8e69$var$PROPERTY_PADDING);
        this._resetElementAttributes($00fe7cf7a0ed8e69$var$SELECTOR_FIXED_CONTENT, $00fe7cf7a0ed8e69$var$PROPERTY_PADDING);
        this._resetElementAttributes($00fe7cf7a0ed8e69$var$SELECTOR_STICKY_CONTENT, $00fe7cf7a0ed8e69$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $00fe7cf7a0ed8e69$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $00fe7cf7a0ed8e69$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $00fe7cf7a0ed8e69$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($00fe7cf7a0ed8e69$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $00fe7cf7a0ed8e69$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$7 = 'modal';
const $00fe7cf7a0ed8e69$var$DATA_KEY$4 = 'bs.modal';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$4 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$4}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$2 = '.data-api';
const $00fe7cf7a0ed8e69$var$ESCAPE_KEY$1 = 'Escape';
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$4 = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$4 = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$4 = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$4 = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_RESIZE$1 = `resize${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DISMISS = `click.dismiss${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$2 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$4}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$2}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_OPEN = 'modal-open';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$3 = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$4 = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_STATIC = 'modal-static';
const $00fe7cf7a0ed8e69$var$OPEN_SELECTOR$1 = '.modal.show';
const $00fe7cf7a0ed8e69$var$SELECTOR_DIALOG = '.modal-dialog';
const $00fe7cf7a0ed8e69$var$SELECTOR_MODAL_BODY = '.modal-body';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $00fe7cf7a0ed8e69$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $00fe7cf7a0ed8e69$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$2b77a92f1a5ad772 extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $00fe7cf7a0ed8e69$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$6;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$6;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $00fe7cf7a0ed8e69$var$EventHandler.off(window, $00fe7cf7a0ed8e69$var$EVENT_KEY$4);
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._dialog, $00fe7cf7a0ed8e69$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $00fe7cf7a0ed8e69$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $00fe7cf7a0ed8e69$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $00fe7cf7a0ed8e69$var$reflow(this._element);
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $00fe7cf7a0ed8e69$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $00fe7cf7a0ed8e69$var$EventHandler.one(this._element, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $00fe7cf7a0ed8e69$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $00fe7cf7a0ed8e69$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$2, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $00fe7cf7a0ed8e69$var$EventHandler.one(target, $00fe7cf7a0ed8e69$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $00fe7cf7a0ed8e69$var$EventHandler.one(target, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$4, ()=>{
            if ($00fe7cf7a0ed8e69$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $00fe7cf7a0ed8e69$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $00fe7cf7a0ed8e69$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$00fe7cf7a0ed8e69$var$enableDismissTrigger($00fe7cf7a0ed8e69$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$6 = 'offcanvas';
const $00fe7cf7a0ed8e69$var$DATA_KEY$3 = 'bs.offcanvas';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$3 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$3}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY$1 = '.data-api';
const $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$2 = `load${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$1}`;
const $00fe7cf7a0ed8e69$var$ESCAPE_KEY = 'Escape';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$3 = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING$1 = 'showing';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_HIDING = 'hiding';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $00fe7cf7a0ed8e69$var$OPEN_SELECTOR = '.offcanvas.show';
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$3 = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$3 = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$3 = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE_PREVENTED = `hidePrevented${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$3 = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_RESIZE = `resize${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$1 = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}${$00fe7cf7a0ed8e69$var$DATA_API_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$00fe7cf7a0ed8e69$var$EVENT_KEY$3}`;
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $00fe7cf7a0ed8e69$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $00fe7cf7a0ed8e69$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$591ca0244c9dfcd4 extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$5;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$5;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $00fe7cf7a0ed8e69$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING$1);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$3, $00fe7cf7a0ed8e69$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $00fe7cf7a0ed8e69$var$ScrollBarHelper().reset();
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $00fe7cf7a0ed8e69$var$Backdrop({
            className: $00fe7cf7a0ed8e69$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $00fe7cf7a0ed8e69$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $00fe7cf7a0ed8e69$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API$1, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($00fe7cf7a0ed8e69$var$isDisabled(this)) return;
    $00fe7cf7a0ed8e69$var$EventHandler.one(target, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($00fe7cf7a0ed8e69$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $00fe7cf7a0ed8e69$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $00fe7cf7a0ed8e69$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$OPEN_SELECTOR))$00fe7cf7a0ed8e69$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_RESIZE, ()=>{
    for (const element of $00fe7cf7a0ed8e69$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $00fe7cf7a0ed8e69$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$00fe7cf7a0ed8e69$var$enableDismissTrigger($00fe7cf7a0ed8e69$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $00fe7cf7a0ed8e69$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $00fe7cf7a0ed8e69$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $00fe7cf7a0ed8e69$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $00fe7cf7a0ed8e69$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $00fe7cf7a0ed8e69$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $00fe7cf7a0ed8e69$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($00fe7cf7a0ed8e69$var$uriAttributes.has(attributeName)) return Boolean($00fe7cf7a0ed8e69$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $00fe7cf7a0ed8e69$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$00fe7cf7a0ed8e69$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$5 = 'TemplateFactory';
const $00fe7cf7a0ed8e69$var$Default$4 = {
    allowList: $00fe7cf7a0ed8e69$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $00fe7cf7a0ed8e69$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $00fe7cf7a0ed8e69$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$var$TemplateFactory extends $00fe7cf7a0ed8e69$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$4;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$4;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $00fe7cf7a0ed8e69$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($00fe7cf7a0ed8e69$var$isElement(content)) {
            this._putElementInTemplate($00fe7cf7a0ed8e69$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $00fe7cf7a0ed8e69$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $00fe7cf7a0ed8e69$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$4 = 'tooltip';
const $00fe7cf7a0ed8e69$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$2 = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_MODAL = 'modal';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$2 = 'show';
const $00fe7cf7a0ed8e69$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $00fe7cf7a0ed8e69$var$SELECTOR_MODAL = `.${$00fe7cf7a0ed8e69$var$CLASS_NAME_MODAL}`;
const $00fe7cf7a0ed8e69$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $00fe7cf7a0ed8e69$var$TRIGGER_HOVER = 'hover';
const $00fe7cf7a0ed8e69$var$TRIGGER_FOCUS = 'focus';
const $00fe7cf7a0ed8e69$var$TRIGGER_CLICK = 'click';
const $00fe7cf7a0ed8e69$var$TRIGGER_MANUAL = 'manual';
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$2 = 'hide';
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$2 = 'hidden';
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$2 = 'show';
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$2 = 'shown';
const $00fe7cf7a0ed8e69$var$EVENT_INSERTED = 'inserted';
const $00fe7cf7a0ed8e69$var$EVENT_CLICK$1 = 'click';
const $00fe7cf7a0ed8e69$var$EVENT_FOCUSIN$1 = 'focusin';
const $00fe7cf7a0ed8e69$var$EVENT_FOCUSOUT$1 = 'focusout';
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEENTER = 'mouseenter';
const $00fe7cf7a0ed8e69$var$EVENT_MOUSELEAVE = 'mouseleave';
const $00fe7cf7a0ed8e69$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $00fe7cf7a0ed8e69$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $00fe7cf7a0ed8e69$var$isRTL() ? 'right' : 'left'
};
const $00fe7cf7a0ed8e69$var$Default$3 = {
    allowList: $00fe7cf7a0ed8e69$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $00fe7cf7a0ed8e69$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$28c660c63b792dea extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        if (typeof $aae29f65524edcb9$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$3;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$3;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._element.closest($00fe7cf7a0ed8e69$var$SELECTOR_MODAL), $00fe7cf7a0ed8e69$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_SHOW$2));
        const shadowRoot = $00fe7cf7a0ed8e69$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$00fe7cf7a0ed8e69$var$EventHandler.on(element, 'mouseover', $00fe7cf7a0ed8e69$var$noop);
        const complete = ()=>{
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$00fe7cf7a0ed8e69$var$EventHandler.off(element, 'mouseover', $00fe7cf7a0ed8e69$var$noop);
        this._activeTrigger[$00fe7cf7a0ed8e69$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$00fe7cf7a0ed8e69$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$00fe7cf7a0ed8e69$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$2, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $00fe7cf7a0ed8e69$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $00fe7cf7a0ed8e69$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$00fe7cf7a0ed8e69$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $00fe7cf7a0ed8e69$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $00fe7cf7a0ed8e69$var$AttachmentMap[placement.toUpperCase()];
        return $aae29f65524edcb9$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $00fe7cf7a0ed8e69$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$00fe7cf7a0ed8e69$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $00fe7cf7a0ed8e69$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $00fe7cf7a0ed8e69$var$TRIGGER_HOVER ? this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_MOUSEENTER) : this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $00fe7cf7a0ed8e69$var$TRIGGER_HOVER ? this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_MOUSELEAVE) : this.constructor.eventName($00fe7cf7a0ed8e69$var$EVENT_FOCUSOUT$1);
                $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $00fe7cf7a0ed8e69$var$TRIGGER_FOCUS : $00fe7cf7a0ed8e69$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $00fe7cf7a0ed8e69$var$TRIGGER_FOCUS : $00fe7cf7a0ed8e69$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element.closest($00fe7cf7a0ed8e69$var$SELECTOR_MODAL), $00fe7cf7a0ed8e69$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $00fe7cf7a0ed8e69$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($00fe7cf7a0ed8e69$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $00fe7cf7a0ed8e69$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$3 = 'popover';
const $00fe7cf7a0ed8e69$var$SELECTOR_TITLE = '.popover-header';
const $00fe7cf7a0ed8e69$var$SELECTOR_CONTENT = '.popover-body';
const $00fe7cf7a0ed8e69$var$Default$2 = {
    ...$00fe7cf7a0ed8e69$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $00fe7cf7a0ed8e69$var$DefaultType$2 = {
    ...$00fe7cf7a0ed8e69$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$5b6b19405a83ff9d extends $00fe7cf7a0ed8e69$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$2;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$2;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$00fe7cf7a0ed8e69$var$SELECTOR_TITLE]: this._getTitle(),
            [$00fe7cf7a0ed8e69$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$2 = 'scrollspy';
const $00fe7cf7a0ed8e69$var$DATA_KEY$2 = 'bs.scrollspy';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$2 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$2}`;
const $00fe7cf7a0ed8e69$var$DATA_API_KEY = '.data-api';
const $00fe7cf7a0ed8e69$var$EVENT_ACTIVATE = `activate${$00fe7cf7a0ed8e69$var$EVENT_KEY$2}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$2}`;
const $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$1 = `load${$00fe7cf7a0ed8e69$var$EVENT_KEY$2}${$00fe7cf7a0ed8e69$var$DATA_API_KEY}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1 = 'active';
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $00fe7cf7a0ed8e69$var$SELECTOR_TARGET_LINKS = '[href]';
const $00fe7cf7a0ed8e69$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $00fe7cf7a0ed8e69$var$SELECTOR_NAV_LINKS = '.nav-link';
const $00fe7cf7a0ed8e69$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $00fe7cf7a0ed8e69$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $00fe7cf7a0ed8e69$var$SELECTOR_LINK_ITEMS = `${$00fe7cf7a0ed8e69$var$SELECTOR_NAV_LINKS}, ${$00fe7cf7a0ed8e69$var$SELECTOR_NAV_ITEMS} > ${$00fe7cf7a0ed8e69$var$SELECTOR_NAV_LINKS}, ${$00fe7cf7a0ed8e69$var$SELECTOR_LIST_ITEMS}`;
const $00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN = '.dropdown';
const $00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $00fe7cf7a0ed8e69$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $00fe7cf7a0ed8e69$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$a6472a5298a374be extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default$1;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType$1;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $00fe7cf7a0ed8e69$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $00fe7cf7a0ed8e69$var$EventHandler.off(this._config.target, $00fe7cf7a0ed8e69$var$EVENT_CLICK);
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._config.target, $00fe7cf7a0ed8e69$var$EVENT_CLICK, $00fe7cf7a0ed8e69$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $00fe7cf7a0ed8e69$var$isDisabled(anchor)) continue;
            const observableSection = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($00fe7cf7a0ed8e69$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN)).classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $00fe7cf7a0ed8e69$var$SelectorEngine.parents(target, $00fe7cf7a0ed8e69$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $00fe7cf7a0ed8e69$var$SelectorEngine.prev(listGroup, $00fe7cf7a0ed8e69$var$SELECTOR_LINK_ITEMS))item.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $00fe7cf7a0ed8e69$var$SelectorEngine.find(`${$00fe7cf7a0ed8e69$var$SELECTOR_TARGET_LINKS}.${$00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_DATA_SPY))$00fe7cf7a0ed8e69$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME$1 = 'tab';
const $00fe7cf7a0ed8e69$var$DATA_KEY$1 = 'bs.tab';
const $00fe7cf7a0ed8e69$var$EVENT_KEY$1 = `.${$00fe7cf7a0ed8e69$var$DATA_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE$1 = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$1 = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOW$1 = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN$1 = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API = `click${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN = `keydown${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API = `load${$00fe7cf7a0ed8e69$var$EVENT_KEY$1}`;
const $00fe7cf7a0ed8e69$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $00fe7cf7a0ed8e69$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $00fe7cf7a0ed8e69$var$ARROW_UP_KEY = 'ArrowUp';
const $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY = 'ArrowDown';
const $00fe7cf7a0ed8e69$var$HOME_KEY = 'Home';
const $00fe7cf7a0ed8e69$var$END_KEY = 'End';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE = 'active';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$1 = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$1 = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_DROPDOWN = 'dropdown';
const $00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $00fe7cf7a0ed8e69$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $00fe7cf7a0ed8e69$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $00fe7cf7a0ed8e69$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $00fe7cf7a0ed8e69$var$SELECTOR_INNER = `.nav-link${$00fe7cf7a0ed8e69$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$00fe7cf7a0ed8e69$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$00fe7cf7a0ed8e69$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $00fe7cf7a0ed8e69$var$SELECTOR_INNER_ELEM = `${$00fe7cf7a0ed8e69$var$SELECTOR_INNER}, ${$00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE}`;
const $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$3e41faf802a29e71 extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($00fe7cf7a0ed8e69$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $00fe7cf7a0ed8e69$var$EventHandler.trigger(active, $00fe7cf7a0ed8e69$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(innerElem, $00fe7cf7a0ed8e69$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE);
        this._activate($00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $00fe7cf7a0ed8e69$var$ARROW_LEFT_KEY,
            $00fe7cf7a0ed8e69$var$ARROW_RIGHT_KEY,
            $00fe7cf7a0ed8e69$var$ARROW_UP_KEY,
            $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY,
            $00fe7cf7a0ed8e69$var$HOME_KEY,
            $00fe7cf7a0ed8e69$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$00fe7cf7a0ed8e69$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $00fe7cf7a0ed8e69$var$HOME_KEY,
            $00fe7cf7a0ed8e69$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $00fe7cf7a0ed8e69$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $00fe7cf7a0ed8e69$var$ARROW_RIGHT_KEY,
                $00fe7cf7a0ed8e69$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $00fe7cf7a0ed8e69$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $00fe7cf7a0ed8e69$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $00fe7cf7a0ed8e69$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($00fe7cf7a0ed8e69$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $00fe7cf7a0ed8e69$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_TOGGLE, $00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE);
        toggle($00fe7cf7a0ed8e69$var$SELECTOR_DROPDOWN_MENU, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($00fe7cf7a0ed8e69$var$SELECTOR_INNER_ELEM) ? elem : $00fe7cf7a0ed8e69$var$SelectorEngine.findOne($00fe7cf7a0ed8e69$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($00fe7cf7a0ed8e69$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(document, $00fe7cf7a0ed8e69$var$EVENT_CLICK_DATA_API, $00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($00fe7cf7a0ed8e69$var$isDisabled(this)) return;
    $00fe7cf7a0ed8e69$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $00fe7cf7a0ed8e69$var$EventHandler.on(window, $00fe7cf7a0ed8e69$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $00fe7cf7a0ed8e69$var$SelectorEngine.find($00fe7cf7a0ed8e69$var$SELECTOR_DATA_TOGGLE_ACTIVE))$00fe7cf7a0ed8e69$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $00fe7cf7a0ed8e69$var$NAME = 'toast';
const $00fe7cf7a0ed8e69$var$DATA_KEY = 'bs.toast';
const $00fe7cf7a0ed8e69$var$EVENT_KEY = `.${$00fe7cf7a0ed8e69$var$DATA_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEOVER = `mouseover${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_MOUSEOUT = `mouseout${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_FOCUSIN = `focusin${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_FOCUSOUT = `focusout${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDE = `hide${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_HIDDEN = `hidden${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOW = `show${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$EVENT_SHOWN = `shown${$00fe7cf7a0ed8e69$var$EVENT_KEY}`;
const $00fe7cf7a0ed8e69$var$CLASS_NAME_FADE = 'fade';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW = 'show';
const $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING = 'showing';
const $00fe7cf7a0ed8e69$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $00fe7cf7a0ed8e69$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $00fe7cf7a0ed8e69$export$8d8dc7d5f743331b extends $00fe7cf7a0ed8e69$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $00fe7cf7a0ed8e69$var$Default;
    }
    static get DefaultType() {
        return $00fe7cf7a0ed8e69$var$DefaultType;
    }
    static get NAME() {
        return $00fe7cf7a0ed8e69$var$NAME;
    }
    // Public
    show() {
        const showEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_HIDE); // @deprecated
        $00fe7cf7a0ed8e69$var$reflow(this._element);
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING, $00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW);
            $00fe7cf7a0ed8e69$var$EventHandler.trigger(this._element, $00fe7cf7a0ed8e69$var$EVENT_HIDDEN);
        };
        this._element.classList.add($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($00fe7cf7a0ed8e69$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $00fe7cf7a0ed8e69$var$EventHandler.on(this._element, $00fe7cf7a0ed8e69$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $00fe7cf7a0ed8e69$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $00fe7cf7a0ed8e69$var$enableDismissTrigger($00fe7cf7a0ed8e69$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $00fe7cf7a0ed8e69$var$defineJQueryPlugin($00fe7cf7a0ed8e69$export$8d8dc7d5f743331b);


// ==================== APP Initialization ====================
(async ()=>{
    const instance = (0, $b3398955cbe6b94e$export$2e2bcd8739ae039)({
        urlBase: 'https://matomo.identifiers.org/',
        siteId: 1,
        disabled: false,
        // optional, false by default. Makes all tracking calls no-ops if set to true.
        heartBeat: {
            // optional, enabled by default
            active: true,
            // optional, default value: true
            seconds: 30 // optional, default value: `15
        },
        linkTracking: true,
        // optional, default value: true
        configurations: {
            // optional, default value: {}
            // any valid matomo configuration, all below are optional
            disableCookies: true,
            setSecureCookie: location.protocol.includes('https'),
            // Only available in https
            setRequestMethod: 'GET'
        }
    });
    // Get locations.
    (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $8720e80f7302d904$export$579aa4ccb2704142)());
    // Get institutions.
    (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $c3dc2e9b5981d644$export$53bd7c9cf2087a2d)());
    // Get Schema.org Metadata depending on current path and append it to the document's head.
    const prefix = window.location.pathname.split('/').pop();
    if (window.location.pathname.includes('registry') && prefix !== "registry" && prefix !== "") await (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $8a5c3ddb423770e6$export$358ac8bb95c77f0c)(prefix));
    else await (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $8a5c3ddb423770e6$export$78572dfc0a558ba6)());
    (0, $fd5d9941f8cbe9ee$export$eea578708101341f)((0, $764c5d8c73d64a30$export$2e2bcd8739ae039).getState().schemaOrgMetadata);
    // Init auth.
    (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).getState().config.enableAuthFeatures && await (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $0b883306a510c740$export$c03d5f201539f0d9)());
    // Auth token periodic renewal.
    if ((0, $764c5d8c73d64a30$export$2e2bcd8739ae039).getState().auth.authenticated) {
        const keycloak = (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).getState().auth.keycloak;
        const tokenDuration = (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ))).unix(keycloak.tokenParsed.exp) - (0, (/*@__PURE__*/$parcel$interopDefault($atqVQ))).unix(keycloak.tokenParsed.iat);
        console.debug(`Auth -> Setting auth token renewal interval to ${(tokenDuration - tokenDuration * .1) / 1000} seconds.`);
        (0, $764c5d8c73d64a30$export$2e2bcd8739ae039).dispatch((0, $0b883306a510c740$export$95c42985d2be0368)((0, $df5c80b7c7e65b14$export$9eb5d800a6b02c7), tokenDuration - tokenDuration * .1));
    }
    // Render app.
    const container = document.getElementById("app");
    const root = (0, $2NwrC.createRoot)(container);
    root.render(/*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $91c02eb1486780d6$export$2e2bcd8739ae039), {
        store: (0, $764c5d8c73d64a30$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $3e6ee78456431aee$export$2e2bcd8739ae039), {
            value: instance,
            children: /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsxs)((0, $dBNnn.StrictMode), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $8e95fc83e6ec5c3c$exports.jsx)((0, $5527d0df700f1d87$export$2e2bcd8739ae039), {}),
                    " "
                ]
            })
        })
    }));
})();


//# sourceMappingURL=site.d6f61d58.js.map
